var av = Object.defineProperty;
var ov = (e, t, n) => t in e ? av(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var kn = (e, t, n) => ov(e, typeof t != "symbol" ? t + "" : t, n);
import { ref as m, computed as k, onMounted as dt, onBeforeUnmount as it, getCurrentInstance as sv, inject as Ws, defineComponent as qe, openBlock as c, createElementBlock as d, normalizeStyle as Ct, normalizeClass as we, Fragment as ae, createTextVNode as Je, toDisplayString as f, createCommentVNode as g, renderList as Te, createVNode as Ge, createElementVNode as o, createBlock as et, unref as s, Teleport as ja, Transition as Rn, withCtx as st, withModifiers as Re, withKeys as Ut, nextTick as gt, watch as He, shallowRef as wn, renderSlot as _n, withDirectives as Ve, vModelText as rt, vModelCheckbox as An, vModelSelect as on, createStaticVNode as Hu, provide as Fu, resolveDynamicComponent as rv, mergeProps as iv, getCurrentScope as lv, onScopeDispose as cv, customRef as uv, watchEffect as dv, createSlots as fv } from "vue";
function Mc(e) {
  return !!e && e.enabled && e.state === "ok";
}
const Nu = ["en", "tr"], Ec = "en";
function cn(e) {
  return e && Nu.includes(e) ? e : pv();
}
function pv() {
  try {
    const e = typeof navigator > "u" ? void 0 : navigator;
    if (!e) return Ec;
    const t = e.languages && e.languages.length ? e.languages : [e.language];
    for (const n of t) {
      if (!n) continue;
      const r = String(n).toLowerCase().split("-")[0];
      if (Nu.includes(r)) return r;
    }
  } catch {
  }
  return Ec;
}
function Ku(e) {
  const t = e.apiBase != null ? e.apiBase.replace(/\/+$/, "") : null;
  function n(a, u) {
    return a || (t === null ? null : `${t}${u}`);
  }
  const r = e.endpoint ?? (t !== null ? `${t}/api/files/manager` : null);
  if (!r)
    throw new Error(
      "[@brftech/filex-core] config requires either `apiBase` or `endpoint`"
    );
  return {
    manager: r,
    // Staged (chunked + resumable) uploads — what useUploadChunked speaks on
    // every driver. The {id} routes are derived from this one.
    uploadBegin: n(e.uploadBegin, "/api/files/upload/begin"),
    uploadInit: n(e.uploadInit, "/api/files/upload/init"),
    uploadFinalize: n(e.uploadFinalize, "/api/files/upload/finalize"),
    uploadAbort: n(e.uploadAbort, "/api/files/upload/abort"),
    shareCreate: n(e.shareCreate, "/api/files/share"),
    shareList: n(e.shareList, "/api/files/share"),
    shareDelete: n(e.shareDelete, "/api/files/share/{uuid}"),
    limits: n(e.limits, "/api/files/limits"),
    capabilities: n(e.capabilities, "/api/files/capabilities"),
    archiveList: n(e.archiveList, "/api/files/archive/list"),
    archiveExtract: n(e.archiveExtract, "/api/files/archive/extract"),
    archiveAdd: n(e.archiveAdd, "/api/files/archive/add"),
    copy: n(e.copy, "/api/files/copy"),
    moveAsync: n(e.moveAsync, "/api/files/move"),
    deleteAsync: n(e.deleteAsync, "/api/files/delete"),
    opsList: n(e.opsList, "/api/files/ops"),
    opsShow: n(e.opsShow, "/api/files/ops/{id}"),
    onlyOfficeConfig: n(e.onlyOfficeConfig, "/api/files/onlyoffice/config"),
    saveText: n(e.saveText, "/api/files/save-text"),
    restore: n(e.restore, "/api/files/restore"),
    // filex trash: list soft-deleted nodes + restore one by node id.
    trashList: n(e.trashList, "/api/files/manager/trash"),
    trashRestore: n(e.trashRestore, "/api/files/manager/restore"),
    /* wiring:e2 — escrow proof-of-possession, then the owner is told. */
    e2eEscrowChallenge: n(e.e2eEscrowChallenge, "/api/files/e2e/escrow/challenge"),
    e2eEscrowUsed: n(e.e2eEscrowUsed, "/api/files/e2e/escrow/used")
  };
}
async function vv(e) {
  if (typeof e == "function") {
    const t = e();
    return t instanceof Promise ? await t : t;
  }
  return e;
}
function hv(e) {
  return e ? "kind" in e ? e : e.type === "bearer" ? { kind: "bearer", token: e.token } : e.type === "csrf" ? { kind: "csrf", csrf: e.csrf } : { kind: "none" } : { kind: "none" };
}
function Ya(e) {
  const t = Ku(e), n = hv(e.auth);
  let r = null;
  async function a(V = {}) {
    const R = { Accept: "application/json", ...V };
    if (n.kind === "bearer") {
      const X = await vv(n.token);
      X && (R.Authorization = `Bearer ${X}`, r = X);
    } else if (n.kind === "csrf")
      R["X-CSRF-TOKEN"] = n.csrf, R["X-Requested-With"] = "XMLHttpRequest";
    else if (n.kind === "basic") {
      const X = btoa(`${n.user}:${n.pass}`);
      R.Authorization = `Basic ${X}`;
    }
    return R;
  }
  function u(V = {}) {
    const R = { Accept: "application/json", ...V };
    if (n.kind === "bearer") {
      const X = typeof n.token == "string" ? n.token : r;
      X && (R.Authorization = `Bearer ${X}`);
    } else if (n.kind === "csrf")
      R["X-CSRF-TOKEN"] = n.csrf, R["X-Requested-With"] = "XMLHttpRequest";
    else if (n.kind === "basic") {
      const X = btoa(`${n.user}:${n.pass}`);
      R.Authorization = `Basic ${X}`;
    }
    return R;
  }
  function v() {
    return n.kind === "csrf" ? "include" : "same-origin";
  }
  function p(V) {
    const R = cn(e.locale) !== "en", ye = {
      400: ["Geçersiz istek", "Bad request"],
      401: ["Oturum gerekli, tekrar giriş yapın", "Sign-in required"],
      403: ["Bu işlem için yetkiniz yok", "You are not allowed to do this"],
      404: ["Bulunamadı", "Not found"],
      409: ["Zaten var / çakışma", "Already exists / conflict"],
      413: ["Dosya çok büyük", "File too large"],
      415: ["Bu dosya türü desteklenmiyor", "Unsupported file type"],
      422: ["Geçersiz veri", "Invalid data"],
      429: ["Çok fazla istek, biraz bekleyin", "Too many requests"],
      500: ["Sunucu hatası", "Server error"],
      501: ["Bu işlem desteklenmiyor", "Not supported"],
      503: ["Servis şu an kullanılamıyor", "Service unavailable"]
    }[V];
    return ye ? R ? ye[0] : ye[1] : R ? `Hata (${V})` : `Error (${V})`;
  }
  async function h(V, R = {}) {
    const X = {
      ...await a(),
      ...R.headers ?? {}
    }, ye = await fetch(V, {
      ...R,
      headers: X,
      credentials: v()
    });
    if (!ye.ok) {
      const Qe = await ye.text().catch(() => ""), at = new Error(p(ye.status));
      throw at.status = ye.status, at.detail = Qe.slice(0, 300), at;
    }
    if (ye.status === 204 || ye.status === 205) return;
    const je = await ye.text();
    if (je)
      return JSON.parse(je);
  }
  function b(V = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/permissions") + V;
  }
  async function y(V) {
    return h(b() + "?path=" + encodeURIComponent(V));
  }
  async function A(V) {
    return h(b("/resolve") + "?email=" + encodeURIComponent(V));
  }
  async function D(V) {
    return h(b("/users") + "?q=" + encodeURIComponent(V));
  }
  async function C(V) {
    return h(b(), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(V) });
  }
  async function B(V, R) {
    return h(b("/" + V), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: R }) });
  }
  async function I(V) {
    return h(b("/" + V), { method: "DELETE" });
  }
  async function U(V) {
    return h(b("/invite"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(V) });
  }
  async function x(V) {
    return h(b("/share-mail"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(V) });
  }
  function E(V) {
    const R = new URLSearchParams();
    for (const [X, ye] of Object.entries(V))
      ye != null && R.set(X, String(ye));
    return R.toString();
  }
  function $(V, R = {}) {
    const X = t.manager.includes("?") ? "&" : "?";
    return `${t.manager}${X}${E({ q: V, action: V, ...R })}`;
  }
  async function M(V) {
    return h($("index", { path: V }));
  }
  async function z(V, R) {
    return h($("search", { path: V, filter: R }));
  }
  async function T(V, R = {}) {
    const X = t.manager.replace(/\/manager(\?.*)?$/, "/search"), ye = X.includes("?") ? "&" : "?", je = `${X}${ye}${E({ q: V, limit: R.limit, scope: R.scope })}`, Qe = await h(je);
    return Array.isArray(Qe == null ? void 0 : Qe.results) ? Qe.results : [];
  }
  async function Y() {
    const V = t.manager.replace(/\/manager(\?.*)?$/, "/quota/me");
    try {
      const R = await h(V);
      return R && typeof R.used_bytes == "number" ? R : null;
    } catch {
      return null;
    }
  }
  async function O(V) {
    return h($("subfolders", { path: V }));
  }
  async function J(V, R) {
    return h($("newfolder"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: V, name: R })
    });
  }
  async function G(V, R, X) {
    return h($("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: V, name: R, type: X })
    });
  }
  async function N(V, R, X) {
    return h($("rename"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: V, item: R, name: X })
    });
  }
  async function P(V, R, X) {
    return h($("move"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: V, item: X, items: R.map((ye) => ({ path: ye })) })
    });
  }
  async function le(V, R) {
    return h($("delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: V, items: R.map((X) => ({ path: X })) })
    });
  }
  async function ve(V, R) {
    if (!t.copy) throw new Error("copy endpoint not configured");
    return h(t.copy, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: V, target: R })
    });
  }
  async function he(V, R, X) {
    if (!t.moveAsync) throw new Error("moveAsync endpoint not configured");
    return h(t.moveAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: V, target: R, sourceDir: X })
    });
  }
  async function oe(V, R) {
    if (!t.deleteAsync) throw new Error("deleteAsync endpoint not configured");
    return h(t.deleteAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: V, sourceDir: R })
    });
  }
  async function ue(V) {
    if (!t.restore) throw new Error("restore endpoint not configured");
    return h(t.restore, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: V })
    });
  }
  async function Q(V) {
    if (!t.trashList) throw new Error("trashList endpoint not configured");
    const R = t.trashList, X = R.includes("?") ? "&" : "?", ye = V ? `${R}${X}storage=${encodeURIComponent(V)}` : R;
    return h(ye);
  }
  async function pe(V) {
    const R = t.trashRestore;
    if (!R) throw new Error("trashRestore endpoint not configured");
    let X = 0;
    const ye = [];
    for (const je of V)
      try {
        await h(R, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ node_id: je })
        }), X++;
      } catch (Qe) {
        const at = Qe;
        if (at.status === 409)
          try {
            const Ye = JSON.parse(at.detail ?? "");
            Ye.code === "EXISTS" && ye.push(Ye.name || String(je));
          } catch {
          }
      }
    return { restored: X, taken: ye };
  }
  async function re(V, R, X) {
    const ye = new FormData();
    ye.append("path", V);
    for (const Qe of R)
      ye.append("file[]", Qe, Qe.name);
    const je = await a();
    return new Promise((Qe, at) => {
      const Ye = new XMLHttpRequest();
      Ye.open("POST", $("upload"));
      for (const [lt, fe] of Object.entries(je))
        lt !== "Content-Type" && Ye.setRequestHeader(lt, fe);
      Ye.withCredentials = v() === "include", Ye.upload.onprogress = (lt) => {
        X && lt.lengthComputable && X(Math.round(lt.loaded / lt.total * 100));
      }, Ye.onload = () => {
        if (Ye.status >= 200 && Ye.status < 300)
          try {
            Qe(JSON.parse(Ye.responseText));
          } catch (lt) {
            at(lt);
          }
        else
          at(new Error(`${Ye.status} ${Ye.statusText}: ${Ye.responseText.slice(0, 200)}`));
      }, Ye.onerror = () => at(new Error("Network error")), Ye.send(ye);
    });
  }
  function S(V) {
    return $("download", { path: V });
  }
  function w(V) {
    return $("preview", { path: V });
  }
  async function j(V, R = {}) {
    const X = await a(), ye = await fetch(w(V), {
      headers: X,
      credentials: v(),
      // ⚠ The preview endpoint answers `Cache-Control: private, max-age=60`,
      // which is right for the thing it was built for — a viewer re-opening
      // an image — and wrong for anything the client treats as CONTROL data.
      // `.filex-e2e.json` is control data: after the client rewrites it
      // (recovery upgrade, escrow slot, escrow refusal) the next read inside
      // that minute came back PRE-write, so the folder looked un-upgraded
      // and the question filex had just been answered was asked again.
      // Measured 2026-09-05 in a real browser: decline the escrow offer,
      // reopen the folder, and the offer was back.
      cache: R.fresh ? "no-store" : "default"
    });
    if (!ye.ok) {
      const Ye = await ye.text().catch(() => "");
      throw new Error(
        `${ye.status} ${ye.statusText}${Ye ? " — " + Ye.slice(0, 200) : ""}`
      );
    }
    const je = await ye.blob(), Qe = je.type || ye.headers.get("content-type") || "";
    return { url: URL.createObjectURL(je), blob: je, mime: Qe };
  }
  async function K(V) {
    const R = await a(), X = await fetch(w(V), {
      headers: R,
      credentials: v()
    });
    if (!X.ok) {
      const ye = await X.text().catch(() => "");
      throw new Error(
        `${X.status} ${X.statusText}${ye ? " — " + ye.slice(0, 200) : ""}`
      );
    }
    return X.arrayBuffer();
  }
  async function Z() {
    return t.limits ? h(t.limits) : { max_upload_mb: 1024 };
  }
  async function W() {
    return t.capabilities ? h(t.capabilities) : {
      ffmpeg: !1,
      ghostscript: !1,
      libreoffice: !1,
      max_chunk_mb: 5,
      upload_limit_mb: 1024,
      onlyoffice_url: e.onlyOfficeBase ?? null,
      drawio_url: e.drawioBase ?? null,
      convert_url: e.convertBase ?? null
    };
  }
  async function $e(V) {
    if (!t.e2eEscrowChallenge) throw new Error("e2e escrow endpoint not configured");
    return h(t.e2eEscrowChallenge, {
      method: "POST",
      body: JSON.stringify({ path: V })
    });
  }
  async function Se(V) {
    if (!t.e2eEscrowUsed) throw new Error("e2e escrow endpoint not configured");
    return h(t.e2eEscrowUsed, {
      method: "POST",
      body: JSON.stringify(V)
    });
  }
  async function ze(V) {
    if (!t.shareCreate) throw new Error("shareCreate endpoint not configured");
    return h(t.shareCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(V)
    });
  }
  async function Ne(V) {
    if (!t.shareList) return { shares: [] };
    const R = t.shareList.includes("?") ? "&" : "?";
    return h(`${t.shareList}${R}path=${encodeURIComponent(V)}`);
  }
  async function be(V) {
    if (!t.shareDelete) throw new Error("shareDelete endpoint not configured");
    const R = t.shareDelete.replace("{uuid}", encodeURIComponent(V));
    return h(R, { method: "DELETE" });
  }
  async function De(V) {
    if (!t.archiveList) throw new Error("archiveList endpoint not configured");
    return {
      entries: (await h(
        t.archiveList,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ path: V })
        }
      )).entries.map((X) => ({
        name: X.name,
        size: X.size,
        isDir: X.is_dir,
        lastModified: X.mtime
      }))
    };
  }
  async function ie(V, R) {
    if (!t.archiveExtract) throw new Error("archiveExtract endpoint not configured");
    return h(t.archiveExtract, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: V, members: R })
    });
  }
  async function ce(V, R) {
    if (!t.archiveAdd) throw new Error("archiveAdd endpoint not configured");
    return h(t.archiveAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: V, files: R })
    });
  }
  function L(V = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/versions") + V;
  }
  async function se(V) {
    const R = await h(
      L() + "?node_id=" + encodeURIComponent(String(V))
    );
    return Array.isArray(R == null ? void 0 : R.versions) ? R.versions : [];
  }
  async function Ce(V, R, X = !0) {
    await h(L("/restore"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        node_id: V,
        version_id: R,
        snapshot_current: X
      })
    });
  }
  async function We(V) {
    await h(L("/snapshot"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: V })
    });
  }
  function Ie(V = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/comments") + V;
  }
  async function Ze(V) {
    const R = await h(
      Ie() + "?node_id=" + encodeURIComponent(String(V))
    );
    return Array.isArray(R == null ? void 0 : R.comments) ? R.comments : [];
  }
  async function vt(V, R) {
    return (await h(Ie(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: V, body: R })
    })).comment;
  }
  async function Xe(V) {
    await h(Ie("/" + encodeURIComponent(String(V))), {
      method: "DELETE"
    });
  }
  async function Ae() {
    const V = t.manager.replace(/\/manager(\?.*)?$/, "/ws-ticket");
    try {
      return await h(V, { method: "POST" });
    } catch {
      return null;
    }
  }
  return {
    // Realtime
    wsTicket: Ae,
    // Manager
    index: M,
    search: z,
    globalSearch: T,
    quotaMe: Y,
    subfolders: O,
    newFolder: J,
    newFile: G,
    rename: N,
    move: P,
    copy: ve,
    moveAsync: he,
    deleteAsync: oe,
    deleteItems: le,
    restore: ue,
    listTrash: Q,
    restoreIds: pe,
    uploadMultipart: re,
    downloadUrl: S,
    previewUrl: w,
    fetchBlob: j,
    fetchArrayBuffer: K,
    // Peripheral
    limits: Z,
    capabilities: W,
    /* wiring:e2 */
    e2eEscrowChallenge: $e,
    e2eEscrowUsed: Se,
    createShare: ze,
    listShares: Ne,
    revokeShare: be,
    archiveList: De,
    archiveExtract: ie,
    archiveAdd: ce,
    // Version history (koru:k1 inspector)
    listVersions: se,
    restoreVersion: Ce,
    snapshotVersion: We,
    // Node comments (calisma:d3 inspector)
    listComments: Ze,
    addComment: vt,
    deleteComment: Xe,
    // Permissions (RBAC panel)
    listPermissions: y,
    resolveEmail: A,
    searchUsers: D,
    addPermission: C,
    updatePermission: B,
    deletePermission: I,
    invitePermission: U,
    shareMail: x,
    // Internals (exposed for useUploadChunked + PreviewModal)
    endpoints: t,
    authHeaders: a,
    authHeadersSync: u,
    credentialsMode: v,
    jsonFetch: h
  };
}
const wi = "filex:uploads:v1", mv = 24 * 60 * 60 * 1e3;
function jr(e, t) {
  return [e, t.name, t.size, t.lastModified ?? 0].join("\0");
}
function yv() {
  try {
    return typeof localStorage > "u" ? null : (localStorage.getItem(wi), localStorage);
  } catch {
    return null;
  }
}
function $i(e) {
  if (!e) return {};
  try {
    const t = e.getItem(wi);
    if (!t) return {};
    const n = JSON.parse(t);
    return n && typeof n == "object" ? n : {};
  } catch {
    return {};
  }
}
function xi(e, t) {
  if (e)
    try {
      e.setItem(wi, JSON.stringify(t));
    } catch {
    }
}
function Ru(e, t = Date.now()) {
  const n = $i(e);
  let r = !1;
  for (const [a, u] of Object.entries(n))
    (!(u != null && u.uploadId) || t - (u.updatedAt ?? 0) > mv) && (delete n[a], r = !0);
  return r && xi(e, n), n;
}
function zc(e, t, n = Date.now()) {
  return Ru(e, n)[t] ?? null;
}
function Ac(e, t, n, r = Date.now()) {
  const a = $i(e);
  a[t] = { ...n, updatedAt: r }, xi(e, a);
}
function yo(e, t) {
  const n = $i(e);
  t in n && (delete n[t], xi(e, n));
}
function bv(e, t = Date.now()) {
  return Object.values(Ru(e, t)).sort((n, r) => r.updatedAt - n.updatedAt);
}
function gv(e) {
  return !e || e === "staging";
}
function Pc(e) {
  return e.stagedUnsupported = !0, e;
}
function kv(e) {
  return !!(e != null && e.stagedUnsupported);
}
function _v(e, t, n = yv()) {
  const r = e.chunkSize ?? 8388608;
  function a() {
    const C = t.endpoints.uploadBegin;
    return C ? C.replace(/\/begin$/, "") : t.endpoints.manager.replace(/\/manager(\?.*)?$/, "/upload");
  }
  function u() {
    return !!a();
  }
  function v() {
    return r;
  }
  function p(C) {
    return u() && C.size > v();
  }
  function h(C, B) {
    return zc(n, jr(C, B));
  }
  function b() {
    return bv(n);
  }
  async function y(C) {
    yo(n, jr(C.path, { name: C.name, size: C.size, lastModified: C.lastModified }));
    try {
      await t.jsonFetch(`${a()}/${encodeURIComponent(C.uploadId)}`, { method: "DELETE" });
    } catch {
    }
  }
  async function A(C) {
    return t.jsonFetch(`${a()}/${encodeURIComponent(C)}`);
  }
  async function D(C) {
    var T, Y;
    const B = jr(C.path, C.file), I = {
      id: crypto.randomUUID(),
      file: C.file,
      path: C.path,
      totalBytes: C.file.size,
      uploadedBytes: 0,
      percent: 0,
      status: "initializing",
      cancel: () => {
      }
    };
    let U = !1, x = null;
    I.cancel = () => {
      U = !0, x == null || x.abort();
    };
    let E = 0;
    function $(O = 0) {
      var J;
      I.uploadedBytes = Math.min(I.totalBytes, E + O), I.percent = I.totalBytes > 0 ? Math.min(100, Math.round(I.uploadedBytes / I.totalBytes * 100)) : I.status === "done" ? 100 : 0, (J = C.onProgress) == null || J.call(C, I);
    }
    try {
      if (!u())
        throw Pc(new Error("staged upload endpoint not configured"));
      const O = a();
      let J = "", G = C.chunkSize ?? r;
      const N = zc(n, B);
      if (N)
        try {
          const ve = await A(N.uploadId);
          gv(ve.state) && (ve.total_size ?? 0) === C.file.size ? (J = N.uploadId, G = ve.chunk_size ?? ve.chunkSize ?? N.chunkSize, E = ve.offset ?? 0, I.resumedFrom = E) : yo(n, B);
        } catch {
          yo(n, B);
        }
      if (!J) {
        let ve;
        try {
          ve = await t.jsonFetch(`${O}/begin`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              path: C.path,
              name: C.file.name,
              size: C.file.size,
              mime: C.file.type || "application/octet-stream",
              // Asked for, not imposed: the server clamps this to its own
              // limits and its answer is what the loop below uses.
              chunk_size: C.chunkSize ?? r
            })
          });
        } catch (he) {
          const oe = he.status;
          throw (oe === 404 || oe === 501) && Pc(he), he;
        }
        if (!(ve != null && ve.id)) throw new Error("begin returned no upload id");
        J = ve.id, G = ve.chunk_size ?? ve.chunkSize ?? G, E = ve.offset ?? 0;
      }
      I.uploadId = J, I.status = "uploading", Ac(n, B, {
        uploadId: J,
        path: C.path,
        name: C.file.name,
        size: C.file.size,
        lastModified: C.file.lastModified,
        chunkSize: G,
        offset: E
      }), $();
      const P = 4;
      for (; E < C.file.size; ) {
        if (U) throw new DOMException("Aborted by user", "AbortError");
        const ve = Math.min(E + G, C.file.size), he = C.file.slice(E, ve);
        let oe = -1, ue = null;
        for (let Q = 0; Q < P; Q++) {
          if (Q > 0) {
            if (await Dc(300 * Q + Math.floor(Math.random() * 150)), U) throw new DOMException("Aborted by user", "AbortError");
            try {
              const pe = await A(J);
              if ((pe.offset ?? 0) >= ve) {
                oe = pe.offset ?? ve;
                break;
              }
              if ((pe.offset ?? 0) !== E) {
                E = pe.offset ?? E, $(), oe = -2;
                break;
              }
            } catch {
            }
          }
          try {
            oe = await M(J, he, E, ve, C.file.size);
            break;
          } catch (pe) {
            const re = pe instanceof Error ? pe : new Error(String(pe));
            if (U || re.name === "AbortError") throw re;
            const S = re.status;
            if (S && S !== 400 && S !== 409 && S < 500) throw re;
            ue = re;
          }
        }
        if (oe !== -2) {
          if (oe < 0) throw ue ?? new Error("chunk upload failed");
          if (oe <= E) throw new Error(`upload stalled at byte ${E}`);
          E = oe, $(), Ac(n, B, {
            uploadId: J,
            path: C.path,
            name: C.file.name,
            size: C.file.size,
            lastModified: C.file.lastModified,
            chunkSize: G,
            offset: E
          });
        }
      }
      if (U) throw new DOMException("Aborted by user", "AbortError");
      I.status = "committing", $();
      const le = await t.jsonFetch(
        `${O}/${encodeURIComponent(J)}/commit`,
        { method: "POST" }
      );
      return yo(n, B), I.opId = le == null ? void 0 : le.op_id, I.nodeId = le == null ? void 0 : le.node_id, C.waitForTransfer !== !1 && (le != null && le.op_id) && t.endpoints.opsShow && (I.status = "transferring", $(), await z(le.op_id)), I.status = "done", E = I.totalBytes, $(), (T = C.onDone) == null || T.call(C, I, le), le;
    } catch (O) {
      const J = O instanceof Error ? O : new Error(String(O));
      if (I.status = J.name === "AbortError" ? "aborted" : "error", I.error = J.message, $(), I.uploadId && I.status === "aborted") {
        yo(n, B);
        try {
          await t.jsonFetch(`${a()}/${encodeURIComponent(I.uploadId)}`, {
            method: "DELETE"
          });
        } catch {
        }
      }
      throw (Y = C.onError) == null || Y.call(C, I, J), J;
    }
    function M(O, J, G, N, P) {
      return new Promise((le, ve) => {
        const he = new XMLHttpRequest();
        x = he, he.open("PUT", `${a()}/${encodeURIComponent(O)}`);
        const oe = t.authHeadersSync({
          "Content-Type": "application/octet-stream",
          "Content-Range": `bytes ${G}-${N - 1}/${P}`
        });
        for (const [ue, Q] of Object.entries(oe)) he.setRequestHeader(ue, Q);
        he.withCredentials = t.credentialsMode() === "include", he.upload.onprogress = (ue) => {
          ue.lengthComputable && $(ue.loaded);
        }, he.onload = () => {
          if (x = null, he.status >= 200 && he.status < 300) {
            try {
              const Q = JSON.parse(he.responseText);
              le(Q.offset ?? N);
            } catch {
              le(N);
            }
            return;
          }
          const ue = new Error(
            `chunk ${G}-${N - 1} → ${he.status}`
          );
          ue.status = he.status, ue.detail = he.responseText.slice(0, 200), ve(ue);
        }, he.onerror = () => {
          x = null, ve(new Error(`chunk ${G}-${N - 1}: network error`));
        }, he.onabort = () => {
          x = null, ve(new DOMException("Aborted", "AbortError"));
        }, he.send(J);
      });
    }
    async function z(O) {
      const J = t.endpoints.opsShow;
      if (!J) return;
      const G = J.replace("{id}", String(O));
      let N = 200, P = 0;
      for (; ; ) {
        if (U) throw new DOMException("Aborted by user", "AbortError");
        try {
          const le = await t.jsonFetch(G);
          if ((le == null ? void 0 : le.status) === "ok") return;
          if ((le == null ? void 0 : le.status) === "failed" || (le == null ? void 0 : le.status) === "partial")
            throw new Lc(le.error || "transfer failed");
          P = 0;
        } catch (le) {
          if (le instanceof Lc || le.name === "AbortError") throw le;
          if (++P >= wv) return;
        }
        await Dc(N), N = Math.min(N * 2, 2e3);
      }
    }
  }
  return {
    uploadFile: D,
    /** True when this file is big enough (and the endpoints exist) to chunk. */
    shouldChunk: p,
    /** The size at which chunking kicks in. */
    threshold: v,
    resumableFor: h,
    listResumable: b,
    discardResumable: y
  };
}
const wv = 6;
class Lc extends Error {
  constructor(t) {
    super(t), this.name = "TransferFailedError";
  }
}
function Dc(e) {
  return new Promise((t) => setTimeout(t, e));
}
function Oc(e) {
  const t = m(/* @__PURE__ */ new Set()), n = m(null);
  function r(D, C = {}) {
    if (C.shift && n.value) {
      const B = e(), I = B.findIndex((M) => M.path === n.value), U = B.findIndex((M) => M.path === D);
      if (I === -1 || U === -1) {
        t.value = /* @__PURE__ */ new Set([D]), n.value = D;
        return;
      }
      const [x, E] = I < U ? [I, U] : [U, I], $ = /* @__PURE__ */ new Set();
      for (let M = x; M <= E; M++) $.add(B[M].path);
      t.value = $;
      return;
    }
    if (C.ctrl) {
      const B = new Set(t.value);
      B.has(D) ? B.delete(D) : B.add(D), t.value = B, n.value = D;
      return;
    }
    t.value = /* @__PURE__ */ new Set([D]), n.value = D;
  }
  function a() {
    t.value = /* @__PURE__ */ new Set(), n.value = null;
  }
  function u() {
    t.value = new Set(e().map((D) => D.path));
  }
  function v(D) {
    return t.value.has(D);
  }
  function p(D) {
    const C = new Set(t.value);
    C.add(D), t.value = C;
  }
  function h(D) {
    const C = new Set(t.value);
    C.delete(D), t.value = C;
  }
  const b = k(() => t.value.size), y = k(() => t.value.size === 0), A = k(() => e().filter((C) => t.value.has(C.path)));
  return { selected: t, anchor: n, click: r, clear: a, selectAll: u, has: v, add: p, remove: h, size: b, isEmpty: y, nodes: A };
}
const $v = /* @__PURE__ */ new Set([
  "Ctrl+N",
  "Ctrl+Shift+N",
  "Ctrl+T",
  "Ctrl+Shift+T",
  "Ctrl+W",
  "Ctrl+Shift+W",
  "Ctrl+Tab",
  "Ctrl+Shift+Tab",
  "Ctrl+Q",
  "Ctrl+Shift+I",
  "Ctrl+Shift+J",
  "Ctrl+Shift+C",
  "F11",
  "F12"
]);
function Bc(e) {
  return $v.has(e);
}
const oa = [
  // Navigation
  { id: "palette", defaultCombo: "Ctrl+K", labelKey: "shortcuts.palette", groupKey: "shortcuts.group.nav" },
  { id: "search", defaultCombo: "/", labelKey: "shortcuts.search", groupKey: "shortcuts.group.nav" },
  { id: "go-up", defaultCombo: "Alt+↑", fixedCombos: ["Backspace"], labelKey: "shortcuts.go_up", groupKey: "shortcuts.group.nav" },
  { id: "open", defaultCombo: "Enter", prevent: !1, labelKey: "shortcuts.open", groupKey: "shortcuts.group.nav" },
  { id: "quicklook", defaultCombo: "Space", labelKey: "shortcuts.quicklook", groupKey: "shortcuts.group.nav" },
  { id: "close", defaultCombo: "Esc", customizable: !1, prevent: !1, inForms: !0, labelKey: "shortcuts.close", groupKey: "shortcuts.group.nav" },
  { id: "inspector", defaultCombo: "I", labelKey: "shortcuts.inspector", groupKey: "shortcuts.group.nav" },
  { id: "help", defaultCombo: "?", labelKey: "shortcuts.help", groupKey: "shortcuts.group.nav" },
  { id: "toggle-hidden", defaultCombo: "Ctrl+Shift+.", labelKey: "shortcuts.toggle_hidden", groupKey: "shortcuts.group.nav" },
  /* yildiz:s1 — starring is an action, so it belongs where the other verbs
   * are. A bare letter like the inspector's `I`; the handler ignores events
   * from form controls, so it never eats a keystroke meant for a filename. */
  { id: "star", defaultCombo: "S", labelKey: "shortcuts.star", groupKey: "shortcuts.group.file" },
  // Selection
  { id: "select-all", defaultCombo: "Ctrl+A", labelKey: "shortcuts.select_all", groupKey: "shortcuts.group.selection" },
  // File operations
  { id: "rename", defaultCombo: "F2", labelKey: "shortcuts.rename", groupKey: "shortcuts.group.file" },
  { id: "delete", defaultCombo: "Del", labelKey: "shortcuts.delete", groupKey: "shortcuts.group.file" },
  { id: "cut", defaultCombo: "Ctrl+X", labelKey: "shortcuts.cut", groupKey: "shortcuts.group.file" },
  { id: "copy", defaultCombo: "Ctrl+C", labelKey: "shortcuts.copy", groupKey: "shortcuts.group.file" },
  { id: "paste", defaultCombo: "Ctrl+V", labelKey: "shortcuts.paste", groupKey: "shortcuts.group.file" },
  /* wiring:d1 — tabs. Note: browsers reserve Ctrl+T/W/Tab in normal pages
   * (preventDefault can't stop them there); they work in webcomponent/PWA/
   * kiosk contexts and stay remappable through the settings modal. */
  { id: "tab-new", defaultCombo: "Ctrl+T", labelKey: "shortcuts.tab_new", groupKey: "shortcuts.group.tabs" },
  { id: "tab-close", defaultCombo: "Ctrl+W", labelKey: "shortcuts.tab_close", groupKey: "shortcuts.group.tabs" },
  { id: "tab-next", defaultCombo: "Ctrl+Tab", labelKey: "shortcuts.tab_next", groupKey: "shortcuts.group.tabs" },
  { id: "tab-prev", defaultCombo: "Ctrl+Shift+Tab", labelKey: "shortcuts.tab_prev", groupKey: "shortcuts.group.tabs" },
  /* /wiring:d1 */
  /* tus:t1 — the rest of the menu verbs. Until now these were reachable only
   * by right-clicking, and the right-click menu named no keys at all, so 16 of
   * the registry's actions were invisible unless somebody opened the `?` sheet
   * on their own. The ones with no default are deliberate: they are rare
   * enough that taking a key from the user by default is the wrong trade, and
   * they are in the registry so the user can take one. */
  { id: "new-folder", defaultCombo: "Shift+N", labelKey: "shortcuts.new_folder", groupKey: "shortcuts.group.file" },
  { id: "upload", defaultCombo: "U", labelKey: "shortcuts.upload", groupKey: "shortcuts.group.file" },
  { id: "refresh", defaultCombo: "R", labelKey: "shortcuts.refresh", groupKey: "shortcuts.group.nav" },
  { id: "download", defaultCombo: "D", labelKey: "shortcuts.download", groupKey: "shortcuts.group.file" },
  { id: "preview", defaultCombo: "P", labelKey: "shortcuts.preview", groupKey: "shortcuts.group.nav" },
  { id: "share", defaultCombo: "Shift+S", labelKey: "shortcuts.share", groupKey: "shortcuts.group.file" },
  { id: "tags", defaultCombo: "T", labelKey: "shortcuts.tags", groupKey: "shortcuts.group.file" },
  { id: "convert", defaultCombo: "", labelKey: "shortcuts.convert", groupKey: "shortcuts.group.file" },
  { id: "open-tab", defaultCombo: "", labelKey: "shortcuts.open_tab", groupKey: "shortcuts.group.tabs" },
  { id: "copy-path", defaultCombo: "", labelKey: "shortcuts.copy_path", groupKey: "shortcuts.group.file" },
  { id: "copy-id", defaultCombo: "", labelKey: "shortcuts.copy_id", groupKey: "shortcuts.group.file" },
  { id: "restore", defaultCombo: "", labelKey: "shortcuts.restore", groupKey: "shortcuts.group.file" }
  /* /tus:t1 */
], xv = {
  palette: "onPathJump",
  search: "onFocusSearch",
  "go-up": "onGoUp",
  open: "onOpen",
  quicklook: "onQuickLook",
  close: "onClose",
  inspector: "onToggleInspector",
  "toggle-hidden": "onToggleHidden",
  star: "onStar",
  help: "onShowHelp",
  "select-all": "onSelectAll",
  rename: "onRename",
  delete: "onDelete",
  cut: "onCut",
  copy: "onCopy",
  paste: "onPaste",
  /* wiring:d1 */
  "tab-new": "onTabNew",
  "tab-close": "onTabClose",
  "tab-next": "onTabNext",
  "tab-prev": "onTabPrev",
  /* tus:t1 */
  "new-folder": "onNewFolder",
  upload: "onUpload",
  refresh: "onRefresh",
  download: "onDownload",
  preview: "onPreview",
  share: "onShare",
  tags: "onTags",
  convert: "onConvert",
  "open-tab": "onOpenTab",
  "copy-path": "onCopyPath",
  "copy-id": "onCopyId",
  restore: "onRestore"
}, oi = "filex.shortcuts";
function Sv() {
  try {
    const e = localStorage.getItem(oi);
    if (!e) return {};
    const t = JSON.parse(e);
    if (!t || typeof t != "object") return {};
    const n = {};
    for (const [r, a] of Object.entries(t))
      typeof a == "string" && oa.some((u) => u.id === r) && (n[r] = a);
    return n;
  } catch {
    return {};
  }
}
const Pn = m(Sv());
function Si() {
  try {
    Object.keys(Pn.value).length === 0 ? localStorage.removeItem(oi) : localStorage.setItem(oi, JSON.stringify(Pn.value));
  } catch {
  }
}
function Ci(e) {
  return oa.find((t) => t.id === e);
}
function Wa(e) {
  var n;
  const t = Pn.value[e];
  return t !== void 0 ? t : ((n = Ci(e)) == null ? void 0 : n.defaultCombo) ?? "";
}
function Yr(e, t) {
  const n = Ci(e);
  if (!n || n.customizable === !1) return;
  const r = { ...Pn.value };
  t === n.defaultCombo ? delete r[e] : r[e] = t, Pn.value = r, Si();
}
function Cv(e) {
  if (!(e in Pn.value)) return;
  const t = { ...Pn.value };
  delete t[e], Pn.value = t, Si();
}
function Tv() {
  Pn.value = {}, Si();
}
function Mv(e, t) {
  var n;
  if (!e) return null;
  for (const r of oa)
    if (r.id !== t) {
      if ((n = r.fixedCombos) != null && n.includes(e)) return { id: r.id, fixed: !0 };
      if (Wa(r.id) === e) return { id: r.id, fixed: r.customizable === !1 };
    }
  return null;
}
const Ev = {
  " ": "Space",
  Spacebar: "Space",
  Escape: "Esc",
  Delete: "Del",
  ArrowUp: "↑",
  ArrowDown: "↓",
  ArrowLeft: "←",
  ArrowRight: "→",
  PageUp: "PgUp",
  PageDown: "PgDn"
}, zv = /* @__PURE__ */ new Set(["Control", "Alt", "Shift", "Meta", "AltGraph", "CapsLock", "NumLock", "ScrollLock", "Fn", "Dead"]);
function Av(e) {
  const t = e.key;
  if (!t || zv.has(t)) return null;
  const n = Ev[t];
  return n || (t.length === 1 ? t.toUpperCase() : t);
}
function Ti(e) {
  const t = Av(e);
  if (!t) return null;
  const n = [];
  (e.ctrlKey || e.metaKey) && n.push("Ctrl"), e.altKey && n.push("Alt");
  const r = t.length === 1 && t.toUpperCase() === t.toLowerCase();
  return e.shiftKey && !r && n.push("Shift"), n.push(t), n.join("+");
}
function Uu() {
  return k(
    () => oa.map((e) => {
      const t = Wa(e.id), n = e.fixedCombos ?? [];
      return {
        id: e.id,
        combo: t,
        fixedCombos: n,
        keys: [t, ...n].filter((r) => !!r),
        labelKey: e.labelKey,
        groupKey: e.groupKey,
        customizable: e.customizable !== !1,
        overridden: Pn.value[e.id] !== void 0
      };
    })
  );
}
function Pv() {
  return typeof navigator < "u" && /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || "");
}
function Lv(e) {
  return e ? Pv() ? e.replace(/\bCtrl\b/g, "⌘") : e : "";
}
const Dv = {
  open: "open",
  "open-tab": "open-tab",
  preview: "preview",
  download: "download",
  convert: "convert",
  access: "share",
  details: "inspector",
  "copy-id": "copy-id",
  "copy-path": "copy-path",
  rename: "rename",
  cut: "cut",
  copy: "copy",
  paste: "paste",
  star: "star",
  tags: "tags",
  delete: "delete",
  restore: "restore",
  "new-folder": "new-folder",
  "toggle-hidden": "toggle-hidden",
  upload: "upload",
  refresh: "refresh"
};
function Vu(e) {
  const t = Dv[e] ?? e;
  return oa.some((n) => n.id === t) ? Na(t) : "";
}
function Na(e) {
  return Lv(Wa(e));
}
function si(e, t) {
  var a, u;
  const n = Wa(t);
  if (!n) return !1;
  const r = Ti(e);
  return r === n ? !0 : ((u = (a = Ci(t)) == null ? void 0 : a.fixedCombos) == null ? void 0 : u.includes(r ?? "")) ?? !1;
}
oa.map((e) => ({
  keys: [e.defaultCombo, ...e.fixedCombos ?? []].filter((t) => !!t),
  labelKey: e.labelKey,
  groupKey: e.groupKey
}));
function Ov(e, t) {
  const n = k(() => {
    const a = /* @__PURE__ */ new Map();
    for (const u of oa) {
      const v = Wa(u.id);
      v && a.set(v, u);
    }
    return a;
  });
  function r(a) {
    var A;
    if (!e.value || a.key !== "Escape" && document.querySelector(".fe-ctx-backdrop")) return;
    const v = a.target, p = !!(v && (v.tagName === "INPUT" || v.tagName === "TEXTAREA" || v.tagName === "SELECT" || v.isContentEditable)), h = Ti(a);
    if (!h) return;
    if (h === "Backspace") {
      if (p) return;
      (A = t.hasSelection) != null && A.call(t) && t.onDelete ? (a.preventDefault(), t.onDelete()) : t.onGoUp && (a.preventDefault(), t.onGoUp());
      return;
    }
    const b = n.value.get(h);
    if (!b || p && !b.inForms || h === "Space" && v && typeof v.closest == "function" && v.closest('button, a, select, summary, [role="button"], [role="menuitem"]'))
      return;
    const y = t[xv[b.id]];
    y && (b.prevent !== !1 && a.preventDefault(), y());
  }
  dt(() => window.addEventListener("keydown", r)), it(() => window.removeEventListener("keydown", r));
}
const Bv = {
  "toolbar.new_folder": "Yeni klasör",
  "toolbar.upload": "Yükle",
  "toolbar.search": "Ara",
  "toolbar.search.placeholder": "Ada ya da tag: ile ara…",
  "toolbar.view.list": "Liste",
  "toolbar.view.grid": "Izgara",
  "toolbar.refresh": "Yenile",
  "toolbar.go_up": "Üst Klasör",
  "ctx.open": "Aç",
  "ctx.preview": "Önizle",
  "ctx.download": "İndir",
  "ctx.convert": "Dönüştür",
  "ctx.rename": "Yeniden adlandır",
  "ctx.delete": "Sil",
  "ctx.delete_perm": "Kalıcı Olarak Sil",
  "ctx.restore": "Geri Getir",
  "ctx.share": "Paylaş",
  "ctx.move": "Taşı",
  "ctx.copy": "Kopyala",
  "ctx.cut": "Kes",
  "ctx.show_hidden": "Gizli dosyaları göster",
  "ctx.hide_hidden": "Gizli dosyaları gizle",
  "ctx.keep_local": "Bilgisayarda tut",
  "ctx.keep_online": "Yalnızca çevrimiçi tut",
  "ctx.keep_reveal": "Yerel klasörü aç",
  "ctx.keep_inherited": "Üst klasörle bilgisayarda tutuluyor",
  "keep.started": "Bilgisayarda tutulacak — eşitleme başladı",
  "keep.failed": "Bilgisayarda tutulamadı",
  "keep.badge_kept": "Bilgisayarda",
  "keep.badge_syncing": "Eşitleniyor…",
  "keep.badge_cloud": "Yalnızca çevrimiçi",
  "keep.badge_partial": "İçinde bilgisayarda tutulanlar var",
  "keep.strip_transfer": "{name} eşitleniyor — {done}/{total} (%{pct})",
  "keep.strip_inventory": "{name} eşitleniyor — sunucu taranıyor…",
  "keep.strip_settling": "{name} eşitleniyor — son durum kaydediliyor…",
  "ctx.paste": "Yapıştır",
  "ctx.info": "Bilgi",
  "ctx.duplicate": "Kopyasını Oluştur",
  "ctx.new_file": "Yeni dosya",
  "modal.delete.title": "Silinsin mi?",
  "modal.delete.message": "{count} öğe çöpe atılacak.",
  "modal.delete.message_one": "{count} öğe çöpe atılacak.",
  "modal.delete.confirm": "Çöpe At",
  "modal.delete.cancel": "Vazgeç",
  "modal.rename.title": "Yeniden adlandır",
  "modal.rename.save": "Kaydet",
  "modal.rename.cancel": "Vazgeç",
  "modal.newfolder.title": "Yeni klasör",
  "modal.newfolder.placeholder": "Klasör adı",
  "modal.newfolder.create": "Oluştur",
  "modal.newfolder.cancel": "Vazgeç",
  "modal.share.title": "Paylaşım Linki",
  "modal.share.pin": "PIN koruması",
  "modal.share.expires": "Son kullanma",
  "modal.share.max_downloads": "İndirme limiti",
  "modal.share.create": "Paylaş",
  "modal.share.cancel": "Vazgeç",
  "modal.share.close": "Kapat",
  "modal.share.limit_applied": "(sunucu sınırı uygulandı)",
  "modal.share.copy": "Kopyala",
  "modal.share.url_copied": "Link kopyalandı",
  "modal.share.pin_copied": "PIN kopyalandı",
  "modal.share.cli_copied": "CLI komutu kopyalandı",
  "upload.progress": "Yükleniyor",
  "upload.done": "Tamamlandı",
  "upload.error": "Hata",
  "upload.failed": "“{name}” yüklenemedi",
  "upload.aborted": "İptal edildi",
  "upload.cancel": "İptal",
  "upload.resuming": "“{name}” %{percent} noktasından devam ediyor",
  "upload.committing": "Tamamlanıyor",
  "upload.transferring": "Depolamaya aktarılıyor",
  "empty.folder": "Bu klasör boş",
  "empty.search": "Sonuç bulunamadı",
  loading: "Yükleniyor…",
  "notFound.title": "Klasör bulunamadı",
  "notFound.desc": "Bu klasör mevcut değil, taşınmış ya da erişim yetkiniz yok.",
  "notFound.goRoot": "Kök klasöre dön",
  "col.name": "Ad",
  "col.size": "Boyut",
  "col.modified": "Tarih",
  "col.type": "Tür",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Kök",
  "breadcrumb.copy_path": "Yolu kopyala",
  "breadcrumb.go_to_path": "Yola git",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Kopyalanıyor",
  "ops.move": "Taşınıyor",
  "ops.delete": "Siliniyor",
  "ops.queued": "sırada",
  "ops.done": "tamamlandı",
  "ops.error": "hata",
  "node.trash": "Çöp Kutusu",
  "node.folder": "Klasör",
  // ——— Zengin önizleyici chrome ———
  "viewer.open_in_new_tab": "Yeni sekmede aç",
  "viewer.loading": "Yükleniyor…",
  "viewer.failed_to_load": "Dosya yüklenemedi",
  "viewer.peer_not_installed": "Bu dosya tipi için opsiyonel kütüphane kurulu değil. Peer dependency yükle veya İndir düğmesini kullan.",
  "viewer.format_unsupported_3d": "Bu 3B format tarayıcı önizlemesinde desteklenmiyor (model-viewer yalnızca .glb / .gltf / .usdz okur). Lütfen indirip yerel bir araçta açın.",
  "viewer.zoom_in": "Yakınlaştır",
  "viewer.zoom_out": "Uzaklaştır",
  "viewer.fit_width": "Sayfa genişliğine sığdır",
  "viewer.next_page": "Sonraki sayfa",
  "viewer.prev_page": "Önceki sayfa",
  "viewer.page_n_of_m": "Sayfa {n} / {m}",
  "viewer.tags": "Etiketler",
  "viewer.layers": "Katmanlar",
  "viewer.toc": "İçindekiler",
  "viewer.font_smaller": "Yazıyı küçült",
  "viewer.font_larger": "Yazıyı büyüt",
  "viewer.search": "Ara",
  "viewer.download": "İndir",
  "viewer.saving": "Kaydediliyor…",
  "viewer.save": "Kaydet (Ctrl+S)",
  "viewer.saved": "Kaydedildi",
  "viewer.save_error": "Hata",
  "viewer.editor_loading": "Editör yükleniyor…",
  "viewer.no_preview": "Bu dosya tipi için önizleme henüz yok.",
  "viewer.edit": "Düzenle",
  "viewer.close": "Kapat",
  "presence.expand": "İsimleri göster",
  "presence.collapse": "Küçült",
  "viewer.save_annotations": "Açıklamaları kaydet",
  "viewer.annotations_on": "Açıklamalar: açık",
  "viewer.annotations_off": "Açıklamalar: kapalı",
  "viewer.read_only": "Salt okunur",
  "viewer.csv_first_row_header": "İlk satır başlık olsun",
  "viewer.csv_filter": "Satır filtrele…",
  "viewer.epub_prev": "Önceki",
  "viewer.epub_next": "Sonraki",
  "viewer.drawio.disabled": "diagrams.net editörü bu filex kurulumunda yapılandırılmamış — yönetici FILEX_DRAWIO_URL'yi ayarlamalı.",
  "viewer.archive.entries": "{n} dosya",
  "viewer.archive.entries_one": "{n} dosya",
  "viewer.archive.empty": "Arşiv boş.",
  "viewer.archive.error": "Arşiv okunamadı.",
  "viewer.name": "Ad",
  "viewer.size": "Boyut",
  // ——— cila:a — sıralama / tarih grupları / yoğunluk ———
  "col.sort": "Sırala",
  "group.today": "Bugün",
  "group.yesterday": "Dün",
  "group.this_week": "Bu Hafta",
  "group.this_month": "Bu Ay",
  "group.no_date": "Tarihsiz",
  "toolbar.density.compact": "Sıkışık görünüm",
  "toolbar.density.comfortable": "Rahat görünüm",
  // ——— cila:c — komut paleti + kısayol yardımı + breadcrumb ———
  "palette.placeholder": "Dosya, klasör veya komut ara…",
  "palette.files": "Dosyalar",
  "palette.commands": "Komutlar",
  "palette.goto": "Yola git",
  "palette.empty": "Sonuç bulunamadı",
  "palette.hint": "↑↓ gezin · Enter seç · Esc kapat",
  "cmd.view_toggle": "Görünümü değiştir (liste ⇄ ızgara)",
  "cmd.trash": "Çöp kutusunu aç",
  "shortcuts.title": "Klavye Kısayolları",
  "shortcuts.group.nav": "Gezinme",
  "shortcuts.group.selection": "Seçim",
  "shortcuts.group.file": "Dosya işlemleri",
  "shortcuts.palette": "Komut paleti",
  "shortcuts.search": "Aramaya odaklan",
  "shortcuts.go_up": "Üst klasöre çık",
  "shortcuts.open": "Seçili öğeyi aç",
  "shortcuts.close": "Kapat / vazgeç",
  "shortcuts.toggle_hidden": "Gizli dosyaları göster/gizle",
  "shortcuts.help": "Bu yardım penceresi",
  "shortcuts.select_all": "Tümünü seç",
  "shortcuts.star": "Yıldızla / yıldızı kaldır",
  "shortcuts.rename": "Yeniden adlandır",
  "shortcuts.delete": "Sil",
  "shortcuts.cut": "Kes",
  "shortcuts.copy": "Kopyala",
  "shortcuts.paste": "Yapıştır",
  "breadcrumb.more": "Aradaki klasörler",
  // ——— State screens + undo snackbar + connection badge (cila:b) ———
  "empty.hint": "Dosyaları buraya sürükleyip bırakın",
  "empty.upload": "Dosya yükle",
  "empty.search.title": "Aramanla eşleşen dosya yok",
  "empty.search.hint": "Farklı bir arama terimi deneyin",
  "empty.trash.title": "Çöp kutusu boş",
  "error.title": "Liste yüklenemedi",
  "error.retry": "Yeniden dene",
  "toast.undo": "Geri Al",
  "toast.undone": "Geri alındı",
  "toast.undo_failed": "Geri alınamadı",
  "toast.renamed": "Yeniden adlandırıldı",
  "toast.moved": "Taşındı",
  "toast.trashed": "Çöpe taşındı",
  /* i18n:hardcoded — FileExplorer.vue'da düz string olarak duran, hiçbir dilin
     değiştiremediği bildirim metinleri. */
  "toast.failed": "İşlem başarısız",
  "toast.copied": "Kopyalandı",
  "toast.deleted": "Silindi",
  "toast.cut": "Kesildi",
  "toast.cut_ready": "Kes → Yapıştır hazır",
  "toast.copy_ready": "Kopyala → Yapıştır hazır",
  "toast.same_folder_cut": "Aynı klasöre kesilemez",
  "toast.restored": "{n} öğe geri getirildi",
  "toast.restored_one": "{n} öğe geri getirildi",
  "toast.restore_taken": "{n} öğe geri getirilmedi: aynı adla bir şey zaten var. Oradakinin adını değiştirip yeniden deneyin.",
  "toast.restore_taken_one": "“{name}” geri getirilmedi: aynı adla bir şey zaten var. Oradakinin adını değiştirip yeniden deneyin.",
  "toast.delete_queued": "Silme kuyruğa alındı",
  "toast.trash_retention": "Çöpteki öğeler saklama süresi sonunda otomatik silinir. Kalıcı silme yönetici panelinden yapılır.",
  "dropzone.hint": "Dosyaları buraya bırak",
  "modal.newfolder.invalid": "Geçersiz karakter",
  "viewer.office_unconfigured": "OnlyOffice yapılandırması yok",
  "viewer.pdf_inline_failed": "Tarayıcı PDF'i inline açamadı.",
  "viewer.too_large": "Dosya çok büyük (>1 MB).",
  "viewer.csv_rows": "{n} satır",
  "viewer.csv_rows_one": "{n} satır",
  "presence.others": "{n} kişi",
  "presence.others_one": "{n} kişi",
  "conn.offline": "Canlı bağlantı yok — değişiklikler gecikebilir",
  "conn.tooltip": "Sunucuyla canlı bağlantı kurulamadı; liste belirli aralıklarla otomatik yenilenir. Bağlantı geri gelince bu uyarı kaybolur.",
  /* === bul:s3 === */
  "palette.everywhere": "Her yerde",
  "palette.searching": "Aranıyor…",
  "palette.saved": "Kayıtlı aramalar",
  "palette.save": "Aramayı kaydet",
  "palette.saved.delete": "Kayıtlı aramayı sil",
  "search.in_content": "İçerikte",
  /* === bag:b4 === */
  "toolbar.more": "Diğer işlemler",
  "toolbar.search.close": "Aramayı kapat",
  "sheet.menu": "İşlemler",
  "sheet.close": "Kapat",
  /* === koru:k1 === */
  "toolbar.inspector": "Ayrıntılar",
  "ctx.details": "Ayrıntılar",
  /* yildiz:s1 — yıldızlamak bir eylem, menüde de öyle görünür. */
  "ctx.star": "Yıldızla",
  "ctx.unstar": "Yıldızı kaldır",
  "star.failed": "Yıldız değiştirilemedi",
  "shortcuts.inspector": "Ayrıntılar panelini aç/kapat",
  "inspector.title": "Ayrıntılar",
  "inspector.copy_name": "Adı kopyala",
  "inspector.items": "{n} öğe",
  "inspector.items_one": "{n} öğe",
  "inspector.type": "Tür",
  "inspector.select_hint": "Ayrıntılarını görmek için bir öğe seçin.",
  /* pane:p1 — panel SON seçilen şeyi tutar (Burak'ın kararı, 2026-09-13);
     dolayısıyla bölünmüş pencerenin bakılmayan yarısındaki bir öğeyi
     anlatıyor olabilir. Bu satır hangisi olduğunu ve nerede durduğunu söyler. */
  "inspector.held": "Son seçilen — {where} içinde",
  "inspector.close": "Kapat",
  "inspector.section.general": "Genel",
  "inspector.section.tags": "Etiketler",
  /* etiket:t1 — TagPicker'ın kendi çerçevesi. 2026-09-13'e kadar bu üçü
     katalogdan bağımsız olarak İngilizce basılıyordu; `tags.open` ise çipin
     yeni "bu etiketi taşıyan her şeyi göster" kapısı. */
  "tags.open": "Etiketi aç: {tag}",
  "tags.add": "+ Etiket ekle",
  "tags.name": "Etiket adı",
  "tags.remove": "Etiketi kaldır",
  "inspector.section.versions": "Sürümler",
  "inspector.section.permissions": "İzinler",
  "inspector.section.shares": "Paylaşımlar",
  "inspector.path": "Yol",
  "inspector.size": "Boyut",
  "inspector.modified": "Değiştirilme",
  "inspector.mime": "MIME türü",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Düğüm kimliği",
  "inspector.copy": "Kopyala",
  "inspector.copied": "Kopyalandı",
  "inspector.error": "Yüklenemedi",
  "inspector.items_summary": "{n} öğe, toplam {size}",
  "inspector.items_summary_one": "{n} öğe, toplam {size}",
  "inspector.folder_items": "{n} öğe",
  "inspector.folder_items_one": "{n} öğe",
  "inspector.versions.empty": "Sürüm geçmişi yok",
  "inspector.versions.v": "Sürüm {n}",
  "inspector.versions.restore": "Geri yükle",
  "inspector.versions.restore_confirm": "Bu sürüm geri yüklensin mi?",
  "inspector.versions.snapshot_current": "Önce şimdiki halin sürümünü al",
  "inspector.versions.confirm": "Onayla",
  "inspector.versions.cancel": "Vazgeç",
  "inspector.versions.take_snapshot": "Şimdiki halin sürümünü al",
  "inspector.versions.restored": "Sürüm geri yüklendi",
  "inspector.versions.snapshotted": "Sürüm alındı",
  "inspector.versions.unsupported": "Sunucu bu işlemi desteklemiyor",
  "inspector.perm.none": "Erişim yok",
  "inspector.perm.viewer": "Görüntüleyen",
  "inspector.perm.editor": "Düzenleyen",
  "inspector.perm.owner": "Sahip",
  "inspector.perm.manage": "İzinleri yönet",
  "inspector.shares.empty": "Paylaşım linki yok",
  "inspector.shares.copy": "Linki kopyala",
  /* wiring:c1 — tema galerisi */
  "theme.menu": "Tema",
  "theme.title": "Tema Galerisi",
  "theme.hint": "Tema yalnız renk paletini değiştirir; gündüz mü gece mi olduğu yukarıdaki seçim.",
  "theme.mode.label": "Görünüm",
  "theme.mode.light": "Gündüz",
  "theme.mode.dark": "Gece",
  "theme.mode.auto": "Otomatik",
  "theme.reset": "Varsayılana dön",
  "theme.close": "Kapat",
  "theme.selected": "Seçili",
  "theme.name.default": "Varsayılan",
  "theme.name.night": "Gece Mavisi",
  "theme.name.forest": "Orman",
  "theme.name.amber": "Kehribar",
  "theme.name.lilac": "Leylak",
  "theme.name.contrast": "Yüksek Kontrast",
  "theme.name.gray": "Yumuşak Gri",
  "theme.name.terminal": "Terminal Yeşili",
  /* === zaman:z3 — saat dilimi seçici (gömme penceresi + web ayarları) === */
  "tz.menu": "Saat dilimi",
  "tz.title": "Saat dilimi",
  "tz.label": "Tarihleri şu saatle göster",
  "tz.search": "Şehir, ülke ya da saat farkı arayın — “İstanbul” veya “GMT+3” deneyin",
  "tz.default.device": "Bu cihazın saat dilimini kullan ({zone})",
  "tz.default.account": "Hesabın saat dilimini kullan ({zone})",
  "tz.default.host": "Bu sitenin varsayılanını kullan ({zone})",
  "tz.no_match": "“{query}” ile eşleşen saat dilimi yok. Bir şehir, bir ülke ya da GMT+3 gibi bir fark deneyin.",
  "tz.more": "{n} kayıt daha var — listeyi daraltmak için yazmayı sürdürün.",
  "tz.hint": "Yalnızca bu tarayıcıda saklanır. Her tarih tek bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir.",
  "tz.now": "{zone} bölgesinde şu an: {time}",
  /* === wiring:c2 — özelleştirilebilir kısayollar + hızlı bakış === */
  "shortcuts.quicklook": "Hızlı bakış",
  "shortcuts.customize": "Özelleştir",
  "shortcuts.settings.menu": "Kısayollar",
  "shortcuts.settings.title": "Kısayol Ayarları",
  "shortcuts.settings.hint": 'Bir kısayolu değiştirmek için "Değiştir"e basıp yeni tuş kombinasyonuna basın. Değişiklikler yalnızca bu tarayıcıda saklanır.',
  "shortcuts.settings.change": "Değiştir",
  "shortcuts.settings.capture": "Tuşlara basın… (Esc iptal)",
  "shortcuts.settings.reset": "Varsayılana dön",
  "shortcuts.settings.reset_all": "Tümünü sıfırla",
  "shortcuts.settings.unbound": "Atanmadı",
  "shortcuts.settings.fixed": "Sabit",
  "shortcuts.settings.customized": "Özelleştirildi",
  "shortcuts.settings.conflict": 'kombinasyonu "{name}" kısayolunda kullanılıyor.',
  "shortcuts.settings.conflict_fixed": 'kombinasyonu "{name}" sabit kısayoluna ayrılmış — kullanılamaz.',
  "shortcuts.settings.conflict_take": "Eskisini boşa çıkar ve ata",
  "shortcuts.settings.conflict_cancel": "Vazgeç",
  "quicklook.hint_close": "kapat",
  "quicklook.hint_nav": "önceki/sonraki",
  "quicklook.hint_open": "aç",
  /* === /wiring:c2 === */
  /* === wiring:c3 — işlem merkezi === */
  "opc.title": "İşlemler",
  "opc.aria_badge": "{n} işlem — işlem merkezini aç/kapat",
  "opc.aria_badge_one": "{n} işlem — işlem merkezini aç/kapat",
  "opc.close": "Kapat",
  "opc.active": "Sürüyor",
  "opc.history": "Geçmiş",
  "opc.clear": "Temizle",
  "opc.empty": "İşlem yok",
  "opc.cancel": "İptal",
  "opc.retry": "Yeniden dene",
  "opc.dismiss": "Kapat",
  "opc.queued": "Sırada",
  "opc.percent": "%{n}",
  "opc.status.running": "Sürüyor",
  "opc.status.done": "Bitti",
  "opc.status.error": "Hata",
  "opc.status.aborted": "İptal edildi",
  "opc.kind.upload": "Yükleme",
  "opc.kind.copy": "Kopyalama",
  "opc.kind.move": "Taşıma",
  "opc.kind.delete": "Silme",
  "opc.kind.convert": "Dönüştürme",
  "opc.kind.archive": "Arşiv",
  /* === wiring:c4 — onboarding turu + erişilebilirlik + hata kartı === */
  "tour.aria": "Tanıtım turu",
  "tour.restart": "Turu tekrar başlat",
  "tour.skip": "Turu atla",
  "tour.back": "Geri",
  "tour.next": "İleri",
  "tour.done": "Bitti",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Depolar ve görünümler",
  "tour.step.nav.desc": "Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp Kutusu hep bu panelde durur; altında da depoların ve bağlantıların. Sol üst köşedeki düğme paneli ince bir şeride indirir ve geri açar.",
  "tour.step.nav.desc_closed": "Bu düğme gezinti panelini açar: Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp Kutusu; altında da depoların ve bağlantıların.",
  "tour.step.new.title": "Yeni bir şey ekle",
  "tour.step.new.desc": "Yeni olan her şey buradan başlar: bu cihazdan dosya yükleyebilir, klasör oluşturabilir ya da birinden dosya isteyebilirsin. Dosyaları pencereye sürükleyip bırakmak da yükler.",
  "tour.step.new.desc_fab": "Bu düğme bu cihazdan dosya yükler. Dosyaları pencereye sürükleyip bırakmak da çalışır.",
  "tour.step.search.title": "Arama",
  "tour.step.search.desc": 'Bu alan deponun tamamında ada göre arar; ayraçları ve bir harflik yazım hatasını affeder, yani "fatura 2026" yazdığında fatura_2026.pdf gelir. tag:fatura yazarak etikete göre süzebilirsin. Yanındaki sürgü düğmesi gelişmiş aramayı, {palette} ise komut paletini açar; palet komut da çalıştırır.',
  "tour.step.crumb.title": "Bulunduğun yer",
  "tour.step.crumb.desc": "Bu iz, ekrandaki klasörün adresidir. Adımlardan birine tıklayarak üste çıkabilir, sonuncusunun yanındaki oktan içindeki klasörleri görebilirsin.",
  "tour.step.filters.title": "Listeyi daralt",
  "tour.step.filters.desc": "Tür, Kişiler, Değiştirilme ve Boyut bulunduğun klasörü süzer; yanındaki kutu yazdıkça adlara göre eşleşir, satırın sonundaki denetim ise sıralar.",
  "tour.step.view.title": "Görünümü değiştir",
  "tour.step.view.desc": "Bu klasörün nasıl çizildiğini değiştirir; seçimin hatırlanır.",
  "tour.step.details.title": "Ayrıntılar ve paylaşım",
  "tour.step.details.desc": 'Bir dosyayı seçip bu paneli açtığında ayrıntılarını, hareketlerini ve paylaşım bağlantılarını görürsün. Tam menü için dosyaya sağ tıkla ya da satırının sonundaki düğmeyi kullan: oradaki "Paylaş / İzinler" ile PIN ve son kullanma süresi verilebilen bir bağlantı oluşturulur.',
  "tour.step.help.title": "Kısayollar",
  "tour.step.help.desc": '{help} tuşu kısayol kartını, {palette} komut paletini açar. Tema ve "Turu tekrar başlat" sağ üstteki "Diğer işlemler" menüsünde; hesabın ve çıkış ise yanındaki avatarın arkasında.',
  "error.hint": "Bağlantı ya da sunucu kaynaklı geçici bir sorun olabilir. Yeniden deneyin.",
  "error.details": "Teknik ayrıntılar",
  "col.star": "Yıldız",
  "toolbar.view_label": "Görünüm",
  "list.aria": "Dosya listesi",
  "grid.aria": "Dosya ızgarası",
  /* === wiring:d1 — sekmeler + split panel === */
  "tabs.strip": "Sekmeler",
  "tabs.new": "Yeni sekme",
  "tabs.close": "Sekmeyi kapat",
  "tabs.split": "Görünümü böl",
  "tabs.split_off": "Bölmeyi kapat",
  "ctx.open_new_tab": "Yeni sekmede aç",
  "shortcuts.group.tabs": "Sekmeler",
  "shortcuts.tab_new": "Yeni sekme",
  "shortcuts.tab_close": "Sekmeyi kapat",
  "shortcuts.tab_next": "Sonraki sekme",
  "shortcuts.tab_prev": "Önceki sekme",
  /* tus:t1 — menü fiilleri */
  "shortcuts.new_folder": "Yeni klasör",
  "shortcuts.upload": "Dosya yükle",
  "shortcuts.refresh": "Listeyi yenile",
  "shortcuts.download": "İndir",
  "shortcuts.preview": "Önizle",
  "shortcuts.share": "Paylaş / izinler",
  "shortcuts.tags": "Etiketler",
  "shortcuts.convert": "Dönüştür",
  "shortcuts.open_tab": "Yeni sekmede aç",
  "shortcuts.copy_path": "Yolu kopyala",
  "shortcuts.copy_id": "Kimliği kopyala",
  "shortcuts.restore": "Çöp kutusundan geri al",
  "shortcuts.settings.reserved": "tarayıcı tarafından sayfaya ulaşmadan yakalanıyor, burada hiçbir şey yapmaz. Başka bir tuş seçin.",
  "shortcuts.settings.reserved_badge": "Yalnız masaüstü uygulamasında",
  "shortcuts.settings.reserved_title": "Bu kombinasyonu tarayıcının kendisi işliyor. Masaüstü uygulamasında ve kurulu PWA’da çalışır, tarayıcı sekmesinde çalışmaz.",
  "cmd.tab_new": "Yeni sekme aç",
  "cmd.split_toggle": "Görünümü böl / birleştir",
  "split.pane": "İkincil panel",
  "split.close": "Yan paneli kapat",
  "split.error": "Liste yüklenemedi",
  "split.retry": "Yeniden dene",
  "split.copy_queued": "Kopyalama kuyruğa alındı",
  "split.move_queued": "Taşıma kuyruğa alındı",
  "toast.move_kept_both": "Taşıma kuyruğa alındı. Hedefte aynı adla bir öğe vardı, taşınan öğe onun yanına “-copy” ekiyle konacak. Bu taşıma geri alınamaz.",
  "split.cross_copy": "Depolar farklı — kopyalama kuyruğa alındı",
  "dragout.downloading": "Bırakılan klasöre indiriliyor…",
  "dragout.not_found": "Bırakılan yer bulunamadı — dosya bir klasöre değil bir uygulamaya bırakıldıysa indirme yapılamaz",
  "dragout.done": "İndirme tamamlandı",
  "dragout.ready": "Dosyalar hazır — masaüstüne sürükleyebilirsin",
  "dragout.preparing": "Sürükleme için hazırlanıyor…",
  "split.cross_move": "Depolar farklı — taşıma kuyruğa alındı (baytlar aktarılıp kaynak silinir)",
  /* === /wiring:d1 === */
  /* wiring:d2 — galeri görünümü */
  "toolbar.view.gallery": "Galeri",
  "gallery.aria": "Dosya galerisi",
  /* /wiring:d2 */
  /* wiring:d3 — Yorumlar (inspector node comments) */
  "inspector.section.comments": "Yorumlar",
  "inspector.comments.empty": "Henüz yorum yok.",
  "inspector.comments.placeholder": "Yorum yaz…",
  "inspector.comments.send": "Gönder",
  "inspector.comments.delete": "Yorumu sil",
  /* wiring:e2 — uçtan uca şifreli klasörler */
  "e2e.create.title": "Şifreli klasör oluştur",
  "e2e.create.option": "Şifreli klasör oluştur…",
  "e2e.create.pw_label": "Klasör parolası",
  "e2e.create.pw_placeholder": "En az 8 karakter",
  "e2e.create.pw2_label": "Parolayı tekrar girin",
  "e2e.create.warn_title": "GERİ DÖNÜŞÜ YOK",
  "e2e.create.warn_body": "Bu klasördeki dosyalar yalnız bu parolayla ya da klasör oluşturulurken bir kez gösterilen kurtarma anahtarıyla açılır. Parola sunucuda TUTULMAZ; kurtarma anahtarının da filex'te kopyası kalmaz. İkisini de kaybederseniz içerik sonsuza dek gider.",
  "e2e.create.ack": "Anladım: parolayı da kurtarma anahtarını da kaybedersem verilerim kurtarılamaz.",
  "e2e.create.ack_required": "Devam etmek için uyarıyı onaylayın.",
  "e2e.create.pw_short": "Parola en az 8 karakter olmalı.",
  "e2e.create.pw_mismatch": "Parolalar birbirini tutmuyor.",
  "e2e.create.bad_name": "Geçersiz klasör adı.",
  "e2e.create.create": "Şifreli klasörü oluştur",
  "e2e.create.busy": "Oluşturuluyor…",
  "e2e.create.done": "Şifreli klasör oluşturuldu",
  "e2e.create.failed": "Şifreli klasör oluşturulamadı",
  "e2e.create.nested": "Şifreli klasörün içine ikinci bir şifreli klasör açılamaz.",
  "e2e.locked.title": "Bu klasör uçtan uca şifreli",
  "e2e.locked.hint": "İçeriği görmek için klasör parolasını girin. Parola yalnız bu sekmede, bellekte tutulur.",
  "e2e.locked.pw_placeholder": "Klasör parolası",
  "e2e.locked.unlock": "Kilidi aç",
  "e2e.locked.busy": "Doğrulanıyor…",
  "e2e.unlock.wrong": "Parola yanlış.",
  "e2e.unlock.marker_missing": "Şifre dosyası (.filex-e2e.json) okunamadı.",
  /* ikon:emoji — listedeki işaretin erişilebilir adı. Satır eskiden yalnız
     bir 🔒 basıyordu; onun yerini alan asma kilit kutunun içinde
     aria-hidden, dolayısıyla adı taşıyan yer bu. */
  "e2e.badge": "Şifreli klasör",
  "e2e.strip.label": "Şifreli klasör — kilit açık",
  "e2e.strip.lock": "Kilitle",
  "e2e.locked_toast": "Klasör kilitlendi",
  "e2e.upload.too_big": "200 MB üstü dosyalar şifreli klasöre yüklenemez (MVP sınırı)",
  "e2e.upload.locked": "Önce klasörün kilidini açın",
  "e2e.decrypting": "Çözülüyor…",
  "e2e.decrypt_failed": "Dosya çözülemedi (parola değişmiş ya da dosya bozulmuş olabilir).",
  /* wiring:e2 recovery — kurtarma anahtarı + yönetici escrow'u */
  "e2e.create.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.create.escrow_body": "Bu kurulumda anahtar emaneti (escrow) açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir. Escrow sunucu kurulurken sabitlenir; bir klasör için kapatılamaz.",
  "e2e.locked.use_recovery": "Parolayı mı kaybettiniz? Kurtarma anahtarı kullanın",
  "e2e.recovery.title": "Kurtarma anahtarınızı saklayın",
  "e2e.recovery.title_upgraded": "Kurtarma anahtarınız",
  "e2e.recovery.lead": "Bu anahtar klasörü parolasız açar. Yalnız bir kez gösterilir — filex bu anahtarı saklamaz ve bir daha gösteremez.",
  "e2e.recovery.lead_upgraded": "Bu klasörün artık bir kurtarma anahtarı var. Klasörü parolasız açar, yalnız bir kez gösterilir ve filex'te kopyası kalmaz.",
  "e2e.recovery.copy": "Kopyala",
  "e2e.recovery.copied": "Kopyalandı",
  "e2e.recovery.download": "Dosya olarak indir",
  "e2e.recovery.warn_title": "BUNU PAROLA GİBİ SAKLAYIN",
  "e2e.recovery.warn_body": "Bu anahtarı eline geçiren herkes klasörü okuyabilir. Parolanızdan ayrı bir yerde tutun — parolanın yanında duran bir anahtar sizi unutmaya karşı korur, başkasına karşı değil.",
  "e2e.recovery.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.recovery.escrow_body": "Bu kurulumda anahtar emaneti açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir.",
  "e2e.recovery.escrow_kid": "Emanet anahtarı",
  "e2e.recovery.ack": "Bu anahtarı güvenli bir yere kaydettim.",
  "e2e.recovery.done": "Tamam",
  "e2e.recover.title": "Parolasız kilit açma",
  "e2e.recover.none": "Bu klasör kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden anahtarı yok. Tek giriş yolu parolası. Bir kez parolayla açın, filex kurtarma anahtarı eklemeyi önerecek.",
  "e2e.recover.tab_recovery": "Kurtarma anahtarı",
  "e2e.recover.tab_escrow": "Emanet anahtarı",
  "e2e.recover.recovery_hint": "Klasör oluşturulurken bir kez gösterilen anahtar.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "Klasörün sahibine haber gidecek",
  "e2e.recover.escrow_warn_body": "Emanet anahtarıyla açılan klasörün sahibine bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.recover.escrow_kid": "Emanet anahtarı",
  "e2e.recover.escrow_predates": "Bu kurulumun emanet anahtarı var ama bu klasörün yok. Klasör, emanet burada açılmadan önce oluşturulmuş; ana anahtarı emanet kimliğine hiç sarmalanmadı. Emanet anahtarı bu klasörü açmaz. İşletmecinin yapabileceği hiçbir şey bunu değiştirmez — sarmalama için klasörün parolası gerekir ve sunucu onu hiçbir zaman görmedi. Klasörün sahibi verebilir: parolayla kilidi açıp işletmeciye anahtar vermeyi seçebilir. O yapılana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.escrow_other_key": "Bu klasör BAŞKA bir kurulumun emanet anahtarını taşıyor. Başka yerde oluşturulup buraya geri yüklenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz. Yalnızca sarmalandığı emanet anahtarının özel yarısı açabilir.",
  "e2e.recover.escrow_placeholder": "Emanet özel anahtarını yapıştırın (PKCS#8, base64 ya da PEM)",
  "e2e.recover.bad_format": "Bu bir kurtarma anahtarına benzemiyor. Dörtlü sekiz grup, toplam 32 karakter olmalı.",
  "e2e.recover.escrow_required": "Emanet özel anahtarını yapıştırın.",
  "e2e.recover.wrong_recovery": "Bu kurtarma anahtarı bu klasörü açmıyor.",
  "e2e.recover.wrong_escrow": "Bu emanet anahtarı bu klasörü açmıyor. Escrow açılmadan önce oluşturulmuş klasörlerin emanet anahtarı yoktur ve sonradan da eklenemez.",
  "e2e.recover.bad_escrow_key": "Bu okunabilir bir özel anahtar değil (PKCS#8, base64 ya da PEM bekleniyor).",
  "e2e.recover.notify_failed": "Klasör sahibine bildirim gönderilemedi, bu yüzden kilit açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.recover.recovery_done": "Kurtarma anahtarıyla açıldı",
  "e2e.recover.escrow_done": "Emanet anahtarıyla açıldı — klasör sahibine bildirildi",
  "e2e.recover.unlock": "Kilidi aç",
  "e2e.recover.busy": "Açılıyor…",
  "e2e.escrowoffer.title": "İşletmeciye bu klasörün anahtarı verilsin mi?",
  "e2e.escrowoffer.body": "Bu klasör, burada anahtar emaneti açılmadan önce oluşturulmuş; bu yüzden kurulumun işletmecisi onu açamıyor. Şu anda — parolanız bellekteyken — filex bu klasörü emanet anahtarına sarmalayabilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz; yalnızca anahtar dosyası değişir.",
  "e2e.escrowoffer.consequence": "Bunun anlamı: işletmeci, parolanız olmadan bu klasöre giren ikinci ve kalıcı bir yol kazanır. O anahtar kullanıldığında size bildirim gelir, ama bu bildirim bir denetim değil yalnızca bir duyurudur.",
  "e2e.escrowoffer.learn_more": "Emanet anahtarı neyi yapar, neyi yapamaz",
  "e2e.escrowoffer.password_label": "Klasör parolası",
  "e2e.escrowoffer.password_required": "Klasör parolasını girin.",
  "e2e.escrowoffer.wrong_password": "Bu, bu klasörün parolası değil.",
  "e2e.escrowoffer.accept": "İşletmeciye anahtar ver",
  "e2e.escrowoffer.decline": "Hayır, bende kalsın",
  "e2e.escrowoffer.cancel": "Vazgeç",
  "e2e.escrowoffer.busy": "Sarmalanıyor…",
  "e2e.escrowoffer.done": "İşletmeci artık bu klasörü emanet anahtarıyla açabilir",
  "e2e.escrowoffer.declined_toast": "Sizde kaldı. filex bu klasör için bir daha sormayacak.",
  "e2e.escrowoffer.decline_failed": "Cevabınız kaydedilemedi, bu yüzden filex bir dahakine yine soracak. Klasörde hiçbir şey değişmedi.",
  "e2e.escrowoffer.failed": "İşletmeciye bu klasörün anahtarı verilemedi",
  "e2e.escrowoffer.strip_action": "Emanet anahtarı…",
  "e2e.upgrade.title": "Bu klasörün kurtarma anahtarı yok",
  "e2e.upgrade.body": "Kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden tek giriş yolu parolası. Şu anda — ve yalnız şu anda, parola bellekteyken — filex bir tane ekleyebilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz.",
  "e2e.upgrade.escrow_note": "Not: bu kurulumda anahtar emaneti açık; kurtarma anahtarı eklemek aynı zamanda işletmecinin bu klasörü parolanız olmadan açabilmesi demektir.",
  "e2e.upgrade.accept": "Kurtarma anahtarı oluştur",
  "e2e.upgrade.decline": "Şimdi değil",
  "e2e.upgrade.busy": "Oluşturuluyor…",
  "e2e.upgrade.failed": "Bu klasöre kurtarma anahtarı eklenemedi",
  "e2e.download.failed": "Şifreli dosya indirilemedi.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Depo bağlantıları",
  "conn.subtitle": "{host} sunucusunu bir arka uca bağlayın ya da kendi bilgisayarınızı {host} sunucusuna bağlayın.",
  "conn.close": "Kapat",
  "conn.tab.storages": "Depolar",
  "conn.tab.connect": "Nasıl bağlanılır",
  "conn.loading": "Yükleniyor…",
  "conn.visibleOnly": "bu depoya göz atabilirsiniz",
  "conn.denied.title": "Buraya depo ekleyebilen tek kişi yöneticidir",
  "conn.denied.none": "Hesabınız dosyalara göz atabilir ama bu sunucunun nereye bağlı olduğunu değiştiremez. Depo eklemek ya da düzenlemek için sunucunun yöneticisine başvurun.",
  "conn.denied.anonymous": "Bu sunucuda oturum açmış değilsiniz.",
  "conn.denied.unreachable": "Sunucu yanıt vermedi: {error}",
  "conn.denied.guideHint": "Zaten görebildiğiniz depolara kendi bilgisayarınızdan bağlanmak için yönetici yetkisi gerekmez.",
  "conn.denied.guideCta": "Nasıl bağlanacağımı göster",
  "conn.list.count": "{n} depo",
  "conn.list.count_one": "{n} depo",
  "conn.list.add": "Depo ekle",
  "conn.list.empty": "Henüz yapılandırılmış depo yok. Bir tane ekleyin, dosyalar dosya yöneticisinde görünsün.",
  "conn.list.edit": "Düzenle",
  "conn.list.remove": "Kaldır",
  "conn.list.confirm": "Gerçekten kaldırılsın mı?",
  "conn.list.readOnly": "salt okunur",
  "conn.list.disabled": "kapalı",
  "conn.form.newTitle": "Yeni depo",
  "conn.form.editTitle": "“{name}” düzenleniyor",
  "conn.form.name": "Görünen isim",
  "conn.form.namePlaceholder": "fotograflar",
  "conn.form.nameHelp": "Bu deponun her yerdeki adı: dosya yöneticisinde, yollarda (isim://klasor) ve WebDAV adreslerinde.",
  "conn.form.driver": "Tür",
  "conn.form.driverLocked": "Bir deponun türü oluşturulduktan sonra değiştirilemez — yollar zaten ona işaret ediyor.",
  "conn.form.readOnly": "Salt okunur (bu depoya hiçbir şey yazılamaz)",
  "conn.form.enabled": "Etkin",
  "conn.form.test": "Bağlantıyı sına",
  "conn.form.testing": "Sınanıyor…",
  "conn.form.testOk": "Bağlandı. Kökte {count} öğe var.",
  "conn.form.testOk_one": "Bağlandı. Kökte {count} öğe var.",
  "conn.form.testFail": "Bağlanılamadı: {error}",
  "conn.form.save": "Kaydet",
  "conn.form.saving": "Kaydediliyor…",
  "conn.form.cancel": "Vazgeç",
  "conn.form.nameRequired": "Depoya bir isim verin.",
  "conn.form.fillRequired": "* ile işaretli alanları doldurun.",
  "conn.form.required": "Zorunlu",
  "conn.form.advanced": "Gelişmiş ayarlar",
  "conn.form.noFields": "Bu sunucu bu sürücü için hiçbir ayar tanımlamadı.",
  "conn.form.reveal": "Göster",
  "conn.form.hide": "Gizle",
  "conn.guide.protocol": "Protokol",
  "conn.guide.storage": "Depo",
  "conn.guide.allStorages": "Tüm depolar",
  "conn.guide.copy": "Kopyala",
  "conn.guide.copied": "Kopyalandı",
  "conn.guide.goodToKnow": "Bilmekte fayda var",
  "conn.guide.userPlaceholder": "eposta@ornek.com",
  "conn.guide.secretPlaceholder": "parolaniz-ya-da-token",
  "conn.guide.fact.url": "Adres",
  "conn.guide.fact.urlRootHint": "Görebildiğiniz her depo bu adresin altında bir klasör olarak görünür.",
  "conn.guide.fact.urlStorageHint": "Doğrudan “{storage}” deposunu bağlar. Son parçayı silerseniz tüm depoları görürsünüz.",
  "conn.guide.fact.user": "Kullanıcı adı",
  "conn.guide.fact.password": "Parola",
  "conn.guide.webdav.summary": "WebDAV, filex’i bir sürücü gibi bağlar: Windows Gezgini, macOS Finder, Linux, rclone ve Cyberduck bu protokolü konuşur ve yapılan her değişiklik filex’e yansır.",
  "conn.guide.webdav.userHint": "filex hesabınızın e-posta adresi — görünen adınız değil.",
  "conn.guide.webdav.passwordHint": "Hesap parolanız ya da bir API token (Ayarlar → API token). İki adımlı doğrulaması açık bir hesap ZORUNLU olarak token kullanır: Basic kimlik doğrulamasında ikinci adım için yer yoktur.",
  "conn.guide.webdav.win.s1": "Dosya Gezgini’ni açın, Bu bilgisayar’a sağ tıklayın ve “Ağ sürücüsü bağla…” deyin.",
  "conn.guide.webdav.win.s2": "Bir sürücü harfi seçin ve klasör olarak {url} adresini girin.",
  "conn.guide.webdav.win.s3": "“Farklı kimlik bilgileri kullanarak bağlan” kutusunu işaretleyin ve yukarıdaki kullanıcı adı/parola ile girin.",
  "conn.guide.webdav.win.cmdCaption": "Komut İstemi (sihirbaz olmadan aynı iş)",
  "conn.guide.webdav.win.limits": "Windows’un tam olarak filex hatası gibi görünen üç yerleşik sınırı vardır: aktarımlar ~47,7 MB’ta durur, yaklaşık bin dosyalı klasörler açılmaz (“Disk biçimlendirilmemiş”) ve her iki ayarı değiştirdikten sonra WebClient hizmeti yeniden başlatılmalıdır.",
  "conn.guide.webdav.win.regCaption": "Yönetici olarak çalıştırın, sonra sürücüyü yeniden bağlayın",
  "conn.guide.webdav.win.https": "HTTPS zorunludur. Windows Basic kimlik bilgilerini yalnızca TLS üzerinden gönderir; düz http:// üzerinde hiçbir açıklama vermeden reddeder. BasicAuthLevel değerini 2 yapmayın — TLS kullanın.",
  "conn.guide.webdav.win.persist": "Bağlanan sürücü oturum kapatmayı atlatamaz: Windows 7’den beri Basic kimlik bilgileri Kimlik Bilgisi Yöneticisi’nde saklanamaz ve /persistent:yes bunu değiştirmez. Kendiliğinden geri gelsin istiyorsanız komutu bir oturum açma betiğinden yeniden çalıştırın.",
  "conn.guide.webdav.win.service": "Hiç bağlanamıyorsa WebClient hizmetinin çalıştığından emin olun: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "Finder’da Git → Sunucuya Bağlan… (⌘K) yolunu izleyin.",
  "conn.guide.webdav.mac.s2": "{url} adresini girip bağlanın.",
  "conn.guide.webdav.mac.s3": "Yukarıdaki kullanıcı adı ve parolayla kimliğinizi doğrulayın.",
  "conn.guide.webdav.mac.note": "Sürücü Konumlar altında görünür; her depo en üst düzeyde bir klasördür.",
  "conn.guide.webdav.linux.mountCaption": "davfs2 ya da masaüstü dosya yöneticisi (GNOME Dosyalar, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "ya da bu adresi GNOME Dosyalar / Dolphin icine yapistirin",
  "conn.guide.webdav.linux.locks": "davfs2 için kilitler kapatılmalıdır. filex WebDAV kilitlerini süreç belleğinde tutar; yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar — davfs2 tersini varsayar ve takılır.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone parolayı gizlenmiş biçimde saklar — önce bunu çalıştırıp çıktısını aşağıya yapıştırın",
  "conn.guide.webdav.rclone.passPlaceholder": "<rclone obscure çıktısı>",
  "conn.guide.webdav.rclone.useCaption": "Kullanımı",
  "conn.guide.webdav.duck.s1": "Yeni Yer İmi → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Sunucu {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Yol {path}.",
  "conn.guide.webdav.duck.s4": "Kullanıcı adı {user}, parola yukarıdaki gibi.",
  "conn.guide.webdav.note.delete": "WebDAV üzerinden silme kalıcıdır. Web arayüzü dosyaları filex çöp kutusuna taşır; istemciden silme ise nesneyi doğrudan arka uçtan kaldırır.",
  "conn.guide.webdav.note.locks": "Kilitler sunucu belleğinde durur: yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar. Windows ile Office’i memnun etmek için varlar, eşzamanlı düzenlemeyi hakemlemek için değil.",
  "conn.guide.webdav.note.permissions": "Web arayüzünde ne görüyorsanız burada da onu görürsünüz. Kök yalnızca açabildiğiniz depoları listeler; yetkiniz dışındaki bir yol 403 değil 404 döner, böylece ağaç neyin var olduğunu sızdırmaz.",
  "conn.guide.webdav.note.http": "Bu sunucuya düz http:// ile erişiliyor. Windows kimlik bilgilerinizi hiç göndermez, diğer tüm istemciler ise parolanızı açık metin olarak yollar. Bağlamadan önce filex’i TLS arkasına alın.",
  // ── S3 ucu: anahtarlar ve rehber ─────────────────────────────────
  "conn.s3keys.title": "S3 erişim anahtarları",
  "conn.s3keys.lead": "Bir erişim anahtarı, S3 konuşan her istemcinin — rclone, restic, AWS CLI, mc, s3fs, Cyberduck — filex’e bağlanmasını sağlar. Anahtar sizin yetkinizi taşır, bir fazlasını değil.",
  "conn.s3keys.disabled": "Bu sunucuda S3 ucu kapalı (FILEX_S3). Burada üretilen anahtar, yönetici ucu tekrar açana kadar bağlanmaz.",
  "conn.s3keys.cannotMint": "Erişim anahtarı üretebilecek bir hesapla oturum açmış değilsiniz. Aşağıdaki talimatlar yine geçerli — bir anahtar isteyip yapıştırmanız yeter.",
  "conn.s3keys.label": "Ne için? (dizüstü yedeği, CI, …)",
  "conn.s3keys.defaultLabel": "erişim anahtarı",
  "conn.s3keys.everyBucket": "Görebildiğim tüm kovalar",
  "conn.s3keys.prefix": "Kova içindeki klasör (isteğe bağlı)",
  "conn.s3keys.mint": "Anahtar oluştur",
  "conn.s3keys.inheritNote": "Bir anahtar sahip olduğunuz yetkiyi yalnızca DARALTABİLİR: yetkileriniz, kiracınız, rolünüz. Anahtarı tek bir kovaya ya da klasöre kısıtlamak, bir dizüstü yedeği ile her şeyi okuyabilen bir kimlik arasındaki farktır.",
  "conn.s3keys.once": "Gizli anahtarı şimdi kopyalayın — bir daha gösterilmeyecek.",
  "conn.s3keys.accessKeyID": "Erişim anahtarı kimliği",
  "conn.s3keys.secret": "Gizli anahtar",
  "conn.s3keys.dismiss": "Kopyaladım",
  "conn.s3keys.col.label": "Etiket",
  "conn.s3keys.col.key": "Erişim anahtarı kimliği",
  "conn.s3keys.col.scope": "Kapsam",
  "conn.s3keys.col.lastUsed": "Son kullanım",
  "conn.s3keys.scopeAll": "görebildiğiniz her şey",
  "conn.s3keys.noLabel": "(etiketsiz)",
  "conn.s3keys.neverUsed": "hiç",
  "conn.s3keys.enable": "Aç",
  "conn.s3keys.disable": "Kapat",
  "conn.s3keys.revoke": "İptal et",
  "conn.s3keys.confirm": "Emin misiniz?",
  "conn.s3keys.empty": "Henüz erişim anahtarı yok.",
  "conn.guide.s3.summary": "S3 ucu, S3 konuşan her şeyin — yedekleme, senkron araçları, SDK’lar — hedefi olarak filex’i kullanmanızı sağlar; hem de zaten sahip olduğunuz depolarla.",
  "conn.guide.s3.keyPlaceholder": "yukarıdan bir anahtar oluşturun",
  "conn.guide.s3.secretPlaceholder": "anahtarı oluştururken bir kez gösterilir",
  "conn.guide.s3.fact.endpoint": "Uç adresi",
  "conn.guide.s3.fact.endpointHint": "İstemciyi buraya yöneltin, filex’in web adresine değil.",
  "conn.guide.s3.fact.bucket": "Kova",
  "conn.guide.s3.fact.bucketHint": "Kova = filex deposu. Kovaları istemci değil yönetici oluşturur.",
  "conn.guide.s3.fact.key": "Erişim anahtarı kimliği",
  "conn.guide.s3.fact.keyHint": "Genel yarısı; her istekte gider.",
  "conn.guide.s3.fact.secret": "Gizli anahtar",
  "conn.guide.s3.fact.secretHint": "Yalnızca anahtar oluşturulurken bir kez gösterilir. filex bir daha gösteremez — kaybolduysa yeni anahtar üretin.",
  "conn.guide.s3.fact.region": "Bölge",
  "conn.guide.s3.fact.regionHint": "filex’te bölge yok; hangi değeri verirseniz aynen geri döner. Yine de istemciler bir değer ister.",
  "conn.guide.s3.fact.addressing": "Adresleme",
  "conn.guide.s3.fact.pathStyle": "yol tabanlı (zorunlu)",
  "conn.guide.s3.fact.pathStyleHint": "Bu kurulumda S3’e ayrılmış bir alan adı yok, yani kova.host çözülmez.",
  "conn.guide.s3.fact.virtualHosted": "sanal-host ya da yol tabanlı",
  "conn.guide.s3.fact.virtualHostedHint": "Bu kurulumun kendi S3 alan adı var, iki adresleme de çalışır.",
  "conn.guide.s3.rclone.useCaption": "Kullanımı",
  "conn.guide.s3.rclone.mtime": "filex dosyanın değişiklik zamanını taşır (x-amz-meta-mtime); böylece rclone sync ilk turdan sonra oturur, her seferinde her şeyi yeniden yüklemez.",
  "conn.guide.s3.aws.configureCaption": "Bir kez ayarlayın",
  "conn.guide.s3.aws.useCaption": "Kullanımı",
  "conn.guide.s3.aws.pathStyle": "AWS yapılandırmanıza yol tabanlı adreslemeyi ekleyin; yoksa her komut DNS aşamasında düşer.",
  "conn.guide.s3.restic.envCaption": "Ortam değişkenleri",
  "conn.guide.s3.restic.useCaption": "Yedekle, doğrula, buda",
  "conn.guide.s3.restic.verified": "Bu uca karşı ölçüldü: restic check --read-data her pack’i bayt bayt okuyor ve hata bulmuyor.",
  "conn.guide.s3.mc.aliasCaption": "Takma adı ekleyin",
  "conn.guide.s3.mc.useCaption": "Kullanımı",
  "conn.guide.s3.s3fs.credsCaption": "Kimlik dosyası",
  "conn.guide.s3.s3fs.mountCaption": "Bağlayın",
  "conn.guide.s3.s3fs.note": "s3fs üzerinden bir dosyayı düzenlemek nesnenin tamamını yeniden yazar; silme ise filex çöpüne gider. Paylaşılan bir klasör için iyi, veritabanı için değil.",
  "conn.guide.s3.duck.s1": "Yeni yer imi → Amazon S3.",
  "conn.guide.s3.duck.s2": "Sunucu: {host}.",
  "conn.guide.s3.duck.s3": "Erişim anahtarı kimliği: {key}, gizli anahtar yukarıdaki.",
  "conn.guide.s3.duck.s4": "Yer imini açın; kovalar sizin filex depolarınızdır.",
  "conn.guide.s3.duck.pathStyle": 'Tercihler → S3 altında "Use virtual host style" seçeneğini KAPATIN — bu kurulumda joker S3 alan adı yok.',
  "conn.guide.s3.sdk.note": "SigV4 konuşan her istemci aynı şekilde çalışır: uç adresi, anahtar, gizli anahtar ve bu kurulumun kendi S3 alan adı yoksa yol tabanlı adresleme.",
  "conn.guide.s3.note.buckets": "Kova = filex deposu. İstemci kovanın İÇİNDE klasör ve nesne oluşturabilir, ama kovanın kendisini oluşturamaz: kova bir sürücü ve bir yol ister, bunu bir S3 isteği ifade edemez.",
  "conn.guide.s3.note.permissions": 'Anahtar tam olarak sizin gördüğünüzü görür. Açamayacağınız bir kova "yasak" değil "böyle bir kova yok" der; böylece uç, neyin var olduğunu sızdırmaz.',
  "conn.guide.s3.note.trash": "Silme her yerdeki gibi filex çöpüne gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.s3.note.mtime": "Yüklemeler değişiklik zamanını taşır; istemcinin gönderdiği sağlama toplamları (Content-MD5, x-amz-checksum-*) doğrulanır — bozulmuş bir yükleme saklanmaz, reddedilir.",
  "conn.guide.s3.note.pathStyle": "Bu kurulumda S3’e ayrılmış alan adı yok; istemcilere yol tabanlı adresleme söylenmeli. Söylenmezse güncel bir SDK, ne filex’i ne de sebebi anan bir DNS hatasıyla düşer.",
  "conn.guide.s3.note.http": "Bu uç düz http://. İmzalar isteği yine korur ama nesneler açık metin gider. Bir yedeği buraya yöneltmeden önce filex’i TLS arkasına alın.",
  // ── SFTP ucu: anahtarlar ve rehber ───────────────────────────────
  "conn.sshkeys.title": "SSH anahtarları",
  "conn.sshkeys.lead": "Bir açık anahtar kaydedin; SSH konuşan her istemci — sftp, scp, WinSCP, FileZilla, rclone, sshfs — parolanızı göndermeden bağlansın.",
  "conn.sshkeys.disabled": "Bu sunucuda SFTP ucu kapalı (FILEX_SFTP). Burada kaydedilen anahtar, yönetici ucu açana kadar bağlanmaz.",
  "conn.sshkeys.cannotAdd": "Anahtar kaydedebilecek bir hesapla oturum açmış değilsiniz.",
  "conn.sshkeys.paste": "~/.ssh/id_ed25519.pub dosyasının içeriğini yapıştırın",
  "conn.sshkeys.name": "Ad (isteğe bağlı — boşsa anahtarın kendi yorumu kullanılır)",
  "conn.sshkeys.add": "Anahtar ekle",
  "conn.sshkeys.noCopyId": "ssh-copy-id burada çalışamaz: kabuk üzerinden ~/.ssh/authorized_keys dosyasına ekler, filex’in kabuğu yoktur. Giriş yolu bu kutudur.",
  "conn.sshkeys.col.name": "Ad",
  "conn.sshkeys.col.fingerprint": "Parmak izi",
  "conn.sshkeys.col.added": "Eklendi",
  "conn.sshkeys.col.lastUsed": "Son kullanım",
  "conn.sshkeys.noName": "(adsız)",
  "conn.sshkeys.neverUsed": "hiç",
  "conn.sshkeys.enable": "Aç",
  "conn.sshkeys.disable": "Kapat",
  "conn.sshkeys.remove": "Sil",
  "conn.sshkeys.confirm": "Emin misiniz?",
  "conn.sshkeys.empty": "Henüz anahtar yok. Anahtarsız istemciler hesap parolanızla giriş yapar.",
  "conn.guide.sftp.summary": "SFTP, filex’i SSH konuşan her şeyin erişebileceği hâle getirir: bir yedekleme işi, bir tarayıcı, WinSCP, rclone ya da bağlanmış bir klasör.",
  "conn.guide.sftp.fact.host": "Sunucu",
  "conn.guide.sftp.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Ne 22 ne 443: SFTP ham TCP’dir, web vekilinin içinden geçemez.",
  "conn.guide.sftp.fact.userHint": "Kısa giriş adınız. Giriş adındaki @ işareti çoğu istemcinin ayar dosyasında tırnaklanmak zorundadır; bu alan tam da onu ortadan kaldırır.",
  "conn.guide.sftp.fact.auth": "Giriş yöntemi",
  "conn.guide.sftp.fact.authKey": "kayıtlı SSH anahtarınız (ya da parolanız)",
  "conn.guide.sftp.fact.authPassword": "hesap parolanız — ya da yukarıdan bir anahtar kaydedin",
  "conn.guide.sftp.fact.authHint": "API token da parola yerine geçer ve tek başına iptal edilebilir. İki adımlı doğrulaması açık bir hesap anahtar ya da token kullanmalıdır.",
  "conn.guide.sftp.fact.path": "Yol",
  "conn.guide.sftp.fact.pathHint": "İlk klasör bir depodur; kök, açabildiğiniz depoları listeler.",
  "conn.guide.sftp.openssh.connectCaption": "Bağlan, gönder, al",
  "conn.guide.sftp.openssh.noShell": "Burada kabuk yok, yalnız SFTP alt sistemi var. `ssh sunucu komut` bilerek reddedilir; scp çalışır çünkü OpenSSH 9 onun için de SFTP konuşur.",
  "conn.guide.sftp.key.tab": "Anahtar kurulumu",
  "conn.guide.sftp.key.s1": "Bağlanacak makinede bir anahtar çifti üretin (zaten varsa atlayın).",
  "conn.guide.sftp.key.s2": "AÇIK yarısını kopyalayın — .pub dosyası, asla diğeri değil.",
  "conn.guide.sftp.key.s3": "Yukarıdaki kutuya yapıştırıp bağlanın; o andan sonra parola gönderilmez.",
  "conn.guide.sftp.key.genCaption": "Kendi makinenizde",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id filex’e karşı ÇALIŞMAZ: ~/.ssh/authorized_keys dosyasına eklemek için kabuğa ihtiyacı var, filex’te kabuk yok. Anahtarı yukarıdan yapıştırın.",
  "conn.guide.sftp.winscp.s1": "Yeni site → Dosya protokolü: SFTP.",
  "conn.guide.sftp.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "Kullanıcı adı: {user}. Anahtar için: Gelişmiş → SSH → Kimlik Doğrulama → özel anahtar dosyası.",
  "conn.guide.sftp.winscp.s4": "WinSCP .ppk biçiminde özel anahtar ister — OpenSSH anahtarını kendi aracıyla (Araçlar → PuTTYgen) bir kez dönüştürün.",
  "conn.guide.sftp.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "Kullanıcı: {user}. Giriş türü: parola için Normal, anahtar için Anahtar dosyası.",
  "conn.guide.sftp.rclone.useCaption": "Kullanımı",
  "conn.guide.sftp.sshfs.mountCaption": "Bağla ve çöz",
  "conn.guide.sftp.sshfs.note": "Bağlanmış bir klasörde her kayıt dosyanın tamamını yeniden yazar. Belgeler için iyi; veritabanı ya da yerinde düzenlediğiniz bir video için değil.",
  "conn.guide.sftp.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.sftp.note.permissions": "İstemcinizin çizdiği izin bitleri buradaki erişim seviyenizden gelir; yani salt-okunur görünen bir dosya sizin için gerçekten öyledir.",
  "conn.guide.sftp.note.trash": "Silme her yerdeki gibi filex çöpüne gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.sftp.note.totp": "Hesabınızda iki adımlı doğrulama açıksa parola burada çalışmaz — SSH’ın kodu soracak bir kanalı yok. Bir anahtar kaydedin ya da parola yerine API token kullanın.",
  "conn.guide.sftp.note.disabled": "Bu sunucuda SFTP ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS, yalnızca FTP öğrenmiş ekipman için var: tarayıp-klasöre-atan yazıcılar, EDI muhatapları, eski laboratuvar ve endüstri yazılımları. Her zaman TLS üzerinden.",
  "conn.guide.ftps.fact.host": "Sunucu",
  "conn.guide.ftps.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "Kontrol kanalı. Veri, aşağıdaki pasif aralıktan ayrı bir porttan akar.",
  "conn.guide.ftps.fact.mode": "Şifreleme",
  "conn.guide.ftps.fact.modeValue": "FTPS — açık (explicit) TLS, zorunlu",
  "conn.guide.ftps.fact.modeHint": 'Düz FTP, parola okunmadan reddedilir. "Require explicit FTP over TLS" seçin; "plain FTP" ya da "implicit" asla.',
  "conn.guide.ftps.fact.userHint": "Kısa giriş adınız ya da e-postanız. Parola yerine API token da geçer ve tek başına iptal edilebilir.",
  "conn.guide.ftps.fact.passwordHint": "Hesap parolanız ya da bir API token. İki adımlı doğrulaması açık hesap token kullanmalıdır — FTP'nin kodu soracak bir yolu yok.",
  "conn.guide.ftps.fact.pasv": "Pasif portlar",
  "conn.guide.ftps.fact.pasvHint": "Veri bağlantıları buraya düşer. Güvenlik duvarınız bu aralığı kapatıyorsa aktarım iki tarafta da hata vermeden ASILI KALIR — FTP'nin klasik arızası budur.",
  "conn.guide.ftps.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Şifreleme: "Require explicit FTP over TLS". Giriş türü: Normal, kullanıcı: {user}.',
  "conn.guide.ftps.filezilla.s4": "Aktarım ayarları → Pasif. Bu sunucu aktif modu reddeder.",
  "conn.guide.ftps.winscp.s1": "Yeni site → Dosya protokolü: FTP, Şifreleme: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "Kullanıcı adı: {user}, parola yukarıdaki.",
  "conn.guide.ftps.curl.caption": "Gönder ve al",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd isteğe bağlı değil: curl'ün düz metne geri düşmek yerine TLS'i ZORUNLU kılmasını sağlar. Bu sunucu zaten düz metni reddediyor, ama alışkanlık sizi reddetmeyen sunuculara karşı korur.",
  "conn.guide.ftps.lftp.caption": "Bağlan",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data yalnız girişi değil DOSYAYI da şifreler. Olmazsa lftp TLS ile giriş yapar ve dosyayı açık metin gönderir — sahada en sık yapılan FTPS yanlışı budur.",
  "conn.guide.ftps.rclone.useCaption": "Kullanımı",
  "conn.guide.ftps.printer.tab": "Tarayıcı / yazıcı",
  "conn.guide.ftps.printer.s1": "Cihazın tara-ve-FTP'ye-gönder ayarlarında: sunucu {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "Kullanıcı: {user}, parola yukarıdaki. Cihaz için kendi parolanız yerine bir API token üretin — başka hiçbir şeyi değiştirmeden iptal edilebilir.",
  "conn.guide.ftps.printer.s3": "Yol: {path} — ya da önceden oluşturduğunuz bir alt klasör. Cihaz depo oluşturamaz.",
  "conn.guide.ftps.printer.s4": '"SSL/TLS" ya da "FTPS explicit" seçeneğini AÇIN ve PASİF modu seçin.',
  "conn.guide.ftps.printer.noTLS": "Tara-ve-gönder yazılımlarının önemli bir kısmı TLS konuşamıyor. Bu sunucu öyle bir cihazla konuşmayacak ve bu bilinçli: alternatifi, belgelerinizin ve parolanızın ofis ağında açık metin dolaşması.",
  "conn.guide.ftps.note.tls": "TLS zorunludur ve kapatan bir düğme yoktur. Düz FTP parolanızı açık metin gönderir, ardından dosyanızı da.",
  "conn.guide.ftps.note.passive": "Yalnızca pasif mod. Aktif modda sunucu istemciyi geri arar; bu NAT arkasında çalışmaz ve çoğu güvenlik duvarı tarafından engellenir.",
  "conn.guide.ftps.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.ftps.note.trash": "Silme her yerdeki gibi filex çöpüne gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.ftps.note.prefer": "İstemci SFTP konuşabiliyorsa onu tercih edin: tek bağlantı, tek port, pasif mod sürprizi yok.",
  "conn.guide.ftps.note.selfSigned": "Bu sunucu kendinden imzalı bir sertifika kullanıyor. Kanalı şifreler ama karşı tarafın kim olduğunu kanıtlamaz; çoğu istemci bir kez onay ister. Önemli bir iş için gerçek sertifika koyun.",
  "conn.guide.ftps.note.disabled": "Bu sunucuda FTPS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS export'ları",
  "conn.nfs.lead": "Bir export, ağınızdaki bir makinenin filex'i sürücü olarak bağlamasını sağlar — medya oynatıcı, derleme sunucusu, yedek kutusu.",
  "conn.nfs.pathIsSecret": "⚠ Export yolu PAROLANIN TA KENDİSİDİR. NFS, Kerberos olmadan istemciye kim olduğunu soramaz; bu yüzden filex yola 32 rastgele bayt koyar: yolu bilen sizin adınıza bağlanır. Bağlama satırını bir kimlik bilgisi gibi saklayın — /etc/fstab çoğu sistemde herkes tarafından okunabilir.",
  "conn.nfs.disabled": "Bu sunucuda NFS ucu kapalı (FILEX_NFS). Burada oluşturulan export, yönetici ucu açana kadar bağlanmaz.",
  "conn.nfs.cannotMint": "Export oluşturabilecek bir hesapla oturum açmış değilsiniz.",
  "conn.nfs.label": "Ne için? (medya oynatıcı, yedek kutusu, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Görebildiğim tüm depolar",
  "conn.nfs.prefix": "Depo içindeki klasör (isteğe bağlı)",
  "conn.nfs.allowCidrs": "İzinli adresler, örn. 192.168.1.0/24 (isteğe bağlı)",
  "conn.nfs.readOnly": "Salt okunur",
  "conn.nfs.readOnlyHint": "Bir makine için güvenli varsayılan salt okunurdur: sizin yetkiniz ne olursa olsun bu bağlantı üzerinden her yazmayı reddeder. Adres listesi daha da daraltır — listenin dışından gelen bağlanamaz.",
  "conn.nfs.mint": "Export oluştur",
  "conn.nfs.once": "Şimdi kopyalayın — yol yalnızca bir kez gösterilir ve geri alınamaz.",
  "conn.nfs.dismiss": "Kopyaladım",
  "conn.nfs.col.label": "Etiket",
  "conn.nfs.col.scope": "Kapsam",
  "conn.nfs.col.mode": "Mod",
  "conn.nfs.col.lastUsed": "Son bağlanma",
  "conn.nfs.scopeAll": "görebildiğiniz her şey",
  "conn.nfs.modeRead": "salt okunur",
  "conn.nfs.modeWrite": "okuma/yazma",
  "conn.nfs.noLabel": "(etiketsiz)",
  "conn.nfs.neverUsed": "hiç",
  "conn.nfs.enable": "Aç",
  "conn.nfs.disable": "Kapat",
  "conn.nfs.revoke": "İptal et",
  "conn.nfs.confirm": "Emin misiniz?",
  "conn.nfs.empty": "Henüz export yok.",
  "conn.guide.nfs.summary": "NFS, filex'i kendi ağınızdaki bir makinede sürücü olarak bağlar — NAS protokolü, onu bekleyen cihazlar için.",
  "conn.guide.nfs.pathPlaceholder": "yukarıdan bir export oluşturun",
  "conn.guide.nfs.fact.host": "Sunucu",
  "conn.guide.nfs.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Hem port= hem mountport= buna ayarlanmalı; filex mount ve NFS servislerini tek portta veriyor.",
  "conn.guide.nfs.fact.export": "Export yolu",
  "conn.guide.nfs.fact.exportHint": "Kimlik bilgisi budur. Export oluşturulurken bir kez gösterilir ve hash'li saklanır — filex bir daha gösteremez.",
  "conn.guide.nfs.fact.options": "Bağlama seçenekleri",
  "conn.guide.nfs.fact.optionsHint": "nolock, çünkü filex NFS kilit yöneticisini çalıştırmıyor; nfsvers=3, çünkü bu sunucunun konuştuğu sürüm bu.",
  "conn.guide.nfs.linux.mountCaption": "Bağla",
  "conn.guide.nfs.linux.fstabSecret": "Bu yolu içeren bir /etc/fstab satırı, herkesin okuyabildiği bir dosyadaki paroladır. Ortamınızda önemliyse kimlik korumalı automount kullanın ya da bağlamayı yalnız root'un okuyabildiği bir unit dosyasında tutun.",
  "conn.guide.nfs.mac.mountCaption": "Bağla",
  "conn.guide.nfs.mac.resvport": "macOS resvport ister: istemcisi ayrıcalıklı bir kaynak portta ısrar eder ve olmadan bağlantıyı reddeder.",
  "conn.guide.nfs.win.s1": `Windows Özellikleri'nden "Services for NFS" → "Client for NFS" bileşenini açın (yalnız Pro ve Enterprise; Home'da yok).`,
  "conn.guide.nfs.win.s2": "Komut İstemi'ni yönetici olarak açın.",
  "conn.guide.nfs.win.s3": "Aşağıdaki komutla export'u bir sürücü harfine bağlayın.",
  "conn.guide.nfs.win.cmdCaption": "Z: sürücüsüne bağla",
  "conn.guide.nfs.win.port": "Windows'un mount servisinin portunu söyleme imkânı yok; yalnızca standart 2049 portundaki bir NFS sunucusuna erişebilir. Bu sunucu başka bir porttaysa SFTP'yi ya da filex masaüstü uygulamasını kullanın.",
  "conn.guide.nfs.nas.tab": "NAS / medya oynatıcı",
  "conn.guide.nfs.nas.s1": "Cihazın NFS ayarlarında: sunucu {host}, port {port} (ayrı ayrı soruyorsa hem NFS hem mount portunu ayarlayın).",
  "conn.guide.nfs.nas.s2": "Uzak yol: yukarıdaki export yolu, birebir.",
  "conn.guide.nfs.nas.s3": "NFS sürüm 3, kilitleme kapalı. Cihazın gerçekten yazması gerekmiyorsa export'u salt okunur oluşturun.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 şifreli değildir. Trafiği okuyabilen dosyalarınızı görür, yolu öğrenen bağlanabilir. Ev/ofis ağında ya da VPN üzerinden kullanın — internet üzerinden asla.",
  "conn.guide.nfs.note.pathIsSecret": "Export yolu kimlik bilgisinin tamamıdır. Sızarsa yukarıdaki listeden iptal edin; değiştirilecek başka bir şey yok.",
  "conn.guide.nfs.note.noPortmapper": "111 portunda portmapper yok; portu söylenmeyen istemci sunucuyu bulamaz. Buradaki her komutun port= ve mountport= taşımasının sebebi bu.",
  "conn.guide.nfs.note.uid": "İstemcinizin gönderdiği kullanıcı ve grup kimlikleri yok sayılır: bağlantı zaten kime ait olduğunu biliyor. Gördüğünüz izinler filex'teki erişiminizden gelir.",
  "conn.guide.nfs.note.trash": "Silme her yerdeki gibi filex çöpüne gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.nfs.note.revoke": "İptal anında değil, bir sonraki istekte etkili olur: NFS'te sonlandırılacak bir oturum yok, bağlantısı açık olan istemci sıradaki işleminde hata alır.",
  "conn.guide.nfs.note.disabled": "Bu sunucuda NFS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  "conn.tokens.title": "API jetonları",
  "conn.tokens.lead": "FTPS, WebDAV ve filex mount hesap parolanız yerine bir jetonla giriş yapar. Buradan üretin — tek başına iptal edilebilir, ayrıca iki adımlı doğrulaması açık bir hesap bunlarda parolasını zaten kullanamaz.",
  "conn.tokens.mint": "Jeton oluştur",
  "conn.tokens.once": "Şimdi kopyalayın — yalnızca bir kez gösterilir. Sunucuda yalnız özeti saklandığı için bir daha gösterilemez.",
  "conn.tokens.dismiss": "Kopyaladım",
  "conn.tokens.cannotMint": "Bu oturum jeton üretemiyor. Kendi hesabınızla giriş yapıp oluşturun.",
  "conn.tokens.empty": "Henüz jeton yok.",
  "conn.tokens.neverUsed": "hiç",
  "conn.tokens.revoke": "İptal et",
  "conn.tokens.confirm": "Emin misin?",
  "conn.tokens.col.label": "Ad",
  "conn.tokens.col.scopes": "Yetkisi",
  "conn.tokens.col.used": "Son kullanım",
  "conn.tokens.revokeHint": "İptal, yalnız bir sonraki girişi değil AÇIK bağlantıyı da durdurur: SFTP ya da FTPS oturumu kesilir, bağlı bir sürücü yarım dakika içinde çalışmayı bırakır.",
  "conn.guide.mount.summary": "filex mount, uzaktaki bir filex sunucusunu bu makinede bir klasöre bağlar — tarayıcının kullandığı aynı HTTPS üzerinden. Buradakilerin her yerden çalışan tek yöntemi: yerel ağ da gerekmez, ek sunucu da, üçüncü parti bir istemci de.",
  "conn.guide.mount.fact.url": "Sunucu adresi",
  "conn.guide.mount.fact.urlHint": "Tarayıcıda kullandığınız adresin aynısı. Başka hiçbir şeye erişilebilir olması gerekmez.",
  "conn.guide.mount.fact.token": "API jetonu",
  "conn.guide.mount.fact.tokenPlaceholder": "Jetonlar bölümünden oluşturun",
  "conn.guide.mount.fact.tokenHint": "Parolanız değil, jeton — tek başına iptal edilebilir, ayrıca 2FA açık bir hesap burada parolasını zaten kullanamaz.",
  "conn.guide.mount.fact.remote": "Neyi bağlayacağınız",
  "conn.guide.mount.fact.remoteHint": "--remote vermezseniz her depo bir klasör olarak görünür; tek bir depoyu — ya da onun içindeki bir klasörü — adlandırırsanız yalnızca o bağlanır.",
  "conn.guide.mount.linux.mountCaption": "Bağlayın",
  "conn.guide.mount.linux.umountCaption": "Ayırın",
  "conn.guide.mount.linux.umountWarn": "Süreci öldürerek değil, fusermount ile ayırın. Ayrılmadan ölen bir bağlantı, birileri elle fusermount çalıştırana kadar her ls komutunun asılı kaldığı bir klasör bırakır.",
  "conn.guide.mount.linux.systemdCaption": "Girişte otomatik bağlansın (systemd kullanıcı birimi)",
  "conn.guide.mount.win.winfsp": "Windows'ta bir kez WinFsp kurulması gerekiyor — ücretsiz ve açık kaynak: https://winfsp.dev. Başka bir şey gerekmiyor, sonrasında yönetici hakkı da istemiyor.",
  "conn.guide.mount.win.mountCaption": "Sürücü olarak bağlayın",
  "conn.guide.mount.win.freeLetter": "BOŞ bir sürücü harfi seçin. Harf bağlama sırasında oluşturulur, var olan bir şeye eklenmez; kullanımdaki bir harfi verirseniz bunu söylemeyen bir hatayla başarısız olur.",
  "conn.guide.mount.win.stop": "O pencerede Ctrl-C ile durdurun. Sürücü kaybolur ve bu makinede hiçbir şey kalmaz.",
  "conn.guide.mount.mac.unsupported": "filex mount macOS'ta çalışmıyor. macFUSE gerekiyor; lisansı filex gibi bir programın onu sizin yerinize kurmasına izin vermiyor ve Go bağlaması filex'in bilinçli olarak kullanmadığı bir C derleyicisi istiyor. Komut burada çalışıyormuş gibi görünüp hiçbir şey yapmak yerine açıkça reddediyor.",
  "conn.guide.mount.mac.alternatives": "macOS'ta filex masaüstü uygulamasını klasör senkronuyla kullanın (dosyalar diskte durur) ya da sürücü bağlayabilen bir istemciyle SFTP.",
  "conn.guide.mount.note.notASync": "Bu bir senkronizasyon değildir. Küçük bir okuma önbelleği dışında bu makineye hiçbir şey kopyalanmaz; yüz bin dosyanın içinden birini gerisini indirmeden açar. Dosyaları çevrimdışıyken istiyorsanız klasör senkronunu kullanın.",
  "conn.guide.mount.note.reachable": "Sunucuya, tarayıcının geçtiği hangi vekil ya da tünel varsa oradan ulaşır — çünkü altında aynı API vardır. İzinleriniz, depolarınız ve çok kiracılı bir sunucuda kiracınız da birlikte gelir.",
  "conn.guide.mount.note.wholeFileWrites": "Bağlantı üzerinden yazdığınız dosya, yazılırken değil, program onu kapattığında yüklenir. Çok büyük bir dosyayı yerinde düzenlemek burada yerel diskten yavaştır; içeri ve dışarı kopyalamak değildir.",
  "conn.guide.mount.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.mount.note.revoke": "Bir bağlantıyı durdurmak için jetonu iptal edin. Bağlantı hâlâ takılı olsa bile yarım dakika içinde hizmet vermeyi bırakır.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Yerel dosya sistemi",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "Sunucu adı olmadan yalnızca paylaşım adı: `\\\\nas\\media` değil, `media`.",
  "storages.fieldHelp.smbDomain": "Yalnızca Windows etki alanı hesabı için. NAS kullanıyorsanız boş bırakın.",
  "storages.fieldHelp.smbRoot": "Paylaşımın içindeki alt klasör. Paylaşımın tamamı için boş bırakın.",
  "storages.fields.share": "Paylaşım",
  "storages.fields.domain": "Etki alanı / çalışma grubu",
  "storages.fields.dialTimeout": "Bağlanma zaman aşımı (saniye)",
  "storages.fieldHelp.disablePresign": "Varsayılan olarak açık: yüklemeler ve herkese açık paylaşım bağlantılarındaki indirmeler filex üzerinden akar; kova endpoint'inin tarayıcıdan erişilebilir olması gerekmez (yalnız yerel ağdaki MinIO doğrudan çalışır). Yalnızca endpoint kullanıcıların tarayıcısından erişilebiliyorsa (AWS, herkese açık MinIO) ve tarayıcının kovayla doğrudan konuşmasını istiyorsanız kapatın — çok büyük dosyalarda daha hızlıdır, ama depo SDK'nın imzaladığı URL'leri kabul etmelidir (Ceph RGW / bazı Hetzner kurulumları SignatureDoesNotMatch döner).",
  "storages.fieldHelp.endpoint": "AWS S3 için boş bırakın. S3 uyumlu diğer tüm depolar kendi endpoint'ini ister.",
  "storages.fieldHelp.hostKey": "authorized_keys / known_hosts satır biçiminde tek bir açık anahtar.",
  "storages.fieldHelp.insecureSkipHostKey": "Her sunucu anahtarını kabul eder. Yalnızca geçici sunucular için.",
  "storages.fieldHelp.keyPath": "Sunucudaki anahtar dosyasının yolu; depo başlarken okunur. PEM alanı boşken kullanılır.",
  "storages.fieldHelp.knownHosts": "Katı sunucu anahtarı denetimi için OpenSSH known_hosts yolu. Varsayılan, ~/.filex/known_hosts içinde ilk bağlantıda güven.",
  "storages.fieldHelp.passive": "Kapatmak aktif moda geçirir; bu, sunucunun bu makineye geri bağlanmasını gerektirir.",
  "storages.fieldHelp.path": "Sunucudaki dizin. Yoksa oluşturulur; filex asla / dizinini mount etmez.",
  "storages.fieldHelp.pathStyle": "AWS dışındaki tüm depolarda açık olmalı. Endpoint girildiyse ve bu alana hiç dokunulmadıysa kendiliğinden açılır.",
  "storages.fieldHelp.prefix": "Bucket içindeki alt klasör. Zorunlu: filex bucket kökünün sahipliğini asla almaz.",
  "storages.fieldHelp.region": 'Boş bırakılırsa "auto" kullanılır.',
  "storages.fieldHelp.root": "Arka uçtaki alt klasör. Zorunlu: filex hesabın kökünü asla mount etmez.",
  "storages.fieldHelp.sftpAuth": "Parola ya da özel anahtardan biri zorunludur.",
  "storages.fieldHelp.tls": "Düz FTP kimlik bilgilerini açık metin gönderir — sunucu destekliyorsa açın.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Temel yol",
  "storages.fields.bucket": "Bucket",
  "storages.fields.disablePresign": "İmzalı URL'leri kapat",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Sunucu",
  "storages.fields.hostKey": "Sabitlenmiş sunucu anahtarı",
  "storages.fields.insecureSkipHostKey": "Sunucu anahtarı doğrulamasını atla (güvensiz)",
  "storages.fields.keyPath": "Özel anahtar dosyası",
  "storages.fields.knownHosts": "known_hosts dosyası",
  "storages.fields.name": "Görünen isim",
  "storages.fields.namePlaceholder": "Kişisel fotoğraflar",
  "storages.fields.passive": "Pasif mod (PASV)",
  "storages.fields.password": "Parola",
  "storages.fields.path": "Dizin yolu",
  "storages.fields.pathStyle": "Path-style URL kullan (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Önek (prefix)",
  "storages.fields.privateKey": "Özel anahtar (PEM)",
  "storages.fields.rbac": "Öğe bazlı erişim denetimi (RBAC)",
  "storages.fields.rbacHint": "Açıkken admin olmayanlar yalnızca izin panelinden kendilerine verilen dosya/klasörleri görür. Kapalıyken depo tüm kullanıcılara açıktır (yetki role göre).",
  "storages.fields.readOnly": "Salt okunur mount",
  "storages.fields.region": "Bölge",
  "storages.fields.root": "Temel yol",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (açık AUTH TLS)",
  "storages.fields.url": "Temel URL",
  "storages.fields.user": "Kullanıcı",
  /* === gezinti:g1 — gezinti paneli (SideNav) === */
  "sidenav.title": "Gezinti",
  "sidenav.views": "Görünümler",
  "sidenav.storages": "Depolar",
  "sidenav.home": "Ana sayfa",
  "sidenav.myfiles": "Dosyalarım",
  "sidenav.recent": "Son kullanılanlar",
  "sidenav.starred": "Yıldızlılar",
  "sidenav.shared": "Benimle paylaşılanlar",
  "sidenav.trash": "Çöp Kutusu",
  "sidenav.collapse": "Gezintiyi daralt",
  "sidenav.expand": "Gezintiyi genişlet",
  "sidenav.close": "Gezintiyi kapat",
  // ⚠ aç/kapat çifti ÇEKMECENİN, daralt/genişlet çifti yerleşik PANELİN —
  // ikisi birbirinin yerine kullanılamaz; bkz. en.ts'teki not ve Toolbar.vue
  // içindeki `navToggleLabel`. 560px altında panel listenin üzerine gelen bir
  // çekmecedir: raya inmez, hiç ekranda değildir; "genişlet" olmayan bir
  // genişliği büyütmeyi vaat ederdi.
  "sidenav.open": "Gezintiyi aç",
  "sidenav.storage.shared": "Paylaşılan",
  "sidenav.storage.readOnly": "Salt okunur",
  // ⚠ `toolbar.nav` KALDIRILDI, yerine bir şey konmadı — bkz. en.ts'teki not.
  // Paneli daraltan tek denetimin etiketiydi; önce "Gezinti" (panelin adı,
  // düğmenin ne yaptığını söylemiyor), sonra "Gezintiyi göster/gizle" (sabit
  // geçici çözüm). Gerçek düzeltme yukarıdaki dört `sidenav.*` fiili:
  // etiket `navOpen`'a bağlı, daraltacaksa "daralt", genişletecekse
  // "genişlet" yazıyor.
  "node.home": "Ana sayfa",
  "node.recent": "Son kullanılanlar",
  "node.starred": "Yıldızlılar",
  "node.shared": "Benimle paylaşılanlar",
  "empty.recent.title": "Henüz hiçbir şey açılmadı",
  "empty.recent.hint": "Açtığın dosyalar burada görünür",
  "empty.starred.title": "Henüz yıldızlı dosya yok",
  "empty.starred.hint": "Bir dosyayı yıldızla, burada bulasın",
  "empty.shared.title": "Seninle henüz bir şey paylaşılmadı",
  "empty.shared.hint": "Başkalarının paylaştığı klasör ve dosyalar burada görünür",
  /* etiket:t1 */
  "sidenav.tags": "Etiketler",
  "sidenav.tags.empty": "Henüz etiket yok — bir dosyaya sağ tıklayıp Etiketler’den ekleyebilirsin.",
  "sidenav.tags.more": "{count} tane daha göster",
  "sidenav.tags.less": "Daha az göster",
  "empty.tag.title": "“{tag}” etiketli hiçbir şey yok",
  "empty.tag.hint": "Bir dosyaya sağ tıklayıp Etiketler’i seç, burada görünsün",
  "sidenav.connections": "Bağlantılar",
  "sidenav.connect": "Nasıl bağlanılır",
  "sidenav.apikeys": "API anahtarları",
  "overlay.close": "Kapat",
  "conn.tokens.scopes": "İzinler",
  "conn.tokens.root": "Tek bir klasörle sınırla (isteğe bağlı)",
  "conn.tokens.rootPlaceholder": "depo://klasör",
  "conn.tokens.expiry": "Geçerlilik (gün)",
  "conn.tokens.expiryNever": "süresiz",
  "conn.tokens.defaultName": "API anahtarı {date}",
  "conn.tokens.namePlaceholder": "Ad — ör. yedekleme betiği",
  "conn.tokens.capNote": "Tavan hesabın ve yetkilerin — sahip olduğundan fazlasını istemek reddedilir, verilmez.",
  /* === /gezinti:g1 === */
  /* === surucu:d1 — kabuk (GitHub #14); artık `uiProfile: 'drive'` ile
     gelen bir seçenek değil, her profilde çizilir === */
  "drive.new": "Yeni",
  "drive.new.upload": "Dosya yükle",
  "drive.new.folder": "Yeni klasör",
  "drive.new.request": "Dosya iste",
  "drive.new.document": "Yeni belge",
  /* === belge:n1 — "Yeni belge": + Yeni altındaki seçici ==================
     Tür adları BURADA durmuyor. Her kutucuk sözcüklerini lib/fileIcons
     `typeLabelFor`den okur — listedeki Tür sütununun okuduğu tablonun
     aynısı — böylece ".docx" iki yerde de aynı adla anılır ve yeni bir tür
     için hiç dizge gerekmez. Aşağıda yalnız bu pencerenin kendi metni var. */
  "newdoc.title": "Yeni belge",
  "newdoc.type.label": "Belge türü",
  "newdoc.group.document": "Belgeler",
  "newdoc.group.text": "Metin ve kod",
  "newdoc.group.diagram": "Çizimler",
  "newdoc.withheld.onlyoffice": "Ofis belgeleri için bir belge sunucusu (OnlyOffice) gerekir; burada tanımlı değil.",
  "newdoc.withheld.drawio": "Çizimler için drawio servisi gerekir; burada tanımlı değil.",
  "newdoc.empty.title": "Kullanılabilir belge türü yok",
  "newdoc.empty.body": "Bu sunucu, bu uygulamanın oluşturabileceği bir tür sunmadı.",
  "newdoc.empty.blocked": "Bu sunucunun oluşturabildiği her tür, burada tanımlı olmayan bir düzenleyici servisine bağlı.",
  "newdoc.name": "Ad",
  "newdoc.name.placeholder": "Belge adı",
  "newdoc.untitled": "Adsız",
  "newdoc.err.slash": "Ad eğik çizgi içeremez.",
  "newdoc.err.exists": "{name} burada zaten var. Başka bir ad seçin.",
  "newdoc.location": "Konum",
  "newdoc.location.none": "Bir klasör seçin",
  "newdoc.location.change": "Değiştir",
  "newdoc.location.noaccess": "Bu klasöre kaydedemezsiniz.",
  "newdoc.create": "Oluştur",
  "newdoc.creating": "Oluşturuluyor…",
  "newdoc.cancel": "Vazgeç",
  "drive.search.placeholder": "{scope} deposunda ara",
  "drive.search.placeholder_all": "Tüm depolarda ara",
  "drive.search.hint_title": "Her yerde ara ve komut çalıştır ({combo})",
  "drive.storage.used": "{total} alanın {used} kadarı dolu",
  "drive.storage.used_unlimited": "{used} kullanılıyor",
  "drive.storage.label": "Depolama",
  /* === gorunum:v3-shell — Ana sayfa görünümü (kabuğun içindeki genel bakış)
   * Bölüm başlıkları `sidenav.storages` / `sidenav.recent` / `sidenav.starred`,
   * boş durumlar da `empty.recent.*` / `empty.starred.*` — bilerek: Ana
   * sayfadaki "Son kullanılanlar" başlığı ile yanındaki panel satırı aynı
   * şeydir, ikisine ayrı metin yazmak onları çeviri çeviri birbirinden
   * ayırmanın yoludur. Aşağıda yalnızca başka hiçbir yerde olmayanlar var. */
  "home.title": "Ana sayfa",
  "home.storages.empty": "Henüz depo yok",
  "home.storages.hint": "Depo, filex’in okuyup yazdığı sürücüdür — depoları yönetici ekler.",
  "drive.section.folders": "Klasörler",
  "drive.section.files": "Dosyalar",
  "filter.aria": "Süzgeçler",
  "filter.type": "Tür",
  "filter.type.any": "Her tür",
  "filter.type.folder": "Klasörler",
  "filter.type.document": "Belgeler",
  "filter.type.spreadsheet": "Hesap tabloları",
  "filter.type.presentation": "Sunumlar",
  "filter.type.pdf": "PDF’ler",
  "filter.type.image": "Görseller",
  "filter.type.video": "Videolar",
  "filter.type.audio": "Ses dosyaları",
  "filter.type.archive": "Arşivler",
  "filter.type.code": "Kod",
  "filter.modified": "Değiştirilme",
  "filter.modified.any": "Her zaman",
  "filter.modified.today": "Bugün",
  "filter.modified.7d": "Son 7 gün",
  "filter.modified.30d": "Son 30 gün",
  "filter.modified.year": "Bu yıl",
  "filter.size": "Boyut",
  "filter.size.any": "Her boyut",
  "filter.size.lt1": "1 MB altı",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "100 MB üstü",
  /* surucu:d1-actions — filtre satırının sonundaki ⋮ menüsü. Yalnızca menünün
     KENDİ adı yeni: içindeki her satır o eylemin zaten sahip olduğu metni
     kullanır (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`,
     `shortcuts.select_all`, `selection.clear`) — bir komutu yeniden adlandıran
     menü, okuyucuya aynı şeyi iki kez öğretir. */
  "filter.actions": "Liste işlemleri",
  "filter.clear": "Süzgeçleri temizle",
  "filter.empty.title": "Bu süzgeçlere uyan bir şey yok",
  "filter.empty.hint": "Bir süzgeci kaldır ya da yukarıdaki alandan her yerde ara.",
  "filter.count": "{total} öğeden {shown} tanesi",
  "inspector.tab.details": "Ayrıntılar",
  "inspector.tab.activity": "Etkinlik",
  "inspector.people": "Erişimi olan kişiler",
  "inspector.people.you": "Sen",
  "inspector.people.inherited": "üst klasörden",
  "inspector.people.empty": "Yalnızca sen ve aşağıdaki bağlantıya sahip olanlar.",
  "inspector.people.manage": "Erişimi yönet",
  "inspector.link": "Paylaşım bağlantısı",
  "inspector.link.none": "Paylaşılmadı",
  "inspector.link.create": "Bağlantı oluştur",
  "inspector.link.copy": "Bağlantıyı kopyala",
  "inspector.activity.empty": "Bu öğe için henüz etkinlik kaydı yok.",
  "inspector.activity.hint": "Sürümler dosya değiştikçe, yorumlar ise insanlar yazdıkça birikir.",
  "inspector.activity.version": "{n}. sürüm kaydedildi",
  "inspector.activity.comment": "{who} yorum yaptı",
  "inspector.activity.select": "Etkinliğini görmek için bir dosya ya da klasör seç.",
  /* === /surucu:d1 === */
  /* i18n:hardcoded — dönüştürme kutusunda hiç anahtar yoktu: her etiket,
     kimsenin geçirmediği isteğe bağlı bir `t` prop'unun arkasındaki düz
     Türkçe metindi. */
  "convert.title": "Dönüştür",
  "convert.loading": "Dönüştürücü yükleniyor…",
  "convert.done": "Dönüştürüldü ve klasöre yüklendi.",
  "convert.close": "Kapat",
  "convert.from": "Kaynak",
  "convert.search_format": "Hedef format ara (pdf, mp4, png…)",
  "convert.no_format": "Eşleşen format yok.",
  "convert.unsupported_input": "Bu dosya tipi için kaynak format bulunamadı.",
  "convert.converting": "Dönüştürülüyor…",
  "convert.convert": "Dönüştür",
  /* === gorunum:v1-chrome — filtre satırındaki ad kutusu === */
  "filter.find": "Bu klasörde filtrele…",
  /* surucu:d1-scope — satırların bir klasörün içeriği olmadığı yerlerde aynı
     kutu. Neyi daralttığını söylemek zorunda: depo listesinde "bu klasör" hiçbir
     şeyi adlandırmaz, Ana sayfada ise üç bloğu birden adlandırırdı. */
  "filter.find.storages": "Depolarda filtrele…",
  "filter.find.home": "Ana sayfada filtrele…",
  /* === gorunum:v1-viewer — tam ekran görüntüleyicinin kendi çerçevesi === */
  "viewer.share": "Paylaş",
  "viewer.nav_prev": "Önceki dosya",
  "viewer.nav_next": "Sonraki dosya",
  /* Üst çubuğun künye satırındaki sayaç: "246,3 KB • 9 Eyl 2026 • 1 / 9". */
  "viewer.counter": "{i} / {n}",
  "viewer.zoom_reset": "Yakınlaştırmayı sıfırla",
  "viewer.fullscreen": "Tam ekran",
  "viewer.exit_fullscreen": "Tam ekrandan çık",
  "viewer.md_placeholder": "# Markdown buraya…",
  /* === gorunum:v1-selbar — filtre satırının yerini alan seçim çubuğu === */
  "selection.count": "{n} seçildi",
  "selection.clear": "Seçimi temizle",
  /* === gorunum:v1-preview — türün adı, kelimeyle =======================
     Tür sütunu eskiden uzantıyı büyük harfle yazıyordu; artık bunları
     yazıyor. Hangisinin seçileceğine `lib/fileIcons.ts` karar verir
     (`typeLabelKey`) — bir türü adlandıran yalnız iki yer var: o tablo ve bu
     liste. Eşleşmeyen her şey yine büyük harfli uzantıya düşer. `Klasör`
     burada DEĞİL: o `node.folder`, grid kartının alt yazısı zaten onu basar. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue bileşeni",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C kaynağı",
  "ftype.cpp": "C++ kaynağı",
  "ftype.csharp": "C# kaynağı",
  "ftype.stylesheet": "Stil dosyası",
  "ftype.html": "HTML belgesi",
  "ftype.json": "JSON verisi",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Kabuk betiği",
  "ftype.powershell": "PowerShell betiği",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Düz metin",
  "ftype.log": "Günlük dosyası",
  "ftype.config": "Ayar dosyası",
  "ftype.sheet": "Hesap tablosu",
  "ftype.figma": "Figma tasarımı",
  "ftype.design": "Tasarım dosyası",
  "ftype.image": "Görsel",
  "ftype.video": "Video",
  "ftype.audio": "Ses",
  "ftype.pdf": "PDF belgesi",
  "ftype.document": "Belge",
  "ftype.slides": "Sunum",
  "ftype.archive": "Arşiv",
  "ftype.code": "Kod",
  /* === gorunum:v1-advsearch — Gelişmiş arama penceresi ===================
   * İki `filter.*` anahtarı kardeşlerinin yanında değil burada: paylaşılan
   * birleşimlere pencerenin eklediği yeni üyeler (`modified: 'around'`,
   * `size: 'range'`). Filtre satırı bunları hiç seçmez ama biri oraya
   * ulaşırsa `chipLabel` ham anahtarı yazardı. */
  "filter.modified.around": "Bir tarihin çevresinde",
  "filter.size.range": "Özel aralık",
  "advsearch.open": "Gelişmiş arama",
  "advsearch.title": "Gelişmiş arama",
  "advsearch.subtitle": "Dosyaları ada, içeriğe, yola ya da etikete göre bulun.",
  "advsearch.close": "Kapat",
  "advsearch.content.heading": "İçerik araması",
  "advsearch.viewall": "Tüm sonuçları gör",
  "advsearch.where.any_short": "Her yerde",
  "advsearch.where.here_short": "Yalnız burada",
  "advsearch.where.skip_short": "Burayı atla",
  "advsearch.server.legend": "Sunucunun aradığı",
  "advsearch.client.legend": "Gelen sonuçları daralt",
  "advsearch.query.label": "Kelimeler",
  "advsearch.query.placeholder": "Adın bir parçası ya da dosyanın içindeki kelimeler",
  "advsearch.scope.label": "Nerede arasın",
  "advsearch.scope.name": "Ad ve yol",
  "advsearch.scope.content": "Dosya içeriği",
  "advsearch.scope.all": "İkisi de",
  "advsearch.scope.hint": "İçerik, dizinden aranır; dizin metin türü dosyaların ilk 200 KB’ını kapsar.",
  "advsearch.people.name_only": "Sahip, gelen satırlardan okunur; sahip bilgisi taşıyan satırları da yalnız ad araması döndürür.",
  "advsearch.scope.name_only": "Burada yalnız ad ve yol: içerik sonucu gezgine hangi depodan geldiği bilgisi olmadan ulaşır, bu yüzden içerik araması yalnız tek depolu kurulumlarda sunulur.",
  "advsearch.tags.label": "Etiketler",
  "advsearch.tags.placeholder": "fatura, üç aylık rapor",
  "advsearch.tags.exclude": "Şu etiketler hariç",
  "advsearch.tags.exclude_placeholder": "arşiv",
  "advsearch.tags.hint": "Virgülle ayırın. Etiket daraltır: birden çok etiket hepsini birden taşıyan dosyalar demektir, hiç kullanılmamış bir etiket ise hiçbir şey döndürmez.",
  "advsearch.where.label": "Klasör",
  "advsearch.where.any": "Bu deponun her yerinde",
  "advsearch.where.here": "Yalnız {folder} içinde",
  "advsearch.where.skip": "{folder} dışındaki her yerde",
  "advsearch.around.label": "Şu kadar içinde",
  "advsearch.around.date": "Tarih ve saat",
  "advsearch.around.h1": "1 saat",
  "advsearch.around.d1": "1 gün",
  "advsearch.around.w1": "1 hafta",
  "advsearch.size.range_label": "Şunun arasında",
  "advsearch.size.from": "En az",
  "advsearch.size.to": "En çok",
  "advsearch.count.idle": "Bir şeyler yazın ya da etiket seçin.",
  "advsearch.count.counting": "Sayılıyor…",
  "advsearch.count.result": "{n} eşleşen öğe",
  "advsearch.count.capped": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.result_one": "1 eşleşen öğe",
  "advsearch.count.capped_one": "Sonuçların ilk sayfasında 1 eşleşen öğe",
  "advsearch.count.error": "Sayım çalıştırılamadı.",
  "advsearch.count.cost": "Sayım bu aramayı çalıştırır. Tür, sahip, tarih, boyut ve klasör sunucuda değil, gelen satırlar üzerinde uygulanır.",
  "advsearch.wire": "Gönderilen",
  "advsearch.reset": "Sıfırla",
  "advsearch.cancel": "Vazgeç",
  "advsearch.submit": "Ara",
  /* === gorunum:v2-topbar — sayfanın üst barı kalktı; onun taşıdıklarını
     artık gezginin kendi başlığı ve kırıntı satırı taşıyor. === */
  "breadcrumb.subfolders": "Alt klasörler",
  "breadcrumb.subfolders.empty": "Burada alt klasör yok",
  "header.admin": "Yönetim paneli",
  "header.settings": "Ayarlar",
  "header.signout": "Çıkış yap",
  "ai.assistant": "AI asistanı",
  "ai.soon": "Yakında",
  "ai.assistant.soon": "AI asistanı — yakında",
  /* gorunum:v2-share — Paylaş / İzinler penceresinin kendi çerçevesi. İçindeki
     denetimler eski metinlerini koruyor; buradakiler yeni kabuk: başlık, tek
     anahtar, "şu anda kim açabilir" cümlesi ve her şeyin katlandığı üç adlı
     bölüm. */
  "access.title": '"{name}" paylaşımı',
  "access.close": "Kapat",
  "access.done": "Bitti",
  "access.copy": "Kopyala",
  "access.copied": "Kopyalandı",
  "access.link.switch": "Bağlantı paylaşımı",
  "access.who.private": "Yalnızca erişimi olan kişiler açabilir.",
  "access.who.link": "Bağlantıyı bilen herkes açabilir.",
  "access.who.pin": "Bağlantıyı ve PIN'i bilen herkes açabilir.",
  "access.who.existing": "Bağlantı paylaşımı açık — {n} bağlantı var.",
  "access.who.existing_one": "Bağlantı paylaşımı açık — {n} bağlantı var.",
  "access.section.link": "Bağlantı seçenekleri",
  "access.section.people": "Erişimi olanlar",
  "access.section.drop": "Dosya iste",
  "access.sum.pin_on": "PIN var",
  "access.sum.pin_off": "PIN yok",
  "access.sum.people": "{n} kişi",
  "access.sum.people_one": "{n} kişi",
  "access.sum.people_none": "Henüz kimse yok",
  "access.sum.drop": "{n} yükleme bağlantısı",
  "access.sum.drop_one": "{n} yükleme bağlantısı",
  "access.sum.drop_none": "Yükleme bağlantısı yok",
  /* Sahiplik — Sahibi sütunu ve Kişiler çipi. "Sistem", filex üzerinden kimsenin
     koymadığı satırın dürüst karşılığıdır (tarayıcı buldu ya da doğrudan kovaya
     yazıldı); boşluk değil, gerçek bir cevaptır. */
  "col.owner": "Sahibi",
  "owner.you": "Siz",
  "owner.system": "Sistem",
  "owner.unknown": "Bilinmiyor",
  "owner.external": "Yükleme bağlantısıyla geldi",
  "owner.last_actor": "Son değiştiren: {who}",
  "filter.people": "Kişiler",
  "filter.people.any": "Herkes",
  "filter.people.me": "Siz",
  "filter.people.system": "Sistem",
  "filter.people.someone": "Başka biri",
  /* surucu:d1-sort — filtre satırının sağ ucundaki sıralama denetimi. Dört
     ölçütün adı `col.*`: menü, liste görünümünün sütun başlıklarındaki
     sözcüklerin aynısını sunar — tek bir sıralamayı süren iki denetim onu
     farklı adlarla anamaz. */
  "sort.by": "Sıralama ölçütü",
  "sort.asc": "Artan",
  "sort.desc": "Azalan",
  /* Bir ARAMA SONUCUNUN sırası. Beşinci bir sıralama ölçütü değildir —
     ekrandaki satırları sunucu sıraladığında denetim, ölçüt adı yerine bunu
     yazar; böylece yapmadığı bir sıralamayı üstlenmez. `_why` denetimin neden
     kapalı olduğudur: Burak, denetimin sessizce işlevsizleşmesini değil
     nedeninin yazılmasını istedi. */
  "sort.relevance": "Alaka",
  "sort.relevance_why": "Arama sonuçları eşleşme yakınlığına göre listelenir. Seçtiğiniz sıralama, aramadan çıkınca geri gelir.",
  /* === tablo:t1 — tablonun kendi yapılandırması ==========================
     Sütun genişlikleri ve görünürlüğü EKRANINIZA dair bir tercihtir; bir
     klasörün hangi görünümle açılacağı ise KLASÖRE dair bir olgudur. İkisi de
     buradan ayarlanır; `folder_hint` kuralı tek cümlede, tam da ona şaşıracak
     kişinin okuyabileceği yerde söyler. */
  "col.location": "Konum",
  "cols.menu": "Sütun seçenekleri",
  "cols.title": "Sütunlar",
  "cols.resize": "{col} sütununu yeniden boyutlandır",
  "cols.move_left": "{col} sütununu sola taşı",
  "cols.move_right": "{col} sütununu sağa taşı",
  "cols.reset": "Sütunları sıfırla",
  "cols.folder_title": "Klasör görünümü",
  "cols.folder_hint": "Ayarladığınız klasörler kendi görünümünü korur. Son seçiminiz diğer her yerde varsayılan olur.",
  "cols.forget_folder": "Bu klasörün görünümünü unut",
  "cols.apply_all": "Tüm klasörlere uygula ({count} klasör hatırlanıyor)",
  /* === tablo:t1 — çöp kutusu bilgi şeridi ================================
     ⚠ `retention` yalnızca kurulum bize sayıyı SÖYLEDİĞİNDE kullanılır
     (GET /api/admin/protection). Diğer her durumda `retention_unknown` aynı
     şeyi, doğrulayamadığımız bir süreyi taahhüt etmeden söyler: yanlış saklama
     süresi yazan bir şerit, hiç şerit olmamasından kötüdür — insanlar ona
     bakıp karar verir. */
  "trash.retention": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_one": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_unknown": "Çöp kutusundaki öğeler, yöneticinizin belirlediği saklama süresi dolunca kalıcı olarak silinir.",
  "trash.empty_action": "Çöp kutusunu boşalt",
  "trash.empty_confirm_title": "Çöp kutusu boşaltılsın mı?",
  "trash.empty_confirm_body_one": "Bu işlem 1 öğeyi ({size}) kalıcı olarak siler. Geri alınamaz.",
  "trash.empty_confirm_body": "Bu işlem {count} öğeyi ({size}) kalıcı olarak siler. Geri alınamaz.",
  "trash.empty_confirm_body_nosize_one": "Bu işlem 1 öğeyi kalıcı olarak siler. Geri alınamaz.",
  "trash.empty_confirm_body_nosize": "Bu işlem {count} öğeyi kalıcı olarak siler. Geri alınamaz.",
  "trash.emptied": "Çöp kutusu boşaltıldı",
  "empty.trash.hint": "Sildiğiniz dosyalar önce buraya düşer, böylece geri alabilirsiniz.",
  /* tasi:m1 — hedef klasör seçici (modals/DestinationPickerModal.vue) ve
     üzerine kurulan iki seçim eylemi. */
  "destpicker.title.move": "Şuraya taşı",
  "destpicker.title.copy": "Şuraya kopyala",
  "destpicker.title.choose": "Klasör seç",
  "destpicker.confirm.move": "Buraya taşı",
  "destpicker.confirm.copy": "Buraya kopyala",
  "destpicker.confirm.choose": "Bu klasörü seç",
  "destpicker.cancel": "Vazgeç",
  "destpicker.up": "Bir üst klasör",
  "destpicker.crumbs": "Konum",
  "destpicker.drives": "Sürücüler",
  "destpicker.loading": "Yükleniyor…",
  "destpicker.empty": "Burada alt klasör yok",
  "destpicker.unreadable": "Bu klasör açılamıyor.",
  "destpicker.readonly": "Salt okunur",
  "destpicker.readonly_here": "Bu klasöre yazamazsınız.",
  "destpicker.pick_a_drive": "Bir klasör seçmek için önce bir depo açın.",
  "destpicker.target": "Hedef: {name}",
  "destpicker.tag.blocked": "Uygun değil",
  "destpicker.blocked.self": "Bir klasör kendi içine taşınamaz.",
  "destpicker.blocked.descendant": "Bir klasör kendi alt klasörlerinden birine taşınamaz.",
  "ctx.move_to": "Şuraya taşı…",
  "ctx.copy_to": "Şuraya kopyala…",
  "ctx.access.one_only": "Paylaşım aynı anda tek öğe için çalışır.",
  "toast.archive.preparing": "Arşiv hazırlanıyor…",
  "toast.archive.started": "{name} indiriliyor ({count} dosya)",
  "toast.archive.started_one": "{name} indiriliyor ({count} dosya)",
  "toast.archive.empty": "İndirilecek bir şey yok — seçimde okunabilir dosya bulunmuyor.",
  "toast.moved_to": "{name} klasörüne taşındı",
  "toast.copied_to": "{name} klasörüne kopyalama kuyruğa alındı"
}, Iv = {
  "toolbar.new_folder": "New folder",
  "toolbar.upload": "Upload",
  "toolbar.search": "Search",
  "toolbar.search.placeholder": "Search by name or tag:…",
  "toolbar.view.list": "List",
  "toolbar.view.grid": "Grid",
  "toolbar.refresh": "Refresh",
  "toolbar.go_up": "Up one level",
  "ctx.open": "Open",
  "ctx.preview": "Preview",
  "ctx.download": "Download",
  "ctx.convert": "Convert",
  "ctx.rename": "Rename",
  "ctx.delete": "Delete",
  "ctx.delete_perm": "Delete Permanently",
  "ctx.restore": "Restore",
  "ctx.share": "Share",
  "ctx.move": "Move",
  "ctx.copy": "Copy",
  "ctx.cut": "Cut",
  "ctx.show_hidden": "Show hidden files",
  "ctx.hide_hidden": "Hide hidden files",
  "ctx.keep_local": "Keep on this computer",
  "ctx.keep_online": "Keep online only",
  "ctx.keep_reveal": "Open local folder",
  "ctx.keep_inherited": "Kept on this computer with its parent",
  "keep.started": "Will be kept on this computer — sync started",
  "keep.failed": "Could not keep on this computer",
  "keep.badge_kept": "On this computer",
  "keep.badge_syncing": "Syncing…",
  "keep.badge_cloud": "Online only",
  "keep.badge_partial": "Contains items kept on this computer",
  "keep.strip_transfer": "Syncing {name} — {done}/{total} ({pct}%)",
  "keep.strip_inventory": "Syncing {name} — scanning the server…",
  "keep.strip_settling": "Syncing {name} — settling…",
  "ctx.paste": "Paste",
  "ctx.info": "Info",
  "ctx.duplicate": "Duplicate",
  "ctx.new_file": "New file",
  "modal.delete.title": "Delete?",
  "modal.delete.message": "{count} items will be moved to trash.",
  "modal.delete.message_one": "1 item will be moved to trash.",
  "modal.delete.confirm": "Move to Trash",
  "modal.delete.cancel": "Cancel",
  "modal.rename.title": "Rename",
  "modal.rename.save": "Save",
  "modal.rename.cancel": "Cancel",
  "modal.newfolder.title": "New folder",
  "modal.newfolder.placeholder": "Folder name",
  "modal.newfolder.create": "Create",
  "modal.newfolder.cancel": "Cancel",
  "modal.share.title": "Share Link",
  "modal.share.pin": "PIN protected",
  "modal.share.expires": "Expires at",
  "modal.share.max_downloads": "Download limit",
  "modal.share.create": "Share",
  "modal.share.cancel": "Cancel",
  "modal.share.close": "Close",
  "modal.share.limit_applied": "(server limit applied)",
  "modal.share.copy": "Copy",
  "modal.share.url_copied": "Link copied",
  "modal.share.pin_copied": "PIN copied",
  "modal.share.cli_copied": "CLI command copied",
  "upload.progress": "Uploading",
  "upload.done": "Done",
  "upload.error": "Error",
  "upload.failed": "Could not upload “{name}”",
  "upload.aborted": "Aborted",
  "upload.cancel": "Cancel",
  "upload.resuming": "Resuming “{name}” from {percent}%",
  "upload.committing": "Finishing",
  "upload.transferring": "Moving to storage",
  "empty.folder": "This folder is empty",
  "empty.search": "No results",
  loading: "Loading…",
  "notFound.title": "Folder not found",
  "notFound.desc": "This folder does not exist, was moved, or you do not have access to it.",
  "notFound.goRoot": "Go to root folder",
  "col.name": "Name",
  "col.size": "Size",
  "col.modified": "Modified",
  "col.type": "Type",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Root",
  "breadcrumb.copy_path": "Copy path",
  "breadcrumb.go_to_path": "Go to path",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Copying",
  "ops.move": "Moving",
  "ops.delete": "Deleting",
  "ops.queued": "queued",
  "ops.done": "done",
  "ops.error": "error",
  "node.trash": "Trash",
  /* gorunum:v1 — the singular kind, printed under a folder's name on a card
   * and beside it in the list. The plural section heading is a different
   * string on purpose. */
  "node.folder": "Folder",
  // ——— Rich viewer chrome ———
  "viewer.open_in_new_tab": "Open in new tab",
  "viewer.loading": "Loading…",
  "viewer.failed_to_load": "Failed to load file",
  "viewer.peer_not_installed": "Optional viewer library is not installed. Install the peer dependency or use the download button.",
  "viewer.format_unsupported_3d": "This 3D format is not supported in the browser preview (model-viewer only reads .glb / .gltf / .usdz). Please download and open with a local tool.",
  "viewer.zoom_in": "Zoom in",
  "viewer.zoom_out": "Zoom out",
  "viewer.fit_width": "Fit width",
  "viewer.next_page": "Next page",
  "viewer.prev_page": "Previous page",
  "viewer.page_n_of_m": "Page {n} of {m}",
  "viewer.tags": "Tags",
  "viewer.layers": "Layers",
  "viewer.toc": "Contents",
  "viewer.font_smaller": "Smaller text",
  "viewer.font_larger": "Larger text",
  "viewer.search": "Search",
  "viewer.download": "Download",
  "viewer.saving": "Saving…",
  "viewer.save": "Save (Ctrl+S)",
  "viewer.saved": "Saved",
  "viewer.save_error": "Error",
  "viewer.editor_loading": "Loading editor…",
  "viewer.no_preview": "No preview for this file type yet.",
  "viewer.edit": "Edit",
  "viewer.close": "Close",
  "presence.expand": "Show names",
  "presence.collapse": "Collapse",
  "viewer.save_annotations": "Save annotations",
  "viewer.annotations_on": "Annotations: on",
  "viewer.annotations_off": "Annotations: off",
  "viewer.read_only": "Read only",
  "viewer.csv_first_row_header": "First row as header",
  "viewer.csv_filter": "Filter rows…",
  "viewer.epub_prev": "Previous",
  "viewer.epub_next": "Next",
  "viewer.drawio.disabled": "diagrams.net embed is not configured for this filex instance — operator must wire FILEX_DRAWIO_URL to enable the editor.",
  "viewer.archive.entries": "{n} files",
  "viewer.archive.entries_one": "1 file",
  "viewer.archive.empty": "Archive is empty.",
  "viewer.archive.error": "Could not read archive contents.",
  "viewer.name": "Name",
  "viewer.size": "Size",
  // ——— cila:a — sorting / date groups / density ———
  "col.sort": "Sort",
  "group.today": "Today",
  "group.yesterday": "Yesterday",
  "group.this_week": "This Week",
  "group.this_month": "This Month",
  "group.no_date": "No date",
  "toolbar.density.compact": "Compact view",
  "toolbar.density.comfortable": "Comfortable view",
  // ——— cila:c — command palette + shortcuts help + breadcrumb ———
  "palette.placeholder": "Search files, folders or commands…",
  "palette.files": "Files",
  "palette.commands": "Commands",
  "palette.goto": "Go to path",
  "palette.empty": "No results",
  "palette.hint": "↑↓ navigate · Enter select · Esc close",
  "cmd.view_toggle": "Toggle view (list ⇄ grid)",
  "cmd.trash": "Open trash",
  "shortcuts.title": "Keyboard Shortcuts",
  "shortcuts.group.nav": "Navigation",
  "shortcuts.group.selection": "Selection",
  "shortcuts.group.file": "File operations",
  "shortcuts.palette": "Command palette",
  "shortcuts.search": "Focus search",
  "shortcuts.go_up": "Go up one level",
  "shortcuts.open": "Open selected item",
  "shortcuts.close": "Close / cancel",
  "shortcuts.toggle_hidden": "Show/hide hidden files",
  "shortcuts.help": "This help dialog",
  "shortcuts.select_all": "Select all",
  "shortcuts.star": "Star / unstar",
  "shortcuts.rename": "Rename",
  "shortcuts.delete": "Delete",
  "shortcuts.cut": "Cut",
  "shortcuts.copy": "Copy",
  "shortcuts.paste": "Paste",
  "breadcrumb.more": "Hidden folders",
  // ——— State screens + undo snackbar + connection badge (cila:b) ———
  "empty.hint": "Drag and drop files here",
  "empty.upload": "Upload files",
  "empty.search.title": "No files match your search",
  "empty.search.hint": "Try a different search term",
  "empty.trash.title": "Trash is empty",
  "error.title": "Could not load this folder",
  "error.retry": "Try again",
  "toast.undo": "Undo",
  "toast.undone": "Undone",
  "toast.undo_failed": "Could not undo",
  "toast.renamed": "Renamed",
  "toast.moved": "Moved",
  "toast.trashed": "Moved to trash",
  /* i18n:hardcoded — toast copy that used to be Turkish string literals in
     FileExplorer.vue, unreachable by any locale. */
  "toast.failed": "Operation failed",
  "toast.copied": "Copied",
  "toast.deleted": "Deleted",
  "toast.cut": "Cut",
  "toast.cut_ready": "Cut — ready to paste",
  "toast.copy_ready": "Copied — ready to paste",
  "toast.same_folder_cut": "Cannot cut into the same folder",
  "toast.restored": "{n} items restored",
  "toast.restored_one": "1 item restored",
  "toast.restore_taken": "{n} items were not restored: something already has their names. Rename what is there, then restore again.",
  "toast.restore_taken_one": "“{name}” was not restored: something already has that name. Rename what is there, then restore again.",
  "toast.delete_queued": "Delete queued",
  "toast.trash_retention": "Items in the trash are removed automatically once the retention window ends. Permanent deletion is done from the admin panel.",
  "dropzone.hint": "Drop files here",
  "modal.newfolder.invalid": "Invalid character",
  "viewer.office_unconfigured": "OnlyOffice is not configured",
  "viewer.pdf_inline_failed": "Your browser could not display this PDF inline.",
  "viewer.too_large": "File is too large (>1 MB).",
  "viewer.csv_rows": "{n} rows",
  "viewer.csv_rows_one": "1 row",
  "presence.others": "{n} people",
  "presence.others_one": "1 person",
  "conn.offline": "No live connection — changes may be delayed",
  "conn.tooltip": "Live connection to the server is unavailable; the list refreshes periodically. This notice disappears once the connection is back.",
  /* === bul:s3 === */
  "palette.everywhere": "Everywhere",
  "palette.searching": "Searching…",
  "palette.saved": "Saved searches",
  "palette.save": "Save search",
  "palette.saved.delete": "Delete saved search",
  "search.in_content": "In content",
  /* === bag:b4 === */
  "toolbar.more": "More actions",
  "toolbar.search.close": "Close search",
  "sheet.menu": "Actions",
  "sheet.close": "Close",
  /* === koru:k1 === */
  "toolbar.inspector": "Details",
  "ctx.details": "Details",
  /* yildiz:s1 — starring is an action, so it has a verb in the menu. */
  "ctx.star": "Star",
  "ctx.unstar": "Unstar",
  "star.failed": "Could not change the star",
  "shortcuts.inspector": "Toggle details panel",
  "inspector.title": "Details",
  "inspector.copy_name": "Copy name",
  "inspector.items": "{n} items",
  "inspector.items_one": "1 item",
  "inspector.type": "Type",
  "inspector.select_hint": "Select an item to see its details.",
  /* pane:p1 — the panel HOLDS the last selected thing (owner's ruling,
     2026-09-13), so it can be describing an item in the half of a split
     window nobody is looking at. This line says which one and where. */
  "inspector.held": "Last selected — in {where}",
  "inspector.close": "Close",
  "inspector.section.general": "General",
  "inspector.section.tags": "Tags",
  /* etiket:t1 — TagPicker's own chrome. It printed these three in English
     regardless of the catalogue until 2026-09-13; `tags.open` is the chip's new
     "show me everything with this tag". */
  "tags.open": "Open tag: {tag}",
  "tags.add": "+ Add tag",
  "tags.name": "Tag name",
  "tags.remove": "Remove tag",
  "inspector.section.versions": "Versions",
  "inspector.section.permissions": "Permissions",
  "inspector.section.shares": "Shares",
  "inspector.path": "Path",
  "inspector.size": "Size",
  "inspector.modified": "Modified",
  "inspector.mime": "MIME type",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Node ID",
  "inspector.copy": "Copy",
  "inspector.copied": "Copied",
  "inspector.error": "Could not load",
  "inspector.items_summary": "{n} items, {size} total",
  "inspector.items_summary_one": "1 item, {size} total",
  "inspector.folder_items": "{n} items",
  "inspector.folder_items_one": "1 item",
  "inspector.versions.empty": "No version history",
  "inspector.versions.v": "Version {n}",
  "inspector.versions.restore": "Restore",
  "inspector.versions.restore_confirm": "Restore this version?",
  "inspector.versions.snapshot_current": "Snapshot the current state first",
  "inspector.versions.confirm": "Confirm",
  "inspector.versions.cancel": "Cancel",
  "inspector.versions.take_snapshot": "Snapshot current state",
  "inspector.versions.restored": "Version restored",
  "inspector.versions.snapshotted": "Snapshot taken",
  "inspector.versions.unsupported": "The server does not support this operation",
  "inspector.perm.none": "No access",
  "inspector.perm.viewer": "Viewer",
  "inspector.perm.editor": "Editor",
  "inspector.perm.owner": "Owner",
  "inspector.perm.manage": "Manage permissions",
  "inspector.shares.empty": "No share links",
  "inspector.shares.copy": "Copy link",
  /* wiring:c1 — theme gallery */
  "theme.menu": "Theme",
  "theme.title": "Theme Gallery",
  "theme.hint": "A theme only changes the colour palette — day or night is the choice above.",
  "theme.mode.label": "Appearance",
  "theme.mode.light": "Day",
  "theme.mode.dark": "Night",
  "theme.mode.auto": "Automatic",
  "theme.reset": "Reset to default",
  "theme.close": "Close",
  "theme.selected": "Selected",
  "theme.name.default": "Default",
  "theme.name.night": "Night Blue",
  "theme.name.forest": "Forest",
  "theme.name.amber": "Amber",
  "theme.name.lilac": "Lilac",
  "theme.name.contrast": "High Contrast",
  "theme.name.gray": "Soft Gray",
  "theme.name.terminal": "Terminal Green",
  /* === zaman:z3 — the time-zone picker (embed dialog + web settings) === */
  "tz.menu": "Time zone",
  "tz.title": "Time zone",
  "tz.label": "Show dates in",
  "tz.search": 'Search a city, country or offset — try "Istanbul" or "GMT+3"',
  "tz.default.device": "Use this device's zone ({zone})",
  "tz.default.account": "Use the account's zone ({zone})",
  "tz.default.host": "Use this site's default ({zone})",
  "tz.no_match": "No zone matches “{query}”. Try a city, a country, or an offset like GMT+3.",
  "tz.more": "{n} more — keep typing to narrow the list.",
  "tz.hint": "Saved in this browser only. Every date is stored as one moment in time and shown on the clock you pick here.",
  "tz.now": "Right now in {zone}: {time}",
  /* === wiring:c2 — customizable shortcuts + quick look === */
  "shortcuts.quicklook": "Quick look",
  "shortcuts.customize": "Customize",
  "shortcuts.settings.menu": "Shortcuts",
  "shortcuts.settings.title": "Shortcut Settings",
  "shortcuts.settings.hint": 'To remap a shortcut, press "Change" and then the new key combination. Changes are stored in this browser only.',
  "shortcuts.settings.change": "Change",
  "shortcuts.settings.capture": "Press keys… (Esc cancels)",
  "shortcuts.settings.reset": "Reset to default",
  "shortcuts.settings.reset_all": "Reset all",
  "shortcuts.settings.unbound": "Not set",
  "shortcuts.settings.fixed": "Fixed",
  "shortcuts.settings.customized": "Customized",
  "shortcuts.settings.conflict": 'is already used by "{name}".',
  "shortcuts.settings.conflict_fixed": 'is reserved by the fixed shortcut "{name}" — it cannot be used.',
  "shortcuts.settings.conflict_take": "Unassign old and use here",
  "shortcuts.settings.conflict_cancel": "Cancel",
  "quicklook.hint_close": "close",
  "quicklook.hint_nav": "previous/next",
  "quicklook.hint_open": "open",
  /* === /wiring:c2 === */
  /* === wiring:c3 — operations center === */
  "opc.title": "Operations",
  "opc.aria_badge": "{n} operations — toggle operations center",
  "opc.aria_badge_one": "1 operation — toggle operations center",
  "opc.close": "Close",
  "opc.active": "In progress",
  "opc.history": "History",
  "opc.clear": "Clear",
  "opc.empty": "No operations",
  "opc.cancel": "Cancel",
  "opc.retry": "Retry",
  "opc.dismiss": "Dismiss",
  "opc.queued": "Queued",
  "opc.percent": "{n}%",
  "opc.status.running": "In progress",
  "opc.status.done": "Done",
  "opc.status.error": "Failed",
  "opc.status.aborted": "Cancelled",
  "opc.kind.upload": "Upload",
  "opc.kind.copy": "Copy",
  "opc.kind.move": "Move",
  "opc.kind.delete": "Delete",
  "opc.kind.convert": "Convert",
  "opc.kind.archive": "Archive",
  /* === wiring:c4 — onboarding tour + accessibility + error card === */
  "tour.aria": "Onboarding tour",
  "tour.restart": "Restart the tour",
  "tour.skip": "Skip tour",
  "tour.back": "Back",
  "tour.next": "Next",
  "tour.done": "Done",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Storages & views",
  "tour.step.nav.desc": "Home, Shared with me, Recent, Starred and Trash are always in this panel, with your storages and connections underneath. The button in the top-left corner collapses it to a rail and brings it back.",
  "tour.step.nav.desc_closed": "This button opens the navigation panel: Home, Shared with me, Recent, Starred and Trash, with your storages and connections underneath.",
  "tour.step.new.title": "Add something",
  "tour.step.new.desc": "Everything new starts here — upload from this device, create a folder, or ask somebody else for a file. Dropping files onto the window uploads them as well.",
  "tour.step.new.desc_fab": "This button uploads files from this device. Dropping files onto the window works as well.",
  "tour.step.search.title": "Search",
  "tour.step.search.desc": 'This field searches the whole storage by name — separators and one typo are forgiven, so "invoice 2026" finds invoice_2026.pdf. Add tag:invoice to filter by tag. The sliders button opens advanced search, and {palette} opens the command palette, which runs commands too.',
  "tour.step.crumb.title": "Where you are",
  "tour.step.crumb.desc": "This trail is the address of the folder on screen. Click any step to go back up, and the chevron beside the last one lists the folders inside it.",
  "tour.step.filters.title": "Narrow the list",
  "tour.step.filters.desc": "Type, People, Modified and Size filter the folder you are in, the box beside them matches names as you type, and the control at the end of the row sorts.",
  "tour.step.view.title": "Switch views",
  "tour.step.view.desc": "Change how this folder is drawn; your choice is remembered.",
  "tour.step.details.title": "Details & sharing",
  "tour.step.details.desc": 'Select a file and open this panel for its details, its activity and its share links. For the full menu, right-click the file or use the button at the end of its row — "Share / Permissions" there creates a link with an optional PIN and expiry.',
  "tour.step.help.title": "Shortcuts",
  "tour.step.help.desc": 'Press {help} for the shortcut cheat-sheet and {palette} for the command palette. Theme and "Restart the tour" are in the "More actions" menu at the top right; your account and sign-out are behind the avatar beside it.',
  "error.hint": "This may be a temporary network or server problem. Please try again.",
  "error.details": "Technical details",
  "col.star": "Star",
  "toolbar.view_label": "View",
  "list.aria": "File list",
  "grid.aria": "File grid",
  /* === wiring:d1 — tabs + split pane === */
  "tabs.strip": "Tabs",
  "tabs.new": "New tab",
  "tabs.close": "Close tab",
  "tabs.split": "Split view",
  "tabs.split_off": "Close split",
  "ctx.open_new_tab": "Open in new tab",
  "shortcuts.group.tabs": "Tabs",
  "shortcuts.tab_new": "New tab",
  "shortcuts.tab_close": "Close tab",
  "shortcuts.tab_next": "Next tab",
  "shortcuts.tab_prev": "Previous tab",
  /* tus:t1 — the menu verbs */
  "shortcuts.new_folder": "New folder",
  "shortcuts.upload": "Upload files",
  "shortcuts.refresh": "Refresh the listing",
  "shortcuts.download": "Download",
  "shortcuts.preview": "Preview",
  "shortcuts.share": "Share / permissions",
  "shortcuts.tags": "Tags",
  "shortcuts.convert": "Convert",
  "shortcuts.open_tab": "Open in a new tab",
  "shortcuts.copy_path": "Copy path",
  "shortcuts.copy_id": "Copy id",
  "shortcuts.restore": "Restore from trash",
  "shortcuts.settings.reserved": "is taken by the browser before the page sees it, so it would do nothing here. Pick another key.",
  "shortcuts.settings.reserved_badge": "Desktop app only",
  "shortcuts.settings.reserved_title": "The browser handles this combination itself. It fires in the desktop app and in an installed PWA, not in a browser tab.",
  "cmd.tab_new": "Open a new tab",
  "cmd.split_toggle": "Toggle split view",
  "split.pane": "Secondary pane",
  "split.close": "Close the side pane",
  "split.error": "Could not load the listing",
  "split.retry": "Retry",
  "split.copy_queued": "Copy queued",
  "split.move_queued": "Move queued",
  "toast.move_kept_both": "Move queued. A name was already taken there, so that item will be kept beside the existing one with “-copy” added. This move cannot be undone.",
  "split.cross_copy": "Different storages — copy queued instead",
  "dragout.downloading": "Downloading into the folder you dropped on…",
  "dragout.not_found": "Could not find where it was dropped — a drop onto an application (rather than a folder) cannot be filled in",
  "dragout.done": "Download finished",
  "dragout.ready": "Files are ready — drag them to your desktop",
  "dragout.preparing": "Getting them ready to drag…",
  "split.cross_move": "Different storages — move queued (bytes travel, then the original is removed)",
  /* === /wiring:d1 === */
  /* wiring:d2 — gallery view */
  "toolbar.view.gallery": "Gallery",
  "gallery.aria": "File gallery",
  /* /wiring:d2 */
  /* wiring:d3 — inspector node comments */
  "inspector.section.comments": "Comments",
  "inspector.comments.empty": "No comments yet.",
  "inspector.comments.placeholder": "Write a comment…",
  "inspector.comments.send": "Send",
  "inspector.comments.delete": "Delete comment",
  /* wiring:e2 — end-to-end encrypted folders */
  "e2e.create.title": "Create encrypted folder",
  "e2e.create.option": "Create encrypted folder…",
  "e2e.create.pw_label": "Folder password",
  "e2e.create.pw_placeholder": "At least 8 characters",
  "e2e.create.pw2_label": "Repeat the password",
  "e2e.create.warn_title": "NO WAY BACK",
  "e2e.create.warn_body": "Files in this folder can only be opened with this password or the recovery key shown once when the folder is created. The password is NEVER stored on the server, and filex keeps no copy of the recovery key either. Lose both and the contents are gone for good.",
  "e2e.create.ack": "I understand: if I lose both the password and the recovery key, my data cannot be recovered.",
  "e2e.create.ack_required": "Please confirm the warning to continue.",
  "e2e.create.pw_short": "Password must be at least 8 characters.",
  "e2e.create.pw_mismatch": "Passwords do not match.",
  "e2e.create.bad_name": "Invalid folder name.",
  "e2e.create.create": "Create encrypted folder",
  "e2e.create.busy": "Creating…",
  "e2e.create.done": "Encrypted folder created",
  "e2e.create.failed": "Could not create the encrypted folder",
  "e2e.create.nested": "You cannot create an encrypted folder inside another one.",
  "e2e.locked.title": "This folder is end-to-end encrypted",
  "e2e.locked.hint": "Enter the folder password to see its contents. The password stays in this tab’s memory only.",
  "e2e.locked.pw_placeholder": "Folder password",
  "e2e.locked.unlock": "Unlock",
  "e2e.locked.busy": "Verifying…",
  "e2e.unlock.wrong": "Wrong password.",
  "e2e.unlock.marker_missing": "Could not read the key file (.filex-e2e.json).",
  /* ikon:emoji — the listing marker's accessible name. The row used to print
     a 🔒 and nothing else; the padlock that replaced it is aria-hidden inside
     the tile, so the span that carries it says this instead. */
  "e2e.badge": "Encrypted folder",
  "e2e.strip.label": "Encrypted folder — unlocked",
  "e2e.strip.lock": "Lock",
  "e2e.locked_toast": "Folder locked",
  "e2e.upload.too_big": "Files over 200 MB cannot be uploaded to an encrypted folder (MVP limit)",
  "e2e.upload.locked": "Unlock the folder first",
  "e2e.decrypting": "Decrypting…",
  "e2e.decrypt_failed": "Could not decrypt the file (password changed or file corrupted).",
  /* wiring:e2 recovery — recovery keys + operator escrow */
  "e2e.create.escrow_title": "This server holds a second key",
  "e2e.create.escrow_body": "Key escrow is enabled on this installation, so its operator can open this folder without your password. Using that key notifies you. Escrow is fixed when the server is installed and cannot be turned off for a folder.",
  "e2e.locked.use_recovery": "Lost the password? Use a recovery key",
  "e2e.recovery.title": "Save your recovery key",
  "e2e.recovery.title_upgraded": "Your recovery key",
  "e2e.recovery.lead": "This key opens the folder without its password. It is shown once — filex does not store it and cannot show it again.",
  "e2e.recovery.lead_upgraded": "This folder now has a recovery key. It opens the folder without its password, is shown once, and is not stored by filex.",
  "e2e.recovery.copy": "Copy",
  "e2e.recovery.copied": "Copied",
  "e2e.recovery.download": "Download as a file",
  "e2e.recovery.warn_title": "TREAT THIS LIKE A PASSWORD",
  "e2e.recovery.warn_body": "Anyone holding this key can read the folder. Keep it somewhere separate from the password — a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.escrow_title": "This server also holds a key",
  "e2e.recovery.escrow_body": "Key escrow is enabled here, so the operator of this installation can open this folder without your password. You are notified when that key is used.",
  "e2e.recovery.escrow_kid": "Escrow key",
  "e2e.recovery.ack": "I have saved this key somewhere safe.",
  "e2e.recovery.done": "Done",
  "e2e.recover.title": "Unlock without the password",
  "e2e.recover.none": "This folder was created before recovery keys existed, so it has none. Its password is the only way in. Unlock it with the password once and filex will offer to add a recovery key.",
  "e2e.recover.tab_recovery": "Recovery key",
  "e2e.recover.tab_escrow": "Escrow key",
  "e2e.recover.recovery_hint": "The key shown once when this folder was created.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "The owner will be told",
  "e2e.recover.escrow_warn_body": "Opening a folder with the escrow key notifies its owner. Use it only when you are entitled to.",
  "e2e.recover.escrow_kid": "Escrow key",
  "e2e.recover.escrow_predates": "This installation has an escrow key, but this folder does not. It was created before escrow was turned on here, so its master key was never wrapped to the escrow identity. The escrow key will not open it. Nothing the operator can do changes that — adding a slot needs this folder’s password, which the server has never had. The folder’s owner can grant it: unlock with the password, then choose to give the operator a key. Until they do, use the password or the recovery key.",
  "e2e.recover.escrow_other_key": "This folder carries an escrow key from a DIFFERENT installation. It was created elsewhere and restored here, so this installation’s escrow key does not open it. Only the private key belonging to the escrow key it was sealed to can.",
  "e2e.recover.escrow_placeholder": "Paste the escrow private key (PKCS#8, base64 or PEM)",
  "e2e.recover.bad_format": "That does not look like a recovery key. It is 32 characters in eight groups of four.",
  "e2e.recover.escrow_required": "Paste the escrow private key.",
  "e2e.recover.wrong_recovery": "That recovery key does not open this folder.",
  "e2e.recover.wrong_escrow": "That escrow key does not open this folder. Folders created before escrow was enabled have no escrow key, and cannot be given one.",
  "e2e.recover.bad_escrow_key": "That is not a readable private key (expected PKCS#8, base64 or PEM).",
  "e2e.recover.notify_failed": "Could not notify the folder owner, so the folder was not unlocked. Escrow use is always announced.",
  "e2e.recover.recovery_done": "Unlocked with the recovery key",
  "e2e.recover.escrow_done": "Unlocked with the escrow key — the owner has been notified",
  "e2e.recover.unlock": "Unlock",
  "e2e.recover.busy": "Unlocking…",
  "e2e.escrowoffer.title": "Give the operator a key to this folder?",
  "e2e.escrowoffer.body": "This folder was created before key escrow was turned on here, so the operator of this installation cannot open it. Right now — while your password is in memory — filex can seal this folder to the escrow key. Your files are not re-encrypted or moved; only the key file changes.",
  "e2e.escrowoffer.consequence": "What this means: the operator gains a second, permanent way into this folder, without your password. You are notified when that key is used, but that notification is an announcement rather than a control.",
  "e2e.escrowoffer.learn_more": "What escrow can and cannot do",
  "e2e.escrowoffer.password_label": "Folder password",
  "e2e.escrowoffer.password_required": "Enter the folder password.",
  "e2e.escrowoffer.wrong_password": "That is not this folder’s password.",
  "e2e.escrowoffer.accept": "Give the operator a key",
  "e2e.escrowoffer.decline": "No, keep it to myself",
  "e2e.escrowoffer.cancel": "Cancel",
  "e2e.escrowoffer.busy": "Sealing…",
  "e2e.escrowoffer.done": "The operator can now open this folder with the escrow key",
  "e2e.escrowoffer.declined_toast": "Kept to yourself. filex will not ask again for this folder.",
  "e2e.escrowoffer.decline_failed": "Could not record your answer, so filex will ask again next time. Nothing about the folder changed.",
  "e2e.escrowoffer.failed": "Could not give the operator a key to this folder",
  "e2e.escrowoffer.strip_action": "Escrow key…",
  "e2e.upgrade.title": "This folder has no recovery key",
  "e2e.upgrade.body": "It was created before recovery keys existed, so its password is the only way in. Right now — and only right now, while the password is in memory — filex can add one. Your files are not re-encrypted or moved.",
  "e2e.upgrade.escrow_note": "Note: this installation has key escrow enabled, so adding a recovery key also lets its operator open this folder without your password.",
  "e2e.upgrade.accept": "Create a recovery key",
  "e2e.upgrade.decline": "Not now",
  "e2e.upgrade.busy": "Creating…",
  "e2e.upgrade.failed": "Could not add a recovery key to this folder",
  "e2e.download.failed": "Could not download the encrypted file.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Storage connections",
  "conn.subtitle": "Connect {host} to a backend, or connect your computer to {host}.",
  "conn.close": "Close",
  "conn.tab.storages": "Storages",
  "conn.tab.connect": "How to connect",
  "conn.loading": "Loading…",
  "conn.visibleOnly": "you can browse this one",
  "conn.denied.title": "Only an administrator can add storages here",
  "conn.denied.none": "Your account may browse files but not change what this server is connected to. Ask an administrator of this server to add or edit a storage.",
  "conn.denied.anonymous": "You are not signed in on this server.",
  "conn.denied.unreachable": "The server did not answer: {error}",
  "conn.denied.guideHint": "You do not need administrator rights to connect your own computer to the storages you can already see.",
  "conn.denied.guideCta": "Show me how to connect",
  "conn.list.count": "{n} storages",
  "conn.list.count_one": "1 storage",
  "conn.list.add": "Add a storage",
  "conn.list.empty": "No storage is configured yet. Add one and the files show up in the explorer.",
  "conn.list.edit": "Edit",
  "conn.list.remove": "Remove",
  "conn.list.confirm": "Really remove?",
  "conn.list.readOnly": "read-only",
  "conn.list.disabled": "disabled",
  "conn.form.newTitle": "New storage",
  "conn.form.editTitle": "Edit “{name}”",
  "conn.form.name": "Display name",
  "conn.form.namePlaceholder": "photos",
  "conn.form.nameHelp": "What this storage is called everywhere: in the explorer, in paths (name://folder) and in WebDAV URLs.",
  "conn.form.driver": "Type",
  "conn.form.driverLocked": "A storage's type cannot change after it is created — the paths already point at it.",
  "conn.form.readOnly": "Read-only (nothing may be written to this storage)",
  "conn.form.enabled": "Enabled",
  "conn.form.test": "Test connection",
  "conn.form.testing": "Testing…",
  "conn.form.testOk": "Connected. {count} items at the root.",
  "conn.form.testOk_one": "Connected. 1 item at the root.",
  "conn.form.testFail": "Could not connect: {error}",
  "conn.form.save": "Save",
  "conn.form.saving": "Saving…",
  "conn.form.cancel": "Cancel",
  "conn.form.nameRequired": "Give the storage a name.",
  "conn.form.fillRequired": "Fill in the fields marked with *.",
  "conn.form.required": "Required",
  "conn.form.advanced": "Advanced settings",
  "conn.form.noFields": "This server did not describe any settings for this driver.",
  "conn.form.reveal": "Show",
  "conn.form.hide": "Hide",
  "conn.guide.protocol": "Protocol",
  "conn.guide.storage": "Storage",
  "conn.guide.allStorages": "All storages",
  "conn.guide.copy": "Copy",
  "conn.guide.copied": "Copied",
  "conn.guide.goodToKnow": "Good to know",
  "conn.guide.userPlaceholder": "your-email@example.com",
  "conn.guide.secretPlaceholder": "your-password-or-token",
  "conn.guide.fact.url": "Address",
  "conn.guide.fact.urlRootHint": "Every storage you can see appears as a folder under this address.",
  "conn.guide.fact.urlStorageHint": "Mounts “{storage}” directly. Drop the last segment to see every storage.",
  "conn.guide.fact.user": "Username",
  "conn.guide.fact.password": "Password",
  "conn.guide.webdav.summary": "WebDAV mounts filex as a drive: Windows Explorer, macOS Finder, Linux, rclone and Cyberduck all speak it, and every change is mirrored back into filex.",
  "conn.guide.webdav.userHint": "Your filex account e-mail — not a display name.",
  "conn.guide.webdav.passwordHint": "Your account password, or an API token (Settings → API tokens). An account with two-factor authentication MUST use a token: Basic auth has no second-factor slot.",
  "conn.guide.webdav.win.s1": "Open File Explorer, right-click This PC and choose “Map network drive…”.",
  "conn.guide.webdav.win.s2": "Pick a drive letter and enter {url} as the folder.",
  "conn.guide.webdav.win.s3": "Tick “Connect using different credentials” and sign in with the username and password above.",
  "conn.guide.webdav.win.cmdCaption": "Command Prompt (same thing, without the wizard)",
  "conn.guide.webdav.win.limits": "Windows has three built-in limits that look exactly like filex bugs: transfers stop at ~47.7 MB, folders with about a thousand files refuse to open (“Disk is not formatted”), and the WebClient service must be restarted after changing either.",
  "conn.guide.webdav.win.regCaption": "Run as administrator, then reconnect the drive",
  "conn.guide.webdav.win.https": "HTTPS is mandatory. Windows sends Basic credentials over TLS only, and over plain http:// it silently refuses with no useful message. Do not set BasicAuthLevel to 2 — use TLS.",
  "conn.guide.webdav.win.persist": "The mapped drive does not survive a sign-out: since Windows 7 Basic credentials cannot be stored in Credential Manager, and /persistent:yes does not change that. Re-run the command from a logon script if you need it back automatically.",
  "conn.guide.webdav.win.service": "If nothing mounts at all, make sure the WebClient service is running: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "In Finder choose Go → Connect to Server… (⌘K).",
  "conn.guide.webdav.mac.s2": "Enter {url} and connect.",
  "conn.guide.webdav.mac.s3": "Authenticate with the username and password above.",
  "conn.guide.webdav.mac.note": "The drive appears under Locations; each storage is a top-level folder.",
  "conn.guide.webdav.linux.mountCaption": "davfs2, or the desktop file manager (GNOME Files, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "or paste this address into GNOME Files / Dolphin",
  "conn.guide.webdav.linux.locks": "davfs2 needs locking turned off. filex keeps WebDAV locks in process memory, so they do not survive a restart and are not shared between replicas — davfs2 assumes otherwise and hangs.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone stores an obscured password — run this first and paste the output below",
  "conn.guide.webdav.rclone.passPlaceholder": "<output of rclone obscure>",
  "conn.guide.webdav.rclone.useCaption": "Using it",
  "conn.guide.webdav.duck.s1": "New Bookmark → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Server {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Path {path}.",
  "conn.guide.webdav.duck.s4": "Username {user}, password as above.",
  "conn.guide.webdav.note.delete": "A WebDAV delete is permanent. The web UI moves files to the filex trash; a client delete removes the object from the backing storage directly.",
  "conn.guide.webdav.note.locks": "Locks live in server memory: they do not survive a restart and are not shared between replicas. They exist to satisfy Windows and Office, not to arbitrate concurrent edits.",
  "conn.guide.webdav.note.permissions": "You see exactly what you see in the web UI. The root lists only the storages you may open, and a path outside your grants answers 404 rather than 403, so the tree never leaks what exists.",
  "conn.guide.webdav.note.http": "This server is reachable over plain http://. Windows will refuse to send your credentials at all, and every other client sends your password in the clear. Put filex behind TLS before mounting it.",
  // ── S3 endpoint: keys and the guide ──────────────────────────────
  "conn.s3keys.title": "S3 access keys",
  "conn.s3keys.lead": "An access key lets any S3 client — rclone, restic, the AWS CLI, mc, s3fs, Cyberduck — connect to filex. It carries your own permissions and nothing more.",
  "conn.s3keys.disabled": "The S3 endpoint is switched off on this server (FILEX_S3). A key minted here will not connect until an operator turns it back on.",
  "conn.s3keys.cannotMint": "You are not signed in with an account that can mint access keys. The instructions below still apply — ask for a key and paste it in.",
  "conn.s3keys.label": "What is it for? (laptop backup, CI, …)",
  "conn.s3keys.defaultLabel": "access key",
  "conn.s3keys.everyBucket": "Every bucket I can see",
  "conn.s3keys.prefix": "Folder inside the bucket (optional)",
  "conn.s3keys.mint": "Create key",
  "conn.s3keys.inheritNote": "A key can only ever narrow what you already have: your grants, your tenant, your role. Confining it to one bucket or folder is the difference between a laptop backup and a credential that can read everything.",
  "conn.s3keys.once": "Copy the secret now — this is the only time it is shown.",
  "conn.s3keys.accessKeyID": "Access key ID",
  "conn.s3keys.secret": "Secret key",
  "conn.s3keys.dismiss": "I have copied it",
  "conn.s3keys.col.label": "Label",
  "conn.s3keys.col.key": "Access key ID",
  "conn.s3keys.col.scope": "Limited to",
  "conn.s3keys.col.lastUsed": "Last used",
  "conn.s3keys.scopeAll": "everything you can see",
  "conn.s3keys.noLabel": "(no label)",
  "conn.s3keys.neverUsed": "never",
  "conn.s3keys.enable": "Enable",
  "conn.s3keys.disable": "Disable",
  "conn.s3keys.revoke": "Revoke",
  "conn.s3keys.confirm": "Sure?",
  "conn.s3keys.empty": "No access keys yet.",
  "conn.guide.s3.summary": "The S3 endpoint makes filex the destination for anything that speaks S3 — backups, sync tools, SDKs — using the storages you already have.",
  "conn.guide.s3.keyPlaceholder": "create a key above",
  "conn.guide.s3.secretPlaceholder": "shown once, when you create the key",
  "conn.guide.s3.fact.endpoint": "Endpoint",
  "conn.guide.s3.fact.endpointHint": "Point the client here, not at the web address of filex.",
  "conn.guide.s3.fact.bucket": "Bucket",
  "conn.guide.s3.fact.bucketHint": "A bucket is a filex storage. Buckets are created by an administrator, not by the client.",
  "conn.guide.s3.fact.key": "Access key ID",
  "conn.guide.s3.fact.keyHint": "The public half. It travels in every request.",
  "conn.guide.s3.fact.secret": "Secret key",
  "conn.guide.s3.fact.secretHint": "Shown once, when the key is created. filex cannot show it again — create a new key if it is lost.",
  "conn.guide.s3.fact.region": "Region",
  "conn.guide.s3.fact.regionHint": "filex has no regions; any value works and is echoed back. Clients still insist on one.",
  "conn.guide.s3.fact.addressing": "Addressing",
  "conn.guide.s3.fact.pathStyle": "path-style (required)",
  "conn.guide.s3.fact.pathStyleHint": "There is no dedicated S3 host on this install, so bucket.host does not resolve.",
  "conn.guide.s3.fact.virtualHosted": "virtual-hosted or path-style",
  "conn.guide.s3.fact.virtualHostedHint": "This install has its own S3 host, so both styles work.",
  "conn.guide.s3.rclone.useCaption": "Use it",
  "conn.guide.s3.rclone.mtime": "filex carries the file modification time (x-amz-meta-mtime), so rclone sync settles after the first run instead of re-uploading everything.",
  "conn.guide.s3.aws.configureCaption": "Configure once",
  "conn.guide.s3.aws.useCaption": "Use it",
  "conn.guide.s3.aws.pathStyle": "Add path addressing to your AWS config, or every command fails at DNS.",
  "conn.guide.s3.restic.envCaption": "Environment",
  "conn.guide.s3.restic.useCaption": "Back up, verify, prune",
  "conn.guide.s3.restic.verified": "Verified against this endpoint: restic check --read-data reads every pack byte for byte and reports no errors.",
  "conn.guide.s3.mc.aliasCaption": "Add the alias",
  "conn.guide.s3.mc.useCaption": "Use it",
  "conn.guide.s3.s3fs.credsCaption": "Credentials file",
  "conn.guide.s3.s3fs.mountCaption": "Mount it",
  "conn.guide.s3.s3fs.note": "Editing a file over s3fs rewrites the whole object, and a delete goes to the filex trash. Good for a shared folder, not for a database.",
  "conn.guide.s3.duck.s1": "New bookmark → Amazon S3.",
  "conn.guide.s3.duck.s2": "Server: {host}.",
  "conn.guide.s3.duck.s3": "Access key ID: {key}, secret as above.",
  "conn.guide.s3.duck.s4": "Open the bookmark; the buckets are your filex storages.",
  "conn.guide.s3.duck.pathStyle": 'In Preferences → S3, turn OFF "Use virtual host style" — this install has no wildcard S3 host.',
  "conn.guide.s3.sdk.note": "Any SigV4 client works the same way: endpoint, key, secret, and path addressing when this install has no S3 host of its own.",
  "conn.guide.s3.note.buckets": "A bucket is a filex storage. A client can create folders and objects inside one, but not the bucket itself — that needs a driver and a path, which an S3 request cannot express.",
  "conn.guide.s3.note.permissions": 'The key sees exactly what you see. A bucket you may not open answers "no such bucket" rather than "forbidden", so the endpoint never reveals what exists.',
  "conn.guide.s3.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.s3.note.mtime": "Uploads carry their modification time, and the checksums clients send (Content-MD5, x-amz-checksum-*) are verified — a corrupted upload is refused rather than stored.",
  "conn.guide.s3.note.pathStyle": "This install has no dedicated S3 host, so clients must be told to use path-style addressing. Without it a current SDK fails at DNS with an error that names neither filex nor the cause.",
  "conn.guide.s3.note.http": "This endpoint is plain http://. Signatures still protect the request, but the objects travel in the clear. Put filex behind TLS before pointing a backup at it.",
  // ── SFTP endpoint: keys and the guide ────────────────────────────
  "conn.sshkeys.title": "SSH keys",
  "conn.sshkeys.lead": "Register a public key and every SSH client — sftp, scp, WinSCP, FileZilla, rclone, sshfs — can connect without sending your password.",
  "conn.sshkeys.disabled": "The SFTP endpoint is switched off on this server (FILEX_SFTP). A key registered here will not connect until an operator turns it back on.",
  "conn.sshkeys.cannotAdd": "You are not signed in with an account that can register keys.",
  "conn.sshkeys.paste": "Paste the contents of ~/.ssh/id_ed25519.pub",
  "conn.sshkeys.name": "Name (optional — the key comment is used otherwise)",
  "conn.sshkeys.add": "Add key",
  "conn.sshkeys.noCopyId": "ssh-copy-id cannot work here: it appends to ~/.ssh/authorized_keys over a shell, and filex has none. This box is the way in.",
  "conn.sshkeys.col.name": "Name",
  "conn.sshkeys.col.fingerprint": "Fingerprint",
  "conn.sshkeys.col.added": "Added",
  "conn.sshkeys.col.lastUsed": "Last used",
  "conn.sshkeys.noName": "(no name)",
  "conn.sshkeys.neverUsed": "never",
  "conn.sshkeys.enable": "Enable",
  "conn.sshkeys.disable": "Disable",
  "conn.sshkeys.remove": "Remove",
  "conn.sshkeys.confirm": "Sure?",
  "conn.sshkeys.empty": "No keys yet. Without one, clients sign in with your account password.",
  "conn.guide.sftp.summary": "SFTP makes filex reachable by anything that already speaks SSH — a backup job, a scanner, WinSCP, rclone, or a mounted folder.",
  "conn.guide.sftp.fact.host": "Host",
  "conn.guide.sftp.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Not 22 and not 443: SFTP is raw TCP and cannot go through the web proxy.",
  "conn.guide.sftp.fact.userHint": "Your short login name. An @ in a login has to be quoted in most client config files, which is what this avoids.",
  "conn.guide.sftp.fact.auth": "Sign in with",
  "conn.guide.sftp.fact.authKey": "your registered SSH key (or your password)",
  "conn.guide.sftp.fact.authPassword": "your account password — or register a key above",
  "conn.guide.sftp.fact.authHint": "An API token works as a password too, and is revocable on its own. An account with two-factor sign-in must use a key or a token.",
  "conn.guide.sftp.fact.path": "Path",
  "conn.guide.sftp.fact.pathHint": "The first folder is a storage; the root lists the ones you may open.",
  "conn.guide.sftp.openssh.connectCaption": "Connect, put, get",
  "conn.guide.sftp.openssh.noShell": "There is no shell here — only the SFTP subsystem. `ssh host command` is refused on purpose, and scp works because OpenSSH 9 speaks SFTP for it.",
  "conn.guide.sftp.key.tab": "Set up a key",
  "conn.guide.sftp.key.s1": "Generate a key pair on the machine that will connect (skip if you already have one).",
  "conn.guide.sftp.key.s2": "Copy the PUBLIC half — the .pub file, never the other one.",
  "conn.guide.sftp.key.s3": "Paste it into the box above and connect; no password is sent from then on.",
  "conn.guide.sftp.key.genCaption": "On your own machine",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id will NOT work against filex: it needs a shell to append to ~/.ssh/authorized_keys, and there is none. Paste the key above instead.",
  "conn.guide.sftp.winscp.s1": "New site → File protocol: SFTP.",
  "conn.guide.sftp.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "User name: {user}. For a key: Advanced → SSH → Authentication → private key file.",
  "conn.guide.sftp.winscp.s4": "WinSCP needs a .ppk private key — use its own tool (Tools → PuTTYgen) to convert an OpenSSH key once.",
  "conn.guide.sftp.filezilla.s1": "File → Site Manager → New site, Protocol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "User: {user}. Logon type: Normal for a password, or Key file for a key.",
  "conn.guide.sftp.rclone.useCaption": "Use it",
  "conn.guide.sftp.sshfs.mountCaption": "Mount and unmount",
  "conn.guide.sftp.sshfs.note": "A mounted folder rewrites the whole file on every save. Good for documents, not for a database or a video you are editing in place.",
  "conn.guide.sftp.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.sftp.note.permissions": "The permission bits your client draws come from your access level here, so a file shown as read-only really is one for you.",
  "conn.guide.sftp.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.sftp.note.totp": "If your account has two-factor sign-in, the password will not work here — SSH has no way to ask for the code. Register a key, or use an API token as the password.",
  "conn.guide.sftp.note.disabled": "The SFTP endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS is here for the equipment that only ever learned FTP — scan-to-folder printers, EDI counterparties, older lab and industrial software. Always over TLS.",
  "conn.guide.ftps.fact.host": "Host",
  "conn.guide.ftps.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "The control channel. Data moves on a separate port from the passive range below.",
  "conn.guide.ftps.fact.mode": "Encryption",
  "conn.guide.ftps.fact.modeValue": "FTPS — explicit TLS (AUTH TLS), required",
  "conn.guide.ftps.fact.modeHint": 'Plain FTP is refused before the password is read. Choose "Require explicit FTP over TLS", never "plain FTP" and never "implicit".',
  "conn.guide.ftps.fact.userHint": "Your short login name, or your e-mail. An API token works as the password too and can be revoked on its own.",
  "conn.guide.ftps.fact.passwordHint": "Your account password, or an API token. An account with two-factor sign-in must use a token — FTP has no way to ask for the code.",
  "conn.guide.ftps.fact.pasv": "Passive ports",
  "conn.guide.ftps.fact.pasvHint": "Data connections land here. If your firewall blocks this range the transfer HANGS with no error on either side — that is the classic FTP failure.",
  "conn.guide.ftps.filezilla.s1": "File → Site Manager → New site, Protocol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Encryption: "Require explicit FTP over TLS". Logon type: Normal, user: {user}.',
  "conn.guide.ftps.filezilla.s4": "Transfer settings → Passive. Active mode is refused by this server.",
  "conn.guide.ftps.winscp.s1": "New site → File protocol: FTP, Encryption: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "User name: {user}, password as above.",
  "conn.guide.ftps.curl.caption": "Upload and download",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd is not optional: it makes curl REQUIRE TLS instead of falling back to plaintext. This server refuses plaintext anyway, but the habit protects you against the servers that do not.",
  "conn.guide.ftps.lftp.caption": "Connect",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data encrypts the FILE as well as the login. Without it lftp logs in over TLS and then sends your file in the clear — which is the FTPS misconfiguration people actually ship.",
  "conn.guide.ftps.rclone.useCaption": "Use it",
  "conn.guide.ftps.printer.tab": "Scanner / printer",
  "conn.guide.ftps.printer.s1": "In the device's scan-to-FTP settings: server {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "User: {user}, password as above. Create an API token for the device rather than using your own password — it can be revoked without changing anything else.",
  "conn.guide.ftps.printer.s3": "Path: {path} — or a folder inside it that you created first. The device cannot create a storage.",
  "conn.guide.ftps.printer.s4": 'Turn ON "SSL/TLS" or "FTPS explicit", and PASSIVE mode.',
  "conn.guide.ftps.printer.noTLS": "Plenty of scan-to-FTP firmware cannot do TLS at all. This server will not talk to such a device, and that is deliberate — the alternative is your documents and your password crossing the office network in the clear.",
  "conn.guide.ftps.note.tls": "TLS is mandatory and there is no switch to turn it off. Plain FTP sends your password in the clear and your file after it.",
  "conn.guide.ftps.note.passive": "Passive mode only. Active mode has the server dial back to the client, which does not survive NAT and is blocked by most firewalls.",
  "conn.guide.ftps.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.ftps.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.ftps.note.prefer": "If the client can speak SFTP, prefer it: one connection, one port, no passive-mode surprises.",
  "conn.guide.ftps.note.selfSigned": "This server is using a self-signed certificate. It encrypts the channel but proves nothing about who is on the other end — most clients will ask you to accept it once. Supply a real certificate for anything that matters.",
  "conn.guide.ftps.note.disabled": "The FTPS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS exports",
  "conn.nfs.lead": "An export lets a machine on your network mount filex as a drive — a media player, a build server, a backup box.",
  "conn.nfs.pathIsSecret": "⚠ The export path IS the password. NFS cannot ask a client who it is without Kerberos, so filex puts 32 random bytes in the path instead: whoever knows it can mount as you. Treat the mount line like a credential — /etc/fstab is world-readable on most systems.",
  "conn.nfs.disabled": "The NFS endpoint is switched off on this server (FILEX_NFS). An export created here will not mount until an operator turns it back on.",
  "conn.nfs.cannotMint": "You are not signed in with an account that can create exports.",
  "conn.nfs.label": "What is it for? (media player, backup box, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Every storage I can see",
  "conn.nfs.prefix": "Folder inside the storage (optional)",
  "conn.nfs.allowCidrs": "Allowed addresses, e.g. 192.168.1.0/24 (optional)",
  "conn.nfs.readOnly": "Read-only",
  "conn.nfs.readOnlyHint": "Read-only is the safer default for a machine: it refuses every write through this mount whatever your own permissions are. An address list narrows it further — outside it, the mount is refused.",
  "conn.nfs.mint": "Create export",
  "conn.nfs.once": "Copy this now — the path is shown only once and cannot be recovered.",
  "conn.nfs.dismiss": "I have copied it",
  "conn.nfs.col.label": "Label",
  "conn.nfs.col.scope": "Limited to",
  "conn.nfs.col.mode": "Mode",
  "conn.nfs.col.lastUsed": "Last mounted",
  "conn.nfs.scopeAll": "everything you can see",
  "conn.nfs.modeRead": "read-only",
  "conn.nfs.modeWrite": "read/write",
  "conn.nfs.noLabel": "(no label)",
  "conn.nfs.neverUsed": "never",
  "conn.nfs.enable": "Enable",
  "conn.nfs.disable": "Disable",
  "conn.nfs.revoke": "Revoke",
  "conn.nfs.confirm": "Sure?",
  "conn.nfs.empty": "No exports yet.",
  "conn.guide.nfs.summary": "NFS mounts filex as a drive on a machine in your own network — the NAS protocol, for the devices that expect one.",
  "conn.guide.nfs.pathPlaceholder": "create an export above",
  "conn.guide.nfs.fact.host": "Host",
  "conn.guide.nfs.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Both port= and mountport= must be set to this; filex serves the mount and NFS services on one port.",
  "conn.guide.nfs.fact.export": "Export path",
  "conn.guide.nfs.fact.exportHint": "This is the credential. It is shown once, when you create the export, and is stored hashed — filex cannot show it again.",
  "conn.guide.nfs.fact.options": "Mount options",
  "conn.guide.nfs.fact.optionsHint": "nolock because filex does not run the NFS lock manager; nfsvers=3 because that is what this server speaks.",
  "conn.guide.nfs.linux.mountCaption": "Mount it",
  "conn.guide.nfs.linux.fstabSecret": "An /etc/fstab line containing this path is a password in a world-readable file. Use a credentials-protected automount, or keep the mount in a root-only unit, if that matters where you are.",
  "conn.guide.nfs.mac.mountCaption": "Mount it",
  "conn.guide.nfs.mac.resvport": "macOS needs resvport: its client insists on a privileged source port and refuses the mount without it.",
  "conn.guide.nfs.win.s1": 'Turn on "Services for NFS" → "Client for NFS" in Windows Features (Pro and Enterprise only; Home does not have it).',
  "conn.guide.nfs.win.s2": "Open a Command Prompt as administrator.",
  "conn.guide.nfs.win.s3": "Map the export to a drive letter with the command below.",
  "conn.guide.nfs.win.cmdCaption": "Map it to Z:",
  "conn.guide.nfs.win.port": "Windows has no way to say which port the mount service is on, so it can only reach an NFS server on the standard port 2049. If this server is on another port, use SFTP or the filex desktop app instead.",
  "conn.guide.nfs.nas.tab": "NAS / media player",
  "conn.guide.nfs.nas.s1": "In the device's NFS settings: server {host}, port {port} (set both the NFS and the mount port if it asks for them separately).",
  "conn.guide.nfs.nas.s2": "Remote path: the export path above, exactly as shown.",
  "conn.guide.nfs.nas.s3": "NFS version 3, no locking. Create the export read-only unless the device genuinely needs to write.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 is not encrypted. Anyone who can read the traffic sees your files, and anyone who learns the path can mount them. Use it on a home or office network, or over a VPN — never across the internet.",
  "conn.guide.nfs.note.pathIsSecret": "The export path is the whole credential. Revoke it from the list above if it leaks; there is nothing else to change.",
  "conn.guide.nfs.note.noPortmapper": "There is no portmapper on port 111, so a client that is not told the port cannot find the server. That is why every command here carries port= and mountport=.",
  "conn.guide.nfs.note.uid": "The user and group ids your client sends are ignored: the mount already knows whose it is. The permissions you see come from your access in filex.",
  "conn.guide.nfs.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.nfs.note.revoke": "Revoking takes effect on the next request, not instantly: NFS has no session to end, so a client with the mount open sees its next operation fail.",
  "conn.guide.nfs.note.disabled": "The NFS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  "conn.tokens.title": "API tokens",
  "conn.tokens.lead": "FTPS, WebDAV and filex mount all sign in with a token instead of your account password. Mint one here — it can be revoked on its own, and an account with two-factor sign-in cannot use its password on these at all.",
  "conn.tokens.mint": "Create token",
  "conn.tokens.once": "Copy it now — this is the only time it is shown. Only a hash is stored, so it cannot be shown again.",
  "conn.tokens.dismiss": "I have copied it",
  "conn.tokens.cannotMint": "This session cannot create tokens. Sign in with your own account to make one.",
  "conn.tokens.empty": "No tokens yet.",
  "conn.tokens.neverUsed": "never",
  "conn.tokens.revoke": "Revoke",
  "conn.tokens.confirm": "Sure?",
  "conn.tokens.col.label": "Name",
  "conn.tokens.col.scopes": "Can do",
  "conn.tokens.col.used": "Last used",
  "conn.tokens.revokeHint": "Revoking stops a connection that is already open, not just the next sign-in: an SFTP or FTPS session is cut and a mount stops working within about half a minute.",
  "conn.guide.mount.summary": "filex mount attaches a remote filex server to a folder on this machine, over the same HTTPS the browser uses. It is the only one of these that works from anywhere — no LAN, no extra server, no third-party client.",
  "conn.guide.mount.fact.url": "Server URL",
  "conn.guide.mount.fact.urlHint": "The same address you use in the browser. Nothing else has to be reachable.",
  "conn.guide.mount.fact.token": "API token",
  "conn.guide.mount.fact.tokenPlaceholder": "create one under Tokens",
  "conn.guide.mount.fact.tokenHint": "A token, not your password — it can be revoked on its own, and an account with 2FA cannot use its password here at all.",
  "conn.guide.mount.fact.remote": "What to mount",
  "conn.guide.mount.fact.remoteHint": "Leave --remote off to see every storage as a folder, or name one storage — or a folder inside it — to mount just that.",
  "conn.guide.mount.linux.mountCaption": "Mount it",
  "conn.guide.mount.linux.umountCaption": "Unmount it",
  "conn.guide.mount.linux.umountWarn": "Unmount with fusermount, not by killing the process. A mount whose process died without detaching leaves a folder where every ls hangs until somebody runs fusermount by hand.",
  "conn.guide.mount.linux.systemdCaption": "Mount it at login (systemd user unit)",
  "conn.guide.mount.win.winfsp": "Windows needs WinFsp installed once — it is free and open source: https://winfsp.dev. Nothing else, and no administrator rights after that.",
  "conn.guide.mount.win.mountCaption": "Mount it as a drive",
  "conn.guide.mount.win.freeLetter": "Pick a drive letter that is FREE. The letter is created by the mount, not attached to something that already exists, and pointing it at one that is in use fails with a message that does not say so.",
  "conn.guide.mount.win.stop": "Stop it with Ctrl-C in that window. The drive disappears and nothing is left behind on this machine.",
  "conn.guide.mount.mac.unsupported": "filex mount does not work on macOS. It needs macFUSE, whose licence does not allow a program like filex to install it for you, and whose Go binding needs a C compiler filex deliberately does not require. The command refuses here rather than appearing to work and doing nothing.",
  "conn.guide.mount.mac.alternatives": "On macOS, use the filex desktop app with folder sync (keeps the files on disk), or SFTP with a client that mounts drives.",
  "conn.guide.mount.note.notASync": "This is not a sync. Nothing is copied to this machine except a small read cache, so a mount opens one file out of a hundred thousand without downloading the rest. If you want the files when you are offline, use folder sync instead.",
  "conn.guide.mount.note.reachable": "It reaches the server through whatever proxy or tunnel the browser goes through, because underneath it is the same API. Your permissions, your storages and — on a multi-tenant server — your tenant come with it.",
  "conn.guide.mount.note.wholeFileWrites": "A file you write through the mount is uploaded when the program closes it, not while it is being written. Editing a very large file in place is slower here than a local disk; copying it in and out is not.",
  "conn.guide.mount.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.mount.note.revoke": "Revoke the token to stop a mount. It stops serving within half a minute, even if the mount is still attached.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Local filesystem",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "The share name alone, without the server: `media`, not `\\\\nas\\media`.",
  "storages.fieldHelp.smbDomain": "Only for a Windows domain account. Leave empty for a NAS.",
  "storages.fieldHelp.smbRoot": "Sub-folder inside the share. Leave empty for the whole share.",
  "storages.fields.share": "Share",
  "storages.fields.domain": "Domain / workgroup",
  "storages.fields.dialTimeout": "Connect timeout (seconds)",
  "storages.fieldHelp.disablePresign": "On by default: uploads and the downloads behind public share links stream through filex, so the bucket endpoint never has to be reachable from a browser (a LAN-only MinIO just works). Turn it off only when the endpoint is reachable from your users' browsers (AWS, a public MinIO) and you want them to talk to the bucket directly — faster for very large files, and the store must accept SDK-signed URLs (Ceph RGW / some Hetzner setups answer SignatureDoesNotMatch).",
  "storages.fieldHelp.endpoint": "Leave empty for AWS S3. Any S3-compatible store needs its endpoint.",
  "storages.fieldHelp.hostKey": "A single public key in authorized_keys / known_hosts line form.",
  "storages.fieldHelp.insecureSkipHostKey": "Accepts any host key. Only for throwaway hosts.",
  "storages.fieldHelp.keyPath": "Path to a key file on the server, read when the storage starts. Used when the PEM field is empty.",
  "storages.fieldHelp.knownHosts": "OpenSSH known_hosts path for strict host-key checking. Default is trust-on-first-use in ~/.filex/known_hosts.",
  "storages.fieldHelp.passive": "Off switches to active mode, which needs the server to dial back into this host.",
  "storages.fieldHelp.path": "Directory on the server. It is created if missing; filex never mounts /.",
  "storages.fieldHelp.pathStyle": "On for every non-AWS store. It is turned on automatically when an endpoint is set and this was never touched.",
  "storages.fieldHelp.prefix": "Sub-folder inside the bucket. Required: filex never takes ownership of the bucket root.",
  "storages.fieldHelp.region": 'Defaults to "auto" when left empty.',
  "storages.fieldHelp.root": "Sub-folder on the backend. Required: filex never mounts the account root.",
  "storages.fieldHelp.sftpAuth": "Either a password or a private key is required.",
  "storages.fieldHelp.tls": "Plain FTP sends credentials in the clear — turn this on whenever the server supports it.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Base path",
  "storages.fields.bucket": "Bucket",
  "storages.fields.disablePresign": "Disable presigned URLs",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Host",
  "storages.fields.hostKey": "Pinned host key",
  "storages.fields.insecureSkipHostKey": "Skip host-key verification (insecure)",
  "storages.fields.keyPath": "Private key file",
  "storages.fields.knownHosts": "known_hosts file",
  "storages.fields.name": "Display name",
  "storages.fields.namePlaceholder": "Personal photos",
  "storages.fields.passive": "Passive mode (PASV)",
  "storages.fields.password": "Password",
  "storages.fields.path": "Filesystem path",
  "storages.fields.pathStyle": "Use path-style URLs (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Prefix",
  "storages.fields.privateKey": "Private key (PEM)",
  "storages.fields.rbac": "Per-item access control (RBAC)",
  "storages.fields.rbacHint": "When on, non-admins see only files/folders explicitly granted to them via the permissions panel. When off, the storage is open to all users (capability by role).",
  "storages.fields.readOnly": "Read-only mount",
  "storages.fields.region": "Region",
  "storages.fields.root": "Base path",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (explicit AUTH TLS)",
  "storages.fields.url": "Base URL",
  "storages.fields.user": "User",
  /* === gezinti:g1 — navigation panel (SideNav) === */
  "sidenav.title": "Navigation",
  "sidenav.views": "Views",
  "sidenav.storages": "Storages",
  "sidenav.home": "Home",
  "sidenav.myfiles": "My files",
  "sidenav.recent": "Recent",
  "sidenav.starred": "Starred",
  "sidenav.shared": "Shared with me",
  "sidenav.trash": "Trash",
  "sidenav.collapse": "Collapse navigation",
  "sidenav.expand": "Expand navigation",
  "sidenav.close": "Close navigation",
  // ⚠ `open`/`close` are the DRAWER's pair, `expand`/`collapse` the docked
  // panel's, and they are not interchangeable — see the note on
  // `navToggleLabel` in Toolbar.vue. Below 560px the panel is a drawer over
  // the listing: it is not narrowed to a rail, it is not on screen at all, so
  // "expand" would promise a width change to something that has no width.
  "sidenav.open": "Open navigation",
  "sidenav.storage.shared": "Shared",
  "sidenav.storage.readOnly": "Read-only",
  // ⚠ `toolbar.nav` is GONE, and nothing replaced it. It was the one label on
  // the panel's collapse control, first as the noun "Navigation" — which names
  // the panel and never says the button does anything to it, so the owner
  // could not find how to collapse the panel (2026-09-13: "yan menüyü kısıp
  // açabilir olalım ya bence") — and then as the static stopgap "Show or hide
  // navigation". The four `sidenav.*` verbs above are the real fix: the label
  // is bound to `navOpen`, so it says *collapse* when it will collapse and
  // *expand* when it will expand.
  "node.home": "Home",
  "node.recent": "Recent",
  "node.starred": "Starred",
  "node.shared": "Shared with me",
  "empty.recent.title": "Nothing opened yet",
  "empty.recent.hint": "Files you open show up here",
  "empty.starred.title": "Nothing starred yet",
  "empty.starred.hint": "Star a file to find it here",
  "empty.shared.title": "Nothing has been shared with you",
  "empty.shared.hint": "Folders and files other people share appear here",
  /* etiket:t1 */
  "sidenav.tags": "Tags",
  "sidenav.tags.empty": "No tags yet — add one from a file’s right-click menu.",
  "sidenav.tags.more": "Show {count} more",
  "sidenav.tags.less": "Show fewer",
  "empty.tag.title": "Nothing is tagged “{tag}”",
  "empty.tag.hint": "Right-click a file and choose Tags to put it here",
  "sidenav.connections": "Connections",
  "sidenav.connect": "How to connect",
  "sidenav.apikeys": "API keys",
  "overlay.close": "Close",
  "conn.tokens.scopes": "Permissions",
  "conn.tokens.root": "Limit to one folder (optional)",
  "conn.tokens.rootPlaceholder": "storage://folder",
  "conn.tokens.expiry": "Expires in (days)",
  "conn.tokens.expiryNever": "never",
  "conn.tokens.defaultName": "API key {date}",
  "conn.tokens.namePlaceholder": "Name — e.g. backup script",
  "conn.tokens.capNote": "Your account and its permissions are the ceiling — asking for more than you have is refused, not granted.",
  /* === /gezinti:g1 === */
  /* === surucu:d1 — the shell (GitHub #14); every profile, no longer a
     `uiProfile: 'drive'` opt-in === */
  "drive.new": "New",
  "drive.new.upload": "Upload files",
  "drive.new.folder": "New folder",
  "drive.new.request": "Request files",
  "drive.new.document": "New document",
  /* === belge:n1 — "New document": the picker under + New =================
     Type names are NOT listed here. A tile reads its words from
     lib/fileIcons `typeLabelFor`, the same table the listing's Type column
     uses, so ".docx" is called the same thing in both places and a new type
     needs no string at all. Only this dialog's own chrome lives below. */
  "newdoc.title": "New document",
  "newdoc.type.label": "Document type",
  "newdoc.group.document": "Documents",
  "newdoc.group.text": "Text and code",
  "newdoc.group.diagram": "Diagrams",
  "newdoc.withheld.onlyoffice": "Office documents need a document server (OnlyOffice), which is not configured here.",
  "newdoc.withheld.drawio": "Diagrams need a drawio service, which is not configured here.",
  "newdoc.empty.title": "No document types are available",
  "newdoc.empty.body": "This server did not offer any type this app can create.",
  "newdoc.empty.blocked": "Every type this server can create needs an editor service that is not configured here.",
  "newdoc.name": "Name",
  "newdoc.name.placeholder": "Document name",
  "newdoc.untitled": "Untitled",
  "newdoc.err.slash": "A name cannot contain a slash.",
  "newdoc.err.exists": "{name} is already here. Choose another name.",
  "newdoc.location": "Location",
  "newdoc.location.none": "Choose a folder",
  "newdoc.location.change": "Change",
  "newdoc.location.noaccess": "You cannot save into this folder.",
  "newdoc.create": "Create",
  "newdoc.creating": "Creating…",
  "newdoc.cancel": "Cancel",
  // ⚠ The top search field searches the WHOLE storage (and every storage at
  // the root) — never only the open folder. The scope named here is therefore
  // the storage, not the folder; "Filter in this folder…" (FilterBar) is the
  // folder-scoped one. It used to say "Search in Photos" for a folder called
  // Photos, which was a lie (2026-09-19).
  "drive.search.placeholder": "Search in {scope}",
  "drive.search.placeholder_all": "Search all storages",
  "drive.search.hint_title": "Search everywhere and run commands ({combo})",
  "drive.storage.used": "{used} of {total} used",
  "drive.storage.used_unlimited": "{used} used",
  "drive.storage.label": "Storage",
  /* === gorunum:v3-shell — the Home view (the overview, inside the shell) ==
   * The section headings are `sidenav.storages` / `sidenav.recent` /
   * `sidenav.starred` and the two empty states are `empty.recent.*` /
   * `empty.starred.*`, on purpose: the block headed "Recent" on Home and the
   * panel row labelled "Recent" beside it are the same thing, and a second
   * string for it is how the two drift apart one translation at a time. Only
   * what exists nowhere else is below. */
  "home.title": "Home",
  "home.storages.empty": "No storages yet",
  "home.storages.hint": "A storage is a drive filex reads and writes — an administrator adds them.",
  "drive.section.folders": "Folders",
  "drive.section.files": "Files",
  "filter.aria": "Filters",
  "filter.type": "Type",
  "filter.type.any": "Any type",
  "filter.type.folder": "Folders",
  "filter.type.document": "Documents",
  "filter.type.spreadsheet": "Spreadsheets",
  "filter.type.presentation": "Presentations",
  "filter.type.pdf": "PDFs",
  "filter.type.image": "Images",
  "filter.type.video": "Videos",
  "filter.type.audio": "Audio",
  "filter.type.archive": "Archives",
  "filter.type.code": "Code",
  "filter.modified": "Modified",
  "filter.modified.any": "Any time",
  "filter.modified.today": "Today",
  "filter.modified.7d": "Last 7 days",
  "filter.modified.30d": "Last 30 days",
  "filter.modified.year": "This year",
  "filter.size": "Size",
  "filter.size.any": "Any size",
  "filter.size.lt1": "Under 1 MB",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "Over 100 MB",
  /* surucu:d1-actions — the ⋮ menu at the end of the filter row. Only its own
     NAME is new: every row inside it reuses the string that verb already has
     (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`, `shortcuts.select_all`,
     `selection.clear`), because a menu that renames a command is a menu the
     reader has to learn twice. */
  "filter.actions": "Listing actions",
  "filter.clear": "Clear filters",
  "filter.empty.title": "Nothing here matches those filters",
  "filter.empty.hint": "Clear a filter, or search everywhere with the field above.",
  "filter.count": "{shown} of {total}",
  "inspector.tab.details": "Details",
  "inspector.tab.activity": "Activity",
  "inspector.people": "People with access",
  "inspector.people.you": "You",
  "inspector.people.inherited": "from a parent folder",
  "inspector.people.empty": "Only you, and anyone with a link below.",
  "inspector.people.manage": "Manage access",
  "inspector.link": "Shared link",
  "inspector.link.none": "Not shared",
  "inspector.link.create": "Create link",
  "inspector.link.copy": "Copy link",
  "inspector.activity.empty": "No activity recorded for this item yet.",
  "inspector.activity.hint": "Versions are written when a file changes; comments are written by people.",
  "inspector.activity.version": "Version {n} saved",
  "inspector.activity.comment": "Comment by {who}",
  "inspector.activity.select": "Select a file or folder to see its activity.",
  /* === /surucu:d1 === */
  /* i18n:hardcoded — the convert modal shipped with no keys at all: every
     label was a Turkish literal behind an optional `t` prop nobody passed. */
  "convert.title": "Convert",
  "convert.loading": "Loading the converter…",
  "convert.done": "Converted and uploaded to this folder.",
  "convert.close": "Close",
  "convert.from": "Source",
  "convert.search_format": "Search a target format (pdf, mp4, png…)",
  "convert.no_format": "No matching format.",
  "convert.unsupported_input": "This file type has no source format the converter can read.",
  "convert.converting": "Converting…",
  "convert.convert": "Convert",
  /* === gorunum:v1-chrome — the filter row's name box === */
  "filter.find": "Filter in this folder…",
  /* surucu:d1-scope — the same box where the rows are not a folder's contents.
     It has to say what it narrows: at the drive list "this folder" names
     nothing, and on Home it would name three blocks at once. */
  "filter.find.storages": "Filter storages…",
  "filter.find.home": "Filter Home…",
  /* === gorunum:v1-viewer — the full-bleed overlay's own chrome === */
  "viewer.share": "Share",
  "viewer.nav_prev": "Previous file",
  "viewer.nav_next": "Next file",
  /* The counter in the top bar's meta line: "246.3 KB • Sep 9, 2026 • 1 of 9". */
  "viewer.counter": "{i} of {n}",
  "viewer.zoom_reset": "Reset zoom",
  "viewer.fullscreen": "Full screen",
  "viewer.exit_fullscreen": "Exit full screen",
  "viewer.md_placeholder": "# Markdown here…",
  /* === gorunum:v1-selbar — the selection bar that replaces the filter row === */
  "selection.count": "{n} selected",
  "selection.clear": "Clear selection",
  /* === gorunum:v1-preview — the kind, said in words ======================
     The Type column used to print the extension in caps. These are what it
     prints instead; the table that picks one is in `lib/fileIcons.ts`
     (`typeLabelKey`), so this list and that one are the only two places a
     kind is named. Anything unmapped still falls back to the uppercased
     extension — these names improve on that fallback, they do not replace
     it. `Folder` is NOT here: it is `node.folder`, which the grid card's
     caption already prints. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue component",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C source",
  "ftype.cpp": "C++ source",
  "ftype.csharp": "C# source",
  "ftype.stylesheet": "Stylesheet",
  "ftype.html": "HTML document",
  "ftype.json": "JSON data",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Shell script",
  "ftype.powershell": "PowerShell script",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Plain text",
  "ftype.log": "Log file",
  "ftype.config": "Configuration",
  "ftype.sheet": "Spreadsheet",
  "ftype.figma": "Figma design",
  "ftype.design": "Design file",
  "ftype.image": "Image",
  "ftype.video": "Video",
  "ftype.audio": "Audio",
  "ftype.pdf": "PDF document",
  "ftype.document": "Document",
  "ftype.slides": "Presentation",
  "ftype.archive": "Archive",
  "ftype.code": "Code",
  /* === gorunum:v1-advsearch — the Advanced search dialog ==================
   * Two `filter.*` keys are added here rather than beside their siblings
   * because they are new members of shared unions the dialog introduced
   * (`modified: 'around'`, `size: 'range'`); the filter row never selects
   * them, but `chipLabel` would print the raw key if one ever reached it. */
  "filter.modified.around": "Around a date",
  "filter.size.range": "Custom range",
  "advsearch.open": "Advanced search",
  "advsearch.title": "Advanced search",
  "advsearch.subtitle": "Find files by name, content, path, or tags.",
  "advsearch.close": "Close",
  "advsearch.content.heading": "Content search",
  "advsearch.viewall": "View all results",
  "advsearch.where.any_short": "Anywhere",
  "advsearch.where.here_short": "Only here",
  "advsearch.where.skip_short": "Skip this",
  "advsearch.server.legend": "What the server searches",
  "advsearch.client.legend": "Narrow the results that come back",
  "advsearch.query.label": "Words",
  "advsearch.query.placeholder": "Part of a name, or words inside a file",
  "advsearch.scope.label": "Look in",
  "advsearch.scope.name": "Names and paths",
  "advsearch.scope.content": "File contents",
  "advsearch.scope.all": "Both",
  "advsearch.scope.hint": "Contents are searched from the index, which covers text-like files up to 200 KB.",
  "advsearch.people.name_only": "Owner is read off the rows that come back, and only a name search returns rows that carry one.",
  "advsearch.scope.name_only": "Only names and paths here: a content hit reaches the explorer without the drive it came from, so content search is offered on single-storage deployments only.",
  "advsearch.tags.label": "Tags",
  "advsearch.tags.placeholder": "invoice, quarterly report",
  "advsearch.tags.exclude": "Without tags",
  "advsearch.tags.exclude_placeholder": "archive",
  "advsearch.tags.hint": "Separate with commas. Tags narrow: several tags means files carrying all of them, and a tag nobody has applied returns nothing.",
  "advsearch.where.label": "Folder",
  "advsearch.where.any": "Anywhere in this storage",
  "advsearch.where.here": "Only in {folder}",
  "advsearch.where.skip": "Everywhere except {folder}",
  "advsearch.around.label": "Within",
  "advsearch.around.date": "Date and time",
  "advsearch.around.h1": "1 hour",
  "advsearch.around.d1": "1 day",
  "advsearch.around.w1": "1 week",
  "advsearch.size.range_label": "Between",
  "advsearch.size.from": "From",
  "advsearch.size.to": "To",
  "advsearch.count.idle": "Type something, or pick a tag.",
  "advsearch.count.counting": "Counting…",
  "advsearch.count.result": "{n} matching items",
  "advsearch.count.capped": "{n} matching items in the first page of hits",
  "advsearch.count.result_one": "1 matching item",
  "advsearch.count.capped_one": "1 matching item in the first page of hits",
  "advsearch.count.error": "The count could not be run.",
  "advsearch.count.cost": "The count runs this search. Type, owner, date, size and folder are applied to the rows that come back, not by the server.",
  "advsearch.wire": "Sent as",
  "advsearch.reset": "Reset",
  "advsearch.cancel": "Cancel",
  "advsearch.submit": "Search",
  /* === gorunum:v2-topbar — the page bar is gone; the explorer's own header
     and breadcrumb row carry what it used to. === */
  "breadcrumb.subfolders": "Subfolders",
  "breadcrumb.subfolders.empty": "No subfolders here",
  "header.admin": "Admin panel",
  "header.settings": "Settings",
  "header.signout": "Sign out",
  "ai.assistant": "AI assistant",
  "ai.soon": "Coming soon",
  "ai.assistant.soon": "AI assistant — coming soon",
  /* gorunum:v2-share — the Share / Permissions dialog's own chrome. The
     controls inside it keep the strings they already had; these are the new
     shell: the title, the one switch, the sentence that says who can open the
     item right now, and the three named sections it all folds into. */
  "access.title": 'Share "{name}"',
  "access.close": "Close",
  "access.done": "Done",
  "access.copy": "Copy",
  "access.copied": "Copied",
  "access.link.switch": "Link sharing",
  "access.who.private": "Only people with access can open it.",
  "access.who.link": "Anyone with the link can open it.",
  "access.who.pin": "Anyone with the link and the PIN can open it.",
  "access.who.existing": "Link sharing is on — {n} links already exist.",
  "access.who.existing_one": "Link sharing is on — 1 link already exists.",
  "access.section.link": "Link options",
  "access.section.people": "People with access",
  "access.section.drop": "Request files",
  "access.sum.pin_on": "PIN on",
  "access.sum.pin_off": "No PIN",
  "access.sum.people": "{n} people",
  "access.sum.people_one": "1 person",
  "access.sum.people_none": "No one yet",
  "access.sum.drop": "{n} upload links",
  "access.sum.drop_one": "1 upload link",
  "access.sum.drop_none": "No upload link",
  /* Ownership — the Owner column and the People chip. "System" is the honest
     word for a row nobody put here through filex (the scanner found it, or it
     was written straight into the bucket); it is a real answer, not a blank. */
  "col.owner": "Owner",
  "owner.you": "You",
  "owner.system": "System",
  "owner.unknown": "Unknown",
  "owner.external": "Uploaded through an upload link",
  "owner.last_actor": "Last changed by {who}",
  "filter.people": "People",
  "filter.people.any": "Anyone",
  "filter.people.me": "You",
  "filter.people.system": "System",
  "filter.people.someone": "Someone else",
  /* surucu:d1-sort — the listing sort control at the trailing edge of the
     filter row. The four key names are `col.*`: the menu offers exactly the
     words the list view's own column headers carry, so the two controls that
     drive one sort cannot name it differently. */
  "sort.by": "Sort by",
  "sort.asc": "Ascending",
  "sort.desc": "Descending",
  /* The order a SEARCH RESULT is in. It is not a fifth sort key — it is what
     the control prints instead of a key while the rows on screen were ranked
     by the server, so the button stops claiming a sort it is not performing.
     `_why` is the reason the control is closed, and the owner asked for the
     reason to be written rather than for the control to go quietly inert. */
  "sort.relevance": "Relevance",
  "sort.relevance_why": "Search results are listed by how well they match. Your sort comes back when you leave the search.",
  /* === tablo:t1 — the table's own configuration ==========================
     Column widths and visibility are a preference about YOUR SCREEN; the view
     a folder opens in is a fact about the FOLDER. Both are set from here, and
     `folder_hint` is the rule in one sentence, written where the person who is
     about to be surprised by it can read it. */
  "col.location": "Location",
  "cols.menu": "Column options",
  "cols.title": "Columns",
  "cols.resize": "Resize {col}",
  "cols.move_left": "Move {col} left",
  "cols.move_right": "Move {col} right",
  "cols.reset": "Reset columns",
  "cols.folder_title": "Folder view",
  "cols.folder_hint": "Folders you set up keep their own view. Your last choice is the default everywhere else.",
  "cols.forget_folder": "Forget this folder's view",
  "cols.apply_all": "Apply to all folders ({count} remembered)",
  /* === tablo:t1 — the trash banner ======================================
     ⚠ `retention` is only used when the deployment has TOLD us the number
     (GET /api/admin/protection). Everywhere else `retention_unknown` says the
     same thing without naming a period we cannot verify: a banner that states
     the wrong retention is worse than no banner, because people act on it. */
  "trash.retention": "Items in the trash are permanently deleted after {days} days.",
  "trash.retention_one": "Items in the trash are permanently deleted after 1 day.",
  "trash.retention_unknown": "Items in the trash are permanently deleted after a retention period set by your administrator.",
  "trash.empty_action": "Empty trash",
  "trash.empty_confirm_title": "Empty the trash?",
  "trash.empty_confirm_body_one": "This permanently deletes 1 item ({size}). It cannot be undone.",
  "trash.empty_confirm_body": "This permanently deletes {count} items ({size}). It cannot be undone.",
  "trash.empty_confirm_body_nosize_one": "This permanently deletes 1 item. It cannot be undone.",
  "trash.empty_confirm_body_nosize": "This permanently deletes {count} items. It cannot be undone.",
  "trash.emptied": "Trash emptied",
  "empty.trash.hint": "Files you delete land here first, so you can put them back.",
  /* tasi:m1 — the destination picker (modals/DestinationPickerModal.vue) and
     the two selection verbs built on it. */
  "destpicker.title.move": "Move to",
  "destpicker.title.copy": "Copy to",
  "destpicker.title.choose": "Choose a folder",
  "destpicker.confirm.move": "Move here",
  "destpicker.confirm.copy": "Copy here",
  "destpicker.confirm.choose": "Choose this folder",
  "destpicker.cancel": "Cancel",
  "destpicker.up": "Up one level",
  "destpicker.crumbs": "Location",
  "destpicker.drives": "Drives",
  "destpicker.loading": "Loading…",
  "destpicker.empty": "No subfolders here",
  "destpicker.unreadable": "This folder cannot be opened.",
  "destpicker.readonly": "Read-only",
  "destpicker.readonly_here": "You cannot write into this folder.",
  "destpicker.pick_a_drive": "Open a storage to choose a folder inside it.",
  "destpicker.target": "Destination: {name}",
  "destpicker.tag.blocked": "Not allowed",
  "destpicker.blocked.self": "A folder cannot be moved into itself.",
  "destpicker.blocked.descendant": "A folder cannot be moved into one of its own subfolders.",
  "ctx.move_to": "Move to…",
  "ctx.copy_to": "Copy to…",
  "ctx.access.one_only": "Sharing works on one item at a time.",
  "toast.archive.preparing": "Preparing the archive…",
  "toast.archive.started": "Downloading {name} ({count} files)",
  "toast.archive.started_one": "Downloading {name} (1 file)",
  "toast.archive.empty": "Nothing to download — the selection contains no readable file.",
  "toast.moved_to": "Moved to {name}",
  "toast.copied_to": "Copy to {name} queued"
}, Ms = { tr: Bv, en: Iv }, Hv = Object.freeze([
  "viewer",
  "host",
  "account",
  "device"
]);
function Mi(e) {
  for (const t of Hv) {
    if (t === "device") break;
    const n = e[t];
    if (typeof n == "string" && n && qa(n)) return { zone: n, tier: t };
  }
  return { zone: void 0, tier: "device" };
}
const ko = "filex.timezone.viewer", Es = "filex.timezone", Fv = [
  "UTC",
  "Europe/Istanbul",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Moscow",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Africa/Cairo",
  "Africa/Lagos",
  "Asia/Dubai",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Shanghai",
  "Asia/Tokyo",
  "Asia/Seoul",
  "Asia/Singapore",
  "Australia/Sydney",
  "Pacific/Auckland"
];
function qs() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
function qa(e) {
  if (!e) return !1;
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: e }), !0;
  } catch {
    return !1;
  }
}
function Nv() {
  try {
    const e = Intl.supportedValuesOf;
    if (typeof e == "function") {
      const t = e("timeZone");
      if (Array.isArray(t) && t.length)
        return t.includes("UTC") ? [...t] : ["UTC", ...t];
    }
  } catch {
  }
  return [...Fv];
}
function Ic(e, t) {
  const n = t ?? Kv();
  try {
    const r = new Intl.DateTimeFormat("en-CA", {
      timeZone: n,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(e), a = (h) => {
      var b;
      return Number((b = r.find((y) => y.type === h)) == null ? void 0 : b.value);
    }, u = a("year"), v = a("month"), p = a("day");
    if (!Number.isFinite(u) || !Number.isFinite(v) || !Number.isFinite(p))
      throw new Error("unparsable");
    return Math.floor(Date.UTC(u, v - 1, p) / 864e5);
  } catch {
    return Math.floor(
      Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()) / 864e5
    );
  }
}
function _o(e) {
  try {
    const t = localStorage.getItem(e);
    return t && qa(t) ? t : "";
  } catch {
    return "";
  }
}
function ju(e, t) {
  try {
    t ? localStorage.setItem(e, t) : localStorage.removeItem(e);
  } catch {
  }
}
const Ei = typeof window < "u", ba = m(Ei ? _o(ko) : "");
function Yu() {
  const e = m([]);
  return {
    set(t, n) {
      const r = e.value.find((a) => a.owner === t);
      if (n === null) {
        r && (e.value = e.value.filter((a) => a !== r));
        return;
      }
      r && r.zone === n || (e.value = [...e.value.filter((a) => a.owner !== t), { owner: t, zone: n }]);
    },
    of(t) {
      var n;
      return ((n = e.value.find((r) => r.owner === t)) == null ? void 0 : n.zone) ?? null;
    },
    current() {
      const t = e.value;
      return t.length ? t[t.length - 1].zone : "";
    },
    /** The newest answer among the owners `pick` accepts. */
    currentWhere(t) {
      const n = e.value.filter((r) => t(r.owner));
      return n.length ? n[n.length - 1].zone : "";
    }
  };
}
const Mo = Yu(), Vn = Yu(), Gs = /* @__PURE__ */ new Set(), zi = k(
  () => Mi({
    viewer: ba.value,
    host: Mo.current(),
    account: Vn.current()
  })
);
function Kv() {
  return zi.value.zone;
}
function LD() {
  return zi.value;
}
const Xs = Symbol("filex-explorer-clock");
function Wu(e) {
  return e ? {
    viewer: ba.value,
    host: Mo.of(e) ?? "",
    account: Vn.of(e) ?? Vn.currentWhere((t) => Gs.has(t))
  } : Rv();
}
function qu(e) {
  return e ? Mi(Wu(e)) : zi.value;
}
function Gu(e) {
  return qu(e).zone;
}
function Rv() {
  return {
    viewer: ba.value,
    host: Mo.current(),
    account: Vn.current()
  };
}
function Uv() {
  return ba.value;
}
function Vv(e) {
  const t = e && qa(e) ? e : "";
  ba.value = t, ju(ko, t);
  try {
    window.dispatchEvent(new CustomEvent("filex:timezone", { detail: t }));
  } catch {
  }
}
function jv(e, t) {
  Mo.set(e, t && qa(t) ? t : null);
}
function Wr(e, t, n = {}) {
  if (t == null) {
    Vn.set(e, null);
    return;
  }
  const r = t && qa(t) ? t : "";
  Vn.set(e, r), n.remember && (Gs.add(e), ju(Es, r));
}
function DD(e) {
  return Vn.of(e);
}
function OD() {
  return Ei ? _o(Es) : "";
}
function Yv(e) {
  Mo.set(e, null), Vn.set(e, null), Gs.delete(e);
}
if (Ei)
  try {
    window.addEventListener("storage", (e) => {
      if ((e.key === null || e.key === ko) && (ba.value = _o(ko)), e.key === null || e.key === Es) {
        const t = _o(Es);
        for (const n of Gs) Vn.set(n, t);
      }
    }), window.addEventListener("filex:timezone", (e) => {
      const t = e.detail;
      ba.value = typeof t == "string" ? t && qa(t) ? t : "" : _o(ko);
    });
  } catch {
  }
function Ai(e) {
  return e === "tr" ? "tr-TR" : "en-US";
}
const Hc = [
  "unit.bytes",
  "unit.kb",
  "unit.mb",
  "unit.gb",
  "unit.tb",
  "unit.pb"
], Wv = {
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB"
};
function Xu(e, t = {}) {
  const n = t.empty ?? "—";
  if (e == null || !Number.isFinite(e) || e < 0) return n;
  const r = t.base ?? 1e3, a = t.unit ?? ((b) => Wv[b]);
  let u = 0, v = e;
  for (; v >= r && u < Hc.length - 1; )
    v /= r, u += 1;
  const p = u === 0 ? 0 : t.digits === "fixed1" ? 1 : v < 10 ? 2 : 1;
  let h;
  if (t.numberLocale == null)
    h = v.toFixed(p);
  else {
    const b = qv(t.numberLocale, p, t.digits === "fixed1" ? p : 0);
    h = b ? b.format(v) : v.toFixed(p);
  }
  return `${h} ${a(Hc[u])}`;
}
const ms = /* @__PURE__ */ new Map();
function qv(e, t, n) {
  const r = `${e}|${t}|${n}`;
  if (!ms.has(r))
    try {
      ms.set(r, new Intl.NumberFormat(e, {
        maximumFractionDigits: t,
        minimumFractionDigits: n
      }));
    } catch {
      ms.set(r, null);
    }
  return ms.get(r) ?? null;
}
const Fc = /* @__PURE__ */ new Map();
function Ju(e, t, n) {
  const r = Gu(n), a = `${e}|${r ?? `device:${qs()}`}|${JSON.stringify(t)}`;
  let u = Fc.get(a);
  return u || (u = new Intl.DateTimeFormat(e, { ...t, timeZone: r }), Fc.set(a, u)), u;
}
function Ha(e, t, n, r) {
  try {
    return Ju(Ai(t), n, r).format(e);
  } catch {
    return e.toISOString();
  }
}
function bo(e) {
  if (!e) return null;
  const t = new Date(e * (e < 1e12 ? 1e3 : 1));
  return Number.isNaN(t.getTime()) ? null : t;
}
const Gv = ["count", "n", "days"];
function Xv(e, t, n) {
  const r = Gv.find((u) => u in t);
  if (r === void 0 || Number(t[r]) !== 1) return e;
  const a = `${e}_one`;
  return n(a) ? a : e;
}
function tt(e) {
  const t = () => typeof e == "function" ? e() : e.value, n = k(() => Ms[t()] ?? Ms.en), r = sv() ? Ws(Xs, void 0) : void 0;
  function a(A, D = {}) {
    const C = n.value, B = C[Xv(A, D, (I) => I in C)] ?? A;
    return Object.entries(D).reduce(
      (I, [U, x]) => I.replaceAll(`{${U}}`, String(x)),
      B
    );
  }
  function u(A) {
    return Xu(A, {
      unit: (D) => a(D),
      numberLocale: Ai(t())
    });
  }
  function v(A) {
    if (A.basename === ".trash") return a("node.trash");
    const D = A.basename.match(/^\d{8}-\d{6}-[A-Za-z0-9]+__(.+)$/);
    return D ? D[1] : A.basename;
  }
  function p(A, D = {}) {
    const C = bo(A);
    if (!C) return "";
    const B = Ha(
      C,
      t(),
      {
        month: "short",
        day: "numeric",
        year: "numeric"
      },
      r
    );
    return D.time ? `${B}, ${Ha(C, t(), { hour: "numeric", minute: "2-digit" }, r)}` : B;
  }
  function h(A) {
    const D = bo(A);
    if (!D) return "";
    const C = Gu(r) ?? qs();
    return `${Ha(D, t(), { dateStyle: "full", timeStyle: "long" }, r)} (${C})`;
  }
  function b(A) {
    const D = A instanceof Date ? A : bo(A);
    return D ? Ha(D, t(), { month: "long", year: "numeric" }, r) : "";
  }
  function y(A) {
    const D = A instanceof Date ? A : bo(A);
    if (!D) return "";
    try {
      return Ju("en-CA", { year: "numeric", month: "2-digit" }, r).format(D);
    } catch {
      return `${D.getFullYear()}-${String(D.getMonth() + 1).padStart(2, "0")}`;
    }
  }
  return {
    t: a,
    formatSize: u,
    formatDate: p,
    formatDateFull: h,
    formatMonthYear: b,
    zonedYearMonth: y,
    /**
     * zaman:z1 — the wire's `last_modified` as a `Date`, or null.
     *
     * Handed out because "seconds or milliseconds" is a fact about the WIRE,
     * not about formatting, and every caller that needs the instant itself
     * (rather than a string) was otherwise re-typing `v * (v < 1e12 ? 1000 :
     * 1)`. ListView had the third copy and used it to group rows by day — so
     * the grouping and the cell four pixels away were reading the same number
     * through two different converters.
     */
    toDate: bo,
    nodeDisplayName: v
  };
}
const Jv = 2e3, Zv = 8e3;
function Nc(e) {
  const t = (...p) => {
    for (const h of p) if (typeof h == "number") return h;
    return 0;
  }, n = (...p) => {
    for (const h of p) if (typeof h == "string" && h !== "") return h;
    return null;
  }, r = String(e.status ?? "pending"), a = r === "ok" || r === "done" ? "done" : r === "failed" || r === "partial" || r === "error" ? "error" : r === "running" ? "running" : "pending", u = Array.isArray(e.sources) ? e.sources : [], v = n(e.op_type, e.kind) ?? "delete";
  return {
    id: t(e.id),
    op_type: v === "copy" || v === "move" ? v : "delete",
    status: a,
    progress_total: t(e.progress_total, e.total, u.length),
    progress_done: t(e.progress_done, e.done),
    bytes_total: t(e.bytes_total),
    bytes_done: t(e.bytes_done),
    target_path: n(e.target_path, e.dest),
    source_dir: n(e.source_dir),
    source_count: t(e.source_count, u.length),
    error_message: n(e.error_message, e.error),
    started_at: n(e.started_at),
    finished_at: n(e.finished_at),
    created_at: n(e.created_at)
  };
}
function Qv(e, t, n = {}) {
  const r = m([]), a = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Map();
  let v = !1;
  const p = k(
    () => r.value.some((B) => B.status === "pending" || B.status === "running")
  );
  let h;
  function b() {
    h || t.endpoints.opsList && (h = setInterval(() => {
      A();
    }, Jv), A());
  }
  function y() {
    h && (clearInterval(h), h = void 0);
  }
  async function A() {
    var B;
    if (t.endpoints.opsList)
      try {
        const U = ((await t.jsonFetch(t.endpoints.opsList)).ops || []).map(Nc);
        for (const O of U)
          (O.status === "done" || O.status === "error") && !a.has(O.id) && (a.add(O.id), u.set(O.id, Date.now()), v && ((B = n.onSettled) == null || B.call(n, O)));
        const x = new Set(r.value.map((O) => O.id)), E = U.filter((O) => O.status === "pending" || O.status === "running" ? !0 : v ? x.has(O.id) : !1), $ = new Set(E.map((O) => O.id)), M = r.value.filter((O) => !$.has(O.id)), z = [...E, ...M];
        v = !0;
        const T = Date.now(), Y = z.filter((O) => {
          if (O.status === "pending" || O.status === "running") return !0;
          const J = u.get(O.id);
          return J !== void 0 && T - J < Zv;
        });
        r.value = Y, !p.value && Y.length === 0 && y();
      } catch (I) {
        console.warn("[usePendingOps] poll failed:", I);
      }
  }
  function D(B) {
    const I = Nc(B);
    r.value.some((x) => x.id === I.id) || (r.value = [I, ...r.value]), b();
  }
  function C(B) {
    r.value = r.value.filter((I) => I.id !== B), u.delete(B);
  }
  return it(() => {
    y();
  }), {
    ops: r,
    hasActive: p,
    register: D,
    dismiss: C,
    poll: A,
    startPolling: b,
    stopPolling: y
  };
}
const eh = 25e3, th = 15e3, nh = 6;
class ah {
  constructor(t) {
    kn(this, "ws", null);
    kn(this, "opts");
    kn(this, "closed", !1);
    kn(this, "connecting", !1);
    kn(this, "retries", 0);
    kn(this, "fallback", !1);
    kn(this, "pingTimer", null);
    kn(this, "reconnectTimer", null);
    // Last-known intent, replayed on (re)connect.
    kn(this, "currentPath", null);
    kn(this, "currentFocus", null);
    this.opts = t, this.connect();
  }
  /** Subscribe to a folder ("<adapter>://<dir>"). Swaps the active room and
   *  resets focus. Passing null unsubscribes (drive list / trash have no room). */
  subscribe(t) {
    this.currentPath = t, this.currentFocus = null, t && this.send({ type: "subscribe", path: t });
  }
  /** Report the file the user is focused on (or null to clear). */
  setFocus(t) {
    this.currentFocus = t, this.send({ type: "focus", file: t });
  }
  /** Tear down permanently — call on unmount. */
  close() {
    this.closed = !0, this.clearTimers(), this.dropSocket();
  }
  async connect() {
    if (this.closed || this.connecting || this.ws) return;
    this.connecting = !0;
    let t = null;
    try {
      t = await this.opts.getTicket();
    } catch {
      t = null;
    }
    if (this.connecting = !1, this.closed) return;
    if (!t || !t.ticket || !t.ws_url) {
      this.fail();
      return;
    }
    const n = t.ws_url.includes("?") ? "&" : "?";
    let r;
    try {
      r = new WebSocket(`${t.ws_url}${n}ticket=${encodeURIComponent(t.ticket)}`);
    } catch {
      this.fail();
      return;
    }
    this.ws = r, r.onopen = () => {
      var a, u;
      this.retries = 0, this.setFallback(!1), (u = (a = this.opts.handlers).onStatus) == null || u.call(a, !0), this.currentPath && this.send({ type: "subscribe", path: this.currentPath }), this.currentFocus !== null && this.send({ type: "focus", file: this.currentFocus }), this.startPing();
    }, r.onmessage = (a) => {
      var p, h, b, y;
      let u;
      try {
        u = JSON.parse(typeof a.data == "string" ? a.data : "");
      } catch {
        return;
      }
      const v = u;
      (v == null ? void 0 : v.type) === "change" ? (h = (p = this.opts.handlers).onChange) == null || h.call(p, u) : (v == null ? void 0 : v.type) === "presence" && ((y = (b = this.opts.handlers).onPresence) == null || y.call(b, u));
    }, r.onerror = () => {
    }, r.onclose = () => {
      var a, u;
      this.stopPing(), this.ws = null, (u = (a = this.opts.handlers).onStatus) == null || u.call(a, !1), this.fail();
    };
  }
  // fail schedules a capped reconnect; after MAX_RETRIES it gives up on the live
  // socket and flips to fallback (polling) mode.
  fail() {
    if (this.closed || this.reconnectTimer) return;
    if (this.retries >= nh) {
      this.setFallback(!0);
      return;
    }
    const t = Math.min(1e3 * 2 ** this.retries, th);
    this.retries += 1, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.connect();
    }, t);
  }
  setFallback(t) {
    var n, r;
    this.fallback !== t && (this.fallback = t, (r = (n = this.opts.handlers).onFallback) == null || r.call(n, t));
  }
  send(t) {
    const n = this.ws;
    if (!(!n || n.readyState !== WebSocket.OPEN))
      try {
        n.send(JSON.stringify(t));
      } catch {
      }
  }
  startPing() {
    this.stopPing(), this.pingTimer = setInterval(() => this.send({ type: "ping" }), eh);
  }
  stopPing() {
    this.pingTimer && (clearInterval(this.pingTimer), this.pingTimer = null);
  }
  dropSocket() {
    if (this.ws) {
      try {
        this.ws.onclose = null, this.ws.close();
      } catch {
      }
      this.ws = null;
    }
  }
  clearTimers() {
    this.stopPing(), this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
  }
}
function oh(e, t) {
  const n = t.now ?? (() => Date.now());
  let r = null, a = null;
  const u = () => {
    const v = n();
    a === null && (a = v);
    const p = a + t.maxWait - v, h = Math.max(0, Math.min(t.wait, p));
    r && clearTimeout(r), r = setTimeout(() => {
      r = null, a = null, e();
    }, h);
  };
  return u.cancel = () => {
    r && clearTimeout(r), r = null, a = null;
  }, u;
}
const sh = 200, rh = 2e3, ih = 12e3;
function lh(e, t) {
  const n = m([]), r = m(!1), a = m(!1);
  let u = null, v = null;
  const p = oh(() => t.reload(), {
    wait: sh,
    maxWait: rh
  });
  let h = null;
  function b(I) {
    v && I.path && I.path !== v || (n.value = Array.isArray(I.users) ? I.users : []);
  }
  function y(I) {
    a.value = I, I ? (n.value = [], h || (h = setInterval(() => t.reload(), ih))) : h && (clearInterval(h), h = null);
  }
  function A() {
    u || (u = new ah({
      getTicket: () => e.wsTicket(),
      handlers: {
        onChange: p,
        onPresence: b,
        onFallback: y,
        onStatus: (I) => {
          r.value = I;
        }
      }
    }));
  }
  function D(I) {
    n.value = [], v = I, u == null || u.subscribe(I);
  }
  function C(I) {
    u == null || u.setFocus(I);
  }
  function B() {
    p.cancel(), h && (clearInterval(h), h = null), u == null || u.close(), u = null, a.value = !1;
  }
  return { presenceUsers: n, connected: r, degraded: a, start: A, subscribe: D, setFocus: C, stop: B };
}
const ch = 500;
function uh(e, t) {
  const n = m({}), r = [], a = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set();
  function v(b) {
    if (/^https?:\/\//i.test(b)) return b;
    const y = (e || "").replace(/\/+$/, "");
    return y && b.startsWith("/") ? y + b : b;
  }
  function p(b) {
    const y = b.thumb_url;
    if (!y) return null;
    const A = n.value[y];
    return A || (!a.has(y) && !u.has(y) && h(y), null);
  }
  async function h(b) {
    u.add(b);
    try {
      const y = await fetch(v(b), {
        headers: await t.authHeaders({ Accept: "*/*" }),
        credentials: t.credentialsMode()
      });
      if (!y.ok) throw new Error(String(y.status));
      const A = await y.blob();
      if (r.length >= ch) {
        const D = r.shift();
        if (D && n.value[D]) {
          URL.revokeObjectURL(n.value[D]);
          const C = { ...n.value };
          delete C[D], n.value = C;
        }
      }
      r.push(b), n.value = { ...n.value, [b]: URL.createObjectURL(A) };
    } catch {
      a.add(b);
    } finally {
      u.delete(b);
    }
  }
  return { src: p };
}
let zs = null, As = null, gs = null, ks = null;
function Js() {
  zs || (zs = import(
    /* @vite-ignore */
    "monaco-editor"
  ).then((e) => (gs = e.default ?? e, gs)).catch(() => (gs = null, null))), As || (As = import(
    /* @vite-ignore */
    "./common-xdTjul80.js"
  ).then((e) => (ks = e.default ?? e, ks)).catch(() => (ks = null, null)));
}
async function ri() {
  return zs || Js(), zs;
}
async function Zu() {
  return As || Js(), As;
}
function Qu() {
  return gs;
}
function dh() {
  return ks;
}
function BD() {
  return Js(), {
    ensureMonaco: ri,
    ensureHighlight: Zu,
    getMonaco: Qu,
    getHighlight: dh
  };
}
const fh = ["title"], ph = ["src", "alt"], vh = {
  key: 2,
  class: "fx-presence-dot",
  "aria-hidden": "true"
}, Kc = /* @__PURE__ */ qe({
  __name: "PresenceAvatar",
  props: {
    user: {},
    title: {}
  },
  setup(e) {
    const t = e, n = k(() => {
      const p = (t.user.avatar ?? "").trim();
      return /^(data:image\/|https?:\/\/|\/)/.test(p) ? p : "";
    }), r = m(!1), a = k(() => !!n.value && !r.value), u = k(() => {
      const p = t.user.name.trim().split(/\s+/).filter(Boolean);
      return p.length === 0 ? "?" : p.length === 1 ? p[0].slice(0, 2).toUpperCase() : (p[0][0] + p[p.length - 1][0]).toUpperCase();
    }), v = k(() => {
      const p = t.user.uid ?? String(t.user.id);
      let h = 0;
      for (let b = 0; b < p.length; b++) h = h * 31 + p.charCodeAt(b) >>> 0;
      return h % 360;
    });
    return (p, h) => (c(), d("span", {
      class: we(["fx-presence-avatar", { "fx-presence-avatar--photo": a.value }]),
      style: Ct({ backgroundColor: `hsl(${v.value} 60% 45%)` }),
      title: e.title
    }, [
      a.value ? (c(), d("img", {
        key: 0,
        class: "fx-presence-photo",
        src: n.value,
        alt: e.user.name,
        onError: h[0] || (h[0] = (b) => r.value = !0)
      }, null, 40, ph)) : (c(), d(ae, { key: 1 }, [
        Je(f(u.value), 1)
      ], 64)),
      e.user.file ? (c(), d("span", vh)) : g("", !0)
    ], 14, fh));
  }
}), hh = {
  key: 0,
  class: "fx-presence-chips"
}, mh = ["title"], yh = { class: "fx-presence-chip-name" }, bh = {
  key: 0,
  class: "fx-presence-chip-file"
}, gh = ["title"], kh = {
  key: 0,
  class: "fx-presence-more"
}, _h = ["title"], wh = { class: "fx-presence-file" }, $h = ["title", "aria-expanded"], Rc = "filex.presence.expanded", xh = /* @__PURE__ */ qe({
  __name: "PresenceBar",
  props: {
    users: {},
    selfId: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = tt(() => cn(t.locale)), r = k(
      () => (t.users ?? []).filter((h) => t.selfId == null || h.id !== t.selfId)
    ), a = m((() => {
      try {
        return localStorage.getItem(Rc) === "1";
      } catch {
        return !1;
      }
    })());
    function u() {
      a.value = !a.value;
      try {
        localStorage.setItem(Rc, a.value ? "1" : "0");
      } catch {
      }
    }
    function v(h) {
      return h.uid ?? String(h.id);
    }
    function p(h) {
      return h.file ? `${h.name} · ${h.file}` : h.name;
    }
    return (h, b) => r.value.length ? (c(), d("div", {
      key: 0,
      class: we(["fx-presence", { "fx-presence--wide": a.value }])
    }, [
      a.value ? (c(), d("div", hh, [
        (c(!0), d(ae, null, Te(r.value, (y) => (c(), d("span", {
          key: v(y),
          class: "fx-presence-chip",
          title: p(y)
        }, [
          Ge(Kc, { user: y }, null, 8, ["user"]),
          o("span", yh, f(y.name), 1),
          y.file ? (c(), d("span", bh, "· " + f(y.file), 1)) : g("", !0)
        ], 8, mh))), 128))
      ])) : (c(), d(ae, { key: 1 }, [
        o("div", {
          class: "fx-presence-avatars",
          title: r.value.map(p).join(", ")
        }, [
          (c(!0), d(ae, null, Te(r.value.slice(0, 5), (y) => (c(), et(Kc, {
            key: v(y),
            user: y,
            title: p(y)
          }, null, 8, ["user", "title"]))), 128)),
          r.value.length > 5 ? (c(), d("span", kh, "+" + f(r.value.length - 5), 1)) : g("", !0)
        ], 8, gh),
        o("span", {
          class: "fx-presence-text",
          title: r.value.map(p).join(", ")
        }, [
          Je(f(r.value.length === 1 ? r.value[0].name : s(n)("presence.others", { n: r.value.length })) + " ", 1),
          r.value.length === 1 && r.value[0].file ? (c(), d(ae, { key: 0 }, [
            b[0] || (b[0] = Je(" · ", -1)),
            o("span", wh, f(r.value[0].file), 1)
          ], 64)) : g("", !0)
        ], 8, _h)
      ], 64)),
      o("button", {
        type: "button",
        class: "fx-presence-toggle",
        title: a.value ? s(n)("presence.collapse") : s(n)("presence.expand"),
        "aria-expanded": a.value,
        onClick: u
      }, f(a.value ? "‹" : "›"), 9, $h)
    ], 2)) : g("", !0);
  }
}), Sh = '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/>', Ch = '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>', Uc = "M12 3.6l2.6 5.3 5.85.85-4.23 4.12 1 5.83L12 16.97l-5.22 2.73 1-5.83L3.55 9.75l5.85-.85z", Vc = '<path d="M8 3.5h8"/><path d="M9.6 3.5v6.1L7.2 12.3v1.7h9.6v-1.7L14.4 9.6V3.5"/><path d="M12 14v6.5"/>', qr = '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/>', jc = '<path d="M4 6.5h16"/><path d="M9.5 6.5V4.9a1.4 1.4 0 0 1 1.4-1.4h2.2a1.4 1.4 0 0 1 1.4 1.4v1.6"/><path d="M6.6 6.5l.85 12.1a2 2 0 0 0 2 1.9h5.1a2 2 0 0 0 2-1.9l.85-12.1"/><path d="M10.3 10.3v6.4"/><path d="M13.7 10.3v6.4"/>', Yc = '<path d="M6.8 3.5h10.4a1.6 1.6 0 0 1 1.6 1.6v15.4l-6.8-3.9-6.8 3.9V5.1A1.6 1.6 0 0 1 6.8 3.5z"/>', ed = {
  /* ── opening ─────────────────────────────────────────────────────────── */
  open: '<path d="M14 3.5h6.5V10"/><path d="M20.5 3.5L12 12"/><path d="M18 13.5v5a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/>',
  "open-tab": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/>',
  preview: Ch,
  download: Sh + '<path d="M12 4v11.5"/><path d="M7.5 11L12 15.5 16.5 11"/>',
  upload: '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/><path d="M12 15.5V4"/><path d="M7.5 8.5L12 4l4.5 4.5"/>',
  convert: '<path d="M4 8.5h13"/><path d="M13.5 5L17 8.5 13.5 12"/><path d="M20 15.5H7"/><path d="M10.5 12L7 15.5 10.5 19"/>',
  /* "Paylaş / İzinler" — the three-node share, not a chain link: this row
     opens permissions as well as a link, and people are the subject. */
  access: '<circle cx="17.5" cy="6" r="2.5"/><circle cx="6.5" cy="12" r="2.5"/><circle cx="17.5" cy="18" r="2.5"/><path d="M8.75 10.8l6.5-3.6"/><path d="M8.75 13.2l6.5 3.6"/>',
  details: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11.2v5.6"/><circle cx="12" cy="7.7" r="0.9" fill="currentColor" stroke="none"/>',
  /* ── identity / clipboard ────────────────────────────────────────────── */
  "copy-id": '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><circle cx="8.5" cy="10.8" r="2"/><path d="M5.3 16.2c.5-1.5 1.75-2.4 3.2-2.4s2.7.9 3.2 2.4"/><path d="M14.8 10h4.2"/><path d="M14.8 13.6h4.2"/>',
  /* A clipboard carrying a path separator — this copies the location, not the
     thing that lives at it. */
  "copy-path": '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/><path d="M10 11.2l2.4 2.4-2.4 2.4"/>',
  rename: '<path d="M4 20l.9-4.1 11-11a2.05 2.05 0 0 1 2.9 2.9l-11 11z"/><path d="M14 7l3 3"/>',
  cut: '<circle cx="6.5" cy="17.5" r="2.5"/><circle cx="6.5" cy="6.5" r="2.5"/><path d="M8.6 8.3L19 19"/><path d="M8.6 15.7L19 5"/>',
  copy: '<rect x="9" y="9" width="11.5" height="11.5" rx="2"/><path d="M15 6v-.5a2 2 0 0 0-2-2H5.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2H6"/>',
  paste: '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/>',
  /* ── metadata ────────────────────────────────────────────────────────── */
  /* star = "not starred yet, do it" (outline); unstar = the state you are in
     (filled). The renderer picks between them by name, see FileExplorer. */
  star: `<path d="${Uc}"/>`,
  unstar: `<path d="${Uc}" fill="currentColor"/>`,
  tags: '<path d="M3.5 11.4V5.2a1.7 1.7 0 0 1 1.7-1.7h6.2a1.7 1.7 0 0 1 1.2.5l7.2 7.2a1.7 1.7 0 0 1 0 2.4l-6.2 6.2a1.7 1.7 0 0 1-2.4 0L4 12.6a1.7 1.7 0 0 1-.5-1.2z"/><circle cx="8" cy="8" r="1.3"/>',
  /* ── destructive / recovery ──────────────────────────────────────────── */
  delete: jc,
  "open-trash": jc,
  /* The undo arrow, not a rotating one: "Geri Yükle" puts a thing back where
     it was, and that is the gesture people already read as undo. */
  restore: '<path d="M9 6L5 10l4 4"/><path d="M5 10h9a5 5 0 0 1 0 10h-3.5"/>',
  /* ── folder-level ────────────────────────────────────────────────────── */
  "new-folder": '<path d="M3 7.5a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.4.6l1.4 1.4H19a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M12 11.3v5"/><path d="M9.5 13.8h5"/>',
  /* belge:n1 — a page with a plus: "make me a new document of some type".
     Keyed by the action's own key, so the menu row carries no icon of its
     own and no emoji enters the markup. */
  "new-document": '<path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M13.5 3l5 5"/><path d="M13.5 3v5h5"/><path d="M17.5 14.5v6"/><path d="M14.5 17.5h6"/>',
  refresh: '<path d="M20.5 12a8.5 8.5 0 1 1-2.49-6.01"/><path d="M18 1.5V6h-4.5"/>',
  /* ── desktop sync ("keep on this device") ────────────────────────────── */
  "keep-local": Vc,
  "keep-online": '<path d="M7 18.5h10a3.5 3.5 0 0 0 0-7 5 5 0 0 0-9.6-1.2A4.2 4.2 0 0 0 7 18.5z"/>',
  /* Kept because a parent folder is kept — the pin, with the branch it came
     down. The row is disabled; the glyph says why. */
  "keep-inherited": Vc + '<path d="M2.5 20.5h3.6a1.6 1.6 0 0 0 1.6-1.6V17"/>',
  "keep-reveal": '<path d="M2.5 17.5V6.5a2 2 0 0 1 2-2h3.8a2 2 0 0 1 1.4.6l1.4 1.4h4.4a2 2 0 0 1 2 2v1.8"/><path d="M4 19.5h13.4a2 2 0 0 0 1.9-1.37l2-6A1.4 1.4 0 0 0 20 10.3H9.4a2 2 0 0 0-1.9 1.37L5.5 18"/>',
  /* ── view preferences ────────────────────────────────────────────────── */
  "toggle-hidden": '<path d="M3.5 3.5l17 17"/><path d="M9.9 6A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17.3 17.3 0 0 1-3.35 4.15"/><path d="M6.55 7.7A17.4 17.4 0 0 0 2.5 12S6 18.5 12 18.5a9.7 9.7 0 0 0 3.95-.85"/><path d="M10.2 10.3a2.9 2.9 0 0 0 3.9 4.1"/>',
  density: '<path d="M8.5 8L12 4.5 15.5 8"/><path d="M8.5 16L12 19.5 15.5 16"/><path d="M12 4.5v15"/>',
  "view-list": '<path d="M8.5 6.5h12"/><path d="M8.5 12h12"/><path d="M8.5 17.5h12"/><path d="M4 6.5h.01"/><path d="M4 12h.01"/><path d="M4 17.5h.01"/>',
  "view-grid": '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
  "view-gallery": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.3" cy="9.6" r="1.5"/><path d="M4.3 17l4.7-4.7 3 3 3-3 5 4.7"/>',
  nav: qr + '<path d="M9.5 4.5v15"/>',
  inspector: qr + '<path d="M14.5 4.5v15"/>',
  /* ── explorer settings ───────────────────────────────────────────────── */
  "shortcut-settings": '<rect x="2.5" y="6" width="19" height="12" rx="2.5"/><path d="M6.5 9.8h.01"/><path d="M10 9.8h.01"/><path d="M13.5 9.8h.01"/><path d="M17 9.8h.01"/><path d="M6.5 12.9h.01"/><path d="M10 12.9h.01"/><path d="M13.5 12.9h.01"/><path d="M17 12.9h.01"/><path d="M8.6 15.6h6.8"/>',
  /* Light/dark as the thing it actually switches: one disc, half of it inked. */
  theme: '<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none"/>',
  /* zaman:z3 — a clock face, for the Time zone row. */
  timezone: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.2V12l3.2 2"/>',
  tour: '<path d="M2.5 9L12 4.5 21.5 9 12 13.5z"/><path d="M6.6 11.1v4.4c0 1.6 2.4 2.9 5.4 2.9s5.4-1.3 5.4-2.9v-4.4"/>',
  /* "Dosya İste" — the public drop link. A chain, because what this makes is
     a URL to hand somebody. */
  "request-files": '<path d="M10.2 13.8a4.2 4.2 0 0 0 6.1 0l2.3-2.3a4.3 4.3 0 0 0-6.1-6.1l-1.35 1.35"/><path d="M13.8 10.2a4.2 4.2 0 0 0-6.1 0l-2.3 2.3a4.3 4.3 0 0 0 6.1 6.1l1.35-1.35"/>',
  /* ── toolbar chrome that is not a ContextAction ──────────────────────── */
  "go-up": '<path d="M12 20V5"/><path d="M5.5 11.5L12 5l6.5 6.5"/>',
  /* === gorunum:v2-topbar — the breadcrumb row's own controls ============
     The crumb trail gained the reference shell's three affordances: a home
     crumb in place of the bare "/" root, a chevron on the last crumb that
     lists what is inside it, and the path editor we already had (its glyph
     moves here from Breadcrumb.vue so every mark in the row comes from one
     file). */
  home: '<path d="M3.5 10.6L12 3.5l8.5 7.1"/><path d="M5.6 9.4V19a1.5 1.5 0 0 0 1.5 1.5h9.8a1.5 1.5 0 0 0 1.5-1.5V9.4"/><path d="M9.9 20.5v-5.2h4.2v5.2"/>',
  subfolders: '<path d="M6.8 9.8L12 15l5.2-5.2"/>',
  "edit-path": '<path d="M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17z"/><path d="M14.5 6.5l3 3"/>',
  /* === gorunum:v2-topbar — the header's trailing cluster ================
     The page chrome around the explorer is gone, so the account-level doors
     are drawn by the header itself (the host fills them through the
     `header-actions` slot). The glyphs live here so an embedder's cluster
     comes out the same weight and colour as everything beside it. */
  admin: '<rect x="3" y="3.5" width="7.4" height="7.4" rx="1.6"/><rect x="13.6" y="3.5" width="7.4" height="4.6" rx="1.6"/><rect x="13.6" y="10.7" width="7.4" height="9.8" rx="1.6"/><rect x="3" y="13.6" width="7.4" height="6.9" rx="1.6"/>',
  /* ⚠ A PERSON, not a cog. The first draft drew the gear as a ringed disc with
     eight spokes and at 16px it came out as a SUN — sitting in the very row
     the light/dark toggle had just been removed from, which is the one thing
     the mark must not be mistaken for (measured at 1440 and 390: it read as a
     theme switch in both). The account bust is what the reference hangs this
     menu on, and the tooltip says which settings. */
  account: '<circle cx="12" cy="8.2" r="3.6"/><path d="M4.9 20.3a7.35 7.35 0 0 1 14.2 0"/>',
  "sign-out": '<path d="M9.5 20.5H6a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h3.5"/><path d="M15.5 16.5L20 12l-4.5-4.5"/><path d="M20 12H9"/>',
  /* The AI assistant, drawn but not yet wired — a spark, the mark every
     assistant in this class of product wears, so the day it does something
     the icon does not have to change under people's fingers. */
  ai: '<path d="M12 3.2l1.75 4.3 4.3 1.75-4.3 1.75L12 15.3l-1.75-4.3L5.95 9.25l4.3-1.75z"/><path d="M18.2 15.1l.8 1.95 1.95.8-1.95.8-.8 1.95-.8-1.95-1.95-.8 1.95-.8z"/>',
  /* The notification bell, for the host's header cluster (web/src
     NotificationBell.vue). ⚠ Drawn HERE, not taken from the app's icon
     library: it sits in the same row as refresh, the spark and the avatar,
     and a glyph at a foreign stroke weight in that row is the exact mismatch
     this set exists to prevent. A dome on a flared rim, the clapper below. */
  bell: '<path d="M6.2 16.6V11a5.8 5.8 0 0 1 11.6 0v5.6l1.7 1.9H4.5z"/><path d="M10.1 21a2.1 2.1 0 0 0 3.8 0"/>',
  /* === /gorunum:v2-topbar === */
  search: '<circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l5.1 5.1"/>',
  /* gorunum:v1-advsearch — sliders, not a funnel. A funnel says "throw rows
     away"; this control opens a dialog where you SET things, and two of its
     three rows are exactly a slider's job (a size range, a time window). */
  filter: '<path d="M4 7.5h4"/><path d="M13 7.5h7"/><circle cx="10.5" cy="7.5" r="2.4"/><path d="M4 16.5h7"/><path d="M16 16.5h4"/><circle cx="13.5" cy="16.5" r="2.4"/>',
  more: '<circle cx="5.5" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="18.5" cy="12" r="1.2" fill="currentColor" stroke="none"/>',
  close: '<path d="M5.5 5.5l13 13"/><path d="M18.5 5.5l-13 13"/>',
  /* A share link. Two half-chains, which is what a link IS. The details
     panel's "Not shared / Create link" row used to draw a chain EMOJI
     there, i.e. whatever glyph the OS happened to ship, full-colour,
     beside a column of stroked grey ones. */
  link: '<path d="M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5"/><path d="M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53"/>',
  /* === ikon:emoji — the command palette's own rows =======================
   * The palette printed `{{ it.icon }}` as TEXT: `➜ 📁 ⬆ ▦ 🗑 ⟳ ↑ 🎨 ⌨ 🎓 ⧉ ◫
   * 💾 🔖`. Thirteen marks from four different type families, in a list whose
   * neighbours — the context menu it duplicates and the toolbar it launches —
   * had already moved here. Most of the keys it needed were drawn already
   * (`tour` is the mortarboard, `shortcut-settings` the keyboard, the three
   * `view-*` the mode chips); these six are what was genuinely missing. */
  /* "Go to path" — the arrow goes INTO the box, the mirror of `sign-out`.
     A bare arrow would have said "next", which this row is not. */
  goto: '<path d="M13.5 4.5h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4"/><path d="M10 8.2L13.8 12 10 15.8"/><path d="M4.5 12h9.3"/>',
  /* A second pane opened beside the first — `nav`/`inspector`'s panel with the
     divider down the middle, because that is literally what split view is. */
  split: qr + '<path d="M12 4.5v15"/>',
  /* A new tab: `open-tab`'s window, with the plus in the body rather than on
     the tab strip (at 16px a plus up there merges into the tab). */
  "tab-new": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/><path d="M12 12.1v5"/><path d="M9.5 14.6h5"/>',
  bookmark: Yc,
  "save-search": Yc + '<path d="M12 7.2v5.2"/><path d="M9.4 9.8h5.2"/>',
  /* The padlock, for the rows and strips that talk ABOUT encryption ("create
     an encrypted folder", "this one is unlocked"). The listing marker is a
     different drawing on purpose — there the lock is cut out of the folder,
     because the row still has to read as a folder. */
  lock: '<rect x="4.5" y="10.3" width="15" height="10.2" rx="2.2"/><path d="M7.9 10.3V7.6a4.1 4.1 0 0 1 8.2 0v2.7"/><circle cx="12" cy="15.4" r="1.5"/>',
  /* === ikon:emoji — states the viewers and modals report ================
   * `✓ ✗ ⚠️ ⏳` in the viewer chrome. The first two are typographic and came
   * out at whatever weight the UI font had; the last two are colour emoji, so
   * a fallback screen's 48px mark was the only full-colour thing on a grey
   * page. `progress` is drawn as an open ring because it is SPUN by CSS
   * (`@keyframes fe-spin`) — an hourglass cannot say "still going". */
  check: '<path d="M4.8 12.6l4.7 4.7L19.2 6.9"/>',
  alert: '<path d="M10.7 4.6L2.9 18.2a1.5 1.5 0 0 0 1.3 2.25h15.6a1.5 1.5 0 0 0 1.3-2.25L13.3 4.6a1.5 1.5 0 0 0-2.6 0z"/><path d="M12 9.9v4.3"/><circle cx="12" cy="17.4" r="0.9" fill="currentColor" stroke="none"/>',
  progress: '<path d="M20.5 12a8.5 8.5 0 1 1-8.5-8.5"/>'
}, Wc = /* @__PURE__ */ new Map();
function Ue(e) {
  if (!e) return "";
  const t = Wc.get(e);
  if (t !== void 0) return t;
  const n = ed[e], r = n ? `<svg class="fe-aicon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${n}</svg>` : "";
  return Wc.set(e, r), r;
}
function ID() {
  return Object.keys(ed);
}
const Th = ["data-prefers-dark"], Mh = ["aria-label"], Eh = ["aria-label", "onKeydown"], zh = { class: "fe-sheet__items" }, Ah = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, Ph = ["disabled", "title", "onClick"], Lh = ["innerHTML"], Dh = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, Oh = { class: "fe-ctx__label" }, Bh = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, Ih = ["aria-label"], Hh = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, Fh = ["disabled", "title", "onClick"], Nh = ["innerHTML"], Kh = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, Rh = { class: "fe-ctx__label" }, Uh = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, Ps = /* @__PURE__ */ qe({
  __name: "ContextMenu",
  props: {
    locale: {},
    actions: {},
    theme: {},
    sheet: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, { t: u } = tt(() => r.locale);
    function v(S) {
      return Vu(S.shortcutId ?? S.key);
    }
    function p(S) {
      return Ue(S.icon || S.key);
    }
    const h = m(!1), b = m(0), y = m(0), A = m([]), D = m(null);
    let C = 0, B = 0, I = null;
    async function U(S, w) {
      var j;
      if (I = document.activeElement ?? null, h.value = !0, b.value = S.clientX, y.value = S.clientY, C = S.clientX, B = S.clientY, A.value = w, await gt(), r.sheet) {
        (j = T.value) == null || j.focus();
        return;
      }
      x(), M(0);
    }
    function x() {
      const S = D.value;
      if (!S || typeof window > "u") return;
      const w = S.getBoundingClientRect(), j = 8, K = window.innerWidth, Z = window.innerHeight;
      if (B + w.height > Z - j) {
        const W = B - w.height;
        y.value = W >= j ? W : Math.max(j, Z - w.height - j);
      }
      if (C + w.width > K - j) {
        const W = C - w.width;
        b.value = W >= j ? W : Math.max(j, K - w.width - j);
      }
    }
    function E() {
      var S;
      h.value = !1, Y.value = !1, O.value = 0, (S = I == null ? void 0 : I.focus) == null || S.call(I), I = null;
    }
    function $() {
      const S = r.sheet ? T.value : D.value;
      return S ? Array.from(
        S.querySelectorAll(".fe-ctx__item:not(:disabled)")
      ) : [];
    }
    function M(S) {
      var K;
      const w = $();
      if (w.length === 0) return;
      const j = (S % w.length + w.length) % w.length;
      (K = w[j]) == null || K.focus();
    }
    function z(S) {
      const w = $();
      if (w.length === 0) return;
      const j = document.activeElement, K = j ? w.indexOf(j) : -1;
      if (K === -1) {
        M(S > 0 ? 0 : w.length - 1);
        return;
      }
      M(K + S);
    }
    const T = m(null), Y = m(!1), O = m(0);
    let J = 0;
    function G(S) {
      const w = S.touches[0];
      w && (Y.value = !0, J = w.clientY, O.value = 0);
    }
    function N(S) {
      if (!Y.value) return;
      const w = S.touches[0];
      w && (O.value = Math.max(0, w.clientY - J));
    }
    function P() {
      if (!Y.value) return;
      const S = O.value > 72;
      Y.value = !1, S ? E() : O.value = 0;
    }
    const le = k(
      () => O.value > 0 ? { transform: `translateY(${O.value}px)`, transition: "none" } : void 0
    );
    function ve(S) {
      S.disabled || (a("select", S, A.value), E());
    }
    function he(S) {
      if (S.key === "Escape") {
        S.stopPropagation(), E();
        return;
      }
      if (S.key === "Enter" || S.key === " ") {
        S.stopPropagation();
        return;
      }
      S.key === "ArrowDown" ? (S.preventDefault(), S.stopPropagation(), z(1)) : S.key === "ArrowUp" ? (S.preventDefault(), S.stopPropagation(), z(-1)) : S.key === "Home" ? (S.preventDefault(), M(0)) : S.key === "End" ? (S.preventDefault(), M(-1)) : S.key === "Tab" && (S.preventDefault(), E());
    }
    const oe = k(() => {
      const S = r.actions.filter((j) => !j.hidden), w = [];
      for (const j of S)
        j.divider && (w.length === 0 || w[w.length - 1].divider) || w.push(j);
      for (; w.length > 0 && w[w.length - 1].divider; ) w.pop();
      return w;
    }), ue = m(!1);
    let Q;
    function pe(S) {
      ue.value = !!(S && "matches" in S && S.matches);
    }
    dt(() => {
      var S;
      typeof window > "u" || (Q = window.matchMedia("(prefers-color-scheme: dark)"), pe(Q), (S = Q.addEventListener) == null || S.call(Q, "change", pe));
    }), it(() => {
      var S;
      (S = Q == null ? void 0 : Q.removeEventListener) == null || S.call(Q, "change", pe);
    });
    const re = k(() => `fe-ctx-backdrop--theme-${r.theme || "auto"}`);
    return t({ show: U, hide: E }), (S, w) => (c(), et(ja, { to: "body" }, [
      Ge(Rn, {
        name: e.sheet ? "fe-sheet" : "fe-ctx"
      }, {
        default: st(() => [
          h.value ? (c(), d("div", {
            key: 0,
            class: we(["fe-ctx-backdrop", [re.value, { "fe-ctx-backdrop--sheet": e.sheet }]]),
            "data-prefers-dark": ue.value ? "1" : "0",
            onClick: E,
            onContextmenu: Re(E, ["prevent"]),
            onKeydown: he
          }, [
            e.sheet ? (c(), d("div", {
              key: 0,
              ref_key: "sheetEl",
              ref: T,
              class: "fe-sheet",
              role: "menu",
              "aria-label": s(u)("sheet.menu"),
              tabindex: "-1",
              style: Ct(le.value),
              onClick: w[0] || (w[0] = Re(() => {
              }, ["stop"]))
            }, [
              o("div", {
                class: "fe-sheet__handle",
                role: "button",
                tabindex: "0",
                "aria-label": s(u)("sheet.close"),
                onClick: E,
                onKeydown: Ut(Re(E, ["prevent"]), ["enter"]),
                onTouchstartPassive: G,
                onTouchmovePassive: N,
                onTouchend: P,
                onTouchcancel: P
              }, null, 40, Eh),
              o("div", zh, [
                (c(!0), d(ae, null, Te(oe.value, (j, K) => (c(), d(ae, {
                  key: j.key || K
                }, [
                  j.divider ? (c(), d("div", Ah)) : (c(), d("button", {
                    key: 1,
                    type: "button",
                    class: we(["fe-ctx__item fe-sheet__item", { "is-danger": j.danger, "is-disabled": j.disabled }]),
                    disabled: j.disabled,
                    title: j.title,
                    role: "menuitem",
                    onClick: (Z) => ve(j)
                  }, [
                    p(j) ? (c(), d("span", {
                      key: 0,
                      class: "fe-ctx__icon",
                      "aria-hidden": "true",
                      innerHTML: p(j)
                    }, null, 8, Lh)) : j.icon ? (c(), d("span", Dh, f(j.icon), 1)) : g("", !0),
                    o("span", Oh, f(j.label), 1),
                    v(j) ? (c(), d("span", Bh, f(v(j)), 1)) : g("", !0)
                  ], 10, Ph))
                ], 64))), 128))
              ])
            ], 12, Mh)) : (c(), d("div", {
              key: 1,
              ref_key: "menuEl",
              ref: D,
              class: "fe-ctx",
              role: "menu",
              "aria-orientation": "vertical",
              "aria-label": s(u)("sheet.menu"),
              style: Ct({ top: y.value + "px", left: b.value + "px" }),
              onClick: w[1] || (w[1] = Re(() => {
              }, ["stop"]))
            }, [
              (c(!0), d(ae, null, Te(oe.value, (j, K) => (c(), d(ae, {
                key: j.key || K
              }, [
                j.divider ? (c(), d("div", Hh)) : (c(), d("button", {
                  key: 1,
                  type: "button",
                  class: we(["fe-ctx__item", { "is-danger": j.danger, "is-disabled": j.disabled }]),
                  disabled: j.disabled,
                  title: j.title,
                  role: "menuitem",
                  onClick: (Z) => ve(j)
                }, [
                  p(j) ? (c(), d("span", {
                    key: 0,
                    class: "fe-ctx__icon",
                    "aria-hidden": "true",
                    innerHTML: p(j)
                  }, null, 8, Nh)) : j.icon ? (c(), d("span", Kh, f(j.icon), 1)) : g("", !0),
                  o("span", Rh, f(j.label), 1),
                  v(j) ? (c(), d("span", Uh, f(v(j)), 1)) : g("", !0)
                ], 10, Fh))
              ], 64))), 128))
            ], 12, Ih))
          ], 42, Th)) : g("", !0)
        ]),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), Vh = ["aria-pressed", "title", "aria-label"], jh = {
  key: 1,
  class: "fe-toolbar__mark"
}, Yh = ["src"], Wh = { key: 1 }, qh = { class: "fe-toolbar__primary" }, Gh = ["title"], Xh = ["innerHTML"], Jh = { class: "fe-btn__label" }, Zh = ["title", "aria-label"], Qh = ["innerHTML"], em = ["title"], tm = ["innerHTML"], nm = { class: "fe-btn__label" }, am = { class: "fe-toolbar__search-group fe-toolbar__search-group--drive" }, om = {
  class: "fe-search fe-drivesearch",
  "data-testid": "drive-search"
}, sm = ["placeholder", "value", "aria-label"], rm = ["title", "aria-label"], im = ["innerHTML"], lm = ["title", "aria-label"], cm = { class: "fe-toolbar__tail" }, um = ["title", "aria-label"], dm = ["innerHTML"], fm = { class: "fe-toolbar__soon-wrap" }, pm = ["aria-label"], vm = ["innerHTML"], hm = {
  class: "fe-toolbar__soon-tip",
  "aria-hidden": "true",
  "data-testid": "header-ai-tip"
}, mm = ["title", "aria-label"], ym = ["innerHTML"], bm = {
  class: "fe-drivesearch",
  "data-testid": "drive-search"
}, gm = ["placeholder", "value", "aria-label"], km = ["title", "aria-label"], _m = ["innerHTML"], wm = ["title", "aria-label"], $m = { class: "fe-toolbar__tail" }, xm = { class: "fe-toolbar__soon-wrap" }, Sm = ["aria-label"], Cm = ["innerHTML"], Tm = {
  class: "fe-toolbar__soon-tip",
  "aria-hidden": "true",
  "data-testid": "header-ai-tip"
}, Mm = ["title", "aria-label"], Em = ["innerHTML"], zm = ["aria-label"], Am = {
  class: "fe-selbar__count",
  role: "status",
  "data-testid": "selection-count"
}, Pm = ["disabled", "title", "aria-label", "data-key", "data-testid", "onClick"], Lm = ["innerHTML"], Dm = ["title", "aria-label"], Om = ["innerHTML"], Bm = ["data-key"], Im = ["innerHTML"], Hm = ["title", "aria-label"], Fm = ["innerHTML"], ys = "filex.density", Nm = 32, qc = "fe:header-menu", Km = /* @__PURE__ */ qe({
  __name: "Toolbar",
  props: {
    viewMode: {},
    searchQuery: {},
    trashActive: { type: Boolean },
    actions: {},
    selectionMode: {},
    selectionCount: {},
    selectionPane: {},
    pasteEnabled: { type: Boolean },
    convertEnabled: { type: Boolean },
    canGoUp: { type: Boolean },
    atVirtualRoot: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    narrow: { type: Boolean },
    theme: {},
    inspectorOpen: { type: Boolean },
    navOpen: { type: Boolean },
    navEnabled: { type: Boolean },
    viewModes: {},
    scopeLabel: {},
    brandName: {},
    brandMarkUrl: {},
    searchEscalates: { type: Boolean }
  },
  emits: ["update:viewMode", "update:searchQuery", "open-advanced-search", "new-folder", "upload", "refresh", "go-up", "action", "open-recents", "update:density", "toggle-inspector", "toggle-nav", "open-theme", "open-shortcut-settings", "open-timezone", "open-palette"],
  setup(e, { expose: t, emit: n }) {
    function r(fe) {
      return Ue(fe.icon || fe.key);
    }
    const a = e, u = n, v = m(
      (() => {
        try {
          return localStorage.getItem(ys) === "compact" ? "compact" : "comfortable";
        } catch {
          return "comfortable";
        }
      })()
    );
    function p() {
      try {
        const fe = localStorage.getItem(ys) === "compact" ? "compact" : "comfortable";
        fe !== v.value && (v.value = fe, u("update:density", fe));
      } catch {
      }
    }
    function h(fe) {
      (fe.key === null || fe.key === ys) && p();
    }
    dt(() => {
      u("update:density", v.value), window.addEventListener("storage", h), window.addEventListener("filex:density", p);
    }), it(() => {
      window.removeEventListener("storage", h), window.removeEventListener("filex:density", p);
    });
    function b() {
      v.value = v.value === "compact" ? "comfortable" : "compact";
      try {
        localStorage.setItem(ys, v.value);
      } catch {
      }
      u("update:density", v.value);
    }
    const { t: y } = tt(() => a.locale), A = m(null), D = m(a.searchQuery);
    He(() => a.searchQuery, (fe) => {
      D.value = fe;
    });
    let C;
    function B(fe) {
      const Pe = fe.target.value;
      D.value = Pe, C && clearTimeout(C), C = setTimeout(() => u("update:searchQuery", Pe), 200);
    }
    async function I() {
      var fe, Pe;
      await gt(), (fe = A.value) == null || fe.focus(), (Pe = A.value) == null || Pe.select();
    }
    t({ focusSearch: I });
    const U = k(() => a.selectionMode ?? "none"), x = k(() => a.actions.filter((fe) => !fe.divider && !fe.hidden)), E = /* @__PURE__ */ new Set(["download", "access", "cut", "copy", "star", "restore", "delete"]), $ = k(() => U.value !== "none"), M = k(() => {
      const fe = [], Pe = [];
      for (const Be of x.value)
        E.has(Be.key) && r(Be) ? fe.push(Be) : Pe.push(Be);
      return { icons: fe, rest: Pe };
    }), z = m(null), T = m(null), Y = m(null), O = m(null), J = m(Number.MAX_SAFE_INTEGER), G = k(() => M.value.icons.slice(0, J.value)), N = k(() => M.value.icons.slice(J.value)), P = k(() => {
      const fe = N.value, Pe = M.value.rest;
      return fe.length && Pe.length ? [...fe, { divider: !0, key: "selbar-sep", label: "" }, ...Pe] : [...fe, ...Pe];
    });
    function le() {
      var $t;
      const fe = z.value, Pe = T.value, Be = M.value.icons.length;
      if (!fe || !Pe) {
        J.value = Be;
        return;
      }
      const ht = parseFloat(getComputedStyle(fe).gap) || 4, Ft = Array.from(Pe.children).map((kt) => kt.offsetWidth + ht), ft = Ft.reduce((kt, Dt) => kt + Dt, 0), qt = fe.clientWidth, Gt = ((($t = Y.value) == null ? void 0 : $t.offsetWidth) || Nm) + ht;
      if (ft <= qt - (M.value.rest.length ? Gt : 0)) {
        J.value = Ft.length;
        return;
      }
      let wt = Gt, en = 0;
      for (const kt of Ft) {
        if (wt + kt > qt) break;
        wt += kt, en += 1;
      }
      J.value = en;
    }
    let ve;
    He(z, (fe) => {
      ve == null || ve.disconnect(), ve = void 0, fe && typeof ResizeObserver < "u" && (ve = new ResizeObserver(() => le()), ve.observe(fe)), gt(le);
    }), it(() => ve == null ? void 0 : ve.disconnect()), He(
      () => [x.value, a.narrow, a.trashActive, U.value],
      () => void gt(le),
      { deep: !1 }
    );
    function he() {
      var Pe, Be;
      const fe = (Pe = Y.value) == null ? void 0 : Pe.getBoundingClientRect();
      (Be = O.value) == null || Be.show({ clientX: fe ? fe.right : 0, clientY: fe ? fe.bottom + 4 : 0 }, []);
    }
    const oe = m(null), ue = wn(null), Q = m(!1), pe = wn(null), re = wn(null);
    function S() {
      var Be;
      const fe = (Be = oe.value) == null ? void 0 : Be.closest(".fe");
      if (!fe) return null;
      const Pe = a.selectionPane;
      if (Pe && /^[A-Za-z][\w-]*$/.test(Pe)) {
        const ht = fe.querySelector(`.fe__primary[data-pane="${Pe}"]`);
        if (ht) return ht;
      }
      return fe.querySelector(".fe__primary");
    }
    function w() {
      const fe = ue.value;
      fe && (fe.classList.remove("is-active"), Q.value && fe.remove()), ue.value = null, Q.value = !1;
    }
    function j() {
      var Be;
      const fe = S();
      if (!fe) {
        w(), re.value = null, pe.value = null;
        return;
      }
      if (re.value === fe && ((Be = ue.value) != null && Be.isConnected)) return;
      w(), re.value = fe, pe.value = fe.querySelector(":scope > .fe__body");
      const Pe = fe.querySelector(":scope > .fe-selbar-slot");
      if (Pe)
        ue.value = Pe, Q.value = !1;
      else {
        const ht = document.createElement("div");
        ht.className = "fe-selbar-slot";
        const Ft = fe.querySelector(":scope > .fe-tabs") ?? fe.querySelector(":scope > .fe-subhead, :scope > .fe-subhead--plain");
        Ft ? Ft.insertAdjacentElement("afterend", ht) : fe.prepend(ht), ue.value = ht, Q.value = !0;
      }
      K(), Ne();
    }
    dt(j), it(w);
    function K() {
      var fe;
      (fe = ue.value) == null || fe.classList.toggle("is-active", $.value);
    }
    He($, K, { immediate: !0 }), He([() => a.selectionPane, $], () => j());
    const Z = m(0);
    let W, $e = !1;
    function Se() {
      const fe = re.value;
      fe && (Z.value = fe.querySelectorAll('[data-fe-path][aria-selected="true"]').length);
    }
    function ze() {
      if ($e) return;
      $e = !0, ((Pe) => typeof requestAnimationFrame == "function" ? requestAnimationFrame(Pe) : setTimeout(Pe, 16))(() => {
        $e = !1, Se();
      });
    }
    function Ne() {
      if (W == null || W.disconnect(), W = void 0, !$.value) {
        Z.value = 0;
        return;
      }
      Se(), !(typeof MutationObserver > "u" || !re.value) && (W = new MutationObserver(ze), W.observe(re.value, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: ["aria-selected"]
      }));
    }
    He($, Ne), it(() => W == null ? void 0 : W.disconnect());
    const be = k(() => typeof a.selectionCount == "number" ? a.selectionCount : U.value === "none" ? 0 : Math.max(Z.value, U.value === "multi" ? 2 : 1)), De = k(() => y("selection.count", { n: String(be.value) }));
    function ie() {
      var fe;
      u("action", "clear-selection"), (fe = pe.value) == null || fe.dispatchEvent(new MouseEvent("click", { bubbles: !0 }));
    }
    function ce(fe) {
      u("action", fe);
    }
    const L = m(!1);
    let se;
    function Ce(fe) {
      L.value = !!(fe && "matches" in fe && fe.matches);
    }
    dt(() => {
      var fe;
      typeof window > "u" || !window.matchMedia || (se = window.matchMedia("(pointer: coarse)"), Ce(se), (fe = se.addEventListener) == null || fe.call(se, "change", Ce));
    }), it(() => {
      var fe;
      (fe = se == null ? void 0 : se.removeEventListener) == null || fe.call(se, "change", Ce);
    });
    const We = m(null), Ie = m(null);
    function Ze(fe) {
      return !a.viewModes || a.viewModes.includes(fe);
    }
    const vt = k(() => {
      const fe = [];
      return a.narrow && fe.push({ key: "refresh", label: y("toolbar.refresh") }), fe.push({
        key: "density",
        label: v.value === "compact" ? y("toolbar.density.comfortable") : y("toolbar.density.compact")
      }), a.viewMode !== "list" && Ze("list") && fe.push({ key: "view-list", label: y("toolbar.view.list") }), a.viewMode !== "grid" && Ze("grid") && fe.push({ key: "view-grid", label: y("toolbar.view.grid") }), a.viewMode !== "gallery" && Ze("gallery") && fe.push({ key: "view-gallery", label: y("toolbar.view.gallery") }), fe.push({ key: "inspector", label: y("toolbar.inspector") }), fe.push({ key: "theme", label: y("theme.menu") }), fe.push({ key: "timezone", label: y("tz.menu") }), fe.push({ key: "shortcut-settings", label: y("shortcuts.settings.menu") }), fe.push({ key: "tour", label: y("tour.restart") }), fe;
    });
    function Xe(fe) {
      const Pe = [], Be = !a.trashActive && !a.atVirtualRoot && a.canWrite !== !1;
      return U.value === "none" && Be && (Pe.push({ key: "new-folder", label: y("toolbar.new_folder") }), a.pasteEnabled && Pe.push({ key: "paste", label: y("ctx.paste") })), $.value || Pe.push(...x.value), fe.length && (Pe.length && Pe.push({ divider: !0, key: "bag-sep", label: "" }), Pe.push(...fe)), Pe;
    }
    const Ae = k(() => Na("palette"));
    function V(fe, Pe) {
      const Be = Vu(Pe);
      return Be ? `${fe} (${Be})` : fe;
    }
    const R = k(() => a.narrow ? a.navOpen ? y("sidenav.close") : y("sidenav.open") : a.navOpen ? y("sidenav.collapse") : y("sidenav.expand")), X = k(
      () => a.scopeLabel ? y("drive.search.placeholder", { scope: a.scopeLabel }) : y("drive.search.placeholder_all")
    );
    function ye(fe) {
      if (si(fe, "palette")) {
        fe.preventDefault(), fe.stopPropagation(), u("open-palette", D.value);
        return;
      }
      a.searchEscalates && fe.key === "Enter" && D.value && (fe.preventDefault(), fe.stopPropagation(), u("open-palette", D.value));
    }
    const je = m(!1);
    function Qe() {
      const fe = oe.value;
      if (!fe) return;
      const Pe = {
        items: vt.value.map((Be) => ({ ...Be })),
        run: (Be) => lt({ key: Be }),
        claimed: !1
      };
      fe.dispatchEvent(
        new CustomEvent(qc, { detail: Pe, bubbles: !0, composed: !0 })
      ), je.value = !!Pe.claimed;
    }
    dt(() => void gt(Qe)), He(vt, () => void gt(Qe), { deep: !1 }), it(() => {
      typeof document > "u" || document.dispatchEvent(
        new CustomEvent(qc, {
          detail: { items: [], run: () => {
          }, claimed: !1 }
        })
      );
    });
    const at = k(() => {
      const fe = je.value ? [] : vt.value;
      return a.narrow ? Xe(fe) : fe;
    });
    function Ye() {
      var Pe, Be;
      const fe = (Pe = We.value) == null ? void 0 : Pe.getBoundingClientRect();
      (Be = Ie.value) == null || Be.show({ clientX: fe ? fe.right : 0, clientY: fe ? fe.bottom + 4 : 0 }, []);
    }
    function lt(fe) {
      var Pe;
      switch (fe.key) {
        case "new-folder":
          u("new-folder");
          break;
        case "refresh":
          u("refresh");
          break;
        case "density":
          b();
          break;
        case "view-list":
          u("update:viewMode", "list");
          break;
        case "view-grid":
          u("update:viewMode", "grid");
          break;
        case "view-gallery":
          u("update:viewMode", "gallery");
          break;
        case "inspector":
          u("toggle-inspector");
          break;
        case "nav":
          u("toggle-nav");
          break;
        case "theme":
          u("open-theme");
          break;
        case "shortcut-settings":
          u("open-shortcut-settings");
          break;
        case "timezone":
          u("open-timezone");
          break;
        case "tour":
          (Pe = oe.value) == null || Pe.dispatchEvent(new CustomEvent("fe:tour-restart", { bubbles: !0 }));
          break;
        default:
          ce(fe.key);
      }
    }
    return (fe, Pe) => (c(), d("div", {
      ref_key: "rootEl",
      ref: oe,
      class: we(["fe-toolbar", {
        "fe-toolbar--narrow": e.narrow,
        /* surucu:d1 — ALWAYS on. It is no longer a variant: this is the only
           header filex has, and the modifier survives as the hook the one
           visual definition in styles/base.css was written against. Dropping it
           would mean moving those rules, not deleting a state. */
        "fe-toolbar--drive": !0
      }])
    }, [
      e.navEnabled !== !1 || fe.$slots.brand || e.brandName || e.brandMarkUrl ? (c(), d("div", {
        key: 0,
        class: we(["fe-toolbar__brand", {
          "fe-toolbar__brand--gutter": e.navEnabled !== !1,
          /* gezinti:g3 — the panel collapsed to its rail, so this gutter has to
             collapse with it. `navOpen === false`, never `!navOpen`: the prop is
             optional, and an embedder that does not pass it must keep the
             expanded layout rather than lose its wordmark to a `undefined`. */
          "fe-toolbar__brand--rail": !e.narrow && e.navEnabled !== !1 && e.navOpen === !1
        }])
      }, [
        e.navEnabled !== !1 ? (c(), d("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--icon-only fe-toolbar__nav",
          "aria-pressed": !!e.navOpen,
          title: R.value,
          "aria-label": R.value,
          "data-testid": "toolbar-nav",
          onClick: Pe[0] || (Pe[0] = (Be) => u("toggle-nav"))
        }, [...Pe[12] || (Pe[12] = [
          o("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            o("path", { d: "M4 7h16M4 12h16M4 17h16" })
          ], -1)
        ])], 8, Vh)) : g("", !0),
        !e.narrow && e.navOpen !== !1 ? (c(), d("div", jh, [
          _n(fe.$slots, "brand", {}, () => [
            e.brandMarkUrl ? (c(), d("img", {
              key: 0,
              class: "fe-toolbar__markimg",
              src: e.brandMarkUrl,
              alt: ""
            }, null, 8, Yh)) : g("", !0),
            e.brandName ? (c(), d("span", Wh, f(e.brandName), 1)) : g("", !0)
          ])
        ])) : g("", !0)
      ], 2)) : g("", !0),
      e.narrow ? (c(), d(ae, { key: 2 }, [
        o("div", bm, [
          Pe[14] || (Pe[14] = o("svg", {
            class: "fe-ficon fe-drivesearch__glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            o("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            o("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          o("input", {
            ref_key: "searchEl",
            ref: A,
            type: "search",
            class: "fe-drivesearch__input",
            placeholder: X.value,
            value: D.value,
            "aria-label": s(y)("toolbar.search"),
            onInput: B,
            onKeydown: ye
          }, null, 40, gm),
          o("button", {
            type: "button",
            class: "fe-drivesearch__tune",
            title: s(y)("advsearch.open"),
            "aria-label": s(y)("advsearch.open"),
            "data-testid": "drive-search-advanced",
            onClick: Pe[8] || (Pe[8] = (Be) => u("open-advanced-search", D.value))
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("filter")
            }, null, 8, _m)
          ], 8, km),
          o("button", {
            type: "button",
            class: "fe-drivesearch__kbd",
            title: s(y)("drive.search.hint_title", { combo: Ae.value }),
            "aria-label": s(y)("drive.search.hint_title", { combo: Ae.value }),
            "data-testid": "drive-search-palette",
            onClick: Pe[9] || (Pe[9] = (Be) => u("open-palette", D.value))
          }, f(Ae.value), 9, wm)
        ]),
        o("div", $m, [
          o("span", xm, [
            o("button", {
              type: "button",
              class: "fe-btn fe-btn--icon-only fe-toolbar__soon",
              disabled: "",
              "aria-label": s(y)("ai.assistant.soon"),
              "aria-disabled": "true",
              "data-testid": "header-ai",
              onClick: Pe[10] || (Pe[10] = Re(() => {
              }, ["prevent"]))
            }, [
              o("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: s(Ue)("ai")
              }, null, 8, Cm)
            ], 8, Sm),
            o("span", Tm, f(s(y)("ai.assistant.soon")), 1)
          ]),
          at.value.length > 0 ? (c(), d("button", {
            key: 0,
            ref_key: "moreBtnEl",
            ref: We,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: s(y)("toolbar.more"),
            "aria-label": s(y)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: Ye
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("more")
            }, null, 8, Em)
          ], 8, Mm)) : g("", !0),
          _n(fe.$slots, "header-actions")
        ])
      ], 64)) : (c(), d(ae, { key: 1 }, [
        o("div", qh, [
          e.navEnabled === !1 && U.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (c(), d("button", {
            key: 0,
            type: "button",
            class: "fe-btn fe-btn--primary",
            title: V(s(y)("toolbar.new_folder"), "new-folder"),
            onClick: Pe[1] || (Pe[1] = (Be) => u("new-folder"))
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("new-folder")
            }, null, 8, Xh),
            o("span", Jh, f(s(y)("toolbar.new_folder")), 1)
          ], 8, Gh)) : g("", !0),
          e.navEnabled === !1 && !e.atVirtualRoot && e.canWrite !== !1 ? (c(), d("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: V(s(y)("toolbar.upload"), "upload"),
            "aria-label": s(y)("toolbar.upload"),
            onClick: Pe[2] || (Pe[2] = (Be) => u("upload"))
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("upload")
            }, null, 8, Qh)
          ], 8, Zh)) : g("", !0),
          e.pasteEnabled && U.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (c(), d("button", {
            key: 2,
            type: "button",
            class: "fe-btn",
            title: V(s(y)("ctx.paste"), "paste"),
            onClick: Pe[3] || (Pe[3] = (Be) => ce("paste"))
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("paste")
            }, null, 8, tm),
            o("span", nm, f(s(y)("ctx.paste")), 1)
          ], 8, em)) : g("", !0)
        ]),
        o("div", am, [
          o("div", om, [
            Pe[13] || (Pe[13] = o("svg", {
              class: "fe-ficon fe-drivesearch__glass",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              o("circle", {
                cx: "11",
                cy: "11",
                r: "6.5"
              }),
              o("path", { d: "M16 16l4.5 4.5" })
            ], -1)),
            o("input", {
              ref_key: "searchEl",
              ref: A,
              type: "search",
              class: "fe-search__input fe-drivesearch__input",
              placeholder: X.value,
              value: D.value,
              "aria-label": s(y)("toolbar.search"),
              onInput: B,
              onKeydown: ye
            }, null, 40, sm),
            o("button", {
              type: "button",
              class: "fe-drivesearch__tune",
              title: s(y)("advsearch.open"),
              "aria-label": s(y)("advsearch.open"),
              "data-testid": "drive-search-advanced",
              onClick: Pe[4] || (Pe[4] = (Be) => u("open-advanced-search", D.value))
            }, [
              o("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: s(Ue)("filter")
              }, null, 8, im)
            ], 8, rm),
            o("button", {
              type: "button",
              class: "fe-drivesearch__kbd",
              title: s(y)("drive.search.hint_title", { combo: Ae.value }),
              "aria-label": s(y)("drive.search.hint_title", { combo: Ae.value }),
              "data-testid": "drive-search-palette",
              onClick: Pe[5] || (Pe[5] = (Be) => u("open-palette", D.value))
            }, f(Ae.value), 9, lm)
          ])
        ]),
        o("div", cm, [
          o("button", {
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: V(s(y)("toolbar.refresh"), "refresh"),
            "aria-label": s(y)("toolbar.refresh"),
            onClick: Pe[6] || (Pe[6] = (Be) => u("refresh"))
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("refresh")
            }, null, 8, dm)
          ], 8, um),
          o("span", fm, [
            o("button", {
              type: "button",
              class: "fe-btn fe-btn--icon-only fe-toolbar__soon",
              disabled: "",
              "aria-label": s(y)("ai.assistant.soon"),
              "aria-disabled": "true",
              "data-testid": "header-ai",
              onClick: Pe[7] || (Pe[7] = Re(() => {
              }, ["prevent"]))
            }, [
              o("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: s(Ue)("ai")
              }, null, 8, vm)
            ], 8, pm),
            o("span", hm, f(s(y)("ai.assistant.soon")), 1)
          ]),
          at.value.length > 0 ? (c(), d("button", {
            key: 0,
            ref_key: "moreBtnEl",
            ref: We,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: s(y)("toolbar.more"),
            "aria-label": s(y)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: Ye
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("more")
            }, null, 8, ym)
          ], 8, mm)) : g("", !0),
          _n(fe.$slots, "header-actions")
        ])
      ], 64)),
      Ge(Ps, {
        ref_key: "moreRef",
        ref: Ie,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: L.value,
        actions: at.value,
        onSelect: lt
      }, null, 8, ["locale", "theme", "sheet", "actions"]),
      (c(), et(ja, {
        to: ue.value || "body",
        disabled: !ue.value
      }, [
        $.value ? (c(), d("div", {
          key: 0,
          class: we(["fe-selbar", { "fe-selbar--inline": !ue.value }]),
          role: "toolbar",
          "aria-label": De.value,
          "data-testid": "selection-bar"
        }, [
          o("span", Am, f(De.value), 1),
          o("div", {
            ref_key: "selBarEl",
            ref: z,
            class: "fe-selbar__actions"
          }, [
            (c(!0), d(ae, null, Te(G.value, (Be) => (c(), d("button", {
              key: Be.key,
              type: "button",
              class: we(["fe-selbar__btn", { "fe-selbar__btn--danger": Be.danger, "is-disabled": Be.disabled }]),
              disabled: Be.disabled,
              title: Be.title || V(Be.label, Be.key),
              "aria-label": Be.label,
              "data-key": Be.key,
              "data-testid": `selbar-${Be.key}`,
              onClick: (ht) => ce(Be.key)
            }, [
              o("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: r(Be)
              }, null, 8, Lm)
            ], 10, Pm))), 128)),
            P.value.length > 0 ? (c(), d("button", {
              key: 0,
              ref_key: "selMoreBtnEl",
              ref: Y,
              type: "button",
              class: "fe-selbar__btn",
              title: s(y)("toolbar.more"),
              "aria-label": s(y)("toolbar.more"),
              "aria-haspopup": "menu",
              "data-testid": "selbar-more",
              onClick: he
            }, [
              o("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: s(Ue)("more")
              }, null, 8, Om)
            ], 8, Dm)) : g("", !0),
            o("div", {
              ref_key: "measureEl",
              ref: T,
              class: "fe-selbar__measure",
              "aria-hidden": "true"
            }, [
              (c(!0), d(ae, null, Te(M.value.icons, (Be) => (c(), d("button", {
                key: "m-" + Be.key,
                type: "button",
                class: "fe-selbar__btn",
                "data-key": Be.key,
                tabindex: "-1"
              }, [
                o("span", {
                  class: "fe-icon",
                  "aria-hidden": "true",
                  innerHTML: r(Be)
                }, null, 8, Im)
              ], 8, Bm))), 128))
            ], 512)
          ], 512),
          o("button", {
            type: "button",
            class: "fe-selbar__close",
            title: s(y)("selection.clear"),
            "aria-label": s(y)("selection.clear"),
            "data-testid": "selection-clear",
            onClick: ie
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("close")
            }, null, 8, Fm)
          ], 8, Hm)
        ], 10, zm)) : g("", !0)
      ], 8, ["to", "disabled"])),
      Ge(Ps, {
        ref_key: "selMoreRef",
        ref: O,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: L.value,
        actions: P.value,
        onSelect: Pe[11] || (Pe[11] = (Be) => ce(Be.key))
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 2));
  }
}), Rm = ["title", "aria-label", "data-testid", "onClick"], Um = ["onClick", "aria-label"], Vm = ["placeholder", "aria-label"], td = /* @__PURE__ */ qe({
  __name: "TagPicker",
  props: {
    nodeId: {},
    locale: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    palette: {}
  },
  emits: ["change", "error", "open"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale ?? "en");
    function u(x) {
      return a("tags.open", { tag: x });
    }
    const v = m([]), p = m(!1), h = m(!1), b = m(""), y = k(() => n.palette ?? [
      "#ef4444",
      "#f59e0b",
      "#10b981",
      "#3b82f6",
      "#8b5cf6",
      "#ec4899",
      "#14b8a6",
      "#f97316"
    ]);
    function A(x) {
      let E = 0;
      for (let M = 0; M < x.length; M++) E = E * 31 + x.charCodeAt(M) | 0;
      const $ = y.value;
      return $[Math.abs(E) % $.length];
    }
    async function D(x = {}) {
      return { ...await (n.authHeaders ?? (() => ({})))(), ...x };
    }
    async function C() {
      p.value = !0;
      try {
        const x = n.apiBase ?? "", E = await fetch(`${x}/api/files/manager/tags?node_id=${n.nodeId}`, {
          headers: await D(),
          credentials: n.authCredentials ?? "same-origin"
        });
        if (E.ok) {
          const $ = await E.json();
          v.value = Array.isArray($.tags) ? $.tags : [];
        }
      } catch (x) {
        r("error", x instanceof Error ? x.message : String(x));
      } finally {
        p.value = !1;
      }
    }
    async function B(x) {
      const E = [...v.value];
      v.value = x;
      try {
        const $ = n.apiBase ?? "", M = await fetch(`${$}/api/files/manager/tags`, {
          method: "POST",
          headers: await D({ "Content-Type": "application/json" }),
          credentials: n.authCredentials ?? "same-origin",
          body: JSON.stringify({ node_id: n.nodeId, tags: x })
        });
        if (!M.ok) throw new Error(`tag save failed: ${M.status}`);
        r("change", x);
      } catch ($) {
        v.value = E, r("error", $ instanceof Error ? $.message : String($));
      }
    }
    function I() {
      const x = b.value.trim();
      if (!x || v.value.includes(x)) {
        b.value = "", h.value = !1;
        return;
      }
      B([...v.value, x]), b.value = "", h.value = !1;
    }
    function U(x) {
      B(v.value.filter((E) => E !== x));
    }
    return dt(C), He(() => n.nodeId, C), (x, E) => (c(), d("div", {
      class: we(["filex-tag-picker", { "is-loading": p.value }])
    }, [
      (c(!0), d(ae, null, Te(v.value, ($) => (c(), d("span", {
        key: $,
        class: "filex-tag",
        style: Ct({ "--filex-tag-color": A($) })
      }, [
        o("button", {
          class: "filex-tag-open",
          type: "button",
          title: u($),
          "aria-label": u($),
          "data-testid": `tag-open-${$}`,
          onClick: (M) => r("open", $)
        }, f($), 9, Rm),
        o("button", {
          class: "filex-tag-x",
          type: "button",
          onClick: (M) => U($),
          "aria-label": s(a)("tags.remove")
        }, "×", 8, Um)
      ], 4))), 128)),
      h.value ? (c(), d("form", {
        key: 0,
        class: "filex-tag-add",
        onSubmit: Re(I, ["prevent"])
      }, [
        Ve(o("input", {
          "onUpdate:modelValue": E[0] || (E[0] = ($) => b.value = $),
          autofocus: "",
          placeholder: s(a)("tags.name"),
          "aria-label": s(a)("tags.name"),
          onBlur: I,
          onKeydown: E[1] || (E[1] = Ut(($) => {
            h.value = !1, b.value = "";
          }, ["escape"]))
        }, null, 40, Vm), [
          [rt, b.value]
        ])
      ], 32)) : (c(), d("button", {
        key: 1,
        class: "filex-tag-add-btn",
        type: "button",
        onClick: E[2] || (E[2] = ($) => h.value = !0)
      }, f(s(a)("tags.add")), 1))
    ], 2));
  }
}), nd = {};
function Dn(e, t) {
  for (const n of t) nd[n] = e;
}
Dn("image", ["jpg", "jpeg", "png", "webp", "gif", "bmp", "avif", "heic", "svg", "ico", "tiff", "tif"]);
Dn("video", ["mp4", "webm", "mov", "mkv", "avi", "ogv", "m4v"]);
Dn("audio", ["mp3", "wav", "flac", "ogg", "m4a", "aac", "opus"]);
Dn("pdf", ["pdf"]);
Dn("doc", ["doc", "docx", "odt", "rtf"]);
Dn("sheet", ["xls", "xlsx", "ods", "csv", "tsv"]);
Dn("slides", ["ppt", "pptx", "odp"]);
Dn("archive", ["zip", "tar", "gz", "bz2", "7z", "rar", "xz", "zst"]);
Dn("code", [
  "js",
  "ts",
  "jsx",
  "tsx",
  "mjs",
  "cjs",
  "vue",
  "py",
  "go",
  "rs",
  "php",
  "rb",
  "java",
  "kt",
  "swift",
  "c",
  "cpp",
  "h",
  "hpp",
  "cs",
  "css",
  "scss",
  "less",
  "html",
  "htm",
  "json",
  "yml",
  "yaml",
  "xml",
  "sh",
  "bash",
  "ps1",
  "sql",
  "toml"
]);
Dn("text", ["txt", "md", "markdown", "log", "ini", "conf", "cfg", "env"]);
function Pi(e) {
  return e.mime_type === "inode/storage";
}
function jn(e) {
  if (Pi(e)) return "storage";
  if (e.basename === ".trash") return "trash";
  if (e.type === "dir") return "folder";
  const t = (e.extension || "").toLowerCase();
  return nd[t] ?? "unknown";
}
const ea = '<path d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3z"/><path d="M13.5 3v5h5"/>', jm = {
  // Folder is the one "filled" member — a soft currentColor wash keeps it
  // visually anchored without breaking the line style.
  /**
   * gorunum:v1 — the folder is SOLID, and it is the one glyph that never
   * gets a tile. A folder is the most common thing in a listing; drawn as an
   * outline in the same weight as the file glyphs it disappears into them,
   * and the eye has to read the label to tell a folder from a document. Filled
   * and in its own colour it is recognisable before the name is read.
   */
  folder: '<path d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5z" fill="currentColor" stroke="none"/>',
  image: '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.6" cy="10" r="1.6"/><path d="M5.2 16.6l4.3-4.3 3 3 2.4-2.4 3.9 3.7"/>',
  video: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10.2 9.3v5.4l4.8-2.7z" fill="currentColor" stroke="none"/>',
  audio: '<path d="M9 17.5V7.2l9-2.2v10.4"/><circle cx="6.8" cy="17.6" r="2.2"/><circle cx="15.8" cy="15.5" r="2.2"/>',
  pdf: ea + '<rect x="7.5" y="12" width="9" height="5" rx="1" fill="currentColor" fill-opacity="0.14"/>',
  doc: ea + '<path d="M8.5 13h7M8.5 16h7"/>',
  sheet: ea + '<path d="M8 12.5h8M8 15.5h8M8 18h8M12 12.5V18"/>',
  slides: ea + '<rect x="8" y="12.5" width="8" height="5" rx="0.8"/>',
  archive: ea + '<path d="M10 3v1.6M10 6.6v1.6M10 10.2v1.6"/><rect x="8.6" y="14" width="2.8" height="3.4" rx="0.8"/>',
  code: ea + '<path d="M10.4 12.5L8.3 15l2.1 2.5M13.6 12.5l2.1 2.5-2.1 2.5"/>',
  text: ea + '<path d="M8.5 12h7M8.5 15h7M8.5 18h4.5"/>',
  // The two-bay drive the sidebar already draws for the same storages, so a
  // drive is one shape across the panel rather than one per surface.
  storage: '<rect x="3" y="5" width="18" height="6" rx="1.6"/><rect x="3" y="13" width="18" height="6" rx="1.6"/><path d="M6.5 8h.01M6.5 16h.01"/>',
  trash: '<path d="M4 7h16"/><path d="M9.5 7V5.6A1.6 1.6 0 0 1 11.1 4h1.8a1.6 1.6 0 0 1 1.6 1.6V7"/><path d="M6.2 7l.85 11.6A1.6 1.6 0 0 0 8.65 20h6.7a1.6 1.6 0 0 0 1.6-1.4L17.8 7"/><path d="M10.2 10.8v5.6M13.8 10.8v5.6"/>',
  unknown: ea + '<path d="M10.3 13.1a1.8 1.8 0 1 1 2.5 1.9c-.6.3-.8.7-.8 1.4"/><circle cx="12" cy="18.4" r="0.9" fill="currentColor" stroke="none"/>'
}, Gc = /* @__PURE__ */ new Map();
function Xc(e) {
  let t = Gc.get(e);
  return t || (t = `<svg class="fe-ficon fe-ficon--${e}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${jm[e]}</svg>`, Gc.set(e, t)), t;
}
const Jc = /* @__PURE__ */ new Map();
function Li(e) {
  if (e === "folder")
    return `<span class="fe-ftile fe-ftile--folder">${Xc(e)}</span>`;
  let t = Jc.get(e);
  return t || (t = `<span class="fe-ftile fe-ftile--${e}">${Xc(e)}</span>`, Jc.set(e, t)), t;
}
function fn(e) {
  return Li(jn(e));
}
function Ls(e) {
  return e.type === "dir" && e.e2e === !0;
}
const Ym = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5zM9.7 12a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1z"/>';
let Gr = "";
function Ds() {
  return Gr || (Gr = `<span class="fe-ftile fe-ftile--folder fe-ftile--folder-locked"><svg class="fe-ficon fe-ficon--folder" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${Ym}</svg></span>`), Gr;
}
const Wm = {
  // Languages the person reading the column thinks of by name.
  ts: "ftype.typescript",
  tsx: "ftype.typescript",
  mts: "ftype.typescript",
  cts: "ftype.typescript",
  js: "ftype.javascript",
  jsx: "ftype.javascript",
  mjs: "ftype.javascript",
  cjs: "ftype.javascript",
  vue: "ftype.vue",
  py: "ftype.python",
  go: "ftype.go",
  rs: "ftype.rust",
  php: "ftype.php",
  rb: "ftype.ruby",
  java: "ftype.java",
  kt: "ftype.kotlin",
  swift: "ftype.swift",
  c: "ftype.c",
  h: "ftype.c",
  cpp: "ftype.cpp",
  hpp: "ftype.cpp",
  cs: "ftype.csharp",
  // Structured text that is code by family but not a language.
  css: "ftype.stylesheet",
  scss: "ftype.stylesheet",
  less: "ftype.stylesheet",
  html: "ftype.html",
  htm: "ftype.html",
  json: "ftype.json",
  yml: "ftype.yaml",
  yaml: "ftype.yaml",
  xml: "ftype.xml",
  toml: "ftype.toml",
  sql: "ftype.sql",
  sh: "ftype.shell",
  bash: "ftype.shell",
  zsh: "ftype.shell",
  ps1: "ftype.powershell",
  // Plain-text family members that are each their own thing.
  md: "ftype.markdown",
  markdown: "ftype.markdown",
  txt: "ftype.plaintext",
  log: "ftype.log",
  ini: "ftype.config",
  conf: "ftype.config",
  cfg: "ftype.config",
  env: "ftype.config",
  // Tabular: a `.csv` IS a spreadsheet to the person looking at the column,
  // whatever the program that wrote it was.
  csv: "ftype.sheet",
  tsv: "ftype.sheet",
  // Design files. No icon family of their own (they fall to `unknown`, which
  // is a decision for the GLYPH, not for the word) — naming them still beats
  // printing "FIG".
  fig: "ftype.figma",
  sketch: "ftype.design",
  xd: "ftype.design",
  psd: "ftype.design",
  ai: "ftype.design"
}, qm = {
  folder: "node.folder",
  image: "ftype.image",
  video: "ftype.video",
  audio: "ftype.audio",
  pdf: "ftype.pdf",
  doc: "ftype.document",
  sheet: "ftype.sheet",
  slides: "ftype.slides",
  archive: "ftype.archive",
  code: "ftype.code",
  text: "ftype.plaintext"
};
function ad(e) {
  if (e.type === "dir") return "node.folder";
  const t = (e.extension || "").trim().toLowerCase(), n = Wm[t];
  return n || (qm[jn(e)] ?? null);
}
function Os(e, t) {
  const n = ad(e);
  if (n) return t(n);
  const r = (e.extension || "").trim();
  return r ? r.toUpperCase() : "—";
}
const ha = ".filex-e2e.json", Gm = "filexe2e", od = 1, sd = 2, rd = 6e5, id = 6e5, ld = 200 * 1024 * 1024, Xm = 8, _s = 20, cd = "RSA-OAEP-256", Eo = "filex-e2e-verify-v1", ws = new TextEncoder().encode(Gm), Bs = 97, ii = 9, li = 21, Jm = 48, ci = 69, aa = 12, Ga = 32, Zm = "filex-e2e-recovery-v1", Qm = 16;
class xo extends Error {
  constructor(t = "e2e: decrypt failed") {
    super(t), this.name = "E2eDecryptError";
  }
}
function Xa(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t);
}
function On(e) {
  const t = atob(e), n = new Uint8Array(t.length);
  for (let r = 0; r < t.length; r++) n[r] = t.charCodeAt(r);
  return n;
}
function Tt(e) {
  return new Uint8Array(e).buffer;
}
function ey(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e, 0), n.set(t, e.length), Xa(n);
}
async function Is(e, t) {
  const n = crypto.getRandomValues(new Uint8Array(aa)), r = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: Tt(n) }, e, Tt(t))
  );
  return ey(n, r);
}
async function Ka(e, t) {
  let n;
  try {
    n = On(t);
  } catch {
    return null;
  }
  if (n.length <= aa) return null;
  try {
    const r = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: Tt(n.slice(0, aa)) },
      e,
      Tt(n.slice(aa))
    );
    return new Uint8Array(r);
  } catch {
    return null;
  }
}
async function zo(e, t, n) {
  const r = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveKey"]
  );
  return crypto.subtle.deriveKey(
    { name: "PBKDF2", salt: Tt(t), iterations: n, hash: "SHA-256" },
    r,
    { name: "AES-GCM", length: 256 },
    !1,
    // non-extractable
    ["encrypt", "decrypt"]
  );
}
async function ud(e, t, n) {
  const r = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveBits"]
  ), a = await crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: Tt(t), iterations: n, hash: "SHA-256" },
    r,
    Ga * 8
  );
  return new Uint8Array(a);
}
async function Zs(e) {
  return crypto.subtle.importKey("raw", Tt(e), { name: "AES-GCM" }, !1, [
    "encrypt",
    "decrypt"
  ]);
}
const ui = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
function ty(e) {
  let t = 0, n = 0, r = "";
  for (let a = 0; a < e.length; a++)
    for (n = n << 8 | e[a], t += 8; t >= 5; )
      r += ui[n >>> t - 5 & 31], t -= 5;
  return t > 0 && (r += ui[n << 5 - t & 31]), (r.match(/.{1,4}/g) || []).join("-");
}
function dd() {
  return ty(crypto.getRandomValues(new Uint8Array(_s)));
}
function Di(e) {
  const t = (e || "").toUpperCase().replace(/[\s-]/g, "").replace(/O/g, "0").replace(/[IL]/g, "1"), n = Math.ceil(_s * 8 / 5);
  if (t.length !== n) return null;
  const r = new Uint8Array(_s);
  let a = 0, u = 0, v = 0;
  for (const p of t) {
    const h = ui.indexOf(p);
    if (h < 0) return null;
    a = a << 5 | h, u += 5, u >= 8 && (r[v++] = a >>> u - 8 & 255, u -= 8);
  }
  return v === _s ? r : null;
}
async function fd(e, t) {
  const n = await crypto.subtle.importKey("raw", Tt(e), "HKDF", !1, ["deriveKey"]);
  return crypto.subtle.deriveKey(
    {
      name: "HKDF",
      hash: "SHA-256",
      salt: Tt(t),
      info: Tt(new TextEncoder().encode(Zm))
    },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  );
}
async function pd(e, t) {
  const n = Di(t);
  if (!n) throw new Error("e2e: malformed recovery key");
  const r = crypto.getRandomValues(new Uint8Array(Qm)), a = await fd(n, r), u = { salt: Xa(r), blob: await Is(a, e) };
  return n.fill(0), u;
}
async function ny(e) {
  return crypto.subtle.importKey(
    "spki",
    Tt(On(e)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !0,
    ["encrypt"]
  );
}
async function ay(e) {
  const t = (e || "").replace(/-----[A-Z ]+-----/g, "").replace(/\s+/g, "");
  return crypto.subtle.importKey(
    "pkcs8",
    Tt(On(t)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !1,
    ["decrypt"]
  );
}
async function oy(e) {
  const t = new Uint8Array(await crypto.subtle.digest("SHA-256", Tt(On(e))));
  return Array.from(t.slice(0, 8)).map((n) => n.toString(16).padStart(2, "0")).join("");
}
async function Oi(e, t) {
  const n = await ny(t), r = new Uint8Array(await crypto.subtle.encrypt({ name: "RSA-OAEP" }, n, Tt(e)));
  return { kid: await oy(t), alg: cd, blob: Xa(r) };
}
async function HD(e, t = rd) {
  const n = Math.max(id, t), r = crypto.getRandomValues(new Uint8Array(16)), a = await zo(e, r, n), u = await Is(a, new TextEncoder().encode(Eo));
  return { marker: { v: 1, salt: Xa(r), iter: n, verify: u }, kek: a };
}
async function sy(e, t = {}) {
  const n = Math.max(id, t.iterations ?? rd), r = crypto.getRandomValues(new Uint8Array(16)), a = await zo(e, r, n), u = crypto.getRandomValues(new Uint8Array(Ga)), v = dd(), p = {
    v: sd,
    salt: Xa(r),
    iter: n,
    verify: await Is(a, new TextEncoder().encode(Eo)),
    fmk: "wrapped",
    fmk_pw: await Is(a, u),
    rk: await pd(u, v)
  };
  t.escrowPublicKey && (p.esc = await Oi(u, t.escrowPublicKey));
  const h = await Zs(u);
  return u.fill(0), { marker: p, fmk: h, recoveryKey: v };
}
async function ry(e, t, n = {}) {
  if (e.v !== 1) throw new Error("e2e: not a v1 marker");
  const r = On(e.salt), a = await zo(t, r, e.iter), u = await Ka(a, e.verify);
  if (!u || new TextDecoder().decode(u) !== Eo)
    throw new xo("e2e: wrong password");
  const v = await ud(t, r, e.iter), p = dd(), h = {
    v: sd,
    salt: e.salt,
    iter: e.iter,
    verify: e.verify,
    fmk: "kek",
    rk: await pd(v, p)
  };
  return n.escrowPublicKey && (h.esc = await Oi(v, n.escrowPublicKey)), v.fill(0), { marker: h, fmk: a, recoveryKey: p };
}
async function iy(e, t, n) {
  if (e.v !== 2) throw new Error("e2e: not a v2 marker");
  if (e.esc) throw new Error("e2e: this folder already has an escrow slot");
  if (!n) throw new Error("e2e: no escrow public key");
  const r = On(e.salt), a = await zo(t, r, e.iter), u = await Ka(a, e.verify);
  if (!u || new TextDecoder().decode(u) !== Eo)
    throw new xo("e2e: wrong password");
  let v;
  if (e.fmk === "wrapped") {
    const b = e.fmk_pw ? await Ka(a, e.fmk_pw) : null;
    if (!b || b.length !== Ga)
      throw new xo("e2e: could not unwrap the folder master key");
    v = b;
  } else
    v = await ud(t, r, e.iter);
  const p = await Oi(v, n);
  v.fill(0);
  const h = { ...e, esc: p };
  return delete h.esc_declined, h;
}
function ly(e, t) {
  return { ...e, esc_declined: t };
}
function Zc(e, t) {
  return !t || !e || e.v !== 2 || e.esc ? "n/a" : e.esc_declined ? "declined" : "offer";
}
function Qc(e) {
  try {
    const t = JSON.parse(e);
    return !t || t.v !== 1 && t.v !== 2 || typeof t.salt != "string" || typeof t.verify != "string" || typeof t.iter != "number" || t.iter < 1 || t.v === 2 && (t.fmk !== "kek" && t.fmk !== "wrapped" || t.fmk === "wrapped" && typeof t.fmk_pw != "string") ? null : t;
  } catch {
    return null;
  }
}
function cy(e) {
  return !!e && e.v === 2 && !!e.rk;
}
function uy(e) {
  return !!e && e.v === 2 && !!e.esc;
}
function dy(e, t) {
  return t ? uy(e) ? e.esc.kid === t ? "available" : "other-key" : "predates" : "off";
}
async function fy(e, t) {
  const n = await zo(t, On(e.salt), e.iter), r = await Ka(n, e.verify);
  return !r || new TextDecoder().decode(r) !== Eo ? null : n;
}
async function py(e, t) {
  if (e.v === 1 || e.fmk === "kek") return t;
  if (!e.fmk_pw) return null;
  const n = await Ka(t, e.fmk_pw);
  if (!n || n.length !== Ga) return null;
  const r = await Zs(n);
  return n.fill(0), r;
}
async function vy(e, t) {
  const n = await fy(e, t);
  return n ? py(e, n) : null;
}
async function hy(e, t) {
  if (e.v !== 2 || !e.rk) return null;
  const n = Di(t);
  if (!n) return null;
  let r;
  try {
    r = On(e.rk.salt);
  } catch {
    return null;
  }
  const a = await fd(n, r);
  n.fill(0);
  const u = await Ka(a, e.rk.blob);
  if (!u || u.length !== Ga) return null;
  const v = await Zs(u);
  return u.fill(0), v;
}
async function my(e, t) {
  if (e.v !== 2 || !e.esc || e.esc.alg !== cd) return null;
  let n;
  try {
    n = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "RSA-OAEP" },
        t,
        Tt(On(e.esc.blob))
      )
    );
  } catch {
    return null;
  }
  if (n.length !== Ga) return null;
  const r = await Zs(n);
  return n.fill(0), r;
}
function di(e) {
  const t = e instanceof Uint8Array ? e : new Uint8Array(e);
  if (t.length < ws.length) return !1;
  for (let n = 0; n < ws.length; n++)
    if (t[n] !== ws[n]) return !1;
  return !0;
}
async function yy(e, t) {
  if (t.byteLength > ld)
    throw new Error("e2e: file exceeds the 200MB single-shot limit");
  const n = crypto.getRandomValues(new Uint8Array(32)), r = await crypto.subtle.importKey("raw", Tt(n), { name: "AES-GCM" }, !1, [
    "encrypt"
  ]), a = crypto.getRandomValues(new Uint8Array(aa)), u = crypto.getRandomValues(new Uint8Array(aa)), v = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: Tt(a) }, e, Tt(n))
  ), p = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: Tt(u) }, r, t)
  );
  n.fill(0);
  const h = new Uint8Array(Bs + p.length);
  return h.set(ws, 0), h[8] = od, h.set(a, ii), h.set(v, li), h.set(u, ci), h.set(p, Bs), h.buffer;
}
async function eu(e, t) {
  const n = new Uint8Array(t);
  if (!di(n) || n.length < Bs)
    throw new Error("e2e: not an encrypted file");
  if (n[8] !== od)
    throw new Error(`e2e: unsupported version ${n[8]}`);
  const r = n.slice(ii, ii + aa), a = n.slice(li, li + Jm), u = n.slice(ci, ci + aa);
  let v;
  try {
    v = await crypto.subtle.decrypt({ name: "AES-GCM", iv: Tt(r) }, e, Tt(a));
  } catch {
    throw new xo("e2e: DEK unwrap failed (wrong key?)");
  }
  const p = await crypto.subtle.importKey("raw", v, { name: "AES-GCM" }, !1, ["decrypt"]);
  try {
    return await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: Tt(u) },
      p,
      Tt(n.slice(Bs))
    );
  } catch {
    throw new xo("e2e: content decrypt failed");
  }
}
function by() {
  const e = /* @__PURE__ */ new Map();
  return {
    get(t) {
      return e.get(t);
    },
    set(t, n) {
      e.set(t, n);
    },
    /** Drop one folder's key ("Lock"). */
    lock(t) {
      e.delete(t);
    },
    has(t) {
      return e.has(t);
    },
    clear() {
      e.clear();
    }
  };
}
function Bi(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function ya(e) {
  const t = Bi(String(e ?? "")), n = t.lastIndexOf("/");
  return n === -1 ? "" : t.slice(0, n);
}
function gy(e) {
  return (e || []).filter((t) => !(t.path.includes(".thumbs") || t.path.includes(".versions") || t.basename === ".versions" || t.basename === ".trash" || t.basename === ".filex-open" || t.basename === ".keepdir" || t.basename === ha));
}
const vd = "filex.showHidden";
function ky() {
  try {
    return localStorage.getItem(vd) === "1";
  } catch {
    return !1;
  }
}
const Hs = m(ky());
function _y(e) {
  Hs.value = e;
  try {
    localStorage.setItem(vd, e ? "1" : "0");
  } catch {
  }
}
function wy(e, t) {
  return t ? e || [] : (e || []).filter((n) => !(n.basename || "").startsWith("."));
}
function $s(e) {
  return wy(gy(e), Hs.value);
}
function $y(e) {
  const t = Bi(e);
  return t === "fileman" || t === "";
}
function xy(e) {
  return Bi(e).startsWith("fileman/.trash");
}
function Sy(e) {
  return {
    type: "dir",
    path: `${e}://fileman/.trash`,
    basename: ".trash",
    extension: "",
    storage: e,
    visibility: "private",
    size: 0,
    file_size: 0,
    mime_type: "inode/directory",
    extra_metadata: {}
  };
}
function hd(e, t, n, r, a = {}) {
  return !r || a.navOffersTrash || a.isSearchResult || xy(n) || !$y(n) ? !1 : (e.unshift(Sy(t)), !0);
}
async function md(e, t, n) {
  try {
    const { entries: r } = await n.listTrash(t), a = e.find((p) => p.basename === ".trash");
    if (!a) return;
    let u = 0, v = 0;
    for (const p of r) {
      u += p.size || 0;
      const h = Date.parse(p.deleted_at);
      !Number.isNaN(h) && h > v && (v = h);
    }
    a.size = u, v > 0 && (a.last_modified = v);
  } catch {
  }
}
const yd = {
  /* gorunum:v3-shell — Home is a destination like the rest, so it gets a
     sentinel like the rest: a restored tab, a reload and a pasted `#.home`
     all have to reopen the overview instead of asking the backend for a
     folder called `.home` and landing on "not found". */
  ".home": "node.home",
  ".trash": "node.trash",
  ".recent": "node.recent",
  ".starred": "node.starred",
  ".shared": "node.shared"
}, fi = ".tag~";
function Cy(e) {
  return `${fi}${e}`;
}
function Ii(e) {
  return e.startsWith(fi) ? e.slice(fi.length) : "";
}
function Ty(e) {
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return Ii(t.split("/").pop() || t);
}
function Fs(e, t) {
  const n = yd[e];
  if (n) return t(n);
  const r = Ii(e);
  return r ? `#${r}` : "";
}
function bd(e) {
  const t = String(e ?? "").replace(/^\/+|\/+$/g, "");
  return t ? !!yd[t] || !!Ii(t) : !1;
}
function pi(e, t) {
  const n = e.type === "dir" ? 0 : 1, r = t.type === "dir" ? 0 : 1;
  return n - r;
}
const gd = ["name", "type", "modified", "size"], kd = "filex.list-sort", Xr = "name";
function Ns(e) {
  return e === "modified" ? "desc" : "asc";
}
function My(e) {
  return typeof e == "string" && gd.includes(e);
}
function _d() {
  const e = { key: Xr, dir: Ns(Xr) };
  if (typeof localStorage > "u") return e;
  try {
    const t = localStorage.getItem(kd);
    if (!t) return e;
    const n = JSON.parse(t), r = My(n.key) ? n.key : Xr, a = n.dir === "asc" || n.dir === "desc" ? n.dir : Ns(r);
    return { key: r, dir: a };
  } catch {
    return e;
  }
}
const wd = m("en");
function Hi(e) {
  wd.value = e;
}
function tu(e) {
  const t = e.last_modified;
  return t ? t * (t < 1e12 ? 1e3 : 1) : null;
}
function nu(e, t) {
  return (e.basename || "").localeCompare(t.basename || "", void 0, {
    numeric: !0,
    sensitivity: "base"
  });
}
function au(e) {
  const t = ad(e);
  if (t)
    return (Ms[wd.value] ?? Ms.en)[t] ?? t;
  const n = (e.extension || "").trim();
  return n ? n.toUpperCase() : "";
}
function Ey(e, t, n, r) {
  const a = t === "asc" ? 1 : -1;
  switch (e) {
    case "name":
      return a * nu(n, r);
    case "size":
      return a * ((n.size ?? -1) - (r.size ?? -1));
    case "type": {
      const u = au(n).localeCompare(au(r), void 0, { sensitivity: "base" });
      return u !== 0 ? a * u : nu(n, r);
    }
    default: {
      const u = tu(n), v = tu(r);
      return u == null && v == null ? 0 : u == null ? 1 : v == null ? -1 : a * (u - v);
    }
  }
}
function ou(e, t) {
  try {
    localStorage.setItem(kd, JSON.stringify({ key: e, dir: t }));
  } catch {
  }
}
function $d() {
  const e = _d(), t = m(e.key), n = m(e.dir);
  function r(b, y) {
    t.value = b, n.value = y ?? Ns(b), ou(t.value, n.value);
  }
  function a(b, y) {
    t.value = b, n.value = y;
  }
  function u() {
    n.value = n.value === "asc" ? "desc" : "asc", ou(t.value, n.value);
  }
  function v(b) {
    t.value === b ? u() : r(b);
  }
  function p(b, y) {
    return pi(b, y) || Ey(t.value, n.value, b, y);
  }
  function h(b) {
    return b === "relevance" ? pi : p;
  }
  return {
    key: t,
    dir: n,
    setSort: r,
    applySort: a,
    toggleSortDir: u,
    chooseSortKey: v,
    compareNodes: p,
    compareInOrder: h,
    sortListing: (b, y = "sort") => [...b || []].sort(h(y))
  };
}
const Qs = $d(), xd = Symbol("fe-sort-store");
function Ao() {
  return Ws(xd, Qs);
}
function su() {
  return Qs.key.value;
}
function ru() {
  return Qs.dir.value;
}
function iu(e, t) {
  Qs.applySort(e, t);
}
function zy() {
  return _d();
}
let Ra = null;
const Po = m(!1), Lo = m(!1);
function lu() {
  return Po.value;
}
const $n = m(!1);
function Ay() {
  return $n.value;
}
function FD(e) {
  $n.value !== e && ($n.value = e, hn());
}
function Sd() {
  return Math.floor(Date.now() / 1e3);
}
function Py(e) {
  return e === "list" || e === "grid" || e === "gallery";
}
const Vt = m({});
function Ly(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = {};
  for (const [n, r] of Object.entries(e)) {
    if (!r || typeof r != "object") continue;
    const a = r, v = { t: typeof a.t == "number" && Number.isFinite(a.t) ? a.t : 0 };
    Py(a.v) && (v.v = a.v), (a.k === "name" || a.k === "type" || a.k === "modified" || a.k === "size") && (v.k = a.k), (a.d === "asc" || a.d === "desc") && (v.d = a.d), (v.v || v.k) && (t[n] = v);
  }
  return t;
}
const cu = 300;
function Dy() {
  const e = Object.entries(Vt.value);
  if (e.length <= cu) return;
  e.sort((n, r) => r[1].t - n[1].t);
  const t = {};
  for (const [n, r] of e.slice(0, cu)) t[n] = r;
  Vt.value = t;
}
function uu(e, t) {
  const n = String(e ?? "").trim(), r = String(t ?? "").replace(/^[a-z][a-z0-9+.-]*:\/\//i, "").replace(/\/{2,}/g, "/").replace(/^\/+|\/+$/g, "");
  return n ? r ? `${n}/${r}` : n : r;
}
const Oy = {
  ".recent": { k: "modified", d: "desc" }
};
function By(e) {
  if (!e) return null;
  if ($n.value) {
    const t = Vt.value[e];
    if (t) {
      const { t: n, ...r } = t;
      return r;
    }
  }
  return Oy[e] ?? null;
}
function Iy(e) {
  return $n.value && !!e && !!Vt.value[e];
}
function Hy() {
  return $n.value ? Object.keys(Vt.value).length : 0;
}
function Fy(e, t) {
  if (!e || !$n.value) return;
  const n = Vt.value[e];
  Vt.value = {
    ...Vt.value,
    [e]: { ...n ?? {}, ...t, t: Sd() }
  }, Dy(), hn();
}
function Ny(e) {
  if (!e || !$n.value) return;
  const t = Vt.value[e];
  if (!t) return;
  const n = Sd();
  t.t !== n && (Vt.value = { ...Vt.value, [e]: { ...t, t: n } }, hn());
}
function Ky(e) {
  if (!e || !Vt.value[e]) return;
  const t = { ...Vt.value };
  delete t[e], Vt.value = t, hn();
}
function Ry() {
  Vt.value = {}, hn();
}
const ma = [
  /* Name is pinned first and cannot be hidden, but its width is the person's
     like any other (see the note on ColumnId). */
  { id: "name", width: 260, min: 120, max: 900, hideable: !1, resizable: !0 },
  { id: "type", width: 88, min: 64, max: 220, hideable: !0, resizable: !0 },
  { id: "location", width: 160, min: 80, max: 420, hideable: !0, resizable: !0 },
  { id: "owner", width: 104, min: 72, max: 260, hideable: !0, resizable: !0 },
  { id: "modified", width: 160, min: 96, max: 300, hideable: !0, resizable: !0 },
  { id: "size", width: 88, min: 64, max: 200, hideable: !0, resizable: !0 },
  /* The star is a control, not a value: there is nothing to size and hiding it
     is the Starred view's own call (`starEnabled`), not a column preference.
     It is in this list only so one pass owns every optional track and no
     stylesheet has to agree with it about which ones exist. */
  { id: "star", width: 24, min: 24, max: 24, hideable: !1, resizable: !1 }
], du = { check: 28, menu: 28 }, ND = 120, fu = 220;
function pn(e) {
  return ma.find((t) => t.id === e);
}
function xs(e) {
  return typeof e == "string" && ma.some((t) => t.id === e);
}
function Fi(e) {
  const t = { w: {}, hidden: [] };
  if (!e || typeof e != "object" || Array.isArray(e)) return t;
  {
    const n = e, r = {};
    if (n.w && typeof n.w == "object")
      for (const [v, p] of Object.entries(n.w)) {
        if (!xs(v) || typeof p != "number" || !Number.isFinite(p)) continue;
        const h = pn(v);
        h && (r[v] = Math.min(h.max, Math.max(h.min, Math.round(p))));
      }
    const a = Array.isArray(n.hidden) ? n.hidden.filter((v) => {
      var p;
      return xs(v) && ((p = pn(v)) == null ? void 0 : p.hideable);
    }) : [], u = Array.isArray(n.o) ? [...new Set(n.o.filter(xs))] : void 0;
    return { w: r, hidden: [...new Set(a)], o: u };
  }
}
const Mt = m(Fi(null));
function ga() {
  const e = Mt.value.o, t = ma.map((r) => r.id);
  if (!e || e.length === 0) return t;
  const n = e.filter((r) => t.includes(r) && r !== "name");
  n.unshift("name");
  for (const r of t) n.includes(r) || n.push(r);
  return n;
}
function Cd(e, t) {
  const n = pn(e);
  if (!n || !n.hideable) return;
  const r = ga(), a = r.indexOf(e);
  if (a === -1) return;
  const u = [...r];
  u.splice(a, 1), u.splice(Math.max(0, Math.min(u.length, t)), 0, e), u.join() !== r.join() && (Mt.value = { ...Mt.value, o: u }, hn());
}
function Uy(e, t) {
  const n = ga().filter((p) => {
    var h;
    return (h = pn(p)) == null ? void 0 : h.hideable;
  }), r = n.indexOf(e);
  if (r === -1) return;
  const a = r + t;
  if (a < 0 || a >= n.length) return;
  const u = n[a], v = ga();
  Cd(e, v.indexOf(u));
}
function pu(e, t) {
  const n = ga().filter((a) => {
    var u;
    return (u = pn(a)) == null ? void 0 : u.hideable;
  }), r = n.indexOf(e);
  return r === -1 ? !1 : r + t >= 0 && r + t < n.length;
}
function wo(e) {
  const t = pn(e);
  return t ? Mt.value.w[e] ?? t.width : 0;
}
function Jr(e, t) {
  const n = pn(e);
  if (!n || !n.resizable) return;
  const r = Math.min(n.max, Math.max(n.min, Math.round(t)));
  Mt.value.w[e] !== r && (Mt.value = { ...Mt.value, w: { ...Mt.value.w, [e]: r } }, hn());
}
function Td() {
  return Mt.value.w.name === void 0;
}
function Vy(e) {
  const t = { ...Mt.value.w };
  let n = !1;
  for (const [r, a] of Object.entries(e)) {
    if (!xs(r) || typeof a != "number" || !Number.isFinite(a) || t[r] !== void 0) continue;
    const u = pn(r);
    !u || !u.resizable || (t[r] = Math.min(u.max, Math.max(u.min, Math.round(a))), n = !0);
  }
  n && (Mt.value = { ...Mt.value, w: t }, hn());
}
function Ks(e) {
  return Mt.value.hidden.includes(e);
}
function jy(e, t) {
  const n = pn(e);
  if (!n || !n.hideable || Ks(e) === t) return;
  const r = new Set(Mt.value.hidden);
  t ? r.add(e) : r.delete(e), Mt.value = { ...Mt.value, hidden: [...r] }, hn();
}
function Yy() {
  Mt.value = { w: {}, hidden: [] }, hn();
}
function Wy() {
  var e;
  return Object.keys(Mt.value.w).length > 0 || Mt.value.hidden.length > 0 || (((e = Mt.value.o) == null ? void 0 : e.length) ?? 0) > 0;
}
const Md = ["on", "f", "c"], Kn = m({});
function qy(e) {
  const t = {};
  for (const [n, r] of Object.entries(e))
    Md.includes(n) || (t[n] = r);
  return t;
}
function Gy() {
  return { ...Kn.value, on: $n.value, f: Vt.value, c: Mt.value };
}
function KD(e) {
  if (!e || Md.includes(e))
    throw new Error(`viewPrefsSlot: "${e}" is reserved by lib/viewPrefs`);
  return {
    get: () => Kn.value[e],
    set(t) {
      Kn.value = { ...Kn.value, [e]: t }, hn();
    },
    clear() {
      if (!(e in Kn.value)) return;
      const t = { ...Kn.value };
      delete t[e], Kn.value = t, hn();
    },
    ready: () => Po.value,
    persistable: () => Lo.value
  };
}
const Xy = 800;
let Un, Rs = !1;
function hn() {
  !Po.value || !Lo.value || !Ra || (Rs = !0, Un && clearTimeout(Un), Un = setTimeout(Us, Xy));
}
function Us() {
  Un && clearTimeout(Un), Un = void 0, !(!Rs || !Ra || !Lo.value) && (Rs = !1, Ra.save(Gy()));
}
typeof window < "u" && (window.addEventListener("pagehide", Us), window.addEventListener("visibilitychange", () => {
  typeof document < "u" && document.visibilityState === "hidden" && Us();
}));
function Jy(e) {
  Ra || (Ra = e, (async () => {
    let t = null;
    try {
      t = await e.load();
    } catch {
      t = null;
    }
    if (t && typeof t == "object" && !Array.isArray(t)) {
      const n = t;
      $n.value = n.on === !0, Vt.value = Ly(n.f), Mt.value = Fi(n.c), Kn.value = qy(n), Lo.value = !0;
    }
    Po.value = !0;
  })());
}
function RD() {
  Ra = null, Po.value = !1, Lo.value = !1, $n.value = !1, Vt.value = {}, Mt.value = Fi(null), Kn.value = {}, Rs = !1, Un && clearTimeout(Un), Un = void 0;
}
function UD() {
  Us();
}
function Zy(e, t, n = {}) {
  const r = n.gap ?? 8, a = n.padding ?? 24, u = ga().filter(
    (A) => A !== "name" && t.includes(A) && !Ks(A)
  ), v = {};
  for (const A of u) v[A] = wo(A);
  v.name = wo("name");
  const p = du.check + du.menu + a + r * (u.length + 2), h = Td(), b = pn("name");
  if (h && e > 0) {
    const A = e - p;
    let D = u.reduce((B, I) => B + v[I], 0);
    const C = A - fu;
    if (D > C) {
      const B = u.reduce((I, U) => I + (v[U] - pn(U).min), 0);
      if (B > 0) {
        const I = Math.min(1, (D - C) / B);
        for (const U of u) {
          const x = pn(U);
          v[U] = Math.max(x.min, v[U] - Math.ceil((v[U] - x.min) * I));
        }
        D = u.reduce((U, x) => U + v[x], 0);
      }
    }
    v.name = Math.round(
      Math.max(fu, Math.min(b.max, A - D))
    );
  }
  const y = p + v.name + u.reduce((A, D) => A + v[D], 0);
  return { visible: u, widths: v, total: y, auto: h };
}
const Qy = ["standard", "simple"], Zr = "standard", vi = /* @__PURE__ */ new Set();
function eb(e) {
  if (e === "simple") return "simple";
  if (e === "standard" || e === void 0 || e === null || e === "")
    return Zr;
  const t = typeof e == "string" ? e : String(e);
  return !vi.has(t) && typeof console < "u" && (vi.add(t), console.warn(
    `[filex] unknown uiProfile ${JSON.stringify(t)} — using "${Zr}". Valid values: ${Qy.map((n) => `"${n}"`).join(", ")}. (The former "drive" profile was removed; pass "simple" for the reduced explorer.)`
  )), Zr;
}
function VD() {
  vi.clear();
}
const tb = { class: "filex-recent" }, nb = ["disabled"], ab = ["innerHTML"], ob = { key: 0 }, sb = ["data-fe-path"], rb = ["onClick", "onContextmenu"], ib = { class: "filex-recent-name" }, lb = { class: "filex-recent-meta" }, cb = {
  key: 1,
  class: "filex-recent-empty"
}, ub = {
  key: 2,
  class: "filex-recent-empty"
}, db = /* @__PURE__ */ qe({
  __name: "RecentlyOpened",
  props: {
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    limit: {},
    refreshKey: {}
  },
  emits: ["open", "context", "error"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = m([]), u = m(!1);
    async function v() {
      u.value = !0;
      try {
        const h = await (n.authHeaders ?? (() => ({})))(), b = n.apiBase ?? "", y = n.limit ?? 20, A = await fetch(`${b}/api/files/manager/recent?limit=${y}`, {
          headers: h,
          credentials: n.authCredentials ?? "same-origin"
        });
        if (A.ok) {
          const D = await A.json();
          a.value = Array.isArray(D.nodes) ? D.nodes : Array.isArray(D.entries) ? D.entries : Array.isArray(D) ? D : [];
        }
      } catch (h) {
        r("error", h instanceof Error ? h.message : String(h));
      } finally {
        u.value = !1;
      }
    }
    function p(h) {
      if (!h) return "";
      const b = new Date(h).getTime();
      if (Number.isNaN(b)) return "";
      const y = Date.now() - b;
      return y < 6e4 ? "just now" : y < 36e5 ? `${Math.floor(y / 6e4)}m ago` : y < 864e5 ? `${Math.floor(y / 36e5)}h ago` : `${Math.floor(y / 864e5)}d ago`;
    }
    return dt(v), He(() => n.refreshKey, v), (h, b) => (c(), d("div", tb, [
      o("header", null, [
        b[0] || (b[0] = o("h3", null, "Recently opened", -1)),
        o("button", {
          class: "filex-recent-refresh",
          type: "button",
          title: "Refresh",
          "aria-label": "Refresh",
          onClick: v,
          disabled: u.value
        }, [
          o("span", {
            "aria-hidden": "true",
            innerHTML: s(Ue)("refresh")
          }, null, 8, ab)
        ], 8, nb)
      ]),
      a.value.length ? (c(), d("ul", ob, [
        (c(!0), d(ae, null, Te(a.value, (y) => (c(), d("li", {
          key: y.id,
          "data-testid": "recent-tray-item",
          "data-fe-path": y.path
        }, [
          o("button", {
            type: "button",
            class: "filex-recent-item",
            onClick: (A) => r("open", y),
            onContextmenu: Re((A) => r("context", y, A), ["prevent"])
          }, [
            o("span", ib, f(y.name), 1),
            o("span", lb, f(p(y.last_opened)), 1)
          ], 40, rb)
        ], 8, sb))), 128))
      ])) : u.value ? (c(), d("p", ub, "Loading…")) : (c(), d("p", cb, "Nothing here yet."))
    ]));
  }
}), na = {
  type: "any",
  modified: "any",
  size: "any",
  name: "",
  aroundDate: "",
  aroundSpan: "d1",
  sizeMin: null,
  sizeMax: null,
  pathMode: "any",
  pathBase: "",
  people: "any"
};
function vu(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{M}+", "gu"), "").toLowerCase();
}
function Ni(e) {
  return (e.name ?? "").trim();
}
function Ed(e) {
  return (e.pathMode ?? "any") !== "any" && !!(e.pathBase ?? "");
}
function Ki(e) {
  return e.people ?? "any";
}
function $o(e) {
  return e.type !== "any" || e.modified !== "any" || e.size !== "any" || Ni(e) !== "" || Ed(e) || Ki(e) !== "any";
}
function fb(e) {
  return (e.type !== "any" ? 1 : 0) + (e.modified !== "any" ? 1 : 0) + (e.size !== "any" ? 1 : 0) + (Ni(e) !== "" ? 1 : 0) + (Ed(e) ? 1 : 0) + (Ki(e) !== "any" ? 1 : 0);
}
const pb = {
  folder: ["folder"],
  document: ["doc", "text"],
  spreadsheet: ["sheet"],
  presentation: ["slides"],
  pdf: ["pdf"],
  image: ["image"],
  video: ["video"],
  audio: ["audio"],
  archive: ["archive"],
  code: ["code"]
}, vb = {
  image: ["image/"],
  video: ["video/"],
  audio: ["audio/"],
  pdf: ["application/pdf"],
  document: ["text/plain", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessing"],
  spreadsheet: ["text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheet"],
  presentation: ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentation"],
  archive: ["application/zip", "application/x-tar", "application/gzip", "application/x-7z"]
};
function hb(e, t) {
  if (t === "any") return !0;
  if (t === "folder") return e.type === "dir";
  if (e.type === "dir") return !1;
  if (pb[t].includes(jn(e))) return !0;
  const n = (e.mime_type || "").toLowerCase();
  return !!n && (vb[t] ?? []).some((r) => n.startsWith(r));
}
const mb = {
  h1: 36e5,
  d1: 864e5,
  w1: 7 * 864e5
};
function yb(e) {
  const t = (e ?? "").trim();
  if (!t) return null;
  const n = Date.parse(t.includes("T") ? t : `${t}T00:00`);
  return Number.isNaN(n) ? null : n;
}
function bb(e, t, n) {
  const r = t.modified;
  if (r === "any") return !0;
  const a = typeof e.last_modified == "number" ? e.last_modified : 0;
  if (!a) return !1;
  if (r === "around") {
    const v = yb(t.aroundDate);
    return v === null ? !0 : Math.abs(a - v) <= mb[t.aroundSpan ?? "d1"];
  }
  if (r === "year")
    return new Date(a).getFullYear() === new Date(n).getFullYear();
  if (r === "today") {
    const v = new Date(n);
    return v.setHours(0, 0, 0, 0), a >= v.getTime();
  }
  return a >= n - (r === "7d" ? 7 : 30) * 864e5;
}
const Oa = 1024 * 1024;
function gb(e, t) {
  const n = t.size;
  if (n === "any") return !0;
  if (e.type === "dir") return !1;
  const r = typeof e.size == "number" ? e.size : 0;
  if (n === "range") {
    const a = typeof t.sizeMin == "number" ? t.sizeMin : null, u = typeof t.sizeMax == "number" ? t.sizeMax : null;
    return !(a !== null && r < a || u !== null && r > u);
  }
  return n === "lt1" ? r < Oa : n === "1to10" ? r >= Oa && r < 10 * Oa : n === "10to100" ? r >= 10 * Oa && r < 100 * Oa : r >= 100 * Oa;
}
function Ss(e, t) {
  return t ? vu(e || "").includes(vu(t)) : !0;
}
function kb(e, t) {
  return Ss(e.basename || "", t);
}
function _b(e, t) {
  const n = t.pathMode ?? "any", r = (t.pathBase ?? "").replace(/\/+$/, "");
  if (n === "any" || !r) return !0;
  const a = e.path || "", u = a === r || a.startsWith(`${r}/`);
  return n === "here" ? u : !u;
}
function So(e) {
  const t = e.owner_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function Ri(e) {
  return e.owner_self === !0;
}
function zd(e) {
  const t = e.owner_name;
  return typeof t == "string" ? t : "";
}
function wb(e) {
  return e.external_upload === !0;
}
function $b(e) {
  const t = [{ value: "any" }, { value: "me" }, { value: "system" }], n = /* @__PURE__ */ new Set();
  for (const u of e) {
    const v = So(u);
    v === null || Ri(u) || n.has(v) || (n.add(v), t.push({ value: `u:${v}`, name: zd(u) }));
  }
  const r = t.slice(0, 3), a = t.slice(3).sort((u, v) => (u.name ?? "").localeCompare(v.name ?? "", void 0, { sensitivity: "base" }));
  return [...r, ...a];
}
function xb(e, t) {
  const n = Ki(t);
  if (n === "any") return !0;
  if (n === "me") return Ri(e);
  if (n === "system") return So(e) === null;
  const r = Number(n.slice(2));
  return Number.isFinite(r) && So(e) === r;
}
function hi(e, t, n = Date.now()) {
  if (!$o(t)) return e;
  const r = Ni(t);
  return e.filter(
    (a) => hb(a, t.type) && bb(a, t, n) && gb(a, t) && kb(a, r) && _b(a, t) && xb(a, t)
  );
}
const Sb = /* @__PURE__ */ qe({
  __name: "UploadProgress",
  props: {
    jobs: {},
    locale: {},
    center: {}
  },
  emits: ["cancel", "dismiss", "retry"],
  setup(e, { emit: t }) {
    const n = e, r = t;
    function a(u) {
      return u === "done" ? "done" : u === "error" ? "error" : u === "aborted" ? "aborted" : "running";
    }
    return He(
      () => n.jobs,
      (u) => {
        n.center.sync(
          "upload",
          u.map((v) => ({
            input: {
              id: v.id,
              kind: "upload",
              name: v.file.name,
              percent: v.totalBytes > 0 || v.status === "done" ? v.percent : null,
              status: a(v.status),
              error: v.error ?? null,
              uploadedBytes: v.uploadedBytes,
              totalBytes: v.totalBytes,
              // Cancellable only while chunks are still moving: once the commit is
              // accepted the bytes are filex's and the ops worker owns the rest.
              cancellable: v.status === "uploading" || v.status === "initializing",
              retryable: v.status === "error"
            },
            actions: {
              cancel: () => r("cancel", v),
              dismiss: () => r("dismiss", v),
              retry: () => r("retry", v)
            }
          }))
        );
      },
      { immediate: !0 }
    ), (u, v) => g("", !0);
  }
});
function hu(e) {
  return Math.max(0, Math.min(100, Math.round(e)));
}
function Cb(e) {
  if (e.status === "done") return 100;
  const t = e.bytes_total ?? 0, n = e.bytes_done ?? 0;
  return t > 0 ? hu(n / t * 100) : n > 0 || e.progress_total <= 1 ? null : hu(e.progress_done / e.progress_total * 100);
}
const Tb = /* @__PURE__ */ qe({
  __name: "PendingOpsTray",
  props: {
    ops: {},
    locale: {},
    center: {}
  },
  emits: ["dismiss"],
  setup(e, { emit: t }) {
    const n = e, r = t;
    function a(v) {
      return v.status === "done" ? "done" : v.status === "error" ? "error" : "running";
    }
    const u = (v) => Cb(v);
    return He(
      () => n.ops,
      (v) => {
        n.center.sync(
          "ops",
          v.map((p) => ({
            input: {
              id: p.id,
              kind: p.op_type,
              name: p.target_path || p.source_dir || "",
              percent: u(p),
              status: a(p),
              error: p.error_message,
              queued: p.status === "pending",
              doneCount: p.progress_done,
              totalCount: p.progress_total,
              cancellable: !1,
              retryable: !1
            },
            actions: {
              dismiss: () => r("dismiss", p.id)
            }
          }))
        );
      },
      { immediate: !0 }
    ), (v, p) => g("", !0);
  }
}), Mb = ["aria-label"], Eb = { class: "fe-inspector__head" }, zb = ["innerHTML"], Ab = { class: "fe-inspector__head-text" }, Pb = ["title"], Lb = { class: "fe-inspector__caption" }, Db = {
  key: 0,
  class: "fe-inspector__held",
  role: "note",
  "data-testid": "inspector-held"
}, Ob = ["title", "aria-label"], Bb = ["innerHTML"], Ib = ["title", "aria-label"], Hb = ["innerHTML"], Fb = ["aria-label"], Nb = ["aria-selected"], Kb = ["aria-selected"], Rb = { class: "fe-inspector__scroll" }, Ub = {
  key: 0,
  class: "fe-inspector__section"
}, Vb = { class: "fe-inspector__heading" }, jb = {
  key: 0,
  class: "fe-inspector__meta"
}, Yb = { class: "fe-inspector__row" }, Wb = ["src"], qb = { class: "fe-inspector__meta" }, Gb = { class: "fe-inspector__row" }, Xb = { class: "fe-inspector__row" }, Jb = { class: "fe-inspector__pathcell" }, Zb = ["title"], Qb = ["title", "aria-label"], eg = ["innerHTML"], tg = {
  key: 0,
  class: "fe-inspector__row"
}, ng = { class: "fe-inspector__row" }, ag = {
  key: 1,
  class: "fe-inspector__row"
}, og = { class: "fe-inspector__mime" }, sg = {
  key: 2,
  class: "fe-inspector__row"
}, rg = { class: "fe-inspector__pathcell" }, ig = { class: "fe-inspector__path" }, lg = ["title", "aria-label"], cg = ["innerHTML"], ug = {
  key: 3,
  class: "fe-inspector__row"
}, dg = { class: "fe-inspector__pathcell" }, fg = ["title"], pg = ["title", "aria-label"], vg = ["innerHTML"], hg = {
  key: 2,
  class: "fe-inspector__empty"
}, mg = {
  key: 1,
  class: "fe-inspector__section",
  "data-testid": "inspector-tags"
}, yg = { class: "fe-inspector__heading" }, bg = {
  key: 2,
  class: "fe-inspector__section"
}, gg = { class: "fe-inspector__heading" }, kg = {
  key: 0,
  class: "fe-inspector__empty"
}, _g = {
  key: 0,
  class: "fe-inspector__empty"
}, wg = {
  key: 1,
  class: "fe-inspector__versions"
}, $g = { class: "fe-inspector__version-main" }, xg = { class: "fe-inspector__version-n" }, Sg = { class: "fe-inspector__version-meta" }, Cg = {
  key: 0,
  class: "fe-inspector__confirm"
}, Tg = { class: "fe-inspector__confirm-q" }, Mg = { class: "fe-inspector__check" }, Eg = { class: "fe-inspector__confirm-actions" }, zg = ["disabled", "onClick"], Ag = ["disabled"], Pg = ["disabled", "onClick"], Lg = ["disabled"], Dg = {
  key: 3,
  class: "fe-inspector__section"
}, Og = { class: "fe-inspector__heading" }, Bg = { class: "fe-inspector__permrow" }, Ig = {
  key: 4,
  class: "fe-inspector__section",
  "data-testid": "inspector-people"
}, Hg = { class: "fe-inspector__heading" }, Fg = {
  key: 0,
  class: "fe-inspector__empty"
}, Ng = {
  key: 1,
  class: "fe-inspector__people"
}, Kg = {
  class: "fe-inspector__avatar",
  "aria-hidden": "true"
}, Rg = { class: "fe-inspector__person-main" }, Ug = ["title"], Vg = { class: "fe-inspector__person-sub" }, jg = {
  key: 5,
  class: "fe-inspector__section",
  "data-testid": "inspector-shares"
}, Yg = { class: "fe-inspector__heading" }, Wg = {
  key: 0,
  class: "fe-inspector__linkrow"
}, qg = ["innerHTML"], Gg = { class: "fe-inspector__linknone" }, Xg = ["disabled"], Jg = {
  key: 1,
  class: "fe-inspector__empty"
}, Zg = {
  key: 2,
  class: "fe-inspector__shares"
}, Qg = ["title"], ek = {
  key: 0,
  class: "fe-inspector__badge fe-inspector__badge--pin"
}, tk = {
  key: 1,
  class: "fe-inspector__share-exp"
}, nk = ["title", "aria-label", "onClick"], ak = ["innerHTML"], ok = {
  key: 6,
  class: "fe-inspector__section"
}, sk = { class: "fe-inspector__heading" }, rk = {
  key: 0,
  class: "fe-inspector__countbadge"
}, ik = {
  key: 0,
  class: "fe-inspector__empty"
}, lk = {
  key: 0,
  class: "fe-inspector__empty"
}, ck = {
  key: 1,
  class: "fe-inspector__comments"
}, uk = { class: "fe-inspector__comment-top" }, dk = ["title"], fk = ["title"], pk = ["disabled", "title", "aria-label", "onClick"], vk = { class: "fe-inspector__comment-body" }, hk = ["placeholder", "aria-label", "disabled"], mk = ["disabled"], yk = {
  key: 7,
  class: "fe-inspector__section",
  "data-testid": "inspector-activity-empty"
}, bk = { class: "fe-inspector__empty" }, gk = {
  key: 0,
  class: "fe-inspector__hint"
}, kk = /* @__PURE__ */ qe({
  __name: "InspectorPanel",
  props: {
    api: {},
    nodes: {},
    dirLabel: {},
    dirCount: {},
    dirPerm: { default: "" },
    heldIn: {},
    locale: {},
    narrow: { type: Boolean, default: !1 },
    thumbSrc: { type: Function, default: void 0 },
    tabs: { type: Boolean, default: !0 },
    apiBase: {},
    authHeaders: {},
    authCredentials: {}
  },
  emits: ["close", "share-created", "manage-permissions", "toast", "changed", "tags-changed", "open-tag"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a, formatSize: u, formatDate: v, nodeDisplayName: p } = tt(
      () => n.locale
    ), h = k(
      () => n.nodes.length === 1 ? n.nodes[0] : null
    ), b = k(() => n.nodes.length > 1), y = k(() => {
      var V;
      return ((V = h.value) == null ? void 0 : V.type) === "file";
    }), A = k(
      () => {
        var V;
        return typeof ((V = h.value) == null ? void 0 : V.id) == "number" ? h.value.id : null;
      }
    ), D = k(
      () => n.nodes.reduce((V, R) => V + (typeof R.size == "number" ? R.size : 0), 0)
    ), C = k(() => {
      var R;
      const V = (R = h.value) == null ? void 0 : R.etag;
      return typeof V == "string" && V !== "" ? V : null;
    }), B = k(
      () => h.value && y.value && n.thumbSrc ? n.thumbSrc(h.value) : null
    ), I = k(() => b.value ? a("inspector.items", { n: n.nodes.length }) : h.value ? p(h.value) : n.dirLabel), U = k(() => {
      if (b.value) return u(D.value);
      const V = h.value;
      if (V) {
        const R = Os(V, a);
        if (V.type === "dir") return R;
        const X = typeof V.size == "number" ? u(V.size) : "";
        return X ? `${R} · ${X}` : R;
      }
      return a("inspector.folder_items", { n: n.dirCount });
    }), x = k(
      () => {
        var V;
        return B.value && /^(image|video)[/]/.test(String(((V = h.value) == null ? void 0 : V.mime_type) ?? "")) ? B.value : null;
      }
    ), E = k(
      () => fn(h.value && !b.value ? h.value : { type: "dir" })
    ), $ = k(
      () => A.value != null && n.apiBase !== void 0 && !b.value
    );
    function M(V) {
      return V.length > 12 ? `${V.slice(0, 12)}…` : V;
    }
    function z(V) {
      return v(V, { time: !0 }) || "—";
    }
    function T(V) {
      if (!V) return "—";
      const R = Date.parse(V);
      return Number.isNaN(R) ? V : z(R);
    }
    async function Y(V) {
      try {
        await navigator.clipboard.writeText(V), r("toast", a("inspector.copied"));
      } catch {
        r("toast", V);
      }
    }
    const O = k(() => {
      if (!h.value) return "";
      const V = h.value.perm;
      return typeof V == "string" && V !== "" ? V : n.dirPerm || "";
    }), J = k(
      () => O.value === "editor" || O.value === "owner"
    );
    function G(V) {
      return a(`inspector.perm.${V}`) === `inspector.perm.${V}` ? V : a(`inspector.perm.${V}`);
    }
    const N = m("idle"), P = m([]), le = m(null), ve = m(!0), he = m(!1), oe = m("idle"), ue = m([]);
    let Q = 0;
    async function pe() {
      const V = ++Q;
      if (le.value = null, P.value = [], ue.value = [], h.value && y.value && A.value != null ? (N.value = "loading", re(V)) : N.value = "hidden", h.value) {
        oe.value = "loading";
        const R = h.value.path;
        try {
          const { shares: X } = await n.api.listShares(R);
          if (V !== Q) return;
          ue.value = Array.isArray(X) ? X : [], oe.value = "ok";
        } catch {
          if (V !== Q) return;
          oe.value = "hidden";
        }
      } else
        oe.value = "hidden";
    }
    async function re(V) {
      const R = A.value;
      if (R != null)
        try {
          const X = await n.api.listVersions(R);
          if (V !== Q) return;
          P.value = X, N.value = "ok";
        } catch (X) {
          if (V !== Q) return;
          const ye = X.status;
          ye === 401 || ye === 403 || ye === 404 ? N.value = "hidden" : N.value = "error";
        }
    }
    function S(V) {
      le.value = V.id, ve.value = !0;
    }
    async function w(V) {
      const R = A.value;
      if (!(R == null || he.value)) {
        he.value = !0;
        try {
          await n.api.restoreVersion(R, V.id, ve.value), r("toast", a("inspector.versions.restored")), le.value = null, r("changed"), await re(++Q);
        } catch (X) {
          r("toast", X.message);
        } finally {
          he.value = !1;
        }
      }
    }
    async function j() {
      const V = A.value;
      if (!(V == null || he.value)) {
        he.value = !0;
        try {
          await n.api.snapshotVersion(V), r("toast", a("inspector.versions.snapshotted")), await re(++Q);
        } catch (R) {
          const X = R.status;
          X === 404 || X === 405 || X === 501 ? r("toast", a("inspector.versions.unsupported")) : r("toast", R.message);
        } finally {
          he.value = !1;
        }
      }
    }
    const K = m("details"), Z = m("hidden"), W = m([]);
    let $e = 0;
    async function Se() {
      const V = ++$e, R = h.value;
      if (!n.tabs || !R) {
        Z.value = "hidden", W.value = [];
        return;
      }
      Z.value = "loading";
      try {
        const X = await n.api.listPermissions(R.path);
        if (V !== $e) return;
        if (!X.storage_rbac) {
          Z.value = "hidden", W.value = [];
          return;
        }
        W.value = [...X.direct ?? [], ...X.inherited ?? []], Z.value = "ok";
      } catch {
        if (V !== $e) return;
        W.value = [], Z.value = "hidden";
      }
    }
    function ze(V) {
      return V.user_display_name || V.user_email || `#${V.user_id}`;
    }
    function Ne(V) {
      const R = ze(V).trim();
      return R ? R[0].toUpperCase() : "?";
    }
    k(() => ue.value.length ? ue.value[0] : null);
    const be = m(!1);
    async function De() {
      var R;
      const V = h.value;
      if (!(!V || be.value)) {
        be.value = !0;
        try {
          const ye = ((R = (await n.api.createShare({ path: V.path })).share) == null ? void 0 : R.url) ?? "", { shares: je } = await n.api.listShares(V.path);
          ue.value = Array.isArray(je) ? je : [], oe.value = "ok", ye && (r("share-created", { path: V.path, url: ye }), await Y(ye));
        } catch (X) {
          r("toast", X.message);
        } finally {
          be.value = !1;
        }
      }
    }
    He(
      () => [n.nodes.map((V) => V.path).join("|"), n.tabs],
      () => void Se(),
      { immediate: !0 }
    );
    const ie = k(
      () => N.value !== "hidden" || ce.value !== "hidden"
    );
    He(
      () => n.nodes.map((V) => V.path).join("\0"),
      () => void pe(),
      { immediate: !0 }
    );
    const ce = m("hidden"), L = m([]), se = m(""), Ce = m(!1), We = k(
      () => {
        var V;
        return typeof ((V = h.value) == null ? void 0 : V.id) == "number" ? h.value.id : null;
      }
    );
    let Ie = 0;
    async function Ze() {
      const V = ++Ie, R = We.value;
      if (R == null) {
        ce.value = "hidden", L.value = [];
        return;
      }
      ce.value = L.value.length > 0 ? "ok" : "loading";
      try {
        const X = await n.api.listComments(R);
        if (V !== Ie) return;
        L.value = X, ce.value = "ok";
      } catch (X) {
        if (V !== Ie) return;
        L.value = [];
        const ye = X.status;
        ce.value = ye === 401 || ye === 403 || ye === 404 ? "hidden" : "error";
      }
    }
    async function vt() {
      const V = We.value, R = se.value.trim();
      if (!(V == null || R === "" || Ce.value)) {
        Ce.value = !0;
        try {
          await n.api.addComment(V, R), se.value = "", await Ze();
        } catch (X) {
          r("toast", X.message);
        } finally {
          Ce.value = !1;
        }
      }
    }
    async function Xe(V) {
      if (!Ce.value) {
        Ce.value = !0;
        try {
          await n.api.deleteComment(V.id), await Ze();
        } catch (R) {
          r("toast", R.message);
        } finally {
          Ce.value = !1;
        }
      }
    }
    function Ae(V) {
      const R = Date.parse(V);
      if (Number.isNaN(R)) return V;
      const X = Math.round((R - Date.now()) / 1e3), ye = Math.abs(X), je = [
        ["year", 31536e3],
        ["month", 2592e3],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60]
      ];
      try {
        const Qe = new Intl.RelativeTimeFormat(
          n.locale === "en" ? "en" : "tr",
          { numeric: "auto" }
        );
        for (const [at, Ye] of je)
          if (ye >= Ye) return Qe.format(Math.trunc(X / Ye), at);
        return Qe.format(X, "second");
      } catch {
        return T(V);
      }
    }
    return He(
      () => We.value,
      () => {
        L.value = [], se.value = "", Ze();
      },
      { immediate: !0 }
    ), (V, R) => (c(), d("aside", {
      class: we(["fe-inspector", { "fe-inspector--overlay": e.narrow }]),
      role: "complementary",
      "aria-label": s(a)("inspector.title")
    }, [
      o("header", Eb, [
        o("span", {
          class: "fe-inspector__head-icon",
          "aria-hidden": "true",
          innerHTML: E.value
        }, null, 8, zb),
        o("div", Ab, [
          o("h2", {
            class: "fe-inspector__title",
            title: I.value
          }, f(I.value), 9, Pb),
          o("p", Lb, f(U.value), 1),
          e.heldIn ? (c(), d("p", Db, f(s(a)("inspector.held", { where: e.heldIn })), 1)) : g("", !0)
        ]),
        h.value ? (c(), d("button", {
          key: 0,
          type: "button",
          class: "fe-inspector__iconbtn",
          title: s(a)("inspector.copy_name"),
          "aria-label": s(a)("inspector.copy_name"),
          "data-testid": "inspector-copy-name",
          onClick: R[0] || (R[0] = (X) => Y(I.value))
        }, [
          o("span", {
            "aria-hidden": "true",
            innerHTML: s(Ue)("copy")
          }, null, 8, Bb)
        ], 8, Ob)) : g("", !0),
        o("button", {
          type: "button",
          class: "fe-inspector__iconbtn fe-inspector__close",
          title: s(a)("inspector.close"),
          "aria-label": s(a)("inspector.close"),
          onClick: R[1] || (R[1] = (X) => r("close"))
        }, [
          o("span", {
            "aria-hidden": "true",
            innerHTML: s(Ue)("close")
          }, null, 8, Hb)
        ], 8, Ib)
      ]),
      e.tabs ? (c(), d("div", {
        key: 0,
        class: "fe-inspector__tabs",
        role: "tablist",
        "aria-label": s(a)("inspector.title")
      }, [
        o("button", {
          type: "button",
          class: we(["fe-inspector__tab", { "is-active": K.value === "details" }]),
          role: "tab",
          "aria-selected": K.value === "details",
          "data-testid": "inspector-tab-details",
          onClick: R[2] || (R[2] = (X) => K.value = "details")
        }, f(s(a)("inspector.tab.details")), 11, Nb),
        o("button", {
          type: "button",
          class: we(["fe-inspector__tab", { "is-active": K.value === "activity" }]),
          role: "tab",
          "aria-selected": K.value === "activity",
          "data-testid": "inspector-tab-activity",
          onClick: R[3] || (R[3] = (X) => K.value = "activity")
        }, f(s(a)("inspector.tab.activity")), 11, Kb)
      ], 8, Fb)) : g("", !0),
      o("div", Rb, [
        !e.tabs || K.value === "details" ? (c(), d("section", Ub, [
          o("h3", Vb, f(s(a)("inspector.section.general")), 1),
          b.value ? (c(), d("dl", jb, [
            o("div", Yb, [
              o("dt", null, f(s(a)("inspector.size")), 1),
              o("dd", null, f(s(u)(D.value)), 1)
            ])
          ])) : h.value ? (c(), d(ae, { key: 1 }, [
            x.value ? (c(), d("img", {
              key: 0,
              class: "fe-inspector__preview",
              src: x.value,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, Wb)) : g("", !0),
            o("dl", qb, [
              o("div", Gb, [
                o("dt", null, f(s(a)("inspector.type")), 1),
                o("dd", null, f(s(Os)(h.value, s(a))), 1)
              ]),
              o("div", Xb, [
                o("dt", null, f(s(a)("inspector.path")), 1),
                o("dd", Jb, [
                  o("span", {
                    class: "fe-inspector__path",
                    title: h.value.path
                  }, f(h.value.path), 9, Zb),
                  o("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: s(a)("inspector.copy"),
                    "aria-label": s(a)("inspector.copy"),
                    onClick: R[4] || (R[4] = (X) => Y(h.value.path))
                  }, [
                    o("span", {
                      "aria-hidden": "true",
                      innerHTML: s(Ue)("copy")
                    }, null, 8, eg)
                  ], 8, Qb)
                ])
              ]),
              y.value ? (c(), d("div", tg, [
                o("dt", null, f(s(a)("inspector.size")), 1),
                o("dd", null, f(s(u)(typeof h.value.size == "number" ? h.value.size : null)), 1)
              ])) : g("", !0),
              o("div", ng, [
                o("dt", null, f(s(a)("inspector.modified")), 1),
                o("dd", null, f(z(h.value.last_modified)), 1)
              ]),
              y.value && h.value.mime_type ? (c(), d("div", ag, [
                o("dt", null, f(s(a)("inspector.mime")), 1),
                o("dd", og, f(h.value.mime_type), 1)
              ])) : g("", !0),
              typeof h.value.id == "number" ? (c(), d("div", sg, [
                o("dt", null, f(s(a)("inspector.nodeId")), 1),
                o("dd", rg, [
                  o("span", ig, f(h.value.id), 1),
                  o("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: s(a)("inspector.copy"),
                    "aria-label": s(a)("inspector.copy"),
                    onClick: R[5] || (R[5] = (X) => Y(String(h.value.id)))
                  }, [
                    o("span", {
                      "aria-hidden": "true",
                      innerHTML: s(Ue)("copy")
                    }, null, 8, cg)
                  ], 8, lg)
                ])
              ])) : g("", !0),
              C.value ? (c(), d("div", ug, [
                o("dt", null, f(s(a)("inspector.etag")), 1),
                o("dd", dg, [
                  o("span", {
                    class: "fe-inspector__path",
                    title: C.value
                  }, f(M(C.value)), 9, fg),
                  o("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: s(a)("inspector.copy"),
                    "aria-label": s(a)("inspector.copy"),
                    onClick: R[6] || (R[6] = (X) => Y(C.value))
                  }, [
                    o("span", {
                      "aria-hidden": "true",
                      innerHTML: s(Ue)("copy")
                    }, null, 8, vg)
                  ], 8, pg)
                ])
              ])) : g("", !0)
            ])
          ], 64)) : (c(), d("p", hg, f(s(a)("inspector.select_hint")), 1))
        ])) : g("", !0),
        $.value && (!e.tabs || K.value === "details") ? (c(), d("section", mg, [
          o("h3", yg, f(s(a)("inspector.section.tags")), 1),
          Ge(td, {
            "node-id": A.value,
            locale: e.locale,
            "api-base": e.apiBase,
            "auth-headers": e.authHeaders,
            "auth-credentials": e.authCredentials,
            onChange: R[7] || (R[7] = (X) => r("tags-changed", X)),
            onOpen: R[8] || (R[8] = (X) => r("open-tag", X)),
            onError: R[9] || (R[9] = () => r("toast", s(a)("inspector.error")))
          }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
        ])) : g("", !0),
        (N.value === "ok" || N.value === "error") && (!e.tabs || K.value === "activity") ? (c(), d("section", bg, [
          o("h3", gg, f(s(a)("inspector.section.versions")), 1),
          N.value === "error" ? (c(), d("p", kg, f(s(a)("inspector.error")), 1)) : (c(), d(ae, { key: 1 }, [
            P.value.length === 0 ? (c(), d("p", _g, f(s(a)("inspector.versions.empty")), 1)) : (c(), d("ul", wg, [
              (c(!0), d(ae, null, Te(P.value, (X) => (c(), d("li", {
                key: X.id,
                class: "fe-inspector__version"
              }, [
                o("div", $g, [
                  o("span", xg, f(s(a)("inspector.versions.v", { n: X.version_n })), 1),
                  o("span", Sg, f(T(X.created_at)) + " · " + f(s(u)(X.size)), 1)
                ]),
                le.value === X.id ? (c(), d("div", Cg, [
                  o("p", Tg, f(s(a)("inspector.versions.restore_confirm")), 1),
                  o("label", Mg, [
                    Ve(o("input", {
                      "onUpdate:modelValue": R[10] || (R[10] = (ye) => ve.value = ye),
                      type: "checkbox"
                    }, null, 512), [
                      [An, ve.value]
                    ]),
                    Je(" " + f(s(a)("inspector.versions.snapshot_current")), 1)
                  ]),
                  o("div", Eg, [
                    o("button", {
                      type: "button",
                      class: "fe-btn fe-btn--primary fe-btn--sm",
                      disabled: he.value,
                      onClick: (ye) => w(X)
                    }, f(s(a)("inspector.versions.confirm")), 9, zg),
                    o("button", {
                      type: "button",
                      class: "fe-btn fe-btn--sm",
                      disabled: he.value,
                      onClick: R[11] || (R[11] = (ye) => le.value = null)
                    }, f(s(a)("inspector.versions.cancel")), 9, Ag)
                  ])
                ])) : (c(), d("button", {
                  key: 1,
                  type: "button",
                  class: "fe-btn fe-btn--sm",
                  disabled: he.value,
                  onClick: (ye) => S(X)
                }, f(s(a)("inspector.versions.restore")), 9, Pg))
              ]))), 128))
            ])),
            o("button", {
              type: "button",
              class: "fe-btn fe-btn--sm fe-inspector__snapshot",
              disabled: he.value,
              onClick: j
            }, f(s(a)("inspector.versions.take_snapshot")), 9, Lg)
          ], 64))
        ])) : g("", !0),
        h.value && O.value && (!e.tabs || K.value === "details") && !(e.tabs && Z.value === "ok") ? (c(), d("section", Dg, [
          o("h3", Og, f(s(a)("inspector.section.permissions")), 1),
          o("div", Bg, [
            o("span", {
              class: we(["fe-inspector__badge", `fe-inspector__badge--${O.value}`])
            }, f(G(O.value)), 3),
            J.value ? (c(), d("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              onClick: R[12] || (R[12] = (X) => r("manage-permissions", h.value))
            }, f(s(a)("inspector.perm.manage")), 1)) : g("", !0)
          ])
        ])) : g("", !0),
        e.tabs && K.value === "details" && Z.value === "ok" ? (c(), d("section", Ig, [
          o("h3", Hg, f(s(a)("inspector.people")), 1),
          W.value.length === 0 ? (c(), d("p", Fg, f(s(a)("inspector.people.empty")), 1)) : (c(), d("ul", Ng, [
            (c(!0), d(ae, null, Te(W.value, (X) => (c(), d("li", {
              key: `${X.id}-${X.user_id}`,
              class: "fe-inspector__person"
            }, [
              o("span", Kg, f(Ne(X)), 1),
              o("span", Rg, [
                o("span", {
                  class: "fe-inspector__person-name",
                  title: X.user_email
                }, f(ze(X)), 9, Ug),
                o("span", Vg, [
                  Je(f(G(X.level)), 1),
                  X.inherited ? (c(), d(ae, { key: 0 }, [
                    Je(" · " + f(s(a)("inspector.people.inherited")), 1)
                  ], 64)) : g("", !0)
                ])
              ])
            ]))), 128))
          ])),
          J.value && h.value ? (c(), d("button", {
            key: 2,
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: R[13] || (R[13] = (X) => r("manage-permissions", h.value))
          }, f(s(a)("inspector.people.manage")), 1)) : g("", !0)
        ])) : g("", !0),
        oe.value === "ok" && (!e.tabs || K.value === "details") ? (c(), d("section", jg, [
          o("h3", Yg, f(e.tabs ? s(a)("inspector.link") : s(a)("inspector.section.shares")), 1),
          e.tabs && ue.value.length === 0 ? (c(), d("div", Wg, [
            o("span", {
              class: "fe-inspector__linkicon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("link")
            }, null, 8, qg),
            o("span", Gg, f(s(a)("inspector.link.none")), 1),
            o("button", {
              type: "button",
              class: "fe-btn fe-btn--sm",
              disabled: be.value || !h.value,
              "data-testid": "inspector-create-link",
              onClick: De
            }, f(s(a)("inspector.link.create")), 9, Xg)
          ])) : ue.value.length === 0 ? (c(), d("p", Jg, f(s(a)("inspector.shares.empty")), 1)) : (c(), d("ul", Zg, [
            (c(!0), d(ae, null, Te(ue.value, (X) => (c(), d("li", {
              key: X.uuid,
              class: "fe-inspector__share"
            }, [
              o("span", {
                class: "fe-inspector__share-url",
                title: X.url
              }, f(X.url), 9, Qg),
              X.password_pin ? (c(), d("span", ek, "PIN")) : g("", !0),
              X.expires_at ? (c(), d("span", tk, f(T(X.expires_at)), 1)) : g("", !0),
              o("button", {
                type: "button",
                class: "fe-inspector__copy",
                title: s(a)("inspector.shares.copy"),
                "aria-label": s(a)("inspector.shares.copy"),
                onClick: (ye) => Y(X.url)
              }, [
                o("span", {
                  "aria-hidden": "true",
                  innerHTML: s(Ue)("copy")
                }, null, 8, ak)
              ], 8, nk)
            ]))), 128))
          ]))
        ])) : g("", !0),
        (ce.value === "ok" || ce.value === "error") && (!e.tabs || K.value === "activity") ? (c(), d("section", ok, [
          o("h3", sk, [
            Je(f(s(a)("inspector.section.comments")) + " ", 1),
            L.value.length > 0 ? (c(), d("span", rk, f(L.value.length), 1)) : g("", !0)
          ]),
          ce.value === "error" ? (c(), d("p", ik, f(s(a)("inspector.error")), 1)) : (c(), d(ae, { key: 1 }, [
            L.value.length === 0 ? (c(), d("p", lk, f(s(a)("inspector.comments.empty")), 1)) : (c(), d("ul", ck, [
              (c(!0), d(ae, null, Te(L.value, (X) => (c(), d("li", {
                key: X.id,
                class: "fe-inspector__comment"
              }, [
                o("div", uk, [
                  o("span", {
                    class: "fe-inspector__comment-author",
                    title: X.author_name
                  }, f(X.author_name || "—"), 9, dk),
                  o("span", {
                    class: "fe-inspector__comment-time",
                    title: T(X.created_at)
                  }, f(Ae(X.created_at)), 9, fk),
                  X.can_delete ? (c(), d("button", {
                    key: 0,
                    type: "button",
                    class: "fe-inspector__comment-del",
                    disabled: Ce.value,
                    title: s(a)("inspector.comments.delete"),
                    "aria-label": s(a)("inspector.comments.delete"),
                    onClick: (ye) => Xe(X)
                  }, "×", 8, pk)) : g("", !0)
                ]),
                o("p", vk, f(X.body), 1)
              ]))), 128))
            ])),
            o("form", {
              class: "fe-inspector__comment-form",
              onSubmit: Re(vt, ["prevent"])
            }, [
              Ve(o("input", {
                "onUpdate:modelValue": R[14] || (R[14] = (X) => se.value = X),
                type: "text",
                class: "fe-inspector__comment-input",
                maxlength: "5000",
                placeholder: s(a)("inspector.comments.placeholder"),
                "aria-label": s(a)("inspector.comments.placeholder"),
                disabled: Ce.value
              }, null, 8, hk), [
                [rt, se.value]
              ]),
              o("button", {
                type: "submit",
                class: "fe-btn fe-btn--primary fe-btn--sm",
                disabled: Ce.value || se.value.trim() === ""
              }, f(s(a)("inspector.comments.send")), 9, mk)
            ], 32)
          ], 64))
        ])) : g("", !0),
        e.tabs && K.value === "activity" && !ie.value ? (c(), d("section", yk, [
          o("p", bk, f(h.value ? s(a)("inspector.activity.empty") : s(a)("inspector.activity.select")), 1),
          h.value ? (c(), d("p", gk, f(s(a)("inspector.activity.hint")), 1)) : g("", !0)
        ])) : g("", !0)
      ])
    ], 10, Mb));
  }
}), _k = ["aria-label"], wk = {
  key: 0,
  class: "fe-sidenav__head"
}, $k = ["aria-expanded", "title", "aria-label"], xk = { class: "fe-sidenav__primary" }, Sk = ["title", "aria-label"], Ck = { class: "fe-sidenav__new-main" }, Tk = {
  key: 0,
  class: "fe-sidenav__text"
}, Mk = {
  key: 0,
  class: "fe-sidenav__new-rule",
  "aria-hidden": "true"
}, Ek = {
  key: 1,
  class: "fe-sidenav__new-caret",
  "aria-hidden": "true"
}, zk = { class: "fe-sidenav__scroll" }, Ak = ["aria-label"], Pk = ["aria-current", "title", "aria-label", "data-testid", "onClick"], Lk = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, Dk = {
  key: 1,
  d: "M3.5 7.5A1.5 1.5 0 0 1 5 6h4l2 2.5h8A1.5 1.5 0 0 1 20.5 10v7.5A1.5 1.5 0 0 1 19 19H5a1.5 1.5 0 0 1-1.5-1.5z"
}, Ok = {
  key: 3,
  d: "M12 4l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4-3.9-3.8 5.4-.8z"
}, Bk = {
  key: 0,
  class: "fe-sidenav__text"
}, Ik = {
  key: 0,
  class: "fe-sidenav__section"
}, Hk = { class: "fe-sidenav__heading" }, Fk = ["aria-label"], Nk = ["aria-current", "title", "aria-label", "data-testid", "onClick"], Kk = { class: "fe-sidenav__text" }, Rk = { key: 0 }, Uk = { class: "fe-sidenav__hint" }, Vk = { key: 1 }, jk = { key: 2 }, Yk = ["aria-label"], Wk = ["title", "aria-label"], qk = {
  key: 1,
  class: "fe-sidenav__section"
}, Gk = {
  key: 0,
  class: "fe-sidenav__heading"
}, Xk = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, Jk = ["aria-label"], Zk = ["title", "aria-label", "data-testid", "onClick"], Qk = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, e_ = {
  key: 0,
  class: "fe-sidenav__text"
}, t_ = ["aria-label"], n_ = ["aria-label"], a_ = {
  key: 2,
  class: "fe-sidenav__section"
}, o_ = {
  key: 0,
  class: "fe-sidenav__heading"
}, s_ = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, r_ = ["aria-label"], i_ = ["title", "aria-label"], l_ = {
  key: 0,
  class: "fe-sidenav__text"
}, c_ = { key: 0 }, u_ = ["title", "aria-label"], d_ = {
  key: 0,
  class: "fe-sidenav__text"
}, f_ = {
  key: 1,
  class: "fe-sidenav__quota",
  "data-testid": "sidenav-quota"
}, p_ = {
  key: 0,
  class: "fe-sidenav__quota-label"
}, v_ = ["aria-valuenow", "aria-label", "title"], h_ = {
  key: 1,
  class: "fe-sidenav__quota-text"
}, m_ = 8, y_ = /* @__PURE__ */ qe({
  __name: "SideNav",
  props: {
    expanded: { type: Boolean },
    narrow: { type: Boolean },
    activeView: {},
    activeStorage: {},
    storages: {},
    sharedStorages: {},
    trashVisible: { type: Boolean },
    tags: {},
    tagsLoaded: { type: Boolean },
    activeTag: {},
    showConnections: { type: Boolean },
    showIdentitySurfaces: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    canRequestFiles: { type: Boolean },
    canNewDocument: { type: Boolean },
    quota: {},
    theme: {}
  },
  emits: ["toggle", "open-view", "open-tag", "open-storage", "open-root", "upload", "new-folder", "new-document", "open-connections", "open-tokens", "request-files", "close"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a, formatSize: u } = tt(() => n.locale), v = k(() => n.expanded || !!n.narrow), p = k(() => new Set(n.sharedStorages ?? [])), h = /* @__PURE__ */ new Set(["recent", "starred", "shared"]), b = k(() => {
      const G = [
        { key: "home", label: a("sidenav.home") },
        ...n.storages.length <= 1 ? [{ key: "myfiles", label: a("sidenav.myfiles") }] : [],
        { key: "shared", label: a("sidenav.shared") },
        { key: "recent", label: a("sidenav.recent") },
        { key: "starred", label: a("sidenav.starred") }
      ];
      return n.trashVisible !== !1 && G.push({ key: "trash", label: a("sidenav.trash") }), n.showIdentitySurfaces === !1 ? G.filter((N) => !h.has(N.key)) : G;
    }), y = k(() => n.canWrite !== !1), A = k(
      () => !!n.activeStorage && n.storages.some((G) => G.name === n.activeStorage && G.readOnly === !0)
    );
    function D(G) {
      return G === "myfiles" ? !n.activeView && !n.activeStorage : n.activeView === G;
    }
    const C = m(!1), B = k(() => n.tags ?? []), I = k(
      () => C.value ? B.value : B.value.slice(0, m_)
    ), U = k(() => Math.max(0, B.value.length - I.value.length)), x = k(() => !!n.tagsLoaded || B.value.length > 0), E = m(null), $ = m(null), M = k(() => {
      const G = [
        /* ⚠ NO `icon:` on any of these three, and that is the fix rather than an
           omission. `ContextMenu.iconFor` resolves `actionIconSvg(a.icon || a.key)`,
           so an `icon` string is an OVERRIDE — and `'⬆'` / `'📁'` / `'🔗'` are not
           keys, so the lookup missed, the component fell through to its literal
           branch and printed the emoji. Meanwhile `new-document`, which carries no
           override, resolved by key and drew a proper glyph: one menu, two icon
           systems, three rows apart. All three keys have had stroked glyphs in
           `lib/actionIcons.ts` the whole time (`upload`, `new-folder`,
           `request-files`); dropping the override is what reaches them.
           ⚠ Emoji in markup is forbidden here for a reason that is visible in this
           very menu: they are rendered by whatever font the OS ships, so the row
           came out flat-grey on one machine and full-colour on another, at a weight
           that matched nothing beside it. */
        { key: "upload", label: a("drive.new.upload"), disabled: !y.value },
        { key: "new-folder", label: a("drive.new.folder"), disabled: !y.value }
      ];
      return n.canNewDocument && G.push({ key: "new-document", label: a("drive.new.document"), disabled: !y.value }), G.push({ divider: !0, key: "new-sep", label: "" }), G.push({
        key: "request-files",
        label: a("drive.new.request"),
        disabled: !n.canRequestFiles
      }), G;
    });
    function z() {
      var N, P;
      const G = (N = E.value) == null ? void 0 : N.getBoundingClientRect();
      (P = $.value) == null || P.show(
        { clientX: G ? G.left : 0, clientY: G ? G.bottom + 6 : 0 },
        []
      );
    }
    function T(G) {
      G.key === "upload" ? r("upload") : G.key === "new-document" ? r("new-document") : G.key === "new-folder" ? r("new-folder") : G.key === "request-files" && r("request-files");
    }
    const Y = k(() => {
      const G = n.quota;
      return !G || G.unlimited || G.total <= 0 ? 0 : Math.max(0, Math.min(100, Math.round(G.used / G.total * 100)));
    }), O = k(() => {
      const G = n.quota;
      return G ? G.unlimited || G.total <= 0 ? a("drive.storage.used_unlimited", { used: u(G.used) }) : a("drive.storage.used", { used: u(G.used), total: u(G.total) }) : "";
    }), J = k(() => a("sidenav.close"));
    return (G, N) => (c(), d("nav", {
      class: we(["fe-sidenav", {
        "fe-sidenav--rail": !e.expanded && !e.narrow,
        "fe-sidenav--drawer": e.narrow
      }]),
      role: "navigation",
      "aria-label": s(a)("sidenav.title"),
      "data-testid": "sidenav"
    }, [
      e.narrow ? (c(), d("div", wk, [
        o("button", {
          type: "button",
          class: "fe-sidenav__toggle",
          "aria-expanded": v.value,
          title: J.value,
          "aria-label": J.value,
          "data-testid": "sidenav-toggle",
          onClick: N[0] || (N[0] = (P) => r("close"))
        }, [...N[6] || (N[6] = [
          o("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            o("path", { d: "M6 6l12 12M18 6L6 18" })
          ], -1)
        ])], 8, $k)
      ])) : g("", !0),
      o("div", xk, [
        A.value ? g("", !0) : (c(), d("button", {
          key: 0,
          ref_key: "newBtnEl",
          ref: E,
          type: "button",
          class: "fe-sidenav__new",
          "aria-haspopup": "menu",
          title: s(a)("drive.new"),
          "aria-label": s(a)("drive.new"),
          "data-testid": "sidenav-new",
          onClick: z
        }, [
          o("span", Ck, [
            N[7] || (N[7] = o("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              o("path", { d: "M12 5v14M5 12h14" })
            ], -1)),
            v.value ? (c(), d("span", Tk, f(s(a)("drive.new")), 1)) : g("", !0)
          ]),
          v.value ? (c(), d("span", Mk)) : g("", !0),
          v.value ? (c(), d("span", Ek, [...N[8] || (N[8] = [
            o("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              o("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])])) : g("", !0)
        ], 8, Sk))
      ]),
      o("div", zk, [
        o("ul", {
          class: "fe-sidenav__group",
          "aria-label": s(a)("sidenav.views")
        }, [
          (c(!0), d(ae, null, Te(b.value, (P) => (c(), d("li", {
            key: P.key
          }, [
            o("button", {
              type: "button",
              class: we(["fe-sidenav__item", { "is-active": D(P.key) }]),
              "aria-current": D(P.key) ? "page" : void 0,
              title: P.label,
              "aria-label": P.label,
              "data-testid": `sidenav-view-${P.key}`,
              onClick: (le) => r("open-view", P.key)
            }, [
              (c(), d("svg", Lk, [
                P.key === "home" ? (c(), d(ae, { key: 0 }, [
                  N[9] || (N[9] = o("path", { d: "M4 10.5L12 4l8 6.5" }, null, -1)),
                  N[10] || (N[10] = o("path", { d: "M6 9.8V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.8" }, null, -1)),
                  N[11] || (N[11] = o("path", { d: "M10 20v-5.5h4V20" }, null, -1))
                ], 64)) : P.key === "myfiles" ? (c(), d("path", Dk)) : P.key === "recent" ? (c(), d(ae, { key: 2 }, [
                  N[12] || (N[12] = o("circle", {
                    cx: "12",
                    cy: "12",
                    r: "8.5"
                  }, null, -1)),
                  N[13] || (N[13] = o("path", { d: "M12 7.5V12l3 2" }, null, -1))
                ], 64)) : P.key === "starred" ? (c(), d("path", Ok)) : P.key === "shared" ? (c(), d(ae, { key: 4 }, [
                  N[14] || (N[14] = o("circle", {
                    cx: "17.5",
                    cy: "6.5",
                    r: "2.5"
                  }, null, -1)),
                  N[15] || (N[15] = o("circle", {
                    cx: "6.5",
                    cy: "12",
                    r: "2.5"
                  }, null, -1)),
                  N[16] || (N[16] = o("circle", {
                    cx: "17.5",
                    cy: "17.5",
                    r: "2.5"
                  }, null, -1)),
                  N[17] || (N[17] = o("path", { d: "M8.8 10.8l6.4-3.2M8.8 13.2l6.4 3.2" }, null, -1))
                ], 64)) : (c(), d(ae, { key: 5 }, [
                  N[18] || (N[18] = o("path", { d: "M4.5 7h15" }, null, -1)),
                  N[19] || (N[19] = o("path", { d: "M9.5 7V5.2A1.2 1.2 0 0 1 10.7 4h2.6a1.2 1.2 0 0 1 1.2 1.2V7" }, null, -1)),
                  N[20] || (N[20] = o("path", { d: "M6.5 7l.9 11.1A1.4 1.4 0 0 0 8.8 19.4h6.4a1.4 1.4 0 0 0 1.4-1.3L17.5 7" }, null, -1))
                ], 64))
              ])),
              v.value ? (c(), d("span", Bk, f(P.label), 1)) : g("", !0)
            ], 10, Pk)
          ]))), 128))
        ], 8, Ak),
        x.value ? (c(), d("div", Ik, [
          v.value ? (c(), d(ae, { key: 0 }, [
            o("p", Hk, f(s(a)("sidenav.tags")), 1),
            o("ul", {
              class: "fe-sidenav__group",
              "aria-label": s(a)("sidenav.tags")
            }, [
              (c(!0), d(ae, null, Te(I.value, (P) => (c(), d("li", { key: P }, [
                o("button", {
                  type: "button",
                  class: we(["fe-sidenav__item fe-sidenav__item--tag", { "is-active": e.activeView === "tag" && e.activeTag === P }]),
                  "aria-current": e.activeView === "tag" && e.activeTag === P ? "page" : void 0,
                  title: P,
                  "aria-label": P,
                  "data-testid": `sidenav-tag-${P}`,
                  onClick: (le) => r("open-tag", P)
                }, [
                  N[21] || (N[21] = o("svg", {
                    class: "fe-ficon",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    o("path", { d: "M4 4.5h7l9 9-6.5 6.5-9-9z" }),
                    o("circle", {
                      cx: "8",
                      cy: "8.5",
                      r: "1.4"
                    })
                  ], -1)),
                  o("span", Kk, f(P), 1)
                ], 10, Nk)
              ]))), 128)),
              B.value.length === 0 ? (c(), d("li", Rk, [
                o("p", Uk, f(s(a)("sidenav.tags.empty")), 1)
              ])) : g("", !0),
              U.value > 0 ? (c(), d("li", Vk, [
                o("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-more",
                  onClick: N[1] || (N[1] = (P) => C.value = !0)
                }, f(s(a)("sidenav.tags.more", { count: U.value })), 1)
              ])) : C.value && B.value.length > 8 ? (c(), d("li", jk, [
                o("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-less",
                  onClick: N[2] || (N[2] = (P) => C.value = !1)
                }, f(s(a)("sidenav.tags.less")), 1)
              ])) : g("", !0)
            ], 8, Fk)
          ], 64)) : (c(), d(ae, { key: 1 }, [
            N[23] || (N[23] = o("hr", {
              class: "fe-sidenav__rule",
              "aria-hidden": "true"
            }, null, -1)),
            o("ul", {
              class: "fe-sidenav__group",
              "aria-label": s(a)("sidenav.tags")
            }, [
              o("li", null, [
                o("button", {
                  type: "button",
                  class: we(["fe-sidenav__item", { "is-active": e.activeView === "tag" }]),
                  title: s(a)("sidenav.tags"),
                  "aria-label": s(a)("sidenav.tags"),
                  "data-testid": "sidenav-tags-rail",
                  onClick: N[3] || (N[3] = (P) => r("toggle"))
                }, [...N[22] || (N[22] = [
                  o("svg", {
                    class: "fe-ficon",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    o("path", { d: "M4 4.5h7l9 9-6.5 6.5-9-9z" }),
                    o("circle", {
                      cx: "8",
                      cy: "8.5",
                      r: "1.4"
                    })
                  ], -1)
                ])], 10, Wk)
              ])
            ], 8, Yk)
          ], 64))
        ])) : g("", !0),
        e.storages.length ? (c(), d("div", qk, [
          v.value ? (c(), d("p", Gk, f(s(a)("sidenav.storages")), 1)) : (c(), d("hr", Xk)),
          o("ul", {
            class: "fe-sidenav__group",
            "aria-label": s(a)("sidenav.storages")
          }, [
            (c(!0), d(ae, null, Te(e.storages, (P) => (c(), d("li", {
              key: P.name
            }, [
              o("button", {
                type: "button",
                class: we(["fe-sidenav__item", { "is-active": !e.activeView && e.activeStorage === P.name }]),
                title: p.value.has(P.name) ? `${P.label || P.name} — ${s(a)("sidenav.storage.shared")}` : P.label || P.name,
                "aria-label": p.value.has(P.name) ? `${P.label || P.name} — ${s(a)("sidenav.storage.shared")}` : P.label || P.name,
                "data-testid": `sidenav-storage-${P.name}`,
                onClick: (le) => r("open-storage", P.name)
              }, [
                (c(), d("svg", Qk, [
                  p.value.has(P.name) ? (c(), d(ae, { key: 0 }, [
                    N[24] || (N[24] = o("path", { d: "M3 8.5A1.5 1.5 0 0 1 4.5 7h5L11 9h8.5A1.5 1.5 0 0 1 21 10.5v7A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z" }, null, -1)),
                    N[25] || (N[25] = o("circle", {
                      cx: "15.6",
                      cy: "13.6",
                      r: "1.6"
                    }, null, -1)),
                    N[26] || (N[26] = o("circle", {
                      cx: "9.4",
                      cy: "15.4",
                      r: "1.6"
                    }, null, -1)),
                    N[27] || (N[27] = o("path", { d: "M10.9 14.7l3.3-.9" }, null, -1))
                  ], 64)) : (c(), d(ae, { key: 1 }, [
                    N[28] || (N[28] = o("rect", {
                      x: "3",
                      y: "5",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    N[29] || (N[29] = o("rect", {
                      x: "3",
                      y: "13",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    N[30] || (N[30] = o("path", { d: "M6.5 8h.01M6.5 16h.01" }, null, -1))
                  ], 64))
                ])),
                v.value ? (c(), d("span", e_, f(P.label || P.name), 1)) : g("", !0),
                v.value && p.value.has(P.name) ? (c(), d("span", {
                  key: 1,
                  class: "fe-sidenav__tag",
                  role: "img",
                  "aria-label": s(a)("sidenav.storage.shared")
                }, f(s(a)("sidenav.storage.shared")), 9, t_)) : g("", !0),
                v.value && P.readOnly ? (c(), d("span", {
                  key: 2,
                  class: "fe-sidenav__tag",
                  role: "img",
                  "data-testid": "sidenav-storage-readonly",
                  "aria-label": s(a)("sidenav.storage.readOnly")
                }, f(s(a)("sidenav.storage.readOnly")), 9, n_)) : g("", !0)
              ], 10, Zk)
            ]))), 128))
          ], 8, Jk)
        ])) : g("", !0),
        e.showConnections ? (c(), d("div", a_, [
          v.value ? (c(), d("p", o_, f(s(a)("sidenav.connections")), 1)) : (c(), d("hr", s_)),
          o("ul", {
            class: "fe-sidenav__group",
            "aria-label": s(a)("sidenav.connections")
          }, [
            o("li", null, [
              o("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: s(a)("sidenav.connect"),
                "aria-label": s(a)("sidenav.connect"),
                "data-testid": "sidenav-connect",
                onClick: N[4] || (N[4] = (P) => r("open-connections"))
              }, [
                N[31] || (N[31] = o("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  o("path", { d: "M9.5 14.5l-2.6 2.6a3.7 3.7 0 0 1-5.2-5.2l2.6-2.6" }),
                  o("path", { d: "M14.5 9.5l2.6-2.6a3.7 3.7 0 0 1 5.2 5.2l-2.6 2.6" }),
                  o("path", { d: "M9 15l6-6" })
                ], -1)),
                v.value ? (c(), d("span", l_, f(s(a)("sidenav.connect")), 1)) : g("", !0)
              ], 8, i_)
            ]),
            e.showIdentitySurfaces !== !1 ? (c(), d("li", c_, [
              o("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: s(a)("sidenav.apikeys"),
                "aria-label": s(a)("sidenav.apikeys"),
                "data-testid": "sidenav-apikeys",
                onClick: N[5] || (N[5] = (P) => r("open-tokens"))
              }, [
                N[32] || (N[32] = o("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  o("circle", {
                    cx: "8",
                    cy: "12",
                    r: "3.5"
                  }),
                  o("path", { d: "M11.5 12H21" }),
                  o("path", { d: "M17.5 12v3.2M20 12v2.2" })
                ], -1)),
                v.value ? (c(), d("span", d_, f(s(a)("sidenav.apikeys")), 1)) : g("", !0)
              ], 8, u_)
            ])) : g("", !0)
          ], 8, r_)
        ])) : g("", !0)
      ]),
      e.quota ? (c(), d("div", f_, [
        v.value ? (c(), d("p", p_, f(s(a)("drive.storage.label")), 1)) : g("", !0),
        o("div", {
          class: "fe-sidenav__quota-bar",
          role: "progressbar",
          "aria-valuenow": Y.value,
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          "aria-label": O.value,
          title: O.value
        }, [
          o("span", {
            class: "fe-sidenav__quota-fill",
            style: Ct({ width: Y.value + "%" })
          }, null, 4)
        ], 8, v_),
        v.value ? (c(), d("p", h_, f(O.value), 1)) : g("", !0)
      ])) : g("", !0),
      Ge(Ps, {
        ref_key: "newMenuRef",
        ref: $,
        locale: e.locale,
        theme: e.theme,
        actions: M.value,
        onSelect: T
      }, null, 8, ["locale", "theme", "actions"])
    ], 10, _k));
  }
}), Ad = "application/x-brf-files", b_ = "application/x-brf-files-src";
let Fa = null;
const g_ = 5 * 6e4;
function k_(e, t) {
  Fa = { items: e.slice(), origin: t, startedAt: Date.now() };
}
function Ba() {
  Fa = null;
}
function Co() {
  return Fa ? Date.now() - Fa.startedAt > g_ ? (Fa = null, null) : Fa : null;
}
function vn(e) {
  var t;
  return (t = e.dataTransfer) != null && t.types.includes(Ad) ? !0 : Co() !== null;
}
function Cs(e) {
  var r;
  const t = (r = e.dataTransfer) == null ? void 0 : r.getData(Ad);
  if (t)
    try {
      const a = JSON.parse(t);
      return Array.isArray(a) && a.length > 0 ? a : null;
    } catch {
      return null;
    }
  const n = Co();
  return n && n.items.length > 0 ? n.items : null;
}
function mi(e) {
  var n, r;
  const t = (n = e.dataTransfer) == null ? void 0 : n.getData(b_);
  return t || ((r = Co()) == null ? void 0 : r.origin) || void 0;
}
function __(e) {
  const t = w_(e);
  return t === void 0 || t === "none" || t === "csrf";
}
function w_(e) {
  if (!e || typeof e != "object") return;
  const t = e;
  return typeof t.kind == "string" ? t.kind : typeof t.type == "string" ? t.type : void 0;
}
function $_(e, t, n) {
  if (e.type !== "file") return null;
  let r = t;
  try {
    r = new URL(t, typeof location < "u" ? location.href : void 0).toString();
  } catch {
    return null;
  }
  if (!/^https?:/i.test(r)) return null;
  const a = e.basename.replace(/[:\r\n]/g, "_");
  return `${n && n.trim() ? n : "application/octet-stream"}:${a}:${r}`;
}
function x_(e) {
  return e.map((t) => t.path).sort().join("\0");
}
const S_ = 500, C_ = 800, mu = 10, T_ = 'button, a, input, select, textarea, label, [role="checkbox"], [data-fe-control]';
function Ui(e, t) {
  return { ctrl: e.ctrlKey || e.metaKey, shift: e.shiftKey, touch: t };
}
function Vi(e) {
  return { ctrl: !0, shift: e.shiftKey, check: !0 };
}
function M_(e) {
  const t = e.target;
  if (typeof (t == null ? void 0 : t.closest) != "function") return !1;
  const n = t.closest(T_), r = e.currentTarget;
  return n !== null && (r === null || typeof r.contains != "function" || r.contains(n));
}
function ji(e, t = {}) {
  let n, r = null, a = { clientX: 0, clientY: 0 }, u = !1, v = 0, p = !1;
  function h() {
    n && clearTimeout(n), n = void 0;
  }
  function b(C, B) {
    const I = B.touches[0];
    I && (h(), r = C, u = !1, a = { clientX: I.clientX, clientY: I.clientY }, p = !M_(B), n = setTimeout(() => {
      n = void 0, r !== null && (u = !0, e(r, a));
    }, S_));
  }
  function y(C) {
    const B = C.touches[0];
    (!B || Math.abs(B.clientX - a.clientX) > mu || Math.abs(B.clientY - a.clientY) > mu) && (h(), r = null);
  }
  function A(C) {
    h();
    const B = r, I = B !== null && !u;
    I && (v = Date.now()), r = null, I && p && t.onTap && (C != null && C.cancelable && C.preventDefault(), t.onTap(B)), p = !1;
  }
  function D(C) {
    const B = C.pointerType;
    return B ? B === "touch" : Date.now() - v < C_;
  }
  return it(h), { onTouchStart: b, onTouchMove: y, onTouchEnd: A, isTap: D };
}
const E_ = ["aria-checked", "aria-label", "title"], Yi = /* @__PURE__ */ qe({
  __name: "ItemCheck",
  props: {
    on: { type: Boolean },
    label: {}
  },
  setup(e) {
    return (t, n) => (c(), d("button", {
      type: "button",
      class: we(["fe-list__check", { "is-on": e.on }]),
      role: "checkbox",
      "aria-checked": e.on ? "true" : "false",
      "aria-label": e.label,
      title: e.label,
      onMousedown: n[0] || (n[0] = Re(() => {
      }, ["prevent"]))
    }, null, 42, E_));
  }
}), Ia = 8 * 1024, z_ = 4 * 1024 * 1024, A_ = 3, P_ = 24, yu = 120, L_ = 16, D_ = 8, O_ = 400, B_ = /* @__PURE__ */ new Set(["csv", "tsv"]);
function I_(e) {
  if (e.trashed) return !0;
  const t = e.extra_metadata;
  return !!t && typeof t == "object" && "deleted_at" in t;
}
function yi(e) {
  if (e.type !== "file" || e.basename === ".trash" || e.mime_type === "inode/storage" || I_(e)) return null;
  const t = e.size ?? 0;
  if (t <= 0 || t > z_) return null;
  const n = (e.extension || "").trim().toLowerCase();
  if (B_.has(n)) return "table";
  const r = jn(e);
  return r === "code" ? "code" : r === "text" ? "text" : null;
}
function Wi(e) {
  if (e.type !== "file") return !1;
  switch (jn(e)) {
    case "pdf":
    case "doc":
    case "sheet":
    case "slides":
      return !0;
    default:
      return !1;
  }
}
function Pd(e) {
  return e.type === "file" && jn(e) === "video";
}
const H_ = /* @__PURE__ */ new Set([
  "import",
  "export",
  "from",
  "require",
  "include",
  "use",
  "using",
  "package",
  "module",
  "namespace",
  "const",
  "let",
  "var",
  "function",
  "func",
  "fn",
  "def",
  "class",
  "struct",
  "enum",
  "interface",
  "type",
  "impl",
  "trait",
  "public",
  "private",
  "protected",
  "static",
  "async",
  "await",
  "return",
  "if",
  "else",
  "for",
  "while",
  "switch",
  "case",
  "try",
  "catch",
  "select",
  "insert",
  "update",
  "delete",
  "create",
  "alter",
  "drop"
]), F_ = /^(#{1,6}|[-*+]|>|\d+\.)$/;
function N_(e) {
  return e.replace(/[(){}[\];:,.]+$/, "").toLowerCase();
}
function K_(e, t) {
  const n = e.length > yu ? e.slice(0, yu) : e, r = /^(\s*)(\S+)([\s\S]*)$/.exec(n);
  if (!r) return { indent: "", tint: "", text: n };
  const [, a, u, v] = r;
  return (t === "code" ? H_.has(N_(u)) : F_.test(u)) ? { indent: a, tint: u, text: v } : { indent: "", tint: "", text: n };
}
function R_(e, t) {
  const n = [];
  let r = "", a = !1;
  for (let u = 0; u < e.length; u++) {
    const v = e[u];
    a ? v === '"' ? e[u + 1] === '"' ? (r += '"', u++) : a = !1 : r += v : v === '"' ? a = !0 : v === t ? (n.push(r), r = "") : r += v;
  }
  return n.push(r), n;
}
function U_(e, t) {
  return e === "tsv" ? "	" : !t.includes(",") && t.includes(";") ? ";" : ",";
}
function V_(e, t, n, r) {
  for (let p = 0; p < e.length; p++)
    if (e[p] === 0) return null;
  const a = new TextDecoder("utf-8", { fatal: !1 }).decode(e);
  let u = 0;
  for (const p of a) p === "�" && u++;
  if (a.length > 0 && u / a.length > 0.1) return null;
  const v = a.split(/\r\n|\r|\n/);
  for (r && v.length > 1 && v.pop(); v.length && v[0].trim() === ""; ) v.shift();
  for (; v.length && v[v.length - 1].trim() === ""; ) v.pop();
  if (v.length === 0) return null;
  if (t === "table") {
    const p = U_(n, v[0]), h = v.filter((y) => y.trim() !== "").slice(0, L_).map((y) => R_(y, p).slice(0, D_).map((A) => A.trim().slice(0, 24)));
    if (h.length === 0) return null;
    const b = h.reduce((y, A) => Math.max(y, A.length), 0);
    for (const y of h) for (; y.length < b; ) y.push("");
    return { kind: t, lines: [], rows: h, cols: b };
  }
  return {
    kind: t,
    lines: v.slice(0, P_).map((p) => K_(p, t)),
    rows: [],
    cols: 0
  };
}
function go(e) {
  const n = (typeof e.etag == "string" ? e.etag : "") || String(e.last_modified ?? "") || String(e.size ?? "");
  return `${e.path}\0${n}`;
}
function Ld(e) {
  const t = e.apiBase !== void 0 && typeof e.authHeaders == "function" && typeof IntersectionObserver < "u" && typeof fetch == "function", n = m({}), r = [], a = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), v = [], p = /* @__PURE__ */ new Set(), h = /* @__PURE__ */ new WeakMap();
  let b = 0, y = null;
  const A = /* @__PURE__ */ new Map();
  function D(M) {
    const z = Ku({ apiBase: e.apiBase }).manager, T = z.includes("?") ? "&" : "?", Y = new URLSearchParams({ q: "preview", action: "preview", path: M });
    return `${z}${T}${Y.toString()}`;
  }
  function C(M, z) {
    if (r.length >= O_) {
      const T = r.shift();
      if (T) {
        const Y = { ...n.value };
        delete Y[T], n.value = Y;
      }
    }
    r.push(M), n.value = { ...n.value, [M]: z };
  }
  async function B(M) {
    const z = M.body;
    if (!z) {
      const N = new Uint8Array(await M.arrayBuffer());
      return { bytes: N.slice(0, Ia), truncated: N.length > Ia };
    }
    const T = z.getReader(), Y = [];
    let O = 0;
    try {
      for (; O < Ia; ) {
        const { done: N, value: P } = await T.read();
        if (N) break;
        P && P.length && (Y.push(P), O += P.length);
      }
    } finally {
      try {
        await T.cancel();
      } catch {
      }
    }
    const J = new Uint8Array(Math.min(O, Ia));
    let G = 0;
    for (const N of Y) {
      if (G >= J.length) break;
      J.set(N.subarray(0, J.length - G), G), G += N.length;
    }
    return { bytes: J, truncated: O >= Ia };
  }
  async function I(M, z) {
    const T = go(M), Y = new AbortController();
    p.add(Y);
    try {
      const O = e.authHeaders ? await e.authHeaders() : {}, J = await fetch(D(M.path), {
        headers: { ...O, Accept: "*/*", Range: `bytes=0-${Ia - 1}` },
        credentials: e.credentials,
        signal: Y.signal
      });
      if (!J.ok && J.status !== 206) throw new Error(String(J.status));
      const { bytes: G, truncated: N } = await B(J);
      Y.abort();
      const P = (M.extension || "").trim().toLowerCase(), le = V_(G, z, P, N);
      if (!le) {
        a.add(T);
        return;
      }
      C(T, le);
    } catch {
      a.add(T);
    } finally {
      p.delete(Y);
    }
  }
  function U() {
    for (; b < A_ && v.length > 0; ) {
      const M = v.shift(), z = yi(M);
      u.delete(go(M)), z && (b++, I(M, z).finally(() => {
        b--, U();
      }));
    }
  }
  function x(M) {
    const z = go(M);
    n.value[z] || a.has(z) || u.has(z) || (u.add(z), v.push(M), U());
  }
  function E() {
    return t ? (y || (y = new IntersectionObserver(
      (M) => {
        for (const z of M) {
          if (!z.isIntersecting) continue;
          const T = A.get(z.target);
          y == null || y.unobserve(z.target), A.delete(z.target), T && x(T);
        }
      },
      { rootMargin: "150px" }
    )), y) : null;
  }
  function $(M) {
    var z;
    return !t || (z = e.disabled) != null && z.call(e) ? null : yi(M);
  }
  return {
    enabled: t,
    kindFor: $,
    get(M) {
      return t ? n.value[go(M)] ?? null : null;
    },
    bind(M, z) {
      if (!M || !$(z)) return;
      const T = go(z);
      if (h.get(M) === T || (h.set(M, T), n.value[T] || a.has(T))) return;
      const Y = E();
      Y && (A.set(M, z), Y.observe(M));
    },
    stats: () => ({
      loaded: r.length,
      inflight: b,
      queued: v.length,
      failed: a.size
    }),
    dispose() {
      y == null || y.disconnect(), y = null, A.clear();
      for (const M of p) M.abort();
      p.clear(), v.length = 0, u.clear();
    }
  };
}
function j_(e, t) {
  if (!e) return { id: "none", label: t.t("group.no_date") };
  const n = /* @__PURE__ */ new Date(), r = Ic(n), a = Ic(e);
  if (a >= r) return { id: "today", label: t.t("group.today") };
  if (a === r - 1) return { id: "yesterday", label: t.t("group.yesterday") };
  if (a > r - 7) return { id: "week", label: t.t("group.this_week") };
  const u = t.zonedYearMonth(e);
  return u === t.zonedYearMonth(n) ? { id: "month", label: t.t("group.this_month") } : { id: `m-${u}`, label: t.formatMonthYear(e) };
}
function qi(e, t) {
  return t !== "relevance" && e === "modified";
}
function Gi(e, t) {
  var a;
  const n = [];
  if (!t.active)
    n.push({ id: "all", label: null, items: [...e] });
  else {
    let u = null;
    for (const v of e) {
      const p = ((a = t.aside) == null ? void 0 : a.call(t, v)) ?? null, h = p ? { id: p.id, label: p.label ?? null } : j_(t.dateOf(v), t.labels);
      (!u || u.id !== h.id) && (u = { id: h.id, label: h.label, items: [] }, n.push(u)), u.items.push(v);
    }
  }
  const r = /* @__PURE__ */ new Map();
  for (const u of n)
    u.label && u.items.length && r.set(u.items[0], u.label);
  return {
    active: t.active,
    runs: n,
    headingBefore: (u) => r.get(u) ?? null
  };
}
async function Dd(e, t, n = {}) {
  const r = {
    "Content-Type": "application/json",
    ...await (n.authHeaders ?? (() => ({})))()
  }, a = n.apiBase ?? "", u = await fetch(`${a}/api/files/manager/star`, {
    method: "POST",
    headers: r,
    credentials: n.authCredentials ?? "same-origin",
    body: JSON.stringify({ node_id: e, starred: t })
  });
  if (!u.ok) throw new Error(`star toggle failed: ${u.status}`);
}
const Y_ = ["aria-pressed", "title", "aria-label"], W_ = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  "aria-hidden": "true"
}, q_ = ["fill"], G_ = {
  key: 0,
  class: "filex-star-label"
}, er = /* @__PURE__ */ qe({
  __name: "StarButton",
  props: {
    starred: { type: Boolean },
    nodeId: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    compact: { type: Boolean },
    card: { type: Boolean },
    locale: {}
  },
  emits: ["change", "error"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = m(n.starred);
    He(() => n.starred, (h) => {
      a.value = h;
    });
    const { t: u } = tt(() => cn(n.locale)), v = k(() => u(a.value ? "ctx.unstar" : "ctx.star"));
    async function p() {
      const h = !a.value;
      a.value = h;
      try {
        await Dd(n.nodeId, h, {
          apiBase: n.apiBase,
          authHeaders: n.authHeaders,
          authCredentials: n.authCredentials
        }), r("change", h);
      } catch (b) {
        a.value = !h, r("error", b instanceof Error ? b.message : String(b));
      }
    }
    return (h, b) => (c(), d("button", {
      type: "button",
      class: we(["filex-star-btn", { "is-starred": a.value, "is-compact": e.compact, "is-card": e.card }]),
      "aria-pressed": a.value,
      title: v.value,
      "aria-label": v.value,
      "data-testid": "star-toggle",
      onClick: Re(p, ["stop"])
    }, [
      (c(), d("svg", W_, [
        o("path", {
          fill: a.value ? "currentColor" : "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linejoin": "round",
          d: "M12 2.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 18.27l-6.18 3.23L7 14.63 2 9.76l6.91-1z"
        }, null, 8, q_)
      ])),
      e.compact ? g("", !0) : (c(), d("span", G_, f(v.value), 1))
    ], 10, Y_));
  }
});
function Vs(e) {
  const t = [];
  if (!e) return t;
  const n = /«([^«»]*)»/g;
  let r = 0, a;
  for (; (a = n.exec(e)) !== null; )
    a.index > r && t.push({ text: e.slice(r, a.index), match: !1 }), a[1] && t.push({ text: a[1], match: !0 }), r = a.index + a[0].length;
  return r < e.length && t.push({ text: e.slice(r), match: !1 }), t;
}
function Od(e) {
  return e === "content" || e === "both";
}
function Xi(e, t, n) {
  const r = e.dataTransfer;
  if (!(!r || typeof document > "u" || typeof r.setDragImage != "function"))
    try {
      const a = document.createElement("div");
      a.className = "fe-dragghost";
      const u = document.createElement("span");
      if (u.className = "fe-dragghost__name", u.textContent = t, a.appendChild(u), n > 1) {
        const v = document.createElement("span");
        v.className = "fe-dragghost__badge", v.textContent = String(n), a.appendChild(v);
      }
      a.style.position = "fixed", a.style.top = "-1000px", a.style.left = "-1000px", document.body.appendChild(a), r.setDragImage(a, 14, 14), setTimeout(() => a.remove(), 0);
    } catch {
    }
}
const X_ = ["aria-label", "aria-busy"], J_ = {
  key: 0,
  class: "fe-grid__heading",
  "aria-hidden": "true"
}, Z_ = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], Q_ = {
  key: 0,
  class: "fe-fprev__tint"
}, ew = ["innerHTML"], tw = ["src", "alt"], nw = ["aria-label", "innerHTML"], aw = ["innerHTML"], ow = {
  key: 4,
  class: "fe-thumb__play",
  "aria-hidden": "true"
}, sw = { class: "fe-grid__foot" }, rw = ["aria-label", "innerHTML"], iw = ["innerHTML"], lw = ["onClick"], cw = { class: "fe-grid__main" }, uw = ["title"], dw = ["title", "aria-label"], fw = { class: "fe-grid__meta" }, pw = ["title"], vw = ["title"], hw = {
  key: 0,
  class: "fe-grid__mark"
}, mw = ["aria-label", "title", "onClick"], yw = {
  key: 0,
  class: "fe-grid__empty"
}, bi = /* @__PURE__ */ qe({
  __name: "GridView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    keepBadgeFor: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    sections: { type: Boolean },
    order: {},
    e2eActive: { type: Boolean },
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change", "display-order"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a, formatSize: u, nodeDisplayName: v, formatDate: p, formatMonthYear: h, zonedYearMonth: b, toDate: y } = tt(() => n.locale), A = k(() => [...n.files].sort(pi));
    He(
      A,
      (K) => r("display-order", K),
      { immediate: !0 }
    );
    const D = k(() => {
      var K;
      return ((K = A.value.find((Z) => Z.type === "dir")) == null ? void 0 : K.path) ?? null;
    }), C = k(() => {
      var K;
      return ((K = A.value.find((Z) => Z.type !== "dir")) == null ? void 0 : K.path) ?? null;
    }), B = Ao(), I = k(
      () => Gi(A.value, {
        active: qi(B.key.value, n.order),
        dateOf: (K) => y(K.last_modified),
        /* Folders keep their own run at the top — the same rule the list follows,
         * and the reason "folders before files" survives a date sort. Here the run
         * is the one that already had a name. */
        aside: (K) => K.type === "dir" ? { id: "dirs", label: n.sections ? a("drive.section.folders") : null } : null,
        labels: { t: a, formatMonthYear: h, zonedYearMonth: b }
      })
    );
    function U(K) {
      return I.value.active ? I.value.headingBefore(K) : n.sections ? K.path === D.value ? a("drive.section.folders") : K.path === C.value ? a("drive.section.files") : null : null;
    }
    function x(K) {
      return n.thumbSrc ? n.thumbSrc(K) : K.thumb_url ?? null;
    }
    const E = Ld({
      // Read once: the explorer's `config.apiBase` is fixed for the life of a
      // mounted panel, and `enabled` has to be answerable at construction.
      apiBase: n.apiBase,
      // Wrapped rather than passed, so a parent that re-creates its arrow on each
      // render is still called through the CURRENT prop. ⚠ The builder is async;
      // `createFilePreviews` awaits it (see the note there — a Promise spread into
      // a headers object sends no Authorization and 401s in silence).
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    it(() => E.dispose());
    function $(K) {
      return E.kindFor(K);
    }
    function M(K) {
      const Z = E.get(K);
      return Z ? [Z] : [];
    }
    function z(K, Z) {
      E.bind(K instanceof Element ? K : null, Z);
    }
    function T(K) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof K.id == "number" && K.type === "file";
    }
    function Y(K) {
      return n.selected.has(K.path);
    }
    function O(K, Z) {
      r("click-card", K, Vi(Z));
    }
    function J(K, Z) {
      r("click-card", K, Ui(Z, Q.isTap(Z)));
    }
    function G(K) {
      r("dbl-card", K);
    }
    function N(K, Z) {
      Z.preventDefault(), Z.stopPropagation(), r("context-card", K, Z);
    }
    function P(K, Z) {
      N(K, Z);
    }
    function le(K, Z) {
      Xi(
        Z,
        v(K),
        n.selected.has(K.path) ? n.selected.size : 1
      ), r("item-drag-start", K, Z);
    }
    const ve = m(null);
    function he(K, Z) {
      K.type === "dir" && vn(Z) && (Z.preventDefault(), Z.stopPropagation(), Z.dataTransfer && (Z.dataTransfer.dropEffect = "move"), ve.value = K.path);
    }
    function oe(K) {
      ve.value === K.path && (ve.value = null);
    }
    function ue(K, Z) {
      ve.value = null, K.type === "dir" && vn(Z) && (Z.preventDefault(), Z.stopPropagation(), r("item-drop-into", K, Z));
    }
    const Q = ji(
      (K, Z) => r("context-card", K, { ...Z, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (K) => r("click-card", K, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function pe(K) {
      return p(K);
    }
    function re(K) {
      if (K.type === "dir") return a("node.folder");
      const Z = pe(K.last_modified), W = u(K.size);
      return Z ? `${W} • ${Z}` : W;
    }
    function S(K) {
      return K === "kept" ? "✓" : K === "syncing" ? "⟳" : K === "partial" ? "◐" : "☁";
    }
    function w(K) {
      const Z = K.snippet;
      return typeof Z == "string" ? Z : "";
    }
    function j(K) {
      return Vs(K).map((Z) => Z.text).join("");
    }
    return (K, Z) => (c(), d("div", {
      class: we(["fe-grid", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0 }]),
      role: "listbox",
      "aria-multiselectable": "true",
      "aria-label": s(a)("grid.aria"),
      "aria-busy": e.loading ? "true" : void 0
    }, [
      (c(!0), d(ae, null, Te(A.value, (W) => {
        var $e, Se;
        return c(), d(ae, {
          key: W.path
        }, [
          U(W) ? (c(), d("p", J_, f(U(W)), 1)) : g("", !0),
          o("div", {
            class: we(["fe-grid__card", {
              "fe-grid__card--folder": W.type === "dir",
              "fe-grid__card--file": W.type !== "dir",
              "is-selected": Y(W),
              "is-dir": W.type === "dir",
              "is-trash": W.trashed,
              "is-clipped": ($e = e.clipped) == null ? void 0 : $e.has(W.path),
              "is-droptarget": ve.value === W.path
            }]),
            tabindex: "0",
            role: "option",
            "aria-selected": Y(W) ? "true" : "false",
            "aria-label": s(v)(W),
            "data-fe-path": W.path,
            draggable: "true",
            onClick: (ze) => J(W, ze),
            onDblclick: (ze) => G(W),
            onContextmenu: (ze) => N(W, ze),
            onDragstart: (ze) => le(W, ze),
            onDragover: (ze) => he(W, ze),
            onDragleave: (ze) => oe(W),
            onDrop: (ze) => ue(W, ze),
            onTouchstartPassive: (ze) => s(Q).onTouchStart(W, ze),
            onTouchend: Z[4] || (Z[4] = //@ts-ignore
            (...ze) => s(Q).onTouchEnd && s(Q).onTouchEnd(...ze)),
            onTouchmovePassive: Z[5] || (Z[5] = //@ts-ignore
            (...ze) => s(Q).onTouchMove && s(Q).onTouchMove(...ze))
          }, [
            W.type !== "dir" ? (c(), d("div", {
              key: 0,
              class: "fe-grid__thumb",
              ref_for: !0,
              ref: (ze) => z(ze, W)
            }, [
              $(W) ? (c(), d(ae, { key: 0 }, [
                (c(!0), d(ae, null, Te(M(W), (ze) => (c(), d("div", {
                  key: "fprev",
                  class: we(["fe-fprev", "fe-fprev--" + ze.kind]),
                  style: Ct(ze.kind === "table" ? { "--fprev-cols": String(ze.cols) } : void 0),
                  "aria-hidden": "true"
                }, [
                  ze.kind === "table" ? (c(!0), d(ae, { key: 0 }, Te(ze.rows, (Ne, be) => (c(), d(ae, { key: be }, [
                    (c(!0), d(ae, null, Te(Ne, (De, ie) => (c(), d("span", {
                      key: ie,
                      class: we(["fe-fprev__cell", { "is-head": be === 0 }])
                    }, f(De), 3))), 128))
                  ], 64))), 128)) : (c(!0), d(ae, { key: 1 }, Te(ze.lines, (Ne, be) => (c(), d("div", {
                    key: be,
                    class: "fe-fprev__line"
                  }, [
                    Ne.tint ? (c(), d("span", Q_, f(Ne.indent) + f(Ne.tint), 1)) : g("", !0),
                    Je(f(Ne.text), 1)
                  ]))), 128))
                ], 6))), 128)),
                M(W).length === 0 ? (c(), d("span", {
                  key: 0,
                  class: "fe-grid__icon fe-grid__icon--svg",
                  innerHTML: s(fn)(W)
                }, null, 8, ew)) : g("", !0)
              ], 64)) : x(W) ? (c(), d("img", {
                key: 1,
                src: x(W),
                alt: W.basename,
                class: we({
                  "fe-thumb--page": s(Wi)(W)
                  /* gorunum:v1-preview — crop a page from its TOP */
                }),
                loading: "lazy",
                draggable: "false"
              }, null, 10, tw)) : s(Ls)(W) ? (c(), d("span", {
                key: 2,
                class: "fe-grid__icon fe-grid__icon--svg",
                role: "img",
                "aria-label": s(a)("e2e.badge"),
                innerHTML: s(Ds)()
              }, null, 8, nw)) : (c(), d("span", {
                key: 3,
                class: "fe-grid__icon fe-grid__icon--svg",
                innerHTML: s(fn)(W)
              }, null, 8, aw)),
              !$(W) && x(W) && s(Pd)(W) ? (c(), d("span", ow)) : g("", !0),
              T(W) ? (c(), d("div", {
                key: 5,
                class: "fe-grid__star",
                onClick: Z[0] || (Z[0] = Re(() => {
                }, ["stop"])),
                onDblclick: Z[1] || (Z[1] = Re(() => {
                }, ["stop"]))
              }, [
                Ge(er, {
                  starred: !!((Se = e.starredIds) != null && Se.has(W.id)),
                  "node-id": W.id,
                  "api-base": e.apiBase,
                  "auth-headers": e.authHeaders,
                  "auth-credentials": e.authCredentials,
                  locale: e.locale,
                  compact: "",
                  card: "",
                  onChange: (ze) => r("star-change", W, ze)
                }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
              ], 32)) : g("", !0)
            ], 512)) : g("", !0),
            o("div", sw, [
              o("span", {
                class: we(["fe-grid__lead", { "fe-grid__lead--pick": e.selectable }])
              }, [
                s(Ls)(W) ? (c(), d("span", {
                  key: 0,
                  class: "fe-grid__tile fe-grid__tile--svg",
                  role: "img",
                  "aria-label": s(a)("e2e.badge"),
                  innerHTML: s(Ds)()
                }, null, 8, rw)) : (c(), d("span", {
                  key: 1,
                  class: "fe-grid__tile fe-grid__tile--svg",
                  innerHTML: s(fn)(W)
                }, null, 8, iw)),
                e.selectable ? (c(), d("span", {
                  key: 2,
                  class: "fe-item-check",
                  "data-fe-control": "",
                  onClick: Re((ze) => O(W, ze), ["stop"]),
                  onDblclick: Z[2] || (Z[2] = Re(() => {
                  }, ["stop"]))
                }, [
                  Ge(Yi, {
                    on: Y(W),
                    label: s(v)(W)
                  }, null, 8, ["on", "label"])
                ], 40, lw)) : g("", !0)
              ], 2),
              o("div", cw, [
                o("div", {
                  class: "fe-grid__label",
                  title: W.basename
                }, [
                  Je(f(s(v)(W)) + " ", 1),
                  e.keepBadgeFor && e.keepBadgeFor(W) ? (c(), d("span", {
                    key: 0,
                    class: we(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(W)]),
                    title: s(a)("keep.badge_" + e.keepBadgeFor(W)),
                    role: "img",
                    "aria-label": s(a)("keep.badge_" + e.keepBadgeFor(W))
                  }, f(S(e.keepBadgeFor(W))), 11, dw)) : g("", !0)
                ], 8, uw),
                o("div", fw, f(re(W)), 1),
                e.showParentPath && s(ya)(W.path) ? (c(), d("div", {
                  key: 0,
                  class: "fe-grid__parent",
                  title: s(ya)(W.path)
                }, f(s(ya)(W.path)), 9, pw)) : g("", !0),
                w(W) ? (c(), d("div", {
                  key: 1,
                  class: "fe-grid__snippet",
                  title: j(w(W))
                }, [
                  (c(!0), d(ae, null, Te(s(Vs)(w(W)), (ze, Ne) => (c(), d(ae, { key: Ne }, [
                    ze.match ? (c(), d("mark", hw, f(ze.text), 1)) : (c(), d(ae, { key: 1 }, [
                      Je(f(ze.text), 1)
                    ], 64))
                  ], 64))), 128))
                ], 8, vw)) : g("", !0)
              ]),
              o("button", {
                type: "button",
                class: "fe-grid__menu",
                "aria-label": s(a)("toolbar.more"),
                title: s(a)("toolbar.more"),
                onClick: Re((ze) => P(W, ze), ["stop"]),
                onDblclick: Z[3] || (Z[3] = Re(() => {
                }, ["stop"]))
              }, "⋮", 40, mw)
            ])
          ], 42, Z_)
        ], 64);
      }), 128)),
      !e.loading && e.files.length === 0 ? (c(), d("div", yw, f(s(a)("empty.folder")), 1)) : g("", !0)
    ], 10, X_));
  }
}), bw = {
  class: "fe-home",
  "data-testid": "home-view"
}, gw = {
  class: "fe-home__section",
  "data-testid": "home-storages"
}, kw = { class: "fe-home__heading" }, _w = {
  key: 0,
  class: "fe-home__storages"
}, ww = ["data-storage", "title", "onClick"], $w = ["innerHTML"], xw = { class: "fe-home__storage-main" }, Sw = { class: "fe-home__storage-label" }, Cw = { class: "fe-home__storage-meta" }, Tw = {
  key: 1,
  class: "fe-home__nomatch",
  "data-testid": "home-storages-nomatch"
}, Mw = {
  key: 2,
  class: "fe-state fe-home__state",
  "data-testid": "home-storages-empty"
}, Ew = { class: "fe-state__title" }, zw = { class: "fe-state__hint" }, Aw = {
  class: "fe-home__section",
  "data-testid": "home-recent"
}, Pw = { class: "fe-home__heading" }, Lw = {
  key: 1,
  class: "fe-home__loading"
}, Dw = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-recent-nomatch"
}, Ow = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-recent-empty"
}, Bw = { class: "fe-state__title" }, Iw = { class: "fe-state__hint" }, Hw = {
  class: "fe-home__section",
  "data-testid": "home-starred"
}, Fw = { class: "fe-home__heading" }, Nw = {
  key: 1,
  class: "fe-home__loading"
}, Kw = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-starred-nomatch"
}, Rw = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-starred-empty"
}, Uw = { class: "fe-state__title" }, Vw = { class: "fe-state__hint" }, jw = /* @__PURE__ */ qe({
  __name: "HomeView",
  props: {
    storages: {},
    recent: {},
    starred: {},
    loading: { type: Boolean },
    locale: {},
    nameFilter: {},
    thumbSrc: { type: Function }
  },
  emits: ["open-storage", "open-node", "context-node"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a, formatSize: u } = tt(() => n.locale), v = k(() => (n.nameFilter ?? "").trim()), p = k(() => v.value !== ""), h = k(
      () => n.storages.filter((x) => Ss(x.label || x.name, v.value))
    ), b = k(
      () => n.recent.filter((x) => Ss(x.basename || "", v.value))
    ), y = k(
      () => n.starred.filter((x) => Ss(x.basename || "", v.value))
    );
    function A(x, E) {
      return p.value && x > 0 && E === 0;
    }
    const D = /* @__PURE__ */ new Set(), C = fn({ type: "dir", mime_type: "inode/storage" });
    function B(x) {
      const E = typeof x.usedBytes == "number" && x.usedBytes >= 0 ? a("drive.storage.used_unlimited", { used: u(x.usedBytes) }) : a("conn.guide.storage");
      return x.readOnly ? `${E} · ${a("sidenav.storage.readOnly")}` : E;
    }
    const I = m({ path: "", at: 0 });
    function U(x) {
      const E = Date.now();
      x.path === I.value.path && E - I.value.at < 700 || (I.value = { path: x.path, at: E }, r("open-node", x));
    }
    return (x, E) => (c(), d("div", bw, [
      o("section", gw, [
        o("h2", kw, f(s(a)("sidenav.storages")), 1),
        h.value.length ? (c(), d("div", _w, [
          (c(!0), d(ae, null, Te(h.value, ($) => (c(), d("button", {
            key: $.name,
            type: "button",
            class: "fe-home__storage",
            "data-testid": "home-storage-card",
            "data-storage": $.name,
            title: $.label || $.name,
            onClick: (M) => r("open-storage", $.name)
          }, [
            o("span", {
              class: "fe-home__storage-tile",
              "aria-hidden": "true",
              innerHTML: s(C)
            }, null, 8, $w),
            o("span", xw, [
              o("span", Sw, f($.label || $.name), 1),
              o("span", Cw, f(B($)), 1)
            ])
          ], 8, ww))), 128))
        ])) : A(e.storages.length, h.value.length) ? (c(), d("p", Tw, f(s(a)("filter.empty.title")), 1)) : (c(), d("div", Mw, [
          E[2] || (E[2] = o("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            o("rect", {
              x: "26",
              y: "30",
              width: "68",
              height: "18",
              rx: "5"
            }),
            o("rect", {
              x: "26",
              y: "54",
              width: "68",
              height: "18",
              rx: "5"
            }),
            o("path", { d: "M38 39h.01M38 63h.01" })
          ], -1)),
          o("p", Ew, f(s(a)("home.storages.empty")), 1),
          o("p", zw, f(s(a)("home.storages.hint")), 1)
        ]))
      ]),
      o("section", Aw, [
        o("h2", Pw, f(s(a)("sidenav.recent")), 1),
        b.value.length ? (c(), et(bi, {
          key: 0,
          files: b.value,
          selected: s(D),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: U,
          onDblCard: U,
          onContextCard: E[0] || (E[0] = ($, M) => r("context-node", $, M))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (c(), d("p", Lw, f(s(a)("loading")), 1)) : A(e.recent.length, b.value.length) ? (c(), d("p", Dw, f(s(a)("filter.empty.title")), 1)) : (c(), d("div", Ow, [
          E[3] || (E[3] = o("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            o("circle", {
              cx: "60",
              cy: "50",
              r: "28"
            }),
            o("path", { d: "M60 32v18l12 8" })
          ], -1)),
          o("p", Bw, f(s(a)("empty.recent.title")), 1),
          o("p", Iw, f(s(a)("empty.recent.hint")), 1)
        ]))
      ]),
      o("section", Hw, [
        o("h2", Fw, f(s(a)("sidenav.starred")), 1),
        y.value.length ? (c(), et(bi, {
          key: 0,
          files: y.value,
          selected: s(D),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: U,
          onDblCard: U,
          onContextCard: E[1] || (E[1] = ($, M) => r("context-node", $, M))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (c(), d("p", Nw, f(s(a)("loading")), 1)) : A(e.starred.length, y.value.length) ? (c(), d("p", Kw, f(s(a)("filter.empty.title")), 1)) : (c(), d("div", Rw, [
          E[4] || (E[4] = o("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            o("path", { d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z" })
          ], -1)),
          o("p", Uw, f(s(a)("empty.starred.title")), 1),
          o("p", Vw, f(s(a)("empty.starred.hint")), 1)
        ]))
      ])
    ]));
  }
});
function wa(e) {
  if (e.apiBase != null) return e.apiBase.replace(/\/+$/, "");
  const t = e.endpoint ?? "", n = t.indexOf("/api/");
  return n >= 0 ? t.slice(0, n) : "";
}
function Yw(e, t) {
  const n = String(t ?? "").trim();
  if (/^https?:\/\/[^/]/i.test(n)) return n.replace(/\/+$/, "");
  const r = wa(e);
  if (/^https?:\/\//i.test(r))
    try {
      return new URL(r).origin;
    } catch {
      return r;
    }
  return typeof window < "u" && window.location ? window.location.origin : r;
}
function Ww(e) {
  const t = Ya(e), n = wa(e), r = (G) => `${n}${G}`, a = wn([]), u = wn([]), v = wn([]), p = m(null), h = m(null), b = m(!1), y = m(!1), A = m(null), D = m(null), C = m(null);
  function B(G) {
    return G == null ? void 0 : G.status;
  }
  function I(G) {
    const N = G;
    return (N == null ? void 0 : N.message) || String(G);
  }
  async function U() {
    b.value = !0, A.value = null;
    try {
      const G = t.capabilities().then((N) => {
        const P = N == null ? void 0 : N.public_url;
        h.value = typeof P == "string" && P ? P : null;
      }).catch(() => {
        h.value = null;
      });
      try {
        const N = await t.jsonFetch(r("/api/auth/me"));
        p.value = (N == null ? void 0 : N.user) ?? null;
      } catch (N) {
        B(N) === 401 && (D.value = !1, C.value = "anonymous"), p.value = null;
      }
      try {
        a.value = await t.jsonFetch(
          r("/api/admin/storage-drivers")
        ), D.value = !0, C.value = null;
      } catch (N) {
        a.value = [], D.value = !1;
        const P = B(N);
        P === 403 ? C.value = "none" : P === 401 ? C.value = "anonymous" : (C.value = "unreachable", A.value = I(N));
      }
      if (D.value)
        try {
          const N = await t.jsonFetch(r("/api/admin/storages"));
          u.value = Array.isArray(N) ? N : [], v.value = u.value.map((P) => P.name);
        } catch (N) {
          A.value = I(N);
        }
      else
        try {
          const N = await t.index("");
          v.value = Array.isArray(N == null ? void 0 : N.storages) ? N.storages : [];
        } catch {
          v.value = [];
        }
      await G, y.value = !0;
    } finally {
      b.value = !1;
    }
  }
  async function x(G) {
    const N = await t.jsonFetch(r("/api/admin/storages"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(G)
    });
    return await U(), N;
  }
  async function E(G, N) {
    const P = await t.jsonFetch(r(`/api/admin/storages/${G}`), {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(N)
    });
    return await U(), P;
  }
  async function $(G) {
    await t.jsonFetch(r(`/api/admin/storages/${G}`), { method: "DELETE" }), await U();
  }
  async function M(G) {
    try {
      return await t.jsonFetch(r("/api/admin/storages/test"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(G)
      });
    } catch (N) {
      return { ok: !1, error: I(N) };
    }
  }
  function z(G) {
    return a.value.find((N) => N.driver === G);
  }
  function T(G) {
    var N;
    return ((N = z(G)) == null ? void 0 : N.fields) ?? [];
  }
  function Y(G) {
    const N = {};
    for (const P of T(G))
      P.default !== void 0 && P.default !== null && (N[P.key] = P.default);
    return N;
  }
  function O(G, N) {
    return T(G).filter((P) => {
      if (!P.required || P.default !== void 0) return !1;
      for (const le of [P.key, ...P.aliases ?? []]) {
        const ve = N[le];
        if (ve != null && !(typeof ve == "string" && ve.trim() === ""))
          return !1;
      }
      return !0;
    });
  }
  const J = k(() => a.value.map((G) => G.driver));
  return {
    // state
    drivers: a,
    driverNames: J,
    storages: u,
    visible: v,
    me: p,
    publicUrl: h,
    loading: b,
    loaded: y,
    error: A,
    canManage: D,
    denial: C,
    // actions
    load: U,
    createStorage: x,
    updateStorage: E,
    deleteStorage: $,
    testStorage: M,
    // descriptor helpers
    descriptor: z,
    fields: T,
    defaults: Y,
    missingRequired: O
  };
}
function ka(e) {
  try {
    return new URL(e).host;
  } catch {
    return e.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
  }
}
function Bd(e) {
  return /^http:\/\//i.test(e);
}
function Ji(e, t) {
  return e.user || t("conn.guide.userPlaceholder");
}
const qw = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), r = `${n}/dav/`, a = e.storage ? `${n}/dav/${e.storage}/` : r, u = Ji(e, t), v = t("conn.guide.secretPlaceholder"), p = [
    { label: t("conn.guide.fact.url"), value: a, hint: e.storage ? t("conn.guide.fact.urlStorageHint", { storage: e.storage }) : t("conn.guide.fact.urlRootHint") },
    { label: t("conn.guide.fact.user"), value: u, hint: t("conn.guide.webdav.userHint") },
    { label: t("conn.guide.fact.password"), value: v, hint: t("conn.guide.webdav.passwordHint"), placeholderOnly: !0 }
  ], h = [
    {
      id: "windows",
      name: "Windows Explorer",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.win.s1"),
            t("conn.guide.webdav.win.s2", { url: a }),
            t("conn.guide.webdav.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.cmdCaption"),
          code: `net use Z: "${a}" /user:${u} ${v} /persistent:yes`
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.win.limits")
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.regCaption"),
          code: [
            'reg add "HKLM\\SYSTEM\\CurrentControlSet\\Services\\WebClient\\Parameters" /v FileSizeLimitInBytes /t REG_DWORD /d 4294967295 /f',
            'reg add "HKLM\\SYSTEM\\CurrentControlSet\\Services\\WebClient\\Parameters" /v FileAttributesLimitInBytes /t REG_DWORD /d 20000000 /f',
            "net stop webclient && net start webclient"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.webdav.win.https") },
        { kind: "note", text: t("conn.guide.webdav.win.persist") },
        { kind: "note", text: t("conn.guide.webdav.win.service") }
      ]
    },
    {
      id: "macos",
      name: "macOS Finder",
      platform: "macos",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.mac.s1"),
            t("conn.guide.webdav.mac.s2", { url: a }),
            t("conn.guide.webdav.mac.s3")
          ]
        },
        { kind: "note", text: t("conn.guide.webdav.mac.note") }
      ]
    },
    {
      id: "linux",
      name: "Linux (davfs2 / GNOME / KDE)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.linux.mountCaption"),
          code: [
            `sudo mount -t davfs ${a} /mnt/filex`,
            "",
            `# ${t("conn.guide.webdav.linux.gvfsComment")}`,
            `gio mount ${a.replace(/^https:/i, "davs:").replace(/^http:/i, "dav:")}`
          ].join(`
`)
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.linux.locks")
        },
        {
          kind: "code",
          caption: "/etc/davfs2/davfs2.conf",
          code: "use_locks 0"
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.obscureCaption"),
          code: `rclone obscure "${v}"`
        },
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = webdav",
            `url = ${n}/dav`,
            "vendor = other",
            `user = ${u}`,
            `pass = ${t("conn.guide.webdav.rclone.passPlaceholder")}`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            e.storage ? `rclone lsl filex:${e.storage}` : "rclone lsl filex:<storage>",
            e.storage ? `rclone copy ./local filex:${e.storage}/backup` : "rclone copy ./local filex:<storage>/backup",
            "rclone mount filex: /mnt/filex"
          ].join(`
`)
        }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.duck.s1"),
            t("conn.guide.webdav.duck.s2", { host: ka(n) }),
            t("conn.guide.webdav.duck.s3", { path: e.storage ? `/dav/${e.storage}/` : "/dav/" }),
            t("conn.guide.webdav.duck.s4", { user: u })
          ]
        }
      ]
    }
  ], b = [
    { kind: "note", text: t("conn.guide.webdav.note.delete") },
    { kind: "note", text: t("conn.guide.webdav.note.locks") },
    { kind: "note", text: t("conn.guide.webdav.note.permissions") }
  ];
  return Bd(n) && b.unshift({ kind: "warn", text: t("conn.guide.webdav.note.http") }), {
    id: "webdav",
    name: "WebDAV",
    summary: t("conn.guide.webdav.summary"),
    facts: p,
    clients: h,
    notes: b
  };
}, Gw = (e, t) => {
  const n = (e.s3Endpoint || `${e.origin.replace(/\/+$/, "")}/s3`).replace(/\/+$/, ""), r = e.storage || e.storages[0] || "<bucket>", a = e.s3AccessKeyID || t("conn.guide.s3.keyPlaceholder"), u = e.s3Secret || t("conn.guide.s3.secretPlaceholder"), v = e.s3PathStyle !== !1, p = ka(n), h = [
    { label: t("conn.guide.s3.fact.endpoint"), value: n, hint: t("conn.guide.s3.fact.endpointHint") },
    { label: t("conn.guide.s3.fact.bucket"), value: r, hint: t("conn.guide.s3.fact.bucketHint") },
    { label: t("conn.guide.s3.fact.key"), value: a, hint: t("conn.guide.s3.fact.keyHint") },
    {
      label: t("conn.guide.s3.fact.secret"),
      value: u,
      hint: t("conn.guide.s3.fact.secretHint"),
      // ⚠ Only real right after minting. filex stores the secret sealed and
      // cannot show it again, and a guide that printed something secret-shaped
      // would be teaching a value that authenticates as nothing.
      placeholderOnly: !e.s3Secret
    },
    { label: t("conn.guide.s3.fact.region"), value: "us-east-1", hint: t("conn.guide.s3.fact.regionHint") },
    {
      label: t("conn.guide.s3.fact.addressing"),
      value: t(v ? "conn.guide.s3.fact.pathStyle" : "conn.guide.s3.fact.virtualHosted"),
      hint: t(v ? "conn.guide.s3.fact.pathStyleHint" : "conn.guide.s3.fact.virtualHostedHint")
    }
  ], b = [
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = s3",
            "provider = Other",
            `endpoint = ${n}`,
            `access_key_id = ${a}`,
            `secret_access_key = ${u}`,
            "region = us-east-1",
            ...v ? ["force_path_style = true"] : []
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            `rclone copy ./local filex:${r}/backup -P`,
            `rclone sync ./local filex:${r}/backup`,
            `rclone mount filex:${r} /mnt/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.rclone.mtime") }
      ]
    },
    {
      id: "awscli",
      name: "AWS CLI",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.configureCaption"),
          code: [
            "aws configure set aws_access_key_id " + a,
            "aws configure set aws_secret_access_key " + u,
            "aws configure set region us-east-1"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.useCaption"),
          code: [
            `aws --endpoint-url ${n} s3 ls`,
            `aws --endpoint-url ${n} s3 cp ./file.pdf s3://${r}/file.pdf`,
            `aws --endpoint-url ${n} s3 sync ./local s3://${r}/backup`,
            `aws --endpoint-url ${n} s3 presign s3://${r}/file.pdf --expires-in 300`
          ].join(`
`)
        },
        ...v ? [
          {
            kind: "note",
            text: t("conn.guide.s3.aws.pathStyle")
          },
          {
            kind: "code",
            caption: "~/.aws/config",
            code: ["[default]", "s3 =", "    addressing_style = path"].join(`
`)
          }
        ] : []
      ]
    },
    {
      id: "restic",
      name: "restic",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.envCaption"),
          code: [
            `export AWS_ACCESS_KEY_ID=${a}`,
            `export AWS_SECRET_ACCESS_KEY=${u}`,
            `export RESTIC_REPOSITORY="s3:${n}/${r}/restic"`,
            "export RESTIC_PASSWORD=…"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.useCaption"),
          code: [
            `restic init${v ? " -o s3.bucket-lookup=path" : ""}`,
            `restic backup ~/Documents${v ? " -o s3.bucket-lookup=path" : ""}`,
            `restic check --read-data${v ? " -o s3.bucket-lookup=path" : ""}`,
            `restic forget --keep-daily 7 --prune${v ? " -o s3.bucket-lookup=path" : ""}`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.restic.verified") }
      ]
    },
    {
      id: "mc",
      name: "MinIO Client (mc)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.aliasCaption"),
          code: `mc alias set filex ${n} ${a} ${u} --api S3v4${v ? " --path on" : ""}`
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.useCaption"),
          code: [
            "mc ls filex",
            `mc cp ./file.pdf filex/${r}/file.pdf`,
            `mc mirror ./local filex/${r}/backup`,
            `mc du filex/${r}`
          ].join(`
`)
        }
      ]
    },
    {
      id: "s3fs",
      name: "s3fs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.credsCaption"),
          code: [
            `echo "${a}:${u}" > ~/.passwd-s3fs`,
            "chmod 600 ~/.passwd-s3fs"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.mountCaption"),
          code: [
            `s3fs ${r} /mnt/filex \\`,
            "  -o passwd_file=~/.passwd-s3fs \\",
            `  -o url=${n} \\`,
            ...v ? ["  -o use_path_request_style"] : []
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.s3fs.note") }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.s3.duck.s1"),
            t("conn.guide.s3.duck.s2", { host: p }),
            t("conn.guide.s3.duck.s3", { key: a }),
            t("conn.guide.s3.duck.s4")
          ]
        },
        ...v ? [{ kind: "warn", text: t("conn.guide.s3.duck.pathStyle") }] : []
      ]
    },
    {
      id: "sdk",
      name: "SDK (Go / Python / JS)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "boto3",
          code: [
            "import boto3",
            "s3 = boto3.client(",
            '    "s3",',
            `    endpoint_url="${n}",`,
            `    aws_access_key_id="${a}",`,
            `    aws_secret_access_key="${u}",`,
            '    region_name="us-east-1",',
            ...v ? [
              '    config=boto3.session.Config(s3={"addressing_style": "path"}),'
            ] : [],
            ")",
            `print([o["Key"] for o in s3.list_objects_v2(Bucket="${r}").get("Contents", [])])`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.sdk.note") }
      ]
    }
  ], y = [
    { kind: "note", text: t("conn.guide.s3.note.buckets") },
    { kind: "note", text: t("conn.guide.s3.note.permissions") },
    { kind: "note", text: t("conn.guide.s3.note.trash") },
    { kind: "note", text: t("conn.guide.s3.note.mtime") }
  ];
  return v && y.unshift({ kind: "warn", text: t("conn.guide.s3.note.pathStyle") }), Bd(n) && y.unshift({ kind: "warn", text: t("conn.guide.s3.note.http") }), {
    id: "s3",
    name: "S3",
    summary: t("conn.guide.s3.summary"),
    facts: h,
    clients: b,
    notes: y
  };
}, Xw = (e, t) => {
  const n = e.sftpHost || ka(e.origin), r = e.sftpPort || 2022, a = e.sftpLogin || Ji(e, t), u = e.storage ? `/${e.storage}` : "/<storage>", v = r === 22 ? "" : ` -P ${r}`, p = [
    { label: t("conn.guide.sftp.fact.host"), value: n, hint: t("conn.guide.sftp.fact.hostHint") },
    { label: t("conn.guide.sftp.fact.port"), value: String(r), hint: t("conn.guide.sftp.fact.portHint") },
    { label: t("conn.guide.fact.user"), value: a, hint: t("conn.guide.sftp.fact.userHint") },
    {
      label: t("conn.guide.sftp.fact.auth"),
      value: e.sftpHasKey ? t("conn.guide.sftp.fact.authKey") : t("conn.guide.sftp.fact.authPassword"),
      hint: t("conn.guide.sftp.fact.authHint"),
      placeholderOnly: !0
    },
    { label: t("conn.guide.sftp.fact.path"), value: u, hint: t("conn.guide.sftp.fact.pathHint") }
  ], h = [
    {
      id: "openssh",
      name: "OpenSSH (sftp / scp)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.openssh.connectCaption"),
          code: [
            `sftp${v} ${a}@${n}`,
            `scp${v} ./report.pdf ${a}@${n}:${u}/report.pdf`,
            `scp${v} ${a}@${n}:${u}/report.pdf ./`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "~/.ssh/config",
          code: [
            "Host filex",
            `  HostName ${n}`,
            `  Port ${r}`,
            `  User ${a}`,
            "  # IdentityFile ~/.ssh/id_ed25519"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.openssh.noShell") }
      ]
    },
    {
      id: "key",
      name: t("conn.guide.sftp.key.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.key.s1"),
            t("conn.guide.sftp.key.s2"),
            t("conn.guide.sftp.key.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.key.genCaption"),
          code: ['ssh-keygen -t ed25519 -C "filex"', "cat ~/.ssh/id_ed25519.pub"].join(`
`)
        },
        // ⚠ The one command people reach for, and the one that cannot work.
        { kind: "warn", text: t("conn.guide.sftp.key.noCopyId") }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.winscp.s1"),
            t("conn.guide.sftp.winscp.s2", { host: n, port: String(r) }),
            t("conn.guide.sftp.winscp.s3", { user: a }),
            t("conn.guide.sftp.winscp.s4")
          ]
        }
      ]
    },
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.filezilla.s1"),
            t("conn.guide.sftp.filezilla.s2", { host: `sftp://${n}`, port: String(r) }),
            t("conn.guide.sftp.filezilla.s3", { user: a })
          ]
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-sftp]",
            "type = sftp",
            `host = ${n}`,
            `port = ${r}`,
            `user = ${a}`,
            "key_file = ~/.ssh/id_ed25519",
            "# filex has no shell, so tell rclone not to look for one:",
            "shell_type = none",
            "md5sum_command = none",
            "sha1sum_command = none"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.rclone.useCaption"),
          code: [
            "rclone lsd filex-sftp:",
            `rclone copy ./local filex-sftp:${u}/backup -P`,
            `rclone sync ./local filex-sftp:${u}/backup`
          ].join(`
`)
        }
      ]
    },
    {
      id: "sshfs",
      name: "sshfs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.sshfs.mountCaption"),
          code: [
            `sshfs -p ${r} ${a}@${n}:${u} /mnt/filex`,
            "fusermount -u /mnt/filex"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.sshfs.note") }
      ]
    }
  ], b = [
    { kind: "note", text: t("conn.guide.sftp.note.storages") },
    { kind: "note", text: t("conn.guide.sftp.note.permissions") },
    { kind: "note", text: t("conn.guide.sftp.note.trash") },
    { kind: "note", text: t("conn.guide.sftp.note.totp") }
  ];
  return e.sftpEnabled === !1 && b.unshift({ kind: "warn", text: t("conn.guide.sftp.note.disabled") }), {
    id: "sftp",
    name: "SFTP",
    summary: t("conn.guide.sftp.summary"),
    facts: p,
    clients: h,
    notes: b
  };
}, Jw = (e, t) => {
  const n = e.ftpsHost || ka(e.origin), r = e.ftpsPort || 2121, a = e.sftpLogin || Ji(e, t), u = t("conn.guide.secretPlaceholder"), v = e.storage ? `/${e.storage}` : "/<storage>", p = e.ftpsPasvMin && e.ftpsPasvMax ? `${e.ftpsPasvMin}-${e.ftpsPasvMax}` : "30000-30100", h = [
    { label: t("conn.guide.ftps.fact.host"), value: n, hint: t("conn.guide.ftps.fact.hostHint") },
    { label: t("conn.guide.ftps.fact.port"), value: String(r), hint: t("conn.guide.ftps.fact.portHint") },
    { label: t("conn.guide.ftps.fact.mode"), value: t("conn.guide.ftps.fact.modeValue"), hint: t("conn.guide.ftps.fact.modeHint") },
    { label: t("conn.guide.fact.user"), value: a, hint: t("conn.guide.ftps.fact.userHint") },
    { label: t("conn.guide.fact.password"), value: u, hint: t("conn.guide.ftps.fact.passwordHint"), placeholderOnly: !0 },
    { label: t("conn.guide.ftps.fact.pasv"), value: p, hint: t("conn.guide.ftps.fact.pasvHint") }
  ], b = [
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.filezilla.s1"),
            t("conn.guide.ftps.filezilla.s2", { host: n, port: String(r) }),
            t("conn.guide.ftps.filezilla.s3", { user: a }),
            t("conn.guide.ftps.filezilla.s4")
          ]
        }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.winscp.s1"),
            t("conn.guide.ftps.winscp.s2", { host: n, port: String(r) }),
            t("conn.guide.ftps.winscp.s3", { user: a })
          ]
        }
      ]
    },
    {
      id: "curl",
      name: "curl",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.ftps.curl.caption"),
          code: [
            `curl --ssl-reqd --ftp-pasv --user ${a} \\`,
            `  -T ./report.pdf "ftp://${n}:${r}${v}/report.pdf"`,
            "",
            `curl --ssl-reqd --ftp-pasv --user ${a} \\`,
            `  -o ./report.pdf "ftp://${n}:${r}${v}/report.pdf"`
          ].join(`
`)
        },
        // ⚠ The flag that matters. Without it curl will happily fall back to
        // plaintext against a server that allows it — this one does not, but
        // the habit is what protects you against the ones that do.
        { kind: "note", text: t("conn.guide.ftps.curl.sslReqd") }
      ]
    },
    {
      id: "lftp",
      name: "lftp",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.lftprc",
          code: [
            "set ftp:ssl-force true",
            "set ftp:ssl-protect-data true",
            "set ftp:passive-mode true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.lftp.caption"),
          code: [
            `lftp -u ${a} ftp://${n}:${r}`,
            `# then: cd ${v}; put ./report.pdf; ls`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.ftps.lftp.protectData") }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-ftp]",
            "type = ftp",
            `host = ${n}`,
            `port = ${r}`,
            `user = ${a}`,
            '# rclone obscure "<your password>"',
            "pass = …",
            "explicit_tls = true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.rclone.useCaption"),
          code: [
            "rclone lsd filex-ftp:",
            `rclone copy ./local filex-ftp:${v}/backup -P`
          ].join(`
`)
        }
      ]
    },
    {
      id: "printer",
      name: t("conn.guide.ftps.printer.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.printer.s1", { host: n, port: String(r) }),
            t("conn.guide.ftps.printer.s2", { user: a }),
            t("conn.guide.ftps.printer.s3", { path: v }),
            t("conn.guide.ftps.printer.s4")
          ]
        },
        // ⚠ The honest warning: plenty of scan-to-FTP firmware cannot do TLS
        // at all, and this endpoint will not talk to it. Saying so beats an
        // afternoon spent debugging a device that was never going to connect.
        { kind: "warn", text: t("conn.guide.ftps.printer.noTLS") }
      ]
    }
  ], y = [
    { kind: "warn", text: t("conn.guide.ftps.note.tls") },
    { kind: "note", text: t("conn.guide.ftps.note.passive") },
    { kind: "note", text: t("conn.guide.ftps.note.storages") },
    { kind: "note", text: t("conn.guide.ftps.note.trash") },
    { kind: "note", text: t("conn.guide.ftps.note.prefer") }
  ];
  return e.ftpsSelfSigned && y.push({ kind: "warn", text: t("conn.guide.ftps.note.selfSigned") }), e.ftpsEnabled === !1 && y.unshift({ kind: "warn", text: t("conn.guide.ftps.note.disabled") }), {
    id: "ftps",
    name: "FTPS",
    summary: t("conn.guide.ftps.summary"),
    facts: h,
    clients: b,
    notes: y
  };
}, Zw = (e, t) => {
  const n = e.nfsHost || ka(e.origin), r = e.nfsPort || 2049, a = e.nfsPath || t("conn.guide.nfs.pathPlaceholder"), u = e.nfsReadOnly ? ",ro" : "", v = `nfsvers=3,tcp,port=${r},mountport=${r},nolock${u}`, p = [
    { label: t("conn.guide.nfs.fact.host"), value: n, hint: t("conn.guide.nfs.fact.hostHint") },
    { label: t("conn.guide.nfs.fact.port"), value: String(r), hint: t("conn.guide.nfs.fact.portHint") },
    {
      label: t("conn.guide.nfs.fact.export"),
      value: a,
      hint: t("conn.guide.nfs.fact.exportHint"),
      // ⚠ Only real right after minting: the path is stored hashed and cannot
      // be shown again, and printing something path-shaped would produce a
      // mount line that fails with no clue why.
      placeholderOnly: !e.nfsPath
    },
    { label: t("conn.guide.nfs.fact.options"), value: v, hint: t("conn.guide.nfs.fact.optionsHint") }
  ], h = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.linux.mountCaption"),
          code: [
            "sudo mkdir -p /mnt/filex",
            `sudo mount -t nfs -o ${v} ${n}:${a} /mnt/filex`,
            "",
            "# and to unmount:",
            "sudo umount /mnt/filex"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "/etc/fstab",
          code: `${n}:${a}  /mnt/filex  nfs  ${v},_netdev,noauto,x-systemd.automount  0  0`
        },
        // ⚠ The warning that belongs next to the fstab line rather than in a
        // document: that file is world-readable on most systems.
        { kind: "warn", text: t("conn.guide.nfs.linux.fstabSecret") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.mac.mountCaption"),
          code: [
            "sudo mkdir -p /Volumes/filex",
            `sudo mount -t nfs -o vers=3,tcp,port=${r},mountport=${r},nolock${u},resvport ${n}:${a} /Volumes/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.nfs.mac.resvport") }
      ]
    },
    {
      id: "windows",
      name: "Windows (Client for NFS)",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.win.s1"),
            t("conn.guide.nfs.win.s2"),
            t("conn.guide.nfs.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.nfs.win.cmdCaption"),
          code: `mount -o anon nolock ${n}:${a} Z:`
        },
        // ⚠ Windows' client has no way to say "the mount service is on this
        // port", so it only works when filex is on 2049.
        { kind: "warn", text: t("conn.guide.nfs.win.port") }
      ]
    },
    {
      id: "synology",
      name: t("conn.guide.nfs.nas.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.nas.s1", { host: n, port: String(r) }),
            t("conn.guide.nfs.nas.s2"),
            t("conn.guide.nfs.nas.s3")
          ]
        }
      ]
    }
  ], b = [
    { kind: "warn", text: t("conn.guide.nfs.note.unencrypted") },
    { kind: "warn", text: t("conn.guide.nfs.note.pathIsSecret") },
    { kind: "note", text: t("conn.guide.nfs.note.noPortmapper") },
    { kind: "note", text: t("conn.guide.nfs.note.uid") },
    { kind: "note", text: t("conn.guide.nfs.note.trash") },
    { kind: "note", text: t("conn.guide.nfs.note.revoke") }
  ];
  return e.nfsEnabled === !1 && b.unshift({ kind: "warn", text: t("conn.guide.nfs.note.disabled") }), {
    id: "nfs",
    name: "NFS",
    summary: t("conn.guide.nfs.summary"),
    facts: p,
    clients: h,
    notes: b
  };
}, Qw = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), r = e.storage || e.storages[0] || "main", a = [
    { label: t("conn.guide.mount.fact.url"), value: n, hint: t("conn.guide.mount.fact.urlHint") },
    {
      label: t("conn.guide.mount.fact.token"),
      value: t("conn.guide.mount.fact.tokenPlaceholder"),
      hint: t("conn.guide.mount.fact.tokenHint"),
      // filex never has the plaintext of a token after it is minted, and a
      // fact row that looked like one would be a lie the user pastes.
      placeholderOnly: !0
    },
    { label: t("conn.guide.mount.fact.remote"), value: `${r}://`, hint: t("conn.guide.mount.fact.remoteHint") }
  ], u = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.mountCaption"),
          code: [
            `export FILEX_URL=${n}`,
            "export FILEX_TOKEN=<token>",
            "",
            "mkdir -p ~/filex",
            "filex mount ~/filex",
            "",
            "# one storage only, or a subfolder of it:",
            `filex mount --remote '${r}://' ~/filex`,
            `filex mount --remote '${r}://projects/acme' --read-only ~/acme`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.umountCaption"),
          code: "fusermount -u ~/filex"
        },
        // ⚠ The one that costs an afternoon if it is not said: killing the
        // process leaves a directory where every `ls` hangs.
        { kind: "warn", text: t("conn.guide.mount.linux.umountWarn") },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.systemdCaption"),
          code: [
            "# ~/.config/systemd/user/filex-mount.service",
            "[Unit]",
            "Description=filex mount",
            "After=network-online.target",
            "",
            "[Service]",
            `Environment=FILEX_URL=${n}`,
            "Environment=FILEX_TOKEN=<token>",
            "ExecStart=%h/.local/bin/filex mount %h/filex",
            "ExecStop=/bin/fusermount -u %h/filex",
            "Restart=on-failure",
            "",
            "[Install]",
            "WantedBy=default.target"
          ].join(`
`)
        }
      ]
    },
    {
      id: "windows",
      name: "Windows",
      platform: "windows",
      blocks: [
        { kind: "note", text: t("conn.guide.mount.win.winfsp") },
        {
          kind: "code",
          caption: t("conn.guide.mount.win.mountCaption"),
          code: [
            `$env:FILEX_URL   = "${n}"`,
            '$env:FILEX_TOKEN = "<token>"',
            "",
            "filex mount Z:"
          ].join(`
`)
        },
        // ⚠ The drive letter is CREATED, not reused — pointing it at one that
        // already exists is the commonest way this fails, and the message the
        // driver gives for it says nothing useful.
        { kind: "warn", text: t("conn.guide.mount.win.freeLetter") },
        { kind: "note", text: t("conn.guide.mount.win.stop") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        // ⚠⚠ A refusal stated up front rather than discovered. macFUSE's Go
        // binding needs a C toolchain filex deliberately does not use, and its
        // licence forbids a commercial program from installing it. Pretending
        // otherwise would mean a command that appears to work and does nothing.
        { kind: "warn", text: t("conn.guide.mount.mac.unsupported") },
        { kind: "note", text: t("conn.guide.mount.mac.alternatives") }
      ]
    }
  ], v = [
    { kind: "note", text: t("conn.guide.mount.note.notASync") },
    { kind: "note", text: t("conn.guide.mount.note.reachable") },
    { kind: "note", text: t("conn.guide.mount.note.wholeFileWrites") },
    { kind: "note", text: t("conn.guide.mount.note.trash") },
    { kind: "note", text: t("conn.guide.mount.note.revoke") }
  ];
  return {
    id: "mount",
    name: "filex mount",
    summary: t("conn.guide.mount.summary"),
    facts: a,
    clients: u,
    notes: v
  };
}, Id = {
  webdav: qw,
  s3: Gw,
  sftp: Xw,
  ftps: Jw,
  nfs: Zw,
  mount: Qw
}, e1 = {
  webdav: "WebDAV",
  s3: "S3",
  sftp: "SFTP",
  ftps: "FTPS",
  nfs: "NFS",
  mount: "filex mount"
};
function t1(e) {
  return e1[e] || e.toUpperCase();
}
function n1() {
  return Object.keys(Id);
}
function a1(e, t, n) {
  const r = Id[e];
  return r ? r(t, n) : null;
}
const o1 = { class: "fe-cfield" }, s1 = {
  key: 0,
  class: "fe-cfield__empty"
}, r1 = {
  key: 0,
  class: "fe-cfield__check"
}, i1 = ["checked", "disabled", "onChange"], l1 = ["for"], c1 = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, u1 = ["id", "value", "disabled", "onChange"], d1 = ["value"], f1 = ["id", "value", "placeholder", "disabled", "onInput"], p1 = {
  key: 4,
  class: "fe-cfield__secret"
}, v1 = ["id", "type", "value", "placeholder", "disabled", "onInput"], h1 = ["title", "aria-label", "onClick"], m1 = ["innerHTML"], y1 = ["id", "type", "value", "placeholder", "min", "max", "disabled", "onInput"], b1 = {
  key: 6,
  class: "fe-cfield__help"
}, g1 = {
  key: 7,
  class: "fe-cfield__error"
}, k1 = {
  key: 1,
  class: "fe-cfield__adv"
}, _1 = {
  key: 0,
  class: "fe-cfield__advbody"
}, w1 = {
  key: 0,
  class: "fe-cfield__check"
}, $1 = ["checked", "disabled", "onChange"], x1 = ["for"], S1 = ["id", "type", "value", "placeholder", "disabled", "onInput"], C1 = {
  key: 2,
  class: "fe-cfield__help"
}, T1 = /* @__PURE__ */ qe({
  __name: "StorageFields",
  props: {
    fields: {},
    modelValue: {},
    locale: {},
    invalid: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = m(!1), v = m({}), p = k(() => n.fields.filter((M) => !M.advanced)), h = k(() => n.fields.filter((M) => M.advanced));
    function b(M) {
      const z = a(M.i18n_key);
      return z === M.i18n_key ? M.label : z;
    }
    function y(M) {
      if (!M.help_i18n_key) return M.help ?? "";
      const z = a(M.help_i18n_key);
      return z === M.help_i18n_key ? M.help ?? "" : z;
    }
    function A(M) {
      if (!M.i18n_key) return M.label;
      const z = a(M.i18n_key);
      return z === M.i18n_key ? M.label : z;
    }
    function D(M, z) {
      r("update:modelValue", { ...n.modelValue, [M]: z });
    }
    function C(M) {
      var T, Y;
      const z = (T = n.modelValue) == null ? void 0 : T[M.key];
      if (z != null) return z;
      for (const O of M.aliases ?? []) {
        const J = (Y = n.modelValue) == null ? void 0 : Y[O];
        if (J != null) return J;
      }
      return M.default ?? void 0;
    }
    function B(M) {
      const z = C(M);
      return z == null ? "" : String(z);
    }
    function I(M) {
      const z = C(M);
      return z === "" || z === void 0 || z === null ? "" : String(z);
    }
    function U(M) {
      return C(M) === !0;
    }
    function x(M) {
      return (n.invalid ?? []).includes(M.key);
    }
    function E(M) {
      return M.type === "int" ? "number" : M.type === "password" && !v.value[M.key] ? "password" : "text";
    }
    function $(M) {
      v.value = { ...v.value, [M]: !v.value[M] };
    }
    return (M, z) => (c(), d("div", o1, [
      e.fields.length ? g("", !0) : (c(), d("p", s1, f(s(a)("conn.form.noFields")), 1)),
      (c(!0), d(ae, null, Te(p.value, (T) => (c(), d("div", {
        key: T.key,
        class: we(["fe-cfield__row", { "is-invalid": x(T) }])
      }, [
        T.type === "bool" ? (c(), d("label", r1, [
          o("input", {
            type: "checkbox",
            checked: U(T),
            disabled: e.disabled,
            onChange: (Y) => D(T.key, Y.target.checked)
          }, null, 40, i1),
          o("span", null, f(b(T)), 1)
        ])) : (c(), d("label", {
          key: 1,
          class: "fe-cfield__label",
          for: `fe-cf-${T.key}`
        }, [
          Je(f(b(T)), 1),
          T.required ? (c(), d("span", c1, "*")) : g("", !0)
        ], 8, l1)),
        T.type === "select" ? (c(), d("select", {
          key: 2,
          id: `fe-cf-${T.key}`,
          class: "fe-cfield__input",
          value: B(T),
          disabled: e.disabled,
          onChange: (Y) => D(T.key, Y.target.value)
        }, [
          (c(!0), d(ae, null, Te(T.options ?? [], (Y) => (c(), d("option", {
            key: Y.value,
            value: Y.value
          }, f(A(Y)), 9, d1))), 128))
        ], 40, u1)) : T.multiline ? (c(), d("textarea", {
          key: 3,
          id: `fe-cf-${T.key}`,
          class: we(["fe-cfield__input fe-cfield__input--area", { "fe-cfield__input--mono": T.monospace }]),
          rows: "4",
          value: B(T),
          placeholder: T.placeholder,
          disabled: e.disabled,
          onInput: (Y) => D(T.key, Y.target.value)
        }, null, 42, f1)) : T.type === "password" ? (c(), d("div", p1, [
          o("input", {
            id: `fe-cf-${T.key}`,
            class: "fe-cfield__input fe-cfield__input--mono",
            type: E(T),
            autocomplete: "new-password",
            spellcheck: "false",
            value: B(T),
            placeholder: T.placeholder,
            disabled: e.disabled,
            onInput: (Y) => D(T.key, Y.target.value)
          }, null, 40, v1),
          o("button", {
            type: "button",
            class: "fe-cfield__eye",
            title: v.value[T.key] ? s(a)("conn.form.hide") : s(a)("conn.form.reveal"),
            "aria-label": v.value[T.key] ? s(a)("conn.form.hide") : s(a)("conn.form.reveal"),
            onClick: (Y) => $(T.key)
          }, [
            o("span", {
              "aria-hidden": "true",
              innerHTML: s(Ue)(v.value[T.key] ? "toggle-hidden" : "preview")
            }, null, 8, m1)
          ], 8, h1)
        ])) : T.type !== "bool" ? (c(), d("input", {
          key: 5,
          id: `fe-cf-${T.key}`,
          class: we(["fe-cfield__input", { "fe-cfield__input--mono": T.monospace }]),
          type: E(T),
          value: T.type === "int" ? I(T) : B(T),
          placeholder: T.placeholder,
          min: T.min,
          max: T.max,
          disabled: e.disabled,
          onInput: (Y) => D(
            T.key,
            T.type === "int" ? Y.target.value === "" ? null : Number(Y.target.value) : Y.target.value
          )
        }, null, 42, y1)) : g("", !0),
        y(T) ? (c(), d("p", b1, f(y(T)), 1)) : g("", !0),
        x(T) ? (c(), d("p", g1, f(s(a)("conn.form.required")), 1)) : g("", !0)
      ], 2))), 128)),
      h.value.length ? (c(), d("div", k1, [
        o("button", {
          type: "button",
          class: "fe-cfield__advtoggle",
          onClick: z[0] || (z[0] = (T) => u.value = !u.value)
        }, f(u.value ? "▾" : "▸") + " " + f(s(a)("conn.form.advanced")), 1),
        u.value ? (c(), d("div", _1, [
          (c(!0), d(ae, null, Te(h.value, (T) => (c(), d("div", {
            key: T.key,
            class: "fe-cfield__row"
          }, [
            T.type === "bool" ? (c(), d("label", w1, [
              o("input", {
                type: "checkbox",
                checked: U(T),
                disabled: e.disabled,
                onChange: (Y) => D(T.key, Y.target.checked)
              }, null, 40, $1),
              o("span", null, f(b(T)), 1)
            ])) : (c(), d(ae, { key: 1 }, [
              o("label", {
                class: "fe-cfield__label",
                for: `fe-cfa-${T.key}`
              }, f(b(T)), 9, x1),
              o("input", {
                id: `fe-cfa-${T.key}`,
                class: we(["fe-cfield__input", { "fe-cfield__input--mono": T.monospace }]),
                type: E(T),
                value: T.type === "int" ? I(T) : B(T),
                placeholder: T.placeholder,
                disabled: e.disabled,
                onInput: (Y) => D(
                  T.key,
                  T.type === "int" ? Y.target.value === "" ? null : Number(Y.target.value) : Y.target.value
                )
              }, null, 42, S1)
            ], 64)),
            y(T) ? (c(), d("p", C1, f(y(T)), 1)) : g("", !0)
          ]))), 128))
        ])) : g("", !0)
      ])) : g("", !0)
    ]));
  }
}), M1 = { class: "fe-guide" }, E1 = { class: "fe-guide__summary" }, z1 = {
  class: "fe-guide__facts",
  "data-testid": "guide-facts"
}, A1 = { class: "fe-guide__factlabel" }, P1 = { class: "fe-guide__factvalue" }, L1 = ["data-testid", "onClick"], D1 = {
  key: 0,
  class: "fe-guide__facthint"
}, O1 = {
  class: "fe-guide__tabs",
  role: "tablist"
}, B1 = ["aria-selected", "data-testid", "onClick"], I1 = {
  key: 0,
  class: "fe-guide__body",
  role: "tabpanel"
}, H1 = {
  key: 0,
  class: "fe-guide__steps"
}, F1 = {
  key: 1,
  class: "fe-guide__codewrap"
}, N1 = { class: "fe-guide__codehead" }, K1 = { class: "fe-guide__caption" }, R1 = ["data-testid", "onClick"], U1 = { class: "fe-guide__code" }, V1 = {
  key: 2,
  class: "fe-guide__warn"
}, j1 = {
  key: 3,
  class: "fe-guide__note"
}, Y1 = {
  key: 4,
  class: "fe-guide__text"
}, W1 = {
  key: 1,
  class: "fe-guide__notes"
}, q1 = { class: "fe-guide__notestitle" }, G1 = /* @__PURE__ */ qe({
  __name: "ConnectionGuideView",
  props: {
    guide: {},
    locale: {}
  },
  setup(e) {
    var y;
    const t = e, { t: n } = tt(() => t.locale), r = m(((y = t.guide.clients[0]) == null ? void 0 : y.id) ?? ""), a = m(null);
    let u = null;
    const v = k(
      () => t.guide.clients.find((A) => A.id === r.value) ?? t.guide.clients[0]
    );
    async function p(A, D) {
      let C = !1;
      try {
        await navigator.clipboard.writeText(A), C = !0;
      } catch {
        try {
          const B = document.createElement("textarea");
          B.value = A, B.setAttribute("readonly", ""), B.style.position = "fixed", B.style.opacity = "0", document.body.appendChild(B), B.select(), C = document.execCommand("copy"), document.body.removeChild(B);
        } catch {
          C = !1;
        }
      }
      a.value = C ? D : null, u && clearTimeout(u), u = setTimeout(() => {
        a.value = null;
      }, 1600);
    }
    function h(A, D) {
      return `${A}-${D}`;
    }
    function b(A) {
      return A.kind === "code";
    }
    return (A, D) => (c(), d("div", M1, [
      o("p", E1, f(e.guide.summary), 1),
      o("section", z1, [
        (c(!0), d(ae, null, Te(e.guide.facts, (C, B) => (c(), d("div", {
          key: C.label,
          class: "fe-guide__fact"
        }, [
          o("span", A1, f(C.label), 1),
          o("span", P1, [
            o("code", {
              class: we({ "fe-guide__ph": C.placeholderOnly })
            }, f(C.value), 3),
            C.placeholderOnly ? g("", !0) : (c(), d("button", {
              key: 0,
              type: "button",
              class: "fe-guide__copy",
              "data-testid": `copy-fact-${B}`,
              onClick: (I) => p(C.value, h("fact", B))
            }, f(a.value === h("fact", B) ? s(n)("conn.guide.copied") : s(n)("conn.guide.copy")), 9, L1))
          ]),
          C.hint ? (c(), d("span", D1, f(C.hint), 1)) : g("", !0)
        ]))), 128))
      ]),
      o("nav", O1, [
        (c(!0), d(ae, null, Te(e.guide.clients, (C) => (c(), d("button", {
          key: C.id,
          type: "button",
          role: "tab",
          class: we(["fe-guide__tab", { "is-active": v.value && C.id === v.value.id }]),
          "aria-selected": v.value && C.id === v.value.id,
          "data-testid": `guide-tab-${C.id}`,
          onClick: (B) => r.value = C.id
        }, f(C.name), 11, B1))), 128))
      ]),
      v.value ? (c(), d("div", I1, [
        (c(!0), d(ae, null, Te(v.value.blocks, (C, B) => (c(), d(ae, { key: B }, [
          C.kind === "steps" ? (c(), d("ol", H1, [
            (c(!0), d(ae, null, Te(C.steps ?? [], (I, U) => (c(), d("li", { key: U }, f(I), 1))), 128))
          ])) : b(C) ? (c(), d("div", F1, [
            o("div", N1, [
              o("span", K1, f(C.caption), 1),
              o("button", {
                type: "button",
                class: "fe-guide__copy",
                "data-testid": `copy-code-${B}`,
                onClick: (I) => p(C.code ?? "", h(v.value.id, B))
              }, f(a.value === h(v.value.id, B) ? s(n)("conn.guide.copied") : s(n)("conn.guide.copy")), 9, R1)
            ]),
            o("pre", U1, [
              o("code", null, f(C.code), 1)
            ])
          ])) : C.kind === "warn" ? (c(), d("p", V1, f(C.text), 1)) : C.kind === "note" ? (c(), d("p", j1, f(C.text), 1)) : (c(), d("p", Y1, f(C.text), 1))
        ], 64))), 128))
      ])) : g("", !0),
      e.guide.notes.length ? (c(), d("section", W1, [
        o("h4", q1, f(s(n)("conn.guide.goodToKnow")), 1),
        (c(!0), d(ae, null, Te(e.guide.notes, (C, B) => (c(), d("p", {
          key: B,
          class: we(C.kind === "warn" ? "fe-guide__warn" : "fe-guide__note")
        }, f(C.text), 3))), 128))
      ])) : g("", !0)
    ]));
  }
});
function X1(e) {
  const t = Ya(e), n = wa(e), r = ($) => `${n}${$}`, a = wn([]), u = m(null), v = m(!1), p = m(!1), h = m(null), b = m(null), y = m(null);
  function A($) {
    const M = $;
    if (M != null && M.detail)
      try {
        const z = JSON.parse(M.detail);
        if (z != null && z.error) return z.error;
      } catch {
      }
    return (M == null ? void 0 : M.message) || String($);
  }
  function D($) {
    return $ == null ? void 0 : $.status;
  }
  async function C() {
    v.value = !0, h.value = null;
    try {
      const $ = await t.jsonFetch(
        r("/api/auth/s3-keys")
      );
      a.value = Array.isArray($ == null ? void 0 : $.keys) ? $.keys : [], u.value = {
        endpoint: ($ == null ? void 0 : $.endpoint) ?? "",
        enabled: ($ == null ? void 0 : $.enabled) !== !1,
        path_style: ($ == null ? void 0 : $.path_style) !== !1
      }, b.value = !0;
    } catch ($) {
      a.value = [];
      const M = D($);
      M === 401 || M === 403 ? b.value = !1 : (b.value = !1, h.value = A($));
    } finally {
      v.value = !1, p.value = !0;
    }
  }
  async function B($) {
    h.value = null;
    try {
      const M = await t.jsonFetch(r("/api/auth/s3-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify($)
      });
      return y.value = M, M != null && M.endpoint && (u.value = {
        endpoint: M.endpoint,
        enabled: M.enabled !== !1,
        path_style: M.path_style !== !1
      }), await C(), M;
    } catch (M) {
      return h.value = A(M), null;
    }
  }
  async function I($, M) {
    h.value = null;
    try {
      await t.jsonFetch(r(`/api/auth/s3-keys/${$}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: M })
      }), await C();
    } catch (z) {
      h.value = A(z);
    }
  }
  async function U($) {
    var M, z;
    h.value = null;
    try {
      await t.jsonFetch(r(`/api/auth/s3-keys/${$}`), { method: "DELETE" }), ((z = (M = y.value) == null ? void 0 : M.key) == null ? void 0 : z.id) === $ && (y.value = null), await C();
    } catch (T) {
      h.value = A(T);
    }
  }
  function x() {
    y.value = null;
  }
  const E = k(() => {
    var M;
    if ((M = y.value) != null && M.key) return y.value.key;
    const $ = a.value.filter((z) => !z.disabled_at);
    return $.length ? $.reduce((z, T) => z.created_at >= T.created_at ? z : T) : null;
  });
  return {
    keys: a,
    connection: u,
    loading: v,
    loaded: p,
    error: h,
    canMint: b,
    revealed: y,
    guideKey: E,
    load: C,
    create: B,
    setDisabled: I,
    remove: U,
    dismissSecret: x
  };
}
function Zi() {
  const e = m(!1);
  function t(n) {
    const r = n.currentTarget, a = ((r == null ? void 0 : r.scrollLeft) ?? 0) > 0;
    a !== e.value && (e.value = a);
  }
  return { scrolledX: e, onScroll: t };
}
const J1 = {
  class: "fe-s3keys",
  "data-testid": "s3-keys"
}, Z1 = { class: "fe-s3keys__head" }, Q1 = { class: "fe-s3keys__title" }, e0 = { class: "fe-s3keys__lead" }, t0 = {
  key: 0,
  class: "fe-s3keys__warn"
}, n0 = {
  key: 1,
  class: "fe-s3keys__muted"
}, a0 = {
  key: 2,
  class: "fe-s3keys__warn"
}, o0 = {
  key: 3,
  class: "fe-s3keys__form"
}, s0 = ["placeholder"], r0 = { value: "" }, i0 = ["value"], l0 = ["placeholder", "disabled"], c0 = ["disabled"], u0 = {
  key: 4,
  class: "fe-s3keys__hint"
}, d0 = {
  key: 5,
  class: "fe-s3keys__secret",
  "data-testid": "s3-key-secret"
}, f0 = { class: "fe-s3keys__once" }, p0 = { class: "fe-s3keys__pair" }, v0 = { class: "fe-s3keys__k" }, h0 = { class: "fe-s3keys__pair" }, m0 = { class: "fe-s3keys__k" }, y0 = {
  key: 6,
  class: "fe-s3keys__muted"
}, b0 = { class: "fe-s3keys__table" }, g0 = { class: "fe-s3keys__actions" }, k0 = ["disabled", "onClick"], _0 = ["disabled", "onClick"], w0 = {
  key: 8,
  class: "fe-s3keys__muted"
}, $0 = /* @__PURE__ */ qe({
  __name: "S3KeysPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = k(() => cn(n.config.locale)), { t: u, formatDate: v } = tt(a), { scrolledX: p, onScroll: h } = Zi(), {
      keys: b,
      connection: y,
      loading: A,
      error: D,
      canMint: C,
      revealed: B,
      guideKey: I,
      load: U,
      create: x,
      setDisabled: E,
      remove: $,
      dismissSecret: M
    } = X1(n.config), z = m(""), T = m(""), Y = m(""), O = m(!1), J = m(null), G = m(null);
    let N = null;
    function P() {
      var re, S, w, j, K;
      const pe = y.value;
      pe && r("active", {
        accessKeyID: ((re = I.value) == null ? void 0 : re.access_key_id) ?? "",
        // Only the freshly minted one. Re-emitting a stale secret would put a
        // dead credential into the commands.
        secret: ((w = (S = B.value) == null ? void 0 : S.key) == null ? void 0 : w.id) === ((j = I.value) == null ? void 0 : j.id) ? (K = B.value) == null ? void 0 : K.secret : void 0,
        endpoint: pe.endpoint,
        pathStyle: pe.path_style
      });
    }
    dt(async () => {
      await U(), P();
    });
    async function le() {
      O.value = !0;
      try {
        await x({
          label: z.value.trim() || u("conn.s3keys.defaultLabel"),
          bucket: T.value.trim() || void 0,
          prefix: Y.value.trim() || void 0
        }), z.value = "", P();
      } finally {
        O.value = !1;
      }
    }
    async function ve(pe) {
      O.value = !0;
      try {
        await E(pe.id, !pe.disabled_at), P();
      } finally {
        O.value = !1;
      }
    }
    async function he(pe) {
      if (J.value !== pe.id) {
        J.value = pe.id;
        return;
      }
      J.value = null, O.value = !0;
      try {
        await $(pe.id), P();
      } finally {
        O.value = !1;
      }
    }
    async function oe(pe, re) {
      let S = !1;
      try {
        await navigator.clipboard.writeText(pe), S = !0;
      } catch {
        try {
          const w = document.createElement("textarea");
          w.value = pe, w.setAttribute("readonly", ""), w.style.position = "fixed", w.style.opacity = "0", document.body.appendChild(w), w.select(), S = document.execCommand("copy"), document.body.removeChild(w);
        } catch {
          S = !1;
        }
      }
      S && (G.value = re, N && clearTimeout(N), N = setTimeout(() => G.value = null, 1600));
    }
    function ue(pe) {
      const re = new Date(pe ?? "").getTime();
      return Number.isNaN(re) ? "" : v(re);
    }
    function Q(pe) {
      return pe.bucket ? pe.prefix ? `${pe.bucket}/${pe.prefix}` : pe.bucket : u("conn.s3keys.scopeAll");
    }
    return (pe, re) => (c(), d("section", J1, [
      o("header", Z1, [
        o("h4", Q1, f(s(u)("conn.s3keys.title")), 1),
        o("p", e0, f(s(u)("conn.s3keys.lead")), 1)
      ]),
      s(y) && !s(y).enabled ? (c(), d("p", t0, f(s(u)("conn.s3keys.disabled")), 1)) : g("", !0),
      s(C) === !1 ? (c(), d("p", n0, f(s(u)("conn.s3keys.cannotMint")), 1)) : g("", !0),
      s(D) ? (c(), d("p", a0, f(s(D)), 1)) : g("", !0),
      s(C) ? (c(), d("div", o0, [
        Ve(o("input", {
          "onUpdate:modelValue": re[0] || (re[0] = (S) => z.value = S),
          class: "fe-cfield__input",
          placeholder: s(u)("conn.s3keys.label"),
          "data-testid": "s3-key-label"
        }, null, 8, s0), [
          [rt, z.value]
        ]),
        Ve(o("select", {
          "onUpdate:modelValue": re[1] || (re[1] = (S) => T.value = S),
          class: "fe-cfield__input",
          "data-testid": "s3-key-bucket"
        }, [
          o("option", r0, f(s(u)("conn.s3keys.everyBucket")), 1),
          (c(!0), d(ae, null, Te(e.storages, (S) => (c(), d("option", {
            key: S,
            value: S
          }, f(S), 9, i0))), 128))
        ], 512), [
          [on, T.value]
        ]),
        Ve(o("input", {
          "onUpdate:modelValue": re[2] || (re[2] = (S) => Y.value = S),
          class: "fe-cfield__input",
          placeholder: s(u)("conn.s3keys.prefix"),
          disabled: !T.value,
          "data-testid": "s3-key-prefix"
        }, null, 8, l0), [
          [rt, Y.value]
        ]),
        o("button", {
          class: "fe-s3keys__btn",
          disabled: O.value,
          "data-testid": "s3-key-mint",
          onClick: le
        }, f(s(u)("conn.s3keys.mint")), 9, c0)
      ])) : g("", !0),
      s(C) ? (c(), d("p", u0, f(s(u)("conn.s3keys.inheritNote")), 1)) : g("", !0),
      s(B) ? (c(), d("div", d0, [
        o("p", f0, f(s(u)("conn.s3keys.once")), 1),
        o("div", p0, [
          o("span", v0, f(s(u)("conn.s3keys.accessKeyID")), 1),
          o("code", null, f(s(B).key.access_key_id), 1),
          o("button", {
            class: "fe-s3keys__copy",
            onClick: re[3] || (re[3] = (S) => oe(s(B).key.access_key_id, "akid"))
          }, f(G.value === "akid" ? s(u)("conn.guide.copied") : s(u)("conn.guide.copy")), 1)
        ]),
        o("div", h0, [
          o("span", m0, f(s(u)("conn.s3keys.secret")), 1),
          o("code", null, f(s(B).secret), 1),
          o("button", {
            class: "fe-s3keys__copy",
            onClick: re[4] || (re[4] = (S) => oe(s(B).secret, "secret"))
          }, f(G.value === "secret" ? s(u)("conn.guide.copied") : s(u)("conn.guide.copy")), 1)
        ]),
        o("button", {
          class: "fe-s3keys__dismiss",
          onClick: re[5] || (re[5] = //@ts-ignore
          (...S) => s(M) && s(M)(...S))
        }, f(s(u)("conn.s3keys.dismiss")), 1)
      ])) : g("", !0),
      s(A) ? (c(), d("p", y0, "…")) : s(b).length ? (c(), d("div", {
        key: 7,
        class: we(["fe-s3keys__scroll", { "is-scrolled-x": s(p) }]),
        onScrollPassive: re[6] || (re[6] = //@ts-ignore
        (...S) => s(h) && s(h)(...S))
      }, [
        o("table", b0, [
          o("thead", null, [
            o("tr", null, [
              o("th", null, f(s(u)("conn.s3keys.col.label")), 1),
              o("th", null, f(s(u)("conn.s3keys.col.key")), 1),
              o("th", null, f(s(u)("conn.s3keys.col.scope")), 1),
              o("th", null, f(s(u)("conn.s3keys.col.lastUsed")), 1),
              re[7] || (re[7] = o("th", null, null, -1))
            ])
          ]),
          o("tbody", null, [
            (c(!0), d(ae, null, Te(s(b), (S) => (c(), d("tr", {
              key: S.id,
              class: we({ "is-off": !!S.disabled_at })
            }, [
              o("td", null, f(S.label || s(u)("conn.s3keys.noLabel")), 1),
              o("td", null, [
                o("code", null, f(S.access_key_id), 1)
              ]),
              o("td", null, f(Q(S)), 1),
              o("td", null, f(S.last_used_at ? ue(S.last_used_at) : s(u)("conn.s3keys.neverUsed")), 1),
              o("td", g0, [
                o("button", {
                  class: "fe-s3keys__link",
                  disabled: O.value,
                  onClick: (w) => ve(S)
                }, f(S.disabled_at ? s(u)("conn.s3keys.enable") : s(u)("conn.s3keys.disable")), 9, k0),
                o("button", {
                  class: "fe-s3keys__link is-danger",
                  disabled: O.value,
                  onClick: (w) => he(S)
                }, f(J.value === S.id ? s(u)("conn.s3keys.confirm") : s(u)("conn.s3keys.revoke")), 9, _0)
              ])
            ], 2))), 128))
          ])
        ])
      ], 34)) : s(C) ? (c(), d("p", w0, f(s(u)("conn.s3keys.empty")), 1)) : g("", !0)
    ]));
  }
});
function x0(e) {
  const t = Ya(e), n = wa(e), r = (x) => `${n}${x}`, a = wn([]), u = m(null), v = m(!1), p = m(!1), h = m(null), b = m(null);
  function y(x) {
    const E = x;
    if (E != null && E.detail)
      try {
        const $ = JSON.parse(E.detail);
        if ($ != null && $.error) return $.error;
      } catch {
      }
    return (E == null ? void 0 : E.message) || String(x);
  }
  function A(x) {
    return x == null ? void 0 : x.status;
  }
  async function D() {
    v.value = !0, h.value = null;
    try {
      const x = await t.jsonFetch(
        r("/api/auth/ssh-keys")
      );
      a.value = Array.isArray(x == null ? void 0 : x.keys) ? x.keys : [], u.value = {
        enabled: (x == null ? void 0 : x.enabled) !== !1,
        host: (x == null ? void 0 : x.host) ?? "",
        port: (x == null ? void 0 : x.port) ?? 2022,
        login: (x == null ? void 0 : x.login) ?? "",
        ftps: x == null ? void 0 : x.ftps
      }, b.value = !0;
    } catch (x) {
      a.value = [], b.value = !1, A(x) !== 401 && A(x) !== 403 && (h.value = y(x));
    } finally {
      v.value = !1, p.value = !0;
    }
  }
  async function C(x, E) {
    h.value = null;
    try {
      return await t.jsonFetch(r("/api/auth/ssh-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: x, name: E })
      }), await D(), !0;
    } catch ($) {
      return h.value = y($), !1;
    }
  }
  async function B(x, E) {
    h.value = null;
    try {
      await t.jsonFetch(r(`/api/auth/ssh-keys/${x}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: E })
      }), await D();
    } catch ($) {
      h.value = y($);
    }
  }
  async function I(x) {
    h.value = null;
    try {
      await t.jsonFetch(r(`/api/auth/ssh-keys/${x}`), { method: "DELETE" }), await D();
    } catch (E) {
      h.value = y(E);
    }
  }
  const U = k(() => a.value.some((x) => !x.disabled_at));
  return { keys: a, connection: u, loading: v, loaded: p, error: h, canAdd: b, hasUsableKey: U, load: D, add: C, setDisabled: B, remove: I };
}
const S0 = {
  key: 0,
  class: "fe-s3keys",
  "data-testid": "ssh-keys"
}, C0 = { class: "fe-s3keys__head" }, T0 = { class: "fe-s3keys__title" }, M0 = { class: "fe-s3keys__lead" }, E0 = {
  key: 0,
  class: "fe-s3keys__warn"
}, z0 = {
  key: 1,
  class: "fe-s3keys__muted"
}, A0 = {
  key: 2,
  class: "fe-s3keys__warn"
}, P0 = {
  key: 3,
  class: "fe-sshkeys__form"
}, L0 = ["placeholder"], D0 = { class: "fe-sshkeys__row" }, O0 = ["placeholder"], B0 = ["disabled"], I0 = { class: "fe-s3keys__hint" }, H0 = {
  key: 4,
  class: "fe-s3keys__muted"
}, F0 = { class: "fe-s3keys__table" }, N0 = { class: "fe-s3keys__actions" }, K0 = ["disabled", "onClick"], R0 = ["disabled", "onClick"], U0 = {
  key: 6,
  class: "fe-s3keys__muted"
}, V0 = /* @__PURE__ */ qe({
  __name: "SSHKeysPanel",
  props: {
    config: {},
    keysVisible: { type: Boolean }
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, r = k(() => n.keysVisible !== !1), a = t, u = k(() => cn(n.config.locale)), { t: v, formatDate: p } = tt(u), { scrolledX: h, onScroll: b } = Zi(), { keys: y, connection: A, loading: D, error: C, canAdd: B, hasUsableKey: I, load: U, add: x, setDisabled: E, remove: $ } = x0(n.config), M = m(""), z = m(""), T = m(!1), Y = m(null);
    function O() {
      const ve = A.value;
      ve && a("active", {
        host: ve.host,
        port: ve.port,
        login: ve.login,
        enabled: ve.enabled,
        hasKey: I.value,
        // The FTPS endpoint travels with the SSH facts: for the user this is one
        // question ("how do I reach this from a program?"), and two calls to
        // answer it would be two chances to disagree.
        ftps: ve.ftps
      });
    }
    dt(async () => {
      await U(), O();
    });
    async function J() {
      if (M.value.trim()) {
        T.value = !0;
        try {
          await x(M.value.trim(), z.value.trim() || void 0) && (M.value = "", z.value = ""), O();
        } finally {
          T.value = !1;
        }
      }
    }
    async function G(ve) {
      T.value = !0;
      try {
        await E(ve.id, !ve.disabled_at), O();
      } finally {
        T.value = !1;
      }
    }
    async function N(ve) {
      if (Y.value !== ve.id) {
        Y.value = ve.id;
        return;
      }
      Y.value = null, T.value = !0;
      try {
        await $(ve.id), O();
      } finally {
        T.value = !1;
      }
    }
    function P(ve) {
      const he = new Date(ve ?? "").getTime();
      return Number.isNaN(he) ? "" : p(he);
    }
    function le(ve) {
      return "SHA256:" + ve.fingerprint;
    }
    return (ve, he) => r.value ? (c(), d("section", S0, [
      o("header", C0, [
        o("h4", T0, f(s(v)("conn.sshkeys.title")), 1),
        o("p", M0, f(s(v)("conn.sshkeys.lead")), 1)
      ]),
      s(A) && !s(A).enabled ? (c(), d("p", E0, f(s(v)("conn.sshkeys.disabled")), 1)) : g("", !0),
      s(B) === !1 ? (c(), d("p", z0, f(s(v)("conn.sshkeys.cannotAdd")), 1)) : g("", !0),
      s(C) ? (c(), d("p", A0, f(s(C)), 1)) : g("", !0),
      s(B) ? (c(), d("div", P0, [
        Ve(o("textarea", {
          "onUpdate:modelValue": he[0] || (he[0] = (oe) => M.value = oe),
          class: "fe-cfield__input fe-sshkeys__paste",
          rows: "2",
          spellcheck: "false",
          placeholder: s(v)("conn.sshkeys.paste"),
          "data-testid": "ssh-key-input"
        }, null, 8, L0), [
          [rt, M.value]
        ]),
        o("div", D0, [
          Ve(o("input", {
            "onUpdate:modelValue": he[1] || (he[1] = (oe) => z.value = oe),
            class: "fe-cfield__input",
            placeholder: s(v)("conn.sshkeys.name"),
            "data-testid": "ssh-key-name"
          }, null, 8, O0), [
            [rt, z.value]
          ]),
          o("button", {
            class: "fe-s3keys__btn",
            disabled: T.value,
            "data-testid": "ssh-key-add",
            onClick: J
          }, f(s(v)("conn.sshkeys.add")), 9, B0)
        ]),
        o("p", I0, f(s(v)("conn.sshkeys.noCopyId")), 1)
      ])) : g("", !0),
      s(D) ? (c(), d("p", H0, "…")) : s(y).length ? (c(), d("div", {
        key: 5,
        class: we(["fe-s3keys__scroll", { "is-scrolled-x": s(h) }]),
        onScrollPassive: he[2] || (he[2] = //@ts-ignore
        (...oe) => s(b) && s(b)(...oe))
      }, [
        o("table", F0, [
          o("thead", null, [
            o("tr", null, [
              o("th", null, f(s(v)("conn.sshkeys.col.name")), 1),
              o("th", null, f(s(v)("conn.sshkeys.col.fingerprint")), 1),
              o("th", null, f(s(v)("conn.sshkeys.col.lastUsed")), 1),
              he[3] || (he[3] = o("th", null, null, -1))
            ])
          ]),
          o("tbody", null, [
            (c(!0), d(ae, null, Te(s(y), (oe) => (c(), d("tr", {
              key: oe.id,
              class: we({ "is-off": !!oe.disabled_at })
            }, [
              o("td", null, f(oe.name || s(v)("conn.sshkeys.noName")), 1),
              o("td", null, [
                o("code", null, f(le(oe)), 1)
              ]),
              o("td", null, f(oe.last_used_at ? P(oe.last_used_at) : s(v)("conn.sshkeys.neverUsed")), 1),
              o("td", N0, [
                o("button", {
                  class: "fe-s3keys__link",
                  disabled: T.value,
                  onClick: (ue) => G(oe)
                }, f(oe.disabled_at ? s(v)("conn.sshkeys.enable") : s(v)("conn.sshkeys.disable")), 9, K0),
                o("button", {
                  class: "fe-s3keys__link is-danger",
                  disabled: T.value,
                  onClick: (ue) => N(oe)
                }, f(Y.value === oe.id ? s(v)("conn.sshkeys.confirm") : s(v)("conn.sshkeys.remove")), 9, R0)
              ])
            ], 2))), 128))
          ])
        ])
      ], 34)) : s(B) ? (c(), d("p", U0, f(s(v)("conn.sshkeys.empty")), 1)) : g("", !0)
    ])) : g("", !0);
  }
});
function j0(e) {
  const t = Ya(e), n = wa(e), r = ($) => `${n}${$}`, a = wn([]), u = m(null), v = m(!1), p = m(!1), h = m(null), b = m(null), y = m(null);
  function A($) {
    const M = $;
    if (M != null && M.detail)
      try {
        const z = JSON.parse(M.detail);
        if (z != null && z.error) return z.error;
      } catch {
      }
    return (M == null ? void 0 : M.message) || String($);
  }
  function D($) {
    return $ == null ? void 0 : $.status;
  }
  async function C() {
    v.value = !0, h.value = null;
    try {
      const $ = await t.jsonFetch(
        r("/api/auth/nfs-exports")
      );
      a.value = Array.isArray($ == null ? void 0 : $.exports) ? $.exports : [], u.value = {
        enabled: ($ == null ? void 0 : $.enabled) !== !1,
        host: ($ == null ? void 0 : $.host) ?? "",
        port: ($ == null ? void 0 : $.port) ?? 2049
      }, b.value = !0;
    } catch ($) {
      a.value = [], b.value = !1, D($) !== 401 && D($) !== 403 && (h.value = A($));
    } finally {
      v.value = !1, p.value = !0;
    }
  }
  async function B($) {
    h.value = null;
    try {
      const M = await t.jsonFetch(r("/api/auth/nfs-exports"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify($)
      });
      return y.value = M, M != null && M.host && (u.value = { enabled: M.enabled !== !1, host: M.host, port: M.port }), await C(), M;
    } catch (M) {
      return h.value = A(M), null;
    }
  }
  async function I($, M) {
    h.value = null;
    try {
      await t.jsonFetch(r(`/api/auth/nfs-exports/${$}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: M })
      }), await C();
    } catch (z) {
      h.value = A(z);
    }
  }
  async function U($) {
    var M, z;
    h.value = null;
    try {
      await t.jsonFetch(r(`/api/auth/nfs-exports/${$}`), { method: "DELETE" }), ((z = (M = y.value) == null ? void 0 : M.export) == null ? void 0 : z.id) === $ && (y.value = null), await C();
    } catch (T) {
      h.value = A(T);
    }
  }
  function x() {
    y.value = null;
  }
  const E = k(() => {
    var M;
    if ((M = y.value) != null && M.export) return y.value.export;
    const $ = a.value.filter((z) => !z.disabled_at);
    return $.length ? $.reduce((z, T) => z.created_at >= T.created_at ? z : T) : null;
  });
  return {
    exports: a,
    connection: u,
    loading: v,
    loaded: p,
    error: h,
    canMint: b,
    revealed: y,
    guideExport: E,
    load: C,
    create: B,
    setDisabled: I,
    remove: U,
    dismissPath: x
  };
}
const Y0 = {
  class: "fe-s3keys",
  "data-testid": "nfs-exports"
}, W0 = { class: "fe-s3keys__head" }, q0 = { class: "fe-s3keys__title" }, G0 = { class: "fe-s3keys__lead" }, X0 = { class: "fe-s3keys__warn" }, J0 = {
  key: 0,
  class: "fe-s3keys__warn"
}, Z0 = {
  key: 1,
  class: "fe-s3keys__muted"
}, Q0 = {
  key: 2,
  class: "fe-s3keys__warn"
}, e2 = {
  key: 3,
  class: "fe-s3keys__form fe-nfs__form"
}, t2 = ["placeholder"], n2 = { value: "" }, a2 = ["value"], o2 = ["placeholder", "disabled"], s2 = ["placeholder"], r2 = { class: "fe-nfs__ro" }, i2 = ["disabled"], l2 = {
  key: 4,
  class: "fe-s3keys__hint"
}, c2 = {
  key: 5,
  class: "fe-s3keys__secret",
  "data-testid": "nfs-path"
}, u2 = { class: "fe-s3keys__once" }, d2 = { class: "fe-s3keys__pair" }, f2 = {
  key: 6,
  class: "fe-s3keys__muted"
}, p2 = {
  key: 7,
  class: "fe-s3keys__table"
}, v2 = { class: "fe-s3keys__actions" }, h2 = ["disabled", "onClick"], m2 = ["disabled", "onClick"], y2 = {
  key: 8,
  class: "fe-s3keys__muted"
}, b2 = /* @__PURE__ */ qe({
  __name: "NFSExportsPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = k(() => cn(n.config.locale)), { t: u, formatDate: v } = tt(a), {
      exports: p,
      connection: h,
      loading: b,
      error: y,
      canMint: A,
      revealed: D,
      guideExport: C,
      load: B,
      create: I,
      setDisabled: U,
      remove: x,
      dismissPath: E
    } = j0(n.config), $ = m(""), M = m(""), z = m(""), T = m(!0), Y = m(""), O = m(!1), J = m(null), G = m(!1);
    let N = null;
    function P() {
      var S, w;
      const re = h.value;
      re && r("active", {
        host: re.host,
        port: re.port,
        enabled: re.enabled,
        // Only the freshly minted path — the stored ones cannot be recovered, and
        // printing a placeholder in a mount line somebody copies would produce a
        // command that fails with no clue why.
        path: (S = D.value) == null ? void 0 : S.path,
        readOnly: ((w = C.value) == null ? void 0 : w.read_only) ?? T.value
      });
    }
    dt(async () => {
      await B(), P();
    });
    async function le() {
      O.value = !0;
      try {
        await I({
          label: $.value.trim() || u("conn.nfs.defaultLabel"),
          storage: M.value.trim() || void 0,
          prefix: z.value.trim() || void 0,
          read_only: T.value,
          allow_cidrs: Y.value.trim() || void 0
        }), $.value = "", P();
      } finally {
        O.value = !1;
      }
    }
    async function ve(re) {
      O.value = !0;
      try {
        await U(re.id, !re.disabled_at), P();
      } finally {
        O.value = !1;
      }
    }
    async function he(re) {
      if (J.value !== re.id) {
        J.value = re.id;
        return;
      }
      J.value = null, O.value = !0;
      try {
        await x(re.id), P();
      } finally {
        O.value = !1;
      }
    }
    const oe = k(() => {
      var j, K, Z;
      const re = h.value, S = (j = D.value) == null ? void 0 : j.path;
      if (!re || !S) return "";
      const w = (Z = (K = D.value) == null ? void 0 : K.export) != null && Z.read_only ? ",ro" : "";
      return `sudo mount -t nfs -o nfsvers=3,tcp,port=${re.port},mountport=${re.port},nolock${w} ${re.host}:${S} /mnt/filex`;
    });
    async function ue() {
      const re = oe.value;
      if (!re) return;
      let S = !1;
      try {
        await navigator.clipboard.writeText(re), S = !0;
      } catch {
        try {
          const w = document.createElement("textarea");
          w.value = re, w.setAttribute("readonly", ""), w.style.position = "fixed", w.style.opacity = "0", document.body.appendChild(w), w.select(), S = document.execCommand("copy"), document.body.removeChild(w);
        } catch {
          S = !1;
        }
      }
      S && (G.value = !0, N && clearTimeout(N), N = setTimeout(() => G.value = !1, 1600));
    }
    function Q(re) {
      const S = new Date(re ?? "").getTime();
      return Number.isNaN(S) ? "" : v(S);
    }
    function pe(re) {
      return re.storage_name ? re.prefix ? `${re.storage_name}/${re.prefix}` : re.storage_name : u("conn.nfs.scopeAll");
    }
    return (re, S) => (c(), d("section", Y0, [
      o("header", W0, [
        o("h4", q0, f(s(u)("conn.nfs.title")), 1),
        o("p", G0, f(s(u)("conn.nfs.lead")), 1)
      ]),
      o("p", X0, f(s(u)("conn.nfs.pathIsSecret")), 1),
      s(h) && !s(h).enabled ? (c(), d("p", J0, f(s(u)("conn.nfs.disabled")), 1)) : g("", !0),
      s(A) === !1 ? (c(), d("p", Z0, f(s(u)("conn.nfs.cannotMint")), 1)) : g("", !0),
      s(y) ? (c(), d("p", Q0, f(s(y)), 1)) : g("", !0),
      s(A) ? (c(), d("div", e2, [
        Ve(o("input", {
          "onUpdate:modelValue": S[0] || (S[0] = (w) => $.value = w),
          class: "fe-cfield__input",
          placeholder: s(u)("conn.nfs.label"),
          "data-testid": "nfs-label"
        }, null, 8, t2), [
          [rt, $.value]
        ]),
        Ve(o("select", {
          "onUpdate:modelValue": S[1] || (S[1] = (w) => M.value = w),
          class: "fe-cfield__input",
          "data-testid": "nfs-storage"
        }, [
          o("option", n2, f(s(u)("conn.nfs.everyStorage")), 1),
          (c(!0), d(ae, null, Te(e.storages, (w) => (c(), d("option", {
            key: w,
            value: w
          }, f(w), 9, a2))), 128))
        ], 512), [
          [on, M.value]
        ]),
        Ve(o("input", {
          "onUpdate:modelValue": S[2] || (S[2] = (w) => z.value = w),
          class: "fe-cfield__input",
          placeholder: s(u)("conn.nfs.prefix"),
          disabled: !M.value,
          "data-testid": "nfs-prefix"
        }, null, 8, o2), [
          [rt, z.value]
        ]),
        Ve(o("input", {
          "onUpdate:modelValue": S[3] || (S[3] = (w) => Y.value = w),
          class: "fe-cfield__input",
          placeholder: s(u)("conn.nfs.allowCidrs"),
          "data-testid": "nfs-cidrs"
        }, null, 8, s2), [
          [rt, Y.value]
        ]),
        o("label", r2, [
          Ve(o("input", {
            type: "checkbox",
            "onUpdate:modelValue": S[4] || (S[4] = (w) => T.value = w),
            "data-testid": "nfs-readonly"
          }, null, 512), [
            [An, T.value]
          ]),
          Je(" " + f(s(u)("conn.nfs.readOnly")), 1)
        ]),
        o("button", {
          class: "fe-s3keys__btn",
          disabled: O.value,
          "data-testid": "nfs-mint",
          onClick: le
        }, f(s(u)("conn.nfs.mint")), 9, i2)
      ])) : g("", !0),
      s(A) ? (c(), d("p", l2, f(s(u)("conn.nfs.readOnlyHint")), 1)) : g("", !0),
      s(D) ? (c(), d("div", c2, [
        o("p", u2, f(s(u)("conn.nfs.once")), 1),
        o("div", d2, [
          o("code", null, f(oe.value), 1),
          o("button", {
            class: "fe-s3keys__copy",
            onClick: ue
          }, f(G.value ? s(u)("conn.guide.copied") : s(u)("conn.guide.copy")), 1)
        ]),
        o("button", {
          class: "fe-s3keys__dismiss",
          onClick: S[5] || (S[5] = //@ts-ignore
          (...w) => s(E) && s(E)(...w))
        }, f(s(u)("conn.nfs.dismiss")), 1)
      ])) : g("", !0),
      s(b) ? (c(), d("p", f2, "…")) : s(p).length ? (c(), d("table", p2, [
        o("thead", null, [
          o("tr", null, [
            o("th", null, f(s(u)("conn.nfs.col.label")), 1),
            o("th", null, f(s(u)("conn.nfs.col.scope")), 1),
            o("th", null, f(s(u)("conn.nfs.col.mode")), 1),
            o("th", null, f(s(u)("conn.nfs.col.lastUsed")), 1),
            S[6] || (S[6] = o("th", null, null, -1))
          ])
        ]),
        o("tbody", null, [
          (c(!0), d(ae, null, Te(s(p), (w) => (c(), d("tr", {
            key: w.id,
            class: we({ "is-off": !!w.disabled_at })
          }, [
            o("td", null, f(w.label || s(u)("conn.nfs.noLabel")), 1),
            o("td", null, f(pe(w)), 1),
            o("td", null, f(w.read_only ? s(u)("conn.nfs.modeRead") : s(u)("conn.nfs.modeWrite")), 1),
            o("td", null, f(w.last_used_at ? Q(w.last_used_at) : s(u)("conn.nfs.neverUsed")), 1),
            o("td", v2, [
              o("button", {
                class: "fe-s3keys__link",
                disabled: O.value,
                onClick: (j) => ve(w)
              }, f(w.disabled_at ? s(u)("conn.nfs.enable") : s(u)("conn.nfs.disable")), 9, h2),
              o("button", {
                class: "fe-s3keys__link is-danger",
                disabled: O.value,
                onClick: (j) => he(w)
              }, f(J.value === w.id ? s(u)("conn.nfs.confirm") : s(u)("conn.nfs.revoke")), 9, m2)
            ])
          ], 2))), 128))
        ])
      ])) : s(A) ? (c(), d("p", y2, f(s(u)("conn.nfs.empty")), 1)) : g("", !0)
    ]));
  }
});
function g2(e) {
  const t = Ya(e), n = wa(e), r = (U) => `${n}${U}`, a = wn([]), u = m(!1), v = m(!1), p = m(null), h = m(null), b = m(null);
  function y(U) {
    const x = U;
    if (x != null && x.detail)
      try {
        const E = JSON.parse(x.detail);
        if (E != null && E.error) return E.error;
      } catch {
      }
    return (x == null ? void 0 : x.message) || String(U);
  }
  function A(U) {
    return U == null ? void 0 : U.status;
  }
  async function D() {
    u.value = !0, p.value = null;
    try {
      const U = await t.jsonFetch(r("/api/tokens"));
      a.value = Array.isArray(U == null ? void 0 : U.tokens) ? U.tokens : [], h.value = !0;
    } catch (U) {
      a.value = [];
      const x = A(U);
      h.value = !1, x !== 401 && x !== 403 && (p.value = y(U));
    } finally {
      u.value = !1, v.value = !0;
    }
  }
  async function C(U) {
    p.value = null;
    try {
      const x = await t.jsonFetch(r("/api/tokens"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(U)
      });
      return b.value = x, await D(), x;
    } catch (x) {
      return p.value = y(x), null;
    }
  }
  async function B(U) {
    var x, E;
    p.value = null;
    try {
      await t.jsonFetch(r(`/api/tokens/${U}`), { method: "DELETE" }), ((E = (x = b.value) == null ? void 0 : x.row) == null ? void 0 : E.id) === U && (b.value = null), await D();
    } catch ($) {
      p.value = y($);
    }
  }
  function I() {
    b.value = null;
  }
  return { tokens: a, loading: u, loaded: v, error: p, canMint: h, revealed: b, load: D, create: C, remove: B, dismiss: I };
}
const k2 = {
  class: "fe-s3keys",
  "data-testid": "api-tokens"
}, _2 = { class: "fe-s3keys__head" }, w2 = { class: "fe-s3keys__title" }, $2 = { class: "fe-s3keys__lead" }, x2 = {
  key: 0,
  class: "fe-s3keys__muted"
}, S2 = {
  key: 1,
  class: "fe-s3keys__warn"
}, C2 = {
  key: 2,
  class: "fe-s3keys__form"
}, T2 = ["placeholder"], M2 = ["disabled"], E2 = {
  key: 3,
  class: "fe-tokform",
  "data-testid": "token-form-full"
}, z2 = ["placeholder"], A2 = { class: "fe-tokform__scopes" }, P2 = { class: "fe-tokform__legend" }, L2 = ["onUpdate:modelValue", "data-testid"], D2 = { class: "fe-tokform__field" }, O2 = { class: "fe-tokform__label" }, B2 = ["placeholder"], I2 = { class: "fe-tokform__row" }, H2 = { class: "fe-tokform__field fe-tokform__field--narrow" }, F2 = { class: "fe-tokform__label" }, N2 = ["placeholder"], K2 = ["disabled"], R2 = { class: "fe-s3keys__hint" }, U2 = {
  key: 4,
  class: "fe-s3keys__secret",
  "data-testid": "token-secret"
}, V2 = { class: "fe-s3keys__once" }, j2 = { class: "fe-s3keys__pair" }, Y2 = {
  key: 5,
  class: "fe-s3keys__muted"
}, W2 = { class: "fe-s3keys__table" }, q2 = { class: "fe-s3keys__actions" }, G2 = ["disabled", "onClick"], X2 = {
  key: 7,
  class: "fe-s3keys__muted"
}, J2 = {
  key: 8,
  class: "fe-s3keys__hint"
}, Hd = /* @__PURE__ */ qe({
  __name: "TokensPanel",
  props: {
    config: {},
    full: { type: Boolean },
    protocol: {},
    host: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = k(() => cn(n.config.locale)), { t: u, formatDate: v } = tt(a), { scrolledX: p, onScroll: h } = Zi(), { tokens: b, loading: y, error: A, canMint: D, revealed: C, load: B, create: I, remove: U, dismiss: x } = g2(
      n.config
    ), E = m(""), $ = m(!1), M = m(!1), z = m(null), T = ["read", "write", "delete", "mcp"], Y = m({
      read: !0,
      write: !1,
      delete: !1,
      mcp: !1
    }), O = m(""), J = m(null);
    function G() {
      const Q = T.filter((re) => Y.value[re]), pe = O.value.trim();
      return pe && Q.push("root:" + pe), Q.join(",");
    }
    dt(async () => {
      await B(), r("active", { hasToken: b.value.length > 0 });
    });
    function N() {
      const Q = (n.protocol || "").toUpperCase();
      return Q ? n.host ? `${Q} — ${n.host}` : Q : u("conn.tokens.defaultName", { date: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10) });
    }
    function P() {
      return n.protocol ? N() : u("conn.tokens.namePlaceholder");
    }
    async function le() {
      if (!$.value) {
        $.value = !0, M.value = !1;
        try {
          if (n.full) {
            const Q = G() || "read";
            await I({
              label: E.value.trim() || N(),
              scopes: Q,
              expires_in_days: J.value && J.value > 0 ? J.value : void 0
            }), await B(), r("active", { hasToken: b.value.length > 0 }), E.value = "", O.value = "";
            return;
          }
          await I({ label: E.value.trim() || N(), scopes: "read,write,delete" }), await B(), r("active", { hasToken: b.value.length > 0 }), E.value = "";
        } finally {
          $.value = !1;
        }
      }
    }
    async function ve(Q) {
      if (z.value !== Q.id) {
        z.value = Q.id;
        return;
      }
      z.value = null, $.value = !0;
      try {
        await U(Q.id), r("active", { hasToken: b.value.length > 0 });
      } finally {
        $.value = !1;
      }
    }
    async function he() {
      var Q;
      if ((Q = C.value) != null && Q.token)
        try {
          await navigator.clipboard.writeText(C.value.token), M.value = !0, window.setTimeout(() => M.value = !1, 1600);
        } catch {
        }
    }
    function oe(Q) {
      const pe = new Date(Q ?? "").getTime();
      return Number.isNaN(pe) ? "" : v(pe);
    }
    function ue(Q) {
      return Q.last_used_at ? oe(Q.last_used_at) : u("conn.tokens.neverUsed");
    }
    return (Q, pe) => (c(), d("section", k2, [
      o("header", _2, [
        o("h4", w2, f(s(u)("conn.tokens.title")), 1),
        o("p", $2, f(s(u)("conn.tokens.lead")), 1)
      ]),
      s(D) === !1 ? (c(), d("p", x2, f(s(u)("conn.tokens.cannotMint")), 1)) : g("", !0),
      s(A) ? (c(), d("p", S2, f(s(A)), 1)) : g("", !0),
      s(D) && !e.full ? (c(), d("div", C2, [
        Ve(o("input", {
          "onUpdate:modelValue": pe[0] || (pe[0] = (re) => E.value = re),
          class: "fe-cfield__input",
          placeholder: P(),
          "data-testid": "token-label"
        }, null, 8, T2), [
          [rt, E.value]
        ]),
        o("button", {
          class: "fe-s3keys__btn",
          disabled: $.value,
          "data-testid": "token-mint",
          onClick: le
        }, f(s(u)("conn.tokens.mint")), 9, M2)
      ])) : s(D) ? (c(), d("div", E2, [
        Ve(o("input", {
          "onUpdate:modelValue": pe[1] || (pe[1] = (re) => E.value = re),
          class: "fe-cfield__input",
          placeholder: P(),
          "data-testid": "token-label"
        }, null, 8, z2), [
          [rt, E.value]
        ]),
        o("fieldset", A2, [
          o("legend", P2, f(s(u)("conn.tokens.scopes")), 1),
          (c(), d(ae, null, Te(T, (re) => o("label", {
            key: re,
            class: "fe-tokform__scope"
          }, [
            Ve(o("input", {
              "onUpdate:modelValue": (S) => Y.value[re] = S,
              type: "checkbox",
              "data-testid": `token-scope-${re}`
            }, null, 8, L2), [
              [An, Y.value[re]]
            ]),
            o("span", null, f(re), 1)
          ])), 64))
        ]),
        o("label", D2, [
          o("span", O2, f(s(u)("conn.tokens.root")), 1),
          Ve(o("input", {
            "onUpdate:modelValue": pe[2] || (pe[2] = (re) => O.value = re),
            class: "fe-cfield__input",
            placeholder: s(u)("conn.tokens.rootPlaceholder"),
            "data-testid": "token-root"
          }, null, 8, B2), [
            [rt, O.value]
          ])
        ]),
        o("div", I2, [
          o("label", H2, [
            o("span", F2, f(s(u)("conn.tokens.expiry")), 1),
            Ve(o("input", {
              "onUpdate:modelValue": pe[3] || (pe[3] = (re) => J.value = re),
              type: "number",
              min: "0",
              class: "fe-cfield__input",
              placeholder: s(u)("conn.tokens.expiryNever"),
              "data-testid": "token-expiry"
            }, null, 8, N2), [
              [
                rt,
                J.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          o("button", {
            class: "fe-s3keys__btn",
            disabled: $.value,
            "data-testid": "token-mint",
            onClick: le
          }, f(s(u)("conn.tokens.mint")), 9, K2)
        ]),
        o("p", R2, f(s(u)("conn.tokens.capNote")), 1)
      ])) : g("", !0),
      s(C) ? (c(), d("div", U2, [
        o("p", V2, f(s(u)("conn.tokens.once")), 1),
        o("div", j2, [
          o("code", null, f(s(C).token), 1),
          o("button", {
            class: "fe-s3keys__copy",
            onClick: he
          }, f(M.value ? s(u)("conn.guide.copied") : s(u)("conn.guide.copy")), 1)
        ]),
        o("button", {
          class: "fe-s3keys__dismiss",
          onClick: pe[4] || (pe[4] = //@ts-ignore
          (...re) => s(x) && s(x)(...re))
        }, f(s(u)("conn.tokens.dismiss")), 1)
      ])) : g("", !0),
      s(y) ? (c(), d("p", Y2, "…")) : s(b).length ? (c(), d("div", {
        key: 6,
        class: we(["fe-s3keys__scroll", { "is-scrolled-x": s(p) }]),
        onScrollPassive: pe[5] || (pe[5] = //@ts-ignore
        (...re) => s(h) && s(h)(...re))
      }, [
        o("table", W2, [
          o("thead", null, [
            o("tr", null, [
              o("th", null, f(s(u)("conn.tokens.col.label")), 1),
              o("th", null, f(s(u)("conn.tokens.col.scopes")), 1),
              o("th", null, f(s(u)("conn.tokens.col.used")), 1),
              pe[6] || (pe[6] = o("th", null, null, -1))
            ])
          ]),
          o("tbody", null, [
            (c(!0), d(ae, null, Te(s(b), (re) => (c(), d("tr", {
              key: re.id
            }, [
              o("td", null, f(re.label || "—"), 1),
              o("td", null, [
                o("code", null, f(re.scopes), 1)
              ]),
              o("td", null, f(ue(re)), 1),
              o("td", q2, [
                o("button", {
                  class: "fe-s3keys__link is-danger",
                  disabled: $.value,
                  onClick: (S) => ve(re)
                }, f(z.value === re.id ? s(u)("conn.tokens.confirm") : s(u)("conn.tokens.revoke")), 9, G2)
              ])
            ]))), 128))
          ])
        ])
      ], 34)) : s(D) ? (c(), d("p", X2, f(s(u)("conn.tokens.empty")), 1)) : g("", !0),
      s(D) ? (c(), d("p", J2, f(s(u)("conn.tokens.revokeHint")), 1)) : g("", !0)
    ]));
  }
}), Z2 = { class: "fe-conn__head" }, Q2 = { class: "fe-conn__title" }, e$ = { class: "fe-conn__sub" }, t$ = ["aria-label"], n$ = ["innerHTML"], a$ = {
  class: "fe-conn__tabs",
  role: "tablist"
}, o$ = ["aria-selected"], s$ = ["aria-selected"], r$ = {
  key: 0,
  class: "fe-conn__body",
  role: "tabpanel"
}, i$ = {
  key: 0,
  class: "fe-conn__muted"
}, l$ = {
  key: 0,
  class: "fe-conn__card fe-conn__card--notice",
  "data-testid": "no-admin"
}, c$ = { class: "fe-conn__muted" }, u$ = { class: "fe-conn__muted" }, d$ = {
  key: 1,
  class: "fe-conn__list"
}, f$ = { class: "fe-conn__rowmain" }, p$ = { class: "fe-conn__name" }, v$ = { class: "fe-conn__muted" }, h$ = {
  key: 0,
  class: "fe-conn__error"
}, m$ = {
  key: 1,
  class: "fe-conn__card fe-conn__form",
  "data-testid": "storage-form"
}, y$ = { class: "fe-conn__formtitle" }, b$ = { class: "fe-cfield__row" }, g$ = {
  class: "fe-cfield__label",
  for: "fe-conn-name"
}, k$ = ["placeholder"], _$ = { class: "fe-cfield__help" }, w$ = { class: "fe-cfield__row" }, $$ = {
  class: "fe-cfield__label",
  for: "fe-conn-driver"
}, x$ = ["value", "disabled"], S$ = ["value"], C$ = {
  key: 0,
  class: "fe-cfield__help"
}, T$ = { class: "fe-cfield__check" }, M$ = { class: "fe-cfield__check" }, E$ = {
  key: 0,
  class: "fe-conn__error",
  "data-testid": "form-error"
}, z$ = { class: "fe-conn__actions" }, A$ = ["disabled"], P$ = ["disabled"], L$ = { key: 2 }, D$ = { class: "fe-conn__listhead" }, O$ = { class: "fe-conn__muted" }, B$ = {
  key: 0,
  class: "fe-conn__empty"
}, I$ = {
  class: "fe-conn__list",
  "data-testid": "storage-list"
}, H$ = { class: "fe-conn__rowmain" }, F$ = { class: "fe-conn__rowtext" }, N$ = { class: "fe-conn__name" }, K$ = { class: "fe-conn__badge" }, R$ = {
  key: 0,
  class: "fe-conn__badge fe-conn__badge--warn"
}, U$ = {
  key: 1,
  class: "fe-conn__badge"
}, V$ = {
  key: 2,
  class: "fe-conn__muted fe-conn__summary"
}, j$ = { class: "fe-conn__rowbtns" }, Y$ = ["data-testid", "onClick"], W$ = ["onClick"], q$ = {
  key: 1,
  class: "fe-conn__body",
  role: "tabpanel"
}, G$ = { class: "fe-conn__guidebar" }, X$ = {
  key: 0,
  class: "fe-conn__pick"
}, J$ = { class: "fe-cfield__label" }, Z$ = ["value"], Q$ = { class: "fe-conn__pick" }, ex = { class: "fe-cfield__label" }, tx = { value: "" }, nx = ["value"], ax = /* @__PURE__ */ qe({
  __name: "ConnectionsPanel",
  props: {
    config: {},
    initialTab: {},
    closable: { type: Boolean }
  },
  emits: ["changed", "close", "error"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = k(() => cn(n.config.locale)), { t: u } = tt(a), {
      drivers: v,
      storages: p,
      visible: h,
      me: b,
      publicUrl: y,
      loading: A,
      loaded: D,
      error: C,
      canManage: B,
      denial: I,
      load: U,
      createStorage: x,
      updateStorage: E,
      deleteStorage: $,
      testStorage: M,
      descriptor: z,
      fields: T,
      defaults: Y,
      missingRequired: O
    } = Ww(n.config), J = typeof window < "u" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : void 0, G = m(!!(J != null && J.matches));
    function N(R) {
      G.value = R.matches;
    }
    const P = k(() => {
      const R = n.config.theme ?? "auto";
      return R === "light" || R === "dark" ? R : G.value ? "dark" : "light";
    }), le = m(n.initialTab ?? "storages"), ve = m({ kind: "none" }), he = m(""), oe = m(""), ue = m(!1), Q = m(!0), pe = m({}), re = m([]), S = m(!1), w = m(!1), j = m(null), K = m(
      null
    ), Z = m(null), W = m(null), $e = k(
      () => v.value.map((R) => {
        const X = u(R.i18n_key);
        return { value: R.driver, label: X === R.i18n_key ? R.label : X };
      })
    ), Se = k(() => T(oe.value));
    function ze() {
      var X;
      const R = ((X = v.value[0]) == null ? void 0 : X.driver) ?? "";
      oe.value = R, he.value = "", ue.value = !1, Q.value = !0, pe.value = Y(R), re.value = [], j.value = null, Z.value = null, ve.value = { kind: "new" };
    }
    function Ne(R) {
      oe.value = R.driver, he.value = R.name, ue.value = !!R.read_only, Q.value = R.enabled !== !1, pe.value = { ...R.config ?? {} }, re.value = [], j.value = null, Z.value = null, ve.value = { kind: "edit", row: R };
    }
    function be() {
      ve.value = { kind: "none" }, j.value = null, Z.value = null;
    }
    function De(R) {
      oe.value = R, pe.value = Y(R), re.value = [], j.value = null;
    }
    function ie() {
      const R = O(oe.value, pe.value).map((X) => X.key);
      return re.value = R, he.value.trim() ? R.length ? Z.value = u("conn.form.fillRequired") : Z.value = null : Z.value = u("conn.form.nameRequired"), !Z.value;
    }
    async function ce() {
      w.value = !0, j.value = null;
      try {
        j.value = await M({
          driver: oe.value,
          config: pe.value
        });
      } finally {
        w.value = !1;
      }
    }
    async function L() {
      if (ie()) {
        S.value = !0, Z.value = null;
        try {
          const R = {
            name: he.value.trim(),
            driver: oe.value,
            config: pe.value,
            read_only: ue.value,
            enabled: Q.value
          };
          ve.value.kind === "edit" ? await E(ve.value.row.id, R) : await x(R), be(), r("changed");
        } catch (R) {
          const X = R ?? {};
          let ye = "";
          try {
            ye = X.detail ? JSON.parse(X.detail).error ?? "" : "";
          } catch {
            ye = X.detail ?? "";
          }
          Z.value = ye || X.message || String(R), r("error", { message: Z.value });
        } finally {
          S.value = !1;
        }
      }
    }
    async function se(R) {
      if (W.value !== R.id) {
        W.value = R.id;
        return;
      }
      W.value = null;
      try {
        await $(R.id), r("changed");
      } catch (X) {
        r("error", { message: X.message });
      }
    }
    function Ce(R) {
      const X = z(R.driver), ye = R.config ?? {}, je = [], Qe = X == null ? void 0 : X.fields.find((fe) => fe.root), at = (fe, Pe = []) => {
        for (const Be of [fe, ...Pe]) {
          const ht = ye[Be];
          if (typeof ht == "string" && ht.trim()) return ht;
        }
        return "";
      }, Ye = at("endpoint") || at("url") || at("host");
      Ye && je.push(Ye);
      const lt = at("bucket");
      if (lt && je.push(lt), Qe) {
        const fe = at(Qe.key, Qe.aliases ?? []);
        fe && je.push(fe);
      }
      return je.join(" · ");
    }
    const We = n1(), Ie = m(We[0] ?? "webdav"), Ze = m(""), vt = k(() => Yw(n.config, y.value)), Xe = m(
      null
    ), Ae = m(null), V = k(
      () => {
        var R, X, ye, je, Qe, at, Ye, lt, fe, Pe, Be, ht, Ft, ft, qt, Gt, wt, en, $t, kt, Dt, At, Ot, Bt, un, pt, tn;
        return a1(
          Ie.value,
          {
            origin: vt.value,
            user: ((R = b.value) == null ? void 0 : R.email) ?? "",
            storages: h.value,
            storage: Ze.value || void 0,
            s3Endpoint: (X = Xe.value) == null ? void 0 : X.endpoint,
            s3PathStyle: (ye = Xe.value) == null ? void 0 : ye.pathStyle,
            s3AccessKeyID: ((je = Xe.value) == null ? void 0 : je.accessKeyID) || void 0,
            s3Secret: (Qe = Xe.value) == null ? void 0 : Qe.secret,
            sftpHost: ((at = Ae.value) == null ? void 0 : at.host) || void 0,
            sftpPort: (Ye = Ae.value) == null ? void 0 : Ye.port,
            sftpEnabled: (lt = Ae.value) == null ? void 0 : lt.enabled,
            sftpLogin: ((fe = Ae.value) == null ? void 0 : fe.login) || void 0,
            sftpHasKey: (Pe = Ae.value) == null ? void 0 : Pe.hasKey,
            ftpsHost: ((ht = (Be = Ae.value) == null ? void 0 : Be.ftps) == null ? void 0 : ht.host) || void 0,
            ftpsPort: (ft = (Ft = Ae.value) == null ? void 0 : Ft.ftps) == null ? void 0 : ft.port,
            ftpsEnabled: (Gt = (qt = Ae.value) == null ? void 0 : qt.ftps) == null ? void 0 : Gt.enabled,
            ftpsPasvMin: (en = (wt = Ae.value) == null ? void 0 : wt.ftps) == null ? void 0 : en.pasv_min,
            ftpsPasvMax: (kt = ($t = Ae.value) == null ? void 0 : $t.ftps) == null ? void 0 : kt.pasv_max,
            ftpsSelfSigned: (At = (Dt = Ae.value) == null ? void 0 : Dt.ftps) == null ? void 0 : At.self_signed,
            nfsHost: ((Ot = K.value) == null ? void 0 : Ot.host) || void 0,
            nfsPort: (Bt = K.value) == null ? void 0 : Bt.port,
            nfsEnabled: (un = K.value) == null ? void 0 : un.enabled,
            nfsPath: (pt = K.value) == null ? void 0 : pt.path,
            nfsReadOnly: (tn = K.value) == null ? void 0 : tn.readOnly
          },
          u
        );
      }
    );
    return He(
      () => h.value,
      (R) => {
        !Ze.value && R.length === 1 && (Ze.value = R[0]);
      }
    ), dt(() => {
      var R;
      (R = J == null ? void 0 : J.addEventListener) == null || R.call(J, "change", N), U();
    }), it(() => {
      var R;
      return (R = J == null ? void 0 : J.removeEventListener) == null ? void 0 : R.call(J, "change", N);
    }), He(
      () => [n.config.apiBase, n.config.endpoint],
      () => {
        be(), U();
      }
    ), (R, X) => (c(), d("div", {
      class: we(["fe-conn", {
        "fe--theme-dark": P.value === "dark",
        "fe--theme-light": P.value === "light"
      }]),
      "data-testid": "connections-panel"
    }, [
      o("header", Z2, [
        o("div", null, [
          o("h2", Q2, f(s(u)("conn.title")), 1),
          o("p", e$, f(s(u)("conn.subtitle", { host: s(ka)(vt.value) })), 1)
        ]),
        e.closable ? (c(), d("button", {
          key: 0,
          type: "button",
          class: "fe-conn__btn",
          "data-testid": "connections-close",
          "aria-label": s(u)("conn.close"),
          onClick: X[0] || (X[0] = (ye) => r("close"))
        }, [
          o("span", {
            "aria-hidden": "true",
            innerHTML: s(Ue)("close")
          }, null, 8, n$)
        ], 8, t$)) : g("", !0)
      ]),
      o("nav", a$, [
        o("button", {
          type: "button",
          role: "tab",
          class: we(["fe-conn__tab", { "is-active": le.value === "storages" }]),
          "aria-selected": le.value === "storages",
          "data-testid": "tab-storages",
          onClick: X[1] || (X[1] = (ye) => le.value = "storages")
        }, f(s(u)("conn.tab.storages")), 11, o$),
        o("button", {
          type: "button",
          role: "tab",
          class: we(["fe-conn__tab", { "is-active": le.value === "connect" }]),
          "aria-selected": le.value === "connect",
          "data-testid": "tab-connect",
          onClick: X[2] || (X[2] = (ye) => le.value = "connect")
        }, f(s(u)("conn.tab.connect")), 11, s$)
      ]),
      le.value === "storages" ? (c(), d("section", r$, [
        s(A) && !s(D) ? (c(), d("p", i$, f(s(u)("conn.loading")), 1)) : (c(), d(ae, { key: 1 }, [
          s(B) === !1 ? (c(), d("div", l$, [
            o("strong", null, f(s(u)("conn.denied.title")), 1),
            o("p", c$, f(s(I) === "anonymous" ? s(u)("conn.denied.anonymous") : s(I) === "unreachable" ? s(u)("conn.denied.unreachable", { error: s(C) ?? "" }) : s(u)("conn.denied.none")), 1),
            o("p", u$, f(s(u)("conn.denied.guideHint")), 1),
            o("button", {
              type: "button",
              class: "fe-conn__btn fe-conn__btn--primary",
              onClick: X[3] || (X[3] = (ye) => le.value = "connect")
            }, f(s(u)("conn.denied.guideCta")), 1)
          ])) : g("", !0),
          s(B) === !1 && s(h).length ? (c(), d("div", d$, [
            (c(!0), d(ae, null, Te(s(h), (ye) => (c(), d("div", {
              key: ye,
              class: "fe-conn__card"
            }, [
              o("div", f$, [
                o("strong", p$, f(ye), 1),
                o("span", v$, f(s(u)("conn.visibleOnly")), 1)
              ])
            ]))), 128))
          ])) : g("", !0),
          s(B) ? (c(), d(ae, { key: 2 }, [
            s(C) ? (c(), d("p", h$, f(s(C)), 1)) : g("", !0),
            ve.value.kind !== "none" ? (c(), d("div", m$, [
              o("h3", y$, f(ve.value.kind === "edit" ? s(u)("conn.form.editTitle", { name: he.value }) : s(u)("conn.form.newTitle")), 1),
              o("div", b$, [
                o("label", g$, [
                  Je(f(s(u)("conn.form.name")), 1),
                  X[14] || (X[14] = o("span", { class: "fe-cfield__req" }, "*", -1))
                ]),
                Ve(o("input", {
                  id: "fe-conn-name",
                  "onUpdate:modelValue": X[4] || (X[4] = (ye) => he.value = ye),
                  class: "fe-cfield__input",
                  "data-testid": "storage-name",
                  placeholder: s(u)("conn.form.namePlaceholder")
                }, null, 8, k$), [
                  [rt, he.value]
                ]),
                o("p", _$, f(s(u)("conn.form.nameHelp")), 1)
              ]),
              o("div", w$, [
                o("label", $$, f(s(u)("conn.form.driver")), 1),
                o("select", {
                  id: "fe-conn-driver",
                  class: "fe-cfield__input",
                  "data-testid": "storage-driver",
                  value: oe.value,
                  disabled: ve.value.kind === "edit",
                  onChange: X[5] || (X[5] = (ye) => De(ye.target.value))
                }, [
                  (c(!0), d(ae, null, Te($e.value, (ye) => (c(), d("option", {
                    key: ye.value,
                    value: ye.value
                  }, f(ye.label), 9, S$))), 128))
                ], 40, x$),
                ve.value.kind === "edit" ? (c(), d("p", C$, f(s(u)("conn.form.driverLocked")), 1)) : g("", !0)
              ]),
              Ge(T1, {
                modelValue: pe.value,
                "onUpdate:modelValue": X[6] || (X[6] = (ye) => pe.value = ye),
                fields: Se.value,
                locale: a.value,
                invalid: re.value
              }, null, 8, ["modelValue", "fields", "locale", "invalid"]),
              o("label", T$, [
                Ve(o("input", {
                  "onUpdate:modelValue": X[7] || (X[7] = (ye) => ue.value = ye),
                  type: "checkbox",
                  "data-testid": "storage-readonly"
                }, null, 512), [
                  [An, ue.value]
                ]),
                o("span", null, f(s(u)("conn.form.readOnly")), 1)
              ]),
              o("label", M$, [
                Ve(o("input", {
                  "onUpdate:modelValue": X[8] || (X[8] = (ye) => Q.value = ye),
                  type: "checkbox"
                }, null, 512), [
                  [An, Q.value]
                ]),
                o("span", null, f(s(u)("conn.form.enabled")), 1)
              ]),
              Z.value ? (c(), d("p", E$, f(Z.value), 1)) : g("", !0),
              j.value ? (c(), d("p", {
                key: 1,
                class: we(["fe-conn__testresult", j.value.ok ? "is-ok" : "is-bad"]),
                "data-testid": "test-result"
              }, f(j.value.ok ? s(u)("conn.form.testOk", { count: j.value.object_count ?? 0 }) : s(u)("conn.form.testFail", { error: j.value.error ?? "" })), 3)) : g("", !0),
              o("div", z$, [
                o("button", {
                  type: "button",
                  class: "fe-conn__btn",
                  "data-testid": "storage-test",
                  disabled: w.value,
                  onClick: ce
                }, f(w.value ? s(u)("conn.form.testing") : s(u)("conn.form.test")), 9, A$),
                o("button", {
                  type: "button",
                  class: "fe-conn__btn fe-conn__btn--primary",
                  "data-testid": "storage-save",
                  disabled: S.value,
                  onClick: L
                }, f(S.value ? s(u)("conn.form.saving") : s(u)("conn.form.save")), 9, P$),
                o("button", {
                  type: "button",
                  class: "fe-conn__btn",
                  onClick: be
                }, f(s(u)("conn.form.cancel")), 1)
              ])
            ])) : (c(), d("div", L$, [
              o("div", D$, [
                o("span", O$, f(s(u)("conn.list.count", { n: s(p).length })), 1),
                o("button", {
                  type: "button",
                  class: "fe-conn__btn fe-conn__btn--primary",
                  "data-testid": "storage-add",
                  onClick: ze
                }, " + " + f(s(u)("conn.list.add")), 1)
              ]),
              s(p).length ? g("", !0) : (c(), d("p", B$, f(s(u)("conn.list.empty")), 1)),
              o("div", I$, [
                (c(!0), d(ae, null, Te(s(p), (ye) => (c(), d("div", {
                  key: ye.id,
                  class: "fe-conn__card"
                }, [
                  o("div", H$, [
                    o("div", F$, [
                      o("strong", N$, f(ye.name), 1),
                      o("span", K$, f(ye.driver), 1),
                      ye.read_only ? (c(), d("span", R$, f(s(u)("conn.list.readOnly")), 1)) : g("", !0),
                      ye.enabled === !1 ? (c(), d("span", U$, f(s(u)("conn.list.disabled")), 1)) : g("", !0),
                      Ce(ye) ? (c(), d("div", V$, f(Ce(ye)), 1)) : g("", !0)
                    ]),
                    o("div", j$, [
                      o("button", {
                        type: "button",
                        class: "fe-conn__btn",
                        "data-testid": `storage-edit-${ye.name}`,
                        onClick: (je) => Ne(ye)
                      }, f(s(u)("conn.list.edit")), 9, Y$),
                      o("button", {
                        type: "button",
                        class: "fe-conn__btn fe-conn__btn--danger",
                        onClick: (je) => se(ye)
                      }, f(W.value === ye.id ? s(u)("conn.list.confirm") : s(u)("conn.list.remove")), 9, W$)
                    ])
                  ])
                ]))), 128))
              ])
            ]))
          ], 64)) : g("", !0)
        ], 64))
      ])) : (c(), d("section", q$, [
        o("div", G$, [
          s(We).length > 1 ? (c(), d("label", X$, [
            o("span", J$, f(s(u)("conn.guide.protocol")), 1),
            Ve(o("select", {
              "onUpdate:modelValue": X[9] || (X[9] = (ye) => Ie.value = ye),
              class: "fe-cfield__input",
              "data-testid": "guide-protocol"
            }, [
              (c(!0), d(ae, null, Te(s(We), (ye) => (c(), d("option", {
                key: ye,
                value: ye
              }, f(s(t1)(ye)), 9, Z$))), 128))
            ], 512), [
              [on, Ie.value]
            ])
          ])) : g("", !0),
          o("label", Q$, [
            o("span", ex, f(s(u)("conn.guide.storage")), 1),
            Ve(o("select", {
              "onUpdate:modelValue": X[10] || (X[10] = (ye) => Ze.value = ye),
              class: "fe-cfield__input",
              "data-testid": "guide-storage"
            }, [
              o("option", tx, f(s(u)("conn.guide.allStorages")), 1),
              (c(!0), d(ae, null, Te(s(h), (ye) => (c(), d("option", {
                key: ye,
                value: ye
              }, f(ye), 9, nx))), 128))
            ], 512), [
              [on, Ze.value]
            ])
          ])
        ]),
        Ie.value === "s3" ? (c(), et($0, {
          key: 0,
          config: e.config,
          storages: s(h),
          onActive: X[11] || (X[11] = (ye) => Xe.value = ye)
        }, null, 8, ["config", "storages"])) : g("", !0),
        Ie.value === "sftp" || Ie.value === "ftps" ? (c(), et(V0, {
          key: 1,
          config: e.config,
          "keys-visible": Ie.value === "sftp",
          onActive: X[12] || (X[12] = (ye) => Ae.value = ye)
        }, null, 8, ["config", "keys-visible"])) : g("", !0),
        Ie.value === "nfs" ? (c(), et(b2, {
          key: 2,
          config: e.config,
          storages: s(h),
          onActive: X[13] || (X[13] = (ye) => K.value = ye)
        }, null, 8, ["config", "storages"])) : g("", !0),
        Ie.value === "ftps" || Ie.value === "webdav" || Ie.value === "mount" ? (c(), et(Hd, {
          key: 3,
          config: e.config,
          protocol: Ie.value,
          host: s(ka)(vt.value)
        }, null, 8, ["config", "protocol", "host"])) : g("", !0),
        V.value ? (c(), et(G1, {
          key: 4,
          guide: V.value,
          locale: a.value
        }, null, 8, ["guide", "locale"])) : g("", !0)
      ]))
    ], 2));
  }
}), ox = ["aria-label"], sx = { class: "fe-cmdp__inputwrap" }, rx = ["placeholder"], ix = ["aria-selected", "onMouseenter", "onClick"], lx = ["innerHTML"], cx = { class: "fe-cmdp__label" }, ux = { class: "fe-cmdp__group" }, dx = ["aria-selected", "onMouseenter", "onClick"], fx = ["innerHTML"], px = { class: "fe-cmdp__label" }, vx = { class: "fe-cmdp__group" }, hx = {
  key: 0,
  class: "fe-cmdp__loading"
}, mx = ["aria-selected", "onMouseenter", "onClick"], yx = ["innerHTML"], bx = { class: "fe-cmdp__hitbody" }, gx = { class: "fe-cmdp__hitline" }, kx = { class: "fe-cmdp__label" }, _x = {
  key: 0,
  class: "fe-cmdp__badge"
}, wx = ["title"], $x = {
  key: 1,
  class: "fe-cmdp__snippet"
}, xx = {
  key: 0,
  class: "fe-cmdp__mark"
}, Sx = { class: "fe-cmdp__group" }, Cx = ["aria-selected", "onMouseenter", "onClick", "onKeydown"], Tx = ["innerHTML"], Mx = { class: "fe-cmdp__label" }, Ex = ["title", "aria-label", "onClick"], zx = ["innerHTML"], Ax = { class: "fe-cmdp__group" }, Px = ["aria-selected", "onMouseenter", "onClick"], Lx = ["innerHTML"], Dx = { class: "fe-cmdp__label" }, Ox = {
  key: 4,
  class: "fe-cmdp__empty"
}, Bx = { class: "fe-cmdp__hint" }, Ix = 3, Hx = 8, Fx = 250, bu = "filex.saved-searches", gu = 10, Nx = /* @__PURE__ */ qe({
  __name: "CommandPalette",
  props: {
    open: { type: Boolean },
    locale: {},
    files: {},
    viewMode: {},
    canWrite: { type: Boolean },
    canGoUp: { type: Boolean },
    globalSearch: { type: Function },
    splitEnabled: { type: Boolean },
    initialQuery: {}
  },
  emits: ["close", "open-node", "navigate", "new-folder", "upload", "toggle-view", "open-trash", "refresh", "go-up", "open-hit", "open-theme", "open-shortcut-settings", "start-tour", "tab-new", "split-toggle"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a, nodeDisplayName: u } = tt(() => n.locale), v = m(""), p = m(0), h = m(null), b = m(null);
    function y(S) {
      const w = S.lastIndexOf(".");
      return w > 0 ? S.slice(w + 1) : "";
    }
    function A(S) {
      if (S.kind === "file") return fn(S.node);
      if (S.kind === "hit") {
        const w = String(S.hit.name ?? "");
        return fn({
          type: S.hit.type === "dir" ? "dir" : "file",
          extension: y(w),
          basename: w
        });
      }
      return Ue(S.icon);
    }
    function D(S, w) {
      if (!w) return 0;
      const j = S.toLocaleLowerCase(), K = w.toLocaleLowerCase(), Z = j.indexOf(K);
      if (Z === -1) return -1;
      let W = 100 - Math.min(Z, 50);
      return Z === 0 && (W += 40), W -= Math.min(j.length, 40) / 4, W;
    }
    const C = k(() => {
      const S = v.value.trim();
      if (!S.includes("/")) return [];
      const w = S.replace(/^\/+|\/+$/g, "");
      return w ? [
        { kind: "goto", id: `goto:${w}`, label: `${a("palette.goto")}: ${w}`, icon: "goto", path: w }
      ] : [];
    }), B = k(() => {
      const S = v.value.trim(), w = n.files.map((j) => ({ f: j, name: u(j), s: D(u(j), S) })).filter((j) => j.s >= 0);
      return S && w.sort((j, K) => K.s - j.s), w.slice(0, 8).map((j) => ({
        kind: "file",
        id: `file:${j.f.path}`,
        label: j.name,
        icon: "",
        // file rows draw their real tile — see iconHtml()
        node: j.f
      }));
    }), I = k(() => {
      const S = v.value.trim();
      return [
        { command: "new-folder", label: a("toolbar.new_folder"), icon: "new-folder", enabled: n.canWrite !== !1 },
        { command: "upload", label: a("toolbar.upload"), icon: "upload", enabled: n.canWrite !== !1 },
        /* wiring:d2 — the mark is the NEXT mode (list→grid→gallery→list), which is
           what pressing the row gets you; the three keys are the ViewSwitcher's own. */
        { command: "toggle-view", label: a("cmd.view_toggle"), icon: n.viewMode === "list" ? "view-grid" : n.viewMode === "grid" ? "view-gallery" : "view-list", enabled: !0 },
        { command: "open-trash", label: a("cmd.trash"), icon: "open-trash", enabled: !0 },
        { command: "refresh", label: a("toolbar.refresh"), icon: "refresh", enabled: !0 },
        { command: "go-up", label: a("toolbar.go_up"), icon: "go-up", enabled: n.canGoUp !== !1 },
        /* wiring:int */
        { command: "open-theme", label: a("theme.menu"), icon: "theme", enabled: !0 },
        { command: "open-shortcut-settings", label: a("shortcuts.settings.menu"), icon: "shortcut-settings", enabled: !0 },
        { command: "start-tour", label: a("tour.restart"), icon: "tour", enabled: !0 },
        /* wiring:d1 — tabs + split */
        { command: "tab-new", label: a("cmd.tab_new"), icon: "tab-new", enabled: !0 },
        { command: "split-toggle", label: a("cmd.split_toggle"), icon: "split", enabled: n.splitEnabled !== !1 }
      ].filter((j) => j.enabled && D(j.label, S) >= 0).map((j) => ({ kind: "command", id: `cmd:${j.command}`, label: j.label, icon: j.icon, command: j.command }));
    }), U = m([]), x = m(!1);
    let E, $ = 0;
    function M(S) {
      E && clearTimeout(E);
      const w = n.globalSearch;
      if (!w || S.length < Ix) {
        U.value = [], x.value = !1;
        return;
      }
      x.value = !0, E = setTimeout(async () => {
        const j = ++$;
        try {
          const K = await w(S);
          if (j !== $) return;
          U.value = Array.isArray(K) ? K.slice(0, Hx) : [];
        } catch {
          j === $ && (U.value = []);
        } finally {
          j === $ && (x.value = !1);
        }
      }, Fx);
    }
    function z(S) {
      const w = String(S.path ?? "").replace(/^\/+|\/+$/g, ""), j = w.lastIndexOf("/"), K = j === -1 ? "" : w.slice(0, j), Z = typeof S.storage == "string" && S.storage || typeof S.storage_name == "string" && S.storage_name || "";
      return Z && K ? `${Z}/${K}` : Z || K || "/";
    }
    const T = k(
      () => U.value.map((S) => ({
        kind: "hit",
        id: `hit:${S.storage_id ?? ""}:${S.path ?? ""}:${S.id ?? ""}`,
        label: String(S.name ?? S.path ?? ""),
        icon: "",
        // hit rows draw their real tile — see iconHtml()
        hit: S,
        crumb: z(S),
        inContent: Od(S.matched),
        snippet: typeof S.snippet == "string" ? S.snippet : ""
      }))
    ), Y = m([]);
    function O() {
      try {
        const S = localStorage.getItem(bu);
        if (!S) return [];
        const w = JSON.parse(S);
        return Array.isArray(w) ? w.filter((j) => typeof j == "string" && j.trim() !== "").slice(0, gu) : [];
      } catch {
        return [];
      }
    }
    function J(S) {
      Y.value = S.slice(0, gu);
      try {
        localStorage.setItem(bu, JSON.stringify(Y.value));
      } catch {
      }
    }
    function G(S) {
      const w = S.trim();
      if (!w) return;
      const j = Y.value.filter((K) => K !== w);
      j.unshift(w), J(j);
    }
    function N(S) {
      J(Y.value.filter((w) => w !== S)), p.value >= le.value.length && (p.value = Math.max(0, le.value.length - 1));
    }
    const P = k(() => {
      const S = v.value.trim(), w = [];
      S && !Y.value.includes(S) && w.push({ kind: "save", id: `save:${S}`, label: `${a("palette.save")}: ${S}`, icon: "save-search", query: S });
      const j = Y.value.map((K) => ({ s: K, sc: D(K, S) })).filter((K) => K.sc >= 0 || !S);
      for (const K of j)
        w.push({ kind: "saved", id: `saved:${K.s}`, label: K.s, icon: "bookmark", query: K.s });
      return w;
    }), le = k(() => [
      ...C.value,
      ...B.value,
      ...T.value,
      ...P.value,
      ...I.value
    ]), ve = k(() => C.value.length), he = k(() => ve.value + B.value.length), oe = k(() => he.value + T.value.length), ue = k(() => oe.value + P.value.length);
    He(v, (S) => {
      p.value = 0, M(S.trim());
    });
    function Q(S) {
      const w = le.value.length;
      w && (p.value = (p.value + S + w) % w, gt(() => {
        var j, K;
        (K = (j = b.value) == null ? void 0 : j.querySelector(".is-active")) == null || K.scrollIntoView({ block: "nearest" });
      }));
    }
    function pe(S) {
      const w = S ?? le.value[p.value];
      if (w) {
        if (w.kind === "saved") {
          v.value = w.query, gt(() => {
            var j;
            return (j = h.value) == null ? void 0 : j.focus();
          });
          return;
        }
        if (w.kind === "save") {
          G(w.query), gt(() => {
            var j;
            return (j = h.value) == null ? void 0 : j.focus();
          });
          return;
        }
        if (r("close"), w.kind === "hit") {
          r("open-hit", w.hit);
          return;
        }
        if (w.kind === "file")
          r("open-node", w.node);
        else if (w.kind === "goto")
          r("navigate", w.path);
        else
          switch (w.command) {
            case "new-folder":
              r("new-folder");
              break;
            case "upload":
              r("upload");
              break;
            case "toggle-view":
              r("toggle-view");
              break;
            case "open-trash":
              r("open-trash");
              break;
            case "refresh":
              r("refresh");
              break;
            case "go-up":
              r("go-up");
              break;
            case "open-theme":
              r("open-theme");
              break;
            case "open-shortcut-settings":
              r("open-shortcut-settings");
              break;
            case "start-tour":
              r("start-tour");
              break;
            case "tab-new":
              r("tab-new");
              break;
            case "split-toggle":
              r("split-toggle");
              break;
          }
      }
    }
    function re(S) {
      if (n.open)
        switch (S.key) {
          case "ArrowDown":
            S.preventDefault(), S.stopPropagation(), Q(1);
            break;
          case "ArrowUp":
            S.preventDefault(), S.stopPropagation(), Q(-1);
            break;
          case "Enter":
            S.preventDefault(), S.stopPropagation(), pe();
            break;
          case "Escape":
            S.preventDefault(), S.stopPropagation(), r("close");
            break;
        }
    }
    return He(
      () => n.open,
      (S) => {
        S ? (v.value = n.initialQuery ?? "", p.value = 0, U.value = [], x.value = !1, Y.value = O(), document.addEventListener("keydown", re, !0), gt(() => {
          var w, j;
          (w = h.value) == null || w.focus(), (j = h.value) == null || j.select();
        })) : (E && clearTimeout(E), document.removeEventListener("keydown", re, !0));
      }
    ), it(() => {
      E && clearTimeout(E), document.removeEventListener("keydown", re, !0);
    }), (S, w) => (c(), et(Rn, { name: "fe-modal" }, {
      default: st(() => [
        e.open ? (c(), d("div", {
          key: 0,
          class: "fe-modal__backdrop fe-cmdp__backdrop",
          role: "presentation",
          onClick: w[2] || (w[2] = (j) => r("close"))
        }, [
          o("div", {
            class: "fe-cmdp",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": s(a)("palette.placeholder"),
            onClick: w[1] || (w[1] = Re(() => {
            }, ["stop"]))
          }, [
            o("div", sx, [
              w[3] || (w[3] = o("svg", {
                class: "fe-cmdp__glyph",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "aria-hidden": "true"
              }, [
                o("circle", {
                  cx: "7",
                  cy: "7",
                  r: "4.5"
                }),
                o("path", { d: "m10.5 10.5 3.5 3.5" })
              ], -1)),
              Ve(o("input", {
                ref_key: "inputEl",
                ref: h,
                "onUpdate:modelValue": w[0] || (w[0] = (j) => v.value = j),
                type: "text",
                class: "fe-cmdp__input",
                placeholder: s(a)("palette.placeholder"),
                autocomplete: "off",
                spellcheck: "false"
              }, null, 8, rx), [
                [rt, v.value]
              ])
            ]),
            o("div", {
              ref_key: "listEl",
              ref: b,
              class: "fe-cmdp__list",
              role: "listbox"
            }, [
              (c(!0), d(ae, null, Te(C.value, (j, K) => (c(), d("button", {
                key: j.id,
                type: "button",
                class: we(["fe-cmdp__item", { "is-active": K === p.value }]),
                role: "option",
                "aria-selected": K === p.value,
                onMouseenter: (Z) => p.value = K,
                onClick: (Z) => pe(j)
              }, [
                o("span", {
                  class: "fe-cmdp__icon",
                  "aria-hidden": "true",
                  innerHTML: A(j)
                }, null, 8, lx),
                o("span", cx, f(j.label), 1)
              ], 42, ix))), 128)),
              B.value.length ? (c(), d(ae, { key: 0 }, [
                o("div", ux, f(s(a)("palette.files")), 1),
                (c(!0), d(ae, null, Te(B.value, (j, K) => (c(), d("button", {
                  key: j.id,
                  type: "button",
                  class: we(["fe-cmdp__item", { "is-active": ve.value + K === p.value }]),
                  role: "option",
                  "aria-selected": ve.value + K === p.value,
                  onMouseenter: (Z) => p.value = ve.value + K,
                  onClick: (Z) => pe(j)
                }, [
                  o("span", {
                    class: "fe-cmdp__icon",
                    "aria-hidden": "true",
                    innerHTML: A(j)
                  }, null, 8, fx),
                  o("span", px, f(j.label), 1)
                ], 42, dx))), 128))
              ], 64)) : g("", !0),
              T.value.length || x.value ? (c(), d(ae, { key: 1 }, [
                o("div", vx, f(s(a)("palette.everywhere")), 1),
                x.value && !T.value.length ? (c(), d("div", hx, f(s(a)("palette.searching")), 1)) : g("", !0),
                (c(!0), d(ae, null, Te(T.value, (j, K) => (c(), d("button", {
                  key: j.id,
                  type: "button",
                  class: we(["fe-cmdp__item fe-cmdp__item--hit", { "is-active": he.value + K === p.value }]),
                  role: "option",
                  "aria-selected": he.value + K === p.value,
                  onMouseenter: (Z) => p.value = he.value + K,
                  onClick: (Z) => pe(j)
                }, [
                  o("span", {
                    class: "fe-cmdp__icon",
                    "aria-hidden": "true",
                    innerHTML: A(j)
                  }, null, 8, yx),
                  o("span", bx, [
                    o("span", gx, [
                      o("span", kx, f(j.label), 1),
                      j.inContent ? (c(), d("span", _x, f(s(a)("search.in_content")), 1)) : g("", !0)
                    ]),
                    j.crumb ? (c(), d("span", {
                      key: 0,
                      class: "fe-cmdp__crumb",
                      title: j.crumb
                    }, f(j.crumb), 9, wx)) : g("", !0),
                    j.snippet ? (c(), d("span", $x, [
                      (c(!0), d(ae, null, Te(s(Vs)(j.snippet), (Z, W) => (c(), d(ae, { key: W }, [
                        Z.match ? (c(), d("mark", xx, f(Z.text), 1)) : (c(), d(ae, { key: 1 }, [
                          Je(f(Z.text), 1)
                        ], 64))
                      ], 64))), 128))
                    ])) : g("", !0)
                  ])
                ], 42, mx))), 128))
              ], 64)) : g("", !0),
              P.value.length ? (c(), d(ae, { key: 2 }, [
                o("div", Sx, f(s(a)("palette.saved")), 1),
                (c(!0), d(ae, null, Te(P.value, (j, K) => (c(), d("div", {
                  key: j.id,
                  class: we(["fe-cmdp__item fe-cmdp__item--saved", { "is-active": oe.value + K === p.value }]),
                  role: "option",
                  "aria-selected": oe.value + K === p.value,
                  tabindex: "-1",
                  onMouseenter: (Z) => p.value = oe.value + K,
                  onClick: (Z) => pe(j),
                  onKeydown: Ut(Re((Z) => pe(j), ["prevent"]), ["enter"])
                }, [
                  o("span", {
                    class: "fe-cmdp__icon",
                    "aria-hidden": "true",
                    innerHTML: A(j)
                  }, null, 8, Tx),
                  o("span", Mx, f(j.label), 1),
                  j.kind === "saved" ? (c(), d("button", {
                    key: 0,
                    type: "button",
                    class: "fe-cmdp__del",
                    title: s(a)("palette.saved.delete"),
                    "aria-label": s(a)("palette.saved.delete"),
                    onClick: Re((Z) => N(j.query), ["stop"])
                  }, [
                    o("span", {
                      "aria-hidden": "true",
                      innerHTML: s(Ue)("delete")
                    }, null, 8, zx)
                  ], 8, Ex)) : g("", !0)
                ], 42, Cx))), 128))
              ], 64)) : g("", !0),
              I.value.length ? (c(), d(ae, { key: 3 }, [
                o("div", Ax, f(s(a)("palette.commands")), 1),
                (c(!0), d(ae, null, Te(I.value, (j, K) => (c(), d("button", {
                  key: j.id,
                  type: "button",
                  class: we(["fe-cmdp__item", { "is-active": ue.value + K === p.value }]),
                  role: "option",
                  "aria-selected": ue.value + K === p.value,
                  onMouseenter: (Z) => p.value = ue.value + K,
                  onClick: (Z) => pe(j)
                }, [
                  o("span", {
                    class: "fe-cmdp__icon",
                    "aria-hidden": "true",
                    innerHTML: A(j)
                  }, null, 8, Lx),
                  o("span", Dx, f(j.label), 1)
                ], 42, Px))), 128))
              ], 64)) : g("", !0),
              le.value.length === 0 && !x.value ? (c(), d("div", Ox, f(s(a)("palette.empty")), 1)) : g("", !0)
            ], 512),
            o("div", Bx, f(s(a)("palette.hint")), 1)
          ], 8, ox)
        ])) : g("", !0)
      ]),
      _: 1
    }));
  }
}), Kx = ["aria-labelledby", "aria-label"], Rx = {
  key: 0,
  class: "fe-modal__head"
}, Ux = { class: "fe-modal__body" }, Vx = {
  key: 1,
  class: "fe-modal__actions"
}, ku = 'input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])', an = /* @__PURE__ */ qe({
  __name: "Modal",
  props: {
    open: { type: Boolean },
    title: {},
    size: {},
    closeOnBackdrop: { type: Boolean },
    chromeless: { type: Boolean },
    fullbleed: { type: Boolean },
    theme: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = m(null);
    let u = 0;
    const v = `fe-modal-title-${++u}-${Math.random().toString(36).slice(2, 7)}`;
    let p = null;
    He(
      () => n.open,
      (y) => {
        var A;
        y ? (p = document.activeElement ?? null, document.addEventListener("keydown", h), setTimeout(() => {
          var C;
          const D = (C = a.value) == null ? void 0 : C.querySelector(ku);
          D == null || D.focus();
        }, 30)) : (document.removeEventListener("keydown", h), (A = p == null ? void 0 : p.focus) == null || A.call(p), p = null);
      }
    ), it(() => document.removeEventListener("keydown", h));
    function h(y) {
      if (y.key === "Escape") {
        r("close");
        return;
      }
      if (y.key === "Tab" && a.value) {
        const A = Array.from(a.value.querySelectorAll(ku)).filter(
          (I) => I.offsetParent !== null || I === document.activeElement
        );
        if (A.length === 0) return;
        const D = A[0], C = A[A.length - 1], B = document.activeElement;
        y.shiftKey && (B === D || !a.value.contains(B)) ? (y.preventDefault(), C.focus()) : !y.shiftKey && (B === C || !a.value.contains(B)) && (y.preventDefault(), D.focus());
      }
    }
    function b() {
      n.closeOnBackdrop !== !1 && r("close");
    }
    return (y, A) => (c(), et(Rn, { name: "fe-modal" }, {
      default: st(() => [
        e.open ? (c(), d("div", {
          key: 0,
          class: we(["fe fe-modal__backdrop", [
            { "fe-modal__backdrop--chromeless": e.chromeless },
            { "fe-modal__backdrop--fullbleed": e.fullbleed && !e.chromeless },
            e.theme === "light" ? "fe--theme-light" : "",
            e.theme === "dark" ? "fe--theme-dark" : ""
          ]]),
          role: "presentation",
          onClick: b
        }, [
          o("div", {
            ref_key: "cardEl",
            ref: a,
            class: we(["fe-modal__card", [
              `fe-modal__card--${e.size || "md"}`,
              e.chromeless && "fe-modal__card--chromeless",
              e.fullbleed && !e.chromeless && "fe-modal__card--fullbleed"
            ]]),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": e.title && !e.chromeless && !e.fullbleed ? v : void 0,
            "aria-label": (!e.title || e.chromeless || e.fullbleed) && e.title || void 0,
            onClick: A[1] || (A[1] = Re(() => {
            }, ["stop"]))
          }, [
            e.title && !e.chromeless && !e.fullbleed ? (c(), d("header", Rx, [
              o("h2", {
                id: v,
                class: "fe-modal__title"
              }, f(e.title), 1),
              o("button", {
                type: "button",
                class: "fe-modal__close",
                "aria-label": "Close",
                onClick: A[0] || (A[0] = (D) => r("close"))
              }, "×")
            ])) : g("", !0),
            o("div", Ux, [
              _n(y.$slots, "default")
            ]),
            y.$slots.actions && !e.chromeless && !e.fullbleed ? (c(), d("footer", Vx, [
              _n(y.$slots, "actions")
            ])) : g("", !0)
          ], 10, Kx)
        ], 2)) : g("", !0)
      ]),
      _: 3
    }));
  }
});
function jx(e = "") {
  return {
    text: "",
    tags: [],
    excludeTags: [],
    scope: "name",
    filters: { ...na, pathBase: e }
  };
}
function _u(e, t) {
  const n = e.trim();
  if (!n) return "";
  const r = /\s/.test(n) ? `"${n}"` : n;
  return `${t ? "-" : ""}tag:${r}`;
}
function js(e) {
  const t = [], n = e.text.trim();
  n && t.push(n);
  for (const r of e.tags) {
    const a = _u(r, !1);
    a && t.push(a);
  }
  for (const r of e.excludeTags) {
    const a = _u(r, !0);
    a && t.push(a);
  }
  return t.join(" ");
}
function Yx(e) {
  return js(e) === "";
}
function wu(e) {
  return e.split(/[,\n]/).map((t) => t.trim()).filter((t) => t !== "");
}
function Wx(e, t) {
  return e >= t;
}
const qx = { class: "fe-advsearch__head" }, Gx = ["innerHTML"], Xx = { class: "fe-advsearch__head-text" }, Jx = { class: "fe-advsearch__head-title" }, Zx = { class: "fe-advsearch__head-sub" }, Qx = ["title", "aria-label"], eS = ["innerHTML"], tS = { class: "fe-advsearch__box" }, nS = ["innerHTML"], aS = ["placeholder", "aria-label"], oS = ["aria-label"], sS = ["aria-selected", "data-testid", "onClick"], rS = ["innerHTML"], iS = { class: "fe-advsearch__cols" }, lS = { class: "fe-advsearch__col" }, cS = { class: "fe-advsearch__group" }, uS = { class: "fe-advsearch__field" }, dS = { class: "fe-advsearch__label" }, fS = ["value"], pS = {
  key: 0,
  class: "fe-advsearch__field"
}, vS = { class: "fe-advsearch__sublabel" }, hS = { class: "fe-advsearch__pair" }, mS = ["aria-label"], yS = ["aria-label"], bS = ["aria-pressed", "onClick"], gS = { class: "fe-advsearch__field" }, kS = { class: "fe-advsearch__label" }, _S = ["value"], wS = { class: "fe-advsearch__group" }, $S = { class: "fe-advsearch__field" }, xS = { class: "fe-advsearch__label" }, SS = ["disabled"], CS = ["value"], TS = {
  key: 0,
  class: "fe-advsearch__hint fe-advsearch__hint--block"
}, MS = { class: "fe-advsearch__group" }, ES = { class: "fe-advsearch__field" }, zS = { class: "fe-advsearch__label" }, AS = ["placeholder"], PS = { class: "fe-advsearch__field" }, LS = { class: "fe-advsearch__label" }, DS = ["placeholder"], OS = { class: "fe-advsearch__hint fe-advsearch__hint--block" }, BS = { class: "fe-advsearch__col" }, IS = { class: "fe-advsearch__group" }, HS = { class: "fe-advsearch__field" }, FS = { class: "fe-advsearch__label" }, NS = ["value"], KS = {
  key: 0,
  class: "fe-advsearch__field"
}, RS = { class: "fe-advsearch__sublabel" }, US = { class: "fe-advsearch__pair" }, VS = ["placeholder", "aria-label"], jS = ["placeholder", "aria-label"], YS = ["aria-label"], WS = { value: "kb" }, qS = { value: "mb" }, GS = { value: "gb" }, XS = { class: "fe-advsearch__group" }, JS = { class: "fe-advsearch__label" }, ZS = ["aria-label"], QS = ["aria-pressed", "data-testid", "onClick"], eC = { class: "fe-advsearch__hint" }, tC = { class: "fe-advsearch__group" }, nC = { class: "fe-advsearch__grouphead" }, aC = ["innerHTML"], oC = { class: "fe-advsearch__hint fe-advsearch__hint--block" }, sC = {
  class: "fe-advsearch__count",
  "data-testid": "advsearch-count"
}, rC = { class: "fe-advsearch__count-top" }, iC = { class: "fe-advsearch__count-line" }, lC = { key: 0 }, cC = { key: 1 }, uC = { key: 2 }, dC = { key: 3 }, fC = { class: "fe-advsearch__hint fe-advsearch__hint--block" }, pC = {
  key: 0,
  class: "fe-advsearch__wire"
}, vC = ["innerHTML"], hC = ["disabled"], mC = ["innerHTML"], yC = /* @__PURE__ */ qe({
  __name: "AdvancedSearch",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    initialQuery: {},
    folderLabel: {},
    pathBase: {},
    contentSearch: { type: Boolean },
    count: { type: Function }
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = m(null), v = m(""), p = m("name"), h = m(""), b = m(""), y = m("any"), A = m("any"), D = m(""), C = m("d1"), B = m("any"), I = m("any"), U = m(""), x = m(""), E = m("mb"), $ = m("any"), M = [
      "any",
      "folder",
      "document",
      "spreadsheet",
      "presentation",
      "pdf",
      "image",
      "video",
      "audio",
      "archive",
      "code"
    ], z = ["any", "today", "7d", "30d", "year", "around"], T = ["any", "lt1", "1to10", "10to100", "gt100", "range"], Y = ["h1", "d1", "w1"], O = {
      kb: 1024,
      mb: 1024 ** 2,
      gb: 1024 ** 3
    }, J = k(
      () => n.contentSearch ? ["all", "content", "name"] : ["name"]
    ), G = {
      all: "search",
      content: "preview",
      name: "copy-path"
    }, N = ["any", "here", "skip"], P = ["any", "me", "system"], le = k(() => p.value === "name");
    He(le, (ie) => {
      ie || (B.value = "any");
    });
    function ve() {
      v.value = "", p.value = "name", h.value = "", b.value = "", y.value = "any", A.value = "any", D.value = "", C.value = "d1", I.value = "any", U.value = "", x.value = "", E.value = "mb", $.value = "any", B.value = "any";
    }
    function he() {
      return {
        text: v.value,
        scope: p.value,
        tagsRaw: h.value,
        excludeRaw: b.value,
        type: y.value,
        modified: A.value,
        aroundDate: D.value,
        aroundSpan: C.value,
        size: I.value,
        sizeFrom: U.value,
        sizeTo: x.value,
        sizeUnit: E.value,
        pathMode: $.value,
        people: B.value
      };
    }
    function oe(ie) {
      v.value = ie.text, p.value = ie.scope, h.value = ie.tagsRaw, b.value = ie.excludeRaw, y.value = ie.type, A.value = ie.modified, D.value = ie.aroundDate, C.value = ie.aroundSpan, I.value = ie.size, U.value = ie.sizeFrom, x.value = ie.sizeTo, E.value = ie.sizeUnit, $.value = ie.pathMode, B.value = ie.people;
    }
    let ue = null;
    He(
      () => n.open,
      (ie) => {
        if (!ie) return;
        const ce = n.initialQuery ?? "";
        ue && ue.query !== "" && ue.query === ce ? oe(ue.form) : (ve(), v.value = ce), w.value = null, K.value = !1, setTimeout(() => {
          var L;
          return (L = u.value) == null ? void 0 : L.focus();
        }, 60);
      }
    );
    function Q(ie) {
      const ce = String(ie ?? "").trim();
      if (!ce) return null;
      const L = Number(ce);
      return !Number.isFinite(L) || L < 0 ? null : Math.round(L * O[E.value]);
    }
    const pe = k(() => ({
      ...jx(n.pathBase ?? ""),
      text: v.value,
      tags: wu(h.value),
      excludeTags: wu(b.value),
      scope: p.value,
      filters: {
        ...na,
        type: y.value,
        modified: A.value,
        aroundDate: D.value,
        aroundSpan: C.value,
        size: I.value,
        sizeMin: I.value === "range" ? Q(U.value) : null,
        sizeMax: I.value === "range" ? Q(x.value) : null,
        pathMode: $.value,
        pathBase: n.pathBase ?? "",
        /* ⚠ Read through the guard, not off the ref. The `ownerFilterable` watch
           below already clears the choice when the scope leaves `name`, so this is
           the SECOND lock, not the first: a disabled select cannot be changed but
           it can still hold a value chosen before the scope moved, and a filter
           that outlives its own control narrows a search nobody asked it to. The
           two are worth keeping apart — one is what the user sees change, the
           other is what actually reaches the predicate. */
        people: le.value ? B.value : "any"
      }
    })), re = k(() => Yx(pe.value)), S = k(() => js(pe.value)), w = m(null), j = m(!1), K = m(!1), Z = k(() => {
      var ie;
      return [
        ...P.map((ce) => ({ value: ce })),
        ...((ie = w.value) == null ? void 0 : ie.people) ?? []
      ];
    });
    function W(ie) {
      return ie.value === "any" || ie.value === "me" || ie.value === "system" ? a(`filter.people.${ie.value}`) : ie.name || a("filter.people.someone");
    }
    He(Z, (ie) => {
      ie.some((ce) => ce.value === B.value) || (B.value = "any");
    });
    let $e = null, Se = 0;
    function ze() {
      if ($e && clearTimeout($e), K.value = !1, re.value) {
        w.value = null, j.value = !1;
        return;
      }
      j.value = !0, $e = setTimeout(Ne, 450);
    }
    async function Ne() {
      const ie = ++Se, ce = pe.value;
      try {
        const L = await n.count(ce);
        if (ie !== Se) return;
        w.value = L;
      } catch {
        if (ie !== Se) return;
        w.value = null, K.value = !0;
      } finally {
        ie === Se && (j.value = !1);
      }
    }
    He(
      () => {
        if (!n.open) return "";
        try {
          return JSON.stringify(pe.value);
        } catch {
          return "ERR";
        }
      },
      (ie) => {
        if (ie) {
          if (ie === "ERR") {
            $e && clearTimeout($e), Se++, w.value = null, j.value = !1, K.value = !0;
            return;
          }
          ze();
        }
      }
    ), it(() => {
      $e && clearTimeout($e);
    });
    const be = k(() => {
      const ie = w.value;
      return ie ? a(ie.capped ? "advsearch.count.capped" : "advsearch.count.result", { n: String(ie.count) }) : "";
    });
    function De() {
      re.value || (ue = { query: S.value, form: he() }, r("submit", pe.value));
    }
    return (ie, ce) => (c(), et(an, {
      open: e.open,
      title: s(a)("advsearch.title"),
      size: "lg",
      theme: e.theme,
      onClose: ce[13] || (ce[13] = (L) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn fe-advsearch__reset",
          onClick: ve
        }, [
          o("span", {
            class: "fe-advsearch__btn-icon",
            "aria-hidden": "true",
            innerHTML: s(Ue)("refresh")
          }, null, 8, vC),
          Je(" " + f(s(a)("advsearch.reset")), 1)
        ]),
        o("button", {
          type: "button",
          class: "fe-btn",
          onClick: ce[12] || (ce[12] = (L) => r("close"))
        }, f(s(a)("advsearch.cancel")), 1),
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: re.value,
          "data-testid": "advsearch-submit",
          onClick: De
        }, [
          o("span", {
            class: "fe-advsearch__btn-icon",
            "aria-hidden": "true",
            innerHTML: s(Ue)("search")
          }, null, 8, mC),
          Je(" " + f(s(a)("advsearch.submit")), 1)
        ], 8, hC)
      ]),
      default: st(() => [
        o("form", {
          class: "fe-advsearch",
          onSubmit: Re(De, ["prevent"])
        }, [
          o("header", qx, [
            o("span", {
              class: "fe-advsearch__head-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("search")
            }, null, 8, Gx),
            o("div", Xx, [
              o("p", Jx, f(s(a)("advsearch.title")), 1),
              o("p", Zx, f(s(a)("advsearch.subtitle")), 1)
            ]),
            o("button", {
              type: "button",
              class: "fe-advsearch__head-close",
              title: s(a)("advsearch.close"),
              "aria-label": s(a)("advsearch.close"),
              onClick: ce[0] || (ce[0] = (L) => r("close"))
            }, [
              o("span", {
                "aria-hidden": "true",
                innerHTML: s(Ue)("close")
              }, null, 8, eS)
            ], 8, Qx)
          ]),
          o("label", tS, [
            o("span", {
              class: "fe-advsearch__glass",
              "aria-hidden": "true",
              innerHTML: s(Ue)("search")
            }, null, 8, nS),
            Ve(o("input", {
              ref_key: "queryEl",
              ref: u,
              "onUpdate:modelValue": ce[1] || (ce[1] = (L) => v.value = L),
              type: "search",
              class: "fe-advsearch__input",
              placeholder: s(a)("advsearch.query.placeholder"),
              "aria-label": s(a)("advsearch.query.label"),
              "data-testid": "advsearch-query"
            }, null, 8, aS), [
              [rt, v.value]
            ])
          ]),
          o("div", {
            class: "fe-advsearch__seg fe-advsearch__seg--tabs",
            role: "tablist",
            "aria-label": s(a)("advsearch.scope.label")
          }, [
            (c(!0), d(ae, null, Te(J.value, (L) => (c(), d("button", {
              key: L,
              type: "button",
              role: "tab",
              class: we(["fe-advsearch__seg-btn", { "is-active": p.value === L }]),
              "aria-selected": p.value === L,
              "data-testid": `advsearch-scope-${L}`,
              onClick: (se) => p.value = L
            }, [
              o("span", {
                class: "fe-advsearch__seg-icon",
                "aria-hidden": "true",
                innerHTML: s(Ue)(G[L])
              }, null, 8, rS),
              Je(" " + f(s(a)(`advsearch.scope.${L}`)), 1)
            ], 10, sS))), 128))
          ], 8, oS),
          o("div", iS, [
            o("div", lS, [
              o("div", cS, [
                o("label", uS, [
                  o("span", dS, f(s(a)("filter.modified")), 1),
                  Ve(o("select", {
                    "onUpdate:modelValue": ce[2] || (ce[2] = (L) => A.value = L),
                    class: "fe-input",
                    "data-testid": "advsearch-modified"
                  }, [
                    (c(), d(ae, null, Te(z, (L) => o("option", {
                      key: L,
                      value: L
                    }, f(s(a)(`filter.modified.${L}`)), 9, fS)), 64))
                  ], 512), [
                    [on, A.value]
                  ])
                ]),
                A.value === "around" ? (c(), d("div", pS, [
                  o("span", vS, f(s(a)("advsearch.around.label")), 1),
                  o("div", hS, [
                    Ve(o("input", {
                      "onUpdate:modelValue": ce[3] || (ce[3] = (L) => D.value = L),
                      type: "datetime-local",
                      class: "fe-input",
                      "aria-label": s(a)("advsearch.around.date"),
                      "data-testid": "advsearch-around-date"
                    }, null, 8, mS), [
                      [rt, D.value]
                    ]),
                    o("div", {
                      class: "fe-advsearch__seg",
                      role: "group",
                      "aria-label": s(a)("advsearch.around.label")
                    }, [
                      (c(), d(ae, null, Te(Y, (L) => o("button", {
                        key: L,
                        type: "button",
                        class: we(["fe-advsearch__seg-btn", { "is-active": C.value === L }]),
                        "aria-pressed": C.value === L,
                        onClick: (se) => C.value = L
                      }, f(s(a)(`advsearch.around.${L}`)), 11, bS)), 64))
                    ], 8, yS)
                  ])
                ])) : g("", !0)
              ]),
              o("label", gS, [
                o("span", kS, f(s(a)("filter.type")), 1),
                Ve(o("select", {
                  "onUpdate:modelValue": ce[4] || (ce[4] = (L) => y.value = L),
                  class: "fe-input",
                  "data-testid": "advsearch-type"
                }, [
                  (c(), d(ae, null, Te(M, (L) => o("option", {
                    key: L,
                    value: L
                  }, f(s(a)(`filter.type.${L}`)), 9, _S)), 64))
                ], 512), [
                  [on, y.value]
                ])
              ]),
              o("div", wS, [
                o("label", $S, [
                  o("span", xS, f(s(a)("filter.people")), 1),
                  Ve(o("select", {
                    "onUpdate:modelValue": ce[5] || (ce[5] = (L) => B.value = L),
                    class: "fe-input",
                    disabled: !le.value,
                    "data-testid": "advsearch-people"
                  }, [
                    (c(!0), d(ae, null, Te(Z.value, (L) => (c(), d("option", {
                      key: L.value,
                      value: L.value
                    }, f(W(L)), 9, CS))), 128))
                  ], 8, SS), [
                    [on, B.value]
                  ])
                ]),
                le.value ? g("", !0) : (c(), d("p", TS, f(s(a)("advsearch.people.name_only")), 1))
              ]),
              o("div", MS, [
                o("label", ES, [
                  o("span", zS, f(s(a)("advsearch.tags.label")), 1),
                  Ve(o("input", {
                    "onUpdate:modelValue": ce[6] || (ce[6] = (L) => h.value = L),
                    type: "text",
                    class: "fe-input",
                    placeholder: s(a)("advsearch.tags.placeholder"),
                    "data-testid": "advsearch-tags"
                  }, null, 8, AS), [
                    [rt, h.value]
                  ])
                ]),
                o("label", PS, [
                  o("span", LS, f(s(a)("advsearch.tags.exclude")), 1),
                  Ve(o("input", {
                    "onUpdate:modelValue": ce[7] || (ce[7] = (L) => b.value = L),
                    type: "text",
                    class: "fe-input",
                    placeholder: s(a)("advsearch.tags.exclude_placeholder"),
                    "data-testid": "advsearch-extags"
                  }, null, 8, DS), [
                    [rt, b.value]
                  ])
                ]),
                o("p", OS, f(s(a)("advsearch.tags.hint")), 1)
              ])
            ]),
            o("div", BS, [
              o("div", IS, [
                o("label", HS, [
                  o("span", FS, f(s(a)("filter.size")), 1),
                  Ve(o("select", {
                    "onUpdate:modelValue": ce[8] || (ce[8] = (L) => I.value = L),
                    class: "fe-input",
                    "data-testid": "advsearch-size"
                  }, [
                    (c(), d(ae, null, Te(T, (L) => o("option", {
                      key: L,
                      value: L
                    }, f(s(a)(`filter.size.${L}`)), 9, NS)), 64))
                  ], 512), [
                    [on, I.value]
                  ])
                ]),
                I.value === "range" ? (c(), d("div", KS, [
                  o("span", RS, f(s(a)("advsearch.size.range_label")), 1),
                  o("div", US, [
                    Ve(o("input", {
                      "onUpdate:modelValue": ce[9] || (ce[9] = (L) => U.value = L),
                      type: "number",
                      min: "0",
                      class: "fe-input fe-advsearch__num",
                      placeholder: s(a)("advsearch.size.from"),
                      "aria-label": s(a)("advsearch.size.from"),
                      "data-testid": "advsearch-size-from"
                    }, null, 8, VS), [
                      [rt, U.value]
                    ]),
                    ce[14] || (ce[14] = o("span", {
                      class: "fe-advsearch__dash",
                      "aria-hidden": "true"
                    }, "–", -1)),
                    Ve(o("input", {
                      "onUpdate:modelValue": ce[10] || (ce[10] = (L) => x.value = L),
                      type: "number",
                      min: "0",
                      class: "fe-input fe-advsearch__num",
                      placeholder: s(a)("advsearch.size.to"),
                      "aria-label": s(a)("advsearch.size.to"),
                      "data-testid": "advsearch-size-to"
                    }, null, 8, jS), [
                      [rt, x.value]
                    ]),
                    Ve(o("select", {
                      "onUpdate:modelValue": ce[11] || (ce[11] = (L) => E.value = L),
                      class: "fe-input fe-advsearch__unit",
                      "aria-label": s(a)("filter.size")
                    }, [
                      o("option", WS, f(s(a)("unit.kb")), 1),
                      o("option", qS, f(s(a)("unit.mb")), 1),
                      o("option", GS, f(s(a)("unit.gb")), 1)
                    ], 8, YS), [
                      [on, E.value]
                    ])
                  ])
                ])) : g("", !0)
              ]),
              o("div", XS, [
                o("span", JS, f(s(a)("advsearch.where.label")), 1),
                o("div", {
                  class: "fe-advsearch__seg fe-advsearch__seg--wide",
                  role: "group",
                  "aria-label": s(a)("advsearch.where.label"),
                  "data-testid": "advsearch-where"
                }, [
                  (c(), d(ae, null, Te(N, (L) => o("button", {
                    key: L,
                    type: "button",
                    class: we(["fe-advsearch__seg-btn", { "is-active": $.value === L }]),
                    "aria-pressed": $.value === L,
                    "data-testid": `advsearch-where-${L}`,
                    onClick: (se) => $.value = L
                  }, f(s(a)(`advsearch.where.${L}_short`)), 11, QS)), 64))
                ], 8, ZS),
                o("span", eC, f(s(a)(`advsearch.where.${$.value}`, { folder: e.folderLabel || "" })), 1)
              ]),
              o("div", tC, [
                o("p", nC, [
                  o("span", {
                    class: "fe-advsearch__grouphead-icon",
                    "aria-hidden": "true",
                    innerHTML: s(Ue)("preview")
                  }, null, 8, aC),
                  Je(" " + f(s(a)("advsearch.content.heading")), 1)
                ]),
                o("p", oC, f(e.contentSearch ? s(a)("advsearch.scope.hint") : s(a)("advsearch.scope.name_only")), 1)
              ])
            ])
          ]),
          o("div", sC, [
            o("div", rC, [
              o("p", iC, [
                re.value ? (c(), d("span", lC, f(s(a)("advsearch.count.idle")), 1)) : j.value ? (c(), d("span", cC, f(s(a)("advsearch.count.counting")), 1)) : K.value ? (c(), d("span", uC, f(s(a)("advsearch.count.error")), 1)) : w.value ? (c(), d("strong", dC, f(be.value), 1)) : g("", !0)
              ]),
              re.value ? g("", !0) : (c(), d("button", {
                key: 0,
                type: "button",
                class: "fe-advsearch__viewall",
                "data-testid": "advsearch-viewall",
                onClick: De
              }, f(s(a)("advsearch.viewall")), 1))
            ]),
            o("p", fC, f(s(a)("advsearch.count.cost")), 1),
            S.value ? (c(), d("p", pC, [
              Je(f(s(a)("advsearch.wire")) + " ", 1),
              o("code", null, f(S.value), 1)
            ])) : g("", !0)
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
}), bC = { class: "fe-shortcuts" }, gC = { class: "fe-shortcuts__heading" }, kC = { class: "fe-shortcuts__table" }, _C = { class: "fe-shortcuts__keys" }, wC = {
  key: 0,
  class: "fe-shortcuts__unbound"
}, $C = { class: "fe-kbd" }, xC = {
  key: 0,
  class: "fe-shortcuts__or",
  "aria-hidden": "true"
}, SC = { class: "fe-shortcuts__desc" }, CC = ["title"], TC = ["innerHTML"], MC = /* @__PURE__ */ qe({
  __name: "ShortcutsHelp",
  props: {
    open: { type: Boolean },
    locale: {}
  },
  emits: ["close", "customize"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = Uu(), v = k(() => {
      const p = [], h = /* @__PURE__ */ new Map();
      for (const b of u.value)
        h.has(b.groupKey) || (h.set(b.groupKey, []), p.push(b.groupKey)), h.get(b.groupKey).push(b);
      return p.map((b) => ({ key: b, items: h.get(b) }));
    });
    return (p, h) => (c(), et(an, {
      open: e.open,
      title: s(a)("shortcuts.title"),
      size: "md",
      onClose: h[2] || (h[2] = (b) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: h[0] || (h[0] = (b) => r("customize"))
        }, [
          o("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: s(Ue)("shortcut-settings")
          }, null, 8, TC),
          Je(" " + f(s(a)("shortcuts.customize")), 1)
        ]),
        o("button", {
          type: "button",
          class: "fe-btn",
          onClick: h[1] || (h[1] = (b) => r("close"))
        }, f(s(a)("viewer.close")), 1)
      ]),
      default: st(() => [
        o("div", bC, [
          (c(!0), d(ae, null, Te(v.value, (b) => (c(), d("section", {
            key: b.key,
            class: "fe-shortcuts__group"
          }, [
            o("h3", gC, f(s(a)(b.key)), 1),
            o("div", kC, [
              (c(!0), d(ae, null, Te(b.items, (y) => (c(), d("div", {
                key: y.id,
                class: "fe-shortcuts__row"
              }, [
                o("span", _C, [
                  y.keys.length === 0 ? (c(), d("span", wC, f(s(a)("shortcuts.settings.unbound")), 1)) : (c(!0), d(ae, { key: 1 }, Te(y.keys, (A, D) => (c(), d(ae, { key: A }, [
                    o("kbd", $C, f(A), 1),
                    D < y.keys.length - 1 ? (c(), d("span", xC, "/")) : g("", !0)
                  ], 64))), 128))
                ]),
                o("span", SC, [
                  Je(f(s(a)(y.labelKey)) + " ", 1),
                  y.overridden ? (c(), d("span", {
                    key: 0,
                    class: "fe-shortcuts__custom",
                    title: s(a)("shortcuts.settings.customized")
                  }, "●", 8, CC)) : g("", !0)
                ])
              ]))), 128))
            ])
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), To = "filex.palette", $u = "filex.theme", Ln = "default", Qi = [
  {
    // Stock palette — the maps duplicate variables.css ONLY for the
    // gallery preview; applying this theme clears all overrides.
    id: Ln,
    nameKey: "theme.name.default",
    light: {
      /* ⚠ Mirrors styles/variables.css exactly — web/tests/api/themeContrast.test.ts
       * fails on any drift. It has drifted before: the stock primary was
       * darkened for contrast and this preview map kept the old blue, so the
       * gallery card advertised a colour the product no longer used. */
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f7f8fb",
      "--fe-bg-hover": "#f3f4f6",
      "--fe-bg-selected": "#eef3ff",
      "--fe-border": "#e5e7eb",
      "--fe-border-soft": "#eef0f4",
      "--fe-border-strong": "#d1d5db",
      "--fe-text": "#1f2937",
      "--fe-text-muted": "#6b7280",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2f6ceb",
      "--fe-primary-hover": "#2559c9",
      "--fe-primary-soft": "#e6ecfa",
      "--fe-primary-ink": "#2559c9",
      "--fe-danger": "#dc2626",
      "--fe-danger-hover": "#b91c1c"
    },
    dark: {
      "--fe-bg": "#15171c",
      "--fe-bg-elev": "#1a1d23",
      "--fe-bg-hover": "#1f232a",
      "--fe-bg-selected": "#1c2740",
      "--fe-border": "#2e333c",
      "--fe-border-soft": "#262a32",
      "--fe-border-strong": "#3d444f",
      "--fe-text": "#e6e8ec",
      "--fe-text-muted": "#888f9b",
      /* Dark ink, not white: white on the button measures 3.16 against the 4.5
       * this file claims. Mirrors styles/variables.css. */
      "--fe-text-on-primary": "#15171c",
      "--fe-primary": "#5b8cff",
      "--fe-primary-hover": "#7ba3ff",
      "--fe-primary-soft": "#1c2740",
      "--fe-primary-ink": "#7ba3ff",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Night Blue — deep indigo/navy.
    id: "night",
    nameKey: "theme.name.night",
    light: {
      "--fe-bg": "#f6f8fd",
      "--fe-bg-elev": "#edf1fa",
      "--fe-bg-hover": "#e2e9f7",
      "--fe-bg-selected": "#d2ddf4",
      "--fe-border": "#d6deee",
      "--fe-border-soft": "#e3e8f4",
      "--fe-border-strong": "#aebfda",
      "--fe-text": "#151f38",
      "--fe-text-muted": "#49587a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2c4a9e",
      "--fe-primary-hover": "#213a80",
      "--fe-primary-soft": "#e0e6f4",
      "--fe-primary-ink": "#213a80",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0a1024",
      "--fe-bg-elev": "#111a35",
      "--fe-bg-hover": "#1a2547",
      "--fe-bg-selected": "#243665",
      "--fe-border": "#26335a",
      "--fe-border-soft": "#1d2748",
      "--fe-border-strong": "#3c4e84",
      "--fe-text": "#dfe6f7",
      "--fe-text-muted": "#96a5cc",
      "--fe-text-on-primary": "#050b26",
      "--fe-primary": "#6d8dfc",
      "--fe-primary-hover": "#5273f2",
      "--fe-primary-soft": "#182243",
      "--fe-primary-ink": "#6d8dfc",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Forest — calm greens.
    id: "forest",
    nameKey: "theme.name.forest",
    light: {
      "--fe-bg": "#f5faf5",
      "--fe-bg-elev": "#eaf3eb",
      "--fe-bg-hover": "#dcecdf",
      "--fe-bg-selected": "#c8e2ce",
      "--fe-border": "#d2e2d4",
      "--fe-border-soft": "#e0ece1",
      "--fe-border-strong": "#a2c3a8",
      "--fe-text": "#182b1d",
      "--fe-text-muted": "#42604a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2b7a41",
      "--fe-primary-hover": "#226334",
      "--fe-primary-soft": "#dbe9dc",
      "--fe-primary-ink": "#226334",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0d1611",
      "--fe-bg-elev": "#132019",
      "--fe-bg-hover": "#1b2d23",
      "--fe-bg-selected": "#264532",
      "--fe-border": "#28402f",
      "--fe-border-soft": "#1f3225",
      "--fe-border-strong": "#3e5f49",
      "--fe-text": "#dcebe0",
      "--fe-text-muted": "#93b09b",
      "--fe-text-on-primary": "#04180b",
      "--fe-primary": "#54c17a",
      "--fe-primary-hover": "#3fae66",
      "--fe-primary-soft": "#16291d",
      "--fe-primary-ink": "#54c17a",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Amber — warm amber/bronze.
    id: "amber",
    nameKey: "theme.name.amber",
    light: {
      "--fe-bg": "#fdf9f0",
      "--fe-bg-elev": "#f7efdd",
      "--fe-bg-hover": "#f0e3c8",
      "--fe-bg-selected": "#ead6ab",
      "--fe-border": "#e6dabf",
      "--fe-border-soft": "#efe6d3",
      "--fe-border-strong": "#c6b184",
      "--fe-text": "#33270f",
      "--fe-text-muted": "#655631",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#9a4b00",
      "--fe-primary-hover": "#7c3c00",
      "--fe-primary-soft": "#f3e5d7",
      "--fe-primary-ink": "#7c3c00",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#191307",
      "--fe-bg-elev": "#231a0c",
      "--fe-bg-hover": "#2f2312",
      "--fe-bg-selected": "#44331b",
      "--fe-border": "#3b2e17",
      "--fe-border-soft": "#302512",
      "--fe-border-strong": "#5b4a29",
      "--fe-text": "#f2e7d4",
      "--fe-text-muted": "#bda887",
      "--fe-text-on-primary": "#2a1c02",
      "--fe-primary": "#f5a524",
      "--fe-primary-hover": "#ffb84d",
      "--fe-primary-soft": "#31230c",
      "--fe-primary-ink": "#ffb84d",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Lilac — soft purple.
    id: "lilac",
    nameKey: "theme.name.lilac",
    light: {
      "--fe-bg": "#faf7fd",
      "--fe-bg-elev": "#f2ecfa",
      "--fe-bg-hover": "#e8ddf5",
      "--fe-bg-selected": "#dccaf0",
      "--fe-border": "#e1d6ee",
      "--fe-border-soft": "#ebe3f4",
      "--fe-border-strong": "#bda6d9",
      "--fe-text": "#241a33",
      "--fe-text-muted": "#584871",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#7231e0",
      "--fe-primary-hover": "#5f21c4",
      "--fe-primary-soft": "#e9e3fc",
      "--fe-primary-ink": "#5f21c4",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#130f1c",
      "--fe-bg-elev": "#1b1527",
      "--fe-bg-hover": "#261d37",
      "--fe-bg-selected": "#37294f",
      "--fe-border": "#302546",
      "--fe-border-soft": "#261e38",
      "--fe-border-strong": "#4b3a6d",
      "--fe-text": "#e9e2f5",
      "--fe-text-muted": "#a999c5",
      "--fe-text-on-primary": "#180d33",
      "--fe-primary": "#b197fa",
      "--fe-primary-hover": "#9c7cf4",
      "--fe-primary-soft": "#272038",
      "--fe-primary-ink": "#b197fa",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // High Contrast — black/white with strong borders, saturated accents.
    id: "contrast",
    nameKey: "theme.name.contrast",
    light: {
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f2f2f2",
      "--fe-bg-hover": "#e0e0e0",
      "--fe-bg-selected": "#c9dcff",
      "--fe-border": "#5c5c5c",
      "--fe-border-soft": "#5c5c5c",
      "--fe-border-strong": "#000000",
      "--fe-text": "#000000",
      "--fe-text-muted": "#3d3d3d",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#003d99",
      "--fe-primary-hover": "#002a6b",
      "--fe-primary-soft": "#e7edf7",
      "--fe-primary-ink": "#002a6b",
      "--fe-danger": "#a80000",
      "--fe-danger-hover": "#7d0000",
      "--fe-shadow": "0 0 0 1px #000000, 0 10px 32px rgba(0, 0, 0, 0.25)",
      "--fe-shadow-sm": "0 0 0 1px #000000"
    },
    dark: {
      "--fe-bg": "#000000",
      "--fe-bg-elev": "#0d0d0d",
      "--fe-bg-hover": "#212121",
      "--fe-bg-selected": "#003d80",
      "--fe-border": "#8f8f8f",
      "--fe-border-soft": "#8f8f8f",
      "--fe-border-strong": "#ffffff",
      "--fe-text": "#ffffff",
      "--fe-text-muted": "#d6d6d6",
      "--fe-text-on-primary": "#001430",
      "--fe-primary": "#7ab8ff",
      "--fe-primary-hover": "#9ccaff",
      "--fe-primary-soft": "#0e1a29",
      "--fe-primary-ink": "#9ccaff",
      "--fe-danger": "#ff7575",
      "--fe-danger-hover": "#ff9999",
      "--fe-shadow": "0 0 0 1px #ffffff, 0 12px 32px rgba(0, 0, 0, 0.65)",
      "--fe-shadow-sm": "0 0 0 1px #ffffff"
    }
  },
  {
    // Soft Gray — desaturated, quiet neutral.
    id: "gray",
    nameKey: "theme.name.gray",
    light: {
      "--fe-bg": "#f7f7f8",
      "--fe-bg-elev": "#efeff1",
      "--fe-bg-hover": "#e4e4e7",
      "--fe-bg-selected": "#d6d7db",
      "--fe-border": "#dfdfe2",
      "--fe-border-soft": "#e9e9eb",
      "--fe-border-strong": "#b9b9c0",
      "--fe-text": "#26272b",
      "--fe-text-muted": "#585a63",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#4b4b54",
      "--fe-primary-hover": "#38383f",
      "--fe-primary-soft": "#e4e4e6",
      "--fe-primary-ink": "#38383f",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#131316",
      "--fe-bg-elev": "#1b1b1f",
      "--fe-bg-hover": "#26262b",
      "--fe-bg-selected": "#35353c",
      "--fe-border": "#2d2d33",
      "--fe-border-soft": "#242429",
      "--fe-border-strong": "#4a4a52",
      "--fe-text": "#e6e6e9",
      "--fe-text-muted": "#a4a4ad",
      "--fe-text-on-primary": "#17171b",
      "--fe-primary": "#b0b0ba",
      "--fe-primary-hover": "#c4c4cd",
      "--fe-primary-soft": "#242428",
      "--fe-primary-ink": "#c4c4cd",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Terminal Green — phosphor green, monospace face for the full CRT vibe.
    id: "terminal",
    nameKey: "theme.name.terminal",
    light: {
      "--fe-bg": "#f3f9f4",
      "--fe-bg-elev": "#e5f2e8",
      "--fe-bg-hover": "#d5ead9",
      "--fe-bg-selected": "#bce3c6",
      "--fe-border": "#cbe2d1",
      "--fe-border-soft": "#dbebdf",
      "--fe-border-strong": "#94c2a0",
      "--fe-text": "#0c2913",
      "--fe-text-muted": "#31573c",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#116b33",
      "--fe-primary-hover": "#0c5427",
      "--fe-primary-soft": "#dbe9dd",
      "--fe-primary-ink": "#0c5427",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    },
    dark: {
      "--fe-bg": "#050d07",
      "--fe-bg-elev": "#0a1710",
      "--fe-bg-hover": "#112418",
      "--fe-bg-selected": "#1a3a26",
      "--fe-border": "#1c3a2a",
      "--fe-border-soft": "#142b1e",
      "--fe-border-strong": "#316144",
      "--fe-text": "#4fdd8b",
      "--fe-text-muted": "#38a668",
      "--fe-text-on-primary": "#03180a",
      "--fe-primary": "#25c95e",
      "--fe-primary-hover": "#4fdd8b",
      "--fe-primary-soft": "#0c2412",
      "--fe-primary-ink": "#4fdd8b",
      "--fe-danger": "#ff6b62",
      "--fe-danger-hover": "#ff8d86",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    }
  }
];
function Ua(e) {
  return Qi.find((t) => t.id === e);
}
const EC = Array.from(
  new Set(Qi.flatMap((e) => [...Object.keys(e.light), ...Object.keys(e.dark)]))
);
function zC() {
  try {
    const e = localStorage.getItem(To);
    if (e && Ua(e)) return e;
    const t = localStorage.getItem($u);
    return t && Ua(t) ? (localStorage.setItem(To, t), localStorage.removeItem($u), t) : Ln;
  } catch {
    return Ln;
  }
}
const el = m(
  typeof window > "u" ? Ln : zC()
);
function AC(e) {
  const t = Ua(e) ? e : Ln;
  el.value = t;
  try {
    t === Ln ? localStorage.removeItem(To) : localStorage.setItem(To, t);
  } catch {
  }
}
function PC() {
  return { themeId: el, setTheme: AC };
}
const Ys = "filex.thememode", tl = ["host", "auto", "light", "dark"];
function LC() {
  try {
    const e = localStorage.getItem(Ys);
    return e && tl.includes(e) ? e : "host";
  } catch {
    return "host";
  }
}
const nl = m(
  typeof window > "u" ? "host" : LC()
);
function DC(e) {
  const t = tl.includes(e) ? e : "host";
  nl.value = t;
  try {
    t === "host" ? localStorage.removeItem(Ys) : localStorage.setItem(Ys, t);
  } catch {
  }
}
function OC() {
  return { themeMode: nl, setThemeMode: DC };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      if (e.key !== Ys) return;
      const t = e.newValue;
      nl.value = t && tl.includes(t) ? t : "host";
    });
  } catch {
  }
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key === To && (el.value = e.newValue && Ua(e.newValue) ? e.newValue : Ln);
    });
  } catch {
  }
function BC(e, t, n) {
  for (const u of EC) e.style.removeProperty(u);
  if (t === Ln) return;
  const r = Ua(t);
  if (!r) return;
  const a = n ? r.dark : r.light;
  for (const [u, v] of Object.entries(a)) e.style.setProperty(u, v);
}
const xu = "data-filex-theme";
function Su(e) {
  return Object.entries(e).map(([t, n]) => `${t}:${n};`).join("");
}
function IC(e) {
  const t = Su(e.light), n = Su(e.dark), r = [
    ".fe--theme-dark",
    ":root[data-theme='dark'] .fe",
    ".fe.fe--theme-dark",
    ":root.dark",
    ".dark",
    ":root.dark .fe",
    ".dark .fe",
    ".fe-ctx-backdrop--theme-dark",
    ".fe-ctx-backdrop--theme-auto[data-prefers-dark='1']"
  ].join(","), a = [
    ".fe:not(.fe--theme-light)",
    ".fe-ctx-backdrop--theme-auto:not(.fe-ctx-backdrop--theme-light)"
  ].join(",");
  return `/* filex theme: ${e.id} */:root,.fe{${t}}${r}{${n}}@media (prefers-color-scheme: dark){${a}{${n}}}`;
}
function HC(e) {
  if (typeof document > "u") return;
  let t = document.head.querySelector(`style[${xu}]`);
  const n = e === Ln ? void 0 : Ua(e);
  if (!n) {
    t && (t.textContent = "");
    return;
  }
  t ? t !== document.head.lastElementChild && document.head.appendChild(t) : (t = document.createElement("style"), t.setAttribute(xu, ""), document.head.appendChild(t));
  const r = IC(n);
  t.textContent !== r && (t.textContent = r);
}
const FC = {
  key: 0,
  class: "fe-themes__hint"
}, NC = ["aria-label"], KC = ["aria-selected", "data-theme-id", "onClick"], RC = { class: "fe-themecard__name" }, UC = ["title"], VC = /* @__PURE__ */ qe({
  __name: "ThemePalette",
  props: {
    locale: {},
    dark: { type: Boolean },
    current: {},
    hint: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale);
    function u(v) {
      return n.dark ? v.dark : v.light;
    }
    return (v, p) => (c(), d(ae, null, [
      e.hint !== !1 ? (c(), d("p", FC, f(s(a)("theme.hint")), 1)) : g("", !0),
      o("div", {
        class: "fe-themes",
        role: "listbox",
        "aria-label": s(a)("theme.title")
      }, [
        (c(!0), d(ae, null, Te(s(Qi), (h) => (c(), d("button", {
          key: h.id,
          type: "button",
          class: we(["fe-themecard", { "is-selected": h.id === e.current }]),
          role: "option",
          "aria-selected": h.id === e.current,
          "data-theme-id": h.id,
          style: Ct(u(h)),
          onClick: (b) => r("select", h.id)
        }, [
          p[0] || (p[0] = Hu('<span class="fe-themecard__preview" aria-hidden="true"><span class="fe-themecard__topbar"><span class="fe-themecard__chip fe-themecard__chip--primary"></span><span class="fe-themecard__chip"></span><span class="fe-themecard__chip fe-themecard__chip--ghost"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot"></span><span class="fe-themecard__line" style="width:62%;"></span></span><span class="fe-themecard__row fe-themecard__row--selected"><span class="fe-themecard__dot fe-themecard__dot--primary"></span><span class="fe-themecard__line" style="width:44%;"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot fe-themecard__dot--muted"></span><span class="fe-themecard__line fe-themecard__line--muted" style="width:74%;"></span></span></span>', 1)),
          o("span", RC, [
            Je(f(s(a)(h.nameKey)) + " ", 1),
            h.id === e.current ? (c(), d("span", {
              key: 0,
              class: "fe-themecard__check",
              title: s(a)("theme.selected")
            }, "✓", 8, UC)) : g("", !0)
          ])
        ], 14, KC))), 128))
      ], 8, NC)
    ], 64));
  }
}), jC = ["aria-label"], YC = { class: "fe-thememode__label" }, WC = { class: "fe-thememode__seg" }, qC = ["aria-pressed", "onClick"], GC = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, XC = {
  key: 1,
  d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"
}, JC = ["disabled"], ZC = /* @__PURE__ */ qe({
  __name: "ThemeGallery",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    dark: { type: Boolean },
    current: {},
    mode: {},
    hostMode: {}
  },
  emits: ["close", "select", "mode"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = [
      { id: "light", labelKey: "theme.mode.light" },
      { id: "dark", labelKey: "theme.mode.dark" },
      { id: "auto", labelKey: "theme.mode.auto" }
    ], v = k(() => n.mode === "host" ? n.hostMode : n.mode), p = Ln;
    return (h, b) => (c(), et(an, {
      open: e.open,
      title: s(a)("theme.title"),
      size: "lg",
      theme: e.theme,
      onClose: b[3] || (b[3] = (y) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.current === s(p),
          onClick: b[1] || (b[1] = (y) => r("select", s(p)))
        }, f(s(a)("theme.reset")), 9, JC),
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: b[2] || (b[2] = (y) => r("close"))
        }, f(s(a)("theme.close")), 1)
      ]),
      default: st(() => [
        o("div", {
          class: "fe-thememode",
          role: "group",
          "aria-label": s(a)("theme.mode.label")
        }, [
          o("span", YC, f(s(a)("theme.mode.label")), 1),
          o("div", WC, [
            (c(), d(ae, null, Te(u, (y) => o("button", {
              key: y.id,
              type: "button",
              class: we(["fe-thememode__opt", { "is-active": v.value === y.id }]),
              "aria-pressed": v.value === y.id,
              onClick: (A) => r("mode", y.id)
            }, [
              (c(), d("svg", GC, [
                y.id === "light" ? (c(), d(ae, { key: 0 }, [
                  b[4] || (b[4] = o("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4"
                  }, null, -1)),
                  b[5] || (b[5] = o("path", { d: "M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" }, null, -1))
                ], 64)) : y.id === "dark" ? (c(), d("path", XC)) : (c(), d(ae, { key: 2 }, [
                  b[6] || (b[6] = o("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }, null, -1)),
                  b[7] || (b[7] = o("path", {
                    d: "M12 3a9 9 0 0 1 0 18z",
                    fill: "currentColor",
                    stroke: "none"
                  }, null, -1))
                ], 64))
              ])),
              o("span", null, f(s(a)(y.labelKey)), 1)
            ], 10, qC)), 64))
          ])
        ], 8, jC),
        Ge(VC, {
          locale: e.locale,
          dark: e.dark,
          current: e.current,
          onSelect: b[0] || (b[0] = (y) => r("select", y))
        }, null, 8, ["locale", "dark", "current"])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
}), QC = { class: "fe-tzpick" }, e3 = ["id", "aria-expanded", "aria-activedescendant", "disabled", "data-testid", "placeholder", "value"], t3 = ["aria-label", "data-testid"], n3 = ["id", "data-tz-active", "data-testid", "aria-selected", "title", "onMousedown", "onMousemove"], a3 = { class: "fe-tzpick__main" }, o3 = { class: "fe-tzpick__city" }, s3 = {
  key: 0,
  class: "fe-tzpick__region"
}, r3 = { class: "fe-tzpick__meta" }, i3 = {
  key: 0,
  class: "fe-tzpick__time"
}, l3 = { class: "fe-tzpick__offset" }, c3 = {
  key: 0,
  class: "fe-tzpick__empty",
  role: "presentation"
}, u3 = {
  key: 1,
  class: "fe-tzpick__empty",
  role: "presentation"
}, d3 = 50, f3 = /* @__PURE__ */ qe({
  __name: "TimeZonePicker",
  props: {
    locale: {},
    modelValue: {},
    fallback: {},
    disabled: { type: Boolean },
    inputId: {},
    label: {},
    testid: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = k(() => Ai(n.locale)), v = k(() => n.testid || "fe-tz");
    let p = 0;
    const h = `fe-tz-${++p}-${Math.random().toString(36).slice(2, 7)}`, b = k(() => n.inputId || `${h}-input`), y = `${h}-list`;
    function A(be) {
      return be.replace(/[\u0130\u0131]/g, "i").replace(/[\u015e\u015f]/g, "s").replace(/[\u011e\u011f]/g, "g").replace(/[\u00dc\u00fc]/g, "u").replace(/[\u00d6\u00f6]/g, "o").replace(/[\u00c7\u00e7]/g, "c").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[_/\-.]+/g, " ").replace(/\s+/g, " ").trim();
    }
    const D = {
      UTC: "utc gmt zulu z greenwich universal",
      "Etc/UTC": "utc gmt zulu greenwich universal",
      "Etc/GMT": "utc gmt greenwich",
      "Europe/Istanbul": "turkey turkiye ist constantinople",
      "Europe/London": "uk britain england gmt bst",
      "America/New_York": "usa united states eastern est edt nyc",
      "America/Los_Angeles": "usa united states pacific pst pdt la",
      "Asia/Kolkata": "india calcutta ist"
    };
    function C(be) {
      const De = /GMT([+-])(\d{1,2})(?::?(\d{2}))?/.exec(be);
      if (!De) return "gmt utc";
      const [, ie, ce, L] = De, se = String(Number(ce)), Ce = se.padStart(2, "0"), We = L ?? "00", Ie = [`${ie}${se}`, `${ie}${Ce}`, `${ie}${Ce}:${We}`, `${ie}${Ce}${We}`];
      return [...Ie.map((Ze) => `gmt${Ze}`), ...Ie.map((Ze) => `utc${Ze}`), ...Ie].join(" ");
    }
    function B(be, De, ie) {
      var ce;
      try {
        return ((ce = new Intl.DateTimeFormat(De, {
          timeZone: be,
          timeZoneName: ie
        }).formatToParts(/* @__PURE__ */ new Date()).find((se) => se.type === "timeZoneName")) == null ? void 0 : ce.value) ?? "";
      } catch {
        return "";
      }
    }
    function I(be) {
      try {
        return new Intl.DateTimeFormat(u.value, { timeZone: be, hour: "2-digit", minute: "2-digit" });
      } catch {
        return null;
      }
    }
    const U = k(() => n.fallback.zone ?? qs()), x = k(() => {
      const be = U.value;
      return n.fallback.tier === "host" ? a("tz.default.host", { zone: be }) : n.fallback.tier === "account" ? a("tz.default.account", { zone: be }) : a("tz.default.device", { zone: be });
    }), E = m(null);
    let $ = "";
    function M() {
      const be = u.value, De = U.value, ie = A(
        `${De} ${x.value} default automatic device local system account site`
      ), ce = [
        {
          value: "",
          label: x.value,
          region: "",
          offset: B(De, be, "shortOffset"),
          haystack: ie,
          cityFold: A(De.split("/").pop() ?? ""),
          words: ie.split(" ").filter(Boolean),
          fmt: I(De)
        }
      ], L = Nv();
      n.modelValue && !L.includes(n.modelValue) && L.unshift(n.modelValue);
      for (const se of L) {
        const Ce = se.split("/"), We = (Ce[Ce.length - 1] ?? se).replace(/_/g, " "), Ie = Ce.length > 1 ? Ce[0].replace(/_/g, " ") : "", Ze = B(se, be, "shortOffset"), vt = B(se, be, "longGeneric"), Xe = be === "en-US" ? "" : B(se, "en-US", "longGeneric"), Ae = A(
          [se, We, Ie, vt, Xe, D[se] ?? "", C(Ze)].filter(Boolean).join(" ")
        );
        ce.push({
          value: se,
          label: We,
          region: Ie,
          offset: Ze,
          haystack: Ae,
          cityFold: A(We),
          words: Ae.split(" ").filter(Boolean),
          fmt: I(se)
        });
      }
      return ce;
    }
    function z() {
      const be = `${n.locale}|${n.fallback.tier}|${U.value}|${n.modelValue}`;
      E.value && $ === be || ($ = be, E.value = M());
    }
    const T = m(!1), Y = m(""), O = m(0), J = m(null), G = m(null), N = m(/* @__PURE__ */ new Date());
    let P;
    function le() {
      N.value = /* @__PURE__ */ new Date(), P || (P = setInterval(() => N.value = /* @__PURE__ */ new Date(), 1e3));
    }
    function ve() {
      P && clearInterval(P), P = void 0;
    }
    it(ve);
    const he = m({ maxHeight: "264px", above: !1 });
    function oe(be) {
      let De = be.parentElement;
      for (; De; ) {
        const ie = getComputedStyle(De).overflowY;
        if (ie === "auto" || ie === "scroll") {
          const ce = De.getBoundingClientRect();
          return { top: ce.top, bottom: ce.bottom };
        }
        De = De.parentElement;
      }
      return { top: 0, bottom: window.innerHeight };
    }
    function ue() {
      const be = J.value;
      if (!be) return;
      const De = be.getBoundingClientRect(), ie = oe(be), ce = 12, L = ie.bottom - De.bottom - ce, se = De.top - ie.top - ce, Ce = 132, We = 264, Ie = L < Ce && se > L, Ze = Ie ? se : L;
      he.value = {
        maxHeight: `${Math.round(Math.max(Ce, Math.min(We, Ze)))}px`,
        above: Ie
      };
    }
    function Q(be, De) {
      let ie = 0;
      for (const ce of De) {
        let L = 0;
        if (be.cityFold === ce ? L = 120 : be.cityFold.startsWith(ce) ? L = 100 : be.words.some((se) => se.startsWith(ce)) ? L = 70 : be.haystack.includes(ce) && (L = 30), L === 0) return -1;
        ie += L;
      }
      return ie;
    }
    const pe = k(() => {
      const be = E.value ?? [], De = A(Y.value);
      if (!De) {
        const L = be.find((se) => se.value === n.modelValue);
        return !L || L === be[0] ? be : [be[0], L, ...be.slice(1).filter((se) => se !== L)];
      }
      const ie = De.split(" ").filter(Boolean), ce = [];
      return be.forEach((L, se) => {
        const Ce = Q(L, ie);
        Ce >= 0 && ce.push({ row: L, score: Ce, i: se });
      }), ce.sort((L, se) => se.score - L.score || L.i - se.i), ce.map((L) => L.row);
    }), re = k(() => pe.value.slice(0, d3)), S = k(() => Math.max(0, pe.value.length - re.value.length)), w = k(() => {
      if (!n.modelValue) return x.value;
      const be = n.modelValue, De = (be.split("/").pop() ?? be).replace(/_/g, " "), ie = B(be, u.value, "shortOffset");
      return ie ? `${De} — ${ie}` : De;
    });
    function j(be) {
      try {
        return be.fmt ? be.fmt.format(N.value) : "";
      } catch {
        return "";
      }
    }
    function K() {
      z(), T.value = !0, Y.value = "", le();
      const be = re.value.findIndex((De) => De.value === n.modelValue);
      O.value = be >= 0 ? be : 0, gt(() => {
        ue(), Se();
      });
    }
    function Z() {
      T.value = !1, Y.value = "", O.value = 0, ve();
    }
    function W(be) {
      z(), T.value || le(), T.value = !0, Y.value = be.target.value, O.value = 0;
    }
    function $e(be) {
      var De;
      Z(), (De = J.value) == null || De.blur(), be.value !== n.modelValue && r("update:modelValue", be.value);
    }
    function Se() {
      var De;
      const be = (De = G.value) == null ? void 0 : De.querySelector('[data-tz-active="1"]');
      be == null || be.scrollIntoView({ block: "nearest" });
    }
    function ze(be) {
      const De = re.value.length;
      if (De === 0) return;
      const ie = Math.min(O.value, De - 1);
      O.value = (ie + be + De) % De, gt(() => Se());
    }
    function Ne(be) {
      switch (be.key) {
        case "ArrowDown":
          be.preventDefault(), T.value ? ze(1) : K();
          break;
        case "ArrowUp":
          be.preventDefault(), T.value ? ze(-1) : K();
          break;
        case "Home":
          if (!T.value) return;
          be.preventDefault(), O.value = 0, gt(() => Se());
          break;
        case "End":
          if (!T.value) return;
          be.preventDefault(), O.value = Math.max(0, re.value.length - 1), gt(() => Se());
          break;
        case "Enter": {
          if (!T.value) return;
          be.preventDefault();
          const De = re.value[O.value];
          De && $e(De);
          break;
        }
        case "Escape":
          if (!T.value) return;
          be.preventDefault(), be.stopPropagation(), Z();
          break;
        case "Tab":
          Z();
          break;
      }
    }
    return (be, De) => (c(), d("div", QC, [
      o("input", {
        id: b.value,
        ref_key: "inputEl",
        ref: J,
        class: "fe-tzpick__input",
        type: "text",
        role: "combobox",
        autocomplete: "off",
        spellcheck: "false",
        "aria-autocomplete": "list",
        "aria-expanded": T.value,
        "aria-controls": y,
        "aria-activedescendant": T.value && re.value.length ? `${y}-opt-${O.value}` : void 0,
        disabled: e.disabled,
        "data-testid": `${v.value}-filter`,
        placeholder: s(a)("tz.search"),
        value: T.value ? Y.value : w.value,
        onFocus: K,
        onInput: W,
        onKeydown: Ne,
        onBlur: Z
      }, null, 40, e3),
      T.value ? (c(), d("ul", {
        key: 0,
        id: y,
        ref_key: "listEl",
        ref: G,
        class: we(["fe-tzpick__list", { "is-above": he.value.above }]),
        style: Ct({ maxHeight: he.value.maxHeight }),
        role: "listbox",
        "aria-label": e.label || s(a)("tz.title"),
        "data-testid": `${v.value}-list`
      }, [
        (c(!0), d(ae, null, Te(re.value, (ie, ce) => (c(), d("li", {
          id: `${y}-opt-${ce}`,
          key: ie.value || "__default",
          class: we(["fe-tzpick__opt", { "is-active": ce === O.value, "is-current": ie.value === e.modelValue }]),
          "data-tz-active": ce === O.value ? "1" : "0",
          "data-testid": `${v.value}-opt-${ie.value || "device"}`,
          role: "option",
          "aria-selected": ie.value === e.modelValue,
          title: ie.value || U.value,
          onMousedown: Re((L) => $e(ie), ["prevent"]),
          onMousemove: (L) => O.value = ce
        }, [
          o("span", a3, [
            o("span", o3, f(ie.label), 1),
            ie.region ? (c(), d("span", s3, f(ie.region), 1)) : g("", !0)
          ]),
          o("span", r3, [
            j(ie) ? (c(), d("span", i3, f(j(ie)), 1)) : g("", !0),
            o("span", l3, f(ie.offset), 1)
          ])
        ], 42, n3))), 128)),
        re.value.length === 0 ? (c(), d("li", c3, f(s(a)("tz.no_match", { query: Y.value })), 1)) : S.value > 0 ? (c(), d("li", u3, f(s(a)("tz.more", { n: S.value })), 1)) : g("", !0)
      ], 14, t3)) : g("", !0)
    ]));
  }
}), p3 = {
  class: "fe-tzdialog",
  "data-testid": "fe-tz-dialog"
}, v3 = { class: "fe-tzdialog__hint" }, h3 = ["data-tier"], m3 = /* @__PURE__ */ qe({
  __name: "TimeZoneDialog",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = `fe-tzdialog-${Math.random().toString(36).slice(2, 9)}`, v = Ws(Xs, void 0), p = k(() => Mi({ ...Wu(v), viewer: "" })), h = k(() => qu(v)), b = k(() => h.value.zone ?? qs()), y = m("");
    let A;
    function D() {
      y.value = Ha(
        /* @__PURE__ */ new Date(),
        n.locale,
        {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        },
        v
      );
    }
    return He(
      () => n.open,
      (C) => {
        A && clearInterval(A), A = void 0, C && (D(), A = setInterval(D, 1e3));
      },
      { immediate: !0 }
    ), He(h, D), it(() => {
      A && clearInterval(A);
    }), (C, B) => (c(), et(an, {
      open: e.open,
      title: s(a)("tz.title"),
      size: "md",
      theme: e.theme,
      onClose: B[0] || (B[0] = (I) => r("close"))
    }, {
      default: st(() => [
        o("div", p3, [
          o("label", {
            class: "fe-tzdialog__label",
            for: u
          }, f(s(a)("tz.label")), 1),
          Ge(f3, {
            "input-id": u,
            locale: e.locale,
            "model-value": s(Uv)(),
            fallback: p.value,
            label: s(a)("tz.label"),
            testid: "fe-tz",
            "onUpdate:modelValue": s(Vv)
          }, null, 8, ["locale", "model-value", "fallback", "label", "onUpdate:modelValue"]),
          o("p", v3, f(s(a)("tz.hint")), 1),
          o("p", {
            class: "fe-tzdialog__now",
            "data-testid": "fe-tz-now",
            "data-tier": h.value.tier
          }, f(s(a)("tz.now", { zone: b.value, time: y.value })), 9, h3)
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
});
function y3(e) {
  const t = Symbol("filex-explorer");
  Fu(Xs, t), He(
    () => e.config().timeZone,
    (a) => jv(t, a),
    { immediate: !0 }
  );
  const n = () => {
    var a;
    return e.config().callerKind ?? ((a = e.capabilities.value) == null ? void 0 : a.caller_kind);
  };
  let r = !1;
  return He(
    n,
    (a) => {
      if (a !== "user") {
        Wr(t, null);
        return;
      }
      r || (r = !0, e.fetchMe().then((u) => {
        var p;
        if (n() !== "user") return;
        const v = (p = u == null ? void 0 : u.user) == null ? void 0 : p.timezone;
        Wr(t, typeof v == "string" ? v : null);
      }).catch(() => Wr(t, null)));
    },
    { immediate: !0 }
  ), it(() => Yv(t)), t;
}
const b3 = { class: "fe-shortset" }, g3 = { class: "fe-shortset__topbar" }, k3 = { class: "fe-shortset__hint" }, _3 = ["disabled"], w3 = ["innerHTML"], $3 = { class: "fe-shortcuts__heading" }, x3 = { class: "fe-shortset__row" }, S3 = { class: "fe-shortset__label" }, C3 = ["title"], T3 = { class: "fe-shortset__keys" }, M3 = {
  key: 0,
  class: "fe-shortset__capture",
  role: "status"
}, E3 = {
  key: 0,
  class: "fe-shortcuts__unbound"
}, z3 = { class: "fe-kbd" }, A3 = ["title"], P3 = {
  key: 1,
  class: "fe-shortcuts__or",
  "aria-hidden": "true"
}, L3 = { class: "fe-shortset__actions" }, D3 = ["onClick"], O3 = ["title", "aria-label", "onClick"], B3 = ["innerHTML"], I3 = {
  key: 1,
  class: "fe-shortset__fixed"
}, H3 = {
  key: 0,
  class: "fe-shortset__conflict",
  role: "alert"
}, F3 = { class: "fe-shortset__conflict-msg" }, N3 = { class: "fe-kbd" }, K3 = { class: "fe-shortset__conflict-actions" }, R3 = {
  key: 1,
  class: "fe-shortset__conflict",
  role: "alert"
}, U3 = { class: "fe-shortset__conflict-msg" }, V3 = { class: "fe-kbd" }, j3 = { class: "fe-shortset__conflict-actions" }, Y3 = /* @__PURE__ */ qe({
  __name: "ShortcutSettings",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = Uu(), v = k(() => {
      const T = [], Y = /* @__PURE__ */ new Map();
      for (const O of u.value)
        Y.has(O.groupKey) || (Y.set(O.groupKey, []), T.push(O.groupKey)), Y.get(O.groupKey).push(O);
      return T.map((O) => ({ key: O, items: Y.get(O) }));
    }), p = k(() => u.value.some((T) => T.overridden)), h = m(null), b = m(null), y = m(null);
    function A(T) {
      const Y = oa.find((O) => O.id === T);
      return Y ? a(Y.labelKey) : T;
    }
    function D(T) {
      b.value = null, y.value = null, h.value = T;
    }
    function C() {
      h.value = null;
    }
    function B(T, Y) {
      if (h.value = null, Y === Wa(T)) return;
      if (Bc(Y)) {
        y.value = { id: T, combo: Y };
        return;
      }
      const O = Mv(Y, T);
      if (O) {
        b.value = { id: T, combo: Y, conflictId: O.id, fixed: O.fixed };
        return;
      }
      Yr(T, Y);
    }
    function I() {
      const T = b.value;
      !T || T.fixed || (Yr(T.conflictId, ""), Yr(T.id, T.combo), b.value = null);
    }
    function U() {
      b.value = null;
    }
    function x() {
      y.value = null;
    }
    function E(T) {
      b.value = null, y.value = null, Cv(T);
    }
    function $() {
      b.value = null, y.value = null, h.value = null, Tv();
    }
    function M(T) {
      if (h.value) {
        if (T.preventDefault(), T.stopPropagation(), T.key === "Escape") {
          C();
          return;
        }
        const Y = Ti(T);
        if (!Y) return;
        B(h.value, Y);
        return;
      }
      T.key === "Escape" || T.key === "Tab" || T.stopPropagation();
    }
    He(
      () => n.open,
      (T) => {
        T ? window.addEventListener("keydown", M, !0) : (window.removeEventListener("keydown", M, !0), h.value = null, b.value = null, y.value = null);
      }
    ), it(() => window.removeEventListener("keydown", M, !0));
    function z() {
      if (h.value) {
        C();
        return;
      }
      r("close");
    }
    return (T, Y) => (c(), et(an, {
      open: e.open,
      title: s(a)("shortcuts.settings.title"),
      size: "lg",
      theme: e.theme,
      onClose: z
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn",
          onClick: z
        }, f(s(a)("viewer.close")), 1)
      ]),
      default: st(() => [
        o("div", b3, [
          o("div", g3, [
            o("p", k3, f(s(a)("shortcuts.settings.hint")), 1),
            o("button", {
              type: "button",
              class: "fe-btn fe-shortset__reset-all",
              disabled: !p.value,
              onClick: $
            }, [
              o("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: s(Ue)("restore")
              }, null, 8, w3),
              Je(" " + f(s(a)("shortcuts.settings.reset_all")), 1)
            ], 8, _3)
          ]),
          (c(!0), d(ae, null, Te(v.value, (O) => (c(), d("section", {
            key: O.key,
            class: "fe-shortset__group"
          }, [
            o("h3", $3, f(s(a)(O.key)), 1),
            (c(!0), d(ae, null, Te(O.items, (J) => {
              var G;
              return c(), d("div", {
                key: J.id,
                class: we(["fe-shortset__item", {
                  "is-capturing": h.value === J.id,
                  "is-conflict": ((G = b.value) == null ? void 0 : G.id) === J.id
                }])
              }, [
                o("div", x3, [
                  o("span", S3, [
                    Je(f(s(a)(J.labelKey)) + " ", 1),
                    J.overridden ? (c(), d("span", {
                      key: 0,
                      class: "fe-shortcuts__custom",
                      title: s(a)("shortcuts.settings.customized")
                    }, "●", 8, C3)) : g("", !0)
                  ]),
                  o("span", T3, [
                    h.value === J.id ? (c(), d("span", M3, f(s(a)("shortcuts.settings.capture")), 1)) : (c(), d(ae, { key: 1 }, [
                      J.keys.length === 0 ? (c(), d("span", E3, f(s(a)("shortcuts.settings.unbound")), 1)) : (c(!0), d(ae, { key: 1 }, Te(J.keys, (N, P) => (c(), d(ae, { key: N }, [
                        o("kbd", z3, f(N), 1),
                        s(Bc)(N) ? (c(), d("span", {
                          key: 0,
                          class: "fe-shortset__reserved",
                          title: s(a)("shortcuts.settings.reserved_title")
                        }, f(s(a)("shortcuts.settings.reserved_badge")), 9, A3)) : g("", !0),
                        P < J.keys.length - 1 ? (c(), d("span", P3, "/")) : g("", !0)
                      ], 64))), 128))
                    ], 64))
                  ]),
                  o("span", L3, [
                    J.customizable ? (c(), d(ae, { key: 0 }, [
                      h.value !== J.id ? (c(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn fe-shortset__btn",
                        onClick: (N) => D(J.id)
                      }, f(s(a)("shortcuts.settings.change")), 9, D3)) : (c(), d("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-shortset__btn",
                        onClick: C
                      }, f(s(a)("shortcuts.settings.conflict_cancel")), 1)),
                      J.overridden ? (c(), d("button", {
                        key: 2,
                        type: "button",
                        class: "fe-btn fe-btn--icon-only fe-shortset__btn",
                        title: s(a)("shortcuts.settings.reset"),
                        "aria-label": s(a)("shortcuts.settings.reset"),
                        onClick: (N) => E(J.id)
                      }, [
                        o("span", {
                          class: "fe-icon",
                          "aria-hidden": "true",
                          innerHTML: s(Ue)("restore")
                        }, null, 8, B3)
                      ], 8, O3)) : g("", !0)
                    ], 64)) : (c(), d("span", I3, f(s(a)("shortcuts.settings.fixed")), 1))
                  ])
                ]),
                b.value && b.value.id === J.id ? (c(), d("div", H3, [
                  o("span", F3, [
                    o("kbd", N3, f(b.value.combo), 1),
                    Je(" " + f(b.value.fixed ? s(a)("shortcuts.settings.conflict_fixed", { name: A(b.value.conflictId) }) : s(a)("shortcuts.settings.conflict", { name: A(b.value.conflictId) })), 1)
                  ]),
                  o("span", K3, [
                    b.value.fixed ? g("", !0) : (c(), d("button", {
                      key: 0,
                      type: "button",
                      class: "fe-btn fe-btn--danger fe-shortset__btn",
                      onClick: I
                    }, f(s(a)("shortcuts.settings.conflict_take")), 1)),
                    o("button", {
                      type: "button",
                      class: "fe-btn fe-shortset__btn",
                      onClick: U
                    }, f(s(a)("shortcuts.settings.conflict_cancel")), 1)
                  ])
                ])) : g("", !0),
                y.value && y.value.id === J.id ? (c(), d("div", R3, [
                  o("span", U3, [
                    o("kbd", V3, f(y.value.combo), 1),
                    Je(" " + f(s(a)("shortcuts.settings.reserved")), 1)
                  ]),
                  o("span", j3, [
                    o("button", {
                      type: "button",
                      class: "fe-btn fe-shortset__btn",
                      onClick: x
                    }, f(s(a)("shortcuts.settings.conflict_cancel")), 1)
                  ])
                ])) : g("", !0)
              ], 2);
            }), 128))
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
}), W3 = "/web-apps/apps/api/documents/api.js", q3 = "/?embed=1&proto=json", G3 = 1e4;
function X3(e) {
  return e.trim().replace(/\/+$/, "");
}
function J3(e, t) {
  return new Promise((n) => {
    const r = document.createElement("script");
    let a = !1;
    const u = (p) => {
      a || (a = !0, clearTimeout(v), r.remove(), n(p));
    }, v = setTimeout(() => u("timeout"), t);
    r.async = !0, r.src = e, r.onload = () => u("load"), r.onerror = () => u("error"), document.head.appendChild(r);
  });
}
function Z3(e, t) {
  return new Promise((n) => {
    let r = null;
    try {
      r = new URL(e, window.location.href).origin;
    } catch {
      r = null;
    }
    const a = document.createElement("iframe");
    a.setAttribute("aria-hidden", "true"), a.style.cssText = "position:absolute;left:-9999px;width:1px;height:1px;border:0";
    let u = !1;
    const v = (b) => {
      u || (u = !0, clearTimeout(h), window.removeEventListener("message", p), a.remove(), n(b));
    }, p = (b) => {
      if (r && b.origin !== r) return;
      let y = b.data;
      if (typeof y == "string")
        try {
          y = JSON.parse(y);
        } catch {
          return;
        }
      y && typeof y == "object" && y.event === "init" && v("ready");
    };
    window.addEventListener("message", p);
    const h = setTimeout(() => v("timeout"), t);
    a.src = e, document.body.appendChild(a);
  });
}
async function Q3(e) {
  try {
    return await fetch(e, { mode: "no-cors", cache: "no-store" }), !0;
  } catch {
    return !1;
  }
}
const eT = {
  loadScript: J3,
  loadFramed: Z3,
  reachable: Q3,
  hasDocsAPI: () => {
    var e;
    return !!((e = window.DocsAPI) != null && e.DocEditor);
  },
  pageProtocol: () => window.location.protocol,
  now: () => typeof performance < "u" ? performance.now() : Date.now()
};
function Fd(e, t) {
  const n = X3(t);
  return n ? e === "onlyoffice" ? n + W3 : e === "drawio" ? n + q3 : "" : "";
}
async function jD(e, t, n = {}) {
  const r = { ...eT, ...n.deps ?? {} }, a = n.timeoutMs ?? G3, u = Fd(e, t ?? ""), v = e === "onlyoffice" ? "script" : e === "drawio" ? "iframe" : "none";
  if (!u)
    return { service: e, state: "skipped", url: "", ms: 0, mechanism: v };
  if (r.pageProtocol() === "https:" && u.startsWith("http://"))
    return { service: e, state: "blocked-mixed-content", url: u, ms: 0, mechanism: v };
  const p = r.now(), h = () => Math.round(r.now() - p);
  if (v === "script") {
    const b = await r.loadScript(u, a);
    if (b === "timeout") return { service: e, state: "timeout", url: u, ms: h(), mechanism: v };
    if (b === "load")
      return {
        service: e,
        state: r.hasDocsAPI() ? "ok" : "wrong-content",
        url: u,
        ms: h(),
        mechanism: v
      };
    const y = await r.reachable(u);
    return {
      service: e,
      state: y ? "wrong-content" : "unreachable",
      url: u,
      ms: h(),
      mechanism: v
    };
  }
  if (v === "iframe") {
    if (await r.loadFramed(u, a) === "ready") return { service: e, state: "ok", url: u, ms: h(), mechanism: v };
    const y = await r.reachable(u);
    return {
      service: e,
      state: y ? "wrong-content" : "unreachable",
      url: u,
      ms: h(),
      mechanism: v
    };
  }
  return { service: e, state: "skipped", url: "", ms: 0, mechanism: v };
}
const tT = {
  key: 0,
  class: "fe-viewer__bar"
}, nT = { class: "fe-viewer__ident" }, aT = ["innerHTML"], oT = { class: "fe-viewer__idcol" }, sT = ["title"], rT = {
  key: 0,
  class: "fe-viewer__meta"
}, iT = { class: "fe-viewer__acts" }, lT = ["href", "title", "aria-label"], cT = ["innerHTML"], uT = ["title", "aria-label"], dT = ["innerHTML"], fT = ["title", "aria-label"], pT = ["innerHTML"], vT = ["title", "aria-label"], hT = ["innerHTML"], mT = { class: "fe-viewer__tail" }, yT = ["title", "aria-label"], bT = ["innerHTML"], gT = ["src", "alt"], kT = ["src"], _T = ["src"], wT = ["data"], $T = { class: "fe-preview__fallback" }, xT = ["innerHTML"], ST = ["href"], CT = {
  key: 0,
  class: "fe-preview__fallback"
}, TT = {
  key: 1,
  class: "fe-preview__fallback"
}, MT = ["href"], ET = {
  key: 2,
  class: "fe-preview__md-split"
}, zT = { class: "fe-preview__md-split-bar" }, AT = {
  key: 0,
  class: "fe-preview__md-split-error"
}, PT = ["disabled"], LT = { class: "fe-preview__md-split-body" }, DT = ["onKeydown", "placeholder"], OT = {
  key: 0,
  class: "fe-preview__md-split-output fe-preview__md"
}, BT = ["innerHTML"], IT = {
  key: 3,
  class: "fe-preview__fallback"
}, HT = ["href"], FT = ["innerHTML"], NT = {
  key: 5,
  class: "fe-preview__pre"
}, KT = {
  key: 0,
  class: "fe-preview__fallback"
}, RT = ["innerHTML"], UT = ["href"], VT = {
  key: 1,
  class: "fe-preview__fallback"
}, jT = ["innerHTML"], YT = {
  key: 0,
  class: "fe-preview__fallback"
}, WT = {
  key: 1,
  class: "fe-preview__fallback"
}, qT = ["href"], GT = {
  key: 2,
  class: "fe-preview__fallback"
}, XT = ["href"], JT = {
  key: 3,
  class: "fe-preview__code-wrap"
}, ZT = { class: "fe-preview__code-toolbar" }, QT = {
  class: "fe-preview__code-lang",
  lang: "en"
}, e4 = {
  key: 0,
  class: "fe-preview__code-status"
}, t4 = {
  key: 1,
  class: "fe-preview__code-status fe-preview__code-status--ok"
}, n4 = ["innerHTML"], a4 = ["title"], o4 = ["innerHTML"], s4 = {
  key: 3,
  class: "fe-preview__code-status"
}, r4 = ["disabled"], i4 = {
  key: 0,
  class: "fe-preview__pre fe-preview__code hljs"
}, l4 = ["innerHTML"], c4 = ["data-lang"], u4 = {
  key: 0,
  class: "fe-preview__fallback",
  "data-testid": "office-fallback"
}, d4 = ["innerHTML"], f4 = ["href"], p4 = {
  key: 8,
  class: "fe-preview__fallback"
}, v4 = ["innerHTML"], h4 = ["href"], m4 = ["title", "aria-label"], y4 = ["title", "aria-label"], b4 = {
  key: 3,
  class: "fe-viewer__zoom"
}, g4 = ["disabled", "title", "aria-label"], k4 = ["title", "aria-label"], _4 = ["disabled", "title", "aria-label"], w4 = ["title", "aria-label"], $4 = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, Qr = 1e6, Cu = "fe-onlyoffice-api-js", Nd = /* @__PURE__ */ qe({
  __name: "PreviewModal",
  props: {
    open: { type: Boolean },
    locale: {},
    file: {},
    previewUrl: { type: Function },
    downloadUrl: { type: Function },
    onlyOfficeBase: {},
    onlyOfficeConfigEndpoint: {},
    saveTextEndpoint: {},
    archiveListEndpoint: {},
    openMode: {},
    authHeaders: { type: Function },
    authCredentials: {},
    drawioUrl: {},
    pdfWorkerUrl: {},
    pdfSaveUrl: {},
    viewerBaseUrl: {},
    newTabEnabled: { type: Boolean },
    chromeless: { type: Boolean },
    theme: {},
    index: {},
    total: {},
    navEnabled: { type: Boolean },
    apiBase: {},
    shareEnabled: { type: Boolean }
  },
  emits: ["close", "nav", "share", "starred"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a, formatSize: u, formatDate: v, nodeDisplayName: p } = tt(() => n.locale);
    function h(xe) {
      return ((xe == null ? void 0 : xe.extension) || "").toLowerCase();
    }
    const b = ["jpg", "jpeg", "png", "webp", "gif", "bmp", "avif", "svg", "heic"], y = ["mp4", "webm", "mov", "mkv", "m4v", "ogv"], A = ["mp3", "wav", "ogg", "flac", "m4a", "aac", "opus"], D = {
      md: "markdown",
      markdown: "markdown",
      txt: "plaintext",
      log: "plaintext",
      js: "javascript",
      mjs: "javascript",
      cjs: "javascript",
      ts: "typescript",
      tsx: "typescript",
      jsx: "javascript",
      vue: "xml",
      svelte: "xml",
      html: "xml",
      htm: "xml",
      xml: "xml",
      svg: "xml",
      css: "css",
      scss: "scss",
      sass: "scss",
      less: "less",
      json: "json",
      jsonc: "json",
      yml: "yaml",
      yaml: "yaml",
      php: "php",
      py: "python",
      rb: "ruby",
      go: "go",
      rs: "rust",
      java: "java",
      kt: "kotlin",
      swift: "swift",
      cpp: "cpp",
      c: "c",
      h: "cpp",
      hpp: "cpp",
      cs: "csharp",
      dart: "dart",
      sh: "bash",
      bash: "bash",
      zsh: "bash",
      fish: "bash",
      sql: "sql",
      toml: "ini",
      ini: "ini",
      conf: "ini",
      env: "bash",
      cfg: "ini",
      dockerfile: "dockerfile",
      graphql: "graphql",
      gql: "graphql",
      diff: "diff",
      patch: "diff"
    }, C = ["txt", "log"], B = ["docx", "doc", "xlsx", "xls", "pptx", "ppt", "odt", "ods", "odp", "rtf"], I = {
      glb: () => import("./Viewer3D-CdZeK4j4.js"),
      gltf: () => import("./Viewer3D-CdZeK4j4.js"),
      obj: () => import("./Viewer3D-CdZeK4j4.js"),
      stl: () => import("./Viewer3D-CdZeK4j4.js"),
      fbx: () => import("./Viewer3D-CdZeK4j4.js"),
      "3ds": () => import("./Viewer3D-CdZeK4j4.js"),
      epub: () => import("./EpubViewer-CAoTSXTO.js"),
      mmd: () => import("./MermaidViewer-DGwAvRZg.js"),
      mermaid: () => import("./MermaidViewer-DGwAvRZg.js"),
      drawio: () => import("./DrawioViewer-CC6rJXeP.js"),
      dio: () => import("./DrawioViewer-CC6rJXeP.js"),
      tif: () => import("./TiffViewer-D0AurvAh.js"),
      tiff: () => import("./TiffViewer-D0AurvAh.js"),
      psd: () => import("./PsdViewer-DhGweA0m.js"),
      // PDF deliberately uses the native browser viewer (`kind === 'pdf'`
      // branch in the template). PdfViewer.vue still exists for callers
      // that want the rich custom UI but the SFC default keeps things
      // minimal — the browser already paints search/zoom/page UI for free.
      ipynb: () => import("./IpynbViewer-D0GwGpnE.js"),
      csv: () => import("./CsvViewer-Bg2_aqzc.js"),
      tsv: () => import("./CsvViewer-Bg2_aqzc.js"),
      zip: () => import("./ArchiveViewer-BUQWLhwX.js")
    }, U = k(() => {
      const xe = h(n.file);
      if (!xe) return "other";
      if (b.includes(xe)) return "image";
      if (y.includes(xe)) return "video";
      if (A.includes(xe)) return "audio";
      if (xe === "pdf") return "pdf";
      const de = n.openMode !== "view";
      return xe === "md" || xe === "markdown" ? "markdown" : xe in D ? "code" : xe in I ? "viewer" : B.includes(xe) ? "office" : C.includes(xe) ? de ? "code" : "text" : "other";
    }), x = wn(null), E = m(null), $ = m(!1);
    async function M(xe) {
      x.value = null, E.value = null;
      const de = I[xe];
      if (de)
        try {
          const Le = await de();
          x.value = Le.default ?? Le;
        } catch (Le) {
          E.value = Le instanceof Error ? Le.message : "viewer load failed", xe === "pdf" && ($.value = !0);
        }
    }
    function z() {
      $.value = !0;
    }
    const T = k(() => {
      var Le;
      const xe = h(n.file), de = {
        url: P.value,
        ext: xe,
        mime: (Le = n.file) == null ? void 0 : Le.mime_type,
        t: a,
        authHeaders: n.authHeaders,
        authCredentials: n.authCredentials
      };
      return n.file && (de.filePath = ve(n.file.path), (xe === "zip" || xe === "rar" || xe === "7z" || xe === "tar" || xe === "gz" || xe === "tgz") && (de.filePath = n.file.path, n.archiveListEndpoint && (de.archiveListUrl = n.archiveListEndpoint))), (xe === "drawio" || xe === "dio") && (de.drawioUrl = n.drawioUrl ?? void 0, de.saveUrl = n.saveTextEndpoint ?? void 0, de.readOnly = n.openMode === "view"), xe === "pdf" && (de.pdfWorkerUrl = n.pdfWorkerUrl ?? void 0, de.pdfSaveUrl = n.pdfSaveUrl ?? void 0), de;
    });
    function Y() {
      J(n.openMode || "edit");
    }
    function O() {
      J("edit");
    }
    function J(xe) {
      if (!n.file) return;
      const de = h(n.file), Le = n.viewerBaseUrl || "/files/edit", q = Le.includes("?") ? "&" : "?", ne = `${Le}${q}path=${encodeURIComponent(n.file.path)}&type=${encodeURIComponent(de)}&mode=${encodeURIComponent(xe)}`;
      window.open(ne, "_blank", "noopener");
    }
    const G = /* @__PURE__ */ new Set([
      // OnlyOffice — open the in-page office editor (or new tab) with
      // edit permissions.
      "docx",
      "doc",
      "xlsx",
      "xls",
      "pptx",
      "ppt",
      "odt",
      "ods",
      "odp",
      "rtf",
      // Drawio / mermaid round-trip via the new-tab route.
      "drawio",
      "dio",
      "mmd",
      "mermaid",
      // Code / text / markdown — Monaco / split editor.
      "md",
      "markdown",
      "txt",
      "log",
      "json",
      "jsonc",
      "yaml",
      "yml",
      "xml",
      "svg",
      "html",
      "htm",
      "js",
      "mjs",
      "cjs",
      "ts",
      "tsx",
      "jsx",
      "vue",
      "svelte",
      "css",
      "scss",
      "sass",
      "less",
      "php",
      "py",
      "rb",
      "go",
      "rs",
      "java",
      "kt",
      "swift",
      "cpp",
      "c",
      "h",
      "hpp",
      "cs",
      "dart",
      "sh",
      "bash",
      "sql",
      "toml",
      "ini",
      "conf",
      "cfg",
      "env",
      "dockerfile",
      "graphql",
      "gql"
    ]), N = k(
      () => !!n.file && G.has(h(n.file))
    ), P = k(() => n.file ? n.previewUrl(n.file.path) : ""), le = k(() => n.file ? n.downloadUrl(n.file.path) : "");
    function ve(xe) {
      const de = xe.indexOf("://");
      return de === -1 ? xe : xe.slice(de + 3);
    }
    const he = k(() => !n.chromeless), oe = m(null), ue = k(() => n.file ? fn(n.file) : ""), Q = k(() => n.file ? p(n.file) : ""), pe = k(() => {
      const xe = n.index, de = n.total;
      return !xe || !de || de < 1 || xe < 1 ? "" : a("viewer.counter", { i: xe, n: de });
    }), re = k(() => {
      const xe = n.file;
      if (!xe) return "";
      const de = [];
      typeof xe.size == "number" && xe.type === "file" && de.push(u(xe.size));
      const Le = v(xe.last_modified);
      return Le && de.push(Le), pe.value && de.push(pe.value), de.join(" • ");
    }), S = k(
      () => he.value && (n.navEnabled === !0 || (n.total ?? 0) > 1)
    ), w = k(
      () => {
        var xe;
        return typeof ((xe = n.file) == null ? void 0 : xe.id) == "number" ? n.file.id : null;
      }
    ), j = /* @__PURE__ */ new Set(["pdf", "markdown", "code", "text", "office", "viewer"]), K = k(
      () => j.has(U.value) ? "fe-preview--fill" : "fe-preview--center"
    ), Z = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4], W = m(1), $e = m(null), Se = m(0), ze = k(() => he.value && U.value === "image");
    function Ne() {
      if (W.value !== 1 || !$e.value) return;
      const xe = $e.value.getBoundingClientRect().width;
      xe > 0 && (Se.value = xe);
    }
    const be = k(() => {
      if (!(W.value === 1 || !Se.value))
        return {
          width: `${Math.round(Se.value * W.value)}px`,
          height: "auto",
          maxWidth: "none",
          maxHeight: "none"
        };
    });
    function De(xe) {
      const de = W.value;
      if (xe > 0)
        W.value = Z.find((Le) => Le > de + 1e-6) ?? Z[Z.length - 1];
      else {
        const Le = Z.filter((q) => q < de - 1e-6);
        W.value = Le.length ? Le[Le.length - 1] : Z[0];
      }
    }
    function ie() {
      W.value = 1, gt(Ne);
    }
    const ce = k(() => `${Math.round(W.value * 100)}%`), L = k(() => W.value < Z[Z.length - 1] - 1e-6), se = k(() => W.value > Z[0] + 1e-6), Ce = m(!1);
    function We() {
      Ce.value = !!document.fullscreenElement;
    }
    function Ie() {
      var xe, de, Le;
      try {
        document.fullscreenElement ? (xe = document.exitFullscreen) == null || xe.call(document) : (Le = (de = oe.value) == null ? void 0 : de.requestFullscreen) == null || Le.call(de);
      } catch {
      }
    }
    function Ze() {
      he.value && r("close");
    }
    const vt = m(!1), Xe = m(null), Ae = m(""), V = m(!1), R = m(!1), X = m(!1);
    let ye, je;
    function Qe() {
      R.value = !0, ye && clearTimeout(ye), ye = setTimeout(() => {
        Be(Ae.value);
      }, 250), je && clearTimeout(je), je = setTimeout(() => {
        at();
      }, 1500);
    }
    async function at() {
      if (!(!n.saveTextEndpoint || !n.file || X.value)) {
        X.value = !0, Xe.value = null;
        try {
          const xe = {
            "Content-Type": "application/json",
            ...await (n.authHeaders ?? (() => ({})))()
          }, de = await fetch(n.saveTextEndpoint, {
            method: "POST",
            headers: xe,
            credentials: n.authCredentials || "same-origin",
            body: JSON.stringify({ path: ve(n.file.path), content: Ae.value })
          });
          if (!de.ok)
            throw new Error(`save failed: ${de.status} ${await de.text()}`);
          R.value = !1;
        } catch (xe) {
          Xe.value = xe instanceof Error ? xe.message : String(xe);
        } finally {
          X.value = !1;
        }
      }
    }
    async function Ye(xe) {
      vt.value = !0, Xe.value = null, Ae.value = "", V.value = !1;
      try {
        const de = {};
        n.authHeaders && Object.assign(de, await n.authHeaders());
        const Le = await fetch(xe, {
          credentials: n.authCredentials || "same-origin",
          headers: de
        });
        if (!Le.ok)
          throw new Error(`${Le.status} ${Le.statusText}`);
        if (Number(Le.headers.get("content-length") || "0") > Qr) {
          V.value = !0;
          return;
        }
        const ne = await Le.text();
        ne.length > Qr ? (V.value = !0, Ae.value = ne.slice(0, Qr)) : Ae.value = ne;
      } catch (de) {
        Xe.value = de instanceof Error ? de.message : String(de);
      } finally {
        vt.value = !1;
      }
    }
    const lt = m(""), fe = m(null), Pe = m(!1);
    async function Be(xe) {
      try {
        const de = await import(
          /* @vite-ignore */
          "markdown-it"
        ).catch(() => null);
        if (!de) {
          lt.value = "", Pe.value = !0;
          return;
        }
        Pe.value = !1;
        const Le = de.default ?? de, ne = new Le({
          html: !0,
          linkify: !0,
          breaks: !0,
          typographer: !0
        }).render(xe);
        lt.value = ht(ne), await new Promise((H) => setTimeout(H, 0)), await Ft();
      } catch (de) {
        lt.value = "", Xe.value = de instanceof Error ? de.message : String(de);
      }
    }
    function ht(xe) {
      return xe.replace(/<\s*script\b[^<]*(?:(?!<\s*\/\s*script\s*>)<[^<]*)*<\s*\/\s*script\s*>/gi, "").replace(/<\s*iframe\b[\s\S]*?<\s*\/\s*iframe\s*>/gi, "").replace(/<\s*object\b[\s\S]*?<\s*\/\s*object\s*>/gi, "").replace(/<\s*embed\b[^>]*>/gi, "").replace(/\son\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "").replace(/(href|src|action|formaction|xlink:href)\s*=\s*(?:"\s*javascript:[^"]*"|'\s*javascript:[^']*')/gi, '$1="#"');
    }
    async function Ft() {
      var ne, H, te;
      if (!fe.value) return;
      const xe = fe.value, de = Array.from(xe.querySelectorAll("pre > code"));
      if (de.length === 0) return;
      let Le, q;
      for (const _e of de) {
        const Me = _e.className || "", ge = /\blanguage-mermaid\b/.test(Me) || /\blanguage-mmd\b/.test(Me), Oe = /\blanguage-math\b/.test(Me) || /\blanguage-latex\b/.test(Me) || /\blanguage-tex\b/.test(Me);
        if (ge) {
          if (Le === void 0)
            try {
              const mt = await import(
                /* @vite-ignore */
                "mermaid"
              );
              Le = mt.default ?? mt, (ne = Le.initialize) == null || ne.call(Le, {
                startOnLoad: !1,
                securityLevel: "strict"
              });
            } catch {
              Le = null;
            }
          if (!Le) continue;
          try {
            const mt = `filex-md-mermaid-${Math.random().toString(36).slice(2)}`, { svg: Xt } = await Le.render(mt, _e.textContent || ""), sa = document.createElement("div");
            sa.className = "fe-preview__md-mermaid", sa.innerHTML = Xt, (H = _e.parentElement) == null || H.replaceWith(sa);
          } catch {
          }
        } else if (Oe) {
          if (q === void 0)
            try {
              const mt = await import(
                /* @vite-ignore */
                "./katex-yuB6V-q6.js"
              );
              q = mt.default ?? mt;
            } catch {
              q = null;
            }
          if (!q) continue;
          try {
            const mt = q.renderToString(_e.textContent || "", {
              displayMode: !0,
              throwOnError: !1
            }), Xt = document.createElement("div");
            Xt.className = "fe-preview__md-math", Xt.innerHTML = mt, (te = _e.parentElement) == null || te.replaceWith(Xt);
          } catch {
          }
        }
      }
    }
    const ft = m("");
    async function qt(xe, de) {
      try {
        const Le = await Zu();
        if (!Le) {
          ft.value = "";
          return;
        }
        const q = Le.default ?? Le;
        if (q.getLanguage(de)) {
          const ne = q.highlight(xe, { language: de, ignoreIllegals: !0 });
          ft.value = ne.value;
        } else {
          const ne = q.highlightAuto(xe);
          ft.value = ne.value;
        }
      } catch (Le) {
        ft.value = "", Xe.value = Le instanceof Error ? Le.message : String(Le);
      }
    }
    const Gt = m(null);
    let wt = null, en;
    const $t = m(!1), kt = m(!1), Dt = m(!1), At = m(!1), Ot = m(null);
    function Bt() {
      if (wt) {
        try {
          wt.dispose();
        } catch {
        }
        wt = null;
      }
      $t.value = !1, At.value = !1, Ot.value = null;
    }
    function un(xe) {
      return {
        js: "javascript",
        mjs: "javascript",
        cjs: "javascript",
        ts: "typescript",
        tsx: "typescript",
        jsx: "javascript",
        json: "json",
        jsonc: "json",
        css: "css",
        scss: "scss",
        sass: "scss",
        less: "less",
        html: "html",
        htm: "html",
        vue: "html",
        svelte: "html",
        xml: "xml",
        svg: "xml",
        md: "markdown",
        markdown: "markdown",
        php: "php",
        py: "python",
        yml: "yaml",
        yaml: "yaml",
        go: "go",
        rs: "rust",
        sql: "sql",
        cpp: "cpp",
        c: "c",
        h: "cpp",
        hpp: "cpp",
        sh: "shell",
        bash: "shell",
        dockerfile: "dockerfile",
        toml: "ini",
        ini: "ini",
        conf: "ini",
        cfg: "ini"
      }[xe] ?? "plaintext";
    }
    async function pt(xe, de) {
      var q;
      const Le = await ri();
      if (Le || (kt.value = !0), !Le || !Gt.value) return !1;
      try {
        Bt();
        const ne = !!n.saveTextEndpoint && n.openMode !== "view", H = n.theme === "dark" ? !0 : n.theme === "light" ? !1 : (q = window.matchMedia) == null ? void 0 : q.call(window, "(prefers-color-scheme: dark)").matches;
        return wt = Le.editor.create(Gt.value, {
          value: xe,
          language: un(de),
          readOnly: !ne,
          theme: H ? "vs-dark" : "vs",
          automaticLayout: !0,
          minimap: { enabled: !1 },
          fontSize: 13
        }), ne && (wt.addCommand(
          Le.KeyMod.CtrlCmd | Le.KeyCode.KeyS,
          () => void tn()
        ), wt.onDidChangeModelContent(() => {
          en && clearTimeout(en), en = setTimeout(() => {
            tn();
          }, 1500);
        })), $t.value = !0, !0;
      } catch (ne) {
        return Xe.value = `Monaco mount fail: ${ne.message}`, !1;
      }
    }
    async function tn() {
      if (!(!n.saveTextEndpoint || !n.file) && n.openMode !== "view" && !Dt.value) {
        Dt.value = !0, At.value = !1, Ot.value = null;
        try {
          const xe = wt ? wt.getValue() : "", de = { "Content-Type": "application/json" };
          n.authHeaders && Object.assign(de, await n.authHeaders());
          const Le = await fetch(n.saveTextEndpoint, {
            method: "POST",
            headers: de,
            credentials: n.authCredentials || "same-origin",
            body: JSON.stringify({
              path: ve(n.file.path),
              content: xe
            })
          });
          if (!Le.ok) {
            const q = await Le.text().catch(() => "");
            throw new Error(`${Le.status} ${Le.statusText}${q ? " — " + q.slice(0, 150) : ""}`);
          }
          At.value = !0, setTimeout(() => {
            At.value = !1;
          }, 2500);
        } catch (xe) {
          Ot.value = xe.message;
        } finally {
          Dt.value = !1;
        }
      }
    }
    async function xt(xe, de, Le) {
      if (Ae.value = "", lt.value = "", ft.value = "", Xe.value = null, _t.value = null, x.value = null, E.value = null, $.value = !1, W.value = 1, Se.value = 0, Nt(), Bt(), !(!xe || !de)) {
        if (Le === "viewer") {
          await M(h(n.file));
          return;
        }
        if (Le === "markdown" || Le === "code" || Le === "text") {
          if (await Ye(de), V.value) return;
          if (Le === "markdown") {
            await Be(Ae.value);
            return;
          }
          const q = D[h(n.file)] || "";
          Qu() ? (await new Promise((te) => setTimeout(te, 0)), await pt(Ae.value, h(n.file)) || await qt(Ae.value, q)) : (Le === "code" && await qt(Ae.value, q), ri().then(async (H) => {
            if (!H) {
              kt.value = !0;
              return;
            }
            n.open && (await new Promise((te) => setTimeout(te, 0)), await pt(Ae.value, h(n.file)));
          }));
        } else Le === "office" && (await new Promise((q) => setTimeout(q, 0)), await sn());
      }
    }
    He(
      () => [n.open, P.value, U.value, n.openMode],
      ([xe, de, Le]) => {
        xt(xe, de, Le);
      }
    ), dt(() => {
      document.addEventListener("fullscreenchange", We), gt(() => {
        n.open && xt(n.open, P.value, U.value);
      });
    });
    const jt = k(() => D[h(n.file)] || "plaintext"), Pt = m(null), _t = m(null);
    let St = null;
    async function sn() {
      if (_t.value = null, !(!n.file || U.value !== "office")) {
        if (!n.onlyOfficeConfigEndpoint) {
          _t.value = a("viewer.office_unconfigured");
          return;
        }
        if (Pt.value)
          try {
            const xe = { "Content-Type": "application/json" };
            n.authHeaders && Object.assign(xe, await n.authHeaders());
            const de = await fetch(n.onlyOfficeConfigEndpoint, {
              method: "POST",
              headers: xe,
              credentials: n.authCredentials || "same-origin",
              body: JSON.stringify({
                // Send the FULL adapter-qualified path. The backend resolves
                // `<adapter>://<rel>` against ListEnabledStorages; passing the
                // bare relative path falls back to storages[0] which 404s for
                // anything sitting on a non-primary storage (e.g. s3-test).
                path: n.file.path,
                mode: n.openMode || "edit"
              })
            });
            if (!de.ok)
              throw new Error(`Config fetch ${de.status}: ${(await de.text()).slice(0, 200)}`);
            const { config: Le, documentServerUrl: q } = await de.json();
            await mn(q), Nt();
            const ne = "fe-onlyoffice-mount";
            Pt.value.id = ne, Le.events = {
              onError: (te) => {
                _t.value = nn(te);
              }
            };
            const H = window;
            if (!H.DocsAPI || !H.DocsAPI.DocEditor)
              throw new Error("DocsAPI not available after script load");
            St = new H.DocsAPI.DocEditor(ne, Le);
          } catch (xe) {
            _t.value = xe instanceof Error ? xe.message : String(xe);
          }
      }
    }
    function Nt() {
      var xe;
      try {
        (xe = St == null ? void 0 : St.destroyEditor) == null || xe.call(St);
      } catch {
      }
      St = null;
    }
    it(() => {
      document.removeEventListener("fullscreenchange", We), Nt(), Bt();
    });
    function nn(xe) {
      if (typeof xe == "string") return xe;
      const de = xe;
      if (de != null && de.data && typeof de.data == "object") {
        const Le = de.data;
        if (typeof Le.errorDescription == "string") return Le.errorDescription;
        if (typeof Le.message == "string") return Le.message;
        if (Le.errorCode !== void 0) return `OnlyOffice error ${Le.errorCode}`;
      }
      if (typeof (de == null ? void 0 : de.data) == "string") return de.data;
      if (typeof (de == null ? void 0 : de.errorDescription) == "string") return de.errorDescription;
      if (typeof (de == null ? void 0 : de.message) == "string") return de.message;
      try {
        return JSON.stringify(xe);
      } catch {
        return "OnlyOffice error";
      }
    }
    function mn(xe) {
      return new Promise((de, Le) => {
        var H;
        if ((H = window.DocsAPI) != null && H.DocEditor) {
          de();
          return;
        }
        const q = document.getElementById(Cu);
        if (q) {
          q.addEventListener("load", () => de()), q.addEventListener("error", () => Le(new Error("OnlyOffice api.js load failed")));
          return;
        }
        const ne = document.createElement("script");
        ne.id = Cu, ne.src = Fd("onlyoffice", xe), ne.async = !0, ne.onload = () => de(), ne.onerror = () => Le(new Error("OnlyOffice api.js load failed")), document.head.appendChild(ne);
      });
    }
    return (xe, de) => {
      var Le;
      return c(), et(an, {
        open: e.open,
        size: "xl",
        title: ((Le = e.file) == null ? void 0 : Le.basename) || "",
        chromeless: e.chromeless,
        fullbleed: !e.chromeless,
        theme: e.theme,
        onClose: de[8] || (de[8] = (q) => r("close"))
      }, {
        default: st(() => [
          o("div", {
            ref_key: "viewerEl",
            ref: oe,
            class: we(["fe-viewer", { "fe-viewer--bare": e.chromeless }])
          }, [
            he.value && e.file ? (c(), d("header", tT, [
              o("div", nT, [
                o("span", {
                  class: "fe-viewer__tile",
                  "aria-hidden": "true",
                  innerHTML: ue.value
                }, null, 8, aT),
                o("span", oT, [
                  o("span", {
                    class: "fe-viewer__name",
                    title: e.file.path
                  }, f(Q.value), 9, sT),
                  re.value ? (c(), d("span", rT, f(re.value), 1)) : g("", !0)
                ])
              ]),
              o("div", iT, [
                o("a", {
                  href: le.value,
                  class: "fe-viewer__act",
                  title: s(a)("viewer.download"),
                  "aria-label": s(a)("viewer.download")
                }, [
                  o("span", {
                    class: "fe-icon",
                    "aria-hidden": "true",
                    innerHTML: s(Ue)("download")
                  }, null, 8, cT)
                ], 8, lT),
                e.shareEnabled ? (c(), d("button", {
                  key: 0,
                  type: "button",
                  class: "fe-viewer__act",
                  title: s(a)("viewer.share"),
                  "aria-label": s(a)("viewer.share"),
                  onClick: de[0] || (de[0] = (q) => r("share"))
                }, [
                  o("span", {
                    class: "fe-icon",
                    "aria-hidden": "true",
                    innerHTML: s(Ue)("access")
                  }, null, 8, dT)
                ], 8, uT)) : g("", !0),
                w.value !== null ? (c(), et(er, {
                  key: 1,
                  class: "fe-viewer__act fe-viewer__act--star",
                  starred: e.file.starred === !0,
                  "node-id": w.value,
                  "api-base": e.apiBase,
                  "auth-headers": e.authHeaders,
                  "auth-credentials": e.authCredentials,
                  locale: e.locale,
                  compact: "",
                  onChange: de[1] || (de[1] = (q) => r("starred", q))
                }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale"])) : g("", !0),
                e.openMode === "view" && N.value && e.newTabEnabled !== !1 ? (c(), d("button", {
                  key: 2,
                  type: "button",
                  class: "fe-viewer__act",
                  title: s(a)("viewer.edit"),
                  "aria-label": s(a)("viewer.edit"),
                  onClick: O
                }, [
                  o("span", {
                    class: "fe-icon",
                    "aria-hidden": "true",
                    innerHTML: s(Ue)("rename")
                  }, null, 8, pT)
                ], 8, fT)) : g("", !0),
                e.newTabEnabled !== !1 ? (c(), d("button", {
                  key: 3,
                  type: "button",
                  class: "fe-viewer__act",
                  title: s(a)("viewer.open_in_new_tab"),
                  "aria-label": s(a)("viewer.open_in_new_tab"),
                  onClick: Y
                }, [
                  o("span", {
                    class: "fe-icon",
                    "aria-hidden": "true",
                    innerHTML: s(Ue)("open-tab")
                  }, null, 8, hT)
                ], 8, vT)) : g("", !0)
              ]),
              o("div", mT, [
                o("button", {
                  type: "button",
                  class: "fe-viewer__act fe-viewer__close",
                  title: s(a)("viewer.close"),
                  "aria-label": s(a)("viewer.close"),
                  onClick: de[2] || (de[2] = (q) => r("close"))
                }, [
                  o("span", {
                    class: "fe-icon",
                    "aria-hidden": "true",
                    innerHTML: s(Ue)("close")
                  }, null, 8, bT)
                ], 8, yT)
              ])
            ])) : g("", !0),
            o("div", {
              class: "fe-viewer__stage",
              onClick: Re(Ze, ["self"])
            }, [
              e.file ? (c(), d("div", {
                key: 0,
                class: we(["fe-preview", K.value]),
                onClick: Re(Ze, ["self"])
              }, [
                U.value === "image" ? (c(), d("img", {
                  key: 0,
                  ref_key: "imgEl",
                  ref: $e,
                  src: P.value,
                  alt: e.file.basename,
                  class: "fe-preview__image",
                  style: Ct(be.value),
                  onLoad: Ne
                }, null, 44, gT)) : U.value === "video" ? (c(), d("video", {
                  key: 1,
                  src: P.value,
                  controls: "",
                  preload: "metadata",
                  class: "fe-preview__video"
                }, null, 8, kT)) : U.value === "audio" ? (c(), d("audio", {
                  key: 2,
                  src: P.value,
                  controls: "",
                  class: "fe-preview__audio"
                }, null, 8, _T)) : U.value === "pdf" ? (c(), d("object", {
                  key: 3,
                  data: P.value,
                  type: "application/pdf",
                  class: "fe-preview__iframe"
                }, [
                  o("div", $T, [
                    o("span", {
                      class: "fe-preview__fallback-icon",
                      "aria-hidden": "true",
                      innerHTML: ue.value
                    }, null, 8, xT),
                    o("p", null, f(s(a)("viewer.pdf_inline_failed")), 1),
                    o("a", {
                      href: le.value,
                      class: "fe-btn fe-btn--primary",
                      target: "_blank",
                      rel: "noopener"
                    }, f(s(a)("viewer.open_in_new_tab")), 9, ST)
                  ])
                ], 8, wT)) : U.value === "markdown" ? (c(), d(ae, { key: 4 }, [
                  vt.value ? (c(), d("div", CT, f(s(a)("viewer.loading")), 1)) : V.value ? (c(), d("div", TT, [
                    Je(f(s(a)("viewer.too_large")) + " ", 1),
                    o("a", {
                      href: le.value,
                      class: "fe-btn"
                    }, f(s(a)("viewer.download")), 9, MT)
                  ])) : e.openMode === "edit" && e.saveTextEndpoint ? (c(), d("div", ET, [
                    o("div", zT, [
                      de[9] || (de[9] = o("span", { class: "fe-preview__md-split-label" }, "MARKDOWN", -1)),
                      Xe.value ? (c(), d("span", AT, f(Xe.value), 1)) : g("", !0),
                      o("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: !R.value || X.value,
                        onClick: at
                      }, f(X.value ? s(a)("viewer.saving") : R.value ? s(a)("viewer.save") : s(a)("viewer.saved")), 9, PT)
                    ]),
                    o("div", LT, [
                      Ve(o("textarea", {
                        class: "fe-preview__md-split-input",
                        "onUpdate:modelValue": de[3] || (de[3] = (q) => Ae.value = q),
                        onInput: Qe,
                        onKeydown: [
                          Ut(Re(at, ["ctrl", "prevent"]), ["s"]),
                          Ut(Re(at, ["meta", "prevent"]), ["s"])
                        ],
                        spellcheck: "false",
                        placeholder: s(a)("viewer.md_placeholder")
                      }, null, 40, DT), [
                        [rt, Ae.value]
                      ]),
                      Pe.value ? (c(), d("div", OT, f(s(a)("viewer.peer_not_installed")), 1)) : (c(), d("div", {
                        key: 1,
                        ref_key: "markdownEl",
                        ref: fe,
                        class: "fe-preview__md-split-output fe-preview__md",
                        innerHTML: lt.value
                      }, null, 8, BT))
                    ])
                  ])) : Xe.value ? (c(), d("div", IT, [
                    o("p", null, f(Xe.value), 1),
                    o("a", {
                      href: le.value,
                      class: "fe-btn fe-btn--primary"
                    }, f(s(a)("viewer.download")), 9, HT)
                  ])) : lt.value ? (c(), d("div", {
                    key: 4,
                    ref_key: "markdownEl",
                    ref: fe,
                    class: "fe-preview__md",
                    innerHTML: lt.value
                  }, null, 8, FT)) : (c(), d("pre", NT, f(Ae.value), 1))
                ], 64)) : U.value === "viewer" ? (c(), d(ae, { key: 5 }, [
                  E.value && !$.value ? (c(), d("div", KT, [
                    o("span", {
                      class: "fe-preview__fallback-icon fe-preview__fallback-icon--alert",
                      "aria-hidden": "true",
                      innerHTML: s(Ue)("alert")
                    }, null, 8, RT),
                    o("p", null, f(E.value), 1),
                    o("a", {
                      href: le.value,
                      class: "fe-btn fe-btn--primary"
                    }, f(s(a)("viewer.download")), 9, UT)
                  ])) : x.value ? (c(), et(rv(x.value), iv({ key: 2 }, T.value, {
                    class: "fe-preview__viewer",
                    onFallback: z
                  }), null, 16)) : (c(), d("div", VT, [
                    o("span", {
                      class: "fe-preview__fallback-icon fe-preview__fallback-icon--spin",
                      "aria-hidden": "true",
                      innerHTML: s(Ue)("progress")
                    }, null, 8, jT),
                    o("p", null, f(s(a)("viewer.loading")), 1)
                  ]))
                ], 64)) : U.value === "code" || U.value === "text" ? (c(), d(ae, { key: 6 }, [
                  vt.value ? (c(), d("div", YT, f(s(a)("viewer.loading")), 1)) : V.value ? (c(), d("div", WT, [
                    Je(f(s(a)("viewer.too_large")) + " ", 1),
                    o("a", {
                      href: le.value,
                      class: "fe-btn"
                    }, f(s(a)("viewer.download")), 9, qT)
                  ])) : Xe.value ? (c(), d("div", GT, [
                    o("p", null, f(Xe.value), 1),
                    o("a", {
                      href: le.value,
                      class: "fe-btn fe-btn--primary"
                    }, f(s(a)("viewer.download")), 9, XT)
                  ])) : (c(), d("div", JT, [
                    o("div", ZT, [
                      o("span", QT, f(jt.value), 1),
                      !$t.value && ft.value ? (c(), d("span", e4, f(e.saveTextEndpoint && !kt.value ? s(a)("viewer.editor_loading") : s(a)("viewer.read_only")), 1)) : g("", !0),
                      At.value ? (c(), d("span", t4, [
                        o("span", {
                          class: "fe-icon",
                          "aria-hidden": "true",
                          innerHTML: s(Ue)("check")
                        }, null, 8, n4),
                        Je(" " + f(s(a)("viewer.saved")), 1)
                      ])) : g("", !0),
                      Ot.value ? (c(), d("span", {
                        key: 2,
                        class: "fe-preview__code-status fe-preview__code-status--err",
                        title: Ot.value
                      }, [
                        o("span", {
                          class: "fe-icon",
                          "aria-hidden": "true",
                          innerHTML: s(Ue)("close")
                        }, null, 8, o4),
                        Je(" " + f(s(a)("viewer.save_error")), 1)
                      ], 8, a4)) : g("", !0),
                      e.openMode === "view" ? (c(), d("span", s4, f(s(a)("viewer.read_only")), 1)) : e.saveTextEndpoint && $t.value ? (c(), d("button", {
                        key: 4,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: Dt.value,
                        onClick: tn
                      }, f(Dt.value ? s(a)("viewer.saving") : s(a)("viewer.save")), 9, r4)) : g("", !0)
                    ]),
                    o("div", {
                      ref_key: "monacoEl",
                      ref: Gt,
                      class: we(["fe-preview__code-editor", { "is-hidden": !$t.value }])
                    }, null, 2),
                    !$t.value && ft.value ? (c(), d("pre", i4, [
                      o("code", {
                        class: we(`language-${jt.value}`),
                        innerHTML: ft.value
                      }, null, 10, l4)
                    ])) : !$t.value && !ft.value ? (c(), d("pre", {
                      key: 1,
                      class: "fe-preview__pre",
                      "data-lang": jt.value
                    }, f(Ae.value), 9, c4)) : g("", !0)
                  ]))
                ], 64)) : U.value === "office" ? (c(), d(ae, { key: 7 }, [
                  _t.value ? (c(), d("div", u4, [
                    o("span", {
                      class: "fe-preview__fallback-icon",
                      "aria-hidden": "true",
                      innerHTML: ue.value
                    }, null, 8, d4),
                    o("p", null, f(_t.value), 1),
                    o("a", {
                      href: le.value,
                      class: "fe-btn fe-btn--primary"
                    }, f(s(a)("viewer.download")), 9, f4)
                  ])) : (c(), d("div", {
                    key: 1,
                    ref_key: "officeEl",
                    ref: Pt,
                    class: "fe-preview__office"
                  }, null, 512))
                ], 64)) : (c(), d("div", p4, [
                  o("span", {
                    class: "fe-preview__fallback-icon",
                    "aria-hidden": "true",
                    innerHTML: ue.value
                  }, null, 8, v4),
                  o("p", null, f(s(a)("viewer.no_preview")), 1),
                  o("a", {
                    href: le.value,
                    class: "fe-btn fe-btn--primary"
                  }, f(s(a)("viewer.download")), 9, h4)
                ]))
              ], 2)) : g("", !0)
            ]),
            S.value ? (c(), d("button", {
              key: 1,
              type: "button",
              class: "fe-viewer__chev fe-viewer__chev--prev",
              title: s(a)("viewer.nav_prev"),
              "aria-label": s(a)("viewer.nav_prev"),
              onClick: de[4] || (de[4] = (q) => r("nav", -1))
            }, [...de[10] || (de[10] = [
              o("svg", {
                viewBox: "0 0 24 24",
                width: "22",
                height: "22",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                o("path", { d: "M15 4.5L7.5 12 15 19.5" })
              ], -1)
            ])], 8, m4)) : g("", !0),
            S.value ? (c(), d("button", {
              key: 2,
              type: "button",
              class: "fe-viewer__chev fe-viewer__chev--next",
              title: s(a)("viewer.nav_next"),
              "aria-label": s(a)("viewer.nav_next"),
              onClick: de[5] || (de[5] = (q) => r("nav", 1))
            }, [...de[11] || (de[11] = [
              o("svg", {
                viewBox: "0 0 24 24",
                width: "22",
                height: "22",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.8",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                o("path", { d: "M9 4.5L16.5 12 9 19.5" })
              ], -1)
            ])], 8, y4)) : g("", !0),
            ze.value ? (c(), d("div", b4, [
              o("button", {
                type: "button",
                class: "fe-viewer__zoom-btn",
                disabled: !se.value,
                title: s(a)("viewer.zoom_out"),
                "aria-label": s(a)("viewer.zoom_out"),
                onClick: de[6] || (de[6] = (q) => De(-1))
              }, "−", 8, g4),
              o("button", {
                type: "button",
                class: "fe-viewer__zoom-level",
                title: s(a)("viewer.zoom_reset"),
                "aria-label": s(a)("viewer.zoom_reset"),
                onClick: ie
              }, f(ce.value), 9, k4),
              o("button", {
                type: "button",
                class: "fe-viewer__zoom-btn",
                disabled: !L.value,
                title: s(a)("viewer.zoom_in"),
                "aria-label": s(a)("viewer.zoom_in"),
                onClick: de[7] || (de[7] = (q) => De(1))
              }, "+", 8, _4),
              de[20] || (de[20] = o("span", {
                class: "fe-viewer__zoom-sep",
                "aria-hidden": "true"
              }, null, -1)),
              o("button", {
                type: "button",
                class: "fe-viewer__zoom-btn",
                title: Ce.value ? s(a)("viewer.exit_fullscreen") : s(a)("viewer.fullscreen"),
                "aria-label": Ce.value ? s(a)("viewer.exit_fullscreen") : s(a)("viewer.fullscreen"),
                onClick: Ie
              }, [
                (c(), d("svg", $4, [
                  Ce.value ? (c(), d(ae, { key: 0 }, [
                    de[12] || (de[12] = o("path", { d: "M9.5 4.5v5h-5" }, null, -1)),
                    de[13] || (de[13] = o("path", { d: "M14.5 4.5v5h5" }, null, -1)),
                    de[14] || (de[14] = o("path", { d: "M9.5 19.5v-5h-5" }, null, -1)),
                    de[15] || (de[15] = o("path", { d: "M14.5 19.5v-5h5" }, null, -1))
                  ], 64)) : (c(), d(ae, { key: 1 }, [
                    de[16] || (de[16] = o("path", { d: "M4.5 9.5v-5h5" }, null, -1)),
                    de[17] || (de[17] = o("path", { d: "M19.5 9.5v-5h-5" }, null, -1)),
                    de[18] || (de[18] = o("path", { d: "M4.5 14.5v5h5" }, null, -1)),
                    de[19] || (de[19] = o("path", { d: "M19.5 14.5v5h-5" }, null, -1))
                  ], 64))
                ]))
              ], 8, w4)
            ])) : g("", !0)
          ], 2)
        ]),
        _: 1
      }, 8, ["open", "title", "chromeless", "fullbleed", "theme"]);
    };
  }
}), x4 = {
  key: 0,
  class: "fe-ql-hint__sep"
}, S4 = { class: "fe-ql-hint__seg" }, C4 = /* @__PURE__ */ qe({
  __name: "QuickLook",
  props: {
    open: { type: Boolean },
    locale: {},
    file: {},
    previewUrl: { type: Function },
    downloadUrl: { type: Function },
    onlyOfficeBase: {},
    onlyOfficeConfigEndpoint: {},
    authHeaders: { type: Function },
    authCredentials: {},
    drawioUrl: {},
    pdfWorkerUrl: {},
    viewerBaseUrl: {},
    theme: {},
    index: {},
    total: {},
    apiBase: {},
    shareEnabled: { type: Boolean }
  },
  emits: ["close", "nav", "open-full", "share", "starred"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale);
    function u(b) {
      const y = b;
      return !!(y && (y.tagName === "INPUT" || y.tagName === "TEXTAREA" || y.tagName === "SELECT" || y.isContentEditable));
    }
    const v = ["↑", "↓"];
    function p(b) {
      if (n.open && !u(b.target)) {
        if (si(b, "quicklook")) {
          b.preventDefault(), b.stopPropagation(), r("close");
          return;
        }
        if (si(b, "open")) {
          b.preventDefault(), b.stopPropagation(), r("open-full");
          return;
        }
        if (!(b.ctrlKey || b.metaKey || b.altKey))
          switch (b.key) {
            case "ArrowRight":
            case "ArrowDown":
              b.preventDefault(), b.stopPropagation(), r("nav", 1);
              break;
            case "ArrowLeft":
            case "ArrowUp":
              b.preventDefault(), b.stopPropagation(), r("nav", -1);
              break;
          }
      }
    }
    const h = k(() => {
      const b = [], y = Na("quicklook");
      y && b.push({ id: "quicklook", keys: [y], label: a("quicklook.hint_close") }), b.push({ id: "nav", keys: [...v], label: a("quicklook.hint_nav") });
      const A = Na("open");
      return A && b.push({ id: "open", keys: [A], label: a("quicklook.hint_open") }), b;
    });
    return He(
      () => n.open,
      (b) => {
        b ? window.addEventListener("keydown", p, !0) : window.removeEventListener("keydown", p, !0);
      },
      { immediate: !0 }
    ), it(() => window.removeEventListener("keydown", p, !0)), (b, y) => (c(), d(ae, null, [
      Ge(Nd, {
        class: "fe-quicklook",
        open: e.open,
        locale: e.locale,
        file: e.file,
        theme: e.theme,
        "preview-url": e.previewUrl,
        "download-url": e.downloadUrl,
        "only-office-base": e.onlyOfficeBase,
        "only-office-config-endpoint": e.onlyOfficeConfigEndpoint,
        "open-mode": "view",
        "auth-headers": e.authHeaders,
        "auth-credentials": e.authCredentials,
        "drawio-url": e.drawioUrl,
        "pdf-worker-url": e.pdfWorkerUrl,
        "viewer-base-url": e.viewerBaseUrl,
        index: e.index,
        total: e.total,
        "api-base": e.apiBase,
        "share-enabled": e.shareEnabled,
        "nav-enabled": !0,
        onClose: y[0] || (y[0] = (A) => r("close")),
        onNav: y[1] || (y[1] = (A) => r("nav", A)),
        onShare: y[2] || (y[2] = (A) => r("share")),
        onStarred: y[3] || (y[3] = (A) => r("starred", A))
      }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "viewer-base-url", "index", "total", "api-base", "share-enabled"]),
      (c(), et(ja, { to: "body" }, [
        Ge(Rn, { name: "fe-toast" }, {
          default: st(() => [
            e.open ? (c(), d("div", {
              key: 0,
              class: we(["fe fe-ql-hint", {
                "fe--theme-light": e.theme === "light",
                "fe--theme-dark": e.theme === "dark"
              }]),
              "aria-hidden": "true"
            }, [
              (c(!0), d(ae, null, Te(h.value, (A, D) => (c(), d(ae, {
                key: A.id
              }, [
                D > 0 ? (c(), d("span", x4, "·")) : g("", !0),
                o("span", S4, [
                  (c(!0), d(ae, null, Te(A.keys, (C) => (c(), d("kbd", {
                    key: C,
                    class: "fe-kbd"
                  }, f(C), 1))), 128)),
                  Je(" " + f(A.label), 1)
                ])
              ], 64))), 128))
            ], 2)) : g("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), T4 = ["aria-label"], M4 = { class: "fe-opc__head" }, E4 = ["aria-label"], z4 = { class: "fe-opc__body" }, A4 = {
  key: 0,
  class: "fe-opc__section",
  "aria-live": "polite"
}, P4 = { class: "fe-opc__section-title" }, L4 = { class: "fe-opc__list" }, D4 = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, O4 = ["d"], B4 = { class: "fe-opc__mid" }, I4 = ["title"], H4 = { class: "fe-opc__sub" }, F4 = { class: "fe-opc__kind" }, N4 = { class: "fe-opc__state" }, K4 = ["aria-valuenow"], R4 = {
  key: 0,
  class: "fe-opc__spin",
  "aria-hidden": "true"
}, U4 = { class: "fe-opc__acts" }, V4 = ["onClick"], j4 = ["onClick"], Y4 = ["aria-label", "onClick"], W4 = {
  key: 1,
  class: "fe-opc__section"
}, q4 = { class: "fe-opc__section-title" }, G4 = { class: "fe-opc__list fe-opc__list--history" }, X4 = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, J4 = ["d"], Z4 = { class: "fe-opc__mid" }, Q4 = ["title"], e5 = {
  key: 0,
  class: "fe-opc__sub fe-opc__sub--err"
}, t5 = {
  key: 2,
  class: "fe-opc__empty"
}, n5 = ["aria-expanded", "aria-label"], a5 = ["stroke-dashoffset"], o5 = { class: "fe-opc__count" }, s5 = {
  key: 0,
  class: "fe-opc__pct"
}, ei = 8.5, r5 = /* @__PURE__ */ qe({
  __name: "OperationsCenter",
  props: {
    center: {},
    locale: {},
    narrow: { type: Boolean }
  },
  setup(e) {
    const t = e, { t: n, formatSize: r } = tt(() => t.locale), a = m(!1), u = m(null), v = k(() => t.center.active.value), p = k(() => t.center.history.value), h = k(() => t.center.hasError.value), b = k(() => t.center.overallPercent.value), y = k(() => t.center.runningCount.value), A = k(() => v.value.length > 0 || a.value && p.value.length > 0);
    He(A, (O) => {
      O || (a.value = !1);
    });
    const D = 2 * Math.PI * ei, C = k(() => {
      const O = b.value;
      return O === null ? D * 0.72 : D * (1 - Math.min(100, Math.max(0, O)) / 100);
    }), B = k(() => b.value === null && y.value > 0), I = k(() => y.value === 0 || b.value === null ? "" : n("opc.percent", { n: b.value })), U = k(() => n("opc.aria_badge", { n: v.value.length })), x = {
      upload: "M12 16V5M7 9.5 12 5l5 4.5M5 19h14",
      copy: "M9 9h11v11H9zM5 15V4h11",
      move: "M4 12h13M12 6l6 6-6 6",
      delete: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13",
      convert: "M20 8A8 8 0 0 0 6 6L4 8M4 16a8 8 0 0 0 14 2l2-2M20 3v5h-5M4 21v-5h5",
      archive: "M4 8V5h16v3zM5 8h14v12H5zM10 12h4"
    };
    function E(O) {
      return n(`opc.kind.${O.kind}`);
    }
    function $(O) {
      return O.name || E(O);
    }
    function M(O) {
      return O.status === "running" ? O.queued ? n("opc.queued") : O.totalBytes && O.totalBytes > 0 ? `${r(O.uploadedBytes ?? 0)} / ${r(O.totalBytes)}` : O.totalCount && O.totalCount > 0 ? `${O.doneCount ?? 0}/${O.totalCount}` : n("opc.status.running") : O.status === "done" ? n("opc.status.done") : O.status === "aborted" ? n("opc.status.aborted") : O.error || n("opc.status.error");
    }
    function z(O) {
      return n(`opc.status.${O.status === "running" ? "running" : O.status}`);
    }
    function T(O) {
      if (!a.value) return;
      const J = u.value;
      J && O.target instanceof Node && !J.contains(O.target) && (a.value = !1);
    }
    function Y(O) {
      a.value && O.key === "Escape" && (a.value = !1);
    }
    return dt(() => {
      document.addEventListener("mousedown", T), document.addEventListener("keydown", Y);
    }), it(() => {
      document.removeEventListener("mousedown", T), document.removeEventListener("keydown", Y);
    }), (O, J) => A.value ? (c(), d("div", {
      key: 0,
      ref_key: "rootEl",
      ref: u,
      class: we(["fe-opc", { "fe-opc--narrow": e.narrow, "fe-opc--open": a.value }])
    }, [
      Ge(Rn, { name: "fe-opc-pop" }, {
        default: st(() => [
          a.value ? (c(), d("section", {
            key: 0,
            class: "fe-opc__panel",
            role: "dialog",
            "aria-label": s(n)("opc.title")
          }, [
            o("header", M4, [
              o("strong", null, f(s(n)("opc.title")), 1),
              o("button", {
                type: "button",
                class: "fe-opc__x",
                "aria-label": s(n)("opc.close"),
                onClick: J[0] || (J[0] = (G) => a.value = !1)
              }, "×", 8, E4)
            ]),
            o("div", z4, [
              v.value.length > 0 ? (c(), d("div", A4, [
                o("h3", P4, f(s(n)("opc.active")), 1),
                o("ul", L4, [
                  (c(!0), d(ae, null, Te(v.value, (G) => (c(), d("li", {
                    key: G.key,
                    class: we(["fe-opc__item", `is-${G.status}`])
                  }, [
                    (c(), d("svg", D4, [
                      o("path", {
                        d: x[G.kind]
                      }, null, 8, O4)
                    ])),
                    o("div", B4, [
                      o("div", {
                        class: "fe-opc__name",
                        title: $(G)
                      }, f($(G)), 9, I4),
                      o("div", H4, [
                        o("span", F4, f(E(G)), 1),
                        J[3] || (J[3] = o("span", {
                          class: "fe-opc__dot",
                          "aria-hidden": "true"
                        }, "·", -1)),
                        o("span", N4, f(M(G)), 1)
                      ]),
                      G.status === "running" && G.percent !== null ? (c(), d("div", {
                        key: 0,
                        class: "fe-opc__bar",
                        role: "progressbar",
                        "aria-valuenow": G.percent,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, [
                        o("div", {
                          class: "fe-opc__bar-fill",
                          style: Ct({ width: G.percent + "%" })
                        }, null, 4)
                      ], 8, K4)) : g("", !0)
                    ]),
                    G.status === "running" && G.percent === null && !G.queued ? (c(), d("span", R4)) : g("", !0),
                    o("div", U4, [
                      G.status === "running" && G.cancellable ? (c(), d("button", {
                        key: 0,
                        type: "button",
                        class: "fe-opc__act",
                        onClick: (N) => e.center.cancel(G.key)
                      }, f(s(n)("opc.cancel")), 9, V4)) : g("", !0),
                      G.status === "error" && G.retryable ? (c(), d("button", {
                        key: 1,
                        type: "button",
                        class: "fe-opc__act fe-opc__act--retry",
                        onClick: (N) => e.center.retry(G.key)
                      }, f(s(n)("opc.retry")), 9, j4)) : g("", !0),
                      G.status !== "running" ? (c(), d("button", {
                        key: 2,
                        type: "button",
                        class: "fe-opc__x",
                        "aria-label": s(n)("opc.dismiss"),
                        onClick: (N) => e.center.dismiss(G.key)
                      }, "×", 8, Y4)) : g("", !0)
                    ])
                  ], 2))), 128))
                ])
              ])) : g("", !0),
              p.value.length > 0 ? (c(), d("div", W4, [
                o("h3", q4, [
                  Je(f(s(n)("opc.history")) + " ", 1),
                  o("button", {
                    type: "button",
                    class: "fe-opc__act",
                    onClick: J[1] || (J[1] = (G) => e.center.clearHistory())
                  }, f(s(n)("opc.clear")), 1)
                ]),
                o("ul", G4, [
                  (c(!0), d(ae, null, Te(p.value, (G) => (c(), d("li", {
                    key: "h-" + G.key,
                    class: we(["fe-opc__item fe-opc__item--history", `is-${G.status}`])
                  }, [
                    (c(), d("svg", X4, [
                      o("path", {
                        d: x[G.kind]
                      }, null, 8, J4)
                    ])),
                    o("div", Z4, [
                      o("div", {
                        class: "fe-opc__name",
                        title: $(G)
                      }, f($(G)), 9, Q4),
                      G.status === "error" && G.error ? (c(), d("div", e5, f(G.error), 1)) : g("", !0)
                    ]),
                    o("span", {
                      class: we(["fe-opc__chip", `is-${G.status}`])
                    }, f(z(G)), 3)
                  ], 2))), 128))
                ])
              ])) : g("", !0),
              v.value.length === 0 && p.value.length === 0 ? (c(), d("p", t5, f(s(n)("opc.empty")), 1)) : g("", !0)
            ])
          ], 8, T4)) : g("", !0)
        ]),
        _: 1
      }),
      o("button", {
        type: "button",
        class: we(["fe-opc__badge", { "is-error": h.value }]),
        "aria-expanded": a.value,
        "aria-label": U.value,
        onClick: J[2] || (J[2] = (G) => a.value = !a.value)
      }, [
        (c(), d("svg", {
          class: we(["fe-opc__ring", { "fe-opc__ring--spin": B.value }]),
          viewBox: "0 0 22 22",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          o("circle", {
            class: "fe-opc__ring-track",
            cx: "11",
            cy: "11",
            r: ei,
            fill: "none",
            "stroke-width": "2.5"
          }),
          o("circle", {
            class: "fe-opc__ring-fill",
            cx: "11",
            cy: "11",
            r: ei,
            fill: "none",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-dasharray": D,
            "stroke-dashoffset": C.value,
            transform: "rotate(-90 11 11)"
          }, null, 8, a5)
        ], 2)),
        o("span", o5, f(v.value.length), 1),
        I.value ? (c(), d("span", s5, f(I.value), 1)) : g("", !0)
      ], 10, n5)
    ], 2)) : g("", !0);
  }
}), i5 = 4e3, Tu = 50;
function l5(e, t, n) {
  const r = t.status !== "running";
  return {
    key: e,
    kind: t.kind,
    name: t.name,
    percent: t.percent,
    status: t.status,
    error: t.error ?? null,
    queued: t.queued ?? !1,
    doneCount: t.doneCount ?? null,
    totalCount: t.totalCount ?? null,
    uploadedBytes: t.uploadedBytes ?? null,
    totalBytes: t.totalBytes ?? null,
    cancellable: t.cancellable ?? !1,
    retryable: t.retryable ?? !1,
    startedAt: (n == null ? void 0 : n.startedAt) ?? Date.now(),
    settledAt: (n == null ? void 0 : n.settledAt) ?? (r ? Date.now() : null)
  };
}
function c5() {
  const e = m([]), t = m([]), n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Map();
  function u(x) {
    const E = a.get(x);
    E !== void 0 && (clearTimeout(E), a.delete(x));
  }
  function v(x, E = {}) {
    u(x);
    const $ = e.value.findIndex((z) => z.key === x);
    if ($ === -1) return;
    const [M] = e.value.splice($, 1);
    e.value = [...e.value], r.add(x), E.toHistory !== !1 && (t.value = [{ ...M, settledAt: M.settledAt ?? Date.now() }, ...t.value].slice(
      0,
      Tu
    ));
  }
  function p(x) {
    a.has(x) || a.set(
      x,
      setTimeout(() => {
        var $;
        a.delete(x);
        const E = n.get(x);
        v(x), ($ = E == null ? void 0 : E.dismiss) == null || $.call(E);
      }, i5)
    );
  }
  function h(x, E) {
    const $ = `${x}:`, M = /* @__PURE__ */ new Set();
    let z = [...e.value], T = !1;
    for (const Y of E) {
      const O = `${x}:${Y.input.id}`;
      if (M.add(O), Y.actions && n.set(O, Y.actions), r.has(O)) continue;
      const J = z.findIndex((N) => N.key === O), G = l5(O, Y.input, J === -1 ? void 0 : z[J]);
      J === -1 ? (z = [G, ...z], T = !0) : JSON.stringify(z[J]) !== JSON.stringify(G) && (z[J] = G, T = !0), (G.status === "done" || G.status === "aborted") && p(O);
    }
    for (const Y of [...z])
      !Y.key.startsWith($) || M.has(Y.key) || Y.status !== "error" && (u(Y.key), z = z.filter((O) => O.key !== Y.key), T = !0, Y.status !== "running" && (r.add(Y.key), t.value = [{ ...Y, settledAt: Y.settledAt ?? Date.now() }, ...t.value].slice(
        0,
        Tu
      )));
    for (const Y of [...r])
      Y.startsWith($) && !M.has(Y) && r.delete(Y);
    for (const Y of [...n.keys()])
      Y.startsWith($) && !M.has(Y) && !e.value.some((O) => O.key === Y) && (z.some((O) => O.key === Y) || n.delete(Y));
    T && (e.value = z);
  }
  function b(x) {
    var E, $;
    ($ = (E = n.get(x)) == null ? void 0 : E.cancel) == null || $.call(E);
  }
  function y(x) {
    var $, M;
    const E = n.get(x);
    v(x), ($ = E == null ? void 0 : E.dismiss) == null || $.call(E), (M = E == null ? void 0 : E.retry) == null || M.call(E);
  }
  function A(x) {
    var $;
    const E = n.get(x);
    v(x), ($ = E == null ? void 0 : E.dismiss) == null || $.call(E);
  }
  function D() {
    t.value = [];
  }
  const C = k(
    () => e.value.filter((x) => x.status === "running").length
  ), B = k(() => e.value.filter((x) => x.status === "error").length), I = k(() => B.value > 0), U = k(() => {
    const x = e.value.filter((M) => M.status === "running");
    let E = 0, $ = 0;
    for (const M of x) {
      let z = null;
      M.totalBytes && M.totalBytes > 0 ? z = Math.min(1, (M.uploadedBytes ?? 0) / M.totalBytes) : M.totalCount && M.totalCount > 0 ? z = Math.min(1, (M.doneCount ?? 0) / M.totalCount) : M.percent !== null && (z = Math.min(1, M.percent / 100)), z !== null && (E += z, $ += 1);
    }
    return $ === 0 ? null : Math.round(E / $ * 100);
  });
  return lv() && cv(() => {
    for (const x of a.values()) clearTimeout(x);
    a.clear();
  }), {
    active: e,
    history: t,
    runningCount: C,
    errorCount: B,
    hasError: I,
    overallPercent: U,
    sync: h,
    cancel: b,
    retry: y,
    dismiss: A,
    clearHistory: D
  };
}
const u5 = ["data-prefers-dark", "aria-label"], d5 = {
  key: 1,
  class: "fe-tour__dim",
  "aria-hidden": "true"
}, f5 = {
  class: "fe-tour__progress",
  "aria-hidden": "true"
}, p5 = { class: "fe-tour__title" }, v5 = { class: "fe-tour__desc" }, h5 = {
  class: "fe-tour__dots",
  "aria-hidden": "true"
}, m5 = { class: "fe-tour__actions" }, ta = 6, Nn = 12, y5 = /* @__PURE__ */ qe({
  __name: "OnboardingTour",
  props: {
    open: { type: Boolean },
    locale: {},
    root: {},
    theme: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = k(() => ({
      palette: Na("palette"),
      help: Na("help")
    })), v = [
      {
        // The navigation panel: the standard views, then STORAGES, then
        // CONNECTIONS. At 390px it is a drawer that starts closed, so there is
        // nothing to spotlight and the button that opens it is the target.
        id: "nav",
        titleKey: "tour.step.nav.title",
        descKey: (P) => (P == null ? void 0 : P.dataset.testid) === "sidenav" ? "tour.step.nav.desc" : "tour.step.nav.desc_closed",
        target: (P) => P.querySelector('[data-testid="sidenav"]') || P.querySelector('[data-testid="toolbar-nav"]')
      },
      {
        // "+ New" — the menu that replaced the Upload / New folder pair. The
        // narrow shell has no panel on screen and draws the upload FAB instead,
        // which does ONE of the three things the menu offers, so it gets a
        // sentence that promises only that one.
        id: "new",
        titleKey: "tour.step.new.title",
        descKey: (P) => (P == null ? void 0 : P.dataset.testid) === "sidenav-new" ? "tour.step.new.desc" : "tour.step.new.desc_fab",
        target: (P) => P.querySelector('[data-testid="sidenav-new"]') || P.querySelector(".fe-fab")
      },
      {
        // ⚠ The FIELD, not `.fe-search__input`. The wide header's input carries
        // both class names and the narrow one carries only `fe-drivesearch__input`
        // — so the old selector resolved at 1440px and matched nothing at 390px,
        // where the field is the widest thing on the row. The testid is on the
        // wrapper in both layouts, and spotlighting the wrapper also takes in the
        // advanced-search and palette buttons the copy now names.
        id: "search",
        titleKey: "tour.step.search.title",
        descKey: "tour.step.search.desc",
        target: (P) => P.querySelector('[data-testid="drive-search"]')
      },
      {
        // The breadcrumb — this was the old first step's target while its title
        // said "Storages & folders", which is the panel. Now it has its own step
        // and its own title. Absent on Home, which has no address; the step drops
        // itself there rather than pointing at the heading that takes its place.
        id: "crumb",
        titleKey: "tour.step.crumb.title",
        descKey: "tour.step.crumb.desc",
        target: (P) => P.querySelector(".fe-breadcrumb")
      },
      {
        // The filter row. Unconditional in the shell now, but only drawn where
        // there is a listing to filter — not at the multi-storage virtual root,
        // which is where a first run usually starts, so this step is often the
        // one that drops itself.
        id: "filters",
        titleKey: "tour.step.filters.title",
        descKey: "tour.step.filters.desc",
        target: (P) => P.querySelector('[data-testid="filterbar"]')
      },
      {
        id: "view",
        titleKey: "tour.step.view.title",
        descKey: "tour.step.view.desc",
        // Still `.fe-toolbar__view`: ViewSwitcher kept its class when it moved
        // from the header to the breadcrumb row.
        target: (P) => P.querySelector(".fe-toolbar__view")
      },
      {
        // Sharing used to spotlight `.fe__body` — the whole listing, which is to
        // say nothing in particular — while talking about a context menu. The
        // details panel is where a share link is actually minted, so the step
        // points at the control that opens it and names the context menu too.
        id: "details",
        titleKey: "tour.step.details.title",
        descKey: "tour.step.details.desc",
        target: (P) => P.querySelector('[data-testid="subhead-inspector"]')
      },
      {
        id: "help",
        titleKey: "tour.step.help.title",
        descKey: "tour.step.help.desc",
        target: () => null
      }
    ], p = m([]), h = m(0), b = k(() => p.value[h.value] ?? null), y = k(() => p.value.length);
    function A() {
      const P = n.root;
      p.value = v.filter((le) => {
        if (le.id === "help") return !0;
        if (!P) return !1;
        const ve = le.target(P);
        if (!ve) return !1;
        const he = ve.getBoundingClientRect();
        return he.width > 0 && he.height > 0;
      });
    }
    const D = m(null), C = m({}), B = m(null), I = m(null), U = k(() => {
      const P = b.value;
      if (!P) return "";
      const le = typeof P.descKey == "function" ? P.descKey(I.value) : P.descKey;
      return a(le, u.value);
    });
    async function x() {
      var Ne;
      const P = b.value, le = n.root;
      if (!P) return;
      const ve = le ? P.target(le) : null;
      if (I.value = ve, !ve) {
        D.value = null, C.value = {};
        return;
      }
      const he = ve.getBoundingClientRect();
      if (he.width <= 0 && he.height <= 0) {
        D.value = null, C.value = {};
        return;
      }
      D.value = {
        top: he.top - ta,
        left: he.left - ta,
        width: he.width + ta * 2,
        height: he.height + ta * 2
      }, await gt();
      const oe = window.innerWidth, ue = window.innerHeight, Q = Math.min(340, oe - 24), pe = ((Ne = B.value) == null ? void 0 : Ne.offsetHeight) ?? 160, re = he.top - ta, S = he.bottom + ta, w = he.left - ta, j = he.right + ta, K = (be) => Math.min(Math.max(12, be), Math.max(12, oe - Q - 12)), Z = (be) => Math.min(Math.max(12, be), Math.max(12, ue - pe - 12)), W = K(he.left + he.width / 2 - Q / 2), $e = Z(he.top + he.height / 2 - pe / 2);
      let Se, ze;
      S + Nn + pe <= ue - 12 ? (Se = S + Nn, ze = W) : re - Nn - pe >= 12 ? (Se = re - Nn - pe, ze = W) : j + Nn + Q <= oe - 12 ? (ze = j + Nn, Se = $e) : w - Nn - Q >= 12 ? (ze = w - Nn - Q, Se = $e) : (Se = Z(S + Nn), ze = W), C.value = {
        top: `${Math.round(Se)}px`,
        left: `${Math.round(ze)}px`,
        width: `${Q}px`
      };
    }
    let E = 0;
    function $() {
      n.open && (E && cancelAnimationFrame(E), E = requestAnimationFrame(() => {
        E = requestAnimationFrame(() => {
          E = 0, gt().then(x);
        });
      }));
    }
    function M() {
      if (h.value >= y.value - 1) {
        r("close");
        return;
      }
      h.value += 1;
    }
    function z() {
      h.value > 0 && (h.value -= 1);
    }
    function T() {
      r("close");
    }
    function Y(P) {
      n.open && (P.key === "Escape" ? (P.stopPropagation(), T()) : P.key === "ArrowRight" || P.key === "Enter" ? (P.preventDefault(), M()) : P.key === "ArrowLeft" && (P.preventDefault(), z()));
    }
    He(
      () => n.open,
      async (P) => {
        var le;
        P && (h.value = 0, A(), await gt(), await x(), (le = B.value) == null || le.focus());
      }
    ), He(h, async () => {
      var P;
      await x(), (P = B.value) == null || P.focus();
    }), dt(() => {
      window.addEventListener("resize", $), window.addEventListener("scroll", $, !0);
    }), it(() => {
      window.removeEventListener("resize", $), window.removeEventListener("scroll", $, !0), E && cancelAnimationFrame(E);
    });
    const O = m(!1);
    let J;
    function G(P) {
      O.value = !!(P && "matches" in P && P.matches);
    }
    dt(() => {
      var P;
      typeof window > "u" || (J = window.matchMedia("(prefers-color-scheme: dark)"), G(J), (P = J.addEventListener) == null || P.call(J, "change", G));
    }), it(() => {
      var P;
      (P = J == null ? void 0 : J.removeEventListener) == null || P.call(J, "change", G);
    });
    const N = k(() => `fe-ctx-backdrop--theme-${n.theme || "auto"}`);
    return (P, le) => (c(), et(ja, { to: "body" }, [
      Ge(Rn, { name: "fe-tour" }, {
        default: st(() => [
          e.open && b.value ? (c(), d("div", {
            key: 0,
            class: we(["fe-tour", N.value]),
            "data-prefers-dark": O.value ? "1" : "0",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": s(a)("tour.aria"),
            onKeydown: Y
          }, [
            D.value ? (c(), d("div", {
              key: 0,
              class: "fe-tour__spot",
              style: Ct({
                top: D.value.top + "px",
                left: D.value.left + "px",
                width: D.value.width + "px",
                height: D.value.height + "px"
              }),
              "aria-hidden": "true"
            }, null, 4)) : (c(), d("div", d5)),
            o("div", {
              ref_key: "cardEl",
              ref: B,
              class: we(["fe-tour__card", { "fe-tour__card--center": !D.value }]),
              style: Ct(D.value ? C.value : {}),
              tabindex: "-1"
            }, [
              o("p", f5, f(s(a)("tour.progress", { n: h.value + 1, m: y.value })), 1),
              o("h3", p5, f(s(a)(b.value.titleKey)), 1),
              o("p", v5, f(U.value), 1),
              o("div", h5, [
                (c(!0), d(ae, null, Te(p.value, (ve, he) => (c(), d("span", {
                  key: ve.id,
                  class: we(["fe-tour__dot", { "is-active": he === h.value }])
                }, null, 2))), 128))
              ]),
              o("div", m5, [
                o("button", {
                  type: "button",
                  class: "fe-btn fe-tour__skip",
                  onClick: T
                }, f(s(a)("tour.skip")), 1),
                le[0] || (le[0] = o("span", { class: "fe-tour__actions-spacer" }, null, -1)),
                h.value > 0 ? (c(), d("button", {
                  key: 0,
                  type: "button",
                  class: "fe-btn",
                  onClick: z
                }, f(s(a)("tour.back")), 1)) : g("", !0),
                o("button", {
                  type: "button",
                  class: "fe-btn fe-btn--primary",
                  onClick: M
                }, f(h.value >= y.value - 1 ? s(a)("tour.done") : s(a)("tour.next")), 1)
              ])
            ], 6)
          ], 42, u5)) : g("", !0)
        ]),
        _: 1
      })
    ]));
  }
}), b5 = ["aria-label"], g5 = {
  key: 0,
  class: "fe-tabs__scroll"
}, k5 = ["aria-selected", "title", "onClick", "onKeydown", "onAuxclick", "onDragstart", "onDragover", "onDragleave", "onDrop"], _5 = {
  key: 0,
  class: "fe-tabs__splitdot",
  "aria-hidden": "true"
}, w5 = { class: "fe-tabs__label" }, $5 = ["aria-label", "title", "onClick"], x5 = ["aria-label", "title"], S5 = ["aria-label", "title", "aria-pressed"], C5 = ["aria-pressed", "title", "aria-label"], T5 = /* @__PURE__ */ qe({
  __name: "TabBar",
  props: {
    tabs: {},
    activeId: {},
    locale: {},
    splitEnabled: { type: Boolean },
    splitActive: { type: Boolean },
    inspectorEnabled: { type: Boolean },
    inspectorOpen: { type: Boolean },
    hideTabs: { type: Boolean }
  },
  emits: ["select", "close", "new", "reorder", "toggle-split", "toggle-inspector"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = m(null), v = m(null);
    function p(B, I) {
      var U;
      u.value = B, I.dataTransfer && (I.dataTransfer.effectAllowed = "move", I.dataTransfer.setData("text/plain", ((U = n.tabs[B]) == null ? void 0 : U.id) ?? ""));
    }
    function h(B, I) {
      u.value !== null && (I.preventDefault(), I.stopPropagation(), I.dataTransfer && (I.dataTransfer.dropEffect = "move"), v.value = B);
    }
    function b(B) {
      v.value === B && (v.value = null);
    }
    function y(B, I) {
      u.value !== null && (I.preventDefault(), I.stopPropagation(), u.value !== B && r("reorder", u.value, B), u.value = null, v.value = null);
    }
    function A() {
      u.value = null, v.value = null;
    }
    function D(B) {
      B.button === 1 && B.preventDefault();
    }
    function C(B, I) {
      I.button === 1 && (I.preventDefault(), I.stopPropagation(), !(n.tabs.length <= 1) && r("close", B));
    }
    return (B, I) => (c(), d("div", {
      class: "fe-tabs",
      role: "tablist",
      "aria-label": s(a)("tabs.strip")
    }, [
      e.hideTabs ? g("", !0) : (c(), d("div", g5, [
        (c(!0), d(ae, null, Te(e.tabs, (U, x) => (c(), d("div", {
          key: U.id,
          class: we(["fe-tabs__tab", {
            "is-active": U.id === e.activeId,
            "is-dragover": v.value === x && u.value !== null && u.value !== x
          }]),
          role: "tab",
          "aria-selected": U.id === e.activeId ? "true" : "false",
          tabindex: "0",
          draggable: "true",
          title: U.label,
          onClick: (E) => r("select", U.id),
          onKeydown: Ut(Re((E) => r("select", U.id), ["prevent"]), ["enter"]),
          onMousedown: I[0] || (I[0] = (E) => D(E)),
          onAuxclick: (E) => C(U.id, E),
          onDragstart: (E) => p(x, E),
          onDragover: (E) => h(x, E),
          onDragleave: (E) => b(x),
          onDrop: (E) => y(x, E),
          onDragend: A
        }, [
          U.split ? (c(), d("span", _5)) : g("", !0),
          o("span", w5, f(U.label), 1),
          e.tabs.length > 1 ? (c(), d("button", {
            key: 1,
            type: "button",
            class: "fe-tabs__close",
            "aria-label": s(a)("tabs.close"),
            title: s(a)("tabs.close"),
            onClick: Re((E) => r("close", U.id), ["stop"])
          }, "×", 8, $5)) : g("", !0)
        ], 42, k5))), 128))
      ])),
      e.hideTabs ? g("", !0) : (c(), d("button", {
        key: 1,
        type: "button",
        class: "fe-tabs__new",
        "aria-label": s(a)("tabs.new"),
        title: s(a)("tabs.new"),
        onClick: I[1] || (I[1] = (U) => r("new"))
      }, "+", 8, x5)),
      e.splitEnabled !== !1 ? (c(), d("button", {
        key: 2,
        type: "button",
        class: we(["fe-tabs__split", { "is-active": e.splitActive }]),
        "aria-label": e.splitActive ? s(a)("tabs.split_off") : s(a)("tabs.split"),
        title: e.splitActive ? s(a)("tabs.split_off") : s(a)("tabs.split"),
        "aria-pressed": e.splitActive ? "true" : "false",
        "data-testid": "tabs-split",
        onClick: I[2] || (I[2] = (U) => r("toggle-split"))
      }, [...I[4] || (I[4] = [
        o("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          o("rect", {
            x: "3",
            y: "4",
            width: "18",
            height: "16",
            rx: "2"
          }),
          o("path", { d: "M12 4v16" })
        ], -1)
      ])], 10, S5)) : g("", !0),
      e.inspectorEnabled ? (c(), d("button", {
        key: 3,
        type: "button",
        class: we(["fe-tabs__inspector", { "is-active": e.inspectorOpen }]),
        "aria-pressed": e.inspectorOpen ? "true" : "false",
        title: s(a)("toolbar.inspector"),
        "aria-label": s(a)("toolbar.inspector"),
        "data-testid": "tabs-inspector",
        onClick: I[3] || (I[3] = (U) => r("toggle-inspector"))
      }, [...I[5] || (I[5] = [
        o("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          o("circle", {
            cx: "12",
            cy: "12",
            r: "9"
          }),
          o("path", { d: "M12 11v5" }),
          o("circle", {
            cx: "12",
            cy: "7.6",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 10, C5)) : g("", !0)
    ], 8, b5));
  }
}), M5 = {
  class: "fe-breadcrumb",
  "aria-label": "Breadcrumb"
}, E5 = ["aria-current", "title", "aria-label"], z5 = ["innerHTML"], A5 = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, P5 = ["aria-current", "onClick", "onContextmenu", "onDrop"], L5 = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, D5 = ["aria-expanded", "aria-label", "title"], O5 = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, B5 = ["onClick"], I5 = ["aria-current", "onClick", "onContextmenu", "onDrop"], H5 = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, F5 = ["aria-expanded", "title", "aria-label"], N5 = ["innerHTML"], K5 = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, R5 = ["onClick"], U5 = {
  key: 0,
  class: "fe-breadcrumb__menu-empty"
}, V5 = ["title", "aria-label"], j5 = ["innerHTML"], Y5 = ["placeholder", "onKeydown"], W5 = 4, q5 = /* @__PURE__ */ qe({
  __name: "Breadcrumb",
  props: {
    dirname: {},
    adapter: {},
    rootLabel: {},
    locale: {},
    multiStorageRoot: { type: Boolean },
    rootPath: {},
    subfolders: {}
  },
  emits: ["navigate", "copy-path", "crumb-context", "crumb-drop"],
  setup(e, { emit: t }) {
    const n = e, r = k(() => {
      if (!n.rootPath) return "";
      const w = n.rootPath, j = w.indexOf("://");
      return (j >= 0 ? w.slice(j + 3) : w).replace(/^\/+|\/+$/g, "");
    }), a = k(() => {
      const w = r.value;
      if (!w) return n.rootLabel || n.adapter;
      const j = w.split("/");
      return j[j.length - 1] || n.rootLabel || n.adapter;
    }), { t: u } = tt(() => n.locale), v = t, p = k(() => {
      const w = n.adapter ? `${n.adapter}://` : "", j = w && n.dirname.startsWith(w) ? n.dirname.slice(w.length) : n.dirname, K = j.split("/").filter(Boolean), Z = [];
      if (n.rootPath) {
        const $e = r.value, Se = j.replace(/^\/+|\/+$/g, ""), ze = $e && (Se === $e || Se.startsWith($e + "/")) ? Se.slice($e.length).replace(/^\/+/, "") : "";
        Z.push({ label: a.value, adapterPath: n.rootPath });
        let Ne = $e;
        for (const be of ze.split("/").filter(Boolean))
          Ne = Ne ? `${Ne}/${be}` : be, Z.push({ label: Fs(be, u) || be, adapterPath: `${w}${Ne}` });
        return Z;
      }
      n.multiStorageRoot ? (Z.push({ label: "/", adapterPath: "" }), n.adapter && Z.push({ label: n.rootLabel || n.adapter, adapterPath: w })) : (n.adapter || n.rootLabel) && Z.push({
        label: n.rootLabel || n.adapter,
        adapterPath: w
      });
      let W = "";
      for (const $e of K) {
        W = W ? `${W}/${$e}` : $e;
        const Se = Fs($e, u) || $e;
        Z.push({ label: Se, adapterPath: `${w}${W}` });
      }
      return Z;
    }), h = k(() => {
      const w = p.value[0];
      return w && n.multiStorageRoot && w.adapterPath === "" ? w : null;
    }), b = k(
      () => h.value ? p.value.slice(1) : p.value
    ), y = k(() => !!h.value && b.value.length === 0), A = k(() => b.value.length > W5), D = k(
      () => A.value ? b.value.slice(0, 1) : b.value
    ), C = k(
      () => A.value ? b.value.slice(1, -2) : []
    ), B = k(
      () => A.value ? b.value.slice(-2) : []
    ), I = m(!1), U = m(null), x = m(!1), E = m(null), $ = k(() => I.value || x.value);
    function M() {
      I.value = !1, x.value = !1;
    }
    function z(w) {
      M(), v("navigate", w.adapterPath);
    }
    function T() {
      I.value = !1, x.value = !x.value;
    }
    function Y(w) {
      var K, Z;
      const j = w.target;
      if (!(j instanceof Node)) {
        M();
        return;
      }
      (K = U.value) != null && K.contains(j) || (Z = E.value) != null && Z.contains(j) || M();
    }
    function O(w) {
      w.key === "Escape" && (w.stopPropagation(), M());
    }
    He($, (w) => {
      w ? (document.addEventListener("click", Y, !0), document.addEventListener("keydown", O, !0)) : (document.removeEventListener("click", Y, !0), document.removeEventListener("keydown", O, !0));
    }), He(p, M), it(() => {
      document.removeEventListener("click", Y, !0), document.removeEventListener("keydown", O, !0);
    });
    function J(w) {
      v("navigate", w.adapterPath);
    }
    function G() {
      h.value && J(h.value);
    }
    function N(w) {
      h.value && le(w, h.value);
    }
    function P(w) {
      h.value && he(w, h.value);
    }
    function le(w, j) {
      w.preventDefault(), w.stopPropagation(), v("crumb-context", {
        x: w.clientX,
        y: w.clientY,
        adapterPath: j.adapterPath,
        label: j.label
      });
    }
    function ve(w) {
      vn(w) && (w.preventDefault(), w.stopPropagation(), w.dataTransfer && (w.dataTransfer.dropEffect = "move"));
    }
    function he(w, j) {
      vn(w) && (w.preventDefault(), w.stopPropagation(), v("crumb-drop", j.adapterPath, w));
    }
    const oe = m(!1), ue = m(""), Q = m(null);
    function pe() {
      const w = `${n.adapter}://`, j = n.dirname.startsWith(w) ? n.dirname.slice(w.length) : n.dirname;
      if (n.rootPath) {
        const K = r.value, Z = j.replace(/^\/+|\/+$/g, ""), W = K && (Z === K || Z.startsWith(K + "/")) ? Z.slice(K.length).replace(/^\/+/, "") : "";
        ue.value = W ? `/${W}` : "/", oe.value = !0, gt(() => {
          var $e, Se;
          ($e = Q.value) == null || $e.focus(), (Se = Q.value) == null || Se.select();
        });
        return;
      }
      if (n.multiStorageRoot)
        if (!n.adapter)
          ue.value = "/";
        else {
          const K = j.replace(/^\/+|\/+$/g, "");
          ue.value = K ? `/${n.adapter}/${K}` : `/${n.adapter}`;
        }
      else
        ue.value = j;
      oe.value = !0, gt(() => {
        var K, Z;
        (K = Q.value) == null || K.focus(), (Z = Q.value) == null || Z.select();
      });
    }
    function re() {
      const w = ue.value.trim();
      if (oe.value = !1, n.rootPath) {
        const K = w.replace(/^\/+|\/+$/g, ""), Z = r.value, W = K ? Z ? `${Z}/${K}` : K : Z;
        v("navigate", W ? `${n.adapter}://${W}` : `${n.adapter}://`);
        return;
      }
      if (n.multiStorageRoot) {
        const K = w.replace(/^\/+|\/+$/g, "");
        if (!K) {
          v("navigate", "");
          return;
        }
        const Z = K.indexOf("/"), W = Z === -1 ? K : K.slice(0, Z), $e = Z === -1 ? "" : K.slice(Z + 1);
        v("navigate", $e ? `${W}://${$e}` : `${W}://`);
        return;
      }
      const j = w.replace(/^\/+|\/+$/g, "");
      j && v("navigate", `${n.adapter}://${j}`);
    }
    function S() {
      oe.value = !1;
    }
    return (w, j) => (c(), d("nav", M5, [
      oe.value ? Ve((c(), d("input", {
        key: 1,
        ref_key: "pathInput",
        ref: Q,
        "onUpdate:modelValue": j[1] || (j[1] = (K) => ue.value = K),
        type: "text",
        class: "fe-breadcrumb__input",
        placeholder: s(u)("breadcrumb.path_placeholder"),
        spellcheck: "false",
        autocomplete: "off",
        onKeydown: [
          Ut(Re(re, ["prevent"]), ["enter"]),
          Ut(Re(S, ["prevent"]), ["escape"])
        ],
        onBlur: S
      }, null, 40, Y5)), [
        [rt, ue.value]
      ]) : (c(), d(ae, { key: 0 }, [
        h.value ? (c(), d("button", {
          key: 0,
          type: "button",
          class: we(["fe-breadcrumb__crumb fe-breadcrumb__home", { "is-last": y.value }]),
          "aria-current": y.value ? "page" : void 0,
          title: s(u)("breadcrumb.root"),
          "aria-label": s(u)("breadcrumb.root"),
          "data-testid": "breadcrumb-home",
          onClick: G,
          onContextmenu: N,
          onDragover: ve,
          onDrop: P
        }, [
          o("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: s(Ue)("home")
          }, null, 8, z5),
          y.value ? g("", !0) : (c(), d("span", A5, "›"))
        ], 42, E5)) : g("", !0),
        (c(!0), d(ae, null, Te(D.value, (K, Z) => (c(), d("button", {
          key: K.adapterPath,
          class: we(["fe-breadcrumb__crumb", { "is-last": !A.value && Z === D.value.length - 1 }]),
          type: "button",
          "aria-current": !A.value && Z === D.value.length - 1 ? "page" : void 0,
          onClick: (W) => J(K),
          onContextmenu: (W) => le(W, K),
          onDragover: ve,
          onDrop: (W) => he(W, K)
        }, [
          o("span", null, f(K.label), 1),
          A.value || Z < D.value.length - 1 ? (c(), d("span", L5, "›")) : g("", !0)
        ], 42, P5))), 128)),
        C.value.length ? (c(), d("span", {
          key: 1,
          ref_key: "moreWrapEl",
          ref: U,
          class: "fe-breadcrumb__more-wrap"
        }, [
          o("button", {
            type: "button",
            class: "fe-breadcrumb__more",
            "aria-haspopup": "menu",
            "aria-expanded": I.value,
            "aria-label": s(u)("breadcrumb.more"),
            title: s(u)("breadcrumb.more"),
            onClick: j[0] || (j[0] = (K) => I.value = !I.value)
          }, "…", 8, D5),
          j[2] || (j[2] = o("span", {
            class: "fe-breadcrumb__sep",
            "aria-hidden": "true"
          }, "›", -1)),
          I.value ? (c(), d("div", O5, [
            (c(!0), d(ae, null, Te(C.value, (K) => (c(), d("button", {
              key: K.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (Z) => z(K)
            }, f(K.label), 9, B5))), 128))
          ])) : g("", !0)
        ], 512)) : g("", !0),
        (c(!0), d(ae, null, Te(B.value, (K, Z) => (c(), d("button", {
          key: K.adapterPath,
          class: we(["fe-breadcrumb__crumb", { "is-last": Z === B.value.length - 1 }]),
          type: "button",
          "aria-current": Z === B.value.length - 1 ? "page" : void 0,
          onClick: (W) => J(K),
          onContextmenu: (W) => le(W, K),
          onDragover: ve,
          onDrop: (W) => he(W, K)
        }, [
          o("span", null, f(K.label), 1),
          Z < B.value.length - 1 ? (c(), d("span", H5, "›")) : g("", !0)
        ], 42, I5))), 128)),
        e.subfolders ? (c(), d("span", {
          key: 2,
          ref_key: "subWrapEl",
          ref: E,
          class: "fe-breadcrumb__sub-wrap"
        }, [
          o("button", {
            type: "button",
            class: "fe-breadcrumb__sub",
            "aria-haspopup": "menu",
            "aria-expanded": x.value,
            title: s(u)("breadcrumb.subfolders"),
            "aria-label": s(u)("breadcrumb.subfolders"),
            "data-testid": "breadcrumb-subfolders",
            onClick: T
          }, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("subfolders")
            }, null, 8, N5)
          ], 8, F5),
          x.value ? (c(), d("div", K5, [
            (c(!0), d(ae, null, Te(e.subfolders, (K) => (c(), d("button", {
              key: K.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (Z) => z(K)
            }, f(K.label), 9, R5))), 128)),
            e.subfolders.length ? g("", !0) : (c(), d("p", U5, f(s(u)("breadcrumb.subfolders.empty")), 1))
          ])) : g("", !0)
        ], 512)) : g("", !0),
        o("button", {
          type: "button",
          class: "fe-breadcrumb__edit",
          title: s(u)("breadcrumb.go_to_path"),
          "aria-label": s(u)("breadcrumb.go_to_path"),
          "data-testid": "breadcrumb-edit-path",
          onClick: pe
        }, [
          o("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: s(Ue)("edit-path")
          }, null, 8, j5)
        ], 8, V5)
      ], 64))
    ]));
  }
}), G5 = ["data-mode"], X5 = ["aria-label"], J5 = ["aria-expanded", "data-testid", "onClick"], Z5 = { class: "fe-filterbar__label" }, Q5 = { class: "fe-filterbar__find" }, eM = ["placeholder", "aria-label", "value", "onKeydown"], tM = {
  key: 2,
  class: "fe-filterbar__count",
  role: "status",
  "data-testid": "filter-count"
}, nM = {
  key: 3,
  class: "fe-filterbar__sort"
}, aM = ["disabled", "title"], oM = { class: "fe-sr-only" }, sM = {
  key: 0,
  class: "fe-ficon fe-filterbar__sortarrow",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, rM = ["aria-label", "title", "disabled", "aria-expanded"], iM = ["aria-label", "title", "aria-expanded"], lM = ["role", "aria-label"], cM = {
  key: 0,
  class: "fe-filterpop__rule",
  "aria-hidden": "true"
}, uM = ["disabled", "aria-disabled", "data-testid", "onClick"], dM = ["data-active", "data-testid", "onClick"], fM = ["aria-selected", "data-checked", "data-active", "data-testid", "onClick"], pM = {
  class: "fe-filterpop__tick",
  "aria-hidden": "true"
}, vM = /* @__PURE__ */ qe({
  __name: "FilterBar",
  props: {
    value: {},
    locale: {},
    theme: {},
    shown: {},
    total: {},
    files: {},
    canPaste: { type: Boolean },
    canWrite: { type: Boolean },
    order: {},
    mode: {},
    findLabel: {}
  },
  emits: ["update:value", "new-folder", "upload", "paste", "select-all"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = k(() => (n.mode ?? "full") === "full"), v = k(() => n.findLabel || a("filter.find")), p = ["type", "people", "modified", "size"], h = [
      "any",
      "folder",
      "document",
      "spreadsheet",
      "presentation",
      "pdf",
      "image",
      "video",
      "audio",
      "archive",
      "code"
    ], b = ["any", "today", "7d", "30d", "year"], y = ["any", "lt1", "1to10", "10to100", "gt100"], A = k(() => $b(n.files ?? []));
    function D(ie) {
      return ie === "people" ? A.value.map((ce) => ce.value) : ie === "type" ? h : ie === "modified" ? b : y;
    }
    function C(ie, ce) {
      var L;
      return ie === "people" && ce.startsWith("u:") ? ((L = A.value.find((se) => se.value === ce)) == null ? void 0 : L.name) || ce.slice(2) : a(`filter.${ie}.${ce}`);
    }
    function B(ie) {
      const ce = ie === "people" ? n.value.people ?? "any" : n.value[ie];
      return ce === "any" ? a(`filter.${ie}`) : C(ie, ce);
    }
    function I(ie) {
      return ie === "people" ? n.value.people ?? "any" : n.value[ie];
    }
    const U = k(() => fb(n.value)), x = Ao(), E = k(() => x.key.value), $ = k(() => x.dir.value === "asc"), M = k(() => n.order === "relevance"), z = k(() => M.value ? a("sort.relevance") : a(`col.${E.value}`)), T = k(
      () => M.value ? a("sort.relevance_why") : a($.value ? "sort.asc" : "sort.desc")
    );
    He(() => n.locale, (ie) => Hi(ie), { immediate: !0 });
    function Y(ie) {
      x.setSort(ie), K(!0);
    }
    function O() {
      M.value || x.toggleSortDir();
    }
    function J() {
      M.value || j("sort");
    }
    const G = k(() => [
      { key: "new-folder", label: a("toolbar.new_folder"), disabled: n.canWrite === !1 },
      { key: "upload", label: a("toolbar.upload"), disabled: n.canWrite === !1 },
      { key: "paste", label: a("ctx.paste"), disabled: !n.canPaste || n.canWrite === !1 },
      { key: "sep", label: "", divider: !0, disabled: !0 },
      { key: "select-all", label: a("shortcuts.select_all"), disabled: !1 }
    ]);
    function N(ie) {
      K(!0), ie === "new-folder" ? r("new-folder") : ie === "upload" ? r("upload") : ie === "paste" ? r("paste") : ie === "select-all" && r("select-all");
    }
    const P = m(null), le = m({ x: 0, y: 0 }), ve = m(null), he = m({});
    function oe(ie, ce) {
      he.value[ie] = ce ?? null;
    }
    const ue = k(
      () => P.value && P.value !== "sort" && P.value !== "actions" ? P.value : null
    ), Q = k(() => ue.value ? D(ue.value) : []), pe = k(
      () => ue.value ? a(`filter.${ue.value}`) : P.value === "actions" ? a("filter.actions") : a("sort.by")
    );
    function re(ie) {
      return !!ue.value && I(ue.value) === ie;
    }
    function S(ie) {
      return ue.value ? C(ue.value, ie) : ie;
    }
    function w(ie) {
      ue.value && Z(ue.value, ie);
    }
    async function j(ie) {
      var se, Ce, We;
      if (P.value === ie) {
        K();
        return;
      }
      const ce = (se = he.value[ie]) == null ? void 0 : se.getBoundingClientRect();
      le.value = { x: ce ? ce.left : 8, y: ce ? ce.bottom + 6 : 8 }, P.value = ie, await gt();
      const L = ve.value;
      if (L) {
        const Ie = L.getBoundingClientRect();
        if (Ie.right > window.innerWidth - 8 && (le.value = { ...le.value, x: Math.max(8, window.innerWidth - 8 - Ie.width) }), Ie.bottom > window.innerHeight - 8) {
          const Ze = (Ce = he.value[ie]) == null ? void 0 : Ce.getBoundingClientRect();
          le.value = { ...le.value, y: Math.max(8, (Ze ? Ze.top : 0) - Ie.height - 6) };
        }
        (We = L.querySelector('[data-active="true"]')) == null || We.focus();
      }
    }
    function K(ie = !1) {
      var L;
      const ce = P.value;
      P.value = null, ie && ce && ((L = he.value[ce]) == null || L.focus());
    }
    He(
      () => n.order,
      (ie) => {
        ie === "relevance" && P.value === "sort" && K();
      }
    );
    function Z(ie, ce) {
      r("update:value", { ...n.value, [ie]: ce }), K(!0);
    }
    function W() {
      $e.value = "", r("update:value", {
        ...n.value,
        type: "any",
        modified: "any",
        size: "any",
        name: "",
        people: "any"
      });
    }
    const $e = m(n.value.name ?? "");
    He(
      () => n.value.name ?? "",
      (ie) => {
        ie !== $e.value.trim() && ($e.value = ie);
      }
    );
    let Se;
    function ze(ie) {
      $e.value = ie.target.value, Se && clearTimeout(Se), Se = setTimeout(() => {
        r("update:value", { ...n.value, name: $e.value.trim() });
      }, 140);
    }
    function Ne() {
      Se && clearTimeout(Se), $e.value = "", r("update:value", { ...n.value, name: "" });
    }
    it(() => {
      Se && clearTimeout(Se);
    });
    function be(ie) {
      var L;
      if (!P.value) return;
      const ce = ie.target;
      (L = ve.value) != null && L.contains(ce) || Object.values(he.value).some((se) => se == null ? void 0 : se.contains(ce)) || K();
    }
    function De(ie) {
      ie.key === "Escape" && P.value && (ie.stopPropagation(), K(!0));
    }
    return dt(() => {
      document.addEventListener("pointerdown", be, !0), document.addEventListener("keydown", De, !0);
    }), it(() => {
      document.removeEventListener("pointerdown", be, !0), document.removeEventListener("keydown", De, !0);
    }), (ie, ce) => (c(), d("div", {
      class: "fe-filterbar",
      "data-mode": u.value ? "full" : "find",
      "data-testid": "filterbar"
    }, [
      u.value ? (c(), d("div", {
        key: 0,
        class: "fe-filterbar__chips",
        role: "group",
        "aria-label": s(a)("filter.aria")
      }, [
        (c(), d(ae, null, Te(p, (L) => o("button", {
          key: L,
          ref_for: !0,
          ref: (se) => oe(L, se),
          type: "button",
          class: we(["fe-filterbar__chip", { "is-set": I(L) !== "any", "is-open": P.value === L }]),
          "aria-expanded": P.value === L,
          "aria-haspopup": "listbox",
          "data-testid": `filter-${L}`,
          onClick: (se) => j(L)
        }, [
          o("span", Z5, f(B(L)), 1),
          ce[3] || (ce[3] = o("svg", {
            class: "fe-ficon fe-filterbar__caret",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            o("path", { d: "M7 10l5 5 5-5" })
          ], -1))
        ], 10, J5)), 64))
      ], 8, X5)) : g("", !0),
      o("div", Q5, [
        ce[4] || (ce[4] = o("svg", {
          class: "fe-ficon fe-filterbar__find-glass",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.9",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          o("circle", {
            cx: "11",
            cy: "11",
            r: "6.5"
          }),
          o("path", { d: "M16 16l4.5 4.5" })
        ], -1)),
        o("input", {
          type: "search",
          class: "fe-filterbar__find-input",
          placeholder: v.value,
          "aria-label": v.value,
          value: $e.value,
          "data-testid": "filter-find",
          onInput: ze,
          onKeydown: Ut(Re(Ne, ["stop", "prevent"]), ["esc"])
        }, null, 40, eM)
      ]),
      u.value && U.value > 0 ? (c(), d("button", {
        key: 1,
        type: "button",
        class: "fe-filterbar__clear",
        "data-testid": "filter-clear",
        onClick: W
      }, f(s(a)("filter.clear")), 1)) : g("", !0),
      u.value && U.value > 0 && typeof e.shown == "number" && typeof e.total == "number" ? (c(), d("span", tM, f(s(a)("filter.count", { shown: String(e.shown), total: String(e.total) })), 1)) : g("", !0),
      u.value ? (c(), d("div", nM, [
        o("button", {
          ref: (L) => oe("sort", L),
          type: "button",
          class: we(["fe-filterbar__sortdir", { "is-ranked": M.value }]),
          disabled: M.value,
          title: M.value ? T.value : void 0,
          "data-testid": "sort-dir",
          onClick: ce[0] || (ce[0] = (L) => O())
        }, [
          o("span", null, f(z.value), 1),
          o("span", oM, ", " + f(T.value), 1),
          M.value ? g("", !0) : (c(), d("svg", sM, [
            $.value ? (c(), d(ae, { key: 0 }, [
              ce[5] || (ce[5] = o("path", { d: "M12 19V5" }, null, -1)),
              ce[6] || (ce[6] = o("path", { d: "M5 12l7-7 7 7" }, null, -1))
            ], 64)) : (c(), d(ae, { key: 1 }, [
              ce[7] || (ce[7] = o("path", { d: "M12 5v14" }, null, -1)),
              ce[8] || (ce[8] = o("path", { d: "M19 12l-7 7-7-7" }, null, -1))
            ], 64))
          ]))
        ], 10, aM),
        o("button", {
          type: "button",
          class: "fe-filterbar__sortpick",
          "aria-label": M.value ? T.value : s(a)("sort.by"),
          title: M.value ? T.value : s(a)("sort.by"),
          disabled: M.value,
          "aria-haspopup": "menu",
          "aria-expanded": P.value === "sort",
          "data-testid": "sort-menu",
          onClick: ce[1] || (ce[1] = (L) => J())
        }, [...ce[9] || (ce[9] = [
          o("svg", {
            class: "fe-ficon fe-filterbar__caret",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            o("path", { d: "M7 10l5 5 5-5" })
          ], -1)
        ])], 8, rM)
      ])) : g("", !0),
      u.value ? (c(), d("button", {
        key: 4,
        ref: (L) => oe("actions", L),
        type: "button",
        class: "fe-filterbar__actions",
        "aria-label": s(a)("filter.actions"),
        title: s(a)("filter.actions"),
        "aria-haspopup": "menu",
        "aria-expanded": P.value === "actions",
        "data-testid": "listing-actions",
        onClick: ce[2] || (ce[2] = (L) => j("actions"))
      }, [...ce[10] || (ce[10] = [
        o("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          o("circle", {
            cx: "12",
            cy: "5.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          o("circle", {
            cx: "12",
            cy: "12",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          o("circle", {
            cx: "12",
            cy: "18.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 8, iM)) : g("", !0),
      (c(), et(ja, { to: "body" }, [
        P.value ? (c(), d("div", {
          key: 0,
          ref_key: "panelEl",
          ref: ve,
          class: we(["fe-filterpop", {
            "fe--theme-light": e.theme === "light",
            "fe--theme-dark": e.theme === "dark",
            "fe-filterpop--sort": P.value === "sort",
            "fe-filterpop--actions": P.value === "actions"
          }]),
          role: P.value === "sort" || P.value === "actions" ? "menu" : "listbox",
          "aria-label": pe.value,
          style: Ct({ left: le.value.x + "px", top: le.value.y + "px" })
        }, [
          P.value === "actions" ? (c(!0), d(ae, { key: 0 }, Te(G.value, (L) => (c(), d(ae, {
            key: L.key
          }, [
            L.divider ? (c(), d("hr", cM)) : (c(), d("button", {
              key: 1,
              type: "button",
              class: "fe-filterpop__item",
              role: "menuitem",
              disabled: L.disabled,
              "aria-disabled": L.disabled,
              "data-active": "false",
              "data-testid": `listing-action-${L.key}`,
              onClick: (se) => N(L.key)
            }, [
              o("span", null, f(L.label), 1)
            ], 8, uM))
          ], 64))), 128)) : P.value === "sort" ? (c(!0), d(ae, { key: 1 }, Te(s(gd), (L) => (c(), d("button", {
            key: L,
            type: "button",
            class: "fe-filterpop__item",
            role: "menuitem",
            "data-active": E.value === L ? "true" : "false",
            "data-testid": `sort-opt-${L}`,
            onClick: (se) => Y(L)
          }, [
            o("span", null, f(s(a)(`col.${L}`)), 1)
          ], 8, dM))), 128)) : (c(!0), d(ae, { key: 2 }, Te(Q.value, (L) => (c(), d("button", {
            key: L,
            type: "button",
            class: "fe-filterpop__item",
            role: "option",
            "aria-selected": re(L),
            "data-checked": re(L) ? "true" : "false",
            "data-active": re(L) ? "true" : "false",
            "data-testid": `filter-opt-${L}`,
            onClick: (se) => w(L)
          }, [
            o("span", pM, f(re(L) ? "✓" : ""), 1),
            o("span", null, f(S(L)), 1)
          ], 8, fM))), 128))
        ], 14, lM)) : g("", !0)
      ]))
    ], 8, G5));
  }
}), hM = ["aria-label"], mM = ["aria-selected", "title", "aria-label"], yM = ["innerHTML"], bM = ["aria-selected", "title", "aria-label"], gM = ["innerHTML"], kM = ["aria-selected", "title", "aria-label"], _M = ["innerHTML"], wM = /* @__PURE__ */ qe({
  __name: "ViewSwitcher",
  props: {
    viewMode: {},
    locale: {},
    modes: {}
  },
  emits: ["update:viewMode"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale);
    function u(v) {
      return !n.modes || n.modes.includes(v);
    }
    return (v, p) => (c(), d("div", {
      class: "fe-toolbar__view",
      role: "tablist",
      "aria-label": s(a)("toolbar.view_label")
    }, [
      u("list") ? (c(), d("button", {
        key: 0,
        type: "button",
        class: we(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "list" }]),
        role: "tab",
        "aria-selected": e.viewMode === "list",
        title: s(a)("toolbar.view.list"),
        "aria-label": s(a)("toolbar.view.list"),
        "data-testid": "view-list",
        onClick: p[0] || (p[0] = (h) => r("update:viewMode", "list"))
      }, [
        o("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: s(Ue)("view-list")
        }, null, 8, yM)
      ], 10, mM)) : g("", !0),
      u("grid") ? (c(), d("button", {
        key: 1,
        type: "button",
        class: we(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "grid" }]),
        role: "tab",
        "aria-selected": e.viewMode === "grid",
        title: s(a)("toolbar.view.grid"),
        "aria-label": s(a)("toolbar.view.grid"),
        "data-testid": "view-grid",
        onClick: p[1] || (p[1] = (h) => r("update:viewMode", "grid"))
      }, [
        o("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: s(Ue)("view-grid")
        }, null, 8, gM)
      ], 10, bM)) : g("", !0),
      u("gallery") ? (c(), d("button", {
        key: 2,
        type: "button",
        class: we(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "gallery" }]),
        role: "tab",
        "aria-selected": e.viewMode === "gallery",
        title: s(a)("toolbar.view.gallery"),
        "aria-label": s(a)("toolbar.view.gallery"),
        "data-testid": "view-gallery",
        onClick: p[2] || (p[2] = (h) => r("update:viewMode", "gallery"))
      }, [
        o("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: s(Ue)("view-gallery")
        }, null, 8, _M)
      ], 10, kM)) : g("", !0)
    ], 8, hM));
  }
}), $M = ["aria-label", "aria-busy"], xM = ["aria-sort"], SM = ["disabled", "title"], CM = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, TM = ["aria-label", "title"], MM = ["aria-sort", "aria-label", "onPointerdown"], EM = ["disabled", "title", "onClick"], zM = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, AM = {
  key: 1,
  class: "fe-list__head-label"
}, PM = ["aria-label", "title", "onPointerdown", "onDblclick", "onKeydown"], LM = {
  class: "fe-list__col fe-list__col--menu",
  role: "columnheader"
}, DM = ["title", "aria-label", "aria-expanded"], OM = {
  class: "fe-list__body",
  role: "rowgroup"
}, BM = {
  key: 0,
  class: "fe-list__group",
  role: "presentation"
}, IM = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], HM = ["onClick"], FM = ["aria-label", "innerHTML"], NM = ["src"], KM = ["innerHTML"], RM = { class: "fe-list__name-wrap" }, UM = ["title"], VM = {
  key: 0,
  class: "fe-list__badge"
}, jM = ["title", "aria-label"], YM = {
  key: 0,
  class: "fe-list__snippet"
}, WM = {
  key: 0,
  class: "fe-list__mark"
}, qM = {
  key: 3,
  class: "fe-list__kind"
}, GM = ["title"], XM = ["title", "aria-label", "onClick"], JM = {
  key: 0,
  class: "fe-list__empty"
}, ZM = ["data-prefers-dark"], QM = ["aria-label", "onKeydown"], eE = { class: "fe-colmenu__title" }, tE = ["aria-checked", "onClick"], nE = { class: "fe-colmenu__label" }, aE = ["disabled", "title", "aria-label", "onClick"], oE = ["disabled", "title", "aria-label", "onClick"], sE = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, rE = { class: "fe-colmenu__label" }, iE = {
  key: 2,
  class: "fe-colmenu__sep",
  role: "separator"
}, lE = {
  key: 3,
  class: "fe-colmenu__title"
}, cE = {
  key: 4,
  class: "fe-colmenu__hint"
}, uE = { class: "fe-colmenu__label" }, dE = { class: "fe-colmenu__label" }, fE = 5, pE = 300, vE = /* @__PURE__ */ qe({
  __name: "ListView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    keepBadgeFor: { type: Function },
    order: {},
    folderKey: {},
    theme: {},
    thumbSrc: { type: Function }
  },
  emits: ["click-row", "dbl-row", "context-row", "item-drag-start", "item-drop-into", "star-change", "display-order"],
  setup(e, { emit: t }) {
    const n = e, r = t, {
      t: a,
      formatSize: u,
      formatDate: v,
      formatDateFull: p,
      formatMonthYear: h,
      zonedYearMonth: b,
      toDate: y,
      nodeDisplayName: A
    } = tt(() => n.locale);
    function D(H) {
      return n.selected.has(H.path);
    }
    function C(H, te) {
      r("click-row", H, Ui(te, Y.isTap(te)));
    }
    function B(H) {
      r("dbl-row", H);
    }
    function I(H, te) {
      te.preventDefault(), te.stopPropagation(), r("context-row", H, te);
    }
    function U(H, te) {
      const _e = te.currentTarget, Me = _e == null ? void 0 : _e.getBoundingClientRect();
      r("context-row", H, {
        clientX: Me ? Me.left : te.clientX,
        clientY: Me ? Me.bottom : te.clientY,
        preventDefault: () => {
        },
        stopPropagation: () => {
        }
      });
    }
    function x(H, te) {
      r("click-row", H, Vi(te));
    }
    function E(H, te) {
      Xi(
        te,
        A(H),
        n.selected.has(H.path) ? n.selected.size : 1
      ), r("item-drag-start", H, te);
    }
    const $ = m(null);
    function M(H, te) {
      H.type === "dir" && vn(te) && (te.preventDefault(), te.stopPropagation(), te.dataTransfer && (te.dataTransfer.dropEffect = "move"), $.value = H.path);
    }
    function z(H) {
      $.value === H.path && ($.value = null);
    }
    function T(H, te) {
      $.value = null, H.type === "dir" && vn(te) && (te.preventDefault(), te.stopPropagation(), r("item-drop-into", H, te));
    }
    const Y = ji(
      (H, te) => r("context-row", H, { ...te, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (H) => r("click-row", H, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function O(H) {
      return H === "kept" ? "✓" : H === "syncing" ? "⟳" : H === "partial" ? "◐" : "☁";
    }
    function J(H) {
      return H.basename === ".trash" || Pi(H);
    }
    function G(H) {
      return v(H, { time: !0 }) || "—";
    }
    function N(H) {
      return p(H);
    }
    function P(H) {
      return J(H) ? "—" : Os(H, a);
    }
    function le(H) {
      return H.type === "dir" || yi(H) ? null : n.thumbSrc ? n.thumbSrc(H) : H.thumb_url ?? null;
    }
    const ve = k(() => ie.value.includes("type"));
    function he(H) {
      return H.type === "dir" && !J(H);
    }
    function oe(H) {
      const te = ya(H.path);
      return [String(H.storage ?? "").trim(), te].filter(Boolean).join("/");
    }
    function ue(H) {
      const te = H.snippet;
      return typeof te == "string" ? te : "";
    }
    function Q(H) {
      return Od(H.matched);
    }
    const pe = Ao(), re = k(() => pe.key.value), S = k(() => pe.dir.value), w = k(() => n.order === "relevance");
    He(() => n.locale, (H) => Hi(H), { immediate: !0 });
    function j(H) {
      w.value || pe.chooseSortKey(H);
    }
    const K = k(() => a(w.value ? "sort.relevance_why" : "col.sort"));
    function Z(H) {
      return w.value || re.value !== H ? "none" : S.value === "asc" ? "ascending" : "descending";
    }
    const W = k(() => {
      const H = ["type"];
      return n.showParentPath && H.push("location"), H.push("owner", "modified", "size"), n.starEnabled !== !1 && (n.apiBase || n.apiBase === "") && H.push("star"), H;
    }), $e = m(null), Se = m(0);
    let ze = null;
    const Ne = m(!1);
    function be(H) {
      const te = H.currentTarget, _e = ((te == null ? void 0 : te.scrollLeft) ?? 0) > 0;
      _e !== Ne.value && (Ne.value = _e);
    }
    dt(() => {
      !$e.value || typeof ResizeObserver > "u" || (ze = new ResizeObserver((H) => {
        var _e, Me;
        const te = ((Me = (_e = H[0]) == null ? void 0 : _e.contentRect) == null ? void 0 : Me.width) ?? 0;
        Math.abs(te - Se.value) >= 1 && (Se.value = te);
      }), ze.observe($e.value));
    }), it(() => {
      ze == null || ze.disconnect(), ze = null, window.removeEventListener("pointermove", ye), window.removeEventListener("pointerup", je);
    });
    const De = k(() => Zy(Se.value, W.value)), ie = k(() => De.value.visible), ce = k(() => ({ width: `${De.value.total}px` }));
    function L(H) {
      return { flex: `0 0 ${De.value.widths[H] ?? wo(H)}px` };
    }
    function se(H) {
      return `fe-list__col fe-list__col--${H === "modified" ? "mod" : H}`;
    }
    const Ce = {
      type: "type",
      modified: "modified",
      size: "size"
    }, We = {
      name: "col.name",
      type: "col.type",
      location: "col.location",
      owner: "col.owner",
      modified: "col.modified",
      size: "col.size",
      star: "col.star"
    };
    function Ie(H) {
      return a(We[H]);
    }
    function Ze(H, te) {
      switch (H) {
        case "type":
          return P(te);
        case "location":
          return oe(te);
        case "owner":
          return Le(te);
        case "modified":
          return G(te.last_modified);
        case "size":
          return u(te.size);
        default:
          return "";
      }
    }
    function vt(H, te) {
      if (H === "owner") return q(te);
      if (H === "modified") return N(te.last_modified);
      if (H === "location") return oe(te) || void 0;
    }
    function Xe(H) {
      if (!n.showParentPath || ie.value.includes("location")) return H.basename;
      const te = oe(H);
      return te ? `${H.basename} · ${te}` : H.basename;
    }
    function Ae(H) {
      var te;
      return ((te = ma.find((_e) => _e.id === H)) == null ? void 0 : te.resizable) === !0;
    }
    let V = null;
    function R() {
      Td() && Vy(De.value.widths);
    }
    function X(H, te) {
      Ae(H) && (te.preventDefault(), te.stopPropagation(), R(), V = { id: H, startX: te.clientX, startW: wo(H) }, window.addEventListener("pointermove", ye), window.addEventListener("pointerup", je));
    }
    function ye(H) {
      V && Jr(V.id, V.startW + (H.clientX - V.startX));
    }
    function je() {
      V = null, window.removeEventListener("pointermove", ye), window.removeEventListener("pointerup", je);
    }
    function Qe(H, te) {
      const _e = te.key === "ArrowLeft" ? -16 : te.key === "ArrowRight" ? 16 : 0;
      _e && (te.preventDefault(), R(), Jr(H, wo(H) + _e));
    }
    function at(H) {
      const te = ma.find((_e) => _e.id === H);
      te && (R(), Jr(H, te.width));
    }
    let Ye = null;
    const lt = m(null), fe = m(null);
    let Pe = 0, Be = !1;
    function ht(H) {
      var te;
      return ((te = ma.find((_e) => _e.id === H)) == null ? void 0 : te.hideable) === !0;
    }
    function Ft(H, te) {
      te.button !== 0 || !ht(H) || (Ye = { id: H, startX: te.clientX, armed: !1 }, window.addEventListener("pointermove", ft), window.addEventListener("pointerup", qt), window.addEventListener("keydown", Gt, !0));
    }
    function ft(H) {
      var Oe;
      if (!Ye) return;
      if (!Ye.armed) {
        if (Math.abs(H.clientX - Ye.startX) < fE) return;
        Ye.armed = !0, lt.value = Ye.id;
      }
      const te = (Oe = $e.value) == null ? void 0 : Oe.querySelector(".fe-list__head");
      if (!te) return;
      const Me = [...te.querySelectorAll(".fe-list__col")].slice(2, 2 + ie.value.length);
      let ge = Me.length;
      for (let mt = 0; mt < Me.length; mt++) {
        const Xt = Me[mt].getBoundingClientRect();
        if (H.clientX < Xt.left + Xt.width / 2) {
          ge = mt;
          break;
        }
      }
      fe.value = ge;
    }
    function qt() {
      const H = Ye, te = fe.value;
      if (wt(), !(H != null && H.armed) || Be) {
        Be = !1;
        return;
      }
      if (Pe = Date.now(), te == null) return;
      const _e = ie.value.filter((Oe) => Oe !== H.id), Me = _e[Math.min(te, _e.length)], ge = ga();
      Cd(H.id, Me ? ge.indexOf(Me) : ge.length);
    }
    function Gt(H) {
      if (H.key !== "Escape") return;
      H.stopPropagation();
      const te = (Ye == null ? void 0 : Ye.armed) === !0;
      wt(), te && (Be = !0, Pe = Date.now());
    }
    function wt() {
      Ye = null, lt.value = null, fe.value = null, window.removeEventListener("pointermove", ft), window.removeEventListener("pointerup", qt), window.removeEventListener("keydown", Gt, !0);
    }
    function en(H) {
      Date.now() - Pe > pE || (Pe = 0, H.preventDefault(), H.stopPropagation());
    }
    const $t = m(!1), kt = m(0), Dt = m(0), At = m(null), Ot = m(!1);
    dt(() => {
      var H;
      try {
        Ot.value = ((H = window.matchMedia) == null ? void 0 : H.call(window, "(prefers-color-scheme: dark)").matches) ?? !1;
      } catch {
      }
    });
    const Bt = k(
      () => `fe-ctx-backdrop--theme-${n.theme || "auto"}`
    ), un = k(
      () => (
        /* In the person's OWN order, so this list reads as the list on screen — a
           settings panel that disagrees with the thing it configures is how someone
           ends up nudging the wrong column left. */
        ga().filter((H) => {
          var te;
          return ((te = ma.find((_e) => _e.id === H)) == null ? void 0 : te.hideable) && W.value.includes(H);
        }).map((H) => ({
          id: H,
          label: Ie(H),
          on: !Ks(H),
          canLeft: pu(H, -1),
          canRight: pu(H, 1)
        }))
      )
    );
    function pt(H, te) {
      Uy(H, te);
    }
    const tn = k(() => Wy()), xt = k(() => Hy()), jt = k(() => !!n.folderKey && Iy(n.folderKey));
    async function Pt(H) {
      var Me;
      H.preventDefault(), H.stopPropagation();
      const te = H.currentTarget, _e = te == null ? void 0 : te.getBoundingClientRect();
      kt.value = H.clientX || (_e ? _e.left : 0), Dt.value = H.clientY || (_e ? _e.bottom : 0), $t.value = !0, await gt(), _t(), (Me = At.value) == null || Me.focus();
    }
    function _t() {
      const H = At.value;
      if (!H) return;
      const te = H.getBoundingClientRect(), _e = 8;
      te.right > window.innerWidth - _e && (kt.value = Math.max(_e, window.innerWidth - _e - te.width)), te.bottom > window.innerHeight - _e && (Dt.value = Math.max(_e, window.innerHeight - _e - te.height));
    }
    function St() {
      $t.value = !1;
    }
    function sn(H) {
      jy(H, !Ks(H));
    }
    function Nt() {
      Yy();
    }
    function nn() {
      Ry(), St();
    }
    function mn() {
      n.folderKey && Ky(n.folderKey), St();
    }
    const xe = k(() => {
      const H = [], te = [];
      for (const _e of n.files) (J(_e) ? H : te).push(_e);
      return [...H, ...te.sort(pe.compareInOrder(n.order ?? "sort"))];
    }), de = k(() => ({ t: a, formatMonthYear: h, zonedYearMonth: b }));
    He(
      xe,
      (H) => r("display-order", H),
      { immediate: !0 }
    );
    function Le(H) {
      return Ri(H) ? a("owner.you") : So(H) === null ? a("owner.system") : zd(H) || a("owner.unknown");
    }
    function q(H) {
      const te = [Le(H)];
      wb(H) && te.push(a("owner.external"));
      const _e = H.last_actor_name, Me = H.last_actor_self === !0, ge = H.last_actor_id;
      if (Me || typeof _e == "string" && _e) {
        const Oe = Me ? a("owner.you") : String(_e);
        Oe !== te[0] && te.push(a("owner.last_actor", { who: Oe }));
      } else ge === void 0 && So(H) !== null && te.push(a("owner.last_actor", { who: a("owner.system") }));
      return te.join(" · ");
    }
    const ne = k(
      () => Gi(xe.value, {
        /* ⚠ `ranked` is half of this and not a detail: over a search's ranked
         * answer the key is still `modified` (nothing cleared it), the listing
         * just is not obeying it — see `lib/dateGroups.groupingActive`. */
        active: qi(re.value, n.order),
        dateOf: (H) => y(H.last_modified),
        /* ⚠ Folders are their OWN run, above the first date heading, and that is
         * what lets "folders before files" hold while sorted by date. The rule
         * used to be softened instead — rows sorted by date, folders floating to
         * the top of each bucket — because hoisting them all would have split a
         * bucket in two and drawn "Today" twice, once over the folders and once
         * over the files. A run of their own removes that reason, and a folder has
         * no meaningful modification date to file under anyway. */
        aside: (H) => J(H) ? { id: "pinned" } : H.type === "dir" ? { id: "dirs" } : null,
        labels: de.value
      }).runs
    );
    return (H, te) => (c(), d(ae, null, [
      o("div", {
        ref_key: "listEl",
        ref: $e,
        class: we(["fe-list", {
          "is-loading": e.loading,
          "has-star-col": !!e.apiBase || e.apiBase === "",
          "is-scrolled-x": Ne.value
        }]),
        role: "grid",
        "aria-label": s(a)("list.aria"),
        "aria-busy": e.loading ? "true" : void 0,
        onScrollPassive: be
      }, [
        o("div", {
          class: we(["fe-list__head", { "is-dragging-col": !!lt.value }]),
          role: "row",
          style: Ct(ce.value),
          onContextmenu: Pt,
          onClickCapture: en
        }, [
          te[13] || (te[13] = o("div", {
            class: "fe-list__col fe-list__col--check",
            role: "columnheader"
          }, null, -1)),
          o("div", {
            class: "fe-list__col fe-list__col--name",
            role: "columnheader",
            style: Ct(L("name")),
            "aria-sort": Z("name")
          }, [
            o("button", {
              type: "button",
              class: "fe-list__sort",
              disabled: w.value,
              title: K.value,
              onClick: te[0] || (te[0] = (_e) => j("name"))
            }, [
              Je(f(s(a)("col.name")) + " ", 1),
              !w.value && re.value === "name" ? (c(), d("span", CM, f(S.value === "asc" ? "↑" : "↓"), 1)) : g("", !0)
            ], 8, SM),
            o("span", {
              class: "fe-list__resize",
              role: "separator",
              "aria-orientation": "vertical",
              tabindex: "0",
              "aria-label": s(a)("cols.resize", { col: s(a)("col.name") }),
              title: s(a)("cols.resize", { col: s(a)("col.name") }),
              onPointerdown: te[1] || (te[1] = (_e) => X("name", _e)),
              onDblclick: te[2] || (te[2] = Re((_e) => at("name"), ["stop"])),
              onKeydown: te[3] || (te[3] = (_e) => Qe("name", _e))
            }, null, 40, TM)
          ], 12, xM),
          (c(!0), d(ae, null, Te(ie.value, (_e, Me) => (c(), d("div", {
            key: _e,
            class: we([
              se(_e),
              {
                "is-col-dragging": lt.value === _e,
                "is-drop-before": fe.value === Me && !!lt.value && lt.value !== _e,
                "is-drop-after": fe.value === ie.value.length && Me === ie.value.length - 1 && !!lt.value,
                "is-movable": ht(_e)
              }
            ]),
            role: "columnheader",
            style: Ct(L(_e)),
            "aria-sort": Ce[_e] ? Z(Ce[_e]) : void 0,
            "aria-label": _e === "star" ? s(a)("col.star") : void 0,
            onPointerdown: (ge) => Ft(_e, ge)
          }, [
            Ce[_e] ? (c(), d("button", {
              key: 0,
              type: "button",
              class: "fe-list__sort",
              disabled: w.value,
              title: K.value,
              onClick: (ge) => j(Ce[_e])
            }, [
              Je(f(Ie(_e)) + " ", 1),
              !w.value && re.value === Ce[_e] ? (c(), d("span", zM, f(S.value === "asc" ? "↑" : "↓"), 1)) : g("", !0)
            ], 8, EM)) : _e !== "star" ? (c(), d("span", AM, f(Ie(_e)), 1)) : g("", !0),
            Ae(_e) ? (c(), d("span", {
              key: 2,
              class: "fe-list__resize",
              role: "separator",
              "aria-orientation": "vertical",
              tabindex: "0",
              "aria-label": s(a)("cols.resize", { col: Ie(_e) }),
              title: s(a)("cols.resize", { col: Ie(_e) }),
              onPointerdown: (ge) => X(_e, ge),
              onDblclick: Re((ge) => at(_e), ["stop"]),
              onKeydown: (ge) => Qe(_e, ge)
            }, null, 40, PM)) : g("", !0)
          ], 46, MM))), 128)),
          o("div", LM, [
            o("button", {
              type: "button",
              class: "fe-list__menu fe-list__colmenu-btn",
              title: s(a)("cols.menu"),
              "aria-label": s(a)("cols.menu"),
              "aria-haspopup": "dialog",
              "aria-expanded": $t.value ? "true" : "false",
              onClick: Pt
            }, [...te[12] || (te[12] = [
              o("span", { "aria-hidden": "true" }, "⋮", -1)
            ])], 8, DM)
          ])
        ], 38),
        o("div", OM, [
          (c(!0), d(ae, null, Te(ne.value, (_e) => (c(), d(ae, {
            key: _e.id
          }, [
            _e.label ? (c(), d("div", BM, f(_e.label), 1)) : g("", !0),
            (c(!0), d(ae, null, Te(_e.items, (Me) => {
              var ge;
              return c(), d("div", {
                key: Me.path,
                class: we(["fe-list__row", {
                  "is-selected": D(Me),
                  "is-dir": Me.type === "dir",
                  "is-trash": Me.trashed,
                  "is-clipped": (ge = e.clipped) == null ? void 0 : ge.has(Me.path),
                  "is-droptarget": $.value === Me.path
                }]),
                role: "row",
                tabindex: "0",
                style: Ct(
                  ce.value
                  /* tablo:t2 — the head's own width, so the two cannot drift */
                ),
                "aria-selected": D(Me) ? "true" : "false",
                "aria-label": s(A)(Me),
                "data-fe-path": Me.path,
                draggable: "true",
                onClick: (Oe) => C(Me, Oe),
                onDblclick: (Oe) => B(Me),
                onContextmenu: (Oe) => I(Me, Oe),
                onDragstart: (Oe) => E(Me, Oe),
                onDragover: (Oe) => M(Me, Oe),
                onDragleave: (Oe) => z(Me),
                onDrop: (Oe) => T(Me, Oe),
                onTouchstartPassive: (Oe) => s(Y).onTouchStart(Me, Oe),
                onTouchend: te[9] || (te[9] = //@ts-ignore
                (...Oe) => s(Y).onTouchEnd && s(Y).onTouchEnd(...Oe)),
                onTouchmovePassive: te[10] || (te[10] = //@ts-ignore
                (...Oe) => s(Y).onTouchMove && s(Y).onTouchMove(...Oe))
              }, [
                o("div", {
                  class: "fe-list__col fe-list__col--check",
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: Re((Oe) => x(Me, Oe), ["stop"]),
                  onDblclick: te[4] || (te[4] = Re(() => {
                  }, ["stop"]))
                }, [
                  Ge(Yi, {
                    on: D(Me),
                    label: s(A)(Me)
                  }, null, 8, ["on", "label"])
                ], 40, HM),
                o("div", {
                  class: "fe-list__col fe-list__col--name",
                  role: "gridcell",
                  style: Ct(L("name"))
                }, [
                  s(Ls)(Me) ? (c(), d("span", {
                    key: 0,
                    class: "fe-list__icon fe-list__icon--svg",
                    role: "img",
                    "aria-label": s(a)("e2e.badge"),
                    innerHTML: s(Ds)()
                  }, null, 8, FM)) : le(Me) ? (c(), d("img", {
                    key: 1,
                    class: we(["fe-list__icon fe-list__icon--img", { "fe-thumb--page": s(Wi)(Me) }]),
                    src: le(Me),
                    alt: "",
                    "aria-hidden": "true",
                    loading: "lazy",
                    draggable: "false"
                  }, null, 10, NM)) : (c(), d("span", {
                    key: 2,
                    class: "fe-list__icon fe-list__icon--svg",
                    "aria-hidden": "true",
                    innerHTML: s(fn)(Me)
                  }, null, 8, KM)),
                  o("div", RM, [
                    o("span", {
                      class: "fe-list__name",
                      title: Xe(Me)
                    }, [
                      Je(f(s(A)(Me)) + " ", 1),
                      Q(Me) ? (c(), d("span", VM, f(s(a)("search.in_content")), 1)) : g("", !0),
                      e.keepBadgeFor && e.keepBadgeFor(Me) ? (c(), d("span", {
                        key: 1,
                        class: we(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(Me)]),
                        title: s(a)("keep.badge_" + e.keepBadgeFor(Me)),
                        role: "img",
                        "aria-label": s(a)("keep.badge_" + e.keepBadgeFor(Me))
                      }, f(O(e.keepBadgeFor(Me))), 11, jM)) : g("", !0)
                    ], 8, UM),
                    ue(Me) ? (c(), d("span", YM, [
                      (c(!0), d(ae, null, Te(s(Vs)(ue(Me)), (Oe, mt) => (c(), d(ae, { key: mt }, [
                        Oe.match ? (c(), d("mark", WM, f(Oe.text), 1)) : (c(), d(ae, { key: 1 }, [
                          Je(f(Oe.text), 1)
                        ], 64))
                      ], 64))), 128))
                    ])) : g("", !0)
                  ]),
                  he(Me) && !ve.value ? (c(), d("span", qM, f(s(a)("node.folder")), 1)) : g("", !0)
                ], 4),
                (c(!0), d(ae, null, Te(ie.value, (Oe) => {
                  var mt;
                  return c(), d(ae, { key: Oe }, [
                    Oe === "star" ? (c(), d("div", {
                      key: 0,
                      class: "fe-list__col fe-list__col--star",
                      role: "gridcell",
                      style: Ct(L(Oe))
                    }, [
                      e.starEnabled !== !1 && typeof Me.id == "number" && Me.type === "file" ? (c(), d("span", {
                        key: 0,
                        class: "fe-list__star-hit",
                        "data-fe-control": "",
                        onClick: te[5] || (te[5] = Re(() => {
                        }, ["stop"])),
                        onDblclick: te[6] || (te[6] = Re(() => {
                        }, ["stop"]))
                      }, [
                        Ge(er, {
                          starred: !!((mt = e.starredIds) != null && mt.has(Me.id)),
                          "node-id": Me.id,
                          "api-base": e.apiBase,
                          "auth-headers": e.authHeaders,
                          "auth-credentials": e.authCredentials,
                          locale: e.locale,
                          compact: "",
                          onChange: (Xt) => r("star-change", Me, Xt)
                        }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
                      ], 32)) : g("", !0)
                    ], 4)) : (c(), d("div", {
                      key: 1,
                      class: we(se(Oe)),
                      role: "gridcell",
                      style: Ct(L(Oe)),
                      title: vt(Oe, Me)
                    }, f(Ze(Oe, Me)), 15, GM))
                  ], 64);
                }), 128)),
                o("div", {
                  class: "fe-list__col fe-list__col--menu",
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: te[7] || (te[7] = Re(() => {
                  }, ["stop"])),
                  onDblclick: te[8] || (te[8] = Re(() => {
                  }, ["stop"]))
                }, [
                  o("button", {
                    type: "button",
                    class: "fe-list__menu",
                    title: s(a)("toolbar.more"),
                    "aria-label": s(a)("toolbar.more"),
                    onClick: (Oe) => U(Me, Oe)
                  }, [...te[14] || (te[14] = [
                    o("span", { "aria-hidden": "true" }, "⋮", -1)
                  ])], 8, XM)
                ], 32)
              ], 46, IM);
            }), 128))
          ], 64))), 128)),
          !e.loading && xe.value.length === 0 ? (c(), d("div", JM, f(s(a)("empty.folder")), 1)) : g("", !0)
        ])
      ], 42, $M),
      (c(), et(ja, { to: "body" }, [
        $t.value ? (c(), d("div", {
          key: 0,
          class: we(["fe-colmenu__backdrop", Bt.value]),
          "data-prefers-dark": Ot.value ? "1" : "0",
          onClick: St,
          onContextmenu: Re(St, ["prevent"])
        }, [
          o("div", {
            ref_key: "colMenuEl",
            ref: At,
            class: "fe-colmenu",
            role: "dialog",
            tabindex: "-1",
            "aria-label": s(a)("cols.menu"),
            style: Ct({ top: Dt.value + "px", left: kt.value + "px" }),
            onClick: te[11] || (te[11] = Re(() => {
            }, ["stop"])),
            onKeydown: Ut(Re(St, ["stop"]), ["esc"])
          }, [
            o("p", eE, f(s(a)("cols.title")), 1),
            (c(!0), d(ae, null, Te(un.value, (_e) => (c(), d("div", {
              key: _e.id,
              class: "fe-colmenu__line"
            }, [
              o("button", {
                type: "button",
                class: "fe-colmenu__row",
                role: "checkbox",
                "aria-checked": _e.on ? "true" : "false",
                onClick: (Me) => sn(_e.id)
              }, [
                o("span", {
                  class: we(["fe-list__check fe-colmenu__tick", { "is-on": _e.on }]),
                  "aria-hidden": "true"
                }, null, 2),
                o("span", nE, f(_e.label), 1)
              ], 8, tE),
              o("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !_e.canLeft,
                title: s(a)("cols.move_left", { col: _e.label }),
                "aria-label": s(a)("cols.move_left", { col: _e.label }),
                onClick: (Me) => pt(_e.id, -1)
              }, [...te[15] || (te[15] = [
                o("span", { "aria-hidden": "true" }, "←", -1)
              ])], 8, aE),
              o("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !_e.canRight,
                title: s(a)("cols.move_right", { col: _e.label }),
                "aria-label": s(a)("cols.move_right", { col: _e.label }),
                onClick: (Me) => pt(_e.id, 1)
              }, [...te[16] || (te[16] = [
                o("span", { "aria-hidden": "true" }, "→", -1)
              ])], 8, oE)
            ]))), 128)),
            tn.value ? (c(), d("div", sE)) : g("", !0),
            tn.value ? (c(), d("button", {
              key: 1,
              type: "button",
              class: "fe-colmenu__row",
              onClick: Nt
            }, [
              o("span", rE, f(s(a)("cols.reset")), 1)
            ])) : g("", !0),
            jt.value || xt.value > 0 ? (c(), d("div", iE)) : g("", !0),
            jt.value || xt.value > 0 ? (c(), d("p", lE, f(s(a)("cols.folder_title")), 1)) : g("", !0),
            jt.value || xt.value > 0 ? (c(), d("p", cE, f(s(a)("cols.folder_hint")), 1)) : g("", !0),
            jt.value ? (c(), d("button", {
              key: 5,
              type: "button",
              class: "fe-colmenu__row",
              onClick: mn
            }, [
              o("span", uE, f(s(a)("cols.forget_folder")), 1)
            ])) : g("", !0),
            xt.value > 0 ? (c(), d("button", {
              key: 6,
              type: "button",
              class: "fe-colmenu__row",
              onClick: nn
            }, [
              o("span", dE, f(s(a)("cols.apply_all", { count: xt.value })), 1)
            ])) : g("", !0)
          ], 44, QM)
        ], 42, ZM)) : g("", !0)
      ]))
    ], 64));
  }
}), hE = ["aria-label", "aria-busy"], mE = {
  key: 0,
  class: "fe-gal__heading",
  "aria-hidden": "true"
}, yE = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], bE = {
  key: 0,
  class: "fe-fprev__tint"
}, gE = ["innerHTML"], kE = ["src", "alt"], _E = ["aria-label", "innerHTML"], wE = ["innerHTML"], $E = {
  key: 4,
  class: "fe-thumb__play",
  "aria-hidden": "true"
}, xE = ["onClick"], SE = {
  class: "fe-gal__meta",
  "aria-hidden": "true"
}, CE = {
  key: 0,
  class: "fe-gal__meta-line"
}, TE = ["title"], ME = ["title"], EE = {
  key: 0,
  class: "fe-gal__empty"
}, zE = /* @__PURE__ */ qe({
  __name: "GalleryView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    order: {},
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a, formatSize: u, nodeDisplayName: v, formatDate: p, formatMonthYear: h, zonedYearMonth: b, toDate: y } = tt(() => n.locale), A = Ao(), D = k(
      () => Gi(n.files, {
        active: qi(A.key.value, n.order),
        dateOf: (oe) => y(oe.last_modified),
        aside: (oe) => oe.type === "dir" ? { id: "dirs" } : null,
        labels: { t: a, formatMonthYear: h, zonedYearMonth: b }
      })
    );
    function C(oe) {
      return n.thumbSrc ? n.thumbSrc(oe) : oe.thumb_url ?? null;
    }
    const B = Ld({
      apiBase: n.apiBase,
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    it(() => B.dispose());
    function I(oe) {
      return B.kindFor(oe);
    }
    function U(oe) {
      const ue = B.get(oe);
      return ue ? [ue] : [];
    }
    function x(oe, ue) {
      B.bind(oe instanceof Element ? oe : null, ue);
    }
    function E(oe) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof oe.id == "number" && oe.type === "file";
    }
    function $(oe) {
      return n.selected.has(oe.path);
    }
    function M(oe, ue) {
      r("click-card", oe, Vi(ue));
    }
    function z(oe, ue) {
      r("click-card", oe, Ui(ue, le.isTap(ue)));
    }
    function T(oe) {
      r("dbl-card", oe);
    }
    function Y(oe, ue) {
      ue.preventDefault(), ue.stopPropagation(), r("context-card", oe, ue);
    }
    function O(oe, ue) {
      Xi(
        ue,
        v(oe),
        n.selected.has(oe.path) ? n.selected.size : 1
      ), r("item-drag-start", oe, ue);
    }
    const J = m(null);
    function G(oe, ue) {
      oe.type === "dir" && vn(ue) && (ue.preventDefault(), ue.stopPropagation(), ue.dataTransfer && (ue.dataTransfer.dropEffect = "move"), J.value = oe.path);
    }
    function N(oe) {
      J.value === oe.path && (J.value = null);
    }
    function P(oe, ue) {
      J.value = null, oe.type === "dir" && vn(ue) && (ue.preventDefault(), ue.stopPropagation(), r("item-drop-into", oe, ue));
    }
    const le = ji(
      (oe, ue) => r("context-card", oe, { ...ue, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (oe) => r("click-card", oe, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function ve(oe) {
      return p(oe, { time: !0 });
    }
    function he(oe) {
      const ue = ve(oe.last_modified);
      return [oe.type === "dir" ? "" : u(oe.size), ue].filter((pe) => !!pe).join(" · ");
    }
    return (oe, ue) => (c(), d("div", {
      class: we(["fe-gal", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0 }]),
      role: "listbox",
      "aria-multiselectable": "true",
      "aria-label": s(a)("gallery.aria"),
      "aria-busy": e.loading ? "true" : void 0
    }, [
      (c(!0), d(ae, null, Te(e.files, (Q) => {
        var pe, re;
        return c(), d(ae, {
          key: Q.path
        }, [
          D.value.headingBefore(Q) ? (c(), d("p", mE, f(D.value.headingBefore(Q)), 1)) : g("", !0),
          o("div", {
            class: we(["fe-gal__card", {
              "is-selected": $(Q),
              "is-dir": Q.type === "dir",
              "is-trash": Q.trashed,
              "is-clipped": (pe = e.clipped) == null ? void 0 : pe.has(Q.path),
              "is-droptarget": J.value === Q.path
            }]),
            tabindex: "0",
            role: "option",
            "aria-selected": $(Q) ? "true" : "false",
            "aria-label": s(v)(Q),
            "data-fe-path": Q.path,
            draggable: "true",
            onClick: (S) => z(Q, S),
            onDblclick: (S) => T(Q),
            onContextmenu: (S) => Y(Q, S),
            onDragstart: (S) => O(Q, S),
            onDragover: (S) => G(Q, S),
            onDragleave: (S) => N(Q),
            onDrop: (S) => P(Q, S),
            onTouchstartPassive: (S) => s(le).onTouchStart(Q, S),
            onTouchend: ue[3] || (ue[3] = //@ts-ignore
            (...S) => s(le).onTouchEnd && s(le).onTouchEnd(...S)),
            onTouchmovePassive: ue[4] || (ue[4] = //@ts-ignore
            (...S) => s(le).onTouchMove && s(le).onTouchMove(...S))
          }, [
            o("div", {
              class: "fe-gal__thumb",
              ref_for: !0,
              ref: (S) => x(S, Q)
            }, [
              I(Q) ? (c(), d(ae, { key: 0 }, [
                (c(!0), d(ae, null, Te(U(Q), (S) => (c(), d("div", {
                  key: "fprev",
                  class: we(["fe-fprev", "fe-fprev--" + S.kind]),
                  style: Ct(S.kind === "table" ? { "--fprev-cols": String(S.cols) } : void 0),
                  "aria-hidden": "true"
                }, [
                  S.kind === "table" ? (c(!0), d(ae, { key: 0 }, Te(S.rows, (w, j) => (c(), d(ae, { key: j }, [
                    (c(!0), d(ae, null, Te(w, (K, Z) => (c(), d("span", {
                      key: Z,
                      class: we(["fe-fprev__cell", { "is-head": j === 0 }])
                    }, f(K), 3))), 128))
                  ], 64))), 128)) : (c(!0), d(ae, { key: 1 }, Te(S.lines, (w, j) => (c(), d("div", {
                    key: j,
                    class: "fe-fprev__line"
                  }, [
                    w.tint ? (c(), d("span", bE, f(w.indent) + f(w.tint), 1)) : g("", !0),
                    Je(f(w.text), 1)
                  ]))), 128))
                ], 6))), 128)),
                U(Q).length === 0 ? (c(), d("span", {
                  key: 0,
                  class: "fe-gal__icon fe-gal__icon--svg",
                  innerHTML: s(fn)(Q)
                }, null, 8, gE)) : g("", !0)
              ], 64)) : C(Q) ? (c(), d("img", {
                key: 1,
                src: C(Q),
                alt: Q.basename,
                class: we({
                  "fe-thumb--page": s(Wi)(Q)
                  /* gorunum:v1-preview — crop a page from its TOP */
                }),
                loading: "lazy",
                draggable: "false"
              }, null, 10, kE)) : s(Ls)(Q) ? (c(), d("span", {
                key: 2,
                class: "fe-gal__icon fe-gal__icon--svg",
                role: "img",
                "aria-label": s(a)("e2e.badge"),
                innerHTML: s(Ds)()
              }, null, 8, _E)) : (c(), d("span", {
                key: 3,
                class: "fe-gal__icon fe-gal__icon--svg",
                innerHTML: s(fn)(Q)
              }, null, 8, wE)),
              !I(Q) && C(Q) && s(Pd)(Q) ? (c(), d("span", $E)) : g("", !0),
              e.selectable ? (c(), d("span", {
                key: 5,
                class: "fe-item-check fe-gal__check",
                "data-fe-control": "",
                onClick: Re((S) => M(Q, S), ["stop"]),
                onDblclick: ue[0] || (ue[0] = Re(() => {
                }, ["stop"]))
              }, [
                Ge(Yi, {
                  on: $(Q),
                  label: s(v)(Q)
                }, null, 8, ["on", "label"])
              ], 40, xE)) : g("", !0),
              E(Q) ? (c(), d("div", {
                key: 6,
                class: "fe-gal__star",
                onClick: ue[1] || (ue[1] = Re(() => {
                }, ["stop"])),
                onDblclick: ue[2] || (ue[2] = Re(() => {
                }, ["stop"]))
              }, [
                Ge(er, {
                  starred: !!((re = e.starredIds) != null && re.has(Q.id)),
                  "node-id": Q.id,
                  "api-base": e.apiBase,
                  "auth-headers": e.authHeaders,
                  "auth-credentials": e.authCredentials,
                  locale: e.locale,
                  compact: "",
                  card: "",
                  onChange: (S) => r("star-change", Q, S)
                }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
              ], 32)) : g("", !0),
              o("div", SE, [
                he(Q) ? (c(), d("span", CE, f(he(Q)), 1)) : g("", !0),
                e.showParentPath && s(ya)(Q.path) ? (c(), d("span", {
                  key: 1,
                  class: "fe-gal__meta-line fe-gal__meta-line--path",
                  title: s(ya)(Q.path)
                }, f(s(ya)(Q.path)), 9, TE)) : g("", !0)
              ])
            ], 512),
            o("div", {
              class: "fe-gal__label",
              title: Q.basename
            }, f(s(v)(Q)), 9, ME)
          ], 42, yE)
        ], 64);
      }), 128)),
      !e.loading && e.files.length === 0 ? (c(), d("div", EE, f(s(a)("empty.folder")), 1)) : g("", !0)
    ], 10, hE));
  }
}), AE = ["data-pane", "data-testid", "aria-label"], PE = {
  key: 0,
  class: "fe-subhead"
}, LE = { class: "fe-subhead__actions" }, DE = ["title", "aria-label"], OE = {
  key: 1,
  class: "fe__skeleton",
  role: "status"
}, BE = { class: "fe-sr-only" }, IE = {
  key: 0,
  class: "fe-skel-grid",
  "aria-hidden": "true"
}, HE = {
  key: 1,
  class: "fe-skel-list",
  "aria-hidden": "true"
}, FE = {
  key: 2,
  class: "fe-state"
}, NE = { class: "fe-state__title" }, KE = { class: "fe-state__hint" }, RE = { class: "fe-state__actions" }, UE = { class: "fe-state__details" }, VE = { class: "fe-state__details-summary" }, jE = { class: "fe-state__details-pre" }, YE = {
  key: 3,
  class: "fe-state",
  "data-testid": "empty-filtered"
}, WE = { class: "fe-state__title" }, qE = { class: "fe-state__hint" }, GE = { class: "fe-state__actions" }, XE = { class: "fe-state" }, JE = { class: "fe-state__title" }, ZE = "application/x-brf-files", QE = "application/x-brf-files-src", e8 = 500, Mu = /* @__PURE__ */ qe({
  __name: "FilePane",
  props: {
    paneId: {},
    api: {},
    locale: {},
    theme: {},
    focused: { type: Boolean },
    closable: { type: Boolean },
    path: {},
    selfDriven: { type: Boolean },
    qualify: {},
    toUser: {},
    clamp: {},
    rootLabel: {},
    rootPath: {},
    floor: {},
    multiRoot: { type: Boolean },
    virtualRows: {},
    trashVisible: { type: Boolean, default: !0 },
    navOffersTrash: { type: Boolean },
    rows: {},
    loading: { type: Boolean },
    error: {},
    order: {},
    viewMode: {},
    viewModes: {},
    showCrumbs: { type: Boolean, default: !0 },
    showFilterBar: { type: Boolean, default: !0 },
    filterMode: {},
    findLabel: {},
    showViewSwitcher: { type: Boolean, default: !0 },
    crumbSubfolders: {},
    folderKey: {},
    showParentPath: { type: Boolean },
    clipped: {},
    extraFilters: {},
    canWrite: { type: Boolean },
    canPaste: { type: Boolean },
    selected: {},
    filters: {},
    thumbSrc: {},
    keepBadgeFor: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    bodyOverride: { type: Boolean },
    openTrigger: { default: "double" }
  },
  emits: ["activate", "close", "navigate", "open", "open-trash", "click-row", "context", "clear-selection", "display-order", "item-drag-start", "item-drop-into", "transfer", "update:viewMode", "update:filters", "crumb-context", "copy-path", "crumb-drop", "new-folder", "upload", "paste", "select-all", "clear-filters", "star-change", "retry"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, { t: u } = tt(() => r.locale), v = r.paneId === "main" ? Ao() : $d();
    Fu(xd, v);
    const p = m(""), h = m([]), b = m(!1), y = m(""), A = m("");
    function D(L) {
      return jn(L) === "storage";
    }
    const C = k(() => r.selfDriven ? p.value : r.path ?? ""), B = k(
      () => r.selfDriven ? h.value : r.rows ?? []
    ), I = k(() => r.selfDriven ? b.value : !!r.loading), U = k(() => r.selfDriven ? y.value : r.error ?? ""), x = k(
      () => !!r.multiRoot && !(C.value ?? "").replace(/^\/+|\/+$/g, "")
    );
    async function E(L) {
      const se = r.clamp(L ?? p.value ?? "");
      b.value = !0, y.value = "";
      try {
        if (r.multiRoot && !se) {
          h.value = r.virtualRows ? r.virtualRows() : [], A.value = "", p.value = "", a("navigate", "");
          return;
        }
        const Ce = await r.api.index(r.qualify(se));
        A.value = Ce.perm || "", h.value = $s(Ce.files), hd(h.value, Ce.adapter, Ce.dirname, r.trashVisible !== !1, {
          navOffersTrash: r.navOffersTrash
        }) && md(h.value, Ce.adapter, r.api), p.value = r.toUser(Ce.dirname), a("navigate", p.value);
      } catch (Ce) {
        y.value = Ce instanceof Error ? Ce.message : String(Ce);
      } finally {
        b.value = !1;
      }
    }
    r.selfDriven && E(r.path ?? "");
    function $(L) {
      a("activate"), r.selfDriven ? E(L) : a("navigate", L);
    }
    const M = k(
      () => bd(C.value) ? C.value : r.qualify(C.value)
    ), z = k(() => {
      const L = M.value, se = L.indexOf("://");
      return se === -1 ? "" : L.slice(0, se);
    });
    function T(L) {
      if (a("activate"), !r.selfDriven) {
        a("navigate", L);
        return;
      }
      if (r.multiRoot && !L) {
        E("");
        return;
      }
      E(r.toUser(L));
    }
    const Y = k(() => {
      const L = hi(B.value, r.filters);
      return v.sortListing(
        r.extraFilters ? hi(L, r.extraFilters) : L,
        r.order ?? "sort"
      );
    }), O = k(() => $o(r.filters) || !!r.extraFilters), J = k(
      () => x.value ? "find" : r.filterMode ?? "full"
    ), G = k(
      () => x.value ? u("filter.find.storages") : r.findLabel ?? ""
    ), N = k(
      () => B.value.filter((L) => L.type === "dir").map((L) => ({ label: L.basename, adapterPath: L.path }))
    );
    let P = 0;
    function le() {
      return Date.now() - P < e8;
    }
    function ve(L, se) {
      if (!le()) {
        if (se.check) {
          a("activate"), a("click-row", L, { ctrl: !0, shift: se.shift });
          return;
        }
        if (se.touch || r.openTrigger === "single") {
          P = Date.now(), pe(L);
          return;
        }
        a("activate"), a("click-row", L, { ctrl: se.ctrl, shift: se.shift });
      }
    }
    function he(L) {
      le() || (P = Date.now(), pe(L));
    }
    function oe(L, se) {
      se.preventDefault(), se.stopPropagation(), a("activate"), a("context", L, se);
    }
    function ue(L) {
      L.preventDefault(), L.stopPropagation(), a("activate"), a("clear-selection"), a("context", null, L);
    }
    function Q() {
      a("clear-selection");
    }
    function pe(L) {
      if (a("activate"), L.basename === ".trash") {
        a("open-trash");
        return;
      }
      if (L.type === "dir" && r.selfDriven) {
        E(D(L) ? L.path : r.toUser(L.path));
        return;
      }
      a("open", L);
    }
    function re(L, se) {
      if (!se.dataTransfer) return;
      if (D(L) || x.value || L.basename === ".trash") {
        se.preventDefault();
        return;
      }
      const Ce = B.value.filter((Ie) => r.selected.has(Ie.path) && !D(Ie)).filter((Ie) => {
        var Ze;
        return !((Ze = r.clipped) != null && Ze.has(Ie.path));
      }).map((Ie) => ({ path: Ie.path, basename: Ie.basename, type: Ie.type })), We = Ce.length > 0 ? Ce : [{ path: L.path, basename: L.basename, type: L.type }];
      se.dataTransfer.setData(ZE, JSON.stringify(We)), se.dataTransfer.setData(QE, M.value), se.dataTransfer.setData("text/plain", We.map((Ie) => Ie.path).join(`
`)), se.dataTransfer.effectAllowed = "move", a("item-drag-start", L, se);
    }
    const S = m(!1);
    function w(L) {
      return vn(L);
    }
    function j(L, se) {
      const Ce = Cs(L);
      if (!Ce || !se) return;
      const We = mi(L), Ie = Ce.map((Ze) => Ze.path).filter((Ze) => Ze && Ze !== se && !se.startsWith(Ze + "/"));
      Ie.length !== 0 && (L.preventDefault(), L.stopPropagation(), a("transfer", { sources: Ie, targetWire: se, originWire: We }));
    }
    function K(L, se) {
      S.value = !1, !(L.type !== "dir" || D(L)) && w(se) && a("item-drop-into", L, se);
    }
    function Z(L) {
      !w(L) || x.value || (L.preventDefault(), L.stopPropagation(), L.dataTransfer && (L.dataTransfer.dropEffect = "move"), S.value = !0);
    }
    function W() {
      S.value = !1;
    }
    function $e(L) {
      S.value = !1, !(!w(L) || x.value) && j(L, M.value);
    }
    function Se() {
      return r.selfDriven ? E() : Promise.resolve();
    }
    function ze() {
      const L = (C.value ?? "").replace(/^\/+|\/+$/g, ""), se = (r.floor || "").replace(/^\/+|\/+$/g, "");
      if (!L || L === se) return;
      const Ce = L.lastIndexOf("/");
      $(Ce === -1 ? "" : L.slice(0, Ce));
    }
    function Ne() {
      return C.value;
    }
    function be() {
      return Y.value.filter((L) => !D(L));
    }
    function De() {
      return B.value.length;
    }
    function ie() {
      return B.value.map((L) => L.path);
    }
    function ce() {
      return r.selfDriven ? A.value : "";
    }
    return t({ reload: Se, goUp: ze, getPath: Ne, visibleNodes: be, loadFolder: E, rowCount: De, rowPaths: ie, dirPerm: ce }), He(C, () => {
      S.value = !1;
    }), (L, se) => (c(), d("section", {
      class: we(["fe__primary fe-pane", {
        "fe-pane--focus": e.focused,
        "fe-pane--split": e.paneId === "split",
        "fe-pane--dropover": S.value
      }]),
      "data-pane": e.paneId,
      "data-testid": `pane-${e.paneId}`,
      role: "region",
      "aria-label": e.paneId === "split" ? s(u)("split.pane") : s(u)("toolbar.view_label"),
      onPointerdownCapture: se[17] || (se[17] = (Ce) => a("activate"))
    }, [
      e.showCrumbs || L.$slots.heading || e.showViewSwitcher || e.closable ? (c(), d("div", PE, [
        _n(L.$slots, "heading", {}, () => [
          e.showCrumbs ? (c(), et(q5, {
            key: 0,
            dirname: M.value,
            adapter: z.value,
            "root-label": e.rootLabel || z.value,
            locale: e.locale,
            "multi-storage-root": e.multiRoot,
            "root-path": e.rootPath,
            subfolders: e.crumbSubfolders ?? N.value,
            onNavigate: T,
            onCopyPath: se[0] || (se[0] = (Ce) => a("copy-path", Ce)),
            onCrumbContext: se[1] || (se[1] = (Ce) => a("crumb-context", Ce)),
            onCrumbDrop: se[2] || (se[2] = (Ce, We) => a("crumb-drop", Ce, We))
          }, null, 8, ["dirname", "adapter", "root-label", "locale", "multi-storage-root", "root-path", "subfolders"])) : g("", !0)
        ]),
        o("div", LE, [
          e.showViewSwitcher ? (c(), et(wM, {
            key: 0,
            "view-mode": e.viewMode,
            locale: e.locale,
            modes: e.viewModes,
            "onUpdate:viewMode": se[3] || (se[3] = (Ce) => {
              a("activate"), a("update:viewMode", Ce);
            })
          }, null, 8, ["view-mode", "locale", "modes"])) : g("", !0),
          e.closable ? (c(), d("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only fe-pane__close",
            title: s(u)("split.close"),
            "aria-label": s(u)("split.close"),
            "data-testid": "pane-close",
            onClick: se[4] || (se[4] = (Ce) => a("close"))
          }, [...se[18] || (se[18] = [
            o("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              o("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, DE)) : g("", !0)
        ])
      ])) : g("", !0),
      se[24] || (se[24] = o("div", { class: "fe-selbar-slot" }, null, -1)),
      e.showFilterBar ? (c(), et(vM, {
        key: 1,
        value: e.filters,
        locale: e.locale,
        theme: e.theme,
        mode: J.value,
        "find-label": G.value,
        order: e.order,
        shown: Y.value.length,
        total: B.value.length,
        files: B.value,
        "can-paste": e.canPaste,
        "can-write": e.canWrite,
        "onUpdate:value": se[5] || (se[5] = (Ce) => {
          a("activate"), a("update:filters", Ce);
        }),
        onNewFolder: se[6] || (se[6] = (Ce) => {
          a("activate"), a("new-folder");
        }),
        onUpload: se[7] || (se[7] = (Ce) => {
          a("activate"), a("upload");
        }),
        onPaste: se[8] || (se[8] = (Ce) => {
          a("activate"), a("paste");
        }),
        onSelectAll: se[9] || (se[9] = (Ce) => {
          a("activate"), a("select-all");
        })
      }, null, 8, ["value", "locale", "theme", "mode", "find-label", "order", "shown", "total", "files", "can-paste", "can-write"])) : g("", !0),
      _n(L.$slots, "banners"),
      o("div", {
        class: we(["fe__body", { "is-dropover": S.value }]),
        onClick: Re(Q, ["self"]),
        onContextmenu: ue,
        onDragover: Z,
        onDragleave: W,
        onDrop: $e
      }, [
        e.bodyOverride ? _n(L.$slots, "body", { key: 0 }) : I.value && B.value.length === 0 ? (c(), d("div", OE, [
          o("span", BE, f(s(u)("loading")), 1),
          e.viewMode !== "list" ? (c(), d("div", IE, [
            (c(), d(ae, null, Te(8, (Ce) => o("div", {
              key: Ce,
              class: "fe-skel-card"
            }, [...se[19] || (se[19] = [
              o("div", { class: "fe-skel fe-skel--thumb" }, null, -1),
              o("div", { class: "fe-skel fe-skel--label" }, null, -1)
            ])])), 64))
          ])) : (c(), d("div", HE, [
            (c(), d(ae, null, Te(8, (Ce) => o("div", {
              key: Ce,
              class: "fe-skel-row"
            }, [...se[20] || (se[20] = [
              o("div", { class: "fe-skel fe-skel--icon" }, null, -1),
              o("div", { class: "fe-skel fe-skel--name" }, null, -1),
              o("div", { class: "fe-skel fe-skel--size" }, null, -1),
              o("div", { class: "fe-skel fe-skel--date" }, null, -1)
            ])])), 64))
          ]))
        ])) : U.value && B.value.length === 0 ? (c(), d("div", FE, [
          se[21] || (se[21] = Hu('<svg class="fe-state__art" viewBox="0 0 120 100" width="110" height="92" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="60" cy="50" r="28"></circle><path d="M60 36v18"></path><circle cx="60" cy="63" r="1.8" fill="currentColor" stroke="none"></circle><path d="M24 88h72" stroke-dasharray="3 5"></path></svg>', 1)),
          o("p", NE, f(s(u)("error.title")), 1),
          o("p", KE, f(s(u)("error.hint")), 1),
          o("div", RE, [
            o("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: se[10] || (se[10] = (Ce) => e.selfDriven ? E() : a("retry"))
            }, f(s(u)("error.retry")), 1)
          ]),
          o("details", UE, [
            o("summary", VE, f(s(u)("error.details")), 1),
            o("pre", jE, f(U.value), 1)
          ])
        ])) : !I.value && O.value && Y.value.length === 0 && B.value.length > 0 ? (c(), d("div", YE, [
          se[22] || (se[22] = o("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "110",
            height: "92",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            o("path", { d: "M26 28h68L68 58v24l-16 8V58z" })
          ], -1)),
          o("p", WE, f(s(u)("filter.empty.title")), 1),
          o("p", qE, f(s(u)("filter.empty.hint")), 1),
          o("div", GE, [
            o("button", {
              type: "button",
              class: "fe-btn",
              onClick: se[11] || (se[11] = (Ce) => a("clear-filters"))
            }, f(s(u)("filter.clear")), 1)
          ])
        ])) : !I.value && B.value.length === 0 ? _n(L.$slots, "empty", { key: 4 }, () => [
          o("div", XE, [
            se[23] || (se[23] = o("svg", {
              class: "fe-state__art",
              viewBox: "0 0 120 100",
              width: "110",
              height: "92",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              o("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" })
            ], -1)),
            o("p", JE, f(s(u)("empty.folder")), 1)
          ])
        ]) : e.viewMode === "list" ? (c(), et(vE, {
          key: 5,
          files: Y.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: I.value,
          "folder-key": e.folderKey,
          theme: e.theme,
          "thumb-src": e.thumbSrc,
          "keep-badge-for": e.keepBadgeFor,
          "starred-ids": e.starredIds,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickRow: ve,
          onDisplayOrder: se[12] || (se[12] = (Ce) => a("display-order", Ce)),
          onDblRow: he,
          onContextRow: oe,
          onItemDragStart: re,
          onItemDropInto: K,
          onStarChange: se[13] || (se[13] = (Ce, We) => a("star-change", Ce, We))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "folder-key", "theme", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : e.viewMode === "grid" ? (c(), et(bi, {
          key: 6,
          files: Y.value,
          order: e.order,
          sections: !0,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: I.value,
          "keep-badge-for": e.keepBadgeFor,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": e.starredIds,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: ve,
          onDisplayOrder: se[14] || (se[14] = (Ce) => a("display-order", Ce)),
          onDblCard: he,
          onContextCard: oe,
          onItemDragStart: re,
          onItemDropInto: K,
          onStarChange: se[15] || (se[15] = (Ce, We) => a("star-change", Ce, We))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "keep-badge-for", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : (c(), et(zE, {
          key: 7,
          files: Y.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: I.value,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": e.starredIds,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: ve,
          onDblCard: he,
          onContextCard: oe,
          onItemDragStart: re,
          onItemDropInto: K,
          onStarChange: se[16] || (se[16] = (Ce, We) => a("star-change", Ce, We))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"]))
      ], 34)
    ], 42, AE));
  }
});
function ti() {
  try {
    return crypto.randomUUID();
  } catch {
    return `t${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
  }
}
function t8(e) {
  const t = m([]), n = m(""), r = k(
    () => t.value.find((U) => U.id === n.value) ?? null
  ), a = k(() => t.value.findIndex((U) => U.id === n.value)), u = k(() => t.value.length > 1);
  function v() {
    if (!e.storageKey) return !1;
    try {
      const U = localStorage.getItem(e.storageKey);
      if (!U) return !1;
      const x = JSON.parse(U);
      if (!x || !Array.isArray(x.tabs) || x.tabs.length === 0) return !1;
      const E = [];
      for (const $ of x.tabs) {
        if (!$ || typeof $.path != "string") continue;
        const M = typeof $.viewMode == "string" && $.viewMode ? $.viewMode : "list", z = $.split, T = z && typeof z == "object" && typeof z.path == "string" ? {
          path: z.path,
          viewMode: typeof z.viewMode == "string" && z.viewMode ? z.viewMode : void 0
        } : null;
        E.push({
          id: typeof $.id == "string" && $.id ? $.id : ti(),
          path: $.path,
          viewMode: M,
          split: T
        });
      }
      return E.length === 0 ? !1 : (t.value = E, n.value = E.some(($) => $.id === x.active) ? String(x.active) : E[0].id, !0);
    } catch {
      return !1;
    }
  }
  function p() {
    if (e.storageKey)
      try {
        localStorage.setItem(
          e.storageKey,
          JSON.stringify({ v: 1, active: n.value, tabs: t.value })
        );
      } catch {
      }
  }
  He([t, n], p, { deep: !0 });
  function h(U, x) {
    if (t.value.length > 0) return;
    const E = { id: ti(), path: U, viewMode: x, split: null };
    t.value = [E], n.value = E.id;
  }
  function b(U) {
    const x = r.value;
    x && (U.path !== void 0 && (x.path = U.path), U.viewMode !== void 0 && (x.viewMode = U.viewMode));
  }
  function y(U, x) {
    const E = { id: ti(), path: U, viewMode: x.viewMode, split: x.split ?? null }, $ = a.value;
    return t.value.splice($ === -1 ? t.value.length : $ + 1, 0, E), x.background || (n.value = E.id), E;
  }
  function A(U) {
    if (t.value.length <= 1) return null;
    const x = t.value.findIndex((M) => M.id === U);
    if (x === -1) return null;
    const E = t.value[x].id === n.value;
    if (t.value.splice(x, 1), !E) return null;
    const $ = t.value[Math.min(x, t.value.length - 1)];
    return n.value = $.id, $;
  }
  function D(U) {
    const x = t.value.find((E) => E.id === U);
    return !x || x.id === n.value ? null : (n.value = x.id, x);
  }
  function C(U) {
    if (t.value.length < 2) return null;
    const x = a.value === -1 ? 0 : a.value, E = t.value[(x + U + t.value.length) % t.value.length];
    return D(E.id);
  }
  function B(U, x) {
    if (U === x || U < 0 || x < 0 || U >= t.value.length || x >= t.value.length) return;
    const E = [...t.value], [$] = E.splice(U, 1);
    E.splice(x, 0, $), t.value = E;
  }
  function I(U) {
    const x = r.value;
    x && (x.split = U);
  }
  return {
    tabs: t,
    activeId: n,
    activeTab: r,
    activeIndex: a,
    hasMultiple: u,
    restore: v,
    seed: h,
    syncActive: b,
    openTab: y,
    closeTab: A,
    activate: D,
    step: C,
    move: B,
    setSplit: I
  };
}
const n8 = { class: "fe-field" }, a8 = { class: "fe-field__label" }, o8 = ["disabled"], s8 = { class: "fe-field" }, r8 = { class: "fe-field__label" }, i8 = ["placeholder", "disabled"], l8 = { class: "fe-field" }, c8 = { class: "fe-field__label" }, u8 = ["disabled", "onKeydown"], d8 = {
  class: "fe-e2e-warn",
  role: "alert"
}, f8 = {
  key: 0,
  class: "fe-e2e-rk__escrow",
  role: "note"
}, p8 = { class: "fe-e2e-ack" }, v8 = ["disabled"], h8 = {
  key: 1,
  class: "fe-form__error"
}, m8 = ["disabled"], y8 = ["disabled"], b8 = /* @__PURE__ */ qe({
  __name: "EncryptedFolderModal",
  props: {
    open: { type: Boolean },
    locale: {},
    busy: { type: Boolean },
    escrowKid: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = m(""), v = m(""), p = m(""), h = m(!1), b = m(null);
    He(
      () => n.open,
      (A) => {
        A && (u.value = "", v.value = "", p.value = "", h.value = !1, b.value = null);
      }
    );
    function y() {
      if (n.busy) return;
      const A = u.value.trim();
      if (!A) {
        b.value = a("modal.newfolder.placeholder");
        return;
      }
      if (/[\\/]/.test(A) || A === "." || A === ".." || A.startsWith(".filex")) {
        b.value = a("e2e.create.bad_name");
        return;
      }
      if (v.value.length < Xm) {
        b.value = a("e2e.create.pw_short");
        return;
      }
      if (v.value !== p.value) {
        b.value = a("e2e.create.pw_mismatch");
        return;
      }
      if (!h.value) {
        b.value = a("e2e.create.ack_required");
        return;
      }
      b.value = null, r("submit", { name: A, password: v.value });
    }
    return (A, D) => (c(), et(an, {
      open: e.open,
      title: s(a)("e2e.create.title"),
      size: "sm",
      onClose: D[5] || (D[5] = (C) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: D[4] || (D[4] = (C) => r("close"))
        }, f(s(a)("modal.newfolder.cancel")), 9, m8),
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          onClick: y
        }, f(e.busy ? s(a)("e2e.create.busy") : s(a)("e2e.create.create")), 9, y8)
      ]),
      default: st(() => [
        o("form", {
          class: "fe-e2e-form",
          onSubmit: Re(y, ["prevent"])
        }, [
          o("label", n8, [
            o("span", a8, f(s(a)("modal.newfolder.placeholder")), 1),
            Ve(o("input", {
              "onUpdate:modelValue": D[0] || (D[0] = (C) => u.value = C),
              type: "text",
              class: "fe-input",
              autocomplete: "off",
              disabled: e.busy
            }, null, 8, o8), [
              [rt, u.value]
            ])
          ]),
          o("label", s8, [
            o("span", r8, f(s(a)("e2e.create.pw_label")), 1),
            Ve(o("input", {
              "onUpdate:modelValue": D[1] || (D[1] = (C) => v.value = C),
              type: "password",
              class: "fe-input",
              placeholder: s(a)("e2e.create.pw_placeholder"),
              autocomplete: "new-password",
              disabled: e.busy
            }, null, 8, i8), [
              [rt, v.value]
            ])
          ]),
          o("label", l8, [
            o("span", c8, f(s(a)("e2e.create.pw2_label")), 1),
            Ve(o("input", {
              "onUpdate:modelValue": D[2] || (D[2] = (C) => p.value = C),
              type: "password",
              class: "fe-input",
              autocomplete: "new-password",
              disabled: e.busy,
              onKeydown: Ut(Re(y, ["prevent"]), ["enter"])
            }, null, 40, u8), [
              [rt, p.value]
            ])
          ]),
          o("div", d8, [
            o("strong", null, f(s(a)("e2e.create.warn_title")), 1),
            o("p", null, f(s(a)("e2e.create.warn_body")), 1)
          ]),
          e.escrowKid ? (c(), d("div", f8, [
            o("strong", null, f(s(a)("e2e.create.escrow_title")), 1),
            o("p", null, f(s(a)("e2e.create.escrow_body")), 1)
          ])) : g("", !0),
          o("label", p8, [
            Ve(o("input", {
              "onUpdate:modelValue": D[3] || (D[3] = (C) => h.value = C),
              type: "checkbox",
              disabled: e.busy
            }, null, 8, v8), [
              [An, h.value]
            ]),
            o("span", null, f(s(a)("e2e.create.ack")), 1)
          ]),
          b.value ? (c(), d("p", h8, f(b.value), 1)) : g("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), g8 = { class: "fe-e2e-rk" }, k8 = { class: "fe-e2e-rk__lead" }, _8 = {
  class: "fe-e2e-rk__key",
  "aria-label": "recovery key"
}, w8 = { class: "fe-e2e-rk__actions" }, $8 = {
  class: "fe-e2e-warn",
  role: "alert"
}, x8 = {
  key: 0,
  class: "fe-e2e-rk__escrow",
  role: "note"
}, S8 = { class: "fe-e2e-rk__kid" }, C8 = { class: "fe-e2e-ack" }, T8 = ["disabled"], M8 = /* @__PURE__ */ qe({
  __name: "RecoveryKeyModal",
  props: {
    open: { type: Boolean },
    locale: {},
    recoveryKey: {},
    folderName: {},
    escrowKid: {},
    variant: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = m(!1), v = m(!1);
    He(
      () => n.open,
      (A) => {
        A && (u.value = !1, v.value = !1);
      }
    );
    const p = k(
      () => n.variant === "upgraded" ? a("e2e.recovery.title_upgraded") : a("e2e.recovery.title")
    );
    async function h() {
      try {
        await navigator.clipboard.writeText(n.recoveryKey), v.value = !0, window.setTimeout(() => v.value = !1, 2e3);
      } catch {
        v.value = !1;
      }
    }
    function b() {
      const A = n.folderName || "folder", D = `filex recovery key
folder: ${A}

${n.recoveryKey}

This key opens the encrypted folder without its password.
Anyone holding it can read the folder. Store it like a password.
filex does not keep a copy and cannot show it again.
`, C = URL.createObjectURL(new Blob([D], { type: "text/plain" })), B = document.createElement("a");
      B.href = C, B.download = `filex-recovery-${A}.txt`, document.body.appendChild(B), B.click(), B.remove(), window.setTimeout(() => URL.revokeObjectURL(C), 3e4);
    }
    function y() {
      u.value && r("close");
    }
    return (A, D) => (c(), et(an, {
      open: e.open,
      title: p.value,
      size: "sm",
      "close-on-backdrop": !1,
      onClose: y
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !u.value,
          onClick: y
        }, f(s(a)("e2e.recovery.done")), 9, T8)
      ]),
      default: st(() => [
        o("div", g8, [
          o("p", k8, f(e.variant === "upgraded" ? s(a)("e2e.recovery.lead_upgraded") : s(a)("e2e.recovery.lead")), 1),
          o("output", _8, f(e.recoveryKey), 1),
          o("div", w8, [
            o("button", {
              type: "button",
              class: "fe-btn",
              onClick: h
            }, f(v.value ? s(a)("e2e.recovery.copied") : s(a)("e2e.recovery.copy")), 1),
            o("button", {
              type: "button",
              class: "fe-btn",
              onClick: b
            }, f(s(a)("e2e.recovery.download")), 1)
          ]),
          o("div", $8, [
            o("strong", null, f(s(a)("e2e.recovery.warn_title")), 1),
            o("p", null, f(s(a)("e2e.recovery.warn_body")), 1)
          ]),
          e.escrowKid ? (c(), d("div", x8, [
            o("strong", null, f(s(a)("e2e.recovery.escrow_title")), 1),
            o("p", null, f(s(a)("e2e.recovery.escrow_body")), 1),
            o("p", S8, [
              Je(f(s(a)("e2e.recovery.escrow_kid")) + ": ", 1),
              o("code", null, f(e.escrowKid), 1)
            ])
          ])) : g("", !0),
          o("label", C8, [
            Ve(o("input", {
              "onUpdate:modelValue": D[0] || (D[0] = (C) => u.value = C),
              type: "checkbox"
            }, null, 512), [
              [An, u.value]
            ]),
            o("span", null, f(s(a)("e2e.recovery.ack")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), E8 = { class: "fe-e2e-recover" }, z8 = {
  key: 0,
  class: "fe-e2e-recover__none"
}, A8 = {
  key: 0,
  class: "fe-e2e-recover__tabs",
  role: "tablist"
}, P8 = ["aria-selected"], L8 = ["aria-selected"], D8 = { class: "fe-e2e-recover__hint" }, O8 = ["placeholder", "disabled"], B8 = {
  class: "fe-e2e-warn",
  role: "alert"
}, I8 = {
  key: 0,
  class: "fe-e2e-recover__hint"
}, H8 = ["placeholder", "disabled"], F8 = {
  key: 2,
  class: "fe-e2e-recover__note"
}, N8 = {
  key: 3,
  class: "fe-form__error"
}, K8 = ["disabled"], R8 = ["disabled"], U8 = /* @__PURE__ */ qe({
  __name: "E2eRecoveryUnlockModal",
  props: {
    open: { type: Boolean },
    locale: {},
    hasRecovery: { type: Boolean },
    escrowState: {},
    escrowKid: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = k(() => n.escrowState === "available"), v = k(() => n.escrowState === "predates" ? a("e2e.recover.escrow_predates") : n.escrowState === "other-key" ? a("e2e.recover.escrow_other_key") : null), p = m("recovery"), h = m(""), b = m(""), y = m(null);
    He(
      () => n.open,
      (B) => {
        B && (p.value = n.hasRecovery ? "recovery" : "escrow", h.value = "", b.value = "", y.value = null);
      }
    );
    const A = k(() => !n.hasRecovery && !u.value), D = k(() => y.value || n.error || null);
    function C() {
      if (!(n.busy || A.value)) {
        if (y.value = null, p.value === "recovery") {
          if (!Di(h.value)) {
            y.value = a("e2e.recover.bad_format");
            return;
          }
          r("submit", { mode: "recovery", value: h.value });
          return;
        }
        if (!b.value.trim()) {
          y.value = a("e2e.recover.escrow_required");
          return;
        }
        r("submit", { mode: "escrow", value: b.value });
      }
    }
    return (B, I) => (c(), et(an, {
      open: e.open,
      title: s(a)("e2e.recover.title"),
      size: "sm",
      onClose: I[5] || (I[5] = (U) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: I[4] || (I[4] = (U) => r("close"))
        }, f(s(a)("modal.newfolder.cancel")), 9, K8),
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || A.value,
          onClick: C
        }, f(e.busy ? s(a)("e2e.recover.busy") : s(a)("e2e.recover.unlock")), 9, R8)
      ]),
      default: st(() => [
        o("div", E8, [
          A.value ? (c(), d("p", z8, f(s(a)("e2e.recover.none")), 1)) : (c(), d(ae, { key: 1 }, [
            e.hasRecovery && u.value ? (c(), d("div", A8, [
              o("button", {
                type: "button",
                role: "tab",
                class: we(["fe-e2e-recover__tab", { "fe-e2e-recover__tab--on": p.value === "recovery" }]),
                "aria-selected": p.value === "recovery",
                onClick: I[0] || (I[0] = (U) => p.value = "recovery")
              }, f(s(a)("e2e.recover.tab_recovery")), 11, P8),
              o("button", {
                type: "button",
                role: "tab",
                class: we(["fe-e2e-recover__tab", { "fe-e2e-recover__tab--on": p.value === "escrow" }]),
                "aria-selected": p.value === "escrow",
                onClick: I[1] || (I[1] = (U) => p.value = "escrow")
              }, f(s(a)("e2e.recover.tab_escrow")), 11, L8)
            ])) : g("", !0),
            p.value === "recovery" ? (c(), d("form", {
              key: 1,
              class: "fe-e2e-form",
              onSubmit: Re(C, ["prevent"])
            }, [
              o("p", D8, f(s(a)("e2e.recover.recovery_hint")), 1),
              Ve(o("input", {
                "onUpdate:modelValue": I[2] || (I[2] = (U) => h.value = U),
                type: "text",
                class: "fe-input fe-e2e-recover__key",
                placeholder: s(a)("e2e.recover.recovery_placeholder"),
                autocomplete: "off",
                spellcheck: "false",
                disabled: e.busy
              }, null, 8, O8), [
                [rt, h.value]
              ])
            ], 32)) : (c(), d("form", {
              key: 2,
              class: "fe-e2e-form",
              onSubmit: Re(C, ["prevent"])
            }, [
              o("div", B8, [
                o("strong", null, f(s(a)("e2e.recover.escrow_warn_title")), 1),
                o("p", null, f(s(a)("e2e.recover.escrow_warn_body")), 1)
              ]),
              e.escrowKid ? (c(), d("p", I8, [
                Je(f(s(a)("e2e.recover.escrow_kid")) + ": ", 1),
                o("code", null, f(e.escrowKid), 1)
              ])) : g("", !0),
              Ve(o("textarea", {
                "onUpdate:modelValue": I[3] || (I[3] = (U) => b.value = U),
                class: "fe-input fe-e2e-recover__escrow",
                rows: "5",
                placeholder: s(a)("e2e.recover.escrow_placeholder"),
                autocomplete: "off",
                spellcheck: "false",
                disabled: e.busy
              }, null, 8, H8), [
                [rt, b.value]
              ])
            ], 32))
          ], 64)),
          v.value ? (c(), d("p", F8, f(v.value), 1)) : g("", !0),
          D.value ? (c(), d("p", N8, f(D.value), 1)) : g("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), V8 = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function Eu(e) {
  if (typeof e != "string" || !e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function j8(e, t) {
  var D;
  const n = String((e == null ? void 0 : e.path) ?? "").replace(/^\/+/, "");
  if (!n) return null;
  const r = t.storages ?? [], a = typeof e.storage == "string" && e.storage ? e.storage : r.length === 1 ? r[0].name : "";
  if (t.multiStorageRoot && !a) return null;
  const u = String(e.name ?? n.split("/").pop() ?? ""), v = e.type === "dir", p = typeof e.size == "number" ? e.size : 0, h = typeof e.id == "number" ? e.id : void 0, b = typeof e.perm == "string" && V8.has(e.perm) ? e.perm : void 0, y = ((D = r.find((C) => C.name === a)) == null ? void 0 : D.readOnly) === !0, A = typeof e.read_only == "boolean" ? e.read_only : y;
  return {
    type: v ? "dir" : "file",
    id: h,
    /* tablo:t1 — ⚠⚠ THE DATE. A node row carries `backend_mtime` (what the
       storage says) and `db_mtime` (what our last scan recorded) as RFC3339
       strings; `FileNode.last_modified` is unix MILLISECONDS. Nothing mapped
       between the two, so every row from Recent, Starred and a tag view
       arrived with no date at all — measured on Recent: eleven rows, eleven em
       dashes in the Modified column, and a Modified column header you could
       click that then sorted nothing. It also made the date grouping this view
       is supposed to show impossible, because every row fell in the "No date"
       bucket. Storage first: `backend_mtime` is the file's own truth and
       `db_mtime` only says when we last looked at it. */
    last_modified: Eu(e.backend_mtime) ?? Eu(e.db_mtime),
    path: a ? `${a}://${n}` : n,
    basename: u,
    extension: v ? "" : u.includes(".") ? (u.split(".").pop() || "").toLowerCase() : "",
    storage: a,
    visibility: "private",
    size: p,
    file_size: p,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    ...b ? { perm: b } : {},
    read_only: A,
    // Keyed by node id. A file with no rendered thumbnail 404s here and the
    // view falls back to its icon — the contract the ordinary listing has too.
    thumb_url: !v && h !== void 0 ? `/api/files/thumb/${h}` : void 0,
    extra_metadata: {}
  };
}
const Y8 = 6e4, gi = /* @__PURE__ */ new Map(), Ts = /* @__PURE__ */ new Map();
function W8() {
  gi.clear(), Ts.clear();
}
async function q8(e = {}) {
  const t = e.apiBase ?? "", n = t || "(same-origin)";
  if (!e.force) {
    const a = gi.get(n);
    if (a && Date.now() - a.at < Y8) return a.tags;
    const u = Ts.get(n);
    if (u) return u;
  }
  const r = (async () => {
    try {
      const a = await fetch(`${t}/api/files/manager/tags/all`, {
        headers: await (e.authHeaders ?? (() => ({})))(),
        credentials: e.authCredentials ?? "same-origin"
      });
      if (!a.ok) return [];
      const u = await a.json(), v = Array.isArray(u == null ? void 0 : u.tags) ? u.tags.filter((p) => typeof p == "string" && p !== "") : [];
      return gi.set(n, { at: Date.now(), tags: v }), v;
    } catch {
      return [];
    } finally {
      Ts.delete(n);
    }
  })();
  return Ts.set(n, r), r;
}
async function G8(e, t = {}, n = 200) {
  const r = t.apiBase ?? "", a = await fetch(
    `${r}/api/files/manager/tagged?tag=${encodeURIComponent(e)}&limit=${n}`,
    {
      headers: await (t.authHeaders ?? (() => ({})))(),
      credentials: t.authCredentials ?? "same-origin"
    }
  );
  if (!a.ok) throw new Error(String(a.status));
  const u = await a.json();
  return Array.isArray(u == null ? void 0 : u.nodes) ? u.nodes : [];
}
function zu(e) {
  const t = String(e ?? "").indexOf("://");
  return t === -1 ? "" : e.slice(0, t);
}
function Au(e, t, n = "auto") {
  const r = zu(t), a = e.some((u) => {
    const v = zu(u);
    return v !== "" && r !== "" && v !== r;
  });
  return n === "copy" ? { kind: "copy", cross: a } : n === "move" ? { kind: "move", cross: a } : { kind: a ? "copy" : "move", cross: a };
}
function X8(e) {
  return e.split("?")[0].replace(/\/manager$/, "/archive/download");
}
function J8(e, t) {
  if (/^https?:\/\//i.test(t)) return t;
  const n = e.split("?")[0], r = /^(https?:\/\/[^/]+)/i.exec(n);
  return r ? r[1] + t : t;
}
async function Z8(e, t, n) {
  const r = X8(e.endpoints.manager);
  return e.jsonFetch(r, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(n ? { paths: t, name: n } : { paths: t })
  });
}
const Q8 = 6e4;
function ez(e, t = document) {
  const n = t.createElement("iframe");
  n.hidden = !0, n.setAttribute("aria-hidden", "true"), n.style.display = "none", n.src = e, t.body.appendChild(n), setTimeout(() => n.remove(), Q8);
}
async function tz(e, t, n = {}) {
  const r = await Z8(e, t, n.name);
  return ez(
    J8(e.endpoints.manager, r.url),
    n.doc ?? document
  ), r;
}
const Wt = "@@drives";
function _a(e) {
  const t = e.indexOf("://");
  return t < 0 ? ["", ki(e)] : [e.slice(0, t), ki(e.slice(t + 3))];
}
function Va(e, t) {
  const n = ki(t);
  return n ? `${e}://${n}` : `${e}://`;
}
function ki(e) {
  return e.replace(/^\/+|\/+$/g, "");
}
function nz(e, t) {
  if (e === Wt) return null;
  const [n, r] = _a(e);
  if (!n) return null;
  if (!r) return t ? Wt : null;
  const a = r.split("/");
  return a.pop(), Va(n, a.join("/"));
}
function _i(e, t) {
  if (e === Wt) return t;
  const [n, r] = _a(e);
  if (!r) return n || t;
  const a = r.split("/");
  return a[a.length - 1] || n;
}
function Kd(e) {
  if (e === Wt || !e) return [];
  const [t, n] = _a(e);
  if (!t) return [];
  const r = [{ label: t, path: Va(t, "") }];
  if (!n) return r;
  let a = "";
  for (const u of n.split("/"))
    a = a ? `${a}/${u}` : u, r.push({ label: u, path: Va(t, a) });
  return r;
}
function al(e) {
  return e == null || e === "" || e === "editor" || e === "owner";
}
function az(e, t) {
  if (e === Wt || t === Wt) return !1;
  const [n, r] = _a(e), [a, u] = _a(t);
  return n !== a ? !1 : u === "" ? !0 : r === u || r.startsWith(u + "/");
}
function ol(e, t) {
  if (!t || t.length === 0 || e === Wt) return null;
  const n = (a) => {
    const [u, v] = _a(a);
    return Va(u, v);
  }, r = n(e);
  for (const a of t)
    if (a) {
      if (r === n(a)) return "self";
      if (az(e, a)) return "descendant";
    }
  return null;
}
function oz(e, t) {
  const n = [];
  for (const r of e ?? [])
    r.type === "dir" && n.push({
      path: r.path,
      label: r.basename,
      writable: al(r.perm),
      blocked: ol(r.path, t)
    });
  return n;
}
function sz(e, t) {
  return (e ?? []).map((n) => {
    const r = Va(n, "");
    return {
      path: r,
      label: n,
      // A storage root's own writability is not knowable from the drive list;
      // it is answered by the listing when the user opens it. Offering it as
      // writable here and letting the listing correct that is the honest
      // order — the alternative greys out every drive until each is opened.
      writable: !0,
      blocked: ol(r, t)
    };
  });
}
function rz(e, t) {
  const n = ((t == null ? void 0 : t.length) ?? 0) > 1;
  if (e && e.includes("://")) return e;
  if (n) return Wt;
  const r = t == null ? void 0 : t[0];
  return r ? Va(r, "") : Wt;
}
const iz = { class: "fe-field" }, lz = { class: "fe-field__label" }, cz = ["onKeydown"], uz = {
  key: 0,
  class: "fe-form__error"
}, dz = ["innerHTML"], fz = /* @__PURE__ */ qe({
  __name: "NewFolderModal",
  props: {
    open: { type: Boolean },
    locale: {},
    encryptedOption: { type: Boolean }
  },
  emits: ["close", "submit", "encrypted"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = m(""), v = m(null);
    He(() => n.open, (h) => {
      h && (u.value = "", v.value = null);
    });
    function p() {
      const h = u.value.trim();
      if (!h) {
        v.value = a("modal.newfolder.placeholder");
        return;
      }
      if (/[\\/]/.test(h) || h === "." || h === "..") {
        v.value = a("modal.newfolder.invalid");
        return;
      }
      r("submit", h);
    }
    return (h, b) => (c(), et(an, {
      open: e.open,
      title: s(a)("modal.newfolder.title"),
      size: "sm",
      onClose: b[3] || (b[3] = (y) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn",
          onClick: b[2] || (b[2] = (y) => r("close"))
        }, f(s(a)("modal.newfolder.cancel")), 1),
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: p
        }, f(s(a)("modal.newfolder.create")), 1)
      ]),
      default: st(() => [
        o("form", {
          onSubmit: Re(p, ["prevent"])
        }, [
          o("label", iz, [
            o("span", lz, f(s(a)("modal.newfolder.placeholder")), 1),
            Ve(o("input", {
              "onUpdate:modelValue": b[0] || (b[0] = (y) => u.value = y),
              type: "text",
              class: "fe-input",
              autocomplete: "off",
              onKeydown: Ut(Re(p, ["prevent"]), ["enter"])
            }, null, 40, cz), [
              [rt, u.value]
            ])
          ]),
          v.value ? (c(), d("p", uz, f(v.value), 1)) : g("", !0),
          e.encryptedOption !== !1 ? (c(), d("button", {
            key: 1,
            type: "button",
            class: "fe-e2e-optlink",
            onClick: b[1] || (b[1] = (y) => r("encrypted"))
          }, [
            o("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("lock")
            }, null, 8, dz),
            Je(" " + f(s(a)("e2e.create.option")), 1)
          ])) : g("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), pz = {
  class: "fe-destpick",
  "data-testid": "destpicker"
}, vz = { class: "fe-destpick__bar" }, hz = ["disabled", "title", "aria-label"], mz = ["aria-label"], yz = ["onClick"], bz = {
  key: 1,
  class: "fe-destpick__crumb is-current"
}, gz = {
  class: "fe-destpick__rows",
  "data-testid": "destpicker-rows"
}, kz = {
  key: 0,
  class: "fe-destpick__note"
}, _z = {
  key: 1,
  class: "fe-destpick__note"
}, wz = {
  key: 2,
  class: "fe-destpick__note"
}, $z = ["disabled", "title", "data-testid", "onClick"], xz = ["innerHTML"], Sz = { class: "fe-destpick__rowname" }, Cz = {
  key: 0,
  class: "fe-destpick__rowtag"
}, Tz = {
  key: 1,
  class: "fe-destpick__rowtag"
}, Mz = {
  key: 1,
  class: "fe-destpick__target",
  "data-testid": "destpicker-target"
}, Ez = ["disabled"], Rd = /* @__PURE__ */ qe({
  __name: "DestinationPickerModal",
  props: {
    open: { type: Boolean },
    api: {},
    locale: {},
    storages: {},
    startAt: {},
    moving: {},
    mode: {},
    busy: { type: Boolean }
  },
  emits: ["close", "pick"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = m(Wt), v = m([]), p = m(!1), h = m(void 0), b = m(!1), y = k(() => {
      var N;
      return (((N = n.storages) == null ? void 0 : N.length) ?? 0) > 1;
    });
    let A = /* @__PURE__ */ new Map();
    He(
      () => n.open,
      (N) => {
        N && (A = /* @__PURE__ */ new Map(), C(rz(n.startAt, n.storages)));
      },
      { immediate: !0 }
    );
    async function D(N) {
      const P = A.get(N);
      if (P) return P;
      try {
        const le = await n.api.index(N);
        return A.set(N, le), le;
      } catch {
        return;
      }
    }
    async function C(N) {
      if (u.value = N, b.value = !1, N === Wt) {
        h.value = void 0, v.value = sz(n.storages, n.moving);
        return;
      }
      p.value = !0;
      const P = await D(N);
      u.value === N && (p.value = !1, h.value = P, b.value = !P, v.value = oz(P == null ? void 0 : P.files, n.moving));
    }
    const B = k(() => nz(u.value, y.value)), I = k(() => Kd(u.value)), U = k(() => ol(u.value, n.moving)), x = k(() => u.value === Wt || !h.value || h.value.read_only ? !1 : al(h.value.perm)), E = k(
      () => !n.busy && u.value !== Wt && x.value && U.value === null
    ), $ = k(() => u.value !== Wt), M = k(() => u.value === Wt ? a("destpicker.pick_a_drive") : U.value === "self" ? a("destpicker.blocked.self") : U.value === "descendant" ? a("destpicker.blocked.descendant") : b.value ? a("destpicker.unreadable") : h.value && !x.value ? a("destpicker.readonly_here") : ""), z = k(() => n.mode === "move" ? a("destpicker.title.move") : n.mode === "copy" ? a("destpicker.title.copy") : a("destpicker.title.choose")), T = k(() => n.mode === "move" ? a("destpicker.confirm.move") : n.mode === "copy" ? a("destpicker.confirm.copy") : a("destpicker.confirm.choose"));
    function Y(N) {
      return N.blocked === "self" ? a("destpicker.blocked.self") : N.blocked === "descendant" ? a("destpicker.blocked.descendant") : N.writable ? N.label : a("destpicker.readonly");
    }
    function O(N) {
      N.blocked || C(N.path);
    }
    function J() {
      E.value && r("pick", u.value);
    }
    const G = k(() => a("destpicker.drives"));
    return (N, P) => (c(), et(an, {
      open: e.open,
      title: z.value,
      size: "md",
      onClose: P[3] || (P[3] = (le) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn",
          onClick: P[2] || (P[2] = (le) => r("close"))
        }, f(s(a)("destpicker.cancel")), 1),
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !E.value,
          "data-testid": "destpicker-confirm",
          onClick: J
        }, f(T.value), 9, Ez)
      ]),
      default: st(() => [
        o("div", pz, [
          o("div", vz, [
            o("button", {
              type: "button",
              class: "fe-destpick__up",
              disabled: !B.value,
              title: s(a)("destpicker.up"),
              "aria-label": s(a)("destpicker.up"),
              "data-testid": "destpicker-up",
              onClick: P[0] || (P[0] = (le) => C(B.value))
            }, [...P[4] || (P[4] = [
              o("svg", {
                class: "fe-ficon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                o("path", { d: "M12 19V5M5 12l7-7 7 7" })
              ], -1)
            ])], 8, hz),
            o("nav", {
              class: "fe-destpick__crumbs",
              "aria-label": s(a)("destpicker.crumbs")
            }, [
              y.value ? (c(), d("button", {
                key: 0,
                type: "button",
                class: we(["fe-destpick__crumb", { "is-current": u.value === s(Wt) }]),
                onClick: P[1] || (P[1] = (le) => C(s(Wt)))
              }, f(G.value), 3)) : g("", !0),
              (c(!0), d(ae, null, Te(I.value, (le) => (c(), d(ae, {
                key: le.path
              }, [
                P[5] || (P[5] = o("span", {
                  class: "fe-destpick__sep",
                  "aria-hidden": "true"
                }, "/", -1)),
                o("button", {
                  type: "button",
                  class: we(["fe-destpick__crumb", { "is-current": le.path === u.value }]),
                  onClick: (ve) => C(le.path)
                }, f(le.label), 11, yz)
              ], 64))), 128)),
              !y.value && !I.value.length ? (c(), d("span", bz, f(s(_i)(u.value, G.value)), 1)) : g("", !0)
            ], 8, mz)
          ]),
          o("ul", gz, [
            p.value ? (c(), d("li", kz, f(s(a)("destpicker.loading")), 1)) : b.value ? (c(), d("li", _z, f(s(a)("destpicker.unreadable")), 1)) : v.value.length ? g("", !0) : (c(), d("li", wz, f(s(a)("destpicker.empty")), 1)),
            (c(!0), d(ae, null, Te(v.value, (le) => (c(), d("li", {
              key: le.path
            }, [
              o("button", {
                type: "button",
                class: we(["fe-destpick__row", { "is-locked": !le.writable, "is-blocked": !!le.blocked }]),
                disabled: !!le.blocked,
                title: Y(le),
                "data-testid": "destpicker-row-" + le.label,
                onClick: (ve) => O(le)
              }, [
                o("span", {
                  class: "fe-destpick__rowicon",
                  "aria-hidden": "true",
                  innerHTML: s(Li)("folder")
                }, null, 8, xz),
                o("span", Sz, f(le.label), 1),
                le.blocked ? (c(), d("span", Cz, f(s(a)("destpicker.tag.blocked")), 1)) : le.writable ? g("", !0) : (c(), d("span", Tz, f(s(a)("destpicker.readonly")), 1)),
                P[6] || (P[6] = o("svg", {
                  class: "fe-destpick__rowinto",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  o("path", { d: "M9 5l7 7-7 7" })
                ], -1))
              ], 10, $z)
            ]))), 128))
          ]),
          M.value ? (c(), d("p", {
            key: 0,
            class: we(["fe-destpick__reason", { "is-hint": !$.value }]),
            "data-testid": "destpicker-reason"
          }, f(M.value), 3)) : (c(), d("p", Mz, f(s(a)("destpicker.target", { name: s(_i)(u.value, G.value) })), 1))
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), zz = {
  class: "fe-newdoc",
  "data-testid": "newdoc-modal"
}, Az = {
  key: 0,
  class: "fe-newdoc__empty",
  "data-testid": "newdoc-empty"
}, Pz = { class: "fe-newdoc__empty-title" }, Lz = { class: "fe-newdoc__empty-body" }, Dz = ["aria-label"], Oz = { class: "fe-newdoc__grouplabel" }, Bz = { class: "fe-newdoc__grid" }, Iz = ["aria-checked", "tabindex", "data-newdoc-ext", "data-testid", "onClick", "onKeydown"], Hz = ["innerHTML"], Fz = { class: "fe-newdoc__ext" }, Nz = { class: "fe-newdoc__kind" }, Kz = {
  key: 0,
  class: "fe-newdoc__withheld",
  "data-testid": "newdoc-withheld"
}, Rz = { class: "fe-newdoc__field" }, Uz = {
  class: "fe-newdoc__label",
  for: "fe-newdoc-name"
}, Vz = { class: "fe-newdoc__nameline" }, jz = ["placeholder", "onKeydown"], Yz = {
  key: 0,
  class: "fe-newdoc__suffix"
}, Wz = {
  key: 0,
  class: "fe-form__error"
}, qz = {
  key: 1,
  class: "fe-form__error",
  "data-testid": "newdoc-collision"
}, Gz = { class: "fe-newdoc__field" }, Xz = { class: "fe-newdoc__label" }, Jz = { class: "fe-newdoc__dest" }, Zz = {
  class: "fe-newdoc__destpath",
  "data-testid": "newdoc-dest"
}, Qz = {
  key: 0,
  class: "fe-form__error",
  "data-testid": "newdoc-noaccess"
}, e6 = {
  key: 0,
  class: "fe-form__error",
  "data-testid": "newdoc-failure"
}, t6 = ["disabled"], n6 = /* @__PURE__ */ qe({
  __name: "NewDocumentModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    api: {},
    types: {},
    currentPath: {},
    storages: {},
    onlyOfficeReady: { type: Boolean },
    drawioReady: { type: Boolean }
  },
  emits: ["close", "created", "error"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale);
    function u(W) {
      return W.requires === "onlyoffice" ? !!n.onlyOfficeReady : W.requires === "drawio" ? !!n.drawioReady : !0;
    }
    const v = k(() => (n.types ?? []).filter(u)), p = k(() => {
      const W = [];
      for (const $e of n.types ?? [])
        !u($e) && $e.requires && !W.includes($e.requires) && W.push($e.requires);
      return W;
    }), h = k(
      () => p.value.map((W) => a("newdoc.withheld." + W)).join(" ")
    ), b = k(() => {
      const W = [], $e = /* @__PURE__ */ new Map();
      for (const Se of v.value)
        $e.has(Se.group) || ($e.set(Se.group, []), W.push(Se.group)), $e.get(Se.group).push(Se);
      return W.map((Se) => ({ group: Se, types: $e.get(Se) }));
    }), y = m(""), A = k(() => v.value.find((W) => W.ext === y.value) ?? null);
    function D(W) {
      return Os({ type: "file", extension: W }, a);
    }
    function C(W) {
      return Li(jn({ type: "file", extension: W, basename: "x." + W }));
    }
    const B = m(""), I = m(!1), U = /* @__PURE__ */ new Map();
    function x(W) {
      return !W || W.read_only ? !1 : al(W.perm);
    }
    async function E(W) {
      if (U.has(W)) return U.get(W);
      try {
        const $e = await n.api.index(W);
        return U.set(W, $e), $e;
      } catch {
        return;
      }
    }
    const $ = k(
      () => B.value ? Kd(B.value).map((W) => W.label).join(" / ") : ""
    ), M = m(!0), z = m(!1), T = m(""), Y = m(!1), O = m(!1), J = m(!1), G = m(null), N = k(() => {
      var Se;
      const W = T.value.trim(), $e = ((Se = A.value) == null ? void 0 : Se.ext) ?? "";
      return !W || !$e || W.toLowerCase().endsWith("." + $e) ? W : W + "." + $e;
    }), P = k(() => /[\\/]/.test(T.value));
    function le(W, $e) {
      const Se = a("newdoc.untitled");
      if (!W.has((Se + "." + $e).toLowerCase())) return Se;
      for (let ze = 2; ze < 100; ze++) {
        const Ne = `${Se} (${ze})`;
        if (!W.has((Ne + "." + $e).toLowerCase())) return Ne;
      }
      return Se;
    }
    function ve(W) {
      const $e = /* @__PURE__ */ new Set();
      for (const Se of (W == null ? void 0 : W.files) ?? []) $e.add(Se.basename.toLowerCase());
      return $e;
    }
    let he = 0, oe = null;
    async function ue(W = {}) {
      var De;
      const $e = ++he, Se = B.value;
      if (!Se) {
        z.value = !1, O.value = !1;
        return;
      }
      const ze = await E(Se);
      if ($e !== he || Se !== B.value) return;
      M.value = x(ze), z.value = !0;
      const Ne = ve(ze), be = ((De = A.value) == null ? void 0 : De.ext) ?? "";
      W.suggest && !Y.value && be && (T.value = le(Ne, be)), O.value = !!N.value && Ne.has(N.value.toLowerCase());
    }
    function Q() {
      oe && clearTimeout(oe), oe = setTimeout(() => void ue(), 220);
    }
    function pe() {
      const W = (n.currentPath || "").trim(), [$e] = _a(W);
      if ($e) return W;
      const Se = n.storages ?? [];
      return Se.length === 1 ? Se[0] + "://" : "";
    }
    He(
      () => n.open,
      async (W) => {
        var $e;
        W && (U.clear(), G.value = null, O.value = !1, Y.value = !1, J.value = !1, T.value = "", y.value = (($e = v.value[0]) == null ? void 0 : $e.ext) ?? "", B.value = pe(), z.value = !1, M.value = !0, I.value = !B.value, await ue({ suggest: !0 }));
      }
    ), He(y, () => {
      ue({ suggest: !0 });
    }), He(T, () => {
      O.value = !1, Q();
    }), He(B, () => {
      ue({ suggest: !0 });
    });
    function re(W) {
      y.value = W;
    }
    function S(W, $e) {
      const Se = v.value.map((be) => be.ext), ze = Se.indexOf($e);
      let Ne = -1;
      W.key === "ArrowRight" || W.key === "ArrowDown" ? Ne = (ze + 1) % Se.length : W.key === "ArrowLeft" || W.key === "ArrowUp" ? Ne = (ze - 1 + Se.length) % Se.length : W.key === "Home" ? Ne = 0 : W.key === "End" && (Ne = Se.length - 1), !(Ne < 0) && (W.preventDefault(), y.value = Se[Ne], gt(() => {
        const be = document.querySelector(`[data-newdoc-ext="${Se[Ne]}"]`);
        be == null || be.focus();
      }));
    }
    function w(W) {
      B.value = W, I.value = !1;
    }
    function j() {
      if (I.value) {
        I.value = !1;
        return;
      }
      r("close");
    }
    const K = k(
      () => !J.value && !!A.value && !!B.value && !I.value && !!T.value.trim() && !P.value && !O.value && (!z.value || M.value)
    );
    async function Z() {
      if (!(!K.value || !A.value)) {
        J.value = !0, G.value = null;
        try {
          const W = await n.api.newFile(B.value, T.value.trim(), A.value.ext);
          r("created", W);
        } catch (W) {
          const $e = W;
          $e.status === 409 ? O.value = !0 : (G.value = $e.message || String(W), r("error", { message: G.value }));
        } finally {
          J.value = !1;
        }
      }
    }
    return (W, $e) => (c(), d(ae, null, [
      Ge(an, {
        open: e.open,
        title: s(a)("newdoc.title"),
        size: "lg",
        theme: e.theme,
        onClose: j
      }, {
        actions: st(() => [
          o("button", {
            type: "button",
            class: "fe-btn",
            onClick: j
          }, f(s(a)("newdoc.cancel")), 1),
          v.value.length ? (c(), d("button", {
            key: 0,
            type: "button",
            class: "fe-btn fe-btn--primary",
            disabled: !K.value,
            "data-testid": "newdoc-create",
            onClick: Z
          }, f(J.value ? s(a)("newdoc.creating") : s(a)("newdoc.create")), 9, t6)) : g("", !0)
        ]),
        default: st(() => [
          o("div", zz, [
            v.value.length ? (c(), d(ae, { key: 1 }, [
              o("div", {
                class: "fe-newdoc__types",
                role: "radiogroup",
                "aria-label": s(a)("newdoc.type.label")
              }, [
                (c(!0), d(ae, null, Te(b.value, (Se) => (c(), d("section", {
                  key: Se.group,
                  class: "fe-newdoc__group"
                }, [
                  o("h3", Oz, f(s(a)("newdoc.group." + Se.group)), 1),
                  o("div", Bz, [
                    (c(!0), d(ae, null, Te(Se.types, (ze) => (c(), d("button", {
                      key: ze.ext,
                      type: "button",
                      role: "radio",
                      class: we(["fe-newdoc__type", { "is-selected": y.value === ze.ext }]),
                      "aria-checked": y.value === ze.ext,
                      tabindex: y.value === ze.ext ? 0 : -1,
                      "data-newdoc-ext": ze.ext,
                      "data-testid": "newdoc-type-" + ze.ext,
                      onClick: (Ne) => re(ze.ext),
                      onKeydown: (Ne) => S(Ne, ze.ext)
                    }, [
                      o("span", {
                        class: "fe-newdoc__tile",
                        "aria-hidden": "true",
                        innerHTML: C(ze.ext)
                      }, null, 8, Hz),
                      o("span", Fz, "." + f(ze.ext), 1),
                      o("span", Nz, f(D(ze.ext)), 1)
                    ], 42, Iz))), 128))
                  ])
                ]))), 128)),
                h.value ? (c(), d("p", Kz, f(h.value), 1)) : g("", !0)
              ], 8, Dz),
              o("div", Rz, [
                o("label", Uz, f(s(a)("newdoc.name")), 1),
                o("div", Vz, [
                  Ve(o("input", {
                    id: "fe-newdoc-name",
                    "onUpdate:modelValue": $e[0] || ($e[0] = (Se) => T.value = Se),
                    type: "text",
                    class: "fe-input fe-newdoc__name",
                    autocomplete: "off",
                    spellcheck: "false",
                    "data-testid": "newdoc-name",
                    placeholder: s(a)("newdoc.name.placeholder"),
                    onInput: $e[1] || ($e[1] = (Se) => Y.value = !0),
                    onKeydown: Ut(Re(Z, ["prevent"]), ["enter"])
                  }, null, 40, jz), [
                    [rt, T.value]
                  ]),
                  A.value ? (c(), d("span", Yz, "." + f(A.value.ext), 1)) : g("", !0)
                ]),
                P.value ? (c(), d("p", Wz, f(s(a)("newdoc.err.slash")), 1)) : O.value ? (c(), d("p", qz, f(s(a)("newdoc.err.exists", { name: N.value })), 1)) : g("", !0)
              ]),
              o("div", Gz, [
                o("span", Xz, f(s(a)("newdoc.location")), 1),
                o("div", Jz, [
                  o("span", Zz, f(B.value ? $.value : s(a)("newdoc.location.none")), 1),
                  o("button", {
                    type: "button",
                    class: "fe-newdoc__changebtn",
                    "data-testid": "newdoc-change",
                    onClick: $e[2] || ($e[2] = (Se) => I.value = !0)
                  }, f(s(a)("newdoc.location.change")), 1)
                ]),
                z.value && !M.value ? (c(), d("p", Qz, f(s(a)("newdoc.location.noaccess")), 1)) : g("", !0)
              ]),
              G.value ? (c(), d("p", e6, f(G.value), 1)) : g("", !0)
            ], 64)) : (c(), d("div", Az, [
              o("p", Pz, f(s(a)("newdoc.empty.title")), 1),
              o("p", Lz, f(p.value.length ? s(a)("newdoc.empty.blocked") : s(a)("newdoc.empty.body")), 1)
            ]))
          ])
        ]),
        _: 1
      }, 8, ["open", "title", "theme"]),
      Ge(Rd, {
        open: I.value,
        api: e.api,
        locale: e.locale,
        mode: "choose",
        storages: e.storages,
        "start-at": B.value || e.currentPath,
        onClose: $e[3] || ($e[3] = (Se) => I.value = !1),
        onPick: w
      }, null, 8, ["open", "api", "locale", "storages", "start-at"])
    ], 64));
  }
}), a6 = ["onKeydown"], o6 = /* @__PURE__ */ qe({
  __name: "RenameModal",
  props: {
    open: { type: Boolean },
    locale: {},
    currentName: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale), u = m("");
    He(
      () => [n.open, n.currentName],
      ([p, h]) => {
        p && (u.value = h);
      }
    );
    function v() {
      const p = u.value.trim();
      p && (/[\\/]/.test(p) || p === "." || p === ".." || r("submit", p));
    }
    return (p, h) => (c(), et(an, {
      open: e.open,
      title: s(a)("modal.rename.title"),
      size: "sm",
      onClose: h[2] || (h[2] = (b) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn",
          onClick: h[1] || (h[1] = (b) => r("close"))
        }, f(s(a)("modal.rename.cancel")), 1),
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: v
        }, f(s(a)("modal.rename.save")), 1)
      ]),
      default: st(() => [
        o("form", {
          onSubmit: Re(v, ["prevent"])
        }, [
          Ve(o("input", {
            "onUpdate:modelValue": h[0] || (h[0] = (b) => u.value = b),
            type: "text",
            class: "fe-input",
            autocomplete: "off",
            onKeydown: Ut(Re(v, ["prevent"]), ["enter"])
          }, null, 40, a6), [
            [rt, u.value]
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), s6 = /* @__PURE__ */ qe({
  __name: "DeleteConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    count: {}
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, r = t, { t: a } = tt(() => n.locale);
    return (u, v) => (c(), et(an, {
      open: e.open,
      title: s(a)("modal.delete.title"),
      size: "sm",
      onClose: v[2] || (v[2] = (p) => r("close"))
    }, {
      actions: st(() => [
        o("button", {
          type: "button",
          class: "fe-btn",
          onClick: v[0] || (v[0] = (p) => r("close"))
        }, f(s(a)("modal.delete.cancel")), 1),
        o("button", {
          type: "button",
          class: "fe-btn fe-btn--danger",
          onClick: v[1] || (v[1] = (p) => r("confirm"))
        }, f(s(a)("modal.delete.confirm")), 1)
      ]),
      default: st(() => [
        o("p", null, f(s(a)("modal.delete.message", { count: e.count })), 1)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), r6 = { class: "filex-cv" }, i6 = { class: "filex-cv__head" }, l6 = ["title", "aria-label"], c6 = ["innerHTML"], u6 = {
  key: 0,
  class: "filex-cv__msg"
}, d6 = {
  key: 1,
  class: "filex-cv__msg filex-cv__ok"
}, f6 = ["innerHTML"], p6 = { class: "filex-cv__src" }, v6 = ["placeholder"], h6 = { class: "filex-cv__list" }, m6 = ["onClick"], y6 = {
  key: 0,
  class: "filex-cv__empty"
}, b6 = {
  key: 0,
  class: "filex-cv__err"
}, g6 = { class: "filex-cv__foot" }, k6 = ["disabled"], _6 = ["src"], w6 = /* @__PURE__ */ qe({
  __name: "ConvertModal",
  props: {
    convertUrl: {},
    fileName: {},
    fetchBytes: { type: Function },
    upload: { type: Function },
    locale: {}
  },
  emits: ["close", "done"],
  setup(e, { emit: t }) {
    const n = e, { t: r } = tt(() => n.locale), a = t, u = m(null), v = m("loading"), p = m(null), h = m([]), b = m(""), y = m(null), A = k(() => (n.fileName.split(".").pop() || "").toLowerCase()), D = k(() => {
      const z = h.value.filter((T) => T.from);
      return z.find((T) => (T.ext || "").toLowerCase() === A.value) || z.find((T) => (T.format || "").toLowerCase() === A.value) || null;
    }), C = k(() => {
      const z = b.value.trim().toLowerCase(), T = /* @__PURE__ */ new Set(), Y = [];
      for (const O of h.value) {
        if (!O.to) continue;
        const J = (O.ext || O.format || "").toLowerCase();
        !J || T.has(J) || (T.add(J), Y.push(O));
      }
      return Y.sort((O, J) => (O.ext || O.format).localeCompare(J.ext || J.format)), z ? Y.filter(
        (O) => (O.ext || "").toLowerCase().includes(z) || (O.format || "").toLowerCase().includes(z) || (O.name || "").toLowerCase().includes(z) || (O.mime || "").toLowerCase().includes(z)
      ) : Y;
    }), B = k(() => `${n.convertUrl.replace(/\/$/, "")}/?embed=1`);
    let I = 0;
    const U = /* @__PURE__ */ new Map();
    function x(z, T = {}, Y = []) {
      const O = ++I;
      return new Promise((J, G) => {
        var N, P;
        U.set(O, { resolve: J, reject: G }), (P = (N = u.value) == null ? void 0 : N.contentWindow) == null || P.postMessage({ target: "convert-embed", id: O, cmd: z, ...T }, "*", Y), setTimeout(() => {
          U.has(O) && (U.delete(O), G(new Error("convert timeout")));
        }, 18e4);
      });
    }
    function E(z) {
      const T = z.data;
      if (!T || T.source !== "convert-embed") return;
      if (T.event === "ready") {
        $();
        return;
      }
      const Y = U.get(T.id);
      Y && (U.delete(T.id), T.ok ? Y.resolve(T) : Y.reject(new Error(T.error || "convert error")));
    }
    async function $() {
      try {
        const z = await x("listFormats");
        h.value = z.formats || [], v.value = "ready", D.value || (p.value = r("convert.unsupported_input"));
      } catch (z) {
        p.value = z.message, v.value = "error";
      }
    }
    async function M() {
      if (!(!y.value || !D.value)) {
        v.value = "converting", p.value = null;
        try {
          const z = await n.fetchBytes(), T = await x(
            "convert",
            { name: n.fileName, bytes: z, fromIndex: D.value.index, toIndex: y.value.index },
            [z]
          ), Y = n.fileName.replace(/\.[^.]+$/, ""), O = T.ext || y.value.ext || y.value.format, J = `${Y}.${O}`, G = new File([T.bytes], J, { type: y.value.mime || "application/octet-stream" });
          await n.upload(G), v.value = "done", a("done", J);
        } catch (z) {
          p.value = z.message, v.value = "error";
        }
      }
    }
    return dt(() => window.addEventListener("message", E)), it(() => window.removeEventListener("message", E)), (z, T) => (c(), d("div", {
      class: "filex-cv__bg",
      onClick: T[3] || (T[3] = Re((Y) => a("close"), ["self"]))
    }, [
      o("div", r6, [
        o("header", i6, [
          o("h3", null, f(s(r)("convert.title")) + " — " + f(e.fileName), 1),
          o("button", {
            class: "filex-cv__x",
            type: "button",
            title: s(r)("convert.close"),
            "aria-label": s(r)("convert.close"),
            onClick: T[0] || (T[0] = (Y) => a("close"))
          }, [
            o("span", {
              "aria-hidden": "true",
              innerHTML: s(Ue)("close")
            }, null, 8, c6)
          ], 8, l6)
        ]),
        v.value === "loading" ? (c(), d("div", u6, f(s(r)("convert.loading")), 1)) : v.value === "done" ? (c(), d("div", d6, [
          o("p", null, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("check")
            }, null, 8, f6),
            Je(" " + f(s(r)("convert.done")), 1)
          ]),
          o("button", {
            class: "filex-cv__convert",
            onClick: T[1] || (T[1] = (Y) => a("close"))
          }, f(s(r)("convert.close")), 1)
        ])) : (c(), d(ae, { key: 2 }, [
          o("p", p6, [
            Je(f(s(r)("convert.from")) + ": ", 1),
            o("b", null, f(A.value || "?"), 1)
          ]),
          Ve(o("input", {
            "onUpdate:modelValue": T[2] || (T[2] = (Y) => b.value = Y),
            class: "filex-cv__search",
            placeholder: s(r)("convert.search_format")
          }, null, 8, v6), [
            [rt, b.value]
          ]),
          o("div", h6, [
            (c(!0), d(ae, null, Te(C.value, (Y) => {
              var O;
              return c(), d("button", {
                key: Y.index,
                class: we(["filex-cv__fmt", { "is-sel": ((O = y.value) == null ? void 0 : O.index) === Y.index }]),
                onClick: (J) => y.value = Y
              }, [
                o("b", null, f((Y.ext || Y.format).toUpperCase()), 1),
                o("small", null, f(Y.name), 1)
              ], 10, m6);
            }), 128)),
            C.value.length === 0 ? (c(), d("div", y6, f(s(r)("convert.no_format")), 1)) : g("", !0)
          ]),
          p.value ? (c(), d("div", b6, f(p.value), 1)) : g("", !0),
          o("footer", g6, [
            o("button", {
              class: "filex-cv__convert",
              disabled: !y.value || !D.value || v.value === "converting",
              onClick: M
            }, f(v.value === "converting" ? s(r)("convert.converting") : s(r)("convert.convert")), 9, k6)
          ])
        ], 64)),
        o("iframe", {
          ref_key: "iframeRef",
          ref: u,
          src: B.value,
          class: "filex-cv__frame",
          title: "converter"
        }, null, 8, _6)
      ])
    ]));
  }
});
function Pu(e) {
  return `'${e.replace(/'/g, "'\\''")}'`;
}
function $6(e) {
  if (!(e != null && e.url)) return "";
  let t = e.url;
  const n = [];
  e.isDir && n.push("zip=wait"), e.pin && n.push("pin=" + encodeURIComponent(e.pin)), n.length && (t += (t.includes("?") ? "&" : "?") + n.join("&"));
  let r = "-OJ ";
  return e.filename && (r = `-o ${Pu(e.isDir ? `${e.filename}.zip` : e.filename)} `), `curl -fSL ${r}${Pu(t)}`;
}
const x6 = [0, 1, 7, 30];
function S6(e, t, n) {
  const r = t && t > 0 ? Math.floor(t) : 0;
  let a = r ? e.filter((u) => u > 0 && u <= r) : e.slice();
  return r && !a.includes(r) && a.push(r), a = Array.from(new Set(a)).sort((u, v) => u === 0 ? -1 : v === 0 ? 1 : u - v), a.map((u) => ({ v: u, l: n(u) }));
}
function bs(e) {
  return e && e > 0 ? Math.floor(e) : 0;
}
function C6(e, t, n) {
  if (!e) return t === "tr" ? "Bu bağlantının süresi yoktur." : "This link does not expire.";
  const r = new Date(e), a = Number.isNaN(r.getTime()) ? e : Ha(r, t, { dateStyle: "medium", timeStyle: "short" }, n);
  return t === "tr" ? `Bu bağlantı ${a} tarihine kadar geçerli.` : `This link is valid until ${a}.`;
}
function T6(e, t) {
  const n = e && e > 0 ? Math.floor(e) : 0;
  return n ? t === "tr" ? `Bağlantılar en fazla ${n} gün geçerli olabilir (sunucu ayarı).` : `Links can be valid for at most ${n} day${n === 1 ? "" : "s"} (server setting).` : "";
}
function M6(e) {
  const t = e.filter((n) => !!n);
  return t.map((n, r) => r < t.length - 1 ? n.replace(/\.\s*$/, "") : n).join(" · ");
}
const E6 = ["aria-label"], z6 = { class: "fe-share__head" }, A6 = ["innerHTML"], P6 = { class: "fe-share__headtext" }, L6 = { class: "fe-share__title" }, D6 = ["title"], O6 = ["aria-label", "title"], B6 = ["innerHTML"], I6 = { class: "fe-share__body" }, H6 = { class: "fe-share__lead" }, F6 = { class: "fe-share__switchrow" }, N6 = ["innerHTML"], K6 = { class: "fe-share__leadlabel" }, R6 = ["aria-checked", "aria-label", "disabled"], U6 = {
  class: "fe-share__who",
  "data-testid": "share-who"
}, V6 = { class: "fe-share__linkrow" }, j6 = ["href", "title"], Y6 = ["innerHTML"], W6 = {
  key: 0,
  class: "fe-share__detail",
  "data-testid": "share-valid-until"
}, q6 = {
  key: 1,
  class: "fe-share__pinrow"
}, G6 = { class: "fe-share__pin" }, X6 = {
  key: 1,
  class: "fe-share__warn"
}, J6 = { class: "fe-share__sections" }, Z6 = { class: "fe-share__section" }, Q6 = ["aria-expanded"], eA = { class: "fe-share__seclabel" }, tA = { class: "fe-share__secmeta" }, nA = {
  key: 0,
  class: "fe-share__panel"
}, aA = { class: "fe-share__opts" }, oA = { class: "fe-share__check" }, sA = { class: "fe-share__field" }, rA = { class: "fe-share__fieldlabel" }, iA = ["value"], lA = { class: "fe-share__field" }, cA = { class: "fe-share__fieldlabel" }, uA = ["value"], dA = {
  key: 0,
  class: "fe-share__hint",
  "data-testid": "share-ttl-hint"
}, fA = ["disabled"], pA = {
  key: 1,
  class: "fe-share__hint"
}, vA = { class: "fx-perm-cli fe-share__cli" }, hA = { class: "fe-share__fieldlabel" }, mA = { class: "fe-share__clirow" }, yA = ["title"], bA = { class: "fe-share__mailrow" }, gA = ["placeholder"], kA = ["disabled"], _A = {
  key: 0,
  class: "fe-share__notice"
}, wA = ["innerHTML"], $A = { class: "fe-share__list" }, xA = { class: "fe-share__listhead" }, SA = {
  key: 0,
  class: "fe-share__empty"
}, CA = ["title"], TA = ["onClick"], MA = ["disabled", "title", "aria-label", "onClick"], EA = ["innerHTML"], zA = {
  key: 0,
  class: "fe-share__section"
}, AA = ["aria-expanded"], PA = { class: "fe-share__seclabel" }, LA = { class: "fe-share__secmeta" }, DA = {
  key: 0,
  class: "fe-share__panel"
}, OA = {
  key: 0,
  class: "fe-share__warn"
}, BA = {
  key: 1,
  class: "fe-share__warn"
}, IA = {
  key: 2,
  class: "fe-share__hint"
}, HA = { class: "fe-share__add" }, FA = { class: "fe-share__emailwrap" }, NA = ["placeholder"], KA = {
  key: 0,
  class: "fe-share__suggest"
}, RA = ["onMousedown"], UA = { class: "fe-share__av fe-share__av--sm" }, VA = { class: "fe-share__suggesttxt" }, jA = { class: "fe-share__suggestname" }, YA = { class: "fe-share__suggestmeta" }, WA = ["title"], qA = ["value"], GA = ["disabled"], XA = {
  key: 0,
  class: "fe-share__invite"
}, JA = { class: "fe-share__hint" }, ZA = { class: "fe-share__inviterow" }, QA = { value: "user" }, eP = { value: "viewer" }, tP = ["disabled"], nP = ["disabled"], aP = {
  key: 1,
  class: "fe-share__notice"
}, oP = {
  key: 2,
  class: "fe-share__notice"
}, sP = { class: "fe-share__pin" }, rP = { class: "fe-share__list" }, iP = { class: "fe-share__listhead" }, lP = {
  key: 0,
  class: "fe-share__empty"
}, cP = { class: "fe-share__av" }, uP = ["title"], dP = ["value", "onChange"], fP = ["value"], pP = ["disabled", "title", "aria-label", "onClick"], vP = ["innerHTML"], hP = { class: "fe-share__av fe-share__av--dim" }, mP = ["title"], yP = { class: "fe-share__badge" }, bP = ["title"], gP = {
  key: 1,
  class: "fe-share__section"
}, kP = ["aria-expanded"], _P = { class: "fe-share__seclabel" }, wP = { class: "fe-share__secmeta" }, $P = {
  key: 0,
  class: "fe-share__panel"
}, xP = { class: "fe-share__hint" }, SP = { class: "fe-share__opts" }, CP = { class: "fe-share__check" }, TP = { class: "fe-share__field" }, MP = { class: "fe-share__fieldlabel" }, EP = ["value"], zP = {
  key: 0,
  class: "fe-share__hint"
}, AP = ["disabled"], PP = ["aria-expanded"], LP = {
  key: 1,
  class: "fe-share__adv"
}, DP = { class: "fe-share__advrow" }, OP = { class: "fe-share__fieldlabel" }, BP = { class: "fe-share__advrow" }, IP = { class: "fe-share__fieldlabel" }, HP = { class: "fe-share__advrow" }, FP = { class: "fe-share__fieldlabel" }, NP = ["placeholder"], KP = { class: "fe-share__check" }, RP = {
  key: 2,
  class: "fe-share__warn"
}, UP = { class: "fe-share__linkrow" }, VP = ["href", "title"], jP = ["innerHTML"], YP = { class: "fe-share__detail" }, WP = { key: 0 }, qP = {
  key: 0,
  class: "fe-share__pinrow"
}, GP = { class: "fe-share__pin" }, XP = { class: "fe-share__mailrow" }, JP = ["placeholder"], ZP = ["disabled"], QP = {
  key: 1,
  class: "fe-share__notice"
}, eL = ["innerHTML"], tL = { class: "fe-share__list" }, nL = { class: "fe-share__listhead" }, aL = {
  key: 0,
  class: "fe-share__empty"
}, oL = ["title"], sL = ["onClick"], rL = ["disabled", "title", "aria-label", "onClick"], iL = ["innerHTML"], lL = { class: "fe-share__foot" }, cL = /* @__PURE__ */ qe({
  __name: "PermissionsModal",
  props: {
    api: {},
    path: {},
    isDir: { type: Boolean },
    size: {},
    locale: {},
    shareMaxTtlDays: {},
    initialTab: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = k(() => cn(n.locale)), { t: u } = tt(() => a.value), v = k(() => a.value !== "en");
    function p(q, ne) {
      return v.value ? q : ne;
    }
    const h = k(() => {
      const q = /^([^:]+):\/\/(.*)$/.exec(n.path), ne = q ? q[1] : "", H = q ? q[2] : n.path, te = H.split("/").filter(Boolean);
      return { adapter: ne, name: te.length ? te[te.length - 1] : ne, rel: H };
    }), b = k(() => {
      const q = h.value.name, ne = q.lastIndexOf(".");
      return fn({
        type: n.isDir ? "dir" : "file",
        extension: !n.isDir && ne > 0 ? q.slice(ne + 1) : ""
      });
    }), y = m({ link: !1, people: !1, drop: !1 });
    function A(q) {
      y.value = { ...y.value, [q]: !y.value[q] };
    }
    const D = m(!1), C = m(!0), B = m(""), I = m([]), U = m([]), x = m(!0), E = m(""), $ = m("viewer"), M = m(!1), z = m(""), T = m(!1), Y = m("user"), O = m(null), J = m([]), G = m(!1);
    let N;
    const P = [
      { v: "viewer", l: p("Görüntüleyen", "Viewer"), d: p("görüntüle + indir", "view + download") },
      { v: "editor", l: p("Düzenleyen", "Editor"), d: p("oku + yaz + sil", "read + write + delete") },
      { v: "owner", l: p("Sahip", "Owner"), d: p("düzenle + izin yönet", "edit + manage access") }
    ];
    function le(q) {
      var ne;
      return ((ne = P.find((H) => H.v === q)) == null ? void 0 : ne.l) ?? q;
    }
    const ve = m([]), he = m(!1), oe = m(!1), ue = m(bs(n.shareMaxTtlDays)), Q = m(null), pe = m(""), re = m(""), S = m(""), w = m(!1), j = m("");
    function K(q) {
      return q.kind ?? "download";
    }
    const Z = k(() => ve.value.filter((q) => K(q) !== "drop")), W = k(() => ve.value.filter((q) => K(q) === "drop"));
    function $e(q) {
      return q === 0 ? p("Süresiz", "Never") : v.value ? `${q} gün` : `${q} day${q === 1 ? "" : "s"}`;
    }
    const Se = k(() => S6(x6, n.shareMaxTtlDays, $e)), ze = k(() => T6(n.shareMaxTtlDays, v.value ? "tr" : "en"));
    He(
      () => n.shareMaxTtlDays,
      () => {
        const q = Se.value.map((ne) => ne.v);
        q.includes(ue.value) || (ue.value = bs(n.shareMaxTtlDays)), q.includes(ce.value) || (ce.value = bs(n.shareMaxTtlDays));
      }
    );
    const Ne = m(0), be = [
      { v: 0, l: p("Sınırsız", "Unlimited") },
      { v: 1, l: p("1 indirme", "1 download") },
      { v: 3, l: p("3 indirme", "3 downloads") },
      { v: 5, l: p("5 indirme", "5 downloads") },
      { v: 10, l: p("10 indirme", "10 downloads") },
      { v: 25, l: p("25 indirme", "25 downloads") }
    ], De = k(
      () => $6(
        Q.value ? {
          url: Q.value.url,
          pin: Q.value.pin,
          filename: h.value.name,
          isDir: !!n.isDir
        } : null
      )
    ), ie = m(!1), ce = m(bs(n.shareMaxTtlDays)), L = m(!1), se = m(""), Ce = m(""), We = m(""), Ie = m(!0), Ze = m(!1), vt = m(""), Xe = m(null), Ae = m(""), V = m(!1), R = m("");
    function X(q) {
      const ne = /* @__PURE__ */ new Set(), H = [];
      for (const te of q.split(/[,;\s]+/)) {
        const _e = te.trim().toLowerCase();
        _e && _e.includes("@") && !ne.has(_e) && (ne.add(_e), H.push(_e));
      }
      return H;
    }
    function ye(q) {
      var te, _e;
      const ne = ((te = q.sent) == null ? void 0 : te.length) ?? 0, H = ((_e = q.failed) == null ? void 0 : _e.length) ?? 0;
      return H === 0 ? p(`E-posta gönderildi ✓ (${ne})`, `Email sent ✓ (${ne})`) : p(`${ne} gönderildi, ${H} başarısız`, `${ne} sent, ${H} failed`);
    }
    async function je() {
      C.value = !0, B.value = "";
      try {
        const q = await n.api.listPermissions(n.path);
        I.value = q.direct ?? [], U.value = q.inherited ?? [], x.value = q.storage_rbac, D.value = !0;
      } catch (q) {
        q.status === 403 ? (D.value = !1, y.value = { ...y.value, people: !1 }) : B.value = q instanceof Error ? q.message : String(q);
      } finally {
        C.value = !1;
      }
    }
    async function Qe() {
      try {
        const q = await n.api.listShares(n.path);
        ve.value = q.shares ?? [];
      } catch {
        ve.value = [];
      }
    }
    function at(q) {
      q.key === "Escape" && r("close");
    }
    dt(async () => {
      n.initialTab === "drop" ? y.value = { ...y.value, drop: !0 } : n.initialTab === "perms" && (y.value = { ...y.value, people: !0 }), document.addEventListener("keydown", at), await je(), await Qe();
    }), it(() => {
      N && clearTimeout(N), document.removeEventListener("keydown", at);
    });
    function Ye() {
      T.value = !1, O.value = null, z.value = "";
      const q = E.value.trim();
      if (N && clearTimeout(N), q.length < 1) {
        J.value = [], G.value = !1;
        return;
      }
      N = setTimeout(async () => {
        try {
          const ne = await n.api.searchUsers(q);
          J.value = ne.users ?? [], G.value = J.value.length > 0;
        } catch {
          G.value = !1;
        }
      }, 180);
    }
    async function lt(q) {
      G.value = !1, E.value = q.email;
      let ne = $.value;
      q.role === "viewer" && ne !== "viewer" && (ne = "viewer"), M.value = !0, z.value = "";
      try {
        await n.api.addPermission({ path: n.path, user_id: q.id, level: ne, is_dir: !!n.isDir }), E.value = "", J.value = [], await je(), z.value = p("Yetki verildi.", "Access granted.");
      } catch (H) {
        z.value = H instanceof Error ? H.message : String(H);
      } finally {
        M.value = !1;
      }
    }
    async function fe() {
      const q = E.value.trim().toLowerCase();
      if (!q || !q.includes("@")) {
        z.value = p("Geçerli bir e-posta girin.", "Enter a valid email.");
        return;
      }
      G.value = !1, M.value = !0, z.value = "", O.value = null;
      try {
        const ne = await n.api.resolveEmail(q);
        if (ne.found && ne.user) {
          let H = $.value;
          ne.user.role === "viewer" && H !== "viewer" && (H = "viewer"), await n.api.addPermission({ path: n.path, user_id: ne.user.id, level: H, is_dir: !!n.isDir }), E.value = "", await je(), z.value = p("Yetki verildi.", "Access granted.");
        } else
          T.value = !0;
      } catch (ne) {
        z.value = ne instanceof Error ? ne.message : String(ne);
      } finally {
        M.value = !1;
      }
    }
    async function Pe() {
      M.value = !0, z.value = "";
      try {
        const q = await n.api.invitePermission({
          path: n.path,
          email: E.value.trim().toLowerCase(),
          level: $.value,
          create_user: !0,
          role: Y.value,
          is_dir: !!n.isDir,
          locale: cn(n.locale)
        });
        O.value = { tempPassword: q.temp_password }, z.value = q.emailed ? p("Kullanıcı açıldı, davet e-postası gönderildi.", "User created, invite emailed.") : p("Kullanıcı açıldı. Geçici parolayı iletin.", "User created. Share the temp password."), T.value = !1, E.value = "", await je();
      } catch (q) {
        z.value = q instanceof Error ? q.message : String(q);
      } finally {
        M.value = !1;
      }
    }
    function Be() {
      S.value = E.value.trim().toLowerCase(), T.value = !1, z.value = "", y.value = { ...y.value, link: !0 };
    }
    async function ht(q, ne) {
      if (ne !== q.level) {
        M.value = !0;
        try {
          await n.api.updatePermission(q.id, ne), await je();
        } catch (H) {
          z.value = H instanceof Error ? H.message : String(H);
        } finally {
          M.value = !1;
        }
      }
    }
    async function Ft(q) {
      M.value = !0;
      try {
        await n.api.deletePermission(q.id), await je();
      } catch (ne) {
        z.value = ne instanceof Error ? ne.message : String(ne);
      } finally {
        M.value = !1;
      }
    }
    function ft(q) {
      return q.user_display_name || q.user_email || `#${q.user_id}`;
    }
    function qt(q) {
      return (q.user_display_name || q.user_email || "?").charAt(0).toUpperCase();
    }
    function Gt() {
      return ue.value ? new Date(Date.now() + ue.value * 864e5).toISOString() : null;
    }
    async function wt() {
      he.value = !0, pe.value = "", Q.value = null, j.value = "";
      try {
        const q = await n.api.createShare({
          path: n.path,
          password: oe.value,
          expires_at: Gt(),
          // null, not 0 — the server reads 0 as "no cap given" either way, but a
          // null says it explicitly and keeps the payload honest.
          max_downloads: Ne.value || null
        });
        Q.value = {
          url: q.share.url,
          pin: q.share.password_pin ?? null,
          expiresAt: q.share.expires_at ?? null,
          clamped: !!q.share.expiry_clamped
        }, await Qe();
      } catch (q) {
        pe.value = q instanceof Error ? q.message : String(q);
      } finally {
        he.value = !1;
      }
    }
    async function en() {
      if (!he.value) {
        if (_t.value) {
          he.value = !0, pe.value = "";
          try {
            for (const q of Z.value) await n.api.revokeShare(q.uuid);
            Q.value = null, await Qe();
          } catch (q) {
            pe.value = q instanceof Error ? q.message : String(q);
          } finally {
            he.value = !1;
          }
          return;
        }
        await wt();
      }
    }
    async function $t() {
      var ne;
      const q = X(S.value);
      if (!q.length) {
        j.value = p("Geçerli bir e-posta girin.", "Enter a valid email.");
        return;
      }
      if ((ne = Q.value) != null && ne.url) {
        w.value = !0, j.value = "";
        try {
          const H = await n.api.shareMail({
            path: n.path,
            emails: q,
            url: Q.value.url,
            pin: Q.value.pin ?? void 0,
            expires_days: ue.value || void 0,
            locale: cn(n.locale),
            is_dir: !!n.isDir,
            size: n.size
          });
          j.value = ye(H);
        } catch (H) {
          const te = H.detail ?? "";
          te.includes("not_configured") ? j.value = p("SMTP ayarlı/doğrulanmış değil — linki elle iletin.", "SMTP not set up/verified — share the link manually.") : te.includes("send_failed") ? j.value = p("Gönderilemedi (geçici hata) — tekrar deneyin.", "Send failed (temporary) — please retry.") : j.value = H instanceof Error ? H.message : String(H);
        } finally {
          w.value = !1;
        }
      }
    }
    function kt() {
      return ce.value ? new Date(Date.now() + ce.value * 864e5).toISOString() : null;
    }
    async function Dt() {
      Ze.value = !0, vt.value = "", Xe.value = null, R.value = "";
      try {
        const q = { ask_name: Ie.value };
        se.value && (q.max_files = Number(se.value)), Ce.value && (q.max_file_size_mb = Number(Ce.value));
        const ne = We.value.split(/[,\s]+/).map((te) => te.trim().replace(/^\./, "")).filter(Boolean);
        ne.length && (q.allowed_ext = ne);
        const H = await n.api.createShare({
          path: n.path,
          kind: "drop",
          password: ie.value,
          expires_at: kt(),
          drop_settings: q
        });
        Xe.value = {
          url: H.share.url,
          pin: H.share.password_pin ?? null,
          expiresAt: H.share.expires_at ?? null,
          clamped: !!H.share.expiry_clamped
        }, await Qe();
      } catch (q) {
        vt.value = q instanceof Error ? q.message : String(q);
      } finally {
        Ze.value = !1;
      }
    }
    async function At() {
      var ne;
      const q = X(Ae.value);
      if (!q.length) {
        R.value = p("Geçerli bir e-posta girin.", "Enter a valid email.");
        return;
      }
      if ((ne = Xe.value) != null && ne.url) {
        V.value = !0, R.value = "";
        try {
          const H = await n.api.shareMail({
            path: n.path,
            emails: q,
            url: Xe.value.url,
            pin: Xe.value.pin ?? void 0,
            expires_days: ce.value || void 0,
            locale: cn(n.locale),
            is_dir: !0,
            mode: "drop"
          });
          R.value = ye(H);
        } catch (H) {
          (H.detail ?? "").includes("not_configured") ? R.value = p("SMTP ayarlı/doğrulanmış değil — linki elle iletin.", "SMTP not set up/verified — share the link manually.") : R.value = H instanceof Error ? H.message : String(H);
        } finally {
          V.value = !1;
        }
      }
    }
    async function Ot(q) {
      he.value = !0;
      try {
        await n.api.revokeShare(q.uuid), Q.value && Q.value.url === q.url && (Q.value = null), await Qe();
      } catch (ne) {
        pe.value = ne instanceof Error ? ne.message : String(ne);
      } finally {
        he.value = !1;
      }
    }
    function Bt(q, ne = "url") {
      var H;
      (H = navigator.clipboard) == null || H.writeText(q), re.value = ne, setTimeout(() => {
        re.value === ne && (re.value = "");
      }, 1400);
    }
    const un = k(() => typeof navigator < "u" && typeof navigator.share == "function");
    function pt(q) {
      return !q || q <= 0 ? "" : Xu(q, { base: 1024, digits: "fixed1", numberLocale: null });
    }
    function tn(q) {
      return q > 0 ? p(`Bu bağlantı ${q} gün geçerlidir.`, `This link is valid for ${q} day(s).`) : p("Bu bağlantının süresi yoktur.", "This link does not expire.");
    }
    const xt = Ws(Xs, void 0);
    function jt(q) {
      return C6((q == null ? void 0 : q.expiresAt) ?? null, v.value ? "tr" : "en", xt);
    }
    const Pt = k(() => {
      var q, ne;
      return ((q = Q.value) == null ? void 0 : q.url) ?? ((ne = Z.value[0]) == null ? void 0 : ne.url) ?? "";
    }), _t = k(() => !!Pt.value), St = k(() => _t.value ? Q.value ? Q.value.pin ? u("access.who.pin") : u("access.who.link") : u("access.who.existing", { n: Z.value.length }) : u("access.who.private")), sn = k(() => {
      var ne, H;
      const q = [];
      if (Q.value)
        q.push(jt(Q.value)), Q.value.clamped && q.push(p("(sunucu sınırı uygulandı)", "(server limit applied)")), Ne.value && q.push(((ne = be.find((te) => te.v === Ne.value)) == null ? void 0 : ne.l) ?? "");
      else if (Z.value[0]) {
        const te = Z.value[0];
        q.push(jt({ expiresAt: te.expires_at ?? null })), te.max_downloads && q.push(((H = be.find((_e) => _e.v === te.max_downloads)) == null ? void 0 : H.l) ?? String(te.max_downloads));
      }
      return M6(q);
    }), Nt = k(() => {
      var ne;
      const q = [];
      return q.push(oe.value ? u("access.sum.pin_on") : u("access.sum.pin_off")), q.push($e(ue.value)), Ne.value && q.push(((ne = be.find((H) => H.v === Ne.value)) == null ? void 0 : ne.l) ?? ""), q.filter(Boolean).join(" · ");
    }), nn = k(() => {
      const q = I.value.length + U.value.length;
      return q ? u("access.sum.people", { n: q }) : u("access.sum.people_none");
    }), mn = k(
      () => W.value.length ? u("access.sum.drop", { n: W.value.length }) : u("access.sum.drop_none")
    );
    function xe() {
      var ge, Oe;
      const q = h.value.name, ne = ((ge = Q.value) == null ? void 0 : ge.url) ?? "", H = ((Oe = Q.value) == null ? void 0 : Oe.pin) ?? "", te = n.isDir ? p("klasör", "folder") : p("dosya", "file"), _e = v.value ? `${q} ${n.isDir ? "klasörü" : "dosyası"} sizinle paylaşıldı` : `${q} has been shared with you`, Me = [];
      if (Me.push(p("Merhaba,", "Hello,"), ""), Me.push(p(`Sizinle bir ${te} paylaşıldı:`, `A ${te} has been shared with you:`), ""), n.isDir)
        Me.push(p(`Klasör: ${q}`, `Folder: ${q}`));
      else {
        Me.push(p(`Dosya: ${q}`, `File: ${q}`));
        const mt = pt(n.size);
        mt && Me.push(p(`Boyut: ${mt}`, `Size: ${mt}`));
      }
      return Me.push("", p("İndirmek için:", "Download it here:"), ne), H && Me.push("", p(`PIN (erişim kodu): ${H}`, `PIN (access code): ${H}`)), Me.push("", tn(ue.value)), { title: _e, text: Me.join(`
`) };
    }
    function de() {
      var mt, Xt;
      const q = h.value.name, ne = ((mt = Xe.value) == null ? void 0 : mt.url) ?? "", H = ((Xt = Xe.value) == null ? void 0 : Xt.pin) ?? "", te = Number(se.value) || 20, _e = Number(Ce.value) || 500, Me = We.value.split(/[,\s]+/).map((sa) => sa.trim().replace(/^\./, "")).filter(Boolean), ge = p(`${q} adlı klasöre dosya eklemeniz istendi`, `You've been asked to add files to ${q}`), Oe = [];
      return Oe.push(p("Merhaba,", "Hello,"), ""), Oe.push(p("Dosya yüklemeniz istendi.", "You've been invited to upload files."), ""), Oe.push(p(`Klasör: ${q}`, `Folder: ${q}`)), Oe.push(p(`Sınır: en fazla ${te} dosya, dosya başına ${_e} MB.`, `Limit: up to ${te} file(s), ${_e} MB per file.`)), Oe.push(Me.length ? p(`İzinli türler: ${Me.join(", ")}`, `Allowed types: ${Me.join(", ")}`) : p("İzinli türler: tüm türler", "Allowed types: all")), Oe.push("", p("Dosyalarınızı buradan yükleyebilirsiniz:", "Upload your files here:"), ne), H && Oe.push("", p(`PIN (erişim kodu): ${H}`, `PIN (access code): ${H}`)), Oe.push("", tn(ce.value)), { title: ge, text: Oe.join(`
`) };
    }
    async function Le(q) {
      if (un.value)
        try {
          await navigator.share(q);
        } catch {
        }
    }
    return (q, ne) => {
      var H, te, _e, Me;
      return c(), d("div", {
        class: "fx-perm-overlay fe-share__scrim",
        onClick: ne[27] || (ne[27] = Re((ge) => r("close"), ["self"]))
      }, [
        o("div", {
          class: "fx-perm-modal fe-share",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": s(u)("access.title", { name: h.value.name })
        }, [
          o("header", z6, [
            o("span", {
              class: "fe-share__tile",
              "aria-hidden": "true",
              innerHTML: b.value
            }, null, 8, A6),
            o("div", P6, [
              o("h3", L6, f(s(u)("access.title", { name: h.value.name })), 1),
              o("span", {
                class: "fe-share__path",
                title: e.path
              }, f(h.value.adapter), 9, D6)
            ]),
            o("button", {
              type: "button",
              class: "fe-share__close",
              "aria-label": s(u)("access.close"),
              title: s(u)("access.close"),
              onClick: ne[0] || (ne[0] = (ge) => r("close"))
            }, [
              o("span", {
                "aria-hidden": "true",
                innerHTML: s(Ue)("close")
              }, null, 8, B6)
            ], 8, O6)
          ]),
          o("div", I6, [
            o("div", H6, [
              o("div", F6, [
                o("span", {
                  class: "fe-share__leadicon",
                  "aria-hidden": "true",
                  innerHTML: s(Ue)("access")
                }, null, 8, N6),
                o("span", K6, f(s(u)("access.link.switch")), 1),
                o("button", {
                  type: "button",
                  class: "fe-share__switch",
                  role: "switch",
                  "aria-checked": _t.value ? "true" : "false",
                  "aria-label": s(u)("access.link.switch"),
                  "data-testid": "share-switch",
                  disabled: he.value,
                  onClick: en
                }, [...ne[28] || (ne[28] = [
                  o("span", { class: "fe-share__knob" }, null, -1)
                ])], 8, R6)
              ]),
              o("p", U6, f(St.value), 1),
              _t.value ? (c(), d(ae, { key: 0 }, [
                o("div", V6, [
                  o("a", {
                    href: Pt.value,
                    target: "_blank",
                    rel: "noopener",
                    class: "fe-share__url",
                    title: Pt.value
                  }, f(Pt.value), 9, j6),
                  o("button", {
                    type: "button",
                    class: "fe-share__copy",
                    "data-testid": "share-copy",
                    onClick: ne[1] || (ne[1] = (ge) => Bt(Pt.value, "new"))
                  }, [
                    o("span", {
                      "aria-hidden": "true",
                      innerHTML: s(Ue)("copy")
                    }, null, 8, Y6),
                    o("span", null, f(re.value === "new" ? s(u)("access.copied") : s(u)("access.copy")), 1)
                  ])
                ]),
                sn.value ? (c(), d("p", W6, f(sn.value), 1)) : g("", !0),
                (H = Q.value) != null && H.pin ? (c(), d("div", q6, [
                  ne[29] || (ne[29] = o("span", { class: "fe-share__pinlabel" }, "PIN", -1)),
                  o("code", G6, f((te = Q.value) == null ? void 0 : te.pin), 1),
                  o("button", {
                    type: "button",
                    class: "fe-share__mini",
                    onClick: ne[2] || (ne[2] = (ge) => {
                      var Oe;
                      return Bt(((Oe = Q.value) == null ? void 0 : Oe.pin) ?? "", "sharepin");
                    })
                  }, f(re.value === "sharepin" ? s(u)("access.copied") : s(u)("access.copy")), 1)
                ])) : g("", !0)
              ], 64)) : g("", !0),
              pe.value ? (c(), d("div", X6, f(pe.value), 1)) : g("", !0)
            ]),
            o("div", J6, [
              o("section", Z6, [
                o("button", {
                  type: "button",
                  class: "fe-share__sechead",
                  "aria-expanded": y.value.link ? "true" : "false",
                  "data-testid": "share-options-toggle",
                  onClick: ne[3] || (ne[3] = (ge) => A("link"))
                }, [
                  (c(), d("svg", {
                    class: we(["fe-share__caret", { "is-open": y.value.link }]),
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [...ne[30] || (ne[30] = [
                    o("path", { d: "M9 6l6 6-6 6" }, null, -1)
                  ])], 2)),
                  o("span", eA, f(s(u)("access.section.link")), 1),
                  o("span", tA, f(Nt.value), 1)
                ], 8, Q6),
                y.value.link ? (c(), d("div", nA, [
                  o("div", aA, [
                    o("label", oA, [
                      Ve(o("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ne[4] || (ne[4] = (ge) => oe.value = ge)
                      }, null, 512), [
                        [An, oe.value]
                      ]),
                      o("span", null, f(p("PIN ile koru", "Protect with a PIN")), 1)
                    ]),
                    o("label", sA, [
                      o("span", rA, f(p("Süre", "Expiry")), 1),
                      Ve(o("select", {
                        "onUpdate:modelValue": ne[5] || (ne[5] = (ge) => ue.value = ge),
                        class: "fe-share__select",
                        "data-testid": "share-expiry"
                      }, [
                        (c(!0), d(ae, null, Te(Se.value, (ge) => (c(), d("option", {
                          key: ge.v,
                          value: ge.v
                        }, f(ge.l), 9, iA))), 128))
                      ], 512), [
                        [
                          on,
                          ue.value,
                          void 0,
                          { number: !0 }
                        ]
                      ])
                    ]),
                    o("label", lA, [
                      o("span", cA, f(p("İndirme limiti", "Download limit")), 1),
                      Ve(o("select", {
                        "onUpdate:modelValue": ne[6] || (ne[6] = (ge) => Ne.value = ge),
                        class: "fe-share__select"
                      }, [
                        (c(), d(ae, null, Te(be, (ge) => o("option", {
                          key: ge.v,
                          value: ge.v
                        }, f(ge.l), 9, uA)), 64))
                      ], 512), [
                        [
                          on,
                          Ne.value,
                          void 0,
                          { number: !0 }
                        ]
                      ])
                    ])
                  ]),
                  ze.value ? (c(), d("p", dA, f(ze.value), 1)) : g("", !0),
                  o("button", {
                    type: "button",
                    class: "fx-perm-create fe-share__btn fe-share__btn--primary fe-share__btn--wide",
                    disabled: he.value,
                    onClick: wt
                  }, f(p("Bağlantı oluştur", "Create link")), 9, fA),
                  !Q.value && S.value ? (c(), d("p", pA, [
                    Je(f(p("Bir bağlantı oluşturun, ardından", "Create a link, then it will be sent to")) + " ", 1),
                    o("strong", null, f(S.value), 1),
                    Je(" " + f(p("adresine gönderin.", ".")), 1)
                  ])) : g("", !0),
                  Q.value ? (c(), d(ae, { key: 2 }, [
                    o("div", vA, [
                      o("span", hA, f(p("Komut satırı", "Command line")), 1),
                      o("div", mA, [
                        o("code", {
                          class: "fe-share__clicmd",
                          title: De.value
                        }, f(De.value), 9, yA),
                        o("button", {
                          type: "button",
                          class: "fe-share__mini",
                          onClick: ne[7] || (ne[7] = (ge) => Bt(De.value, "sharecli"))
                        }, f(re.value === "sharecli" ? s(u)("access.copied") : s(u)("access.copy")), 1)
                      ])
                    ]),
                    o("div", bA, [
                      Ve(o("input", {
                        "onUpdate:modelValue": ne[8] || (ne[8] = (ge) => S.value = ge),
                        type: "text",
                        class: "fe-share__input",
                        autocomplete: "off",
                        placeholder: p("e-posta(lar) — virgülle ayırın", "email(s) — comma separated"),
                        onKeyup: Ut($t, ["enter"])
                      }, null, 40, gA), [
                        [rt, S.value]
                      ]),
                      o("button", {
                        type: "button",
                        class: "fe-share__btn",
                        disabled: w.value,
                        onClick: $t
                      }, f(p("Gönder", "Send")), 9, kA)
                    ]),
                    j.value ? (c(), d("div", _A, f(j.value), 1)) : g("", !0),
                    un.value ? (c(), d("button", {
                      key: 1,
                      type: "button",
                      class: "fe-share__btn fe-share__btn--wide",
                      onClick: ne[9] || (ne[9] = (ge) => Le(xe()))
                    }, [
                      o("span", {
                        "aria-hidden": "true",
                        innerHTML: s(Ue)("access")
                      }, null, 8, wA),
                      o("span", null, f(p("Paylaş", "Share")), 1)
                    ])) : g("", !0)
                  ], 64)) : g("", !0),
                  o("div", $A, [
                    o("h4", xA, f(p("Mevcut bağlantılar", "Existing links")), 1),
                    Z.value.length ? g("", !0) : (c(), d("p", SA, f(p("Yok", "None")), 1)),
                    (c(!0), d(ae, null, Te(Z.value, (ge) => (c(), d("div", {
                      key: ge.uuid,
                      class: "fe-share__row"
                    }, [
                      o("span", {
                        class: "fe-share__url",
                        title: ge.url
                      }, f(ge.url), 9, CA),
                      o("button", {
                        type: "button",
                        class: "fe-share__mini",
                        onClick: (Oe) => Bt(ge.url, ge.uuid)
                      }, f(re.value === ge.uuid ? s(u)("access.copied") : s(u)("access.copy")), 9, TA),
                      o("button", {
                        type: "button",
                        class: "fe-share__del",
                        disabled: he.value,
                        title: p("İptal", "Revoke"),
                        "aria-label": p("İptal", "Revoke"),
                        onClick: (Oe) => Ot(ge)
                      }, [
                        o("span", {
                          "aria-hidden": "true",
                          innerHTML: s(Ue)("close")
                        }, null, 8, EA)
                      ], 8, MA)
                    ]))), 128))
                  ])
                ])) : g("", !0)
              ]),
              D.value ? (c(), d("section", zA, [
                o("button", {
                  type: "button",
                  class: "fe-share__sechead",
                  "aria-expanded": y.value.people ? "true" : "false",
                  "data-testid": "share-people-toggle",
                  onClick: ne[10] || (ne[10] = (ge) => A("people"))
                }, [
                  (c(), d("svg", {
                    class: we(["fe-share__caret", { "is-open": y.value.people }]),
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [...ne[31] || (ne[31] = [
                    o("path", { d: "M9 6l6 6-6 6" }, null, -1)
                  ])], 2)),
                  o("span", PA, f(s(u)("access.section.people")), 1),
                  o("span", LA, f(nn.value), 1)
                ], 8, AA),
                y.value.people ? (c(), d("div", DA, [
                  x.value ? g("", !0) : (c(), d("div", OA, f(p("Bu diskte RBAC kapalı — izinler yalnızca RBAC açık disklerde geçerli.", "RBAC is off on this storage — grants only apply when RBAC is enabled.")), 1)),
                  B.value ? (c(), d("div", BA, f(B.value), 1)) : g("", !0),
                  C.value ? (c(), d("p", IA, f(p("Yükleniyor…", "Loading…")), 1)) : (c(), d(ae, { key: 3 }, [
                    o("div", HA, [
                      o("div", FA, [
                        Ve(o("input", {
                          "onUpdate:modelValue": ne[11] || (ne[11] = (ge) => E.value = ge),
                          type: "email",
                          class: "fe-share__input",
                          autocomplete: "off",
                          placeholder: p("İsim veya e-posta", "Name or email"),
                          onInput: Ye,
                          onKeyup: Ut(fe, ["enter"]),
                          onFocus: Ye
                        }, null, 40, NA), [
                          [rt, E.value]
                        ]),
                        G.value ? (c(), d("ul", KA, [
                          (c(!0), d(ae, null, Te(J.value, (ge) => (c(), d("li", {
                            key: ge.id,
                            onMousedown: Re((Oe) => lt(ge), ["prevent"])
                          }, [
                            o("span", UA, f((ge.display_name || ge.email).charAt(0).toUpperCase()), 1),
                            o("span", VA, [
                              o("span", jA, f(ge.display_name || ge.email), 1),
                              o("span", YA, f(ge.email) + " · " + f(ge.role), 1)
                            ])
                          ], 40, RA))), 128))
                        ])) : g("", !0)
                      ]),
                      Ve(o("select", {
                        "onUpdate:modelValue": ne[12] || (ne[12] = (ge) => $.value = ge),
                        class: "fe-share__select",
                        title: (_e = P.find((ge) => ge.v === $.value)) == null ? void 0 : _e.d
                      }, [
                        (c(), d(ae, null, Te(P, (ge) => o("option", {
                          key: ge.v,
                          value: ge.v
                        }, f(ge.l), 9, qA)), 64))
                      ], 8, WA), [
                        [on, $.value]
                      ]),
                      o("button", {
                        type: "button",
                        class: "fe-share__btn fe-share__btn--primary",
                        disabled: M.value,
                        onClick: fe
                      }, f(p("Ekle", "Add")), 9, GA)
                    ]),
                    T.value ? (c(), d("div", XA, [
                      o("p", JA, f(p("Bu e-postada hesap yok. Ne yapmak istersiniz?", "No account for this email — what next?")), 1),
                      o("div", ZA, [
                        Ve(o("select", {
                          "onUpdate:modelValue": ne[13] || (ne[13] = (ge) => Y.value = ge),
                          class: "fe-share__select"
                        }, [
                          o("option", QA, f(p("Kullanıcı", "User")), 1),
                          o("option", eP, f(p("Görüntüleyen", "Viewer")), 1)
                        ], 512), [
                          [on, Y.value]
                        ]),
                        o("button", {
                          type: "button",
                          class: "fe-share__btn fe-share__btn--primary",
                          disabled: M.value,
                          onClick: Pe
                        }, f(p("Kullanıcı oluştur + yetki ver", "Create user + grant")), 9, tP)
                      ]),
                      o("button", {
                        type: "button",
                        class: "fe-share__linkbtn",
                        disabled: M.value,
                        onClick: Be
                      }, f(p("Sadece paylaşım linki gönder →", "Just send a share link →")), 9, nP)
                    ])) : g("", !0),
                    z.value ? (c(), d("div", aP, f(z.value), 1)) : g("", !0),
                    (Me = O.value) != null && Me.tempPassword ? (c(), d("div", oP, [
                      Je(f(p("Geçici parola:", "Temp password:")) + " ", 1),
                      o("code", sP, f(O.value.tempPassword), 1)
                    ])) : g("", !0),
                    o("div", rP, [
                      o("h4", iP, f(p("Erişimi olanlar", "People with access")), 1),
                      !I.value.length && !U.value.length ? (c(), d("p", lP, f(p("Henüz kimseyle paylaşılmadı.", "Not shared with anyone yet.")), 1)) : g("", !0),
                      (c(!0), d(ae, null, Te(I.value, (ge) => (c(), d("div", {
                        key: "d" + ge.id,
                        class: "fe-share__row"
                      }, [
                        o("span", cP, f(qt(ge)), 1),
                        o("span", {
                          class: "fe-share__person",
                          title: ge.user_email
                        }, f(ft(ge)), 9, uP),
                        o("select", {
                          class: "fe-share__select fe-share__select--sm",
                          value: ge.level,
                          onChange: (Oe) => ht(ge, Oe.target.value)
                        }, [
                          (c(), d(ae, null, Te(P, (Oe) => o("option", {
                            key: Oe.v,
                            value: Oe.v
                          }, f(Oe.l), 9, fP)), 64))
                        ], 40, dP),
                        o("button", {
                          type: "button",
                          class: "fe-share__del",
                          disabled: M.value,
                          title: p("Kaldır", "Remove"),
                          "aria-label": p("Kaldır", "Remove"),
                          onClick: (Oe) => Ft(ge)
                        }, [
                          o("span", {
                            "aria-hidden": "true",
                            innerHTML: s(Ue)("close")
                          }, null, 8, vP)
                        ], 8, pP)
                      ]))), 128)),
                      (c(!0), d(ae, null, Te(U.value, (ge) => (c(), d("div", {
                        key: "i" + ge.id,
                        class: "fe-share__row fe-share__row--dim"
                      }, [
                        o("span", hP, f(qt(ge)), 1),
                        o("span", {
                          class: "fe-share__person",
                          title: ge.user_email
                        }, f(ft(ge)), 9, mP),
                        o("span", yP, f(le(ge.level)), 1),
                        o("span", {
                          class: "fe-share__from",
                          title: p("Üst klasörden gelir", "Inherited from") + ": " + (ge.path_prefix || "/")
                        }, f(ge.path_prefix || "/"), 9, bP)
                      ]))), 128))
                    ])
                  ], 64))
                ])) : g("", !0)
              ])) : g("", !0),
              e.isDir ? (c(), d("section", gP, [
                o("button", {
                  type: "button",
                  class: "fe-share__sechead",
                  "aria-expanded": y.value.drop ? "true" : "false",
                  "data-testid": "share-drop-toggle",
                  onClick: ne[14] || (ne[14] = (ge) => A("drop"))
                }, [
                  (c(), d("svg", {
                    class: we(["fe-share__caret", { "is-open": y.value.drop }]),
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [...ne[32] || (ne[32] = [
                    o("path", { d: "M9 6l6 6-6 6" }, null, -1)
                  ])], 2)),
                  o("span", _P, f(s(u)("access.section.drop")), 1),
                  o("span", wP, f(mn.value), 1)
                ], 8, kP),
                y.value.drop ? (c(), d("div", $P, [
                  o("p", xP, f(p("Bu klasöre herkesin dosya YÜKLEYEBİLECEĞİ herkese açık bir bağlantı. Yükleyenler klasördeki mevcut dosyaları göremez.", "A public link that lets anyone UPLOAD files into this folder. Uploaders never see the folder's existing files.")), 1),
                  o("div", SP, [
                    o("label", CP, [
                      Ve(o("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ne[15] || (ne[15] = (ge) => ie.value = ge)
                      }, null, 512), [
                        [An, ie.value]
                      ]),
                      o("span", null, f(p("PIN ile koru", "Protect with a PIN")), 1)
                    ]),
                    o("label", TP, [
                      o("span", MP, f(p("Süre", "Expiry")), 1),
                      Ve(o("select", {
                        "onUpdate:modelValue": ne[16] || (ne[16] = (ge) => ce.value = ge),
                        class: "fe-share__select",
                        "data-testid": "drop-expiry"
                      }, [
                        (c(!0), d(ae, null, Te(Se.value, (ge) => (c(), d("option", {
                          key: ge.v,
                          value: ge.v
                        }, f(ge.l), 9, EP))), 128))
                      ], 512), [
                        [
                          on,
                          ce.value,
                          void 0,
                          { number: !0 }
                        ]
                      ])
                    ])
                  ]),
                  ze.value ? (c(), d("p", zP, f(ze.value), 1)) : g("", !0),
                  o("button", {
                    type: "button",
                    class: "fe-share__btn fe-share__btn--primary fe-share__btn--wide",
                    "data-testid": "drop-create",
                    disabled: Ze.value,
                    onClick: Dt
                  }, f(p("Bağlantı oluştur", "Create link")), 9, AP),
                  o("button", {
                    type: "button",
                    class: "fe-share__linkbtn",
                    "aria-expanded": L.value ? "true" : "false",
                    onClick: ne[17] || (ne[17] = (ge) => L.value = !L.value)
                  }, f(L.value ? p("Yükleme sınırlarını gizle", "Hide upload limits") : p("Yükleme sınırları", "Upload limits")), 9, PP),
                  L.value ? (c(), d("div", LP, [
                    o("label", DP, [
                      o("span", OP, f(p("En fazla dosya", "Max files")), 1),
                      Ve(o("input", {
                        "onUpdate:modelValue": ne[18] || (ne[18] = (ge) => se.value = ge),
                        type: "number",
                        min: "1",
                        class: "fe-share__input fe-share__input--sm",
                        placeholder: "20"
                      }, null, 512), [
                        [rt, se.value]
                      ])
                    ]),
                    o("label", BP, [
                      o("span", IP, f(p("Dosya başı MB", "MB / file")), 1),
                      Ve(o("input", {
                        "onUpdate:modelValue": ne[19] || (ne[19] = (ge) => Ce.value = ge),
                        type: "number",
                        min: "1",
                        class: "fe-share__input fe-share__input--sm",
                        placeholder: "500"
                      }, null, 512), [
                        [rt, Ce.value]
                      ])
                    ]),
                    o("label", HP, [
                      o("span", FP, f(p("İzinli türler", "Allowed types")), 1),
                      Ve(o("input", {
                        "onUpdate:modelValue": ne[20] || (ne[20] = (ge) => We.value = ge),
                        type: "text",
                        class: "fe-share__input fe-share__input--sm",
                        placeholder: p("hepsi (örn. pdf, jpg)", "all (e.g. pdf, jpg)")
                      }, null, 8, NP), [
                        [rt, We.value]
                      ])
                    ]),
                    o("label", KP, [
                      Ve(o("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ne[21] || (ne[21] = (ge) => Ie.value = ge)
                      }, null, 512), [
                        [An, Ie.value]
                      ]),
                      o("span", null, f(p("Yükleyenin adını sor", "Ask uploader name")), 1)
                    ])
                  ])) : g("", !0),
                  vt.value ? (c(), d("div", RP, f(vt.value), 1)) : g("", !0),
                  Xe.value ? (c(), d(ae, { key: 3 }, [
                    o("div", UP, [
                      o("a", {
                        href: Xe.value.url,
                        target: "_blank",
                        rel: "noopener",
                        class: "fe-share__url",
                        title: Xe.value.url
                      }, f(Xe.value.url), 9, VP),
                      o("button", {
                        type: "button",
                        class: "fe-share__copy",
                        "data-testid": "drop-copy",
                        onClick: ne[22] || (ne[22] = (ge) => Bt(Xe.value.url, "drop"))
                      }, [
                        o("span", {
                          "aria-hidden": "true",
                          innerHTML: s(Ue)("copy")
                        }, null, 8, jP),
                        o("span", null, f(re.value === "drop" ? s(u)("access.copied") : s(u)("access.copy")), 1)
                      ])
                    ]),
                    o("p", YP, [
                      Je(f(jt(Xe.value)) + " ", 1),
                      Xe.value.clamped ? (c(), d("span", WP, f(p("(sunucu sınırı uygulandı)", "(server limit applied)")), 1)) : g("", !0)
                    ]),
                    Xe.value.pin ? (c(), d("div", qP, [
                      ne[33] || (ne[33] = o("span", { class: "fe-share__pinlabel" }, "PIN", -1)),
                      o("code", GP, f(Xe.value.pin), 1),
                      o("button", {
                        type: "button",
                        class: "fe-share__mini",
                        onClick: ne[23] || (ne[23] = (ge) => Bt(Xe.value.pin, "droppin"))
                      }, f(re.value === "droppin" ? s(u)("access.copied") : s(u)("access.copy")), 1)
                    ])) : g("", !0),
                    o("div", XP, [
                      Ve(o("input", {
                        "onUpdate:modelValue": ne[24] || (ne[24] = (ge) => Ae.value = ge),
                        type: "text",
                        class: "fe-share__input",
                        autocomplete: "off",
                        placeholder: p("e-posta(lar) — virgülle ayırın", "email(s) — comma separated"),
                        onKeyup: Ut(At, ["enter"])
                      }, null, 40, JP), [
                        [rt, Ae.value]
                      ]),
                      o("button", {
                        type: "button",
                        class: "fe-share__btn",
                        disabled: V.value,
                        onClick: At
                      }, f(p("Gönder", "Send")), 9, ZP)
                    ]),
                    R.value ? (c(), d("div", QP, f(R.value), 1)) : g("", !0),
                    un.value ? (c(), d("button", {
                      key: 2,
                      type: "button",
                      class: "fe-share__btn fe-share__btn--wide",
                      onClick: ne[25] || (ne[25] = (ge) => Le(de()))
                    }, [
                      o("span", {
                        "aria-hidden": "true",
                        innerHTML: s(Ue)("access")
                      }, null, 8, eL),
                      o("span", null, f(p("Paylaş", "Share")), 1)
                    ])) : g("", !0)
                  ], 64)) : g("", !0),
                  o("div", tL, [
                    o("h4", nL, f(p("Mevcut bağlantılar", "Existing links")), 1),
                    W.value.length ? g("", !0) : (c(), d("p", aL, f(p("Yok", "None")), 1)),
                    (c(!0), d(ae, null, Te(W.value, (ge) => (c(), d("div", {
                      key: ge.uuid,
                      class: "fe-share__row"
                    }, [
                      o("span", {
                        class: "fe-share__url",
                        title: ge.url
                      }, f(ge.url), 9, oL),
                      o("button", {
                        type: "button",
                        class: "fe-share__mini",
                        onClick: (Oe) => Bt(ge.url, ge.uuid)
                      }, f(re.value === ge.uuid ? s(u)("access.copied") : s(u)("access.copy")), 9, sL),
                      o("button", {
                        type: "button",
                        class: "fe-share__del",
                        disabled: he.value,
                        title: p("İptal", "Revoke"),
                        "aria-label": p("İptal", "Revoke"),
                        onClick: (Oe) => Ot(ge)
                      }, [
                        o("span", {
                          "aria-hidden": "true",
                          innerHTML: s(Ue)("close")
                        }, null, 8, iL)
                      ], 8, rL)
                    ]))), 128))
                  ])
                ])) : g("", !0)
              ])) : g("", !0)
            ])
          ]),
          o("footer", lL, [
            o("button", {
              type: "button",
              class: "fe-share__btn fe-share__btn--primary",
              "data-testid": "share-done",
              onClick: ne[26] || (ne[26] = (ge) => r("close"))
            }, f(s(u)("access.done")), 1)
          ])
        ], 8, E6)
      ]);
    };
  }
}), uL = ["title", "aria-label"], dL = { class: "fe__stack" }, fL = { class: "fe__panes" }, pL = {
  key: 0,
  class: "fe__presence"
}, vL = ["title"], hL = {
  key: 1,
  class: "fe-e2e-upgrade",
  role: "alert"
}, mL = { class: "fe-e2e-upgrade__text" }, yL = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, bL = { class: "fe-e2e-upgrade__actions" }, gL = ["disabled"], kL = ["disabled"], _L = {
  key: 2,
  class: "fe-e2e-upgrade fe-e2e-upgrade--escrow",
  role: "alert"
}, wL = { class: "fe-e2e-upgrade__text" }, $L = { class: "fe-e2e-upgrade__escrow" }, xL = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, SL = {
  key: 1,
  class: "fe-e2e-upgrade__pw"
}, CL = ["disabled"], TL = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, ML = { class: "fe-e2e-upgrade__actions" }, EL = ["disabled"], zL = ["disabled"], AL = {
  key: 3,
  class: "fe-e2e-strip",
  role: "status"
}, PL = ["innerHTML"], LL = { class: "fe-e2e-strip__label" }, DL = {
  key: 4,
  class: "fe-trashbar"
}, OL = { class: "fe-trashbar__text" }, BL = ["disabled"], IL = {
  key: 1,
  class: "fe-state"
}, HL = { class: "fe-state__title" }, FL = { class: "fe-state__path" }, NL = { class: "fe-state__hint" }, KL = { class: "fe-state__actions" }, RL = {
  key: 2,
  class: "fe-state fe-e2e-lock"
}, UL = { class: "fe-state__title" }, VL = { class: "fe-state__hint" }, jL = ["placeholder", "aria-label", "disabled"], YL = ["disabled"], WL = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, qL = {
  key: 0,
  class: "fe-state"
}, GL = { class: "fe-state__title" }, XL = { class: "fe-state__hint" }, JL = ["data-testid"], ZL = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, QL = {
  key: 1,
  d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z"
}, eD = { class: "fe-state__title" }, tD = { class: "fe-state__hint" }, nD = {
  key: 2,
  class: "fe-state"
}, aD = { class: "fe-state__title" }, oD = { class: "fe-state__hint" }, sD = {
  key: 3,
  class: "fe-state"
}, rD = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, iD = { key: 0 }, lD = { class: "fe-state__title" }, cD = {
  key: 0,
  class: "fe-state__hint"
}, uD = {
  key: 1,
  class: "fe-state__actions"
}, dD = { class: "fe-overlay__head" }, fD = { class: "fe-overlay__title" }, pD = ["title", "aria-label"], vD = {
  key: 1,
  class: "fe__dragover"
}, hD = { class: "fe__dragover-card" }, mD = ["innerHTML"], yD = ["title", "aria-label"], bD = {
  key: 3,
  class: "fe-keep-strip",
  role: "status",
  "aria-live": "polite"
}, gD = { class: "fe-keep-strip__label" }, kD = {
  key: 0,
  class: "fe-keep-strip__bar",
  "aria-hidden": "true"
}, _D = { class: "fe-recents__header" }, wD = { class: "fe-modal__head" }, $D = { class: "fe-modal__title" }, xD = { class: "fe-modal__body" }, SD = { class: "fe-toast__msg" }, ni = "brf-file-explorer:view-mode", Lu = "filex.inspector", Du = "filex.sidenav", Ou = 250, ai = "brf-file-explorer:path", CD = "application/x-brf-files", TD = 8 * 1024 * 1024, MD = 10, ED = "/files/edit", Bu = "filex.tourDone", Iu = "filex.tabs", zD = "https://docs.filex.sh/E2E-ENCRYPTION#what-escrow-can-and-cannot-do", YD = /* @__PURE__ */ qe({
  __name: "FileExplorer",
  props: {
    config: {}
  },
  emits: ["share-created", "file-opened", "error", "upload-progress", "selection-change", "navigate", "refresh"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, u = Ya(r.config), v = k(() => cn(r.config.locale));
    He(v, (i) => Hi(i), { immediate: !0 });
    const { t: p, formatSize: h } = tt(v), b = lh(u, { reload: () => ot() }), y = b.presenceUsers, A = b.degraded;
    function D(i) {
      const l = (i || "").replace(/^\/+|\/+$/g, "");
      if (l === ".trash" || l.startsWith(".trash/")) return null;
      const _ = ut(l);
      return !_ || !_.includes("://") || _.startsWith("://") ? null : _;
    }
    dt(() => {
      b.start(), b.subscribe(D(z.value));
    }), it(() => b.stop());
    const C = uh(r.config.apiBase, u), B = _v(r.config, u), I = /* @__PURE__ */ new Map(), U = Qv(r.config, u, {
      onSettled: (i) => {
        var _;
        const l = I.get(i.id);
        if (I.delete(i.id), i.status === "error")
          Ke(i.error_message || p("toast.failed"));
        else if (l)
          Ro(`${l.message} (${i.progress_total})`, l.fn);
        else {
          const F = i.op_type === "copy" ? p("toast.copied") : i.op_type === "move" ? p("toast.moved") : p("toast.deleted");
          Ke(`${F} (${i.progress_total})`);
        }
        ot(), (_ = bt.value) == null || _.reload();
      }
    }), x = m(!1), E = (r.config.rootPath || "").trim(), $ = E.replace("://", "/").replace(/^\/+|\/+$/g, ""), M = $ || r.config.initialPath || "", z = m(M), T = m(r.config.defaultAdapter || "brf"), Y = m(M), O = m([]), J = m(""), G = m(!1), N = m(""), P = m("");
    let le;
    function ve() {
      ot(le);
    }
    let he = !1;
    const oe = uv((i, l) => {
      let _ = (() => {
        try {
          const F = localStorage.getItem(ni);
          if (F === "list" || F === "grid" || F === "gallery") return F;
        } catch {
        }
        return r.config.viewMode ?? "list";
      })();
      return {
        get() {
          return i(), _;
        },
        set(F) {
          if (F !== _) {
            if (_ = F, !he)
              try {
                localStorage.setItem(ni, F);
              } catch {
              }
            l();
          }
        }
      };
    }), ue = m("comfortable"), Q = m(""), pe = m(!1), re = m(""), S = k(() => pe.value), w = m(""), j = m(""), K = k(
      () => w.value !== "" && w.value !== "trash" && w.value !== "home"
    ), Z = k(() => r.config.rememberFolderView !== !1), W = k(() => {
      if (!Z.value) return "";
      const i = String(z.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!i) return "";
      const [l, ..._] = i.split("/"), F = (r.config.storages ?? []).find((ee) => ee.name === l);
      return uu((F == null ? void 0 : F.uid) || l, _.join("/"));
    });
    function $e() {
      try {
        const i = localStorage.getItem(ni);
        if (i === "list" || i === "grid" || i === "gallery") return i;
      } catch {
      }
      return r.config.viewMode ?? "list";
    }
    let Se = "";
    function ze(i) {
      return `${i}|${oe.value}|${su()}|${ru()}`;
    }
    function Ne(i) {
      if (!i) return;
      Ny(i);
      const l = By(i);
      he = !0;
      try {
        const _ = (l == null ? void 0 : l.v) ?? $e();
        if (_ !== oe.value && (oe.value = _), l != null && l.k) iu(l.k, l.d ?? Ns(l.k));
        else {
          const F = zy();
          iu(F.key, F.dir);
        }
      } finally {
        he = !1;
      }
      Se = ze(i);
    }
    dt(() => {
      const l = `${r.config.apiBase ?? ""}/api/files/manager/view-prefs`;
      Jy({
        async load() {
          const _ = await fetch(l, {
            headers: await Rt(),
            credentials: u.credentialsMode()
          });
          if (!_.ok) return null;
          const F = await _.json();
          return (F == null ? void 0 : F.prefs) ?? null;
        },
        save(_) {
          (async () => {
            try {
              const F = JSON.stringify({ prefs: _ });
              await fetch(l, {
                method: "PUT",
                headers: { ...await Rt(), "Content-Type": "application/json" },
                credentials: u.credentialsMode(),
                body: F,
                /* ⚠ `keepalive` is what lets the save fired on `pagehide` outlive
                 * the page — but browsers cap a keepalive body at 64 KB and reject
                 * the request outright above it. The document is capped far below
                 * that (300 folders ≈ 33 KB), so this only ever guards the
                 * pathological case; sending it without keepalive is strictly
                 * better than having it rejected. */
                keepalive: F.length < 6e4
              });
            } catch {
            }
          })();
        }
      });
    }), He(
      [W, () => lu()],
      ([i, l]) => {
        l && Ne(i);
      },
      { immediate: !0, flush: "post" }
    ), He(
      () => [W.value, oe.value, su(), ru()],
      ([i, l, _, F]) => {
        if (!i || !lu()) return;
        const ee = ze(i);
        ee !== Se && (Se = ee, Fy(i, { v: l, k: _, d: F }));
      },
      /* ⚠⚠ `post`, and registered AFTER the applier, for a reason that is not
       * stylistic. A navigation changes `currentFolderKey`, which is a dependency
       * of BOTH watchers. Left pre-flush this one would run first, while the view
       * state is still the folder you just LEFT, and write that folder's view mode
       * and sort against the folder you just arrived in — every walk through the
       * tree quietly configuring the next folder with the last one's setup. Post
       * puts the applier first; by the time this runs, `appliedSig` matches and it
       * correctly does nothing. */
      { flush: "post" }
    );
    const be = m(""), De = {
      home: ".home",
      recent: ".recent",
      starred: ".starred",
      shared: ".shared"
    };
    function ie(i) {
      if (!bd(i)) return null;
      const l = String(i ?? "").replace(/^\/+|\/+$/g, ""), _ = Ty(l);
      return _ ? { kind: "tag", tag: _ } : { kind: l.slice(1), tag: "" };
    }
    const ce = k(() => {
      if (!Et.value) return "";
      const i = r.config.storages ?? [];
      return i.length === 1 ? i[0].name : "";
    }), L = k(() => {
      const i = (z.value ?? "").replace(/^\/+|\/+$/g, "");
      return $ && i === $ || ce.value && i === ce.value ? !1 : i.length > 0;
    }), se = k(() => w.value && w.value !== "trash" ? !0 : Et.value ? !(z.value ?? "").replace(/^\/+|\/+$/g, "") : !1), Ce = k(
      () => w.value === "home" ? "find" : "full"
    );
    function We() {
      if (pe.value) {
        ot(re.value);
        return;
      }
      if (w.value) {
        ot(j.value);
        return;
      }
      const i = (z.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!i || i === $ || ce.value && i === ce.value) return;
      const l = i.lastIndexOf("/");
      let _ = l === -1 ? "" : i.slice(0, l);
      $ && !(_ === $ || _.startsWith($ + "/")) && (_ = $), ot(_);
    }
    const Ie = m([]), Ze = k(
      () => (Ie.value.length ? Ie.value : O.value).filter((i) => i.type !== "dir")
    ), vt = k(() => {
      var F;
      const i = Ze.value, l = (F = nn.value) == null ? void 0 : F.path, _ = l ? i.findIndex((ee) => ee.path === l) : -1;
      return { index: _ === -1 ? 0 : _ + 1, total: _ === -1 ? 0 : i.length };
    });
    function Xe(i) {
      const l = Ze.value, _ = l.findIndex((ee) => {
        var me;
        return ee.path === ((me = nn.value) == null ? void 0 : me.path);
      });
      if (_ === -1) return;
      const F = l[_ + i];
      F && (nn.value = F);
    }
    const Ae = Oc(() => Ie.value.length ? Ie.value : O.value);
    He(
      () => [...Ae.selected.value],
      () => {
        a(
          "selection-change",
          Ae.nodes.value.map((l) => ({ path: l.path, basename: l.basename, type: l.type }))
        );
        const i = Ae.nodes.value.filter((l) => l.type === "file");
        b.setFocus(i.length === 1 ? i[0].basename : null);
      }
    );
    const V = m({ mode: null, items: [], sourcePath: null }), R = m(null), X = m(!1);
    y3({
      config: () => r.config,
      capabilities: R,
      fetchMe: () => u.jsonFetch(`${wa(r.config)}/api/auth/me`)
    });
    const ye = k(() => {
      var i;
      return ((i = R.value) == null ? void 0 : i.share_max_ttl_days) ?? 0;
    }), je = m(/* @__PURE__ */ new Set()), Qe = m(!1), at = m(!1), Ye = m(null), lt = m(0);
    async function fe() {
      try {
        const i = await Rt(), l = r.config.apiBase ?? "", _ = await fetch(`${l}/api/files/manager/star/list?limit=500`, {
          headers: i,
          // ⚠ NOT 'include'. With a bearer token the request is cross-origin for
          // every embedder that serves the UI from a different origin to the API
          // (the desktop app is one), and a credentialed request may not be
          // answered with `Access-Control-Allow-Origin: *` — which is what filex
          // sends. This one line made starred files fail silently in every such
          // install while the rest of the explorer worked.
          credentials: u.credentialsMode()
        });
        if (!_.ok) return;
        const F = await _.json(), ee = Array.isArray(F) ? F : Array.isArray(F == null ? void 0 : F.entries) ? F.entries : Array.isArray(F == null ? void 0 : F.nodes) ? F.nodes : [];
        je.value = new Set(ee.map((me) => me.id).filter((me) => typeof me == "number"));
      } catch {
      }
    }
    function Pe(i, l) {
      if (typeof i.id != "number") return;
      const _ = new Set(je.value);
      l ? _.add(i.id) : _.delete(i.id), je.value = _;
    }
    function Be(i) {
      return eo.value ? i.filter((l) => typeof l.id == "number" && l.type === "file") : [];
    }
    function ht(i) {
      const l = Be(i);
      return l.length > 0 && l.every((_) => je.value.has(_.id));
    }
    async function Ft(i) {
      const l = Be(i);
      if (l.length === 0) return;
      const _ = !ht(l), F = {
        apiBase: r.config.apiBase ?? "",
        authHeaders: () => Rt(),
        authCredentials: u.credentialsMode()
      }, ee = new Set(je.value);
      for (const Ee of l)
        _ ? ee.add(Ee.id) : ee.delete(Ee.id);
      je.value = ee;
      let me = 0;
      await Promise.all(
        l.map(async (Ee) => {
          try {
            await Dd(Ee.id, _, F);
          } catch {
            me += 1;
            const Fe = new Set(je.value);
            _ ? Fe.delete(Ee.id) : Fe.add(Ee.id), je.value = Fe;
          }
        })
      ), me > 0 && Ke(p("star.failed")), w.value === "starred" && await ir("starred");
    }
    async function ft(i) {
      if (typeof i.id == "number")
        try {
          const l = r.config.apiBase ?? "";
          await fetch(`${l}/api/files/manager/recent`, {
            method: "POST",
            headers: await Rt({ "Content-Type": "application/json" }),
            credentials: u.credentialsMode(),
            body: JSON.stringify({ node_id: i.id })
          }), lt.value += 1;
        } catch {
        }
    }
    function qt(i) {
      typeof i.id == "number" && (Ye.value = i, at.value = !0);
    }
    function Gt(i) {
      at.value = !1, oo(i);
    }
    function wt() {
      W8(), cr(!0), w.value === "tag" && be.value && oo(be.value);
    }
    function en(i) {
      const l = Fo(i) ?? {
        type: "file",
        path: i.path,
        basename: i.name,
        extension: (i.name.split(".").pop() || "").toLowerCase(),
        id: i.id
      };
      Qe.value = !1, dn(l);
    }
    function $t(i, l) {
      const _ = Fo(i);
      _ && (Qe.value = !1, wr(_, l));
    }
    const kt = k(() => {
      var l, _, F;
      if (r.config.onlyOfficeBase) return r.config.onlyOfficeBase;
      const i = (_ = (l = R.value) == null ? void 0 : l.external) == null ? void 0 : _.onlyoffice;
      return i && !Mc(i) ? null : ((F = R.value) == null ? void 0 : F.onlyoffice_url) || null;
    }), Dt = k(() => kt.value && u.endpoints.onlyOfficeConfig || null), At = k(() => {
      var _, F, ee;
      const i = r.config.drawioUrl || r.config.drawioBase;
      if (i) return i;
      const l = (F = (_ = R.value) == null ? void 0 : _.external) == null ? void 0 : F.drawio;
      return l && !Mc(l) ? null : ((ee = R.value) == null ? void 0 : ee.drawio_url) || null;
    }), Ot = k(
      () => {
        var i;
        return r.config.convertBase || ((i = R.value) == null ? void 0 : i.convert_url) || null;
      }
    ), Bt = k(() => {
      var i;
      return ((i = R.value) == null ? void 0 : i.newdoc_types) ?? null;
    }), un = k(() => {
      const i = Bt.value;
      return !i || i.length === 0 ? !1 : i.some(
        (l) => l.requires === "onlyoffice" ? !!kt.value : l.requires === "drawio" ? !!At.value : !0
      );
    }), pt = m([]), tn = m(null), xt = m(!1), jt = m(!1), Pt = m(!1), _t = m(!1), St = m(!1), sn = m(null), Nt = m(!1), nn = m(null), mn = m("edit"), xe = m(!1), de = m(null), Le = m(!1), q = m(null), ne = m(!1), H = m("move"), te = m([]), _e = m(!1), Me = m(
      (() => {
        try {
          return localStorage.getItem(Lu) === "1";
        } catch {
          return !1;
        }
      })()
    );
    function ge(i) {
      try {
        localStorage.setItem(Lu, i ? "1" : "0");
      } catch {
      }
    }
    function Oe() {
      Me.value = !Me.value, ge(Me.value);
    }
    function mt() {
      Me.value || (Me.value = !0, ge(!0));
    }
    function Xt() {
      Me.value && (Me.value = !1, ge(!1));
    }
    const sa = k(() => eb(r.config.uiProfile)), Ja = k(() => sa.value === "simple"), sl = k(() => r.config.showInfoPanel !== !1), Za = m(
      (() => {
        try {
          const i = localStorage.getItem(Du);
          if (i === "1") return !0;
          if (i === "0") return !1;
        } catch {
        }
        return !0;
      })()
    );
    function Ud(i) {
      try {
        localStorage.setItem(Du, i ? "1" : "0");
      } catch {
      }
    }
    const ra = m(!1), Qa = k(() => r.config.sideNav ?? !E), tr = k(
      () => Qa.value && (rn.value ? ra.value : !0)
    ), rl = k(
      () => Qa.value && r.config.trashVisible !== !1
    ), Vd = k(
      () => rn.value ? ra.value : Za.value
    );
    function il() {
      if (Qa.value) {
        if (rn.value) {
          ra.value = !ra.value;
          return;
        }
        Za.value = !Za.value, Ud(Za.value);
      }
    }
    function ia() {
      ra.value = !1;
    }
    const nr = m([]), jd = k(() => r.config.connections ?? !Ja.value), ll = k(
      () => {
        var i;
        return (r.config.callerKind ?? ((i = R.value) == null ? void 0 : i.caller_kind)) === "app";
      }
    ), eo = k(() => !ll.value), $a = m(!1), to = m(!1);
    function Yd() {
      to.value = !1, $a.value = !0;
    }
    function Wd() {
      ll.value || ($a.value = !1, to.value = !0);
    }
    function Do() {
      $a.value = !1, to.value = !1;
    }
    const qd = k(() => $a.value || to.value);
    function Gd(i) {
      const l = i instanceof Error ? i.message : String(i);
      a("error", { message: l, context: { op: "connections" } }), Ke(l);
    }
    const ar = k(
      () => Ja.value ? ["list", "grid"] : void 0
    );
    dv(() => {
      Ja.value && oe.value === "gallery" && (oe.value = "grid");
    });
    const no = m({ ...na }), ao = m(null), Oo = m("name"), Xd = k(() => Q.value ? "relevance" : "sort");
    function Jd() {
      ao.value = null, cl({ ...na });
    }
    function cl(i) {
      no.value = i, Ae.clear();
    }
    He(
      () => `${z.value}|${w.value}`,
      () => {
        $o(no.value) && (no.value = { ...na }), Q.value || (ao.value = null);
      }
    );
    const Bo = m(!1), ul = m(""), Zd = k(() => !0);
    function Qd(i, l) {
      const _ = String(i.path ?? "").replace(/^\/+/, ""), F = typeof i.storage == "string" && i.storage ? i.storage : l, ee = String(i.name ?? _.split("/").pop() ?? ""), me = ee.lastIndexOf("."), Ee = typeof i.backend_mtime == "string" ? i.backend_mtime : i.updated_at, Fe = typeof Ee == "string" ? Date.parse(Ee) : NaN;
      return {
        id: typeof i.id == "number" ? i.id : void 0,
        path: F ? `${F}://${_}` : _,
        basename: ee,
        relativePath: _,
        type: i.type === "dir" ? "dir" : "file",
        extension: me > 0 ? ee.slice(me + 1).toLowerCase() : "",
        size: typeof i.size == "number" ? i.size : 0,
        // ⚠ Left UNSET when the row carries no parseable timestamp rather than
        // defaulted to 0 or to now: `matchesModified` treats a missing timestamp
        // as "unknown" and drops the row from a date filter, which is the honest
        // answer. Stamping it with `Date.now()` would file every such file under
        // "Today".
        last_modified: Number.isNaN(Fe) ? void 0 : Fe,
        mime_type: typeof i.mime == "string" ? i.mime : "",
        /* The content snippet the hit came with, so a content match can show why
           it matched. Undefined on name-only hits, exactly as the backend sends. */
        snippet: typeof i.snippet == "string" && i.snippet ? i.snippet : void 0,
        /* Owner, so the People filter and the Owner column mean the same thing in a
           content result as they do in a folder listing. Undefined rather than
           guessed when the backend does not send it. */
        owner_id: typeof i.owner_id == "number" ? i.owner_id : void 0,
        owner_name: typeof i.owner_name == "string" ? i.owner_name : void 0,
        owner_self: i.owner_self === !0 ? !0 : void 0
      };
    }
    async function dl(i, l, _) {
      var me;
      if (i === "name") {
        const Ee = await u.search(_, l);
        return $s(Ee.files);
      }
      const F = await u.globalSearch(l, { limit: Ou, scope: i }), ee = T.value || ((me = (r.config.storages ?? [])[0]) == null ? void 0 : me.name) || "";
      return $s(F.map((Ee) => Qd(Ee, ee)));
    }
    function ef() {
      const i = z.value ?? "";
      return Et.value ? Uo(i) : ut(i);
    }
    async function tf(i) {
      const l = js(i), _ = await dl(i.scope, l, ef()), F = i.scope === "name" ? 250 : Ou;
      return {
        count: hi(_, i.filters).length,
        capped: Wx(_.length, F)
      };
    }
    function nf(i) {
      ul.value = ut(z.value ?? "") || "", fl.value = i, Bo.value = !0;
    }
    const fl = m("");
    function af(i) {
      Bo.value = !1, Oo.value = i.scope, ao.value = $o(i.filters) ? { ...i.filters } : null;
      const l = js(i);
      l === Q.value ? ot() : Q.value = l;
    }
    function of(i) {
      ao.value = null, Oo.value = "name", w.value !== "home" && (Q.value = i);
    }
    const pl = k(() => {
      if (w.value || se.value) return "";
      const i = T.value;
      if (!i) return "";
      const l = (r.config.storages ?? []).find((_) => _.name === i);
      return (l == null ? void 0 : l.label) || i;
    }), or = m("");
    function sf(i) {
      or.value = i, Xo.value = !0;
    }
    const Io = m(void 0);
    function rf() {
      const i = ut(z.value);
      if (!i) return;
      const l = z.value.split("/").filter(Boolean);
      q.value = {
        path: i,
        basename: l.length ? l[l.length - 1] : T.value,
        type: "dir"
      }, Io.value = "drop", Le.value = !0;
    }
    function lf(i) {
      a("share-created", { path: i.path, url: i.url, pin: null }), Ke(p("inspector.copied"));
    }
    const Ho = m(null);
    async function cf() {
      if (!eo.value) {
        Ho.value = null;
        return;
      }
      const i = await u.quotaMe();
      if (!i) {
        Ho.value = null;
        return;
      }
      const l = !!i.unlimited || i.quota_bytes <= 0;
      Ho.value = l && i.used_bytes <= 0 ? null : { used: i.used_bytes, total: i.quota_bytes, unlimited: l };
    }
    function Fo(i) {
      return j8(i, {
        storages: r.config.storages ?? [],
        multiStorageRoot: Et.value
      });
    }
    async function sr(i) {
      const l = r.config.apiBase ?? "", _ = i === "shared" ? `${l}/api/files/manager/shared-with-me?limit=200` : i === "starred" ? `${l}/api/files/manager/star/list?limit=200` : `${l}/api/files/manager/recent?limit=50`, F = await fetch(_, {
        headers: await Rt(),
        // ⚠ NOT 'include' — same reason as loadStarred: a credentialed
        // cross-origin request cannot be answered with `ACAO: *`.
        credentials: u.credentialsMode()
      });
      if (!F.ok) throw new Error(String(F.status));
      const ee = await F.json();
      return i === "shared" ? (nr.value = Array.isArray(ee == null ? void 0 : ee.storages) ? ee.storages : [], Array.isArray(ee == null ? void 0 : ee.files) ? ee.files : []) : (Array.isArray(ee == null ? void 0 : ee.nodes) ? ee.nodes : []).map(Fo).filter((Ee) => Ee !== null);
    }
    const vl = m([]), hl = m([]), rr = m(!1), uf = k(() => r.config.storages ?? []);
    async function df() {
      rr.value = !0;
      try {
        const [i, l] = await Promise.all([
          sr("recent").catch(() => []),
          sr("starred").catch(() => [])
        ]);
        vl.value = i, hl.value = l;
      } finally {
        rr.value = !1;
      }
    }
    async function ir(i) {
      if (ia(), i === "home") {
        w.value || (j.value = z.value ?? ""), w.value = "home", be.value = "", pe.value = !1, yt.value = "", ur(), Ae.clear(), O.value = [], Y.value = De.home, z.value = De.home, T.value = "", await df();
        return;
      }
      if (i === "tag") {
        be.value && await oo(be.value);
        return;
      }
      if (i === "trash") {
        _f(), await Yn(), w.value = "trash", be.value = "";
        return;
      }
      x.value = !0, w.value || (j.value = z.value ?? ""), w.value = i, be.value = "", pe.value = !1, yt.value = "", ur(), Ae.clear();
      try {
        O.value = await sr(i), Y.value = De[i], z.value = De[i], T.value = "";
      } catch (l) {
        const _ = l instanceof Error ? l.message : String(l);
        O.value = [], a("error", { message: _, context: { op: `nav-view:${i}` } }), Ke(_);
      } finally {
        x.value = !1;
      }
    }
    async function oo(i) {
      ia();
      const l = String(i ?? "").trim();
      if (l) {
        x.value = !0, w.value || (j.value = z.value ?? ""), w.value = "tag", be.value = l, pe.value = !1, yt.value = "", ur(), Ae.clear();
        try {
          const _ = await G8(l, {
            apiBase: r.config.apiBase ?? "",
            authHeaders: () => Rt(),
            authCredentials: u.credentialsMode()
          });
          O.value = _.map(Fo).filter((ee) => ee !== null);
          const F = Cy(l);
          Y.value = F, z.value = F, T.value = "";
        } catch (_) {
          const F = _ instanceof Error ? _.message : String(_);
          O.value = [], a("error", { message: F, context: { op: `nav-view:tag:${l}` } }), Ke(F);
        } finally {
          x.value = !1;
        }
      }
    }
    const ml = m([]), lr = m(!1);
    async function cr(i = !1) {
      tr.value && (ml.value = await q8({
        apiBase: r.config.apiBase ?? "",
        authHeaders: () => Rt(),
        authCredentials: u.credentialsMode(),
        force: i
      }), lr.value = !0);
    }
    function ff(i) {
      if (i === "myfiles") {
        ia(), ot("");
        return;
      }
      ir(i);
    }
    function yl(i) {
      ia(), ot(Et.value ? i : "");
    }
    async function pf() {
      try {
        const i = r.config.apiBase ?? "", l = await fetch(`${i}/api/files/manager/shared-with-me?limit=1`, {
          headers: await Rt(),
          credentials: u.credentialsMode()
        });
        if (!l.ok) return;
        const _ = await l.json();
        nr.value = Array.isArray(_ == null ? void 0 : _.storages) ? _.storages : [];
      } catch {
      }
    }
    function bl(i) {
      const l = (i ?? "").replace(/^\/+|\/+$/g, "");
      if (!l) return Et.value ? p("breadcrumb.root") : T.value || p("breadcrumb.root");
      const _ = l.split("/").pop() || l;
      return Fs(_, p) || _;
    }
    function vf(i) {
      q.value = i, Le.value = !0;
    }
    function No(i) {
      return G.value ? !1 : i === void 0 || i === "editor" || i === "owner";
    }
    function ur() {
      J.value = "", G.value = !1;
    }
    const hf = k(() => !!w.value && w.value !== "trash");
    function gl(i) {
      return typeof i.perm == "string" ? i.perm : hf.value ? void 0 : J.value;
    }
    function kl(i) {
      if (i.read_only === !0) return !0;
      const l = typeof i.storage == "string" ? i.storage : "";
      return l ? (r.config.storages ?? []).some((_) => _.name === l && _.readOnly === !0) : !1;
    }
    function dr(i) {
      return No(gl(i)) && !kl(i);
    }
    const _l = { none: 0, viewer: 1, editor: 2, owner: 3 };
    function mf(i) {
      if (i.length === 0) return J.value;
      let l, _ = !1;
      for (const F of i) {
        const ee = gl(F);
        if (ee === void 0) {
          _ = !0;
          continue;
        }
        (l === void 0 || (_l[ee] ?? 0) < (_l[l] ?? 0)) && (l = ee);
      }
      return l ?? (_ ? void 0 : J.value);
    }
    function yf(i) {
      return i.some(kl);
    }
    const xn = k(() => No(J.value)), Ko = k(
      () => xn.value && !se.value && !pe.value
    ), la = m(null), Kt = m(null), wl = m(null), rn = m(!1), $l = m(!1);
    let xa, yn;
    function fr(i) {
      $l.value = !!(i && "matches" in i && i.matches);
    }
    dt(() => {
      var i;
      typeof ResizeObserver < "u" && Kt.value && (xa = new ResizeObserver((l) => {
        var F, ee, me;
        const _ = ((ee = (F = l[0]) == null ? void 0 : F.contentRect) == null ? void 0 : ee.width) ?? ((me = Kt.value) == null ? void 0 : me.clientWidth) ?? 0;
        rn.value = _ > 0 && _ < 560;
      }), xa.observe(Kt.value)), typeof window < "u" && window.matchMedia && (yn = window.matchMedia("(pointer: coarse)"), fr(yn), (i = yn.addEventListener) == null || i.call(yn, "change", fr));
    }), it(() => {
      var i;
      xa == null || xa.disconnect(), xa = void 0, (i = yn == null ? void 0 : yn.removeEventListener) == null || i.call(yn, "change", fr), yn = void 0;
    });
    const Sn = m(null);
    let Sa;
    function xl(i, l) {
      Sn.value = i, Sa && clearTimeout(Sa), Sa = setTimeout(() => Sn.value = null, l);
    }
    function Ke(i) {
      xl({ message: i }, 2500);
    }
    function Ro(i, l) {
      xl({ message: i, actionLabel: p("toast.undo"), action: l }, 8e3);
    }
    function pr() {
      Sa && (clearTimeout(Sa), Sa = void 0), Sn.value = null;
    }
    async function bf() {
      var l;
      const i = (l = Sn.value) == null ? void 0 : l.action;
      if (pr(), !!i)
        try {
          await i(), Ke(p("toast.undone")), await ot();
        } catch {
          Ke(p("toast.undo_failed"));
        }
    }
    const Et = k(() => r.config.multiStorageRoot === !0);
    function gf(i) {
      const l = i.replace(/^\/+|\/+$/g, "");
      if (!l) return { adapter: "", rel: "" };
      const _ = l.indexOf("/");
      return _ === -1 ? { adapter: l, rel: "" } : { adapter: l.slice(0, _), rel: l.slice(_ + 1) };
    }
    function Uo(i) {
      if (i.includes("://")) return i;
      const { adapter: l, rel: _ } = gf(i);
      return l ? _ ? `${l}://${_}` : `${l}://` : "";
    }
    function Ca(i) {
      const l = i.indexOf("://");
      if (l === -1) return i.replace(/^\/+|\/+$/g, "");
      const _ = i.slice(0, l), F = i.slice(l + 3).replace(/^\/+|\/+$/g, "");
      return F ? `${_}/${F}` : _;
    }
    function Sl() {
      return (r.config.storages ?? []).map((l) => ({
        type: "dir",
        path: l.name,
        // virtual path (no adapter prefix)
        basename: l.label || l.name,
        extension: "",
        storage: l.name,
        visibility: "private",
        file_size: 0,
        mime_type: "inode/storage",
        extra_metadata: { driver: l.driver, readOnly: l.readOnly }
      }));
    }
    function Cl() {
      var i;
      _y(!Hs.value), ot(), (i = bt.value) == null || i.reload();
    }
    function Tl() {
      ot(), a("refresh");
    }
    async function ot(i) {
      const l = ie(i ?? z.value ?? "");
      if (l) {
        if (!(l.kind === "trash" ? r.config.trashVisible !== !1 : Qa.value))
          return hr(""), await ot("");
        l.kind === "tag" ? await oo(l.tag) : await ir(l.kind);
        return;
      }
      const _ = String(z.value ?? "").replace(/^\/+|\/+$/g, ""), F = (me) => {
        String(me ?? "").replace(/^\/+|\/+$/g, "") !== _ && (Ae.clear(), Ie.value = []);
      };
      x.value = !0, pe.value = !1, w.value = "", be.value = "";
      let ee = i ?? z.value ?? "";
      try {
        if (N.value = "", P.value = "", $) {
          const ct = String(ee).replace(/^\/+|\/+$/g, "");
          (!ct || !(ct === $ || ct.startsWith($ + "/"))) && (ee = $);
        }
        if (Et.value && !Uo(ee)) {
          if (ce.value) return await ot(ce.value);
          F(""), z.value = "", T.value = "", Y.value = "", yt.value = "", O.value = Sl();
          return;
        }
        const me = Et.value ? Uo(ee) : ut(ee), Fe = !!Q.value && Oo.value !== "name" ? {
          adapter: T.value,
          storages: (r.config.storages ?? []).map((ct) => ct.name),
          dirname: Y.value,
          read_only: !1,
          files: await dl(Oo.value, Q.value, me)
        } : Q.value ? await u.search(me, Q.value) : await u.index(me);
        T.value = Fe.adapter, Y.value = Fe.dirname, J.value = Fe.perm || "", G.value = Fe.read_only === !0, yt.value = typeof Fe.e2e_root == "string" ? Fe.e2e_root : "";
        const nt = Et.value ? Ca(Fe.dirname) : ca(Fe.dirname);
        F(nt), O.value = $s(Fe.files), hd(O.value, Fe.adapter, Fe.dirname, r.config.trashVisible !== !1, {
          isSearchResult: !!Q.value,
          navOffersTrash: rl.value
        }) && md(O.value, Fe.adapter, u), z.value = nt;
      } catch (me) {
        const Ee = me instanceof Error ? me.message : String(me), Fe = me.status;
        if (Fe === 404 || Fe === 403) {
          N.value = String(ee), F(String(ee)), yt.value = "", O.value = [], a("error", { message: Ee, context: { path: i } });
          return;
        }
        P.value = Ee, le = typeof ee == "string" ? ee : void 0, a("error", { message: Ee, context: { path: i } }), O.value.length > 0 && Ke(Ee);
      } finally {
        x.value = !1;
      }
    }
    function ca(i) {
      const l = i.indexOf("://");
      return l === -1 ? i : i.slice(l + 3);
    }
    function kf() {
      N.value = "", hr(""), ot("");
    }
    const Vo = m(null), jo = m(!1), Yo = m(!1), so = m(!1);
    async function _f() {
      Vo.value = null, jo.value = !1;
      try {
        const i = await fetch(`${r.config.apiBase ?? ""}/api/admin/protection`, {
          headers: await Rt(),
          credentials: u.credentialsMode()
        });
        if (!i.ok) return;
        const l = await i.json(), _ = l == null ? void 0 : l.trash_retention_days;
        typeof _ == "number" && _ > 0 && (Vo.value = _), jo.value = !0;
      } catch {
      }
    }
    const wf = k(
      () => Vo.value !== null ? p("trash.retention", { days: Vo.value }) : p("trash.retention_unknown")
    ), Ml = k(
      () => O.value.reduce((i, l) => {
        const _ = typeof l.size == "number" ? l.size : l.file_size;
        return i + (typeof _ == "number" ? _ : 0);
      }, 0)
    ), $f = k(() => Ml.value > 0), xf = k(
      () => $f.value ? "trash.empty_confirm_body" : "trash.empty_confirm_body_nosize"
    );
    async function Sf() {
      if (so.value = !1, !(!jo.value || Yo.value)) {
        Yo.value = !0;
        try {
          const i = await fetch(`${r.config.apiBase ?? ""}/api/admin/trash/empty`, {
            method: "POST",
            headers: await Rt(),
            credentials: u.credentialsMode()
          });
          if (!i.ok) throw new Error(String(i.status));
          await Yn(), Ke(p("trash.emptied"));
        } catch (i) {
          const l = i instanceof Error ? i.message : String(i);
          a("error", { message: l, context: { op: "trash:empty" } }), Ke(l);
        } finally {
          Yo.value = !1;
        }
      }
    }
    async function Yn() {
      x.value = !0, re.value = T.value || "", pe.value = !0, yt.value = "", Ae.clear();
      try {
        const { entries: i } = await u.listTrash();
        O.value = i.map(
          (l) => ({
            type: "file",
            id: l.id,
            path: l.storage_name ? `${l.storage_name}://${l.path}` : l.path,
            basename: l.name,
            extension: l.name.includes(".") && l.name.split(".").pop() || "",
            storage: l.storage_name || "",
            visibility: "private",
            /* tablo:t1 — ⚠ BOTH. Every view reads `size` (the Size column, the
               info panel, the empty-trash confirmation); only the upload code
               reads `file_size`. Setting one of the two left every trashed row
               with a blank Size cell and made "this permanently deletes 2 items
               (0 B)" a false statement about two real files. */
            size: l.size,
            file_size: l.size,
            mime_type: l.mime || "",
            extra_metadata: { deleted_at: l.deleted_at, ttl_days: l.ttl_days ?? null }
          })
        ), Y.value = ".trash", z.value = ".trash";
      } catch (i) {
        const l = i instanceof Error ? i.message : String(i);
        a("error", { message: l, context: { op: "trash-list" } }), Ke(l);
      } finally {
        x.value = !1;
      }
    }
    function ut(i) {
      if (i && i.includes("://")) return i;
      if (Et.value) {
        const l = Uo(i ?? "");
        return l || (T.value ? `${T.value}://` : "");
      }
      return i ? `${T.value}://${i.replace(/^\/+/, "")}` : `${T.value}://`;
    }
    function Wo(i) {
      const l = i.indexOf("://"), _ = (l === -1 ? i : i.slice(l + 3)).replace(/\/+$/, ""), F = _.lastIndexOf("/");
      return F === -1 ? _ : _.slice(F + 1);
    }
    function qo(i) {
      const l = i.indexOf("://"), _ = l === -1 ? "" : i.slice(0, l + 3), F = (l === -1 ? i : i.slice(l + 3)).replace(/\/+$/, ""), ee = F.lastIndexOf("/");
      return ee === -1 ? _ : _ + F.slice(0, ee);
    }
    function vr(i, l) {
      const _ = (F) => {
        const ee = F.indexOf("://"), me = ee === -1 ? "" : F.slice(0, ee + 3), Ee = (ee === -1 ? F : F.slice(ee + 3)).replace(/\/+$/, "");
        return me + Ee;
      };
      return _(i) === _(l);
    }
    function Ta(i, l) {
      return i ? i.endsWith("://") || i.endsWith("/") ? i + l : `${i}/${l}` : l;
    }
    async function El(i, l) {
      try {
        const _ = await u.index(l), F = new Set((_.files ?? []).map((ee) => String(ee.basename ?? "").toLowerCase()));
        return i.some((ee) => F.has(Wo(ee).toLowerCase()));
      } catch {
        return !0;
      }
    }
    function zl(i, l, _, F, ee) {
      if (!F || !_ || ee) return;
      const me = l.map((Ee) => Ta(_, Wo(Ee)));
      me.length !== 0 && I.set(i, {
        message: p("toast.moved"),
        fn: async () => {
          const { op: Ee } = await u.moveAsync(me, F, _);
          U.register(Ee);
        }
      });
    }
    He(
      () => Q.value,
      () => void ot()
    );
    function Go() {
      return r.config.pathPersist ?? "hash";
    }
    function Al() {
      const i = Go();
      return i === "hash" || i === "hash+localStorage";
    }
    function Cf(i) {
      try {
        return decodeURIComponent(i);
      } catch {
        return i;
      }
    }
    function Pl() {
      try {
        return localStorage.getItem(ai) || "";
      } catch {
        return "";
      }
    }
    function Ll() {
      const i = window.location.hash || "";
      return i.startsWith("#") ? Cf(i.slice(1)).replace(/^\/+|\/+$/g, "") : "";
    }
    function Tf() {
      if (typeof window > "u") return "";
      const i = Go();
      if (i === "none") return "";
      if (i === "localStorage") return Pl();
      const l = Ll();
      return l || i === "hash" ? l : M ? "" : Pl();
    }
    function hr(i) {
      if (typeof window > "u") return;
      const l = Go();
      if (l === "none") return;
      if (l === "localStorage" || l === "hash+localStorage") {
        try {
          i ? localStorage.setItem(ai, i) : localStorage.removeItem(ai);
        } catch {
        }
        if (l === "localStorage") return;
      }
      const _ = i ? i.split("/").map(encodeURIComponent).join("/") : "", F = _ ? `#${_}` : "";
      (window.location.hash || "") !== F && history.replaceState(
        history.state,
        "",
        F || window.location.pathname + window.location.search
      );
    }
    function Dl() {
      if (!Al()) return;
      const i = Ll();
      i && i !== z.value && ot(i);
    }
    He(z, (i) => {
      hr(i), a("navigate", { path: i }), b.subscribe(D(i));
    }), t({ reload: () => ot() }), dt(async () => {
      var l;
      Js();
      const i = Tf();
      await ot(i || void 0), await gt(), (l = Kt.value) == null || l.focus(), fe(), pf(), cr(), cf(), He(tr, (_) => {
        _ && !lr.value && cr();
      }), Al() && window.addEventListener("hashchange", Dl), u.endpoints.opsList && U.startPolling(), u.endpoints.capabilities && u.capabilities().then((_) => {
        R.value = _;
      }).catch(() => {
      });
    });
    const Xo = m(!1), Jo = m(!1);
    function Mf(i) {
      return u.globalSearch(i, { limit: 8, scope: "all" });
    }
    async function Ef(i) {
      const l = String(i.path ?? "").replace(/^\/+|\/+$/g, "");
      if (!l) return;
      const _ = i.type === "dir", F = l.lastIndexOf("/"), ee = _ ? l : F === -1 ? "" : l.slice(0, F);
      let me = ee;
      if (Et.value) {
        const nt = r.config.storages ?? [], ct = typeof i.storage == "string" && i.storage || typeof i.storage_name == "string" && i.storage_name || (nt.length === 1 ? nt[0].name : "") || T.value;
        if (!ct) return;
        me = ee ? `${ct}/${ee}` : ct;
      }
      if (await ot(me), _) return;
      const Ee = String(i.name ?? l.slice(F + 1)), Fe = O.value.find((nt) => nt.type === "file" && nt.basename === Ee);
      Fe && (Ae.click(Fe.path), dn(Fe));
    }
    Ov(Kt, {
      onDelete: () => {
        if (zt.value) {
          const i = Ht.nodes.value;
          i.length && (ua.value = i, Nt.value = !0, _t.value = !0);
        } else Ae.isEmpty.value || (Nt.value = !1, _t.value = !0);
      },
      onRename: () => {
        if (zt.value) {
          const i = Ht.nodes.value;
          i.length === 1 && (sn.value = i[0], Nt.value = !0, Pt.value = !0);
        } else Ae.nodes.value.length === 1 && (sn.value = Ae.nodes.value[0], Nt.value = !1, Pt.value = !0);
      },
      onSelectAll: () => zt.value ? Ht.selectAll() : Ae.selectAll(),
      onOpen: () => {
        if (zt.value) {
          const l = Ht.nodes.value[0];
          l && zp("split", l);
          return;
        }
        const i = Ae.nodes.value[0];
        i && dn(i);
      },
      onClose: () => {
        var i;
        if (xt.value = !1, Pt.value = !1, _t.value = !1, St.value = !1, (i = la.value) == null || i.hide(), pr(), qd.value) {
          Do();
          return;
        }
        if (ra.value) {
          ia();
          return;
        }
        rn.value && Xt();
      },
      onFocusSearch: () => {
        var i;
        return (i = wl.value) == null ? void 0 : i.focusSearch();
      },
      onCut: () => zt.value ? yc() : Vf(),
      onCopy: () => zt.value ? bc() : jf(),
      onPaste: () => zt.value ? void gc() : void Nl(),
      onGoUp: () => {
        var i;
        return zt.value ? (i = bt.value) == null ? void 0 : i.goUp() : We();
      },
      /* cila:c wiring */
      onPathJump: () => {
        or.value = "", Xo.value = !0;
      },
      onShowHelp: () => {
        Jo.value = !0;
      },
      /* /cila:c wiring */
      onQuickLook: () => pp(),
      onToggleHidden: () => Cl(),
      onStar: () => void Ft(Ae.nodes.value),
      onToggleInspector: () => Oe(),
      /* wiring:d1 — tab actions (registry: tab-new/close/next/prev) */
      onTabNew: () => Pr(),
      onTabClose: () => rc(Ar.value),
      onTabNext: () => $p(),
      onTabPrev: () => xp(),
      /* /wiring:d1 */
      /* tus:t1 — the menu verbs, routed through the SAME dispatcher the right-click
       * menu and the toolbar use (dispatchItemAction), so a key and a click cannot
       * drift apart. The ones that act on a selection do nothing without one, which
       * is what the menu does too. */
      onNewFolder: () => {
        xt.value = !0;
      },
      onUpload: () => qn(),
      onRefresh: () => void ot(),
      onDownload: () => void gn("download", Jt()),
      onPreview: () => void gn("preview", Jt()),
      onShare: () => void gn("access", Jt()),
      onTags: () => void gn("tags", Jt()),
      onConvert: () => void gn("convert", Jt()),
      onOpenTab: () => void gn("open-tab", Jt()),
      onCopyPath: () => {
        const i = Jt()[0];
        i && as(i.path);
      },
      onCopyId: () => void gn("copy-id", Jt()),
      onRestore: () => void gn("restore", Jt()),
      /* /tus:t1 */
      hasSelection: () => !Ae.isEmpty.value
    });
    function Jt() {
      return zt.value ? Ht.nodes.value : Ae.nodes.value;
    }
    const zf = /* @__PURE__ */ new Set([
      "docx",
      "xlsx",
      "pptx",
      "doc",
      "xls",
      "ppt",
      "odt",
      "ods",
      "odp"
    ]);
    function dn(i) {
      if (i.basename === ".trash") {
        Yn();
        return;
      }
      if (i.type === "dir") {
        const _ = Et.value ? Ca(i.path) : ca(i.path);
        ot(_);
        return;
      }
      if (Mn.value && i.type === "file") {
        Vr(i);
        return;
      }
      if (Ir.value && i.type === "file") return;
      if (r.config.openInHost && i.type === "file") {
        a("file-opened", { path: i.path, basename: i.basename }), ft(i);
        return;
      }
      const l = (i.extension || "").toLowerCase();
      mn.value = dr(i) ? Pf(l) : "view", nn.value = i, St.value = !0, a("file-opened", { path: i.path, basename: i.basename }), ft(i);
    }
    const Af = /* @__PURE__ */ new Set([
      ...zf,
      "drawio",
      "dio",
      "pdf",
      "epub",
      "ipynb",
      "tiff",
      "tif",
      "psd",
      "mmd",
      "mermaid",
      "glb",
      "gltf",
      "obj",
      "stl",
      "fbx",
      "3ds",
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "tgz",
      "jpg",
      "jpeg",
      "png",
      "webp",
      "gif",
      "bmp",
      "avif",
      "svg",
      "heic",
      "mp4",
      "webm",
      "mov",
      "mkv",
      "m4v",
      "ogv",
      "mp3",
      "wav",
      "ogg",
      "flac",
      "m4a",
      "aac",
      "opus"
    ]);
    function Pf(i) {
      return Af.has(i) ? "view" : "edit";
    }
    async function Lf(i) {
      const l = i ?? Ae.nodes.value;
      if (l.length !== 0)
        try {
          if (pe.value) {
            const ee = l.map((Fe) => Fe.id).filter((Fe) => typeof Fe == "number"), { restored: me, taken: Ee } = await u.restoreIds(ee);
            Ke(
              Ee.length ? p("toast.restore_taken", { n: Ee.length, name: Ee[0] }) : p("toast.restored", { n: me })
            ), Ae.clear(), await Yn();
            return;
          }
          if (!u.endpoints.restore) return;
          const _ = l.map((ee) => ee.path), { restored: F } = await u.restore(_);
          Ke(p("toast.restored", { n: F })), Ae.clear(), await ot();
        } catch (_) {
          a("error", { message: _.message, context: { op: "restore" } });
        }
    }
    function Ol(i) {
      if (Mn.value && i.type === "file") {
        Vr(i);
        return;
      }
      mn.value = "view", nn.value = i, St.value = !0, ft(i);
    }
    function Df(i) {
      if (i.type === "dir") {
        const Ee = Et.value ? Ca(i.path) : ca(i.path);
        ot(Ee);
        return;
      }
      if (Zt.value) {
        Mn.value && Vr(i);
        return;
      }
      if (r.config.openInHost) {
        dn(i);
        return;
      }
      if (!dr(i)) {
        Ol(i);
        return;
      }
      const l = (i.extension || "").toLowerCase(), _ = r.config.openPageBase;
      if (!_) {
        dn(i);
        return;
      }
      const F = Ql(_), ee = F.includes("?") ? "&" : "?", me = `${F}${ee}path=${encodeURIComponent(i.path)}&type=${encodeURIComponent(l)}&mode=edit`;
      window.open(me, "_blank", "noopener"), a("file-opened", { path: i.path, basename: i.basename }), ft(i);
    }
    const Cn = m("selection"), mr = m(""), ua = m([]), Of = m(""), Bf = k(() => {
      const i = Jt();
      return i.length === 0 ? "none" : i.length === 1 ? i[0].type === "dir" ? "single-dir" : "single-file" : "multi";
    });
    async function yr(i) {
      const l = Jt();
      if (i === "open") {
        l[0] && dn(l[0]);
        return;
      }
      await gn(i, l);
    }
    const bn = k(() => r.config.desktopSync ?? null), Zo = m([]);
    async function da() {
      if (bn.value)
        try {
          Zo.value = await bn.value.kept();
        } catch {
        }
    }
    const Ma = m(null);
    async function Bl() {
      const i = bn.value;
      if (i != null && i.status)
        try {
          Ma.value = (await i.status()).active ?? null;
        } catch {
          Ma.value = null;
        }
    }
    let Ea = null, br = !0;
    function If() {
      Ea || !br || (Ea = setTimeout(() => {
        Ea = null, br && (Bl(), da());
      }, 300));
    }
    dt(() => {
      var i, l;
      da(), Bl(), (l = (i = bn.value) == null ? void 0 : i.onChange) == null || l.call(i, If);
    }), it(() => {
      br = !1, Ea && (clearTimeout(Ea), Ea = null);
    });
    function ro(i) {
      const l = String(i.path ?? "");
      return l.includes("://") ? l.replace(/\/+$/, "") : `${l}://`;
    }
    function Qo(i, l) {
      return l.endsWith("://") ? i.startsWith(l) && i !== l : i === l ? !1 : i.startsWith(l + "/");
    }
    function gr(i) {
      return Zo.value.some((l) => l.remote === i) ? "kept" : Zo.value.some((l) => Qo(i, l.remote)) ? "inherited" : Zo.value.some((l) => Qo(l.remote, i)) ? "partial" : "none";
    }
    function Il(i) {
      if (!bn.value || S.value || i.basename === ".trash") return null;
      const l = ro(i), _ = Ma.value;
      if (_ && (l === _.remote || Qo(l, _.remote) || Qo(_.remote, l)))
        return "syncing";
      const F = gr(l);
      return F === "kept" || F === "inherited" ? "kept" : F === "partial" ? "partial" : "cloud";
    }
    const Hf = k(() => {
      const i = Ma.value;
      if (!i) return "";
      const l = i.remote.endsWith("://") ? i.remote.slice(0, -3) : i.remote.slice(i.remote.lastIndexOf("/") + 1);
      return i.phase === "transfer" && i.total > 0 ? p("keep.strip_transfer", {
        name: l,
        done: String(i.done),
        total: String(i.total),
        pct: String(Math.min(100, Math.round(i.done * 100 / i.total)))
      }) : i.phase === "settling" ? p("keep.strip_settling", { name: l }) : p("keep.strip_inventory", { name: l });
    }), Hl = k(() => {
      const i = Ma.value;
      return !i || i.phase !== "transfer" || i.total <= 0 ? null : Math.min(100, Math.round(i.done * 100 / i.total));
    });
    function kr(i) {
      var ee, me, Ee;
      const l = bn.value, _ = i.length === 1 && (((ee = i[0]) == null ? void 0 : ee.type) === "dir" || ((me = i[0]) == null ? void 0 : me.type) === "file");
      if (!l || !_ || S.value || Zt.value || ((Ee = i[0]) == null ? void 0 : Ee.e2e) === !0) return [];
      const F = gr(ro(i[0]));
      return [
        { divider: !0, key: "sep-keep", label: "" },
        { key: "keep-local", label: p("ctx.keep_local"), hidden: F === "kept" || F === "inherited" },
        { key: "keep-online", label: p("ctx.keep_online"), hidden: F !== "kept" },
        { key: "keep-inherited", label: p("ctx.keep_inherited"), disabled: !0, hidden: F !== "inherited" },
        { key: "keep-reveal", label: p("ctx.keep_reveal"), hidden: F !== "kept" && F !== "inherited" }
      ];
    }
    const _r = m([]);
    async function wr(i, l) {
      var F;
      Cn.value = "selection", da(), Ae.has(i.path) || (Ae.click(i.path), await gt()), _r.value = Ae.nodes.value.length ? [] : [i];
      const _ = Ae.nodes.value.length ? Ae.nodes.value : [i];
      (F = la.value) == null || F.show({ clientX: l.clientX, clientY: l.clientY }, _);
    }
    function Ff(i) {
      var l;
      i.preventDefault(), Cn.value = "selection", Ae.clear(), _r.value = [], (l = la.value) == null || l.show({ clientX: i.clientX, clientY: i.clientY }, []);
    }
    function Nf(i) {
      var l;
      Cn.value = "breadcrumb", mr.value = i.adapterPath, Of.value = i.label, (l = la.value) == null || l.show({ clientX: i.x, clientY: i.y }, []);
    }
    async function Fl(i, l, _) {
      var F, ee;
      if (da(), i === "split") {
        Tn.value = "split";
        const me = Ht.nodes.value;
        l && !Ht.has(l.path) && (Ht.click(l.path), await gt());
        const Ee = Ht.nodes.value;
        ua.value = l ? Ee.length > 0 ? Ee : me.length > 0 ? me : [l] : [], Cn.value = "pane", (F = la.value) == null || F.show({ clientX: _.clientX, clientY: _.clientY }, ua.value);
        return;
      }
      if (Tn.value = "main", Cn.value = "selection", !l) {
        Ae.clear(), (ee = la.value) == null || ee.show({ clientX: _.clientX, clientY: _.clientY }, []);
        return;
      }
      await wr(l, _);
    }
    const Kf = k(() => {
      if (Cn.value === "breadcrumb")
        return [
          { key: "open", label: p("ctx.open") },
          { key: "copy-path", label: p("breadcrumb.copy_path") }
        ];
      if (Cn.value === "pane") {
        const me = ua.value;
        return me.length === 0 ? [
          { key: "new-folder", label: p("toolbar.new_folder") },
          { key: "paste", label: p("ctx.paste"), disabled: !V.value.mode }
        ] : es(me);
      }
      const i = Ae.nodes.value.length ? Ae.nodes.value : _r.value, l = i.length > 0, _ = i.length === 1;
      if (S.value)
        return l ? [
          { key: "restore", label: p("ctx.restore") },
          { divider: !0, key: "sep1", label: "" },
          { key: "delete", label: p("ctx.delete_perm"), danger: !0 }
        ] : [];
      const F = (z.value ?? "").replace(/^\/+|\/+$/g, "");
      if (Et.value && F === "")
        return l ? _ ? [
          { key: "open", label: p("ctx.open") },
          { key: "open-tab", label: p("ctx.open_new_tab") },
          // A whole storage can be kept too — that IS the "sync everything"
          // shape, and it is one pair, not one per subfolder.
          ...kr(i)
        ] : [] : [];
      if (!l) {
        const me = [
          {
            key: "toggle-hidden",
            label: Hs.value ? p("ctx.hide_hidden") : p("ctx.show_hidden")
          }
        ];
        return No(J.value) ? [
          { key: "new-folder", label: p("toolbar.new_folder") },
          { key: "paste", label: p("ctx.paste"), disabled: !V.value.mode },
          ...me
        ] : me;
      }
      return es(i);
    });
    function es(i) {
      var Qt, Cc, Tc;
      const l = i.length > 0, _ = i.length === 1;
      if (i.some(Pi))
        return _ ? [
          { key: "open", label: p("ctx.open") },
          { key: "open-tab", label: p("ctx.open_new_tab") },
          ...kr(i)
        ] : [];
      const F = _ && ((Qt = i[0]) == null ? void 0 : Qt.type) === "file", ee = v.value === "en" ? "Tags…" : "Etiketler…", me = _ && typeof ((Cc = i[0]) == null ? void 0 : Cc.id) == "number", Ee = Be(i).length > 0, Fe = ht(i), nt = mf(i), ct = No(nt) && !yf(i), ke = v.value === "en" ? "Share / Permissions" : "Paylaş / İzinler";
      return [
        { key: "open", label: p("ctx.open"), hidden: !_ },
        { key: "open-tab", label: p("ctx.open_new_tab"), hidden: !_ || ((Tc = i[0]) == null ? void 0 : Tc.type) !== "dir" },
        { key: "preview", label: p("ctx.preview"), hidden: !_, disabled: !F },
        /* tasi:m1 — Download works on ANY selection now. It used to disappear the
           moment a second row was ticked, because the only implementation was one
           `window.open` per node and the browser blocks the second popup; there is
           one streaming archive behind it now (lib/downloadSelection), and the
           server expands a selected folder itself, so a lone folder is a zip too.
           ⚠ Still single-only inside an encrypted folder: those bytes are
           decrypted IN THE BROWSER, one file at a time, and the server has no
           plaintext to zip. */
        { key: "download", label: p("ctx.download"), hidden: !l || Zt.value && !_, disabled: !l },
        { key: "convert", label: p("ctx.convert"), hidden: !_ || !Ot.value || !ct || Zt.value, disabled: !F },
        /* tasi:m1 — VISIBLE and grey above a multi-selection, not gone. Sharing
           really is one item at a time (a share link addresses one node), and the
           row now says so in its tooltip; vanishing taught the reader that filex
           cannot share the thing they are looking at. */
        {
          key: "access",
          label: ke,
          hidden: !l || !ct || Zt.value,
          disabled: !_,
          title: _ ? void 0 : p("ctx.access.one_only")
        },
        { key: "details", label: p("ctx.details"), hidden: !l },
        /* ⚠ "Copy node id" is NOT here any more (owner's call, 2026-09-13): it is a
           developer's handle on a support ticket, not an everyday verb, and this
           list is rendered by BOTH the right-click menu and the selection bar — so
           one row put it in front of everyone, twice. It lives in the details
           panel now, beside Path and ETag, which is where the other technical
           facts about a file already are. The `copy-id` case below stays: the
           panel dispatches it. */
        { divider: !0, key: "sep1", label: "", hidden: !ct },
        { key: "rename", label: p("ctx.rename"), hidden: !_ || !ct, disabled: !_ },
        { key: "cut", label: p("ctx.cut"), hidden: !l || !ct, disabled: !l },
        { key: "copy", label: p("ctx.copy"), hidden: !l, disabled: !l },
        /* tasi:m1 — "somewhere else", without the clipboard. Cut+paste has always
           been able to do this, but only by navigating away from the rows you had
           just picked; these two ask WHERE in a dialog and leave the listing where
           it is.
           ⚠ `icon:` is not decoration here — `actionIconSvg` answers '' for a key
           it does not know, and a bar button with no glyph is an empty 28px box.
           They borrow the clipboard verbs' marks, which is what they are. */
        { key: "move-to", label: p("ctx.move_to"), icon: "cut", hidden: !l || !ct, disabled: !l },
        { key: "copy-to", label: p("ctx.copy_to"), icon: "copy", hidden: !l, disabled: !l },
        /* Paste needs a destination folder; a virtual view (Recent / Starred /
           Shared / a tag / Home) has none, so it is the one write verb the row
           menu does not carry there — every per-row verb above and below does. */
        { key: "paste", label: p("ctx.paste"), hidden: !ct || se.value, disabled: !V.value.mode },
        { divider: !0, key: "sep-meta", label: "", hidden: !me && !Ee },
        /* yildiz:s1 — "star must be an action, like a tag" (owner, v0.30.0).
           Beside Tags on purpose: they are the same kind of verb, and this is the
           ONLY star a grid/gallery user reaches with the keyboard. Works on a
           multi-selection; the label follows the selection's state. */
        {
          key: "star",
          label: p(Fe ? "ctx.unstar" : "ctx.star"),
          icon: Fe ? "unstar" : "star",
          hidden: !Ee
        },
        { key: "tags", label: ee, hidden: !me, disabled: !me },
        ...kr(i),
        { divider: !0, key: "sep2", label: "", hidden: !ct },
        { key: "delete", label: p("ctx.delete"), danger: !0, hidden: !l || !ct, disabled: !l }
      ];
    }
    const Rf = k(() => {
      const i = Jt();
      if (zt.value) return i.length ? es(i) : [];
      if (S.value)
        return i.length === 0 ? [] : [
          { key: "restore", label: p("ctx.restore") },
          { key: "delete", label: p("ctx.delete_perm"), danger: !0 }
        ];
      const l = (z.value ?? "").replace(/^\/+|\/+$/g, "");
      return Et.value && l === "" ? i.length === 1 ? [{ key: "open", label: p("ctx.open") }] : [] : i.length === 0 ? [] : es(i);
    });
    async function Uf(i, l) {
      if (Cn.value === "breadcrumb") {
        i.key === "open" ? ot(ca(mr.value)) : i.key === "copy-path" && await as(mr.value);
        return;
      }
      if (Cn.value === "pane") {
        await gn(i.key, ua.value);
        return;
      }
      await gn(i.key, l);
    }
    function Wn() {
      return Cn.value === "pane" || zt.value;
    }
    async function gn(i, l) {
      var _;
      switch (i) {
        case "clear-selection":
          zt.value ? Ht.clear() : Ae.clear();
          return;
        case "open":
          l[0] && Df(l[0]);
          break;
        case "preview":
          l[0] && Ol(l[0]);
          break;
        case "download":
          await qf(l);
          break;
        case "move-to":
        case "copy-to":
          if (l.length === 0) break;
          H.value = i === "move-to" ? "move" : "copy", te.value = l, _e.value = !1, ne.value = !0;
          break;
        case "keep-local": {
          const F = bn.value;
          if (!F || !l[0]) break;
          const ee = ro(l[0]);
          try {
            await F.keep(ee, l[0].type === "file" ? "file" : "dir"), await da(), gr(ee) !== "none" && Ke(p("keep.started"));
          } catch (me) {
            await da(), Ke(`${p("keep.failed")}: ${String((me == null ? void 0 : me.message) ?? me)}`);
          }
          break;
        }
        case "keep-online": {
          const F = bn.value;
          if (!F || !l[0]) break;
          try {
            await F.unkeep(ro(l[0]));
          } catch {
          }
          await da();
          break;
        }
        case "keep-reveal": {
          const F = bn.value;
          F && l[0] && F.reveal(ro(l[0]));
          break;
        }
        case "convert":
          l[0] && ep(l[0]);
          break;
        case "access":
          l[0] && (q.value = l[0], Le.value = !0);
          break;
        case "details":
          mt();
          break;
        case "copy-id":
          if (l[0] && typeof l[0].id == "number") {
            const F = l[0].id;
            (_ = navigator.clipboard) == null || _.writeText(String(F)).then(
              () => Ke(v.value === "en" ? `Node id ${F} copied` : `Node id ${F} kopyalandı`),
              () => Ke(`#${F}`)
            );
          }
          break;
        case "star":
          await Ft(l);
          break;
        case "tags":
          l[0] && qt(l[0]);
          break;
        case "rename":
          l[0] && (sn.value = l[0], Nt.value = Wn(), Pt.value = !0);
          break;
        case "cut":
          Wn() ? yc() : (V.value = { mode: "cut", items: l, sourcePath: z.value }, Ke(p("toast.cut_ready")));
          break;
        case "copy":
          Wn() ? bc() : (V.value = { mode: "copy", items: l, sourcePath: z.value }, Ke(p("toast.copy_ready")));
          break;
        case "paste":
          Wn() ? await gc() : await Nl();
          break;
        case "delete": {
          const F = Wn();
          F && (ua.value = l), Nt.value = F, _t.value = !0;
          break;
        }
        case "restore":
          l.length > 0 && await Lf(l);
          break;
        case "toggle-hidden":
          Cl();
          break;
        case "new-folder":
          Nt.value = Wn(), xt.value = !0;
          break;
        case "duplicate":
          l[0] && await Yf(l[0]);
          break;
        case "open-tab":
          l[0] && ic(l[0]);
          break;
      }
    }
    function Vf() {
      Ae.isEmpty.value || (V.value = { mode: "cut", items: Ae.nodes.value, sourcePath: z.value }, Ke(p("toast.cut")));
    }
    function jf() {
      Ae.isEmpty.value || (V.value = { mode: "copy", items: Ae.nodes.value, sourcePath: z.value }, Ke(p("toast.copied")));
    }
    async function Nl() {
      const i = V.value;
      if (!(!i.mode || i.items.length === 0))
        try {
          const l = i.items.map((Ee) => Ee.path), _ = i.sourcePath || "";
          if (i.mode === "cut" && _ === z.value) {
            Ke(p("toast.same_folder_cut"));
            return;
          }
          const ee = ut(z.value), me = Au(l, ee, i.mode === "cut" ? "move" : "copy");
          if (i.mode === "cut") {
            const Ee = ut(_) || void 0, Fe = await El(l, ee), { op: nt } = await u.moveAsync(l, ee, Ee);
            zl(nt.id, l, ee, Ee, Fe), U.register(nt), Ke(
              Fe ? p("toast.move_kept_both") : me.cross ? p("split.cross_move") : p("split.move_queued")
            );
          } else {
            const { op: Ee } = await u.copy(l, ee);
            U.register(Ee), Ke(me.cross ? p("split.cross_copy") : p("split.copy_queued"));
          }
          V.value = { mode: null, items: [], sourcePath: null };
        } catch (l) {
          a("error", { message: l.message, context: { op: "paste" } });
        }
    }
    async function Yf(i) {
      try {
        const { op: l } = await u.copy([i.path], ut(z.value));
        U.register(l);
      } catch (l) {
        a("error", { message: l.message, context: { op: "duplicate" } });
      }
    }
    function Wf(i) {
      if (Mn.value) {
        jp(i);
        return;
      }
      const l = u.downloadUrl(i.path);
      window.open(l, "_blank");
    }
    async function qf(i) {
      if (i.length !== 0) {
        if (i.length === 1 && i[0].type === "file") {
          Wf(i[0]);
          return;
        }
        Ke(p("toast.archive.preparing"));
        try {
          const l = await tz(u, i.map((_) => _.path));
          Ke(p("toast.archive.started", { name: l.name, count: String(l.files) }));
        } catch (l) {
          const _ = l;
          Ke(_.status === 409 ? p("toast.archive.empty") : _.message), a("error", { message: _.message, context: { op: "archive-download" } });
        }
      }
    }
    async function Gf(i) {
      var ee;
      const l = te.value;
      if (!i || l.length === 0) {
        ne.value = !1;
        return;
      }
      const _ = H.value === "move", F = Wn() ? ut(((ee = bt.value) == null ? void 0 : ee.getPath()) ?? "") : ut(z.value);
      _e.value = !0;
      try {
        await Aa(l.map((Ee) => Ee.path), i, F || void 0, _ ? "move" : "copy");
        const me = _i(i, i);
        Ke(_ ? p("toast.moved_to", { name: me }) : p("toast.copied_to", { name: me })), _ && (Wn() ? Ht.clear() : Ae.clear());
      } finally {
        _e.value = !1, ne.value = !1;
      }
    }
    async function Xf(i) {
      jt.value = !1;
      const l = i.path.slice(0, i.path.lastIndexOf("/"));
      l && l !== ut(z.value) ? await ot(l) : await ot();
      const _ = O.value.find((F) => F.path === i.path) ?? { type: "file", path: i.path, basename: i.name, extension: i.ext };
      nn.value = _, mn.value = dr(_) ? "edit" : "view", St.value = !0, a("file-opened", { path: _.path, basename: _.basename }), ft(_);
    }
    async function Jf(i) {
      var _, F;
      const l = Nt.value;
      try {
        const ee = ut(l ? ((_ = bt.value) == null ? void 0 : _.getPath()) ?? "" : z.value);
        await u.newFolder(ee, i), xt.value = !1, l ? await ((F = bt.value) == null ? void 0 : F.reload()) : await ot();
      } catch (ee) {
        a("error", { message: ee.message, context: { op: "newfolder" } });
      }
    }
    async function Zf(i) {
      var F, ee;
      const l = sn.value;
      if (!l) return;
      const _ = Nt.value;
      try {
        const me = ut(_ ? ((F = bt.value) == null ? void 0 : F.getPath()) ?? "" : z.value), Ee = l.path, Fe = l.basename;
        if (await u.rename(me, Ee, i), Pt.value = !1, sn.value = null, _ ? await ((ee = bt.value) == null ? void 0 : ee.reload()) : await ot(), i && i !== Fe) {
          const nt = Ta(qo(Ee), i);
          Ro(p("toast.renamed"), async () => {
            await u.rename(me, nt, Fe);
          });
        }
      } catch (me) {
        a("error", { message: me.message, context: { op: "rename" } });
      }
    }
    async function Qf() {
      var Ee, Fe, nt;
      if (pe.value) {
        _t.value = !1, Ke(p("toast.trash_retention"));
        return;
      }
      const i = Nt.value, l = i ? ua.value : Ae.nodes.value, _ = ut(i ? ((Ee = bt.value) == null ? void 0 : Ee.getPath()) ?? "" : z.value), F = l.map((ct) => ct.path);
      if (F.length === 0) {
        _t.value = !1;
        return;
      }
      const ee = l.map((ct) => ct.id).filter((ct) => typeof ct == "number"), me = u.endpoints.trashRestore && ee.length === l.length ? async () => {
        const { restored: ct } = await u.restoreIds(ee);
        if (ct === 0) throw new Error("restore failed");
      } : null;
      try {
        if (u.endpoints.deleteAsync) {
          const { op: ct } = await u.deleteAsync(F, _);
          me && I.set(ct.id, { message: p("toast.trashed"), fn: me }), U.register(ct), Ke(p("toast.delete_queued"));
        } else
          await u.deleteItems(_, F), i ? await ((Fe = bt.value) == null ? void 0 : Fe.reload()) : await ot(), me && Ro(p("toast.trashed"), me);
        _t.value = !1, i ? (nt = bt.value) == null || nt.reload() : Ae.clear();
      } catch (ct) {
        a("error", { message: ct.message, context: { op: "delete" } });
      }
    }
    function ep(i) {
      de.value = i, xe.value = !0;
    }
    function tp(i) {
      Ke(v.value === "en" ? `Converted → ${i}` : `Dönüştürüldü → ${i}`), ot();
    }
    function qn() {
      var i;
      if (!xn.value) {
        Ke(v.value === "en" ? "Read-only here" : "Burada yazma yetkiniz yok");
        return;
      }
      (i = tn.value) == null || i.click();
    }
    function np(i) {
      const l = i.target, _ = l.files ? Array.from(l.files) : [];
      l.value = "", Kl(_);
    }
    async function Kl(i) {
      if (i.length !== 0) {
        if (Ir.value) {
          Ke(p("e2e.upload.locked"));
          return;
        }
        if (!(Mn.value && (i = await Yp(i), i.length === 0))) {
          for (const l of i) {
            if (B.shouldChunk(l)) {
              const _ = B.resumableFor(ut(z.value), l);
              if (_ && Ke(
                p("upload.resuming", {
                  name: l.name,
                  percent: l.size > 0 ? Math.round(_.offset / l.size * 100) : 0
                })
              ), await Ul(l)) continue;
            }
            await Rl(l);
          }
          await ot();
        }
      }
    }
    async function Rl(i, l) {
      const _ = crypto.randomUUID(), F = l ?? ut(z.value);
      pt.value = [
        ...pt.value,
        { id: _, file: i, path: F, totalBytes: i.size, uploadedBytes: 0, percent: 0, status: "uploading", cancel() {
        } }
      ];
      const ee = (me) => {
        const Ee = pt.value.findIndex((nt) => nt.id === _);
        if (Ee === -1) return;
        const Fe = [...pt.value];
        Fe[Ee] = { ...Fe[Ee], ...me }, pt.value = Fe;
      };
      try {
        await u.uploadMultipart(F, [i], (me) => {
          ee({ percent: me, uploadedBytes: Math.round(me / 100 * i.size) }), a("upload-progress", { uploadId: _, percent: me, done: me >= 100 });
        }), ee({ percent: 100, uploadedBytes: i.size, status: "done" }), a("upload-progress", { uploadId: _, percent: 100, done: !0 });
      } catch (me) {
        const Ee = me.message;
        ee({ status: "error", error: Ee }), Ke(p("upload.failed", { name: i.name })), a("error", {
          message: Ee,
          context: { op: "upload", file: i.name }
        });
      }
    }
    async function Ul(i, l) {
      const _ = crypto.randomUUID();
      let F = !1;
      const ee = (Ee) => {
        if (!F) {
          pt.value = [...pt.value, { ...Ee, id: _ }], F = !0;
          return;
        }
        const Fe = pt.value.findIndex((nt) => nt.id === _);
        if (Fe !== -1) {
          const nt = [...pt.value];
          nt[Fe] = { ...Ee, id: _ }, pt.value = nt;
        }
      }, me = l ?? ut(z.value);
      try {
        return await B.uploadFile({
          path: me,
          file: i,
          onProgress: (Ee) => {
            !F && Ee.status !== "uploading" && Ee.uploadedBytes <= 0 || (ee(Ee), a("upload-progress", {
              uploadId: Ee.uploadId ?? _,
              percent: Ee.percent,
              done: Ee.status === "done"
            }));
          }
        }), !0;
      } catch (Ee) {
        if (kv(Ee))
          return F && (pt.value = pt.value.filter((nt) => nt.id !== _)), !1;
        const Fe = Ee.message;
        return F || (pt.value = [
          ...pt.value,
          {
            id: _,
            file: i,
            path: me,
            totalBytes: i.size,
            uploadedBytes: 0,
            percent: 0,
            status: "error",
            error: Fe,
            cancel() {
            }
          }
        ], F = !0), Ke(p("upload.failed", { name: i.name })), a("error", { message: Fe, context: { op: "upload", file: i.name } }), !0;
      }
    }
    const Gn = m(0), Xn = m(!1);
    function $r(i) {
      const l = i.dataTransfer;
      if (!l || l.types && l.types.includes(CD) || Co()) return !1;
      if (l.items && l.items.length > 0) {
        let _ = !1;
        for (const F of Array.from(l.items))
          if (F.kind === "file") {
            _ = !0;
            break;
          }
        return _;
      }
      return l.types ? l.types.includes("Files") : !1;
    }
    function ap(i) {
      $r(i) && (i.preventDefault(), Gn.value++, Xn.value = !0);
    }
    function op() {
      Gn.value = Math.max(0, Gn.value - 1), Gn.value === 0 && (Xn.value = !1);
    }
    function sp(i) {
      if (vn(i)) {
        i.preventDefault();
        return;
      }
      $r(i) && i.preventDefault();
    }
    function rp(i) {
      var _;
      if (vn(i)) {
        const F = mi(i) || "", ee = ut(z.value), me = Cs(i);
        if (me && F && ee && F !== ee && !pe.value && xn.value) {
          i.preventDefault(), Gn.value = 0, Xn.value = !1, Ba(), io(), Aa(me.map((Ee) => Ee.path), ee, F);
          return;
        }
      }
      if (vn(i)) {
        Gn.value = 0, Xn.value = !1, Ba(), io();
        return;
      }
      if (!$r(i)) {
        Gn.value = 0, Xn.value = !1;
        return;
      }
      if (i.preventDefault(), Gn.value = 0, Xn.value = !1, !xn.value) {
        Ke(v.value === "en" ? "Read-only here" : "Burada yazma yetkiniz yok");
        return;
      }
      const l = (_ = i.dataTransfer) != null && _.files ? Array.from(i.dataTransfer.files) : [];
      l.length !== 0 && Kl(l);
    }
    function Vl(i) {
      var l;
      (l = i.dataTransfer) != null && l.types.includes("Files") && i.preventDefault();
    }
    function jl(i) {
      const l = Kt.value, _ = i.target;
      l && _ && !l.contains(_) && i.preventDefault();
    }
    dt(() => {
      var i, l;
      window.addEventListener("dragover", Vl), window.addEventListener("drop", jl), window.addEventListener("pointerup", ts), window.addEventListener("blur", ts), (l = (i = fa.value) == null ? void 0 : i.onProgress) == null || l.call(i, (_) => {
        const F = !!(_ != null && _.dropped);
        if ((_ == null ? void 0 : _.error) === "drop_not_found") {
          Ke(p("dragout.not_found"));
          return;
        }
        if (_ != null && _.error) {
          (F || !ns) && Ke(_.error);
          return;
        }
        if (F) {
          Ke(_ != null && _.finished ? p("dragout.done") : p("dragout.downloading"));
          return;
        }
        ns || !(_ != null && _.finished) && (_ == null ? void 0 : _.done) === 0 && Ke(p("dragout.preparing"));
      });
    });
    function ts() {
      Co() && Ba();
    }
    function io() {
      var i;
      (i = fa.value) != null && i.cancel && Promise.resolve(fa.value.cancel()).catch(() => {
      });
    }
    it(() => {
      window.removeEventListener("dragover", Vl), window.removeEventListener("drop", jl), window.removeEventListener("hashchange", Dl), window.removeEventListener("pointerup", ts), window.removeEventListener("blur", ts);
    });
    const xr = k(() => V.value.mode !== "cut" ? /* @__PURE__ */ new Set() : new Set(V.value.items.map((i) => i.path)));
    function Yl(i, l, _) {
      (i === "split" ? Ht : Ae).click(l.path, _);
    }
    function Wl(i, l, _) {
      var Fe;
      if (!_.dataTransfer) return;
      if (l.basename === ".trash") {
        _.preventDefault();
        return;
      }
      const F = i === "split" ? Ht.nodes.value : Ae.nodes.value, ee = ut(i === "split" ? ((Fe = bt.value) == null ? void 0 : Fe.getPath()) ?? "" : z.value), Ee = (F.some((nt) => nt.path === l.path) ? F : [l]).filter((nt) => !xr.value.has(nt.path)).filter((nt) => nt.basename !== ".trash").map((nt) => ({ path: nt.path, basename: nt.basename, type: nt.type }));
      if (Ee.length !== 0) {
        if (fa.value) {
          _.preventDefault(), k_(Ee, ee), Promise.resolve(fa.value.start(Ee)).catch((nt) => {
            Ba(), io(), a("error", { message: nt.message, context: { op: "drag-out" } });
          }), Xl(Ee);
          return;
        }
        if (Ee.length === 1 && Ee[0] && __(r.config.auth)) {
          const nt = $_(Ee[0], u.downloadUrl(Ee[0].path), l.mime_type);
          nt && _.dataTransfer.setData("DownloadURL", nt);
        }
      }
    }
    const fa = k(() => r.config.dragOut ?? null), ql = m(""), Sr = m(!1);
    let ns = !1, Gl;
    He(
      () => Ae.selected.value,
      () => {
        if (!fa.value) return;
        clearTimeout(Gl);
        const i = Ae.nodes.value;
        if (i.length === 0 || i.length > MD || i.some((F) => F.type !== "file") || i.reduce((F, ee) => F + (ee.size ?? 0), 0) > TD) return;
        const _ = i.map((F) => ({ path: F.path, basename: F.basename, type: F.type }));
        Gl = setTimeout(() => void Xl(_, !0), 400);
      },
      { deep: !0 }
    );
    async function Xl(i, l = !1) {
      const _ = fa.value;
      if (!_ || Sr.value) return;
      const F = x_(i);
      if (F !== ql.value) {
        Sr.value = !0, ns = l;
        try {
          const ee = await _.prepare(i);
          ee != null && ee.ready ? (ql.value = F, l || Ke(p("dragout.ready"))) : ee != null && ee.error && !l && Ke(ee.error);
        } catch (ee) {
          a("error", { message: ee.message, context: { op: "drag-out-prepare" } });
        } finally {
          Sr.value = !1, ns = !1;
        }
      }
    }
    async function ip(i, l, _, F) {
      try {
        const ee = F ?? ut(z.value), me = await El(i, l);
        if (u.endpoints.moveAsync) {
          const { op: Ee } = await u.moveAsync(i, l, ee);
          zl(Ee.id, i, l, ee, me), U.register(Ee), Ke(p(me ? "toast.move_kept_both" : "split.move_queued"));
        } else if (await u.move(ee, i, l), await ot(), me)
          Ke(p("toast.move_kept_both"));
        else {
          const Ee = i.map((Fe) => Ta(l, Wo(Fe)));
          Ro(p("toast.moved"), async () => {
            await u.move(l, Ee, ee);
          });
        }
        Ae.clear();
      } catch (ee) {
        a("error", { message: ee.message, context: { op: _, targetDir: l } });
      }
    }
    async function Jl(i, l) {
      if (i.type !== "dir") return;
      const _ = Cs(l);
      if (!_ || _.length === 0) return;
      Ba(), io();
      const F = i.path, ee = _.map((me) => me.path).filter((me) => me && me !== F && !F.startsWith(me + "/") && !vr(qo(me), F));
      ee.length !== 0 && await Aa(ee, F, kc(l));
    }
    async function Zl(i, l) {
      const _ = Cs(l);
      if (!_ || _.length === 0) return;
      Ba(), io();
      const F = i, ee = _.map((me) => me.path).filter((me) => me && me !== F && !F.startsWith(me + "/") && !vr(qo(me), F));
      ee.length !== 0 && await Aa(ee, F, kc(l));
    }
    function lp(i) {
      i.cancel();
    }
    function cp(i) {
      pt.value = pt.value.filter((l) => l.id !== i.id);
    }
    function up(i) {
      if (Et.value && !i) {
        ot("");
        return;
      }
      if (Et.value) {
        ot(Ca(i));
        return;
      }
      ot(ca(i));
    }
    async function as(i) {
      try {
        await navigator.clipboard.writeText(i), Ke(p("breadcrumb.copy_path"));
      } catch {
      }
    }
    function Rt(i = {}) {
      return u.authHeaders({ ...i });
    }
    function Ql(i) {
      if (/^[a-z][a-z0-9+.-]*:\/\//i.test(i)) return i;
      const l = r.config.apiBase;
      if (!l) return i;
      try {
        return new URL(i, l.endsWith("/") ? l : `${l}/`).toString();
      } catch {
        return i;
      }
    }
    const ec = k(
      () => Ql(r.config.viewerBaseUrl || ED)
    ), os = m(!1), { themeId: ss, setTheme: dp } = PC(), { themeMode: Cr, setThemeMode: fp } = OC(), It = k(
      () => Cr.value === "host" ? r.config.theme || "auto" : Cr.value
    ), ln = typeof window < "u" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : void 0, tc = m(!!(ln != null && ln.matches));
    function nc(i) {
      tc.value = i.matches;
    }
    dt(() => {
      var i;
      return (i = ln == null ? void 0 : ln.addEventListener) == null ? void 0 : i.call(ln, "change", nc);
    }), it(() => {
      var i;
      return (i = ln == null ? void 0 : ln.removeEventListener) == null ? void 0 : i.call(ln, "change", nc);
    });
    const Tr = k(
      () => It.value === "dark" || It.value !== "light" && tc.value
    );
    He(
      [ss, Tr, Kt],
      () => {
        HC(ss.value), Kt.value && BC(Kt.value, ss.value, Tr.value);
      },
      { immediate: !0 }
    );
    const lo = m(!1), Jn = m(!1), Bn = m(null);
    function pp() {
      if (Jn.value) {
        Jn.value = !1;
        return;
      }
      const i = Ae.nodes.value, l = i.length === 1 ? i[0] : null;
      if (!(!l || l.type !== "file" || l.basename === ".trash")) {
        if (Zt.value) {
          if (!Mn.value) return;
          (async () => {
            try {
              await Ur(l);
            } catch {
              Ke(p("e2e.decrypt_failed"));
              return;
            }
            Bn.value = l, Jn.value = !0, ft(l);
          })();
          return;
        }
        Bn.value = l, Jn.value = !0, ft(l);
      }
    }
    function vp(i) {
      const l = O.value.filter((me) => me.type === "file");
      if (l.length === 0) return;
      const _ = Bn.value;
      let F = _ ? l.findIndex((me) => me.path === _.path) : -1;
      F = F === -1 ? i > 0 ? 0 : l.length - 1 : (F + i + l.length) % l.length;
      const ee = l[F];
      !ee || ee.path === (_ == null ? void 0 : _.path) || Ae.click(ee.path);
    }
    function hp() {
      const i = Bn.value;
      Jn.value = !1, i && dn(i);
    }
    He(
      () => Ae.nodes.value,
      (i) => {
        var _, F;
        if (!Jn.value) return;
        const l = i.length === 1 && i[0].type === "file" ? i[0] : null;
        if (l && l.path !== ((_ = Bn.value) == null ? void 0 : _.path) && Mn.value) {
          (async () => {
            try {
              await Ur(l);
            } catch {
            }
            Bn.value = l, ft(l);
          })();
          return;
        }
        l && l.path !== ((F = Bn.value) == null ? void 0 : F.path) && (Bn.value = l, ft(l));
      }
    );
    const Mr = c5();
    function mp(i) {
      pt.value = pt.value.filter((F) => F.id !== i.id);
      const l = i.file, _ = i.path || ut(z.value);
      (async () => {
        if (B.shouldChunk(l) && await Ul(l, _)) {
          await ot();
          return;
        }
        await Rl(l, _), await ot();
      })();
    }
    const rs = m(!1);
    let Er;
    function yp() {
      try {
        return localStorage.getItem(Bu) === "1";
      } catch {
        return !0;
      }
    }
    function zr() {
      rs.value = !0;
    }
    function bp() {
      var i;
      rs.value = !1;
      try {
        localStorage.setItem(Bu, "1");
      } catch {
      }
      (i = Kt.value) == null || i.focus();
    }
    function ac() {
      zr();
    }
    dt(() => {
      var i;
      (i = Kt.value) == null || i.addEventListener("fe:tour-restart", ac), yp() || (Er = setTimeout(() => {
        rs.value || zr();
      }, 900));
    }), it(() => {
      var i;
      Er && clearTimeout(Er), (i = Kt.value) == null || i.removeEventListener("fe:tour-restart", ac);
    });
    function gp() {
      return Go() === "none" ? null : E ? `${Iu}:${E}` : Iu;
    }
    const Lt = t8({ storageKey: gp() }), kp = Lt.restore(), Ar = Lt.activeId, In = k(() => {
      var i;
      return ((i = Lt.activeTab.value) == null ? void 0 : i.split) ?? null;
    });
    function _p(i) {
      const l = (i || "").replace(/^\/+|\/+$/g, ""), _ = Fs(l.split("/").pop() || l, p);
      return _ || (l ? l.split("/").pop() || l : Et.value ? p("breadcrumb.root") : T.value || p("breadcrumb.root"));
    }
    const oc = k(
      () => Lt.tabs.value.map((i) => ({ id: i.id, label: _p(i.path), split: !!i.split }))
    ), sc = k(
      () => (
        /* gezinti:g1 — the simple profile has no tab strip at all, not even once a
           second tab exists: tabs were the first thing #14 named as power-user
           chrome. The tab STATE is untouched, so switching the profile back brings
           the strip and its tabs straight back. */
        !Ja.value && (Lt.hasMultiple.value || r.config.tabStrip !== "auto" && oc.value.length > 0)
      )
    );
    He(z, (i) => Lt.syncActive({ path: i })), He(oe, (i) => Lt.syncActive({ viewMode: i })), dt(() => {
      kp || Lt.seed(z.value ?? "", oe.value);
    });
    function is(i) {
      !Ay() && i.viewMode && i.viewMode !== oe.value && (oe.value = i.viewMode);
      const l = () => Ne(W.value);
      if (i.path === ".trash") {
        Yn().then(l, l);
        return;
      }
      ot(i.path).then(l, l);
    }
    function wp(i) {
      const l = Lt.activate(i);
      l && is(l);
    }
    function Pr() {
      Lt.openTab(z.value ?? "", { viewMode: oe.value, background: !1 });
    }
    function rc(i) {
      const l = Lt.closeTab(i);
      l && is(l);
    }
    function $p() {
      const i = Lt.step(1);
      i && is(i);
    }
    function xp() {
      const i = Lt.step(-1);
      i && is(i);
    }
    function ic(i) {
      if (i.type !== "dir" || i.basename === ".trash") return;
      const l = Et.value ? Ca(i.path) : ca(i.path);
      Lt.openTab(l, { viewMode: oe.value, background: !0 });
    }
    function lc(i) {
      if (i.button !== 1) return;
      const l = i.target, _ = l && typeof l.closest == "function" ? l.closest("[data-fe-path]") : null, F = _ == null ? void 0 : _.getAttribute("data-fe-path");
      if (!F) return;
      const ee = O.value.find((me) => me.path === F);
      !ee || ee.type !== "dir" || ee.basename === ".trash" || (i.preventDefault(), ic(ee));
    }
    function cc(i) {
      if (i.button !== 1) return;
      const l = i.target;
      l && typeof l.closest == "function" && l.closest("[data-fe-path]") && i.preventDefault();
    }
    dt(() => {
      var i, l;
      (i = Kt.value) == null || i.addEventListener("auxclick", lc), (l = Kt.value) == null || l.addEventListener("mousedown", cc);
    }), it(() => {
      var i, l;
      (i = Kt.value) == null || i.removeEventListener("auxclick", lc), (l = Kt.value) == null || l.removeEventListener("mousedown", cc);
    });
    const Sp = m(null), bt = m(null), ls = m([]), Ht = Oc(
      () => {
        var i;
        return ls.value.length ? ls.value : ((i = bt.value) == null ? void 0 : i.visibleNodes()) ?? [];
      }
    ), co = m({ ...na }), Cp = k(() => {
      var ee;
      if (!Z.value) return "";
      const i = String(((ee = bt.value) == null ? void 0 : ee.getPath()) ?? "").replace(/^\/+|\/+$/g, "");
      if (!i) return "";
      const [l, ..._] = i.split("/"), F = (r.config.storages ?? []).find((me) => me.name === l);
      return uu((F == null ? void 0 : F.uid) || l, _.join("/"));
    }), Tp = k(
      () => sc.value || sl.value || uo.value
    ), Lr = k(() => w.value === "home" ? "home" : x.value && O.value.length === 0 ? "" : N.value ? "notfound" : P.value && O.value.length === 0 ? "" : Ir.value ? "locked" : ""), uo = k(() => !rn.value && !Ja.value), za = k(
      () => !!In.value && uo.value
      /* gezinti:g1 */
    );
    function uc() {
      if (In.value) {
        Lt.setSplit(null), Tn.value = "main";
        return;
      }
      uo.value && Lt.setSplit({ path: z.value ?? "", viewMode: oe.value });
    }
    function Mp() {
      Lt.setSplit(null), Tn.value = "main";
    }
    function Ep(i) {
      Lt.setSplit({ ...In.value ?? {}, path: i }), $o(co.value) && (co.value = { ...na }), Ht.clear(), ls.value = [];
    }
    function zp(i, l) {
      var _;
      if (l.type === "dir" && l.basename !== ".trash") {
        (_ = bt.value) == null || _.loadFolder(
          /* A multi-storage drive row's path is already the wire form for that
             storage's root; a real row needs converting. The predicate comes from
             `lib/fileIcons`, which is that concept's one home. */
          jn(l) === "storage" ? l.path : Br(l.path)
        );
        return;
      }
      dn(l);
    }
    function Ap() {
      Tn.value = "main", Yn();
    }
    const dc = k(() => {
      var i;
      return ((i = In.value) == null ? void 0 : i.viewMode) ?? oe.value;
    });
    function fc(i) {
      In.value && Lt.setSplit({ ...In.value, viewMode: i });
    }
    const Dr = k(
      () => zt.value ? dc.value : oe.value
    );
    function pc(i) {
      zt.value ? fc(i) : oe.value = i;
    }
    const Tn = m("main");
    function Pp() {
      Tn.value = "main";
    }
    He(za, (i) => {
      i || (Tn.value = "main");
    });
    const zt = k(() => Tn.value === "split" && za.value), Lp = k(() => za.value && Tn.value === "main"), vc = k(() => zt.value ? "split" : "main"), fo = m(null), hc = k(
      () => {
        var i;
        return zt.value ? ((i = bt.value) == null ? void 0 : i.getPath()) ?? "" : z.value ?? "";
      }
    );
    function Dp(i) {
      var l;
      return i === "split" ? ((l = bt.value) == null ? void 0 : l.getPath()) ?? "" : z.value ?? "";
    }
    function Op(i) {
      var l;
      return i === "split" ? ((l = bt.value) == null ? void 0 : l.rowPaths()) ?? [] : O.value.map((_) => _.path);
    }
    He(
      () => Jt(),
      (i) => {
        i.length && (fo.value = {
          nodes: i,
          pane: vc.value,
          path: hc.value
        });
      },
      { deep: !1 }
    );
    const Or = k(() => {
      const i = fo.value;
      if (!i || !i.nodes.length || i.pane === "split" && !za.value) return !1;
      if (Dp(i.pane) !== i.path) return !0;
      const l = new Set(Op(i.pane));
      return i.nodes.some((_) => l.has(_.path));
    });
    He(Or, (i) => {
      i || (fo.value = null);
    });
    const Bp = k(() => Jt().length === 0 && Or.value), Ip = k(() => {
      var l;
      const i = Jt();
      return i.length ? i : Or.value ? ((l = fo.value) == null ? void 0 : l.nodes) ?? [] : [];
    }), Hp = k(
      () => {
        var i;
        return Bp.value ? bl(((i = fo.value) == null ? void 0 : i.path) ?? "") : "";
      }
    ), Fp = k(() => bl(hc.value)), Np = k(
      () => {
        var i;
        return zt.value ? ((i = bt.value) == null ? void 0 : i.rowCount()) ?? 0 : O.value.length;
      }
    ), Kp = k(
      () => {
        var i;
        return zt.value ? ((i = bt.value) == null ? void 0 : i.dirPerm()) ?? "" : J.value;
      }
    );
    function Br(i) {
      return Et.value ? Ca(i) : ca(i);
    }
    function mc(i) {
      const l = String(i ?? "").replace(/^\/+|\/+$/g, "");
      return $ && (!l || !(l === $ || l.startsWith($ + "/"))) ? $ : l;
    }
    function yc() {
      var l;
      const i = Ht.nodes.value;
      i.length !== 0 && (V.value = { mode: "cut", items: i, sourcePath: ((l = bt.value) == null ? void 0 : l.getPath()) ?? "" }, Ke(p("toast.cut")));
    }
    function bc() {
      var l;
      const i = Ht.nodes.value;
      i.length !== 0 && (V.value = { mode: "copy", items: i, sourcePath: ((l = bt.value) == null ? void 0 : l.getPath()) ?? "" }, Ke(p("toast.copied")));
    }
    async function gc() {
      const i = V.value, l = bt.value;
      if (!i.mode || i.items.length === 0 || !l) return;
      const _ = ut(l.getPath() ?? ""), F = ut(i.sourcePath || "") || void 0;
      if (i.mode === "cut" && F === _) {
        Ke(p("toast.same_folder_cut"));
        return;
      }
      await Aa(i.items.map((ee) => ee.path), _, F, i.mode === "copy" ? "copy" : "move"), V.value = { mode: null, items: [], sourcePath: null };
    }
    function kc(i) {
      return mi(i);
    }
    async function Aa(i, l, _, F = "auto") {
      var Ee;
      const ee = i.filter(
        (Fe) => Fe && Fe !== l && !l.startsWith(Fe + "/") && !vr(qo(Fe), l)
      );
      if (ee.length === 0 || !l) return;
      const me = Au(ee, l, F);
      if (me.kind === "copy")
        try {
          const { op: Fe } = await u.copy(ee, l);
          U.register(Fe), Ke(me.cross ? p("split.cross_copy") : p("split.copy_queued"));
        } catch (Fe) {
          a("error", { message: Fe.message, context: { op: "transfer", targetWire: l } }), Ke(Fe.message);
          return;
        }
      else
        me.cross && Ke(p("split.cross_move")), await ip(ee, l, "move-transfer", _);
      (Ee = bt.value) == null || Ee.reload();
    }
    function _c(i) {
      Aa(i.sources, i.targetWire, i.originWire);
    }
    const pa = by(), Pa = m(0), yt = m(""), po = /* @__PURE__ */ new Map(), Zt = k(() => !!yt.value && !pe.value), Mn = k(() => (Pa.value, Zt.value && pa.has(yt.value))), Ir = k(() => (Pa.value, Zt.value && !pa.has(yt.value))), Zn = m(""), La = m(!1), Da = m(""), cs = m(!1), Hr = m(!1), Yt = m(null), us = m(!1), Fr = m(!1), Qn = m(null), ds = m(!1), fs = m(""), Nr = m("created"), ps = m(""), vs = m(!1), vo = m(""), ho = m(!1), va = m(!1), mo = m("unlock"), Hn = m(""), En = m(!1), zn = m(""), Kr = k(
      () => {
        var i, l;
        return ((l = (i = R.value) == null ? void 0 : i.e2e_escrow) == null ? void 0 : l.public_key) || null;
      }
    ), Fn = k(
      () => {
        var i, l;
        return ((l = (i = R.value) == null ? void 0 : i.e2e_escrow) == null ? void 0 : l.kid) || null;
      }
    );
    function Rr() {
      return pa.get(yt.value) ?? null;
    }
    function wc() {
      for (const i of po.values()) URL.revokeObjectURL(i);
      po.clear();
    }
    it(wc);
    async function Rp() {
      if (!(!Zn.value || La.value || !yt.value)) {
        La.value = !0, Da.value = "";
        try {
          let i = "";
          try {
            const { blob: F, url: ee } = await u.fetchBlob(Ta(yt.value, ha), { fresh: !0 });
            URL.revokeObjectURL(ee), i = await F.text();
          } catch {
            Da.value = p("e2e.unlock.marker_missing");
            return;
          }
          const l = Qc(i);
          if (!l) {
            Da.value = p("e2e.unlock.marker_missing");
            return;
          }
          Yt.value = l;
          const _ = await vy(l, Zn.value);
          if (!_) {
            Da.value = p("e2e.unlock.wrong");
            return;
          }
          pa.set(yt.value, _), Pa.value++, l.v === 1 ? (vo.value = Zn.value, vs.value = !0) : Zc(l, Fn.value) === "offer" && (Hn.value = Zn.value, mo.value = "unlock", zn.value = "", va.value = !0), Zn.value = "";
        } finally {
          La.value = !1;
        }
      }
    }
    function Up() {
      yt.value && (pa.lock(yt.value), Pa.value++, wc(), Ke(p("e2e.locked_toast")));
    }
    const Vp = {
      txt: "text/plain",
      md: "text/markdown",
      log: "text/plain",
      csv: "text/csv",
      json: "application/json",
      xml: "application/xml",
      html: "text/html",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      webp: "image/webp",
      bmp: "image/bmp",
      avif: "image/avif",
      svg: "image/svg+xml",
      pdf: "application/pdf",
      mp4: "video/mp4",
      webm: "video/webm",
      mov: "video/quicktime",
      m4v: "video/mp4",
      mp3: "audio/mpeg",
      wav: "audio/wav",
      ogg: "audio/ogg",
      flac: "audio/flac",
      m4a: "audio/mp4",
      aac: "audio/aac",
      opus: "audio/opus"
    };
    function $c(i) {
      const l = (i.extension || "").toLowerCase();
      return Vp[l] || "application/octet-stream";
    }
    async function Ur(i) {
      const l = po.get(i.path);
      if (l) return l;
      const _ = Rr();
      if (!_) return null;
      const F = await u.fetchArrayBuffer(i.path);
      if (!di(F)) return null;
      const ee = await eu(_, F), me = URL.createObjectURL(new Blob([ee], { type: $c(i) }));
      return po.set(i.path, me), me;
    }
    function hs(i) {
      return po.get(i) ?? u.previewUrl(i);
    }
    async function Vr(i) {
      try {
        await Ur(i);
      } catch {
        Ke(p("e2e.decrypt_failed"));
        return;
      }
      mn.value = "view", nn.value = i, St.value = !0, a("file-opened", { path: i.path, basename: i.basename }), ft(i);
    }
    async function jp(i) {
      try {
        const l = await u.fetchArrayBuffer(i.path), _ = Rr();
        let F = l;
        if (di(l)) {
          if (!_) throw new Error("locked");
          F = await eu(_, l);
        }
        const ee = URL.createObjectURL(new Blob([F], { type: $c(i) })), me = document.createElement("a");
        me.href = ee, me.download = i.basename, document.body.appendChild(me), me.click(), me.remove(), setTimeout(() => URL.revokeObjectURL(ee), 3e4);
      } catch {
        Ke(p("e2e.download.failed"));
      }
    }
    async function Yp(i) {
      const l = Rr();
      if (!l) return [];
      const _ = [];
      for (const F of i)
        if (F.name !== ha) {
          if (F.size > ld) {
            Ke(p("e2e.upload.too_big"));
            continue;
          }
          try {
            const ee = await yy(l, await F.arrayBuffer());
            _.push(new File([ee], F.name, { type: "application/octet-stream" }));
          } catch (ee) {
            a("error", { message: ee.message, context: { op: "e2e-encrypt", file: F.name } });
          }
        }
      return _;
    }
    async function Wp(i) {
      if (Zt.value) {
        Ke(p("e2e.create.nested"));
        return;
      }
      Hr.value = !0;
      try {
        const l = ut(z.value);
        await u.newFolder(l, i.name);
        const { marker: _, fmk: F, recoveryKey: ee } = await sy(i.password, {
          escrowPublicKey: Kr.value
        }), me = new File([JSON.stringify(_)], ha, {
          type: "application/json"
        }), Ee = Ta(l, i.name);
        await u.uploadMultipart(Ee, [me]), pa.set(Ee, F), Pa.value++, cs.value = !1, fs.value = ee, ps.value = i.name, Nr.value = "created", ds.value = !0, await ot();
      } catch (l) {
        a("error", { message: l.message, context: { op: "e2e-create" } }), Ke(p("e2e.create.failed"));
      } finally {
        Hr.value = !1;
      }
    }
    async function qp(i) {
      if (!(!Yt.value || !yt.value)) {
        Fr.value = !0, Qn.value = null;
        try {
          let l = null;
          if (i.mode === "recovery") {
            if (l = await hy(Yt.value, i.value), !l) {
              Qn.value = p("e2e.recover.wrong_recovery");
              return;
            }
          } else {
            let _;
            try {
              _ = await ay(i.value);
            } catch {
              Qn.value = p("e2e.recover.bad_escrow_key");
              return;
            }
            if (l = await my(Yt.value, _), !l) {
              Qn.value = p("e2e.recover.wrong_escrow");
              return;
            }
            try {
              const F = await u.e2eEscrowChallenge(yt.value), ee = new Uint8Array(
                await crypto.subtle.decrypt(
                  { name: "RSA-OAEP" },
                  _,
                  On(F.challenge).buffer
                )
              );
              await u.e2eEscrowUsed({
                path: yt.value,
                id: F.id,
                nonce: Xa(ee)
              });
            } catch (F) {
              Qn.value = p("e2e.recover.notify_failed"), a("error", {
                message: F.message,
                context: { op: "e2e-escrow-notify" }
              });
              return;
            }
          }
          pa.set(yt.value, l), Pa.value++, us.value = !1, Ke(
            i.mode === "escrow" ? p("e2e.recover.escrow_done") : p("e2e.recover.recovery_done")
          );
        } catch (l) {
          Qn.value = l.message;
        } finally {
          Fr.value = !1;
        }
      }
    }
    async function Gp() {
      if (!Yt.value && yt.value)
        try {
          const { blob: i, url: l } = await u.fetchBlob(Ta(yt.value, ha), { fresh: !0 });
          URL.revokeObjectURL(l), Yt.value = Qc(await i.text());
        } catch {
          Yt.value = null;
        }
      Qn.value = null, us.value = !0;
    }
    async function Xp() {
      if (!(!Yt.value || !yt.value || !vo.value)) {
        ho.value = !0;
        try {
          const i = await ry(Yt.value, vo.value, {
            escrowPublicKey: Kr.value
          }), l = new File([JSON.stringify(i.marker)], ha, {
            type: "application/json"
          });
          await u.uploadMultipart(yt.value, [l]), Yt.value = i.marker, vs.value = !1, vo.value = "", fs.value = i.recoveryKey, ps.value = Wo(yt.value), Nr.value = "upgraded", ds.value = !0;
        } catch (i) {
          a("error", { message: i.message, context: { op: "e2e-upgrade" } }), Ke(p("e2e.upgrade.failed"));
        } finally {
          ho.value = !1;
        }
      }
    }
    const Jp = k(() => Zc(Yt.value, Fn.value));
    function Zp() {
      mo.value = "manual", Hn.value = "", zn.value = "", va.value = !0;
    }
    async function xc(i) {
      const l = new File([JSON.stringify(i)], ha, { type: "application/json" });
      await u.uploadMultipart(yt.value, [l]), Yt.value = i;
    }
    async function Sc() {
      const i = Yt.value, l = Kr.value;
      if (!(!i || !l || !yt.value || En.value)) {
        if (!Hn.value) {
          zn.value = p("e2e.escrowoffer.password_required");
          return;
        }
        En.value = !0, zn.value = "";
        try {
          const _ = await iy(i, Hn.value, l);
          await xc(_), va.value = !1, Hn.value = "", Ke(p("e2e.escrowoffer.done"));
        } catch (_) {
          (_ == null ? void 0 : _.name) === "E2eDecryptError" ? zn.value = p("e2e.escrowoffer.wrong_password") : (zn.value = p("e2e.escrowoffer.failed"), a("error", { message: _.message, context: { op: "e2e-escrow-offer" } }));
        } finally {
          En.value = !1;
        }
      }
    }
    async function Qp() {
      const i = Yt.value;
      if (!(!i || !yt.value || En.value)) {
        En.value = !0;
        try {
          await xc(ly(i, (/* @__PURE__ */ new Date()).toISOString())), va.value = !1, Hn.value = "", Ke(p("e2e.escrowoffer.declined_toast"));
        } catch (l) {
          zn.value = p("e2e.escrowoffer.decline_failed"), a("error", { message: l.message, context: { op: "e2e-escrow-decline" } });
        } finally {
          En.value = !1;
        }
      }
    }
    function ev() {
      va.value = !1, Hn.value = "", zn.value = "";
    }
    function tv() {
      vs.value = !1, vo.value = "";
    }
    function nv() {
      ds.value = !1, fs.value = "", ps.value = "";
    }
    return (i, l) => {
      var _, F, ee, me, Ee, Fe, nt, ct;
      return c(), d("div", {
        ref_key: "rootEl",
        ref: Kt,
        class: we(["fe", {
          "fe--theme-light": It.value === "light",
          "fe--theme-dark": It.value === "dark",
          "fe--is-dragover": Xn.value,
          "fe--density-compact": ue.value === "compact",
          "fe--narrow": rn.value
        }]),
        tabindex: "-1",
        onDragenter: ap,
        onDragover: sp,
        onDragleave: op,
        onDrop: rp,
        onContextmenu: Ff
      }, [
        Ge(Km, {
          ref_key: "toolbarRef",
          ref: wl,
          "view-mode": Dr.value,
          "search-query": Q.value,
          "trash-active": S.value,
          actions: Rf.value,
          "selection-mode": Bf.value,
          "selection-count": Jt().length,
          "selection-pane": vc.value,
          "paste-enabled": !!V.value.mode,
          "convert-enabled": !!Ot.value,
          "can-go-up": L.value,
          "at-virtual-root": se.value,
          "can-write": xn.value,
          locale: v.value,
          narrow: rn.value,
          theme: It.value,
          "inspector-open": Me.value,
          "nav-open": Vd.value,
          "nav-enabled": Qa.value,
          "view-modes": ar.value,
          "scope-label": pl.value,
          "brand-name": (_ = e.config.brand) == null ? void 0 : _.name,
          "brand-mark-url": (F = e.config.brand) == null ? void 0 : F.markUrl,
          "search-escalates": w.value === "home",
          onOpenPalette: sf,
          onToggleInspector: Oe,
          onToggleNav: il,
          onOpenTheme: l[0] || (l[0] = (ke) => os.value = !0),
          "onUpdate:viewMode": l[1] || (l[1] = (ke) => pc(ke)),
          "onUpdate:searchQuery": of,
          onOpenAdvancedSearch: nf,
          "onUpdate:density": l[2] || (l[2] = (ke) => ue.value = ke),
          onOpenShortcutSettings: l[3] || (l[3] = (ke) => lo.value = !0),
          onOpenTimezone: l[4] || (l[4] = (ke) => X.value = !0),
          onNewFolder: l[5] || (l[5] = (ke) => xt.value = !0),
          onUpload: qn,
          onRefresh: Tl,
          onGoUp: We,
          onAction: yr,
          onOpenRecents: l[6] || (l[6] = (ke) => Qe.value = !0)
        }, fv({
          "header-actions": st(() => [
            _n(i.$slots, "header-actions")
          ]),
          _: 2
        }, [
          i.$slots.brand ? {
            name: "brand",
            fn: st(() => [
              _n(i.$slots, "brand")
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["view-mode", "search-query", "trash-active", "actions", "selection-mode", "selection-count", "selection-pane", "paste-enabled", "convert-enabled", "can-go-up", "at-virtual-root", "can-write", "locale", "narrow", "theme", "inspector-open", "nav-open", "nav-enabled", "view-modes", "scope-label", "brand-name", "brand-mark-url", "search-escalates", "onOpenPalette", "onToggleInspector", "onToggleNav", "onUpdate:searchQuery", "onOpenAdvancedSearch", "onRefresh"]),
        o("div", {
          class: we([
            "fe__main",
            { "fe__main--split": za.value }
            /* wiring:d1 */
          ])
        }, [
          tr.value ? (c(), et(y_, {
            key: 0,
            expanded: Za.value,
            narrow: rn.value,
            "active-view": w.value,
            "active-tag": be.value,
            tags: ml.value,
            "tags-loaded": lr.value,
            "active-storage": T.value,
            storages: e.config.storages ?? [],
            "shared-storages": nr.value,
            "trash-visible": e.config.trashVisible !== !1,
            "show-connections": jd.value,
            "show-identity-surfaces": eo.value,
            "can-write": xn.value && !se.value && !S.value,
            locale: v.value,
            "can-request-files": xn.value && !se.value && !S.value && !w.value,
            "can-new-document": un.value && !S.value && !w.value,
            onNewDocument: l[7] || (l[7] = (ke) => jt.value = !0),
            quota: Ho.value,
            theme: It.value,
            onRequestFiles: rf,
            onToggle: il,
            onClose: ia,
            onOpenView: ff,
            onOpenTag: oo,
            onOpenStorage: yl,
            onUpload: qn,
            onNewFolder: l[8] || (l[8] = (ke) => xt.value = !0),
            onOpenConnections: Yd,
            onOpenTokens: Wd
          }, null, 8, ["expanded", "narrow", "active-view", "active-tag", "tags", "tags-loaded", "active-storage", "storages", "shared-storages", "trash-visible", "show-connections", "show-identity-surfaces", "can-write", "locale", "can-request-files", "can-new-document", "quota", "theme", "onRequestFiles", "onOpenView"])) : g("", !0),
          rn.value && ra.value ? (c(), d("button", {
            key: 1,
            type: "button",
            class: "fe-sidenav__scrim",
            title: s(p)("sidenav.close"),
            "aria-label": s(p)("sidenav.close"),
            onClick: ia
          }, null, 8, uL)) : g("", !0),
          o("div", dL, [
            Tp.value ? (c(), et(T5, {
              key: 0,
              tabs: oc.value,
              "active-id": s(Ar),
              locale: v.value,
              "hide-tabs": !sc.value,
              "split-enabled": uo.value,
              "split-active": !!In.value,
              "inspector-enabled": sl.value,
              "inspector-open": Me.value,
              onSelect: wp,
              onClose: rc,
              onNew: Pr,
              onReorder: l[9] || (l[9] = (ke, Qt) => s(Lt).move(ke, Qt)),
              onToggleSplit: uc,
              onToggleInspector: Oe
            }, null, 8, ["tabs", "active-id", "locale", "hide-tabs", "split-enabled", "split-active", "inspector-enabled", "inspector-open"])) : g("", !0),
            o("div", fL, [
              Ge(Mu, {
                "pane-id": "main",
                ref_key: "mainPaneRef",
                ref: Sp,
                api: s(u),
                locale: v.value,
                theme: It.value,
                focused: Lp.value,
                path: z.value,
                qualify: ut,
                "to-user": Br,
                clamp: mc,
                "root-path": s(E),
                floor: s($),
                "multi-root": Et.value,
                rows: O.value,
                loading: x.value,
                error: P.value,
                order: Xd.value,
                "view-mode": oe.value,
                "view-modes": ar.value,
                "open-trigger": r.config.openTrigger,
                "show-crumbs": w.value !== "home",
                "filter-mode": Ce.value,
                "find-label": w.value === "home" ? s(p)("filter.find.home") : "",
                "show-view-switcher": w.value !== "home",
                "folder-key": W.value,
                "show-parent-path": !!Q.value || K.value,
                clipped: xr.value,
                "extra-filters": ao.value,
                "can-write": xn.value && !S.value,
                "can-paste": !!V.value.mode,
                selected: s(Ae).selected.value,
                filters: no.value,
                "thumb-src": s(C).src,
                "keep-badge-for": bn.value ? Il : void 0,
                "starred-ids": je.value,
                "star-enabled": eo.value,
                "api-base": r.config.apiBase ?? "",
                "auth-headers": () => Rt(),
                "auth-credentials": s(u).credentialsMode(),
                "e2e-active": Zt.value,
                "body-override": Lr.value !== "",
                onActivate: Pp,
                onNavigate: up,
                onOpen: dn,
                onOpenTrash: l[14] || (l[14] = () => Yn()),
                onClickRow: l[15] || (l[15] = (ke, Qt) => Yl("main", ke, Qt)),
                onContext: l[16] || (l[16] = (ke, Qt) => Fl("main", ke, Qt)),
                onClearSelection: l[17] || (l[17] = (ke) => s(Ae).clear()),
                onDisplayOrder: l[18] || (l[18] = (ke) => Ie.value = ke),
                onItemDragStart: l[19] || (l[19] = (ke, Qt) => Wl("main", ke, Qt)),
                onItemDropInto: Jl,
                onTransfer: _c,
                "onUpdate:viewMode": l[20] || (l[20] = (ke) => oe.value = ke),
                "onUpdate:filters": cl,
                onCrumbContext: Nf,
                onCopyPath: as,
                onCrumbDrop: Zl,
                onNewFolder: l[21] || (l[21] = (ke) => xt.value = !0),
                onUpload: qn,
                onPaste: l[22] || (l[22] = (ke) => yr("paste")),
                onSelectAll: l[23] || (l[23] = (ke) => s(Ae).selectAll()),
                onClearFilters: Jd,
                onStarChange: Pe,
                onRetry: ve
              }, {
                banners: st(() => [
                  s(y).length || s(A) ? (c(), d("div", pL, [
                    s(y).length ? (c(), et(xh, {
                      key: 0,
                      users: s(y),
                      locale: v.value
                    }, null, 8, ["users", "locale"])) : g("", !0),
                    s(A) ? (c(), d("span", {
                      key: 1,
                      class: "fe-connbadge",
                      role: "status",
                      title: s(p)("conn.tooltip")
                    }, [
                      l[80] || (l[80] = o("span", {
                        class: "fe-connbadge__dot",
                        "aria-hidden": "true"
                      }, null, -1)),
                      Je(" " + f(s(p)("conn.offline")), 1)
                    ], 8, vL)) : g("", !0)
                  ])) : g("", !0),
                  vs.value ? (c(), d("div", hL, [
                    o("div", mL, [
                      o("strong", null, f(s(p)("e2e.upgrade.title")), 1),
                      o("p", null, f(s(p)("e2e.upgrade.body")), 1),
                      Fn.value ? (c(), d("p", yL, f(s(p)("e2e.upgrade.escrow_note")), 1)) : g("", !0)
                    ]),
                    o("div", bL, [
                      o("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: ho.value,
                        onClick: tv
                      }, f(s(p)("e2e.upgrade.decline")), 9, gL),
                      o("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: ho.value,
                        onClick: Xp
                      }, f(ho.value ? s(p)("e2e.upgrade.busy") : s(p)("e2e.upgrade.accept")), 9, kL)
                    ])
                  ])) : g("", !0),
                  va.value ? (c(), d("div", _L, [
                    o("div", wL, [
                      o("strong", null, f(s(p)("e2e.escrowoffer.title")), 1),
                      o("p", null, f(s(p)("e2e.escrowoffer.body")), 1),
                      o("p", $L, [
                        Je(f(s(p)("e2e.escrowoffer.consequence")) + " ", 1),
                        o("a", {
                          href: zD,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, f(s(p)("e2e.escrowoffer.learn_more")), 1)
                      ]),
                      Fn.value ? (c(), d("p", xL, [
                        Je(f(s(p)("e2e.recover.escrow_kid")) + ": ", 1),
                        o("code", null, f(Fn.value), 1)
                      ])) : g("", !0),
                      mo.value === "manual" ? (c(), d("label", SL, [
                        o("span", null, f(s(p)("e2e.escrowoffer.password_label")), 1),
                        Ve(o("input", {
                          "onUpdate:modelValue": l[10] || (l[10] = (ke) => Hn.value = ke),
                          type: "password",
                          class: "fe-input",
                          autocomplete: "current-password",
                          disabled: En.value,
                          onKeyup: Ut(Sc, ["enter"])
                        }, null, 40, CL), [
                          [rt, Hn.value]
                        ])
                      ])) : g("", !0),
                      zn.value ? (c(), d("p", TL, f(zn.value), 1)) : g("", !0)
                    ]),
                    o("div", ML, [
                      o("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: En.value,
                        onClick: l[11] || (l[11] = (ke) => mo.value === "manual" ? ev() : Qp())
                      }, f(mo.value === "manual" ? s(p)("e2e.escrowoffer.cancel") : s(p)("e2e.escrowoffer.decline")), 9, EL),
                      o("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: En.value,
                        onClick: Sc
                      }, f(En.value ? s(p)("e2e.escrowoffer.busy") : s(p)("e2e.escrowoffer.accept")), 9, zL)
                    ])
                  ])) : g("", !0),
                  Mn.value ? (c(), d("div", AL, [
                    o("span", {
                      class: "fe-e2e-strip__icon",
                      "aria-hidden": "true",
                      innerHTML: s(Ue)("lock")
                    }, null, 8, PL),
                    o("span", LL, f(s(p)("e2e.strip.label")), 1),
                    Jp.value !== "n/a" && !va.value ? (c(), d("button", {
                      key: 0,
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      onClick: Zp
                    }, f(s(p)("e2e.escrowoffer.strip_action")), 1)) : g("", !0),
                    o("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      onClick: Up
                    }, f(s(p)("e2e.strip.lock")), 1)
                  ])) : g("", !0),
                  pe.value && !x.value ? (c(), d("div", DL, [
                    o("p", OL, f(wf.value), 1),
                    jo.value ? (c(), d("button", {
                      key: 0,
                      type: "button",
                      class: "fe-btn fe-btn--danger fe-trashbar__action",
                      disabled: O.value.length === 0 || Yo.value,
                      "data-testid": "trash-empty",
                      onClick: l[12] || (l[12] = (ke) => so.value = !0)
                    }, f(s(p)("trash.empty_action")), 9, BL)) : g("", !0)
                  ])) : g("", !0)
                ]),
                body: st(() => [
                  Lr.value === "home" ? (c(), et(jw, {
                    key: 0,
                    storages: uf.value,
                    recent: vl.value,
                    starred: hl.value,
                    loading: rr.value,
                    locale: v.value,
                    "name-filter": no.value.name ?? "",
                    "thumb-src": s(C).src,
                    onOpenStorage: yl,
                    onOpenNode: dn,
                    onContextNode: wr
                  }, null, 8, ["storages", "recent", "starred", "loading", "locale", "name-filter", "thumb-src"])) : Lr.value === "notfound" ? (c(), d("div", IL, [
                    l[81] || (l[81] = o("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      o("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }),
                      o("path", { d: "M52 55c0-4.6 3.6-8 8-8s8 3.4 8 8c0 5.5-8 4.8-8 11" }),
                      o("circle", {
                        cx: "60",
                        cy: "73",
                        r: "1.6",
                        fill: "currentColor",
                        stroke: "none"
                      })
                    ], -1)),
                    o("p", HL, f(s(p)("notFound.title")), 1),
                    o("p", FL, f(N.value), 1),
                    o("p", NL, f(s(p)("notFound.desc")), 1),
                    o("div", KL, [
                      o("button", {
                        type: "button",
                        class: "fe-btn",
                        onClick: kf
                      }, f(s(p)("notFound.goRoot")), 1)
                    ])
                  ])) : (c(), d("div", RL, [
                    l[82] || (l[82] = o("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      o("rect", {
                        x: "38",
                        y: "44",
                        width: "44",
                        height: "34",
                        rx: "6"
                      }),
                      o("path", { d: "M46 44v-8a14 14 0 0 1 28 0v8" }),
                      o("circle", {
                        cx: "60",
                        cy: "59",
                        r: "3",
                        fill: "currentColor",
                        stroke: "none"
                      }),
                      o("path", { d: "M60 62v7" })
                    ], -1)),
                    o("p", UL, f(s(p)("e2e.locked.title")), 1),
                    o("p", VL, f(s(p)("e2e.locked.hint")), 1),
                    o("form", {
                      class: "fe-e2e-lock__form",
                      onSubmit: Re(Rp, ["prevent"])
                    }, [
                      Ve(o("input", {
                        "onUpdate:modelValue": l[13] || (l[13] = (ke) => Zn.value = ke),
                        type: "password",
                        class: "fe-input fe-e2e-lock__input",
                        placeholder: s(p)("e2e.locked.pw_placeholder"),
                        "aria-label": s(p)("e2e.locked.pw_placeholder"),
                        autocomplete: "current-password",
                        disabled: La.value
                      }, null, 8, jL), [
                        [rt, Zn.value]
                      ]),
                      o("button", {
                        type: "submit",
                        class: "fe-btn fe-btn--primary",
                        disabled: La.value || !Zn.value
                      }, f(La.value ? s(p)("e2e.locked.busy") : s(p)("e2e.locked.unlock")), 9, YL)
                    ], 32),
                    Da.value ? (c(), d("p", WL, f(Da.value), 1)) : g("", !0),
                    o("button", {
                      type: "button",
                      class: "fe-e2e-optlink",
                      onClick: Gp
                    }, f(s(p)("e2e.locked.use_recovery")), 1)
                  ]))
                ]),
                empty: st(() => [
                  Q.value ? (c(), d("div", qL, [
                    l[83] || (l[83] = o("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      o("circle", {
                        cx: "52",
                        cy: "44",
                        r: "22"
                      }),
                      o("path", { d: "M68 61l20 20" }),
                      o("path", { d: "M46 38l12 12M58 38l-12 12" })
                    ], -1)),
                    o("p", GL, f(s(p)("empty.search.title")), 1),
                    o("p", XL, f(s(p)("empty.search.hint")), 1)
                  ])) : w.value && w.value !== "trash" ? (c(), d("div", {
                    key: 1,
                    class: "fe-state",
                    "data-testid": `empty-${w.value}`
                  }, [
                    (c(), d("svg", ZL, [
                      w.value === "recent" ? (c(), d(ae, { key: 0 }, [
                        l[84] || (l[84] = o("circle", {
                          cx: "60",
                          cy: "50",
                          r: "28"
                        }, null, -1)),
                        l[85] || (l[85] = o("path", { d: "M60 32v18l12 8" }, null, -1))
                      ], 64)) : w.value === "starred" ? (c(), d("path", QL)) : w.value === "tag" ? (c(), d(ae, { key: 2 }, [
                        l[86] || (l[86] = o("path", { d: "M30 30h24l32 32-24 24-32-32z" }, null, -1)),
                        l[87] || (l[87] = o("circle", {
                          cx: "43",
                          cy: "43",
                          r: "4.5"
                        }, null, -1))
                      ], 64)) : (c(), d(ae, { key: 3 }, [
                        l[88] || (l[88] = o("circle", {
                          cx: "84",
                          cy: "34",
                          r: "9"
                        }, null, -1)),
                        l[89] || (l[89] = o("circle", {
                          cx: "36",
                          cy: "52",
                          r: "9"
                        }, null, -1)),
                        l[90] || (l[90] = o("circle", {
                          cx: "84",
                          cy: "70",
                          r: "9"
                        }, null, -1)),
                        l[91] || (l[91] = o("path", { d: "M44.5 47.5l31-9M44.5 56.5l31 9" }, null, -1))
                      ], 64))
                    ])),
                    o("p", eD, f(w.value === "tag" ? s(p)("empty.tag.title", { tag: be.value }) : s(p)(`empty.${w.value}.title`)), 1),
                    o("p", tD, f(w.value === "tag" ? s(p)("empty.tag.hint") : s(p)(`empty.${w.value}.hint`)), 1)
                  ], 8, JL)) : pe.value ? (c(), d("div", nD, [
                    l[92] || (l[92] = o("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      o("path", { d: "M38 34l4 48a6 6 0 0 0 6 5.6h24a6 6 0 0 0 6-5.6l4-48" }),
                      o("path", { d: "M32 34h56" }),
                      o("path", { d: "M50 34v-6a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v6" }),
                      o("path", {
                        d: "M52 44v32M60 44v32M68 44v32",
                        opacity: "0.5"
                      })
                    ], -1)),
                    o("p", aD, f(s(p)("empty.trash.title")), 1),
                    o("p", oD, f(s(p)("empty.trash.hint")), 1)
                  ])) : (c(), d("div", sD, [
                    (c(), d("svg", rD, [
                      l[94] || (l[94] = o("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }, null, -1)),
                      Ko.value ? (c(), d("g", iD, [...l[93] || (l[93] = [
                        o("path", {
                          d: "M60 50v14",
                          "stroke-dasharray": "3 4"
                        }, null, -1),
                        o("path", { d: "M53 59l7 8 7-8" }, null, -1)
                      ])])) : g("", !0)
                    ])),
                    o("p", lD, f(s(p)("empty.folder")), 1),
                    Ko.value ? (c(), d("p", cD, f(s(p)("empty.hint")), 1)) : g("", !0),
                    Ko.value ? (c(), d("div", uD, [
                      o("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        onClick: qn
                      }, f(s(p)("empty.upload")), 1)
                    ])) : g("", !0)
                  ]))
                ]),
                _: 1
              }, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "rows", "loading", "error", "order", "view-mode", "view-modes", "open-trigger", "show-crumbs", "filter-mode", "find-label", "show-view-switcher", "folder-key", "show-parent-path", "clipped", "extra-filters", "can-write", "can-paste", "selected", "filters", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "e2e-active", "body-override"]),
              za.value && In.value ? (c(), et(Mu, {
                ref_key: "splitPaneRef",
                ref: bt,
                key: "split-" + s(Ar),
                "pane-id": "split",
                "self-driven": "",
                closable: "",
                api: s(u),
                locale: v.value,
                theme: It.value,
                focused: zt.value,
                path: In.value.path,
                qualify: ut,
                "to-user": Br,
                clamp: mc,
                "root-path": s(E),
                floor: s($),
                "multi-root": Et.value,
                "virtual-rows": Sl,
                "trash-visible": e.config.trashVisible !== !1,
                "nav-offers-trash": rl.value,
                "view-mode": dc.value,
                "view-modes": ar.value,
                "open-trigger": r.config.openTrigger,
                clipped: xr.value,
                "can-write": xn.value,
                "can-paste": !!V.value.mode,
                selected: s(Ht).selected.value,
                filters: co.value,
                "folder-key": Cp.value,
                "thumb-src": s(C).src,
                "keep-badge-for": bn.value ? Il : void 0,
                "starred-ids": je.value,
                "star-enabled": eo.value,
                "api-base": r.config.apiBase ?? "",
                "auth-headers": () => Rt(),
                "auth-credentials": s(u).credentialsMode(),
                onActivate: l[24] || (l[24] = (ke) => Tn.value = "split"),
                onClose: Mp,
                onNavigate: Ep,
                onOpen: dn,
                onOpenTrash: Ap,
                onClickRow: l[25] || (l[25] = (ke, Qt) => Yl("split", ke, Qt)),
                onContext: l[26] || (l[26] = (ke, Qt) => Fl("split", ke, Qt)),
                onClearSelection: l[27] || (l[27] = (ke) => s(Ht).clear()),
                onDisplayOrder: l[28] || (l[28] = (ke) => ls.value = ke),
                onItemDragStart: l[29] || (l[29] = (ke, Qt) => Wl("split", ke, Qt)),
                onItemDropInto: Jl,
                onTransfer: _c,
                "onUpdate:viewMode": fc,
                "onUpdate:filters": l[30] || (l[30] = (ke) => co.value = ke),
                onCopyPath: as,
                onCrumbDrop: Zl,
                onNewFolder: l[31] || (l[31] = (ke) => xt.value = !0),
                onUpload: qn,
                onPaste: l[32] || (l[32] = (ke) => yr("paste")),
                onSelectAll: l[33] || (l[33] = (ke) => s(Ht).selectAll()),
                onClearFilters: l[34] || (l[34] = (ke) => co.value = { ...s(na) }),
                onStarChange: Pe
              }, null, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "trash-visible", "nav-offers-trash", "view-mode", "view-modes", "open-trigger", "clipped", "can-write", "can-paste", "selected", "filters", "folder-key", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : g("", !0)
            ])
          ]),
          Me.value ? (c(), et(kk, {
            key: 2,
            api: s(u),
            nodes: Ip.value,
            "dir-label": Fp.value,
            "dir-count": Np.value,
            "dir-perm": Kp.value,
            "held-in": Hp.value,
            locale: v.value,
            narrow: rn.value,
            "thumb-src": s(C).src,
            "api-base": r.config.apiBase ?? "",
            "auth-headers": () => Rt(),
            "auth-credentials": s(u).credentialsMode(),
            onTagsChanged: wt,
            onOpenTag: Gt,
            onClose: Xt,
            onShareCreated: lf,
            onManagePermissions: vf,
            onToast: Ke,
            onChanged: l[35] || (l[35] = () => {
              var ke;
              return zt.value ? void ((ke = bt.value) == null ? void 0 : ke.reload()) : void ot();
            })
          }, null, 8, ["api", "nodes", "dir-label", "dir-count", "dir-perm", "held-in", "locale", "narrow", "thumb-src", "api-base", "auth-headers", "auth-credentials", "onTagsChanged", "onOpenTag", "onShareCreated"])) : g("", !0)
        ], 2),
        $a.value || to.value ? (c(), d("div", {
          key: 0,
          class: "fe-overlay",
          "data-testid": "explorer-overlay",
          onClick: Re(Do, ["self"])
        }, [
          o("div", {
            class: "fe-overlay__card",
            onClick: l[37] || (l[37] = Re(() => {
            }, ["stop"]))
          }, [
            $a.value ? (c(), et(ax, {
              key: 0,
              config: e.config,
              "initial-tab": "connect",
              closable: "",
              onClose: Do,
              onChanged: l[36] || (l[36] = () => ot()),
              onError: Gd
            }, null, 8, ["config"])) : (c(), d(ae, { key: 1 }, [
              o("header", dD, [
                o("h2", fD, f(s(p)("sidenav.apikeys")), 1),
                o("button", {
                  type: "button",
                  class: "fe-overlay__close",
                  title: s(p)("overlay.close"),
                  "aria-label": s(p)("overlay.close"),
                  onClick: Do
                }, " × ", 8, pD)
              ]),
              Ge(Hd, {
                config: e.config,
                full: ""
              }, null, 8, ["config"])
            ], 64))
          ])
        ])) : g("", !0),
        Xn.value ? (c(), d("div", vD, [
          o("div", hD, [
            o("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: s(Ue)("upload")
            }, null, 8, mD),
            o("p", null, f(s(p)("dropzone.hint")), 1)
          ])
        ])) : g("", !0),
        Ge(Sb, {
          jobs: pt.value,
          locale: v.value,
          center: s(Mr),
          onCancel: lp,
          onDismiss: cp,
          onRetry: mp
        }, null, 8, ["jobs", "locale", "center"]),
        Ge(Tb, {
          ops: s(U).ops.value,
          locale: v.value,
          center: s(Mr),
          onDismiss: l[38] || (l[38] = (ke) => s(U).dismiss(ke))
        }, null, 8, ["ops", "locale", "center"]),
        Ge(r5, {
          center: s(Mr),
          locale: v.value,
          narrow: rn.value
        }, null, 8, ["center", "locale", "narrow"]),
        rn.value && Ko.value ? (c(), d("button", {
          key: 2,
          type: "button",
          class: "fe-fab",
          title: s(p)("toolbar.upload"),
          "aria-label": s(p)("toolbar.upload"),
          onClick: qn
        }, [...l[95] || (l[95] = [
          o("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            o("path", { d: "M12 5v14M5 12h14" })
          ], -1)
        ])], 8, yD)) : g("", !0),
        Ma.value ? (c(), d("div", bD, [
          l[96] || (l[96] = o("span", {
            class: "fe-keep-strip__icon",
            "aria-hidden": "true"
          }, "⟳", -1)),
          o("span", gD, f(Hf.value), 1),
          Hl.value !== null ? (c(), d("div", kD, [
            o("div", {
              class: "fe-keep-strip__fill",
              style: Ct({ width: Hl.value + "%" })
            }, null, 4)
          ])) : g("", !0)
        ])) : g("", !0),
        Ge(Ps, {
          ref_key: "ctxRef",
          ref: la,
          locale: v.value,
          theme: It.value,
          sheet: $l.value,
          actions: Kf.value,
          onSelect: Uf
        }, null, 8, ["locale", "theme", "sheet", "actions"]),
        Ge(n6, {
          open: jt.value,
          locale: v.value,
          theme: It.value,
          api: s(u),
          types: Bt.value,
          "current-path": ut(z.value),
          storages: (r.config.storages ?? []).map((ke) => ke.name),
          "only-office-ready": !!kt.value,
          "drawio-ready": !!At.value,
          onClose: l[39] || (l[39] = (ke) => jt.value = !1),
          onCreated: Xf,
          onError: l[40] || (l[40] = (ke) => a("error", { message: ke.message, context: { op: "newdoc" } }))
        }, null, 8, ["open", "locale", "theme", "api", "types", "current-path", "storages", "only-office-ready", "drawio-ready"]),
        Ge(fz, {
          open: xt.value,
          locale: v.value,
          "encrypted-option": !Zt.value,
          onClose: l[41] || (l[41] = (ke) => xt.value = !1),
          onSubmit: Jf,
          onEncrypted: l[42] || (l[42] = (ke) => {
            xt.value = !1, cs.value = !0;
          })
        }, null, 8, ["open", "locale", "encrypted-option"]),
        Ge(Rd, {
          open: ne.value,
          api: s(u),
          locale: v.value,
          mode: H.value,
          busy: _e.value,
          storages: (r.config.storages ?? []).map((ke) => ke.name),
          "start-at": ut(zt.value ? ((ee = bt.value) == null ? void 0 : ee.getPath()) ?? "" : z.value),
          moving: H.value === "move" ? te.value.filter((ke) => ke.type === "dir").map((ke) => ke.path) : [],
          onClose: l[43] || (l[43] = (ke) => ne.value = !1),
          onPick: Gf
        }, null, 8, ["open", "api", "locale", "mode", "busy", "storages", "start-at", "moving"]),
        Ge(b8, {
          open: cs.value,
          locale: v.value,
          busy: Hr.value,
          "escrow-kid": Fn.value,
          onClose: l[44] || (l[44] = (ke) => cs.value = !1),
          onSubmit: Wp
        }, null, 8, ["open", "locale", "busy", "escrow-kid"]),
        Ge(M8, {
          open: ds.value,
          locale: v.value,
          "recovery-key": fs.value,
          "folder-name": ps.value,
          "escrow-kid": Fn.value,
          variant: Nr.value,
          onClose: nv
        }, null, 8, ["open", "locale", "recovery-key", "folder-name", "escrow-kid", "variant"]),
        Ge(U8, {
          open: us.value,
          locale: v.value,
          "has-recovery": s(cy)(Yt.value),
          "escrow-state": s(dy)(Yt.value, Fn.value),
          "escrow-kid": ((Ee = (me = Yt.value) == null ? void 0 : me.esc) == null ? void 0 : Ee.kid) || Fn.value,
          busy: Fr.value,
          error: Qn.value,
          onClose: l[45] || (l[45] = (ke) => us.value = !1),
          onSubmit: qp
        }, null, 8, ["open", "locale", "has-recovery", "escrow-state", "escrow-kid", "busy", "error"]),
        Ge(o6, {
          open: Pt.value,
          locale: v.value,
          "current-name": ((Fe = sn.value) == null ? void 0 : Fe.basename) || "",
          onClose: l[46] || (l[46] = (ke) => Pt.value = !1),
          onSubmit: Zf
        }, null, 8, ["open", "locale", "current-name"]),
        Ge(an, {
          open: so.value,
          title: s(p)("trash.empty_confirm_title"),
          size: "sm",
          onClose: l[48] || (l[48] = (ke) => so.value = !1)
        }, {
          actions: st(() => [
            o("button", {
              type: "button",
              class: "fe-btn",
              onClick: l[47] || (l[47] = (ke) => so.value = !1)
            }, f(s(p)("modal.delete.cancel")), 1),
            o("button", {
              type: "button",
              class: "fe-btn fe-btn--danger",
              "data-testid": "trash-empty-confirm",
              onClick: Sf
            }, f(s(p)("trash.empty_action")), 1)
          ]),
          default: st(() => [
            o("p", null, f(s(p)(xf.value, { count: O.value.length, size: s(h)(Ml.value) })), 1)
          ]),
          _: 1
        }, 8, ["open", "title"]),
        Ge(s6, {
          open: _t.value,
          locale: v.value,
          count: s(Ae).size.value,
          onClose: l[49] || (l[49] = (ke) => _t.value = !1),
          onConfirm: Qf
        }, null, 8, ["open", "locale", "count"]),
        Ge(Nd, {
          open: St.value,
          locale: v.value,
          file: nn.value,
          theme: It.value,
          "preview-url": (ke) => hs(ke),
          "download-url": (ke) => Mn.value ? hs(ke) : s(u).downloadUrl(ke),
          "only-office-base": Zt.value ? null : kt.value,
          "only-office-config-endpoint": Dt.value,
          "new-tab-enabled": !Zt.value,
          "save-text-endpoint": Zt.value ? null : s(u).endpoints.saveText || null,
          "archive-list-endpoint": s(u).endpoints.archiveList || null,
          "open-mode": mn.value,
          "auth-headers": () => Rt({ "Content-Type": "application/json" }),
          "auth-credentials": s(u).credentialsMode(),
          "drawio-url": At.value,
          "pdf-worker-url": r.config.pdfWorkerUrl || null,
          "pdf-save-url": r.config.pdfSaveUrl || null,
          "viewer-base-url": ec.value,
          index: vt.value.index,
          total: vt.value.total,
          "nav-enabled": vt.value.total > 1,
          "share-enabled": !Zt.value,
          onShare: l[50] || (l[50] = () => {
            const ke = nn.value;
            ke && (q.value = ke, Io.value = void 0, Le.value = !0);
          }),
          "api-base": r.config.apiBase ?? "",
          onNav: Xe,
          onClose: l[51] || (l[51] = (ke) => St.value = !1)
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "new-tab-enabled", "save-text-endpoint", "archive-list-endpoint", "open-mode", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "pdf-save-url", "viewer-base-url", "index", "total", "nav-enabled", "share-enabled", "api-base"]),
        xe.value && de.value && Ot.value ? (c(), et(w6, {
          key: 4,
          "convert-url": Ot.value,
          "file-name": ((nt = de.value) == null ? void 0 : nt.basename) || ((ct = de.value) == null ? void 0 : ct.path) || "",
          "fetch-bytes": () => {
            var ke;
            return s(u).fetchArrayBuffer(((ke = de.value) == null ? void 0 : ke.path) ?? "");
          },
          upload: (ke) => s(u).uploadMultipart(ut(z.value), [ke]).then(() => {
          }),
          locale: v.value,
          onClose: l[52] || (l[52] = (ke) => xe.value = !1),
          onDone: tp
        }, null, 8, ["convert-url", "file-name", "fetch-bytes", "upload", "locale"])) : g("", !0),
        Le.value && q.value ? (c(), et(cL, {
          key: 5,
          api: s(u),
          path: q.value.path,
          "is-dir": q.value.type === "dir",
          size: typeof q.value.size == "number" ? q.value.size : void 0,
          locale: v.value === "en" ? "en" : "tr",
          "share-max-ttl-days": ye.value,
          "initial-tab": Io.value,
          onClose: l[53] || (l[53] = (ke) => {
            Le.value = !1, Io.value = void 0;
          })
        }, null, 8, ["api", "path", "is-dir", "size", "locale", "share-max-ttl-days", "initial-tab"])) : g("", !0),
        Ge(Rn, { name: "fe-modal" }, {
          default: st(() => [
            Qe.value ? (c(), d("div", {
              key: 0,
              class: we(["fe fe-modal__backdrop fe-recents__backdrop", {
                "fe--theme-light": It.value === "light",
                "fe--theme-dark": It.value === "dark"
              }]),
              onClick: l[57] || (l[57] = (ke) => Qe.value = !1)
            }, [
              o("div", {
                class: "fe-recents__panel",
                onClick: l[56] || (l[56] = Re(() => {
                }, ["stop"]))
              }, [
                o("div", _D, [
                  o("strong", null, f(v.value === "en" ? "Recently opened" : "Son açılanlar"), 1),
                  o("button", {
                    class: "fe-recents__close",
                    "aria-label": "Close",
                    onClick: l[54] || (l[54] = (ke) => Qe.value = !1)
                  }, "×")
                ]),
                Ge(db, {
                  "api-base": r.config.apiBase ?? "",
                  "auth-headers": () => Rt(),
                  "auth-credentials": s(u).credentialsMode(),
                  limit: 20,
                  "refresh-key": lt.value,
                  onOpen: en,
                  onContext: $t,
                  onError: l[55] || (l[55] = (ke) => a("error", { message: ke, context: { op: "recents" } }))
                }, null, 8, ["api-base", "auth-headers", "auth-credentials", "refresh-key"])
              ])
            ], 2)) : g("", !0)
          ]),
          _: 1
        }),
        Ge(Rn, { name: "fe-modal" }, {
          default: st(() => [
            at.value && Ye.value && typeof Ye.value.id == "number" ? (c(), d("div", {
              key: 0,
              class: "fe-modal__backdrop",
              onClick: l[62] || (l[62] = (ke) => at.value = !1)
            }, [
              o("div", {
                class: "fe-modal__card fe-modal__card--md",
                onClick: l[61] || (l[61] = Re(() => {
                }, ["stop"]))
              }, [
                o("header", wD, [
                  o("h2", $D, f(v.value === "en" ? "Tags" : "Etiketler") + " — " + f(Ye.value.basename), 1),
                  o("button", {
                    class: "fe-modal__close",
                    "aria-label": "Close",
                    onClick: l[58] || (l[58] = (ke) => at.value = !1)
                  }, "×")
                ]),
                o("div", xD, [
                  Ge(td, {
                    "node-id": Ye.value.id,
                    locale: v.value,
                    "api-base": r.config.apiBase ?? "",
                    "auth-headers": () => Rt(),
                    "auth-credentials": s(u).credentialsMode(),
                    onChange: wt,
                    onOpen: l[59] || (l[59] = (ke) => {
                    }),
                    onError: l[60] || (l[60] = (ke) => a("error", { message: ke, context: { op: "tags" } }))
                  }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
                ])
              ])
            ])) : g("", !0)
          ]),
          _: 1
        }),
        Ge(yC, {
          open: Bo.value,
          locale: v.value,
          theme: It.value,
          "initial-query": fl.value,
          "folder-label": pl.value,
          "path-base": ul.value,
          "content-search": Zd.value,
          count: tf,
          onClose: l[63] || (l[63] = (ke) => Bo.value = !1),
          onSubmit: af
        }, null, 8, ["open", "locale", "theme", "initial-query", "folder-label", "path-base", "content-search"]),
        Ge(Nx, {
          "initial-query": or.value,
          open: Xo.value,
          locale: v.value,
          files: O.value,
          "view-mode": oe.value,
          "can-write": xn.value && !se.value && !S.value,
          "can-go-up": L.value,
          "global-search": Mf,
          onClose: l[64] || (l[64] = (ke) => Xo.value = !1),
          onOpenHit: Ef,
          onOpenNode: dn,
          onNavigate: l[65] || (l[65] = (ke) => ot(ke)),
          onNewFolder: l[66] || (l[66] = (ke) => xt.value = !0),
          onUpload: qn,
          onToggleView: l[67] || (l[67] = (ke) => pc(Dr.value === "list" ? "grid" : Dr.value === "grid" ? "gallery" : "list")),
          onOpenTrash: Yn,
          onRefresh: Tl,
          onGoUp: We,
          onOpenTheme: l[68] || (l[68] = (ke) => os.value = !0),
          onOpenShortcutSettings: l[69] || (l[69] = (ke) => lo.value = !0),
          onStartTour: l[70] || (l[70] = (ke) => zr()),
          "split-enabled": uo.value,
          onTabNew: l[71] || (l[71] = (ke) => Pr()),
          onSplitToggle: l[72] || (l[72] = (ke) => uc())
        }, null, 8, ["initial-query", "open", "locale", "files", "view-mode", "can-write", "can-go-up", "onRefresh", "split-enabled"]),
        Ge(MC, {
          open: Jo.value,
          locale: v.value,
          onClose: l[73] || (l[73] = (ke) => Jo.value = !1),
          onCustomize: l[74] || (l[74] = (ke) => {
            Jo.value = !1, lo.value = !0;
          })
        }, null, 8, ["open", "locale"]),
        Ge(ZC, {
          open: os.value,
          locale: v.value,
          theme: It.value,
          dark: Tr.value,
          current: s(ss),
          mode: s(Cr),
          "host-mode": e.config.theme || "auto",
          onClose: l[75] || (l[75] = (ke) => os.value = !1),
          onSelect: s(dp),
          onMode: l[76] || (l[76] = (ke) => s(fp)(ke))
        }, null, 8, ["open", "locale", "theme", "dark", "current", "mode", "host-mode", "onSelect"]),
        o("input", {
          ref_key: "fileInputEl",
          ref: tn,
          type: "file",
          multiple: "",
          class: "fe__file-input",
          onChange: np
        }, null, 544),
        Ge(Rn, { name: "fe-toast" }, {
          default: st(() => [
            Sn.value ? (c(), d("div", {
              key: 0,
              class: we(["fe-toast", { "fe-toast--action": !!Sn.value.actionLabel }]),
              role: "status",
              onClick: pr
            }, [
              o("span", SD, f(Sn.value.message), 1),
              Sn.value.actionLabel && Sn.value.action ? (c(), d("button", {
                key: 0,
                type: "button",
                class: "fe-toast__action",
                onClick: Re(bf, ["stop"])
              }, f(Sn.value.actionLabel), 1)) : g("", !0)
            ], 2)) : g("", !0)
          ]),
          _: 1
        }),
        Ge(m3, {
          open: X.value,
          locale: v.value,
          theme: It.value,
          onClose: l[77] || (l[77] = (ke) => X.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        Ge(Y3, {
          open: lo.value,
          locale: v.value,
          theme: It.value,
          onClose: l[78] || (l[78] = (ke) => lo.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        Ge(C4, {
          open: Jn.value,
          locale: v.value,
          file: Bn.value,
          theme: It.value,
          "preview-url": (ke) => hs(ke),
          "download-url": (ke) => Mn.value ? hs(ke) : s(u).downloadUrl(ke),
          "only-office-base": Zt.value ? null : kt.value,
          "only-office-config-endpoint": Dt.value,
          "auth-headers": () => Rt({ "Content-Type": "application/json" }),
          "auth-credentials": s(u).credentialsMode(),
          "drawio-url": At.value,
          "pdf-worker-url": r.config.pdfWorkerUrl || null,
          "viewer-base-url": ec.value,
          onClose: l[79] || (l[79] = (ke) => Jn.value = !1),
          onNav: vp,
          onOpenFull: hp
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "viewer-base-url"]),
        Ge(y5, {
          open: rs.value,
          locale: v.value,
          root: Kt.value,
          theme: It.value,
          onClose: bp
        }, null, 8, ["open", "locale", "root", "theme"])
      ], 34);
    };
  }
});
export {
  ZC as $,
  Nd as A,
  C4 as B,
  ma as C,
  G3 as D,
  rd as E,
  cu as F,
  Id as G,
  db as H,
  M8 as I,
  $0 as J,
  V0 as K,
  Y3 as L,
  Dv as M,
  fu as N,
  er as O,
  T1 as P,
  To as Q,
  mv as R,
  oa as S,
  Qi as T,
  Ys as U,
  Es as V,
  ko as W,
  Hv as X,
  T5 as Y,
  td as Z,
  G1 as _,
  Ue as a,
  Ha as a$,
  VC as a0,
  f3 as a1,
  Hd as a2,
  Qy as a3,
  UD as a4,
  VD as a5,
  RD as a6,
  J8 as a7,
  DD as a8,
  ID as a9,
  Kd as aA,
  j_ as aB,
  ly as aC,
  eu as aD,
  yv as aE,
  zo as aF,
  oz as aG,
  pv as aH,
  qs as aI,
  tz as aJ,
  sz as aK,
  Wa as aL,
  Iv as aM,
  yy as aN,
  ri as aO,
  dy as aP,
  oy as aQ,
  Zc as aR,
  si as aS,
  Mv as aT,
  Iy as aU,
  uu as aV,
  Ay as aW,
  By as aX,
  Ry as aY,
  Ky as aZ,
  Xu as a_,
  Kv as aa,
  iy as ab,
  BC as ac,
  X8 as ad,
  Jy as ae,
  ol as af,
  Fd as ag,
  Jw as ah,
  a1 as ai,
  Zw as aj,
  Gw as ak,
  Xw as al,
  qw as am,
  pu as an,
  yo as ao,
  Ks as ap,
  ga as aq,
  wo as ar,
  Wy as as,
  Ti as at,
  Lv as au,
  wa as av,
  Yw as aw,
  sy as ax,
  by as ay,
  HD as az,
  ax as b,
  Na as b$,
  ty as b0,
  Vy as b1,
  dd as b2,
  IC as b3,
  dh as b4,
  Qu as b5,
  Gi as b6,
  qi as b7,
  n1 as b8,
  di as b9,
  Di as bA,
  al as bB,
  Js as bC,
  jD as bD,
  Ru as bE,
  Yv as bF,
  Fy as bG,
  OD as bH,
  Hy as bI,
  Z8 as bJ,
  Tv as bK,
  Yy as bL,
  Cv as bM,
  Ku as bN,
  cn as bO,
  Mi as bP,
  eb as bQ,
  LD as bR,
  Wr as bS,
  jy as bT,
  Jr as bU,
  FD as bV,
  jv as bW,
  Yr as bX,
  AC as bY,
  DC as bZ,
  Vv as b_,
  ka as ba,
  ay as bb,
  ny as bc,
  rz as bd,
  az as be,
  Mc as bf,
  Pv as bg,
  Bd as bh,
  Bc as bi,
  kv as bj,
  qa as bk,
  Va as bl,
  _i as bm,
  bv as bn,
  zc as bo,
  Ai as bp,
  uy as bq,
  cy as br,
  Od as bs,
  Vu as bt,
  Ms as bu,
  Cd as bv,
  Uy as bw,
  Cb as bx,
  nz as by,
  Qc as bz,
  Ln as c,
  Vs as c0,
  _a as c1,
  Nv as c2,
  HC as c3,
  Zy as c4,
  Ua as c5,
  Rv as c6,
  Ny as c7,
  Bv as c8,
  ez as c9,
  Ic as cA,
  my as ca,
  vy as cb,
  hy as cc,
  ry as cd,
  jr as ce,
  Ww as cf,
  Ya as cg,
  Ov as ch,
  tt as ci,
  BD as cj,
  j0 as ck,
  c5 as cl,
  Qv as cm,
  X1 as cn,
  x0 as co,
  Oc as cp,
  Uu as cq,
  t8 as cr,
  OC as cs,
  PC as ct,
  g2 as cu,
  _v as cv,
  fy as cw,
  KD as cx,
  Uv as cy,
  Td as cz,
  Zr as d,
  Zu as e,
  fn as f,
  Q8 as g,
  Wt as h,
  Rd as i,
  cd as j,
  Gm as k,
  ha as l,
  sd as m,
  ld as n,
  Xm as o,
  _s as p,
  od as q,
  xo as r,
  U8 as s,
  b8 as t,
  YD as u,
  Mu as v,
  ND as w,
  b2 as x,
  n6 as y,
  r5 as z
};
//# sourceMappingURL=index-BArI-B1M.js.map
